/* eslint-disable */
import { TypedDocumentNode as DocumentNode } from '@graphql-typed-document-node/core';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  /** The javascript `Date` as string. Type represents date and time as the ISO Date string. */
  DateTime: any;
  /** The `JSON` scalar type represents JSON values as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSON: any;
  /** The `JSONObject` scalar type represents JSON objects as specified by [ECMA-404](http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-404.pdf). */
  JSONObject: any;
  /** The `Upload` scalar type represents a file upload. */
  Upload: any;
};

export type AbstractAccessGrant = {
  address?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  credentials?: Maybe<Array<Credential>>;
  endDate?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: Maybe<Scalars['String']>;
  gracePeriods?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idVerification: IdVerification;
  infos?: Maybe<Array<InfoItem>>;
  location: Location;
  locationId: Scalars['String'];
  maxKeys?: Maybe<Scalars['Float']>;
  numKeysDispensed?: Maybe<Scalars['Float']>;
  requirements?: Maybe<Array<Requirement>>;
  resources?: Maybe<Array<Resource>>;
  retryCheckin?: Maybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: Maybe<Scalars['DateTime']>;
  startDate?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  startTime?: Maybe<Scalars['String']>;
  state?: Maybe<AccessGrantState>;
  status: AccessGrantStatus;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String'];
  type: AccessGrantType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['String'];
};


export type AbstractAccessGrantCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type AbstractAccessGrantRequirementsArgs = {
  cursor?: InputMaybe<RequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<RequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
};


export type AbstractAccessGrantResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};

/** Access to a resource or resource grouping */
export type AccessGrant = {
  _count?: Maybe<AccessGrantCount>;
  AccessGrantResId: Array<AccessGrantResId>;
  address?: Maybe<Scalars['String']>;
  arrivalTime?: Maybe<Scalars['String']>;
  callRecords: Array<CallRecord>;
  code?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  credentials: Array<Credential>;
  deviceRegistrations: Array<DeviceRegistration>;
  endDate?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: Maybe<Scalars['String']>;
  floorPlan?: Maybe<Scalars['String']>;
  gotCODResponse?: Maybe<Scalars['Boolean']>;
  gracePeriods?: Maybe<Scalars['JSON']>;
  housekeepingDate?: Maybe<Scalars['DateTime']>;
  housekeepingRRule?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idVerification: IdVerification;
  idVerificationResult?: Maybe<IdVerificationResult>;
  idVerificationResultId?: Maybe<Scalars['String']>;
  infos: Array<InfoItem>;
  lastPolledAt?: Maybe<Scalars['DateTime']>;
  location: Location;
  locationId: Scalars['String'];
  maxKeys?: Maybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: Maybe<Scalars['DateTime']>;
  notifications: Array<Notification>;
  numKeysDispensed?: Maybe<Scalars['Int']>;
  overrides: Array<Override>;
  passes: Array<Pass>;
  paymentTransactions: Array<PaymentTransaction>;
  qrCodeImageUrl?: Maybe<Scalars['String']>;
  requirements: Array<Requirement>;
  resources: Array<Resource>;
  retryCheckin?: Maybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: Maybe<Scalars['DateTime']>;
  roomNumber?: Maybe<Scalars['String']>;
  secondaryUsers: Array<SecondaryUsersOnAccessGrants>;
  serviceRequests: Array<ServiceRequest>;
  startDate?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  startTime?: Maybe<Scalars['String']>;
  state?: Maybe<AccessGrantState>;
  status: AccessGrantStatus;
  supplementaryCards: Array<SupplementaryCard>;
  tenant: Tenant;
  tenantId: Scalars['String'];
  type: AccessGrantType;
  uidOnLocation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  UserAccessGrantRequirement: Array<UserAccessGrantRequirement>;
  userId: Scalars['String'];
};


/** Access to a resource or resource grouping */
export type AccessGrantAccessGrantResIdArgs = {
  cursor?: InputMaybe<AccessGrantResIdWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantResIdScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantResIdOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantResIdWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantDeviceRegistrationsArgs = {
  cursor?: InputMaybe<DeviceRegistrationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DeviceRegistrationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DeviceRegistrationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DeviceRegistrationWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantInfosArgs = {
  cursor?: InputMaybe<InfoItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<InfoItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantNotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantOverridesArgs = {
  cursor?: InputMaybe<OverrideWhereUniqueInput>;
  distinct?: InputMaybe<Array<OverrideScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OverrideOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OverrideWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantPassesArgs = {
  cursor?: InputMaybe<PassWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PassWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantPaymentTransactionsArgs = {
  cursor?: InputMaybe<PaymentTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantRequirementsArgs = {
  cursor?: InputMaybe<RequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<RequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantSecondaryUsersArgs = {
  cursor?: InputMaybe<SecondaryUsersOnAccessGrantsWhereUniqueInput>;
  distinct?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SecondaryUsersOnAccessGrantsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantServiceRequestsArgs = {
  cursor?: InputMaybe<ServiceRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantSupplementaryCardsArgs = {
  cursor?: InputMaybe<SupplementaryCardWhereUniqueInput>;
  distinct?: InputMaybe<Array<SupplementaryCardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SupplementaryCardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


/** Access to a resource or resource grouping */
export type AccessGrantUserAccessGrantRequirementArgs = {
  cursor?: InputMaybe<UserAccessGrantRequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAccessGrantRequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAccessGrantRequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};

export type AccessGrantAuthCredentials = {
  deeplink: Scalars['String'];
  mobileWebUrl: Scalars['String'];
  qrCodeBase64: Scalars['String'];
};

export type AccessGrantAuthenticationCredentials = {
  deeplink: Scalars['String'];
  mobileWebUrl: Scalars['String'];
  passUrl: Scalars['String'];
  qrCode: Scalars['String'];
  qrCodeBase64: Scalars['String'];
};

export type AccessGrantAvgAggregate = {
  maxKeys?: Maybe<Scalars['Float']>;
  numKeysDispensed?: Maybe<Scalars['Float']>;
};

export type AccessGrantAvgOrderByAggregateInput = {
  maxKeys?: InputMaybe<SortOrder>;
  numKeysDispensed?: InputMaybe<SortOrder>;
};

export type AccessGrantCount = {
  AccessGrantResId: Scalars['Int'];
  callRecords: Scalars['Int'];
  credentials: Scalars['Int'];
  deviceRegistrations: Scalars['Int'];
  infos: Scalars['Int'];
  notifications: Scalars['Int'];
  overrides: Scalars['Int'];
  passes: Scalars['Int'];
  paymentTransactions: Scalars['Int'];
  requirements: Scalars['Int'];
  resources: Scalars['Int'];
  secondaryUsers: Scalars['Int'];
  serviceRequests: Scalars['Int'];
  supplementaryCards: Scalars['Int'];
  UserAccessGrantRequirement: Scalars['Int'];
};


export type AccessGrantCountAccessGrantResIdArgs = {
  where?: InputMaybe<AccessGrantResIdWhereInput>;
};


export type AccessGrantCountCallRecordsArgs = {
  where?: InputMaybe<CallRecordWhereInput>;
};


export type AccessGrantCountCredentialsArgs = {
  where?: InputMaybe<CredentialWhereInput>;
};


export type AccessGrantCountDeviceRegistrationsArgs = {
  where?: InputMaybe<DeviceRegistrationWhereInput>;
};


export type AccessGrantCountInfosArgs = {
  where?: InputMaybe<InfoItemWhereInput>;
};


export type AccessGrantCountNotificationsArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type AccessGrantCountOverridesArgs = {
  where?: InputMaybe<OverrideWhereInput>;
};


export type AccessGrantCountPassesArgs = {
  where?: InputMaybe<PassWhereInput>;
};


export type AccessGrantCountPaymentTransactionsArgs = {
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


export type AccessGrantCountRequirementsArgs = {
  where?: InputMaybe<RequirementWhereInput>;
};


export type AccessGrantCountResourcesArgs = {
  where?: InputMaybe<ResourceWhereInput>;
};


export type AccessGrantCountSecondaryUsersArgs = {
  where?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
};


export type AccessGrantCountServiceRequestsArgs = {
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type AccessGrantCountSupplementaryCardsArgs = {
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


export type AccessGrantCountUserAccessGrantRequirementArgs = {
  where?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};

export type AccessGrantCountAggregate = {
  _all: Scalars['Int'];
  address: Scalars['Int'];
  arrivalTime: Scalars['Int'];
  code: Scalars['Int'];
  confirmationCode: Scalars['Int'];
  createdAt: Scalars['Int'];
  endDate: Scalars['Int'];
  endsAt: Scalars['Int'];
  endTime: Scalars['Int'];
  floorPlan: Scalars['Int'];
  gotCODResponse: Scalars['Int'];
  gracePeriods: Scalars['Int'];
  housekeepingDate: Scalars['Int'];
  housekeepingRRule: Scalars['Int'];
  id: Scalars['Int'];
  idVerification: Scalars['Int'];
  idVerificationResultId: Scalars['Int'];
  lastPolledAt: Scalars['Int'];
  locationId: Scalars['Int'];
  maxKeys: Scalars['Int'];
  metadata: Scalars['Int'];
  noticeDate: Scalars['Int'];
  numKeysDispensed: Scalars['Int'];
  qrCodeImageUrl: Scalars['Int'];
  retryCheckin: Scalars['Int'];
  retryCheckinStartsAt: Scalars['Int'];
  roomNumber: Scalars['Int'];
  startDate: Scalars['Int'];
  startsAt: Scalars['Int'];
  startTime: Scalars['Int'];
  state: Scalars['Int'];
  status: Scalars['Int'];
  tenantId: Scalars['Int'];
  type: Scalars['Int'];
  uidOnLocation: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
};

export type AccessGrantCountOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  arrivalTime?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  confirmationCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  endsAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  floorPlan?: InputMaybe<SortOrder>;
  gotCODResponse?: InputMaybe<SortOrder>;
  gracePeriods?: InputMaybe<SortOrder>;
  housekeepingDate?: InputMaybe<SortOrder>;
  housekeepingRRule?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idVerification?: InputMaybe<SortOrder>;
  idVerificationResultId?: InputMaybe<SortOrder>;
  lastPolledAt?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  maxKeys?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  noticeDate?: InputMaybe<SortOrder>;
  numKeysDispensed?: InputMaybe<SortOrder>;
  qrCodeImageUrl?: InputMaybe<SortOrder>;
  retryCheckin?: InputMaybe<SortOrder>;
  retryCheckinStartsAt?: InputMaybe<SortOrder>;
  roomNumber?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  startsAt?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  uidOnLocation?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccessGrantCreateInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateManyInput = {
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResultId?: InputMaybe<Scalars['String']>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  tenantId: Scalars['String'];
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type AccessGrantCreateManyLocationInput = {
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResultId?: InputMaybe<Scalars['String']>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  tenantId: Scalars['String'];
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type AccessGrantCreateManyLocationInputEnvelope = {
  data: Array<AccessGrantCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AccessGrantCreateManyTenantInput = {
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResultId?: InputMaybe<Scalars['String']>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type AccessGrantCreateManyTenantInputEnvelope = {
  data: Array<AccessGrantCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AccessGrantCreateManyUserInput = {
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResultId?: InputMaybe<Scalars['String']>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  tenantId: Scalars['String'];
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type AccessGrantCreateManyUserInputEnvelope = {
  data: Array<AccessGrantCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AccessGrantCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<AccessGrantCreateWithoutLocationInput>>;
  createMany?: InputMaybe<AccessGrantCreateManyLocationInputEnvelope>;
};

export type AccessGrantCreateNestedManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantCreateOrConnectWithoutResourcesInput>>;
  create?: InputMaybe<Array<AccessGrantCreateWithoutResourcesInput>>;
};

export type AccessGrantCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<AccessGrantCreateWithoutTenantInput>>;
  createMany?: InputMaybe<AccessGrantCreateManyTenantInputEnvelope>;
};

export type AccessGrantCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AccessGrantCreateWithoutUserInput>>;
  createMany?: InputMaybe<AccessGrantCreateManyUserInputEnvelope>;
};

export type AccessGrantCreateNestedOneWithoutAccessGrantResIdInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutAccessGrantResIdInput>;
  create?: InputMaybe<AccessGrantCreateWithoutAccessGrantResIdInput>;
};

export type AccessGrantCreateNestedOneWithoutCallRecordsInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutCallRecordsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutCallRecordsInput>;
};

export type AccessGrantCreateNestedOneWithoutCredentialsInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutCredentialsInput>;
};

export type AccessGrantCreateNestedOneWithoutDeviceRegistrationsInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutDeviceRegistrationsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutDeviceRegistrationsInput>;
};

export type AccessGrantCreateNestedOneWithoutInfosInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutInfosInput>;
  create?: InputMaybe<AccessGrantCreateWithoutInfosInput>;
};

export type AccessGrantCreateNestedOneWithoutNotificationsInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutNotificationsInput>;
};

export type AccessGrantCreateNestedOneWithoutOverridesInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutOverridesInput>;
  create?: InputMaybe<AccessGrantCreateWithoutOverridesInput>;
};

export type AccessGrantCreateNestedOneWithoutPassesInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutPassesInput>;
  create?: InputMaybe<AccessGrantCreateWithoutPassesInput>;
};

export type AccessGrantCreateNestedOneWithoutPaymentTransactionsInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutPaymentTransactionsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutPaymentTransactionsInput>;
};

export type AccessGrantCreateNestedOneWithoutRequirementsInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutRequirementsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutRequirementsInput>;
};

export type AccessGrantCreateNestedOneWithoutSecondaryUsersInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutSecondaryUsersInput>;
  create?: InputMaybe<AccessGrantCreateWithoutSecondaryUsersInput>;
};

export type AccessGrantCreateNestedOneWithoutServiceRequestsInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutServiceRequestsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutServiceRequestsInput>;
};

export type AccessGrantCreateNestedOneWithoutSupplementaryCardsInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutSupplementaryCardsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutSupplementaryCardsInput>;
};

export type AccessGrantCreateNestedOneWithoutUserAccessGrantRequirementInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutUserAccessGrantRequirementInput>;
  create?: InputMaybe<AccessGrantCreateWithoutUserAccessGrantRequirementInput>;
};

export type AccessGrantCreateOrConnectWithoutAccessGrantResIdInput = {
  create: AccessGrantCreateWithoutAccessGrantResIdInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutCallRecordsInput = {
  create: AccessGrantCreateWithoutCallRecordsInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutCredentialsInput = {
  create: AccessGrantCreateWithoutCredentialsInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutDeviceRegistrationsInput = {
  create: AccessGrantCreateWithoutDeviceRegistrationsInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutInfosInput = {
  create: AccessGrantCreateWithoutInfosInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutLocationInput = {
  create: AccessGrantCreateWithoutLocationInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutNotificationsInput = {
  create: AccessGrantCreateWithoutNotificationsInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutOverridesInput = {
  create: AccessGrantCreateWithoutOverridesInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutPassesInput = {
  create: AccessGrantCreateWithoutPassesInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutPaymentTransactionsInput = {
  create: AccessGrantCreateWithoutPaymentTransactionsInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutRequirementsInput = {
  create: AccessGrantCreateWithoutRequirementsInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutResourcesInput = {
  create: AccessGrantCreateWithoutResourcesInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutSecondaryUsersInput = {
  create: AccessGrantCreateWithoutSecondaryUsersInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutServiceRequestsInput = {
  create: AccessGrantCreateWithoutServiceRequestsInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutSupplementaryCardsInput = {
  create: AccessGrantCreateWithoutSupplementaryCardsInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutTenantInput = {
  create: AccessGrantCreateWithoutTenantInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutUserAccessGrantRequirementInput = {
  create: AccessGrantCreateWithoutUserAccessGrantRequirementInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateOrConnectWithoutUserInput = {
  create: AccessGrantCreateWithoutUserInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantCreateWithoutAccessGrantResIdInput = {
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutCallRecordsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutCredentialsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutDeviceRegistrationsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutInfosInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutLocationInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutNotificationsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutOverridesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutPassesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutPaymentTransactionsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutRequirementsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutResourcesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutSecondaryUsersInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutServiceRequestsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutSupplementaryCardsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutTenantInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantCreateWithoutUserAccessGrantRequirementInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutAccessGrantsInput;
};

export type AccessGrantCreateWithoutUserInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutAccessGrantInput>;
  address?: InputMaybe<Scalars['String']>;
  arrivalTime?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutAccessGrantInput>;
  code?: InputMaybe<Scalars['String']>;
  confirmationCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentials?: InputMaybe<CredentialCreateNestedManyWithoutAccessGrantInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutAccessGrantInput>;
  endDate?: InputMaybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: InputMaybe<Scalars['String']>;
  floorPlan?: InputMaybe<Scalars['String']>;
  gotCODResponse?: InputMaybe<Scalars['Boolean']>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<Scalars['DateTime']>;
  housekeepingRRule?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  idVerification?: InputMaybe<IdVerification>;
  idVerificationResult?: InputMaybe<IdVerificationResultCreateNestedOneWithoutAccessGrantInput>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutAccessGrantInput>;
  lastPolledAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutAccessGrantsInput;
  maxKeys?: InputMaybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: InputMaybe<Scalars['DateTime']>;
  notifications?: InputMaybe<NotificationCreateNestedManyWithoutAccessGrantInput>;
  numKeysDispensed?: InputMaybe<Scalars['Int']>;
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutAccessGrantInput>;
  passes?: InputMaybe<PassCreateNestedManyWithoutAccessGrantInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionCreateNestedManyWithoutAccessGrantInput>;
  qrCodeImageUrl?: InputMaybe<Scalars['String']>;
  requirements?: InputMaybe<RequirementCreateNestedManyWithoutAccessGrantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutAccessGrantsInput>;
  retryCheckin?: InputMaybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: InputMaybe<Scalars['DateTime']>;
  roomNumber?: InputMaybe<Scalars['String']>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutAccessGrantInput>;
  startDate?: InputMaybe<Scalars['String']>;
  startsAt?: InputMaybe<Scalars['DateTime']>;
  startTime?: InputMaybe<Scalars['String']>;
  state?: InputMaybe<AccessGrantState>;
  status?: InputMaybe<AccessGrantStatus>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutAccessGrantInput>;
  tenant: TenantCreateNestedOneWithoutAccessGrantsInput;
  type?: InputMaybe<AccessGrantType>;
  uidOnLocation?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput>;
};

export type AccessGrantGroupBy = {
  _avg?: Maybe<AccessGrantAvgAggregate>;
  _count?: Maybe<AccessGrantCountAggregate>;
  _max?: Maybe<AccessGrantMaxAggregate>;
  _min?: Maybe<AccessGrantMinAggregate>;
  _sum?: Maybe<AccessGrantSumAggregate>;
  address?: Maybe<Scalars['String']>;
  arrivalTime?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  endDate?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: Maybe<Scalars['String']>;
  floorPlan?: Maybe<Scalars['String']>;
  gotCODResponse?: Maybe<Scalars['Boolean']>;
  gracePeriods?: Maybe<Scalars['JSON']>;
  housekeepingDate?: Maybe<Scalars['DateTime']>;
  housekeepingRRule?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idVerification: IdVerification;
  idVerificationResultId?: Maybe<Scalars['String']>;
  lastPolledAt?: Maybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  maxKeys?: Maybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: Maybe<Scalars['DateTime']>;
  numKeysDispensed?: Maybe<Scalars['Int']>;
  qrCodeImageUrl?: Maybe<Scalars['String']>;
  retryCheckin?: Maybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: Maybe<Scalars['DateTime']>;
  roomNumber?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  startTime?: Maybe<Scalars['String']>;
  state?: Maybe<AccessGrantState>;
  status: AccessGrantStatus;
  tenantId: Scalars['String'];
  type: AccessGrantType;
  uidOnLocation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type AccessGrantListRelationFilter = {
  every?: InputMaybe<AccessGrantWhereInput>;
  none?: InputMaybe<AccessGrantWhereInput>;
  some?: InputMaybe<AccessGrantWhereInput>;
};

export type AccessGrantMaxAggregate = {
  address?: Maybe<Scalars['String']>;
  arrivalTime?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['String']>;
  floorPlan?: Maybe<Scalars['String']>;
  gotCODResponse?: Maybe<Scalars['Boolean']>;
  housekeepingDate?: Maybe<Scalars['DateTime']>;
  housekeepingRRule?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  idVerification?: Maybe<IdVerification>;
  idVerificationResultId?: Maybe<Scalars['String']>;
  lastPolledAt?: Maybe<Scalars['DateTime']>;
  locationId?: Maybe<Scalars['String']>;
  maxKeys?: Maybe<Scalars['Int']>;
  noticeDate?: Maybe<Scalars['DateTime']>;
  numKeysDispensed?: Maybe<Scalars['Int']>;
  qrCodeImageUrl?: Maybe<Scalars['String']>;
  retryCheckin?: Maybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: Maybe<Scalars['DateTime']>;
  roomNumber?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['String']>;
  state?: Maybe<AccessGrantState>;
  status?: Maybe<AccessGrantStatus>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<AccessGrantType>;
  uidOnLocation?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type AccessGrantMaxOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  arrivalTime?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  confirmationCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  endsAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  floorPlan?: InputMaybe<SortOrder>;
  gotCODResponse?: InputMaybe<SortOrder>;
  housekeepingDate?: InputMaybe<SortOrder>;
  housekeepingRRule?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idVerification?: InputMaybe<SortOrder>;
  idVerificationResultId?: InputMaybe<SortOrder>;
  lastPolledAt?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  maxKeys?: InputMaybe<SortOrder>;
  noticeDate?: InputMaybe<SortOrder>;
  numKeysDispensed?: InputMaybe<SortOrder>;
  qrCodeImageUrl?: InputMaybe<SortOrder>;
  retryCheckin?: InputMaybe<SortOrder>;
  retryCheckinStartsAt?: InputMaybe<SortOrder>;
  roomNumber?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  startsAt?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  uidOnLocation?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccessGrantMinAggregate = {
  address?: Maybe<Scalars['String']>;
  arrivalTime?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  endDate?: Maybe<Scalars['String']>;
  endsAt?: Maybe<Scalars['DateTime']>;
  endTime?: Maybe<Scalars['String']>;
  floorPlan?: Maybe<Scalars['String']>;
  gotCODResponse?: Maybe<Scalars['Boolean']>;
  housekeepingDate?: Maybe<Scalars['DateTime']>;
  housekeepingRRule?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  idVerification?: Maybe<IdVerification>;
  idVerificationResultId?: Maybe<Scalars['String']>;
  lastPolledAt?: Maybe<Scalars['DateTime']>;
  locationId?: Maybe<Scalars['String']>;
  maxKeys?: Maybe<Scalars['Int']>;
  noticeDate?: Maybe<Scalars['DateTime']>;
  numKeysDispensed?: Maybe<Scalars['Int']>;
  qrCodeImageUrl?: Maybe<Scalars['String']>;
  retryCheckin?: Maybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: Maybe<Scalars['DateTime']>;
  roomNumber?: Maybe<Scalars['String']>;
  startDate?: Maybe<Scalars['String']>;
  startsAt?: Maybe<Scalars['DateTime']>;
  startTime?: Maybe<Scalars['String']>;
  state?: Maybe<AccessGrantState>;
  status?: Maybe<AccessGrantStatus>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<AccessGrantType>;
  uidOnLocation?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
};

export type AccessGrantMinOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  arrivalTime?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  confirmationCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  endsAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrder>;
  floorPlan?: InputMaybe<SortOrder>;
  gotCODResponse?: InputMaybe<SortOrder>;
  housekeepingDate?: InputMaybe<SortOrder>;
  housekeepingRRule?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  idVerification?: InputMaybe<SortOrder>;
  idVerificationResultId?: InputMaybe<SortOrder>;
  lastPolledAt?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  maxKeys?: InputMaybe<SortOrder>;
  noticeDate?: InputMaybe<SortOrder>;
  numKeysDispensed?: InputMaybe<SortOrder>;
  qrCodeImageUrl?: InputMaybe<SortOrder>;
  retryCheckin?: InputMaybe<SortOrder>;
  retryCheckinStartsAt?: InputMaybe<SortOrder>;
  roomNumber?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  startsAt?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  uidOnLocation?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccessGrantOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccessGrantOrderByWithAggregationInput = {
  _avg?: InputMaybe<AccessGrantAvgOrderByAggregateInput>;
  _count?: InputMaybe<AccessGrantCountOrderByAggregateInput>;
  _max?: InputMaybe<AccessGrantMaxOrderByAggregateInput>;
  _min?: InputMaybe<AccessGrantMinOrderByAggregateInput>;
  _sum?: InputMaybe<AccessGrantSumOrderByAggregateInput>;
  address?: InputMaybe<SortOrderInput>;
  arrivalTime?: InputMaybe<SortOrderInput>;
  code?: InputMaybe<SortOrderInput>;
  confirmationCode?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrderInput>;
  endsAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrderInput>;
  floorPlan?: InputMaybe<SortOrderInput>;
  gotCODResponse?: InputMaybe<SortOrderInput>;
  gracePeriods?: InputMaybe<SortOrderInput>;
  housekeepingDate?: InputMaybe<SortOrderInput>;
  housekeepingRRule?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  idVerification?: InputMaybe<SortOrder>;
  idVerificationResultId?: InputMaybe<SortOrderInput>;
  lastPolledAt?: InputMaybe<SortOrderInput>;
  locationId?: InputMaybe<SortOrder>;
  maxKeys?: InputMaybe<SortOrderInput>;
  metadata?: InputMaybe<SortOrder>;
  noticeDate?: InputMaybe<SortOrderInput>;
  numKeysDispensed?: InputMaybe<SortOrderInput>;
  qrCodeImageUrl?: InputMaybe<SortOrderInput>;
  retryCheckin?: InputMaybe<SortOrderInput>;
  retryCheckinStartsAt?: InputMaybe<SortOrderInput>;
  roomNumber?: InputMaybe<SortOrderInput>;
  startDate?: InputMaybe<SortOrderInput>;
  startsAt?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrderInput>;
  state?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  uidOnLocation?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type AccessGrantOrderByWithRelationInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdOrderByRelationAggregateInput>;
  address?: InputMaybe<SortOrderInput>;
  arrivalTime?: InputMaybe<SortOrderInput>;
  callRecords?: InputMaybe<CallRecordOrderByRelationAggregateInput>;
  code?: InputMaybe<SortOrderInput>;
  confirmationCode?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  credentials?: InputMaybe<CredentialOrderByRelationAggregateInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationOrderByRelationAggregateInput>;
  endDate?: InputMaybe<SortOrderInput>;
  endsAt?: InputMaybe<SortOrder>;
  endTime?: InputMaybe<SortOrderInput>;
  floorPlan?: InputMaybe<SortOrderInput>;
  gotCODResponse?: InputMaybe<SortOrderInput>;
  gracePeriods?: InputMaybe<SortOrderInput>;
  housekeepingDate?: InputMaybe<SortOrderInput>;
  housekeepingRRule?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  idVerification?: InputMaybe<SortOrder>;
  idVerificationResult?: InputMaybe<IdVerificationResultOrderByWithRelationInput>;
  idVerificationResultId?: InputMaybe<SortOrderInput>;
  infos?: InputMaybe<InfoItemOrderByRelationAggregateInput>;
  lastPolledAt?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrder>;
  maxKeys?: InputMaybe<SortOrderInput>;
  metadata?: InputMaybe<SortOrder>;
  noticeDate?: InputMaybe<SortOrderInput>;
  notifications?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  numKeysDispensed?: InputMaybe<SortOrderInput>;
  overrides?: InputMaybe<OverrideOrderByRelationAggregateInput>;
  passes?: InputMaybe<PassOrderByRelationAggregateInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionOrderByRelationAggregateInput>;
  qrCodeImageUrl?: InputMaybe<SortOrderInput>;
  requirements?: InputMaybe<RequirementOrderByRelationAggregateInput>;
  resources?: InputMaybe<ResourceOrderByRelationAggregateInput>;
  retryCheckin?: InputMaybe<SortOrderInput>;
  retryCheckinStartsAt?: InputMaybe<SortOrderInput>;
  roomNumber?: InputMaybe<SortOrderInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsOrderByRelationAggregateInput>;
  serviceRequests?: InputMaybe<ServiceRequestOrderByRelationAggregateInput>;
  startDate?: InputMaybe<SortOrderInput>;
  startsAt?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrderInput>;
  state?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  supplementaryCards?: InputMaybe<SupplementaryCardOrderByRelationAggregateInput>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  uidOnLocation?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementOrderByRelationAggregateInput>;
  userId?: InputMaybe<SortOrder>;
};

export type AccessGrantRelationFilter = {
  is?: InputMaybe<AccessGrantWhereInput>;
  isNot?: InputMaybe<AccessGrantWhereInput>;
};

export type AccessGrantResId = {
  accessGrantId: Scalars['String'];
  id: Scalars['String'];
  locationId: Scalars['String'];
  resId: Scalars['String'];
  type: Scalars['String'];
};

export type AccessGrantResIdAccessGrantIdTypeCompoundUniqueInput = {
  accessGrantId: Scalars['String'];
  type: Scalars['String'];
};

export type AccessGrantResIdCreateManyAccessGrantInput = {
  id?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
  resId: Scalars['String'];
  type: Scalars['String'];
};

export type AccessGrantResIdCreateManyAccessGrantInputEnvelope = {
  data: Array<AccessGrantResIdCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AccessGrantResIdCreateManyLocationInput = {
  accessGrantId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  resId: Scalars['String'];
  type: Scalars['String'];
};

export type AccessGrantResIdCreateManyLocationInputEnvelope = {
  data: Array<AccessGrantResIdCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AccessGrantResIdCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantResIdCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<AccessGrantResIdCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<AccessGrantResIdCreateManyAccessGrantInputEnvelope>;
};

export type AccessGrantResIdCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantResIdCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<AccessGrantResIdCreateWithoutLocationInput>>;
  createMany?: InputMaybe<AccessGrantResIdCreateManyLocationInputEnvelope>;
};

export type AccessGrantResIdCreateOrConnectWithoutAccessGrantInput = {
  create: AccessGrantResIdCreateWithoutAccessGrantInput;
  where: AccessGrantResIdWhereUniqueInput;
};

export type AccessGrantResIdCreateOrConnectWithoutLocationInput = {
  create: AccessGrantResIdCreateWithoutLocationInput;
  where: AccessGrantResIdWhereUniqueInput;
};

export type AccessGrantResIdCreateWithoutAccessGrantInput = {
  id?: InputMaybe<Scalars['String']>;
  location: LocationCreateNestedOneWithoutAccessGrantResIdInput;
  resId: Scalars['String'];
  type: Scalars['String'];
};

export type AccessGrantResIdCreateWithoutLocationInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutAccessGrantResIdInput;
  id?: InputMaybe<Scalars['String']>;
  resId: Scalars['String'];
  type: Scalars['String'];
};

export type AccessGrantResIdListRelationFilter = {
  every?: InputMaybe<AccessGrantResIdWhereInput>;
  none?: InputMaybe<AccessGrantResIdWhereInput>;
  some?: InputMaybe<AccessGrantResIdWhereInput>;
};

export type AccessGrantResIdOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AccessGrantResIdOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrder>;
  resId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export enum AccessGrantResIdScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  Id = 'id',
  LocationId = 'locationId',
  ResId = 'resId',
  Type = 'type'
}

export type AccessGrantResIdScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<AccessGrantResIdScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<AccessGrantResIdScalarWhereInput>>;
  OR?: InputMaybe<Array<AccessGrantResIdScalarWhereInput>>;
  resId?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type AccessGrantResIdUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  resId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantResIdCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<AccessGrantResIdCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<AccessGrantResIdCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessGrantResIdScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessGrantResIdUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<AccessGrantResIdUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<AccessGrantResIdUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type AccessGrantResIdUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantResIdCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<AccessGrantResIdCreateWithoutLocationInput>>;
  createMany?: InputMaybe<AccessGrantResIdCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessGrantResIdScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessGrantResIdWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessGrantResIdUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<AccessGrantResIdUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<AccessGrantResIdUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type AccessGrantResIdUpdateManyWithWhereWithoutAccessGrantInput = {
  data: AccessGrantResIdUpdateManyMutationInput;
  where: AccessGrantResIdScalarWhereInput;
};

export type AccessGrantResIdUpdateManyWithWhereWithoutLocationInput = {
  data: AccessGrantResIdUpdateManyMutationInput;
  where: AccessGrantResIdScalarWhereInput;
};

export type AccessGrantResIdUpdateWithoutAccessGrantInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantResIdNestedInput>;
  resId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccessGrantResIdUpdateWithoutLocationInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutAccessGrantResIdNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  resId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AccessGrantResIdUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: AccessGrantResIdUpdateWithoutAccessGrantInput;
  where: AccessGrantResIdWhereUniqueInput;
};

export type AccessGrantResIdUpdateWithWhereUniqueWithoutLocationInput = {
  data: AccessGrantResIdUpdateWithoutLocationInput;
  where: AccessGrantResIdWhereUniqueInput;
};

export type AccessGrantResIdUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: AccessGrantResIdCreateWithoutAccessGrantInput;
  update: AccessGrantResIdUpdateWithoutAccessGrantInput;
  where: AccessGrantResIdWhereUniqueInput;
};

export type AccessGrantResIdUpsertWithWhereUniqueWithoutLocationInput = {
  create: AccessGrantResIdCreateWithoutLocationInput;
  update: AccessGrantResIdUpdateWithoutLocationInput;
  where: AccessGrantResIdWhereUniqueInput;
};

export type AccessGrantResIdWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<AccessGrantResIdWhereInput>>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<AccessGrantResIdWhereInput>>;
  OR?: InputMaybe<Array<AccessGrantResIdWhereInput>>;
  resId?: InputMaybe<StringFilter>;
  type?: InputMaybe<StringFilter>;
};

export type AccessGrantResIdWhereUniqueInput = {
  accessGrantId_type?: InputMaybe<AccessGrantResIdAccessGrantIdTypeCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export enum AccessGrantScalarFieldEnum {
  Address = 'address',
  ArrivalTime = 'arrivalTime',
  Code = 'code',
  ConfirmationCode = 'confirmationCode',
  CreatedAt = 'createdAt',
  EndDate = 'endDate',
  EndsAt = 'endsAt',
  EndTime = 'endTime',
  FloorPlan = 'floorPlan',
  GotCodResponse = 'gotCODResponse',
  GracePeriods = 'gracePeriods',
  HousekeepingDate = 'housekeepingDate',
  HousekeepingRRule = 'housekeepingRRule',
  Id = 'id',
  IdVerification = 'idVerification',
  IdVerificationResultId = 'idVerificationResultId',
  LastPolledAt = 'lastPolledAt',
  LocationId = 'locationId',
  MaxKeys = 'maxKeys',
  Metadata = 'metadata',
  NoticeDate = 'noticeDate',
  NumKeysDispensed = 'numKeysDispensed',
  QrCodeImageUrl = 'qrCodeImageUrl',
  RetryCheckin = 'retryCheckin',
  RetryCheckinStartsAt = 'retryCheckinStartsAt',
  RoomNumber = 'roomNumber',
  StartDate = 'startDate',
  StartsAt = 'startsAt',
  StartTime = 'startTime',
  State = 'state',
  Status = 'status',
  TenantId = 'tenantId',
  Type = 'type',
  UidOnLocation = 'uidOnLocation',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type AccessGrantScalarWhereInput = {
  address?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<AccessGrantScalarWhereInput>>;
  arrivalTime?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  confirmationCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  endDate?: InputMaybe<StringNullableFilter>;
  endsAt?: InputMaybe<DateTimeFilter>;
  endTime?: InputMaybe<StringNullableFilter>;
  floorPlan?: InputMaybe<StringNullableFilter>;
  gotCODResponse?: InputMaybe<BoolNullableFilter>;
  gracePeriods?: InputMaybe<JsonNullableFilter>;
  housekeepingDate?: InputMaybe<DateTimeNullableFilter>;
  housekeepingRRule?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  idVerification?: InputMaybe<EnumIdVerificationFilter>;
  idVerificationResultId?: InputMaybe<StringNullableFilter>;
  lastPolledAt?: InputMaybe<DateTimeNullableFilter>;
  locationId?: InputMaybe<StringFilter>;
  maxKeys?: InputMaybe<IntNullableFilter>;
  metadata?: InputMaybe<JsonFilter>;
  NOT?: InputMaybe<Array<AccessGrantScalarWhereInput>>;
  noticeDate?: InputMaybe<DateTimeNullableFilter>;
  numKeysDispensed?: InputMaybe<IntNullableFilter>;
  OR?: InputMaybe<Array<AccessGrantScalarWhereInput>>;
  qrCodeImageUrl?: InputMaybe<StringNullableFilter>;
  retryCheckin?: InputMaybe<EnumRetryCheckinStatusNullableFilter>;
  retryCheckinStartsAt?: InputMaybe<DateTimeNullableFilter>;
  roomNumber?: InputMaybe<StringNullableFilter>;
  startDate?: InputMaybe<StringNullableFilter>;
  startsAt?: InputMaybe<DateTimeFilter>;
  startTime?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<EnumAccessGrantStateNullableFilter>;
  status?: InputMaybe<EnumAccessGrantStatusFilter>;
  tenantId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumAccessGrantTypeFilter>;
  uidOnLocation?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type AccessGrantScalarWhereWithAggregatesInput = {
  address?: InputMaybe<StringNullableWithAggregatesFilter>;
  AND?: InputMaybe<Array<AccessGrantScalarWhereWithAggregatesInput>>;
  arrivalTime?: InputMaybe<StringNullableWithAggregatesFilter>;
  code?: InputMaybe<StringNullableWithAggregatesFilter>;
  confirmationCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  endDate?: InputMaybe<StringNullableWithAggregatesFilter>;
  endsAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  endTime?: InputMaybe<StringNullableWithAggregatesFilter>;
  floorPlan?: InputMaybe<StringNullableWithAggregatesFilter>;
  gotCODResponse?: InputMaybe<BoolNullableWithAggregatesFilter>;
  gracePeriods?: InputMaybe<JsonNullableWithAggregatesFilter>;
  housekeepingDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  housekeepingRRule?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  idVerification?: InputMaybe<EnumIdVerificationWithAggregatesFilter>;
  idVerificationResultId?: InputMaybe<StringNullableWithAggregatesFilter>;
  lastPolledAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  locationId?: InputMaybe<StringWithAggregatesFilter>;
  maxKeys?: InputMaybe<IntNullableWithAggregatesFilter>;
  metadata?: InputMaybe<JsonWithAggregatesFilter>;
  NOT?: InputMaybe<Array<AccessGrantScalarWhereWithAggregatesInput>>;
  noticeDate?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  numKeysDispensed?: InputMaybe<IntNullableWithAggregatesFilter>;
  OR?: InputMaybe<Array<AccessGrantScalarWhereWithAggregatesInput>>;
  qrCodeImageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  retryCheckin?: InputMaybe<EnumRetryCheckinStatusNullableWithAggregatesFilter>;
  retryCheckinStartsAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  roomNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  startDate?: InputMaybe<StringNullableWithAggregatesFilter>;
  startsAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  startTime?: InputMaybe<StringNullableWithAggregatesFilter>;
  state?: InputMaybe<EnumAccessGrantStateNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumAccessGrantStatusWithAggregatesFilter>;
  tenantId?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumAccessGrantTypeWithAggregatesFilter>;
  uidOnLocation?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type AccessGrantSearchInput = {
  confirmationCode?: InputMaybe<StringFilter>;
};

export enum AccessGrantState {
  Canceled = 'CANCELED',
  CheckedOut = 'CHECKED_OUT',
  InHouse = 'IN_HOUSE',
  PreCheckIn = 'PRE_CHECK_IN'
}

export enum AccessGrantStatus {
  Active = 'ACTIVE',
  Canceled = 'CANCELED'
}

export type AccessGrantSumAggregate = {
  maxKeys?: Maybe<Scalars['Int']>;
  numKeysDispensed?: Maybe<Scalars['Int']>;
};

export type AccessGrantSumOrderByAggregateInput = {
  maxKeys?: InputMaybe<SortOrder>;
  numKeysDispensed?: InputMaybe<SortOrder>;
};

export enum AccessGrantType {
  Basic = 'BASIC',
  Hotel = 'HOTEL',
  Leasing = 'LEASING',
  Workcamp = 'WORKCAMP'
}

export type AccessGrantUpdateInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateManyMutationInput = {
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AccessGrantUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<AccessGrantCreateWithoutLocationInput>>;
  createMany?: InputMaybe<AccessGrantCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessGrantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessGrantUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<AccessGrantUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<AccessGrantUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type AccessGrantUpdateManyWithoutResourcesNestedInput = {
  connect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantCreateOrConnectWithoutResourcesInput>>;
  create?: InputMaybe<Array<AccessGrantCreateWithoutResourcesInput>>;
  delete?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessGrantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessGrantUpdateWithWhereUniqueWithoutResourcesInput>>;
  updateMany?: InputMaybe<Array<AccessGrantUpdateManyWithWhereWithoutResourcesInput>>;
  upsert?: InputMaybe<Array<AccessGrantUpsertWithWhereUniqueWithoutResourcesInput>>;
};

export type AccessGrantUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<AccessGrantCreateWithoutTenantInput>>;
  createMany?: InputMaybe<AccessGrantCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessGrantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessGrantUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<AccessGrantUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<AccessGrantUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type AccessGrantUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AccessGrantCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AccessGrantCreateWithoutUserInput>>;
  createMany?: InputMaybe<AccessGrantCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AccessGrantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  set?: InputMaybe<Array<AccessGrantWhereUniqueInput>>;
  update?: InputMaybe<Array<AccessGrantUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<AccessGrantUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<AccessGrantUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AccessGrantUpdateManyWithWhereWithoutLocationInput = {
  data: AccessGrantUpdateManyMutationInput;
  where: AccessGrantScalarWhereInput;
};

export type AccessGrantUpdateManyWithWhereWithoutResourcesInput = {
  data: AccessGrantUpdateManyMutationInput;
  where: AccessGrantScalarWhereInput;
};

export type AccessGrantUpdateManyWithWhereWithoutTenantInput = {
  data: AccessGrantUpdateManyMutationInput;
  where: AccessGrantScalarWhereInput;
};

export type AccessGrantUpdateManyWithWhereWithoutUserInput = {
  data: AccessGrantUpdateManyMutationInput;
  where: AccessGrantScalarWhereInput;
};

export type AccessGrantUpdateOneRequiredWithoutAccessGrantResIdNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutAccessGrantResIdInput>;
  create?: InputMaybe<AccessGrantCreateWithoutAccessGrantResIdInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutAccessGrantResIdInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutAccessGrantResIdInput>;
};

export type AccessGrantUpdateOneRequiredWithoutCredentialsNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutCredentialsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutCredentialsInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutCredentialsInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutCredentialsInput>;
};

export type AccessGrantUpdateOneRequiredWithoutDeviceRegistrationsNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutDeviceRegistrationsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutDeviceRegistrationsInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutDeviceRegistrationsInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutDeviceRegistrationsInput>;
};

export type AccessGrantUpdateOneRequiredWithoutPassesNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutPassesInput>;
  create?: InputMaybe<AccessGrantCreateWithoutPassesInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutPassesInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutPassesInput>;
};

export type AccessGrantUpdateOneRequiredWithoutPaymentTransactionsNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutPaymentTransactionsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutPaymentTransactionsInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutPaymentTransactionsInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutPaymentTransactionsInput>;
};

export type AccessGrantUpdateOneRequiredWithoutRequirementsNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutRequirementsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutRequirementsInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutRequirementsInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutRequirementsInput>;
};

export type AccessGrantUpdateOneRequiredWithoutSecondaryUsersNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutSecondaryUsersInput>;
  create?: InputMaybe<AccessGrantCreateWithoutSecondaryUsersInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutSecondaryUsersInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutSecondaryUsersInput>;
};

export type AccessGrantUpdateOneRequiredWithoutServiceRequestsNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutServiceRequestsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutServiceRequestsInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutServiceRequestsInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutServiceRequestsInput>;
};

export type AccessGrantUpdateOneRequiredWithoutSupplementaryCardsNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutSupplementaryCardsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutSupplementaryCardsInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutSupplementaryCardsInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutSupplementaryCardsInput>;
};

export type AccessGrantUpdateOneRequiredWithoutUserAccessGrantRequirementNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutUserAccessGrantRequirementInput>;
  create?: InputMaybe<AccessGrantCreateWithoutUserAccessGrantRequirementInput>;
  update?: InputMaybe<AccessGrantUpdateWithoutUserAccessGrantRequirementInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutUserAccessGrantRequirementInput>;
};

export type AccessGrantUpdateOneWithoutCallRecordsNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutCallRecordsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutCallRecordsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<AccessGrantUpdateWithoutCallRecordsInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutCallRecordsInput>;
};

export type AccessGrantUpdateOneWithoutInfosNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutInfosInput>;
  create?: InputMaybe<AccessGrantCreateWithoutInfosInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<AccessGrantUpdateWithoutInfosInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutInfosInput>;
};

export type AccessGrantUpdateOneWithoutNotificationsNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutNotificationsInput>;
  create?: InputMaybe<AccessGrantCreateWithoutNotificationsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<AccessGrantUpdateWithoutNotificationsInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutNotificationsInput>;
};

export type AccessGrantUpdateOneWithoutOverridesNestedInput = {
  connect?: InputMaybe<AccessGrantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AccessGrantCreateOrConnectWithoutOverridesInput>;
  create?: InputMaybe<AccessGrantCreateWithoutOverridesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<AccessGrantUpdateWithoutOverridesInput>;
  upsert?: InputMaybe<AccessGrantUpsertWithoutOverridesInput>;
};

export type AccessGrantUpdateWithoutAccessGrantResIdInput = {
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutCallRecordsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutCredentialsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutDeviceRegistrationsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutInfosInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutLocationInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutNotificationsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutOverridesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutPassesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutPaymentTransactionsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutRequirementsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutResourcesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutSecondaryUsersInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutServiceRequestsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutSupplementaryCardsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutTenantInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithoutUserAccessGrantRequirementInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutAccessGrantsNestedInput>;
};

export type AccessGrantUpdateWithoutUserInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutAccessGrantNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  arrivalTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutAccessGrantNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  confirmationCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credentials?: InputMaybe<CredentialUpdateManyWithoutAccessGrantNestedInput>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput>;
  endDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floorPlan?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  gotCODResponse?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  gracePeriods?: InputMaybe<Scalars['JSON']>;
  housekeepingDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  housekeepingRRule?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  idVerification?: InputMaybe<EnumIdVerificationFieldUpdateOperationsInput>;
  idVerificationResult?: InputMaybe<IdVerificationResultUpdateOneWithoutAccessGrantNestedInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutAccessGrantNestedInput>;
  lastPolledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  maxKeys?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  noticeDate?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  notifications?: InputMaybe<NotificationUpdateManyWithoutAccessGrantNestedInput>;
  numKeysDispensed?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutAccessGrantNestedInput>;
  passes?: InputMaybe<PassUpdateManyWithoutAccessGrantNestedInput>;
  paymentTransactions?: InputMaybe<PaymentTransactionUpdateManyWithoutAccessGrantNestedInput>;
  qrCodeImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  requirements?: InputMaybe<RequirementUpdateManyWithoutAccessGrantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutAccessGrantsNestedInput>;
  retryCheckin?: InputMaybe<NullableEnumRetryCheckinStatusFieldUpdateOperationsInput>;
  retryCheckinStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  roomNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutAccessGrantNestedInput>;
  startDate?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  startsAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  state?: InputMaybe<NullableEnumAccessGrantStateFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumAccessGrantStatusFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutAccessGrantNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutAccessGrantsNestedInput>;
  type?: InputMaybe<EnumAccessGrantTypeFieldUpdateOperationsInput>;
  uidOnLocation?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput>;
};

export type AccessGrantUpdateWithWhereUniqueWithoutLocationInput = {
  data: AccessGrantUpdateWithoutLocationInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantUpdateWithWhereUniqueWithoutResourcesInput = {
  data: AccessGrantUpdateWithoutResourcesInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantUpdateWithWhereUniqueWithoutTenantInput = {
  data: AccessGrantUpdateWithoutTenantInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantUpdateWithWhereUniqueWithoutUserInput = {
  data: AccessGrantUpdateWithoutUserInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantUpsertWithoutAccessGrantResIdInput = {
  create: AccessGrantCreateWithoutAccessGrantResIdInput;
  update: AccessGrantUpdateWithoutAccessGrantResIdInput;
};

export type AccessGrantUpsertWithoutCallRecordsInput = {
  create: AccessGrantCreateWithoutCallRecordsInput;
  update: AccessGrantUpdateWithoutCallRecordsInput;
};

export type AccessGrantUpsertWithoutCredentialsInput = {
  create: AccessGrantCreateWithoutCredentialsInput;
  update: AccessGrantUpdateWithoutCredentialsInput;
};

export type AccessGrantUpsertWithoutDeviceRegistrationsInput = {
  create: AccessGrantCreateWithoutDeviceRegistrationsInput;
  update: AccessGrantUpdateWithoutDeviceRegistrationsInput;
};

export type AccessGrantUpsertWithoutInfosInput = {
  create: AccessGrantCreateWithoutInfosInput;
  update: AccessGrantUpdateWithoutInfosInput;
};

export type AccessGrantUpsertWithoutNotificationsInput = {
  create: AccessGrantCreateWithoutNotificationsInput;
  update: AccessGrantUpdateWithoutNotificationsInput;
};

export type AccessGrantUpsertWithoutOverridesInput = {
  create: AccessGrantCreateWithoutOverridesInput;
  update: AccessGrantUpdateWithoutOverridesInput;
};

export type AccessGrantUpsertWithoutPassesInput = {
  create: AccessGrantCreateWithoutPassesInput;
  update: AccessGrantUpdateWithoutPassesInput;
};

export type AccessGrantUpsertWithoutPaymentTransactionsInput = {
  create: AccessGrantCreateWithoutPaymentTransactionsInput;
  update: AccessGrantUpdateWithoutPaymentTransactionsInput;
};

export type AccessGrantUpsertWithoutRequirementsInput = {
  create: AccessGrantCreateWithoutRequirementsInput;
  update: AccessGrantUpdateWithoutRequirementsInput;
};

export type AccessGrantUpsertWithoutSecondaryUsersInput = {
  create: AccessGrantCreateWithoutSecondaryUsersInput;
  update: AccessGrantUpdateWithoutSecondaryUsersInput;
};

export type AccessGrantUpsertWithoutServiceRequestsInput = {
  create: AccessGrantCreateWithoutServiceRequestsInput;
  update: AccessGrantUpdateWithoutServiceRequestsInput;
};

export type AccessGrantUpsertWithoutSupplementaryCardsInput = {
  create: AccessGrantCreateWithoutSupplementaryCardsInput;
  update: AccessGrantUpdateWithoutSupplementaryCardsInput;
};

export type AccessGrantUpsertWithoutUserAccessGrantRequirementInput = {
  create: AccessGrantCreateWithoutUserAccessGrantRequirementInput;
  update: AccessGrantUpdateWithoutUserAccessGrantRequirementInput;
};

export type AccessGrantUpsertWithWhereUniqueWithoutLocationInput = {
  create: AccessGrantCreateWithoutLocationInput;
  update: AccessGrantUpdateWithoutLocationInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantUpsertWithWhereUniqueWithoutResourcesInput = {
  create: AccessGrantCreateWithoutResourcesInput;
  update: AccessGrantUpdateWithoutResourcesInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantUpsertWithWhereUniqueWithoutTenantInput = {
  create: AccessGrantCreateWithoutTenantInput;
  update: AccessGrantUpdateWithoutTenantInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantUpsertWithWhereUniqueWithoutUserInput = {
  create: AccessGrantCreateWithoutUserInput;
  update: AccessGrantUpdateWithoutUserInput;
  where: AccessGrantWhereUniqueInput;
};

export type AccessGrantUser = {
  _count?: Maybe<UserCount>;
  accessGrants: Array<AccessGrant>;
  authChallenges: Array<AuthChallenge>;
  callRecords: Array<CallRecord>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  Credential: Array<Credential>;
  cuid: Scalars['String'];
  dashboardPreferences?: Maybe<Scalars['JSON']>;
  deviceId?: Maybe<Scalars['String']>;
  devices: Array<Device>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internalApiCalls: Array<InternalApiCall>;
  lastName?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  madeCalls: Array<CallRecord>;
  memberships: Array<Membership>;
  name?: Maybe<Scalars['String']>;
  Notification: Array<Notification>;
  openpathExternalUserId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  payments: Array<Payment>;
  phoneNumber?: Maybe<Scalars['String']>;
  primary: Scalars['Boolean'];
  receivedCalls: Array<CallRecord>;
  SecondaryUsersOnAccessGrants: Array<SecondaryUsersOnAccessGrants>;
  UserAccessGrantRequirement: Array<UserAccessGrantRequirement>;
  UserLocationData: Array<UserLocationData>;
  userPushNotificationTokens: Array<UserPushNotificationToken>;
  userRecords: Array<UserRecord>;
  UserTenantData: Array<UserTenantData>;
};


export type AccessGrantUserAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type AccessGrantUserAuthChallengesArgs = {
  cursor?: InputMaybe<AuthChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuthChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuthChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuthChallengeWhereInput>;
};


export type AccessGrantUserCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type AccessGrantUserCredentialArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type AccessGrantUserDevicesArgs = {
  cursor?: InputMaybe<DeviceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DeviceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DeviceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type AccessGrantUserInternalApiCallsArgs = {
  cursor?: InputMaybe<InternalApiCallWhereUniqueInput>;
  distinct?: InputMaybe<Array<InternalApiCallScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InternalApiCallOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InternalApiCallWhereInput>;
};


export type AccessGrantUserMadeCallsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type AccessGrantUserMembershipsArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type AccessGrantUserNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type AccessGrantUserPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type AccessGrantUserReceivedCallsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type AccessGrantUserSecondaryUsersOnAccessGrantsArgs = {
  cursor?: InputMaybe<SecondaryUsersOnAccessGrantsWhereUniqueInput>;
  distinct?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SecondaryUsersOnAccessGrantsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
};


export type AccessGrantUserUserAccessGrantRequirementArgs = {
  cursor?: InputMaybe<UserAccessGrantRequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAccessGrantRequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAccessGrantRequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};


export type AccessGrantUserUserLocationDataArgs = {
  cursor?: InputMaybe<UserLocationDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserLocationDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserLocationDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserLocationDataWhereInput>;
};


export type AccessGrantUserUserPushNotificationTokensArgs = {
  cursor?: InputMaybe<UserPushNotificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPushNotificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPushNotificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type AccessGrantUserUserRecordsArgs = {
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type AccessGrantUserUserTenantDataArgs = {
  cursor?: InputMaybe<UserTenantDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTenantDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};

export type AccessGrantWhereInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdListRelationFilter>;
  address?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<AccessGrantWhereInput>>;
  arrivalTime?: InputMaybe<StringNullableFilter>;
  callRecords?: InputMaybe<CallRecordListRelationFilter>;
  code?: InputMaybe<StringNullableFilter>;
  confirmationCode?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentials?: InputMaybe<CredentialListRelationFilter>;
  deviceRegistrations?: InputMaybe<DeviceRegistrationListRelationFilter>;
  endDate?: InputMaybe<StringNullableFilter>;
  endsAt?: InputMaybe<DateTimeFilter>;
  endTime?: InputMaybe<StringNullableFilter>;
  floorPlan?: InputMaybe<StringNullableFilter>;
  gotCODResponse?: InputMaybe<BoolNullableFilter>;
  gracePeriods?: InputMaybe<JsonNullableFilter>;
  housekeepingDate?: InputMaybe<DateTimeNullableFilter>;
  housekeepingRRule?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  idVerification?: InputMaybe<EnumIdVerificationFilter>;
  idVerificationResult?: InputMaybe<IdVerificationResultRelationFilter>;
  idVerificationResultId?: InputMaybe<StringNullableFilter>;
  infos?: InputMaybe<InfoItemListRelationFilter>;
  lastPolledAt?: InputMaybe<DateTimeNullableFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringFilter>;
  maxKeys?: InputMaybe<IntNullableFilter>;
  metadata?: InputMaybe<JsonFilter>;
  NOT?: InputMaybe<Array<AccessGrantWhereInput>>;
  noticeDate?: InputMaybe<DateTimeNullableFilter>;
  notifications?: InputMaybe<NotificationListRelationFilter>;
  numKeysDispensed?: InputMaybe<IntNullableFilter>;
  OR?: InputMaybe<Array<AccessGrantWhereInput>>;
  overrides?: InputMaybe<OverrideListRelationFilter>;
  passes?: InputMaybe<PassListRelationFilter>;
  paymentTransactions?: InputMaybe<PaymentTransactionListRelationFilter>;
  qrCodeImageUrl?: InputMaybe<StringNullableFilter>;
  requirements?: InputMaybe<RequirementListRelationFilter>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  retryCheckin?: InputMaybe<EnumRetryCheckinStatusNullableFilter>;
  retryCheckinStartsAt?: InputMaybe<DateTimeNullableFilter>;
  roomNumber?: InputMaybe<StringNullableFilter>;
  secondaryUsers?: InputMaybe<SecondaryUsersOnAccessGrantsListRelationFilter>;
  serviceRequests?: InputMaybe<ServiceRequestListRelationFilter>;
  startDate?: InputMaybe<StringNullableFilter>;
  startsAt?: InputMaybe<DateTimeFilter>;
  startTime?: InputMaybe<StringNullableFilter>;
  state?: InputMaybe<EnumAccessGrantStateNullableFilter>;
  status?: InputMaybe<EnumAccessGrantStatusFilter>;
  supplementaryCards?: InputMaybe<SupplementaryCardListRelationFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumAccessGrantTypeFilter>;
  uidOnLocation?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementListRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type AccessGrantWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  idVerificationResultId?: InputMaybe<Scalars['String']>;
};

export type AccessSetupInput = {
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  enableEarlyCheckInByLoyalty?: InputMaybe<Scalars['Boolean']>;
  enableEarlyCheckInByTimeRange?: InputMaybe<Scalars['Boolean']>;
};

export type AccessSetupResponse = {
  defaultEndTime: Scalars['String'];
  defaultStartTime: Scalars['String'];
  enableEarlyCheckInByLoyalty: Scalars['Boolean'];
  enableEarlyCheckInByTimeRange: Scalars['Boolean'];
  gracePeriods: GracePeriod;
  limitKeys: LimitKeys;
  packages?: Maybe<Array<EarlyCheckInPackage>>;
};

export type AccessSetupWhere = {
  locationId: Scalars['String'];
};

export type AccessTokenOnlyAuthAnswer = {
  accessToken: Scalars['String'];
};

export type ActionBarCtAs = {
  blockCheckIn?: Maybe<Scalars['Boolean']>;
  checkIn?: Maybe<Scalars['Boolean']>;
  checkOut?: Maybe<Scalars['Boolean']>;
  getAutenticationCredentials?: Maybe<Scalars['Boolean']>;
  remotePrintKeyCard?: Maybe<Scalars['Boolean']>;
  repollReservation?: Maybe<Scalars['Boolean']>;
};

export type AddUserToAccessGrantArgsWhereInput = {
  accessGrantId: Scalars['String'];
};

export type AddUserToAccessGrantInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AddUserToAccessGrantResult = {
  accessGrantId: Scalars['String'];
  userId: Scalars['String'];
};

export type AffectedRowsOutput = {
  count: Scalars['Int'];
};

export type AggregateAccessGrant = {
  _avg?: Maybe<AccessGrantAvgAggregate>;
  _count?: Maybe<AccessGrantCountAggregate>;
  _max?: Maybe<AccessGrantMaxAggregate>;
  _min?: Maybe<AccessGrantMinAggregate>;
  _sum?: Maybe<AccessGrantSumAggregate>;
};

export type AggregateAmenity = {
  _count?: Maybe<AmenityCountAggregate>;
  _max?: Maybe<AmenityMaxAggregate>;
  _min?: Maybe<AmenityMinAggregate>;
};

export type AggregateAmenityGroup = {
  _count?: Maybe<AmenityGroupCountAggregate>;
  _max?: Maybe<AmenityGroupMaxAggregate>;
  _min?: Maybe<AmenityGroupMinAggregate>;
};

export type AggregateCallRecord = {
  _avg?: Maybe<CallRecordAvgAggregate>;
  _count?: Maybe<CallRecordCountAggregate>;
  _max?: Maybe<CallRecordMaxAggregate>;
  _min?: Maybe<CallRecordMinAggregate>;
  _sum?: Maybe<CallRecordSumAggregate>;
};

export type AggregateCredential = {
  _avg?: Maybe<CredentialAvgAggregate>;
  _count?: Maybe<CredentialCountAggregate>;
  _max?: Maybe<CredentialMaxAggregate>;
  _min?: Maybe<CredentialMinAggregate>;
  _sum?: Maybe<CredentialSumAggregate>;
};

export type AggregateFileToEntity = {
  _count?: Maybe<FileToEntityCountAggregate>;
  _max?: Maybe<FileToEntityMaxAggregate>;
  _min?: Maybe<FileToEntityMinAggregate>;
};

export type AggregateInfoItem = {
  _count?: Maybe<InfoItemCountAggregate>;
  _max?: Maybe<InfoItemMaxAggregate>;
  _min?: Maybe<InfoItemMinAggregate>;
};

export type AggregateKiosk = {
  _avg?: Maybe<KioskAvgAggregate>;
  _count?: Maybe<KioskCountAggregate>;
  _max?: Maybe<KioskMaxAggregate>;
  _min?: Maybe<KioskMinAggregate>;
  _sum?: Maybe<KioskSumAggregate>;
};

export type AggregateLanguage = {
  _count?: Maybe<LanguageCountAggregate>;
  _max?: Maybe<LanguageMaxAggregate>;
  _min?: Maybe<LanguageMinAggregate>;
};

export type AggregateLocalization = {
  _count?: Maybe<LocalizationCountAggregate>;
  _max?: Maybe<LocalizationMaxAggregate>;
  _min?: Maybe<LocalizationMinAggregate>;
};

export type AggregateLocation = {
  _avg?: Maybe<LocationAvgAggregate>;
  _count?: Maybe<LocationCountAggregate>;
  _max?: Maybe<LocationMaxAggregate>;
  _min?: Maybe<LocationMinAggregate>;
  _sum?: Maybe<LocationSumAggregate>;
};

export type AggregatePass = {
  _count?: Maybe<PassCountAggregate>;
  _max?: Maybe<PassMaxAggregate>;
  _min?: Maybe<PassMinAggregate>;
};

export type AggregatePayment = {
  _count?: Maybe<PaymentCountAggregate>;
  _max?: Maybe<PaymentMaxAggregate>;
  _min?: Maybe<PaymentMinAggregate>;
};

export type AggregatePaymentTransaction = {
  _avg?: Maybe<PaymentTransactionAvgAggregate>;
  _count?: Maybe<PaymentTransactionCountAggregate>;
  _max?: Maybe<PaymentTransactionMaxAggregate>;
  _min?: Maybe<PaymentTransactionMinAggregate>;
  _sum?: Maybe<PaymentTransactionSumAggregate>;
};

export type AggregateRegistration = {
  _count?: Maybe<RegistrationCountAggregate>;
  _max?: Maybe<RegistrationMaxAggregate>;
  _min?: Maybe<RegistrationMinAggregate>;
};

export type AggregateRequirement = {
  _count?: Maybe<RequirementCountAggregate>;
  _max?: Maybe<RequirementMaxAggregate>;
  _min?: Maybe<RequirementMinAggregate>;
};

export type AggregateResource = {
  _avg?: Maybe<ResourceAvgAggregate>;
  _count?: Maybe<ResourceCountAggregate>;
  _max?: Maybe<ResourceMaxAggregate>;
  _min?: Maybe<ResourceMinAggregate>;
  _sum?: Maybe<ResourceSumAggregate>;
};

export type AggregateResourceGroup = {
  _count?: Maybe<ResourceGroupCountAggregate>;
  _max?: Maybe<ResourceGroupMaxAggregate>;
  _min?: Maybe<ResourceGroupMinAggregate>;
};

export type AggregateService = {
  _avg?: Maybe<ServiceAvgAggregate>;
  _count?: Maybe<ServiceCountAggregate>;
  _max?: Maybe<ServiceMaxAggregate>;
  _min?: Maybe<ServiceMinAggregate>;
  _sum?: Maybe<ServiceSumAggregate>;
};

export type AggregateServiceRequest = {
  _avg?: Maybe<ServiceRequestAvgAggregate>;
  _count?: Maybe<ServiceRequestCountAggregate>;
  _max?: Maybe<ServiceRequestMaxAggregate>;
  _min?: Maybe<ServiceRequestMinAggregate>;
  _sum?: Maybe<ServiceRequestSumAggregate>;
};

export type AggregateSupplementaryCard = {
  _count?: Maybe<SupplementaryCardCountAggregate>;
  _max?: Maybe<SupplementaryCardMaxAggregate>;
  _min?: Maybe<SupplementaryCardMinAggregate>;
};

export type AggregateTenant = {
  _count?: Maybe<TenantCountAggregate>;
  _max?: Maybe<TenantMaxAggregate>;
  _min?: Maybe<TenantMinAggregate>;
};

export type AggregateTheme = {
  _count?: Maybe<ThemeCountAggregate>;
  _max?: Maybe<ThemeMaxAggregate>;
  _min?: Maybe<ThemeMinAggregate>;
};

export type AggregateUnitType = {
  _avg?: Maybe<UnitTypeAvgAggregate>;
  _count?: Maybe<UnitTypeCountAggregate>;
  _max?: Maybe<UnitTypeMaxAggregate>;
  _min?: Maybe<UnitTypeMinAggregate>;
  _sum?: Maybe<UnitTypeSumAggregate>;
};

export type AggregateUser = {
  _count?: Maybe<UserCountAggregate>;
  _max?: Maybe<UserMaxAggregate>;
  _min?: Maybe<UserMinAggregate>;
};

export type AggregateUserPushNotificationToken = {
  _count?: Maybe<UserPushNotificationTokenCountAggregate>;
  _max?: Maybe<UserPushNotificationTokenMaxAggregate>;
  _min?: Maybe<UserPushNotificationTokenMinAggregate>;
};

export type AggregateUserRecord = {
  _count?: Maybe<UserRecordCountAggregate>;
  _max?: Maybe<UserRecordMaxAggregate>;
  _min?: Maybe<UserRecordMinAggregate>;
};

export type AggregateUserTenantData = {
  _count?: Maybe<UserTenantDataCountAggregate>;
  _max?: Maybe<UserTenantDataMaxAggregate>;
  _min?: Maybe<UserTenantDataMinAggregate>;
};

export type AggregateVendorServer = {
  _avg?: Maybe<VendorServerAvgAggregate>;
  _count?: Maybe<VendorServerCountAggregate>;
  _max?: Maybe<VendorServerMaxAggregate>;
  _min?: Maybe<VendorServerMinAggregate>;
  _sum?: Maybe<VendorServerSumAggregate>;
};

export type Amenity = {
  amenityGroupId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  group?: Maybe<AmenityGroup>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityCountAggregate = {
  _all: Scalars['Int'];
  amenityGroupId: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  imageUrl: Scalars['Int'];
  locationId: Scalars['Int'];
  moreInfoLink: Scalars['Int'];
  title: Scalars['Int'];
};

export type AmenityCountOrderByAggregateInput = {
  amenityGroupId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  moreInfoLink?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AmenityCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<AmenityGroupCreateNestedOneWithoutAmenitiesInput>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  location?: InputMaybe<LocationCreateNestedOneWithoutAmenitiesInput>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityCreateManyGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityCreateManyGroupInputEnvelope = {
  data: Array<AmenityCreateManyGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AmenityCreateManyInput = {
  amenityGroupId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityCreateManyLocationInput = {
  amenityGroupId?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityCreateManyLocationInputEnvelope = {
  data: Array<AmenityCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AmenityCreateNestedManyWithoutGroupInput = {
  connect?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AmenityCreateOrConnectWithoutGroupInput>>;
  create?: InputMaybe<Array<AmenityCreateWithoutGroupInput>>;
  createMany?: InputMaybe<AmenityCreateManyGroupInputEnvelope>;
};

export type AmenityCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AmenityCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<AmenityCreateWithoutLocationInput>>;
  createMany?: InputMaybe<AmenityCreateManyLocationInputEnvelope>;
};

export type AmenityCreateOrConnectWithoutGroupInput = {
  create: AmenityCreateWithoutGroupInput;
  where: AmenityWhereUniqueInput;
};

export type AmenityCreateOrConnectWithoutLocationInput = {
  create: AmenityCreateWithoutLocationInput;
  where: AmenityWhereUniqueInput;
};

export type AmenityCreateWithoutGroupInput = {
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  location?: InputMaybe<LocationCreateNestedOneWithoutAmenitiesInput>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityCreateWithoutLocationInput = {
  description?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<AmenityGroupCreateNestedOneWithoutAmenitiesInput>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityGroup = {
  _count?: Maybe<AmenityGroupCount>;
  id: Scalars['String'];
  title: Scalars['String'];
};

export type AmenityGroupBy = {
  _count?: Maybe<AmenityCountAggregate>;
  _max?: Maybe<AmenityMaxAggregate>;
  _min?: Maybe<AmenityMinAggregate>;
  amenityGroupId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityGroupCount = {
  amenities: Scalars['Int'];
};


export type AmenityGroupCountAmenitiesArgs = {
  where?: InputMaybe<AmenityWhereInput>;
};

export type AmenityGroupCountAggregate = {
  _all: Scalars['Int'];
  id: Scalars['Int'];
  title: Scalars['Int'];
};

export type AmenityGroupCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AmenityGroupCreateInput = {
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutGroupInput>;
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityGroupCreateManyInput = {
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityGroupCreateNestedOneWithoutAmenitiesInput = {
  connect?: InputMaybe<AmenityGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AmenityGroupCreateOrConnectWithoutAmenitiesInput>;
  create?: InputMaybe<AmenityGroupCreateWithoutAmenitiesInput>;
};

export type AmenityGroupCreateOrConnectWithoutAmenitiesInput = {
  create: AmenityGroupCreateWithoutAmenitiesInput;
  where: AmenityGroupWhereUniqueInput;
};

export type AmenityGroupCreateWithoutAmenitiesInput = {
  id?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type AmenityGroupGroupBy = {
  _count?: Maybe<AmenityGroupCountAggregate>;
  _max?: Maybe<AmenityGroupMaxAggregate>;
  _min?: Maybe<AmenityGroupMinAggregate>;
  id: Scalars['String'];
  title: Scalars['String'];
};

export type AmenityGroupMaxAggregate = {
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AmenityGroupMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AmenityGroupMinAggregate = {
  id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AmenityGroupMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AmenityGroupOrderByWithAggregationInput = {
  _count?: InputMaybe<AmenityGroupCountOrderByAggregateInput>;
  _max?: InputMaybe<AmenityGroupMaxOrderByAggregateInput>;
  _min?: InputMaybe<AmenityGroupMinOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AmenityGroupOrderByWithRelationInput = {
  amenities?: InputMaybe<AmenityOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AmenityGroupRelationFilter = {
  is?: InputMaybe<AmenityGroupWhereInput>;
  isNot?: InputMaybe<AmenityGroupWhereInput>;
};

export enum AmenityGroupScalarFieldEnum {
  Id = 'id',
  Title = 'title'
}

export type AmenityGroupScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<AmenityGroupScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<AmenityGroupScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AmenityGroupScalarWhereWithAggregatesInput>>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type AmenityGroupUpdateInput = {
  amenities?: InputMaybe<AmenityUpdateManyWithoutGroupNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AmenityGroupUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AmenityGroupUpdateOneWithoutAmenitiesNestedInput = {
  connect?: InputMaybe<AmenityGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<AmenityGroupCreateOrConnectWithoutAmenitiesInput>;
  create?: InputMaybe<AmenityGroupCreateWithoutAmenitiesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<AmenityGroupUpdateWithoutAmenitiesInput>;
  upsert?: InputMaybe<AmenityGroupUpsertWithoutAmenitiesInput>;
};

export type AmenityGroupUpdateWithoutAmenitiesInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AmenityGroupUpsertWithoutAmenitiesInput = {
  create: AmenityGroupCreateWithoutAmenitiesInput;
  update: AmenityGroupUpdateWithoutAmenitiesInput;
};

export type AmenityGroupWhereInput = {
  amenities?: InputMaybe<AmenityListRelationFilter>;
  AND?: InputMaybe<Array<AmenityGroupWhereInput>>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<AmenityGroupWhereInput>>;
  OR?: InputMaybe<Array<AmenityGroupWhereInput>>;
  title?: InputMaybe<StringFilter>;
};

export type AmenityGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type AmenityListRelationFilter = {
  every?: InputMaybe<AmenityWhereInput>;
  none?: InputMaybe<AmenityWhereInput>;
  some?: InputMaybe<AmenityWhereInput>;
};

export type AmenityMaxAggregate = {
  amenityGroupId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AmenityMaxOrderByAggregateInput = {
  amenityGroupId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  moreInfoLink?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AmenityMinAggregate = {
  amenityGroupId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
};

export type AmenityMinOrderByAggregateInput = {
  amenityGroupId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  moreInfoLink?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type AmenityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AmenityOrderByWithAggregationInput = {
  _count?: InputMaybe<AmenityCountOrderByAggregateInput>;
  _max?: InputMaybe<AmenityMaxOrderByAggregateInput>;
  _min?: InputMaybe<AmenityMinOrderByAggregateInput>;
  amenityGroupId?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrderInput>;
  moreInfoLink?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
};

export type AmenityOrderByWithRelationInput = {
  amenityGroupId?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  group?: InputMaybe<AmenityGroupOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  moreInfoLink?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
};

export enum AmenityScalarFieldEnum {
  AmenityGroupId = 'amenityGroupId',
  Description = 'description',
  Id = 'id',
  ImageUrl = 'imageUrl',
  LocationId = 'locationId',
  MoreInfoLink = 'moreInfoLink',
  Title = 'title'
}

export type AmenityScalarWhereInput = {
  amenityGroupId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<AmenityScalarWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  moreInfoLink?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<AmenityScalarWhereInput>>;
  OR?: InputMaybe<Array<AmenityScalarWhereInput>>;
  title?: InputMaybe<StringFilter>;
};

export type AmenityScalarWhereWithAggregatesInput = {
  amenityGroupId?: InputMaybe<StringNullableWithAggregatesFilter>;
  AND?: InputMaybe<Array<AmenityScalarWhereWithAggregatesInput>>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  moreInfoLink?: InputMaybe<StringNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<AmenityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<AmenityScalarWhereWithAggregatesInput>>;
  title?: InputMaybe<StringWithAggregatesFilter>;
};

export type AmenityUpdateInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  group?: InputMaybe<AmenityGroupUpdateOneWithoutAmenitiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutAmenitiesNestedInput>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AmenityUpdateManyMutationInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AmenityUpdateManyWithoutGroupNestedInput = {
  connect?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AmenityCreateOrConnectWithoutGroupInput>>;
  create?: InputMaybe<Array<AmenityCreateWithoutGroupInput>>;
  createMany?: InputMaybe<AmenityCreateManyGroupInputEnvelope>;
  delete?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AmenityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  set?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  update?: InputMaybe<Array<AmenityUpdateWithWhereUniqueWithoutGroupInput>>;
  updateMany?: InputMaybe<Array<AmenityUpdateManyWithWhereWithoutGroupInput>>;
  upsert?: InputMaybe<Array<AmenityUpsertWithWhereUniqueWithoutGroupInput>>;
};

export type AmenityUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AmenityCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<AmenityCreateWithoutLocationInput>>;
  createMany?: InputMaybe<AmenityCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AmenityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  set?: InputMaybe<Array<AmenityWhereUniqueInput>>;
  update?: InputMaybe<Array<AmenityUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<AmenityUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<AmenityUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type AmenityUpdateManyWithWhereWithoutGroupInput = {
  data: AmenityUpdateManyMutationInput;
  where: AmenityScalarWhereInput;
};

export type AmenityUpdateManyWithWhereWithoutLocationInput = {
  data: AmenityUpdateManyMutationInput;
  where: AmenityScalarWhereInput;
};

export type AmenityUpdateWithoutGroupInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutAmenitiesNestedInput>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AmenityUpdateWithoutLocationInput = {
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  group?: InputMaybe<AmenityGroupUpdateOneWithoutAmenitiesNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type AmenityUpdateWithWhereUniqueWithoutGroupInput = {
  data: AmenityUpdateWithoutGroupInput;
  where: AmenityWhereUniqueInput;
};

export type AmenityUpdateWithWhereUniqueWithoutLocationInput = {
  data: AmenityUpdateWithoutLocationInput;
  where: AmenityWhereUniqueInput;
};

export type AmenityUpsertWithWhereUniqueWithoutGroupInput = {
  create: AmenityCreateWithoutGroupInput;
  update: AmenityUpdateWithoutGroupInput;
  where: AmenityWhereUniqueInput;
};

export type AmenityUpsertWithWhereUniqueWithoutLocationInput = {
  create: AmenityCreateWithoutLocationInput;
  update: AmenityUpdateWithoutLocationInput;
  where: AmenityWhereUniqueInput;
};

export type AmenityWhereInput = {
  amenityGroupId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<AmenityWhereInput>>;
  description?: InputMaybe<StringNullableFilter>;
  group?: InputMaybe<AmenityGroupRelationFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  moreInfoLink?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<AmenityWhereInput>>;
  OR?: InputMaybe<Array<AmenityWhereInput>>;
  title?: InputMaybe<StringFilter>;
};

export type AmenityWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ApiCallErrorCreateManyInternalApiCallInput = {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
};

export type ApiCallErrorCreateManyInternalApiCallInputEnvelope = {
  data: Array<ApiCallErrorCreateManyInternalApiCallInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ApiCallErrorCreateNestedManyWithoutInternalApiCallInput = {
  connect?: InputMaybe<Array<ApiCallErrorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiCallErrorCreateOrConnectWithoutInternalApiCallInput>>;
  create?: InputMaybe<Array<ApiCallErrorCreateWithoutInternalApiCallInput>>;
  createMany?: InputMaybe<ApiCallErrorCreateManyInternalApiCallInputEnvelope>;
};

export type ApiCallErrorCreateOrConnectWithoutInternalApiCallInput = {
  create: ApiCallErrorCreateWithoutInternalApiCallInput;
  where: ApiCallErrorWhereUniqueInput;
};

export type ApiCallErrorCreateWithoutInternalApiCallInput = {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  message: Scalars['String'];
};

export type ApiCallErrorListRelationFilter = {
  every?: InputMaybe<ApiCallErrorWhereInput>;
  none?: InputMaybe<ApiCallErrorWhereInput>;
  some?: InputMaybe<ApiCallErrorWhereInput>;
};

export type ApiCallErrorOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ApiCallErrorScalarWhereInput = {
  AND?: InputMaybe<Array<ApiCallErrorScalarWhereInput>>;
  code?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  internalApiCallId?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ApiCallErrorScalarWhereInput>>;
  OR?: InputMaybe<Array<ApiCallErrorScalarWhereInput>>;
};

export type ApiCallErrorUpdateManyMutationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApiCallErrorUpdateManyWithoutInternalApiCallNestedInput = {
  connect?: InputMaybe<Array<ApiCallErrorWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ApiCallErrorCreateOrConnectWithoutInternalApiCallInput>>;
  create?: InputMaybe<Array<ApiCallErrorCreateWithoutInternalApiCallInput>>;
  createMany?: InputMaybe<ApiCallErrorCreateManyInternalApiCallInputEnvelope>;
  delete?: InputMaybe<Array<ApiCallErrorWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ApiCallErrorScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ApiCallErrorWhereUniqueInput>>;
  set?: InputMaybe<Array<ApiCallErrorWhereUniqueInput>>;
  update?: InputMaybe<Array<ApiCallErrorUpdateWithWhereUniqueWithoutInternalApiCallInput>>;
  updateMany?: InputMaybe<Array<ApiCallErrorUpdateManyWithWhereWithoutInternalApiCallInput>>;
  upsert?: InputMaybe<Array<ApiCallErrorUpsertWithWhereUniqueWithoutInternalApiCallInput>>;
};

export type ApiCallErrorUpdateManyWithWhereWithoutInternalApiCallInput = {
  data: ApiCallErrorUpdateManyMutationInput;
  where: ApiCallErrorScalarWhereInput;
};

export type ApiCallErrorUpdateWithoutInternalApiCallInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  message?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ApiCallErrorUpdateWithWhereUniqueWithoutInternalApiCallInput = {
  data: ApiCallErrorUpdateWithoutInternalApiCallInput;
  where: ApiCallErrorWhereUniqueInput;
};

export type ApiCallErrorUpsertWithWhereUniqueWithoutInternalApiCallInput = {
  create: ApiCallErrorCreateWithoutInternalApiCallInput;
  update: ApiCallErrorUpdateWithoutInternalApiCallInput;
  where: ApiCallErrorWhereUniqueInput;
};

export type ApiCallErrorWhereInput = {
  AND?: InputMaybe<Array<ApiCallErrorWhereInput>>;
  code?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  internalApiCall?: InputMaybe<InternalApiCallRelationFilter>;
  internalApiCallId?: InputMaybe<StringFilter>;
  message?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ApiCallErrorWhereInput>>;
  OR?: InputMaybe<Array<ApiCallErrorWhereInput>>;
};

export type ApiCallErrorWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum ApiCallStatus {
  Error = 'ERROR',
  Pending = 'PENDING',
  Success = 'SUCCESS'
}

export enum AssaCardType {
  Classic = 'Classic',
  DesFire = 'DESFire',
  Plus = 'Plus'
}

export type AssaCreateEndpointInvitationResponse = {
  invitationCode?: Maybe<Scalars['String']>;
};

export type AssaCreateMobileKeyResponse = {
  keyId?: Maybe<Scalars['String']>;
};

export type AssaEncryptedImageAndAuthenticationKey = {
  authenticationKey: Scalars['String'];
  encryptedImage: Scalars['String'];
};

export type AssaEndpointTmsIdResponse = {
  tmsId?: Maybe<Scalars['Float']>;
};

export type AuthAnswer = {
  accessGrantId?: Maybe<Scalars['String']>;
  accessToken?: Maybe<Scalars['String']>;
  authErrorCode?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['String']>;
  refreshToken?: Maybe<Scalars['String']>;
  wasUserSeen?: Maybe<Scalars['Boolean']>;
};

/** Internal SMS auth recordkeeping */
export type AuthChallenge = {
  challenge: Scalars['String'];
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type AuthChallengeCreateManyUserInput = {
  challenge: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  expiresAt: Scalars['DateTime'];
};

export type AuthChallengeCreateManyUserInputEnvelope = {
  data: Array<AuthChallengeCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type AuthChallengeCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<AuthChallengeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuthChallengeCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AuthChallengeCreateWithoutUserInput>>;
  createMany?: InputMaybe<AuthChallengeCreateManyUserInputEnvelope>;
};

export type AuthChallengeCreateOrConnectWithoutUserInput = {
  create: AuthChallengeCreateWithoutUserInput;
  where: AuthChallengeWhereUniqueInput;
};

export type AuthChallengeCreateWithoutUserInput = {
  challenge: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  expiresAt: Scalars['DateTime'];
};

export type AuthChallengeListRelationFilter = {
  every?: InputMaybe<AuthChallengeWhereInput>;
  none?: InputMaybe<AuthChallengeWhereInput>;
  some?: InputMaybe<AuthChallengeWhereInput>;
};

export type AuthChallengeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type AuthChallengeOrderByWithRelationInput = {
  challenge?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum AuthChallengeScalarFieldEnum {
  Challenge = 'challenge',
  CreatedAt = 'createdAt',
  ExpiresAt = 'expiresAt',
  UserId = 'userId'
}

export type AuthChallengeScalarWhereInput = {
  AND?: InputMaybe<Array<AuthChallengeScalarWhereInput>>;
  challenge?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  NOT?: InputMaybe<Array<AuthChallengeScalarWhereInput>>;
  OR?: InputMaybe<Array<AuthChallengeScalarWhereInput>>;
  userId?: InputMaybe<StringFilter>;
};

export type AuthChallengeUpdateManyMutationInput = {
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuthChallengeUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<AuthChallengeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<AuthChallengeCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<AuthChallengeCreateWithoutUserInput>>;
  createMany?: InputMaybe<AuthChallengeCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<AuthChallengeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<AuthChallengeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<AuthChallengeWhereUniqueInput>>;
  set?: InputMaybe<Array<AuthChallengeWhereUniqueInput>>;
  update?: InputMaybe<Array<AuthChallengeUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<AuthChallengeUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<AuthChallengeUpsertWithWhereUniqueWithoutUserInput>>;
};

export type AuthChallengeUpdateManyWithWhereWithoutUserInput = {
  data: AuthChallengeUpdateManyMutationInput;
  where: AuthChallengeScalarWhereInput;
};

export type AuthChallengeUpdateWithoutUserInput = {
  challenge?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type AuthChallengeUpdateWithWhereUniqueWithoutUserInput = {
  data: AuthChallengeUpdateWithoutUserInput;
  where: AuthChallengeWhereUniqueInput;
};

export type AuthChallengeUpsertWithWhereUniqueWithoutUserInput = {
  create: AuthChallengeCreateWithoutUserInput;
  update: AuthChallengeUpdateWithoutUserInput;
  where: AuthChallengeWhereUniqueInput;
};

export type AuthChallengeUserIdChallengeCompoundUniqueInput = {
  challenge: Scalars['String'];
  userId: Scalars['String'];
};

export type AuthChallengeWhereInput = {
  AND?: InputMaybe<Array<AuthChallengeWhereInput>>;
  challenge?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  NOT?: InputMaybe<Array<AuthChallengeWhereInput>>;
  OR?: InputMaybe<Array<AuthChallengeWhereInput>>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type AuthChallengeWhereUniqueInput = {
  userId_challenge?: InputMaybe<AuthChallengeUserIdChallengeCompoundUniqueInput>;
};

export type AuthenticatePmsRequestResponse = {
  locationId: Scalars['String'];
  tenantId: Scalars['String'];
};

export type AuthorizedAmountResponse = {
  authorizedAmount: Scalars['Float'];
};

export type BaseLocalizationAnswer = {
  id: Scalars['String'];
  language: LanguageInfo;
  settingsData?: Maybe<Scalars['JSONObject']>;
};

export type BaseSettingAnswer = {
  mergedSettingsData: Scalars['JSONObject'];
  settingsData?: Maybe<Scalars['JSONObject']>;
};

export type BeamsAuthAnswer = {
  beamsToken: Scalars['String'];
};

export type BookedPackage = {
  /** The Package Description */
  description?: Maybe<Scalars['String']>;
  /** The Package external Id */
  externalId: Scalars['String'];
  /** The Package Image URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** Whether the package is inventory based or not */
  isInventoryBased?: Maybe<Scalars['Boolean']>;
  /** The Package Long Description */
  longDescription?: Maybe<Scalars['String']>;
  /** How many out of the given quantity was already there at Reservation creation */
  originalQuantity: Scalars['Float'];
  /** The internal id (serviceRequest id) of the PackageRequest */
  packageRequestId?: Maybe<Scalars['String']>;
  /** The total quantity of acquired Packages (serviceRequests) to the Reservations */
  quantity: Scalars['Float'];
  /** The internal id for the Package (Service) */
  serviceId: Scalars['String'];
  /** To assert whether a given item will be cart add able or not. */
  status: ServiceStatus;
  /** The Package Name */
  title: Scalars['String'];
  /** The total price of the acquired respective Package */
  totalPrice: Scalars['Float'];
  /** The unitary price of the Package */
  unitPrice: Scalars['Float'];
  /** Used for returning a status at the end of the upsertBookedPackages, for testing purposes */
  upsertStatus?: Maybe<Scalars['String']>;
};

export type BoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type BoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type BoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type BoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type BoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type CallAnswer = {
  accessToken: Scalars['String'];
  callRecordId: Scalars['String'];
};

export type CallRecord = {
  _count?: Maybe<CallRecordCount>;
  accessGrant?: Maybe<AccessGrant>;
  accessGrantId?: Maybe<Scalars['String']>;
  agent?: Maybe<User>;
  agentId?: Maybe<Scalars['String']>;
  caller?: Maybe<User>;
  callerId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  kiosk?: Maybe<Kiosk>;
  kioskId?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  origin?: Maybe<OriginType>;
  room?: Maybe<Scalars['String']>;
  status: CallStatus;
  tenant?: Maybe<Tenant>;
  tenantId?: Maybe<Scalars['String']>;
  type: CallType;
  users: Array<User>;
};


export type CallRecordUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};

export type CallRecordAvgAggregate = {
  duration?: Maybe<Scalars['Float']>;
};

export type CallRecordAvgOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
};

export type CallRecordCount = {
  users: Scalars['Int'];
};


export type CallRecordCountUsersArgs = {
  where?: InputMaybe<UserWhereInput>;
};

export type CallRecordCountAggregate = {
  _all: Scalars['Int'];
  accessGrantId: Scalars['Int'];
  agentId: Scalars['Int'];
  callerId: Scalars['Int'];
  createdAt: Scalars['Int'];
  duration: Scalars['Int'];
  id: Scalars['Int'];
  kioskId: Scalars['Int'];
  locationId: Scalars['Int'];
  origin: Scalars['Int'];
  room: Scalars['Int'];
  status: Scalars['Int'];
  tenantId: Scalars['Int'];
  type: Scalars['Int'];
};

export type CallRecordCountOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  agentId?: InputMaybe<SortOrder>;
  callerId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  kioskId?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  room?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CallRecordCreateInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutCallRecordsInput>;
  agent?: InputMaybe<UserCreateNestedOneWithoutReceivedCallsInput>;
  caller?: InputMaybe<UserCreateNestedOneWithoutMadeCallsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kiosk?: InputMaybe<KioskCreateNestedOneWithoutCallRecordInput>;
  location?: InputMaybe<LocationCreateNestedOneWithoutCallRecordsInput>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutCallRecordsInput>;
  type?: InputMaybe<CallType>;
  users?: InputMaybe<UserCreateNestedManyWithoutCallRecordsInput>;
};

export type CallRecordCreateManyAccessGrantInput = {
  agentId?: InputMaybe<Scalars['String']>;
  callerId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CallType>;
};

export type CallRecordCreateManyAccessGrantInputEnvelope = {
  data: Array<CallRecordCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CallRecordCreateManyAgentInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  callerId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CallType>;
};

export type CallRecordCreateManyAgentInputEnvelope = {
  data: Array<CallRecordCreateManyAgentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CallRecordCreateManyCallerInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CallType>;
};

export type CallRecordCreateManyCallerInputEnvelope = {
  data: Array<CallRecordCreateManyCallerInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CallRecordCreateManyInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  callerId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CallType>;
};

export type CallRecordCreateManyKioskInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  callerId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CallType>;
};

export type CallRecordCreateManyKioskInputEnvelope = {
  data: Array<CallRecordCreateManyKioskInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CallRecordCreateManyLocationInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  callerId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenantId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<CallType>;
};

export type CallRecordCreateManyLocationInputEnvelope = {
  data: Array<CallRecordCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CallRecordCreateManyTenantInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  agentId?: InputMaybe<Scalars['String']>;
  callerId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  type?: InputMaybe<CallType>;
};

export type CallRecordCreateManyTenantInputEnvelope = {
  data: Array<CallRecordCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CallRecordCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<CallRecordCreateManyAccessGrantInputEnvelope>;
};

export type CallRecordCreateNestedManyWithoutAgentInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutAgentInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutAgentInput>>;
  createMany?: InputMaybe<CallRecordCreateManyAgentInputEnvelope>;
};

export type CallRecordCreateNestedManyWithoutCallerInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutCallerInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutCallerInput>>;
  createMany?: InputMaybe<CallRecordCreateManyCallerInputEnvelope>;
};

export type CallRecordCreateNestedManyWithoutKioskInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutKioskInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutKioskInput>>;
  createMany?: InputMaybe<CallRecordCreateManyKioskInputEnvelope>;
};

export type CallRecordCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutLocationInput>>;
  createMany?: InputMaybe<CallRecordCreateManyLocationInputEnvelope>;
};

export type CallRecordCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutTenantInput>>;
  createMany?: InputMaybe<CallRecordCreateManyTenantInputEnvelope>;
};

export type CallRecordCreateNestedManyWithoutUsersInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutUsersInput>>;
};

export type CallRecordCreateOrConnectWithoutAccessGrantInput = {
  create: CallRecordCreateWithoutAccessGrantInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordCreateOrConnectWithoutAgentInput = {
  create: CallRecordCreateWithoutAgentInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordCreateOrConnectWithoutCallerInput = {
  create: CallRecordCreateWithoutCallerInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordCreateOrConnectWithoutKioskInput = {
  create: CallRecordCreateWithoutKioskInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordCreateOrConnectWithoutLocationInput = {
  create: CallRecordCreateWithoutLocationInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordCreateOrConnectWithoutTenantInput = {
  create: CallRecordCreateWithoutTenantInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordCreateOrConnectWithoutUsersInput = {
  create: CallRecordCreateWithoutUsersInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordCreateWithoutAccessGrantInput = {
  agent?: InputMaybe<UserCreateNestedOneWithoutReceivedCallsInput>;
  caller?: InputMaybe<UserCreateNestedOneWithoutMadeCallsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kiosk?: InputMaybe<KioskCreateNestedOneWithoutCallRecordInput>;
  location?: InputMaybe<LocationCreateNestedOneWithoutCallRecordsInput>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutCallRecordsInput>;
  type?: InputMaybe<CallType>;
  users?: InputMaybe<UserCreateNestedManyWithoutCallRecordsInput>;
};

export type CallRecordCreateWithoutAgentInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutCallRecordsInput>;
  caller?: InputMaybe<UserCreateNestedOneWithoutMadeCallsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kiosk?: InputMaybe<KioskCreateNestedOneWithoutCallRecordInput>;
  location?: InputMaybe<LocationCreateNestedOneWithoutCallRecordsInput>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutCallRecordsInput>;
  type?: InputMaybe<CallType>;
  users?: InputMaybe<UserCreateNestedManyWithoutCallRecordsInput>;
};

export type CallRecordCreateWithoutCallerInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutCallRecordsInput>;
  agent?: InputMaybe<UserCreateNestedOneWithoutReceivedCallsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kiosk?: InputMaybe<KioskCreateNestedOneWithoutCallRecordInput>;
  location?: InputMaybe<LocationCreateNestedOneWithoutCallRecordsInput>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutCallRecordsInput>;
  type?: InputMaybe<CallType>;
  users?: InputMaybe<UserCreateNestedManyWithoutCallRecordsInput>;
};

export type CallRecordCreateWithoutKioskInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutCallRecordsInput>;
  agent?: InputMaybe<UserCreateNestedOneWithoutReceivedCallsInput>;
  caller?: InputMaybe<UserCreateNestedOneWithoutMadeCallsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutCallRecordsInput>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutCallRecordsInput>;
  type?: InputMaybe<CallType>;
  users?: InputMaybe<UserCreateNestedManyWithoutCallRecordsInput>;
};

export type CallRecordCreateWithoutLocationInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutCallRecordsInput>;
  agent?: InputMaybe<UserCreateNestedOneWithoutReceivedCallsInput>;
  caller?: InputMaybe<UserCreateNestedOneWithoutMadeCallsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kiosk?: InputMaybe<KioskCreateNestedOneWithoutCallRecordInput>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutCallRecordsInput>;
  type?: InputMaybe<CallType>;
  users?: InputMaybe<UserCreateNestedManyWithoutCallRecordsInput>;
};

export type CallRecordCreateWithoutTenantInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutCallRecordsInput>;
  agent?: InputMaybe<UserCreateNestedOneWithoutReceivedCallsInput>;
  caller?: InputMaybe<UserCreateNestedOneWithoutMadeCallsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kiosk?: InputMaybe<KioskCreateNestedOneWithoutCallRecordInput>;
  location?: InputMaybe<LocationCreateNestedOneWithoutCallRecordsInput>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  type?: InputMaybe<CallType>;
  users?: InputMaybe<UserCreateNestedManyWithoutCallRecordsInput>;
};

export type CallRecordCreateWithoutUsersInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutCallRecordsInput>;
  agent?: InputMaybe<UserCreateNestedOneWithoutReceivedCallsInput>;
  caller?: InputMaybe<UserCreateNestedOneWithoutMadeCallsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
  kiosk?: InputMaybe<KioskCreateNestedOneWithoutCallRecordInput>;
  location?: InputMaybe<LocationCreateNestedOneWithoutCallRecordsInput>;
  origin?: InputMaybe<OriginType>;
  room?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<CallStatus>;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutCallRecordsInput>;
  type?: InputMaybe<CallType>;
};

export type CallRecordGroupBy = {
  _avg?: Maybe<CallRecordAvgAggregate>;
  _count?: Maybe<CallRecordCountAggregate>;
  _max?: Maybe<CallRecordMaxAggregate>;
  _min?: Maybe<CallRecordMinAggregate>;
  _sum?: Maybe<CallRecordSumAggregate>;
  accessGrantId?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  callerId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['String'];
  kioskId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  origin?: Maybe<OriginType>;
  room?: Maybe<Scalars['String']>;
  status: CallStatus;
  tenantId?: Maybe<Scalars['String']>;
  type: CallType;
};

export type CallRecordListRelationFilter = {
  every?: InputMaybe<CallRecordWhereInput>;
  none?: InputMaybe<CallRecordWhereInput>;
  some?: InputMaybe<CallRecordWhereInput>;
};

export type CallRecordMaxAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  callerId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  kioskId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  origin?: Maybe<OriginType>;
  room?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<CallType>;
};

export type CallRecordMaxOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  agentId?: InputMaybe<SortOrder>;
  callerId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  kioskId?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  room?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CallRecordMinAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  agentId?: Maybe<Scalars['String']>;
  callerId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['String']>;
  kioskId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  origin?: Maybe<OriginType>;
  room?: Maybe<Scalars['String']>;
  status?: Maybe<CallStatus>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<CallType>;
};

export type CallRecordMinOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  agentId?: InputMaybe<SortOrder>;
  callerId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  kioskId?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  room?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type CallRecordOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CallRecordOrderByWithAggregationInput = {
  _avg?: InputMaybe<CallRecordAvgOrderByAggregateInput>;
  _count?: InputMaybe<CallRecordCountOrderByAggregateInput>;
  _max?: InputMaybe<CallRecordMaxOrderByAggregateInput>;
  _min?: InputMaybe<CallRecordMinOrderByAggregateInput>;
  _sum?: InputMaybe<CallRecordSumOrderByAggregateInput>;
  accessGrantId?: InputMaybe<SortOrderInput>;
  agentId?: InputMaybe<SortOrderInput>;
  callerId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  kioskId?: InputMaybe<SortOrderInput>;
  locationId?: InputMaybe<SortOrderInput>;
  origin?: InputMaybe<SortOrderInput>;
  room?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
};

export type CallRecordOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrderInput>;
  agent?: InputMaybe<UserOrderByWithRelationInput>;
  agentId?: InputMaybe<SortOrderInput>;
  caller?: InputMaybe<UserOrderByWithRelationInput>;
  callerId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  duration?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  kiosk?: InputMaybe<KioskOrderByWithRelationInput>;
  kioskId?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  origin?: InputMaybe<SortOrderInput>;
  room?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  users?: InputMaybe<UserOrderByRelationAggregateInput>;
};

export enum CallRecordScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  AgentId = 'agentId',
  CallerId = 'callerId',
  CreatedAt = 'createdAt',
  Duration = 'duration',
  Id = 'id',
  KioskId = 'kioskId',
  LocationId = 'locationId',
  Origin = 'origin',
  Room = 'room',
  Status = 'status',
  TenantId = 'tenantId',
  Type = 'type'
}

export type CallRecordScalarWhereInput = {
  accessGrantId?: InputMaybe<StringNullableFilter>;
  agentId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  callerId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  kioskId?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  OR?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  origin?: InputMaybe<EnumOriginTypeNullableFilter>;
  room?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumCallStatusFilter>;
  tenantId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumCallTypeFilter>;
};

export type CallRecordScalarWhereWithAggregatesInput = {
  accessGrantId?: InputMaybe<StringNullableWithAggregatesFilter>;
  agentId?: InputMaybe<StringNullableWithAggregatesFilter>;
  AND?: InputMaybe<Array<CallRecordScalarWhereWithAggregatesInput>>;
  callerId?: InputMaybe<StringNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  duration?: InputMaybe<IntNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  kioskId?: InputMaybe<StringNullableWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<CallRecordScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CallRecordScalarWhereWithAggregatesInput>>;
  origin?: InputMaybe<EnumOriginTypeNullableWithAggregatesFilter>;
  room?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumCallStatusWithAggregatesFilter>;
  tenantId?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumCallTypeWithAggregatesFilter>;
};

export type CallRecordSumAggregate = {
  duration?: Maybe<Scalars['Int']>;
};

export type CallRecordSumOrderByAggregateInput = {
  duration?: InputMaybe<SortOrder>;
};

export type CallRecordUpdateInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutCallRecordsNestedInput>;
  agent?: InputMaybe<UserUpdateOneWithoutReceivedCallsNestedInput>;
  caller?: InputMaybe<UserUpdateOneWithoutMadeCallsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kiosk?: InputMaybe<KioskUpdateOneWithoutCallRecordNestedInput>;
  location?: InputMaybe<LocationUpdateOneWithoutCallRecordsNestedInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  room?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCallStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutCallRecordsNestedInput>;
  type?: InputMaybe<EnumCallTypeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutCallRecordsNestedInput>;
};

export type CallRecordUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  room?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCallStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCallTypeFieldUpdateOperationsInput>;
};

export type CallRecordUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<CallRecordCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<CallRecordUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<CallRecordUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<CallRecordUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type CallRecordUpdateManyWithoutAgentNestedInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutAgentInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutAgentInput>>;
  createMany?: InputMaybe<CallRecordCreateManyAgentInputEnvelope>;
  delete?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<CallRecordUpdateWithWhereUniqueWithoutAgentInput>>;
  updateMany?: InputMaybe<Array<CallRecordUpdateManyWithWhereWithoutAgentInput>>;
  upsert?: InputMaybe<Array<CallRecordUpsertWithWhereUniqueWithoutAgentInput>>;
};

export type CallRecordUpdateManyWithoutCallerNestedInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutCallerInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutCallerInput>>;
  createMany?: InputMaybe<CallRecordCreateManyCallerInputEnvelope>;
  delete?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<CallRecordUpdateWithWhereUniqueWithoutCallerInput>>;
  updateMany?: InputMaybe<Array<CallRecordUpdateManyWithWhereWithoutCallerInput>>;
  upsert?: InputMaybe<Array<CallRecordUpsertWithWhereUniqueWithoutCallerInput>>;
};

export type CallRecordUpdateManyWithoutKioskNestedInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutKioskInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutKioskInput>>;
  createMany?: InputMaybe<CallRecordCreateManyKioskInputEnvelope>;
  delete?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<CallRecordUpdateWithWhereUniqueWithoutKioskInput>>;
  updateMany?: InputMaybe<Array<CallRecordUpdateManyWithWhereWithoutKioskInput>>;
  upsert?: InputMaybe<Array<CallRecordUpsertWithWhereUniqueWithoutKioskInput>>;
};

export type CallRecordUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutLocationInput>>;
  createMany?: InputMaybe<CallRecordCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<CallRecordUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<CallRecordUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<CallRecordUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type CallRecordUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutTenantInput>>;
  createMany?: InputMaybe<CallRecordCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<CallRecordUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<CallRecordUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<CallRecordUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type CallRecordUpdateManyWithoutUsersNestedInput = {
  connect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CallRecordCreateOrConnectWithoutUsersInput>>;
  create?: InputMaybe<Array<CallRecordCreateWithoutUsersInput>>;
  delete?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CallRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<CallRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<CallRecordUpdateWithWhereUniqueWithoutUsersInput>>;
  updateMany?: InputMaybe<Array<CallRecordUpdateManyWithWhereWithoutUsersInput>>;
  upsert?: InputMaybe<Array<CallRecordUpsertWithWhereUniqueWithoutUsersInput>>;
};

export type CallRecordUpdateManyWithWhereWithoutAccessGrantInput = {
  data: CallRecordUpdateManyMutationInput;
  where: CallRecordScalarWhereInput;
};

export type CallRecordUpdateManyWithWhereWithoutAgentInput = {
  data: CallRecordUpdateManyMutationInput;
  where: CallRecordScalarWhereInput;
};

export type CallRecordUpdateManyWithWhereWithoutCallerInput = {
  data: CallRecordUpdateManyMutationInput;
  where: CallRecordScalarWhereInput;
};

export type CallRecordUpdateManyWithWhereWithoutKioskInput = {
  data: CallRecordUpdateManyMutationInput;
  where: CallRecordScalarWhereInput;
};

export type CallRecordUpdateManyWithWhereWithoutLocationInput = {
  data: CallRecordUpdateManyMutationInput;
  where: CallRecordScalarWhereInput;
};

export type CallRecordUpdateManyWithWhereWithoutTenantInput = {
  data: CallRecordUpdateManyMutationInput;
  where: CallRecordScalarWhereInput;
};

export type CallRecordUpdateManyWithWhereWithoutUsersInput = {
  data: CallRecordUpdateManyMutationInput;
  where: CallRecordScalarWhereInput;
};

export type CallRecordUpdateWithoutAccessGrantInput = {
  agent?: InputMaybe<UserUpdateOneWithoutReceivedCallsNestedInput>;
  caller?: InputMaybe<UserUpdateOneWithoutMadeCallsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kiosk?: InputMaybe<KioskUpdateOneWithoutCallRecordNestedInput>;
  location?: InputMaybe<LocationUpdateOneWithoutCallRecordsNestedInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  room?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCallStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutCallRecordsNestedInput>;
  type?: InputMaybe<EnumCallTypeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutCallRecordsNestedInput>;
};

export type CallRecordUpdateWithoutAgentInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutCallRecordsNestedInput>;
  caller?: InputMaybe<UserUpdateOneWithoutMadeCallsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kiosk?: InputMaybe<KioskUpdateOneWithoutCallRecordNestedInput>;
  location?: InputMaybe<LocationUpdateOneWithoutCallRecordsNestedInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  room?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCallStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutCallRecordsNestedInput>;
  type?: InputMaybe<EnumCallTypeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutCallRecordsNestedInput>;
};

export type CallRecordUpdateWithoutCallerInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutCallRecordsNestedInput>;
  agent?: InputMaybe<UserUpdateOneWithoutReceivedCallsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kiosk?: InputMaybe<KioskUpdateOneWithoutCallRecordNestedInput>;
  location?: InputMaybe<LocationUpdateOneWithoutCallRecordsNestedInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  room?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCallStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutCallRecordsNestedInput>;
  type?: InputMaybe<EnumCallTypeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutCallRecordsNestedInput>;
};

export type CallRecordUpdateWithoutKioskInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutCallRecordsNestedInput>;
  agent?: InputMaybe<UserUpdateOneWithoutReceivedCallsNestedInput>;
  caller?: InputMaybe<UserUpdateOneWithoutMadeCallsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutCallRecordsNestedInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  room?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCallStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutCallRecordsNestedInput>;
  type?: InputMaybe<EnumCallTypeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutCallRecordsNestedInput>;
};

export type CallRecordUpdateWithoutLocationInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutCallRecordsNestedInput>;
  agent?: InputMaybe<UserUpdateOneWithoutReceivedCallsNestedInput>;
  caller?: InputMaybe<UserUpdateOneWithoutMadeCallsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kiosk?: InputMaybe<KioskUpdateOneWithoutCallRecordNestedInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  room?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCallStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutCallRecordsNestedInput>;
  type?: InputMaybe<EnumCallTypeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutCallRecordsNestedInput>;
};

export type CallRecordUpdateWithoutTenantInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutCallRecordsNestedInput>;
  agent?: InputMaybe<UserUpdateOneWithoutReceivedCallsNestedInput>;
  caller?: InputMaybe<UserUpdateOneWithoutMadeCallsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kiosk?: InputMaybe<KioskUpdateOneWithoutCallRecordNestedInput>;
  location?: InputMaybe<LocationUpdateOneWithoutCallRecordsNestedInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  room?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCallStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCallTypeFieldUpdateOperationsInput>;
  users?: InputMaybe<UserUpdateManyWithoutCallRecordsNestedInput>;
};

export type CallRecordUpdateWithoutUsersInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutCallRecordsNestedInput>;
  agent?: InputMaybe<UserUpdateOneWithoutReceivedCallsNestedInput>;
  caller?: InputMaybe<UserUpdateOneWithoutMadeCallsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  duration?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kiosk?: InputMaybe<KioskUpdateOneWithoutCallRecordNestedInput>;
  location?: InputMaybe<LocationUpdateOneWithoutCallRecordsNestedInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  room?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumCallStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutCallRecordsNestedInput>;
  type?: InputMaybe<EnumCallTypeFieldUpdateOperationsInput>;
};

export type CallRecordUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: CallRecordUpdateWithoutAccessGrantInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpdateWithWhereUniqueWithoutAgentInput = {
  data: CallRecordUpdateWithoutAgentInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpdateWithWhereUniqueWithoutCallerInput = {
  data: CallRecordUpdateWithoutCallerInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpdateWithWhereUniqueWithoutKioskInput = {
  data: CallRecordUpdateWithoutKioskInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpdateWithWhereUniqueWithoutLocationInput = {
  data: CallRecordUpdateWithoutLocationInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpdateWithWhereUniqueWithoutTenantInput = {
  data: CallRecordUpdateWithoutTenantInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpdateWithWhereUniqueWithoutUsersInput = {
  data: CallRecordUpdateWithoutUsersInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: CallRecordCreateWithoutAccessGrantInput;
  update: CallRecordUpdateWithoutAccessGrantInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpsertWithWhereUniqueWithoutAgentInput = {
  create: CallRecordCreateWithoutAgentInput;
  update: CallRecordUpdateWithoutAgentInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpsertWithWhereUniqueWithoutCallerInput = {
  create: CallRecordCreateWithoutCallerInput;
  update: CallRecordUpdateWithoutCallerInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpsertWithWhereUniqueWithoutKioskInput = {
  create: CallRecordCreateWithoutKioskInput;
  update: CallRecordUpdateWithoutKioskInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpsertWithWhereUniqueWithoutLocationInput = {
  create: CallRecordCreateWithoutLocationInput;
  update: CallRecordUpdateWithoutLocationInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpsertWithWhereUniqueWithoutTenantInput = {
  create: CallRecordCreateWithoutTenantInput;
  update: CallRecordUpdateWithoutTenantInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordUpsertWithWhereUniqueWithoutUsersInput = {
  create: CallRecordCreateWithoutUsersInput;
  update: CallRecordUpdateWithoutUsersInput;
  where: CallRecordWhereUniqueInput;
};

export type CallRecordWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringNullableFilter>;
  agent?: InputMaybe<UserRelationFilter>;
  agentId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<CallRecordWhereInput>>;
  caller?: InputMaybe<UserRelationFilter>;
  callerId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  duration?: InputMaybe<IntNullableFilter>;
  id?: InputMaybe<StringFilter>;
  kiosk?: InputMaybe<KioskRelationFilter>;
  kioskId?: InputMaybe<StringNullableFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<CallRecordWhereInput>>;
  OR?: InputMaybe<Array<CallRecordWhereInput>>;
  origin?: InputMaybe<EnumOriginTypeNullableFilter>;
  room?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumCallStatusFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumCallTypeFilter>;
  users?: InputMaybe<UserListRelationFilter>;
};

export type CallRecordWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum CallStatus {
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  Initialized = 'INITIALIZED',
  Missed = 'MISSED',
  Waiting = 'WAITING'
}

export enum CallType {
  Video = 'VIDEO',
  Voice = 'VOICE'
}

export type Characteristic = {
  _count?: Maybe<CharacteristicCount>;
  category: CharacteristicCategory;
  createdAt?: Maybe<Scalars['DateTime']>;
  id: Scalars['String'];
  locationId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export enum CharacteristicCategory {
  NeedVoucher = 'NEED_VOUCHER',
  Parking = 'PARKING',
  RoomType = 'ROOM_TYPE',
  Service = 'SERVICE'
}

export type CharacteristicCount = {
  characteristicRules: Scalars['Int'];
};


export type CharacteristicCountCharacteristicRulesArgs = {
  where?: InputMaybe<CharacteristicRulesWhereInput>;
};

export type CharacteristicCreateManyLocationInput = {
  category: CharacteristicCategory;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CharacteristicCreateManyLocationInputEnvelope = {
  data: Array<CharacteristicCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CharacteristicCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<CharacteristicWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CharacteristicCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<CharacteristicCreateWithoutLocationInput>>;
  createMany?: InputMaybe<CharacteristicCreateManyLocationInputEnvelope>;
};

export type CharacteristicCreateOrConnectWithoutLocationInput = {
  create: CharacteristicCreateWithoutLocationInput;
  where: CharacteristicWhereUniqueInput;
};

export type CharacteristicCreateWithoutLocationInput = {
  category: CharacteristicCategory;
  characteristicRules?: InputMaybe<CharacteristicRulesCreateNestedManyWithoutCharacteristicsInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CharacteristicListRelationFilter = {
  every?: InputMaybe<CharacteristicWhereInput>;
  none?: InputMaybe<CharacteristicWhereInput>;
  some?: InputMaybe<CharacteristicWhereInput>;
};

export type CharacteristicOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CharacteristicOrderByWithRelationInput = {
  category?: InputMaybe<SortOrder>;
  characteristicRules?: InputMaybe<CharacteristicRulesOrderByRelationAggregateInput>;
  createdAt?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export type CharacteristicRelationFilter = {
  is?: InputMaybe<CharacteristicWhereInput>;
  isNot?: InputMaybe<CharacteristicWhereInput>;
};

export type CharacteristicRulesCreateManyCharacteristicsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  ruleId: Scalars['String'];
  ruleType: CharacteristicRuleType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type CharacteristicRulesCreateManyCharacteristicsInputEnvelope = {
  data: Array<CharacteristicRulesCreateManyCharacteristicsInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CharacteristicRulesCreateNestedManyWithoutCharacteristicsInput = {
  connect?: InputMaybe<Array<CharacteristicRulesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CharacteristicRulesCreateOrConnectWithoutCharacteristicsInput>>;
  create?: InputMaybe<Array<CharacteristicRulesCreateWithoutCharacteristicsInput>>;
  createMany?: InputMaybe<CharacteristicRulesCreateManyCharacteristicsInputEnvelope>;
};

export type CharacteristicRulesCreateOrConnectWithoutCharacteristicsInput = {
  create: CharacteristicRulesCreateWithoutCharacteristicsInput;
  where: CharacteristicRulesWhereUniqueInput;
};

export type CharacteristicRulesCreateWithoutCharacteristicsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  ruleId: Scalars['String'];
  ruleType: CharacteristicRuleType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  value?: InputMaybe<Scalars['Int']>;
};

export type CharacteristicRulesListRelationFilter = {
  every?: InputMaybe<CharacteristicRulesWhereInput>;
  none?: InputMaybe<CharacteristicRulesWhereInput>;
  some?: InputMaybe<CharacteristicRulesWhereInput>;
};

export type CharacteristicRulesOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CharacteristicRulesRuleIdRuleTypeCharacteristicIdCompoundUniqueInput = {
  characteristicId: Scalars['String'];
  ruleId: Scalars['String'];
  ruleType: CharacteristicRuleType;
};

export type CharacteristicRulesScalarWhereInput = {
  AND?: InputMaybe<Array<CharacteristicRulesScalarWhereInput>>;
  characteristicId?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  NOT?: InputMaybe<Array<CharacteristicRulesScalarWhereInput>>;
  OR?: InputMaybe<Array<CharacteristicRulesScalarWhereInput>>;
  ruleId?: InputMaybe<StringFilter>;
  ruleType?: InputMaybe<EnumCharacteristicRuleTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<IntNullableFilter>;
};

export type CharacteristicRulesUpdateManyMutationInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ruleId?: InputMaybe<StringFieldUpdateOperationsInput>;
  ruleType?: InputMaybe<EnumCharacteristicRuleTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CharacteristicRulesUpdateManyWithoutCharacteristicsNestedInput = {
  connect?: InputMaybe<Array<CharacteristicRulesWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CharacteristicRulesCreateOrConnectWithoutCharacteristicsInput>>;
  create?: InputMaybe<Array<CharacteristicRulesCreateWithoutCharacteristicsInput>>;
  createMany?: InputMaybe<CharacteristicRulesCreateManyCharacteristicsInputEnvelope>;
  delete?: InputMaybe<Array<CharacteristicRulesWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CharacteristicRulesScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CharacteristicRulesWhereUniqueInput>>;
  set?: InputMaybe<Array<CharacteristicRulesWhereUniqueInput>>;
  update?: InputMaybe<Array<CharacteristicRulesUpdateWithWhereUniqueWithoutCharacteristicsInput>>;
  updateMany?: InputMaybe<Array<CharacteristicRulesUpdateManyWithWhereWithoutCharacteristicsInput>>;
  upsert?: InputMaybe<Array<CharacteristicRulesUpsertWithWhereUniqueWithoutCharacteristicsInput>>;
};

export type CharacteristicRulesUpdateManyWithWhereWithoutCharacteristicsInput = {
  data: CharacteristicRulesUpdateManyMutationInput;
  where: CharacteristicRulesScalarWhereInput;
};

export type CharacteristicRulesUpdateWithoutCharacteristicsInput = {
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  ruleId?: InputMaybe<StringFieldUpdateOperationsInput>;
  ruleType?: InputMaybe<EnumCharacteristicRuleTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  value?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CharacteristicRulesUpdateWithWhereUniqueWithoutCharacteristicsInput = {
  data: CharacteristicRulesUpdateWithoutCharacteristicsInput;
  where: CharacteristicRulesWhereUniqueInput;
};

export type CharacteristicRulesUpsertWithWhereUniqueWithoutCharacteristicsInput = {
  create: CharacteristicRulesCreateWithoutCharacteristicsInput;
  update: CharacteristicRulesUpdateWithoutCharacteristicsInput;
  where: CharacteristicRulesWhereUniqueInput;
};

export type CharacteristicRulesWhereInput = {
  AND?: InputMaybe<Array<CharacteristicRulesWhereInput>>;
  characteristicId?: InputMaybe<StringFilter>;
  characteristics?: InputMaybe<CharacteristicRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  NOT?: InputMaybe<Array<CharacteristicRulesWhereInput>>;
  OR?: InputMaybe<Array<CharacteristicRulesWhereInput>>;
  ruleId?: InputMaybe<StringFilter>;
  ruleType?: InputMaybe<EnumCharacteristicRuleTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  value?: InputMaybe<IntNullableFilter>;
};

export type CharacteristicRulesWhereUniqueInput = {
  ruleId_ruleType_characteristicId?: InputMaybe<CharacteristicRulesRuleIdRuleTypeCharacteristicIdCompoundUniqueInput>;
};

export enum CharacteristicRuleType {
  RoomType = 'ROOM_TYPE',
  Service = 'SERVICE'
}

export enum CharacteristicScalarFieldEnum {
  Category = 'category',
  CreatedAt = 'createdAt',
  Id = 'id',
  LocationId = 'locationId',
  Name = 'name',
  UpdatedAt = 'updatedAt'
}

export type CharacteristicScalarWhereInput = {
  AND?: InputMaybe<Array<CharacteristicScalarWhereInput>>;
  category?: InputMaybe<EnumCharacteristicCategoryFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<CharacteristicScalarWhereInput>>;
  OR?: InputMaybe<Array<CharacteristicScalarWhereInput>>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CharacteristicUpdateManyMutationInput = {
  category?: InputMaybe<EnumCharacteristicCategoryFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CharacteristicUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<CharacteristicWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CharacteristicCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<CharacteristicCreateWithoutLocationInput>>;
  createMany?: InputMaybe<CharacteristicCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<CharacteristicWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CharacteristicScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CharacteristicWhereUniqueInput>>;
  set?: InputMaybe<Array<CharacteristicWhereUniqueInput>>;
  update?: InputMaybe<Array<CharacteristicUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<CharacteristicUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<CharacteristicUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type CharacteristicUpdateManyWithWhereWithoutLocationInput = {
  data: CharacteristicUpdateManyMutationInput;
  where: CharacteristicScalarWhereInput;
};

export type CharacteristicUpdateWithoutLocationInput = {
  category?: InputMaybe<EnumCharacteristicCategoryFieldUpdateOperationsInput>;
  characteristicRules?: InputMaybe<CharacteristicRulesUpdateManyWithoutCharacteristicsNestedInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type CharacteristicUpdateWithWhereUniqueWithoutLocationInput = {
  data: CharacteristicUpdateWithoutLocationInput;
  where: CharacteristicWhereUniqueInput;
};

export type CharacteristicUpsertWithWhereUniqueWithoutLocationInput = {
  create: CharacteristicCreateWithoutLocationInput;
  update: CharacteristicUpdateWithoutLocationInput;
  where: CharacteristicWhereUniqueInput;
};

export type CharacteristicWhereInput = {
  AND?: InputMaybe<Array<CharacteristicWhereInput>>;
  category?: InputMaybe<EnumCharacteristicCategoryFilter>;
  characteristicRules?: InputMaybe<CharacteristicRulesListRelationFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<CharacteristicWhereInput>>;
  OR?: InputMaybe<Array<CharacteristicWhereInput>>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type CharacteristicWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum ChargingState {
  Charging = 'CHARGING',
  Full = 'FULL',
  Unplugged = 'UNPLUGGED'
}

export type CleanedAccessGrantForApiUse = {
  checkin: Scalars['String'];
  checkout: Scalars['String'];
  credentials: Array<CleanedCredentialForApiUse>;
  id: Scalars['String'];
  location: CleanedLocationForApiUse;
  metadata: HotelMetadata;
  resources: Array<CleanedResourceForApiUse>;
  tenant: CleanedTenantForApiUse;
  users: Array<CleanedUserForApiUse>;
  vendor: ResourceVendor;
};

export type CleanedCredentialForApiUse = {
  id: Scalars['String'];
  serialNumber?: Maybe<Scalars['String']>;
  type: CredentialType;
  userId: Scalars['String'];
};

export type CleanedLocationForApiUse = {
  address: Scalars['String'];
  email: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type CleanedResourceForApiUse = {
  name: Scalars['String'];
  type: ResourceType;
  unitType?: Maybe<CleanedUnitTypeForApiUse>;
  vendor: ResourceVendor;
  vendorId: Scalars['String'];
};

export type CleanedTenantForApiUse = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type CleanedUnitTypeForApiUse = {
  imageUrl: Scalars['String'];
  numberOfGuests: Scalars['Float'];
  type: Scalars['String'];
};

export type CleanedUserForApiUse = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type ClearIdVerificationRemoteConfigResponse = {
  clientId: Scalars['String'];
};

export type Component = {
  _count?: Maybe<ComponentCount>;
  id: Scalars['String'];
  name: Scalars['String'];
};

export type ComponentCount = {
  Localization: Scalars['Int'];
  Theme: Scalars['Int'];
};


export type ComponentCountLocalizationArgs = {
  where?: InputMaybe<LocalizationWhereInput>;
};


export type ComponentCountThemeArgs = {
  where?: InputMaybe<ThemeWhereInput>;
};

export type ComponentCreateNestedOneWithoutLocalizationInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutLocalizationInput>;
  create?: InputMaybe<ComponentCreateWithoutLocalizationInput>;
};

export type ComponentCreateNestedOneWithoutThemeInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutThemeInput>;
  create?: InputMaybe<ComponentCreateWithoutThemeInput>;
};

export type ComponentCreateOrConnectWithoutLocalizationInput = {
  create: ComponentCreateWithoutLocalizationInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentCreateOrConnectWithoutThemeInput = {
  create: ComponentCreateWithoutThemeInput;
  where: ComponentWhereUniqueInput;
};

export type ComponentCreateWithoutLocalizationInput = {
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  Theme?: InputMaybe<ThemeCreateNestedManyWithoutComponentInput>;
};

export type ComponentCreateWithoutThemeInput = {
  id?: InputMaybe<Scalars['String']>;
  Localization?: InputMaybe<LocalizationCreateNestedManyWithoutComponentInput>;
  name: Scalars['String'];
};

export type ComponentOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  Localization?: InputMaybe<LocalizationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  Theme?: InputMaybe<ThemeOrderByRelationAggregateInput>;
};

export type ComponentRelationFilter = {
  is?: InputMaybe<ComponentWhereInput>;
  isNot?: InputMaybe<ComponentWhereInput>;
};

export type ComponentUpdateOneRequiredWithoutLocalizationNestedInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutLocalizationInput>;
  create?: InputMaybe<ComponentCreateWithoutLocalizationInput>;
  update?: InputMaybe<ComponentUpdateWithoutLocalizationInput>;
  upsert?: InputMaybe<ComponentUpsertWithoutLocalizationInput>;
};

export type ComponentUpdateOneRequiredWithoutThemeNestedInput = {
  connect?: InputMaybe<ComponentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ComponentCreateOrConnectWithoutThemeInput>;
  create?: InputMaybe<ComponentCreateWithoutThemeInput>;
  update?: InputMaybe<ComponentUpdateWithoutThemeInput>;
  upsert?: InputMaybe<ComponentUpsertWithoutThemeInput>;
};

export type ComponentUpdateWithoutLocalizationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Theme?: InputMaybe<ThemeUpdateManyWithoutComponentNestedInput>;
};

export type ComponentUpdateWithoutThemeInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  Localization?: InputMaybe<LocalizationUpdateManyWithoutComponentNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ComponentUpsertWithoutLocalizationInput = {
  create: ComponentCreateWithoutLocalizationInput;
  update: ComponentUpdateWithoutLocalizationInput;
};

export type ComponentUpsertWithoutThemeInput = {
  create: ComponentCreateWithoutThemeInput;
  update: ComponentUpdateWithoutThemeInput;
};

export type ComponentWhereInput = {
  AND?: InputMaybe<Array<ComponentWhereInput>>;
  id?: InputMaybe<StringFilter>;
  Localization?: InputMaybe<LocalizationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ComponentWhereInput>>;
  OR?: InputMaybe<Array<ComponentWhereInput>>;
  Theme?: InputMaybe<ThemeListRelationFilter>;
};

export type ComponentWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
};

export type ConciergeChildren = {
  accessGrant?: Maybe<AccessGrant>;
  accessGrantId?: Maybe<Scalars['String']>;
  children?: Maybe<Array<ConciergeNestedChildren>>;
  contentType?: Maybe<InfoContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  infoType?: Maybe<TypeOfInfo>;
  infoTypeId?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConciergeClientResponse = {
  accessGrant?: Maybe<AccessGrant>;
  accessGrantId?: Maybe<Scalars['String']>;
  children?: Maybe<Array<ConciergeChildren>>;
  contentType?: Maybe<InfoContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  infoType?: Maybe<TypeOfInfo>;
  infoTypeId?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConciergeItem = {
  accessGrant?: Maybe<AccessGrant>;
  accessGrantId?: Maybe<Scalars['String']>;
  contentType?: Maybe<InfoContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  infoType?: Maybe<TypeOfInfo>;
  infoTypeId?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConciergeNestedChildren = {
  accessGrant?: Maybe<AccessGrant>;
  accessGrantId?: Maybe<Scalars['String']>;
  children?: Maybe<Array<ConciergeItem>>;
  contentType?: Maybe<InfoContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  infoType?: Maybe<TypeOfInfo>;
  infoTypeId?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ConciergeTreeViewNode = {
  data: ConciergeItem;
  droppable: Scalars['Boolean'];
  id: Scalars['String'];
  parent: Scalars['String'];
  text: Scalars['String'];
};

export type CreateAssaKeyResponse = {
  endpointStatus?: Maybe<Scalars['String']>;
  key?: Maybe<Scalars['String']>;
};

export type CreateAssaMobileKeyResponse = {
  data: Scalars['String'];
  responseType: Scalars['String'];
};

export type CreateConciergeItemInput = {
  contentType?: InputMaybe<InfoContentType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
  moreInfoLink?: InputMaybe<Scalars['String']>;
  parentCategory?: InputMaybe<Scalars['String']>;
  pdfUrl?: InputMaybe<Scalars['String']>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type?: InputMaybe<InfoType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CreateFaceLivenessSessionResponse = {
  sessionId: Scalars['String'];
};

export type Credential = {
  _count?: Maybe<CredentialCount>;
  accessGrant: AccessGrant;
  accessGrantId: Scalars['String'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  data: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  hasPaymentCapability?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  keycardDispensed?: Maybe<Scalars['Boolean']>;
  keycardOrigin?: Maybe<KeycardOrigin>;
  keyId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  supplementaryCards: Array<SupplementaryCard>;
  type: CredentialType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageCounter?: Maybe<Scalars['Int']>;
  user: User;
  userId: Scalars['String'];
};


export type CredentialSupplementaryCardsArgs = {
  cursor?: InputMaybe<SupplementaryCardWhereUniqueInput>;
  distinct?: InputMaybe<Array<SupplementaryCardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SupplementaryCardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SupplementaryCardWhereInput>;
};

export type CredentialAccessGrantIdUserIdTypeCompoundUniqueInput = {
  accessGrantId: Scalars['String'];
  type: CredentialType;
  userId: Scalars['String'];
};

export type CredentialAvgAggregate = {
  usageCounter?: Maybe<Scalars['Float']>;
};

export type CredentialAvgOrderByAggregateInput = {
  usageCounter?: InputMaybe<SortOrder>;
};

export type CredentialCount = {
  supplementaryCards: Scalars['Int'];
};


export type CredentialCountSupplementaryCardsArgs = {
  where?: InputMaybe<SupplementaryCardWhereInput>;
};

export type CredentialCountAggregate = {
  _all: Scalars['Int'];
  accessGrantId: Scalars['Int'];
  cancelledAt: Scalars['Int'];
  createdAt: Scalars['Int'];
  data: Scalars['Int'];
  expiresAt: Scalars['Int'];
  hasPaymentCapability: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  keycardDispensed: Scalars['Int'];
  keycardOrigin: Scalars['Int'];
  keyId: Scalars['Int'];
  serialNumber: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  usageCounter: Scalars['Int'];
  userId: Scalars['Int'];
};

export type CredentialCountOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  hasPaymentCapability?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  keycardDispensed?: InputMaybe<SortOrder>;
  keycardOrigin?: InputMaybe<SortOrder>;
  keyId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usageCounter?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CredentialCreateInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutCredentialsInput;
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keycardDispensed?: InputMaybe<Scalars['Boolean']>;
  keycardOrigin?: InputMaybe<KeycardOrigin>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutCredentialInput>;
  type: CredentialType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageCounter?: InputMaybe<Scalars['Int']>;
  user: UserCreateNestedOneWithoutCredentialInput;
};

export type CredentialCreateManyAccessGrantInput = {
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keycardDispensed?: InputMaybe<Scalars['Boolean']>;
  keycardOrigin?: InputMaybe<KeycardOrigin>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  type: CredentialType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageCounter?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};

export type CredentialCreateManyAccessGrantInputEnvelope = {
  data: Array<CredentialCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CredentialCreateManyInput = {
  accessGrantId: Scalars['String'];
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keycardDispensed?: InputMaybe<Scalars['Boolean']>;
  keycardOrigin?: InputMaybe<KeycardOrigin>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  type: CredentialType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageCounter?: InputMaybe<Scalars['Int']>;
  userId: Scalars['String'];
};

export type CredentialCreateManyUserInput = {
  accessGrantId: Scalars['String'];
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keycardDispensed?: InputMaybe<Scalars['Boolean']>;
  keycardOrigin?: InputMaybe<KeycardOrigin>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  type: CredentialType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageCounter?: InputMaybe<Scalars['Int']>;
};

export type CredentialCreateManyUserInputEnvelope = {
  data: Array<CredentialCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type CredentialCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<CredentialCreateManyAccessGrantInputEnvelope>;
};

export type CredentialCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutUserInput>>;
  createMany?: InputMaybe<CredentialCreateManyUserInputEnvelope>;
};

export type CredentialCreateNestedOneWithoutSupplementaryCardsInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutSupplementaryCardsInput>;
  create?: InputMaybe<CredentialCreateWithoutSupplementaryCardsInput>;
};

export type CredentialCreateOrConnectWithoutAccessGrantInput = {
  create: CredentialCreateWithoutAccessGrantInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutSupplementaryCardsInput = {
  create: CredentialCreateWithoutSupplementaryCardsInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateOrConnectWithoutUserInput = {
  create: CredentialCreateWithoutUserInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialCreateWithoutAccessGrantInput = {
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keycardDispensed?: InputMaybe<Scalars['Boolean']>;
  keycardOrigin?: InputMaybe<KeycardOrigin>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutCredentialInput>;
  type: CredentialType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageCounter?: InputMaybe<Scalars['Int']>;
  user: UserCreateNestedOneWithoutCredentialInput;
};

export type CredentialCreateWithoutSupplementaryCardsInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutCredentialsInput;
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keycardDispensed?: InputMaybe<Scalars['Boolean']>;
  keycardOrigin?: InputMaybe<KeycardOrigin>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  type: CredentialType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageCounter?: InputMaybe<Scalars['Int']>;
  user: UserCreateNestedOneWithoutCredentialInput;
};

export type CredentialCreateWithoutUserInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutCredentialsInput;
  cancelledAt?: InputMaybe<Scalars['DateTime']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['String'];
  expiresAt?: InputMaybe<Scalars['DateTime']>;
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keycardDispensed?: InputMaybe<Scalars['Boolean']>;
  keycardOrigin?: InputMaybe<KeycardOrigin>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber?: InputMaybe<Scalars['String']>;
  supplementaryCards?: InputMaybe<SupplementaryCardCreateNestedManyWithoutCredentialInput>;
  type: CredentialType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usageCounter?: InputMaybe<Scalars['Int']>;
};

export type CredentialGroupBy = {
  _avg?: Maybe<CredentialAvgAggregate>;
  _count?: Maybe<CredentialCountAggregate>;
  _max?: Maybe<CredentialMaxAggregate>;
  _min?: Maybe<CredentialMinAggregate>;
  _sum?: Maybe<CredentialSumAggregate>;
  accessGrantId: Scalars['String'];
  cancelledAt?: Maybe<Scalars['DateTime']>;
  createdAt: Scalars['DateTime'];
  data: Scalars['String'];
  expiresAt?: Maybe<Scalars['DateTime']>;
  hasPaymentCapability?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  keycardDispensed?: Maybe<Scalars['Boolean']>;
  keycardOrigin?: Maybe<KeycardOrigin>;
  keyId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  type: CredentialType;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageCounter?: Maybe<Scalars['Int']>;
  userId: Scalars['String'];
};

export type CredentialListRelationFilter = {
  every?: InputMaybe<CredentialWhereInput>;
  none?: InputMaybe<CredentialWhereInput>;
  some?: InputMaybe<CredentialWhereInput>;
};

export type CredentialMaxAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  hasPaymentCapability?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  keycardDispensed?: Maybe<Scalars['Boolean']>;
  keycardOrigin?: Maybe<KeycardOrigin>;
  keyId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  type?: Maybe<CredentialType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageCounter?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
};

export type CredentialMaxOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  hasPaymentCapability?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  keycardDispensed?: InputMaybe<SortOrder>;
  keycardOrigin?: InputMaybe<SortOrder>;
  keyId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usageCounter?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CredentialMinAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  cancelledAt?: Maybe<Scalars['DateTime']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  data?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  hasPaymentCapability?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  keycardDispensed?: Maybe<Scalars['Boolean']>;
  keycardOrigin?: Maybe<KeycardOrigin>;
  keyId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  type?: Maybe<CredentialType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  usageCounter?: Maybe<Scalars['Int']>;
  userId?: Maybe<Scalars['String']>;
};

export type CredentialMinOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  hasPaymentCapability?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  keycardDispensed?: InputMaybe<SortOrder>;
  keycardOrigin?: InputMaybe<SortOrder>;
  keyId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  usageCounter?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type CredentialOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type CredentialOrderByWithAggregationInput = {
  _avg?: InputMaybe<CredentialAvgOrderByAggregateInput>;
  _count?: InputMaybe<CredentialCountOrderByAggregateInput>;
  _max?: InputMaybe<CredentialMaxOrderByAggregateInput>;
  _min?: InputMaybe<CredentialMinOrderByAggregateInput>;
  _sum?: InputMaybe<CredentialSumOrderByAggregateInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrderInput>;
  hasPaymentCapability?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  keycardDispensed?: InputMaybe<SortOrderInput>;
  keycardOrigin?: InputMaybe<SortOrderInput>;
  keyId?: InputMaybe<SortOrderInput>;
  serialNumber?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
  usageCounter?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrder>;
};

export type CredentialOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  cancelledAt?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrderInput>;
  hasPaymentCapability?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  keycardDispensed?: InputMaybe<SortOrderInput>;
  keycardOrigin?: InputMaybe<SortOrderInput>;
  keyId?: InputMaybe<SortOrderInput>;
  serialNumber?: InputMaybe<SortOrderInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
  usageCounter?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type CredentialRelationFilter = {
  is?: InputMaybe<CredentialWhereInput>;
  isNot?: InputMaybe<CredentialWhereInput>;
};

export enum CredentialScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  CancelledAt = 'cancelledAt',
  CreatedAt = 'createdAt',
  Data = 'data',
  ExpiresAt = 'expiresAt',
  HasPaymentCapability = 'hasPaymentCapability',
  Id = 'id',
  IsActive = 'isActive',
  KeycardDispensed = 'keycardDispensed',
  KeycardOrigin = 'keycardOrigin',
  KeyId = 'keyId',
  SerialNumber = 'serialNumber',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UsageCounter = 'usageCounter',
  UserId = 'userId'
}

export type CredentialScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<CredentialScalarWhereInput>>;
  cancelledAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  hasPaymentCapability?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  keycardDispensed?: InputMaybe<BoolNullableFilter>;
  keycardOrigin?: InputMaybe<EnumKeycardOriginNullableFilter>;
  keyId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<CredentialScalarWhereInput>>;
  OR?: InputMaybe<Array<CredentialScalarWhereInput>>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  type?: InputMaybe<EnumCredentialTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  usageCounter?: InputMaybe<IntNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CredentialScalarWhereWithAggregatesInput = {
  accessGrantId?: InputMaybe<StringWithAggregatesFilter>;
  AND?: InputMaybe<Array<CredentialScalarWhereWithAggregatesInput>>;
  cancelledAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  data?: InputMaybe<StringWithAggregatesFilter>;
  expiresAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  hasPaymentCapability?: InputMaybe<BoolNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isActive?: InputMaybe<BoolWithAggregatesFilter>;
  keycardDispensed?: InputMaybe<BoolNullableWithAggregatesFilter>;
  keycardOrigin?: InputMaybe<EnumKeycardOriginNullableWithAggregatesFilter>;
  keyId?: InputMaybe<StringNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<CredentialScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<CredentialScalarWhereWithAggregatesInput>>;
  serialNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  type?: InputMaybe<EnumCredentialTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  usageCounter?: InputMaybe<IntNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type CredentialSumAggregate = {
  usageCounter?: Maybe<Scalars['Int']>;
};

export type CredentialSumOrderByAggregateInput = {
  usageCounter?: InputMaybe<SortOrder>;
};

export enum CredentialType {
  AssaAbloyMobile = 'ASSA_ABLOY_MOBILE',
  DormakabaAmbianceMobile = 'DORMAKABA_AMBIANCE_MOBILE',
  DormakabaSystem_6000Mobile = 'DORMAKABA_SYSTEM_6000_MOBILE',
  MifareCard_1K = 'MIFARE_CARD_1K',
  MifarePlus = 'MIFARE_PLUS',
  MifareUltralight = 'MIFARE_ULTRALIGHT',
  MifareUltralightC = 'MIFARE_ULTRALIGHT_C',
  MiwaMobile = 'MIWA_MOBILE',
  OnityMobile = 'ONITY_MOBILE',
  OpenpathMobile = 'OPENPATH_MOBILE',
  Qr = 'QR',
  SaltoCardBlob = 'SALTO_CARD_BLOB',
  SaltoMobile = 'SALTO_MOBILE',
  WebsiteToken = 'WEBSITE_TOKEN'
}

export type CredentialUpdateInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutCredentialsNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPaymentCapability?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keycardDispensed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  keycardOrigin?: InputMaybe<NullableEnumKeycardOriginFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutCredentialNestedInput>;
  type?: InputMaybe<EnumCredentialTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  usageCounter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialNestedInput>;
};

export type CredentialUpdateManyMutationInput = {
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPaymentCapability?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keycardDispensed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  keycardOrigin?: InputMaybe<NullableEnumKeycardOriginFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCredentialTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  usageCounter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CredentialUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<CredentialCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CredentialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  set?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  update?: InputMaybe<Array<CredentialUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<CredentialUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<CredentialUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type CredentialUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<CredentialCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<CredentialCreateWithoutUserInput>>;
  createMany?: InputMaybe<CredentialCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<CredentialScalarWhereInput>>;
  disconnect?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  set?: InputMaybe<Array<CredentialWhereUniqueInput>>;
  update?: InputMaybe<Array<CredentialUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<CredentialUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<CredentialUpsertWithWhereUniqueWithoutUserInput>>;
};

export type CredentialUpdateManyWithWhereWithoutAccessGrantInput = {
  data: CredentialUpdateManyMutationInput;
  where: CredentialScalarWhereInput;
};

export type CredentialUpdateManyWithWhereWithoutUserInput = {
  data: CredentialUpdateManyMutationInput;
  where: CredentialScalarWhereInput;
};

export type CredentialUpdateOneWithoutSupplementaryCardsNestedInput = {
  connect?: InputMaybe<CredentialWhereUniqueInput>;
  connectOrCreate?: InputMaybe<CredentialCreateOrConnectWithoutSupplementaryCardsInput>;
  create?: InputMaybe<CredentialCreateWithoutSupplementaryCardsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<CredentialUpdateWithoutSupplementaryCardsInput>;
  upsert?: InputMaybe<CredentialUpsertWithoutSupplementaryCardsInput>;
};

export type CredentialUpdateWithoutAccessGrantInput = {
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPaymentCapability?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keycardDispensed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  keycardOrigin?: InputMaybe<NullableEnumKeycardOriginFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutCredentialNestedInput>;
  type?: InputMaybe<EnumCredentialTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  usageCounter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutSupplementaryCardsInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutCredentialsNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPaymentCapability?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keycardDispensed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  keycardOrigin?: InputMaybe<NullableEnumKeycardOriginFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumCredentialTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  usageCounter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutCredentialNestedInput>;
};

export type CredentialUpdateWithoutUserInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutCredentialsNestedInput>;
  cancelledAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  hasPaymentCapability?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keycardDispensed?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  keycardOrigin?: InputMaybe<NullableEnumKeycardOriginFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  supplementaryCards?: InputMaybe<SupplementaryCardUpdateManyWithoutCredentialNestedInput>;
  type?: InputMaybe<EnumCredentialTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  usageCounter?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
};

export type CredentialUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: CredentialUpdateWithoutAccessGrantInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpdateWithWhereUniqueWithoutUserInput = {
  data: CredentialUpdateWithoutUserInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpsertWithoutSupplementaryCardsInput = {
  create: CredentialCreateWithoutSupplementaryCardsInput;
  update: CredentialUpdateWithoutSupplementaryCardsInput;
};

export type CredentialUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: CredentialCreateWithoutAccessGrantInput;
  update: CredentialUpdateWithoutAccessGrantInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialUpsertWithWhereUniqueWithoutUserInput = {
  create: CredentialCreateWithoutUserInput;
  update: CredentialUpdateWithoutUserInput;
  where: CredentialWhereUniqueInput;
};

export type CredentialWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<CredentialWhereInput>>;
  cancelledAt?: InputMaybe<DateTimeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  data?: InputMaybe<StringFilter>;
  expiresAt?: InputMaybe<DateTimeNullableFilter>;
  hasPaymentCapability?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  keycardDispensed?: InputMaybe<BoolNullableFilter>;
  keycardOrigin?: InputMaybe<EnumKeycardOriginNullableFilter>;
  keyId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<CredentialWhereInput>>;
  OR?: InputMaybe<Array<CredentialWhereInput>>;
  serialNumber?: InputMaybe<StringNullableFilter>;
  supplementaryCards?: InputMaybe<SupplementaryCardListRelationFilter>;
  type?: InputMaybe<EnumCredentialTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
  usageCounter?: InputMaybe<IntNullableFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type CredentialWhereUniqueInput = {
  accessGrantId_userId_type?: InputMaybe<CredentialAccessGrantIdUserIdTypeCompoundUniqueInput>;
  data?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export enum CreditCardType {
  Amex = 'AMEX',
  Diners = 'DINERS',
  Discover = 'DISCOVER',
  Jcb = 'JCB',
  Maestro = 'MAESTRO',
  Mastercard = 'MASTERCARD',
  UnionPay = 'UNION_PAY',
  Visa = 'VISA'
}

export type CustomAmenityCreateInput = {
  description?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<AmenityGroupCreateNestedOneWithoutAmenitiesInput>;
  id?: InputMaybe<Scalars['String']>;
  image: CustomImageInput;
  location?: InputMaybe<LocationCreateNestedOneWithoutAmenitiesInput>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
};

export type CustomAmenityUpdateInput = {
  description?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<AmenityGroupUpdateOneWithoutAmenitiesNestedInput>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<CustomImageInput>;
  location?: InputMaybe<LocationUpdateOneWithoutAmenitiesNestedInput>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
};

export type CustomImageInput = {
  imageFile?: InputMaybe<Scalars['Upload']>;
  imageUrl?: InputMaybe<Scalars['String']>;
};

export type CustomInfoItemCreateInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutInfosInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  image: CustomImageInput;
  infoType?: InputMaybe<TypeOfInfoCreateNestedOneWithoutInfoInput>;
  location: LocationCreateNestedOneWithoutInfosInput;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomInfoItemUpdateInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutInfosNestedInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<CustomImageInput>;
  infoType?: InputMaybe<TypeOfInfoUpdateOneWithoutInfoNestedInput>;
  location?: InputMaybe<LocationUpdateOneWithoutInfosNestedInput>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<InfoType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type CustomKioskUpdateInput = {
  batteryLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  buildNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  CallRecord?: InputMaybe<CallRecordUpdateManyWithoutKioskNestedInput>;
  chargingState?: InputMaybe<NullableEnumChargingStateFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigUpdateManyWithoutAssociatedKioskNestedInput>;
  dispenserConfigList?: InputMaybe<Array<DispenserConfigInput>>;
  dispenserLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dispenserType?: InputMaybe<NullableEnumDispenserTypeFieldUpdateOperationsInput>;
  hasDispenser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasTerminal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutKioskNestedInput>;
  isDispenserConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStripeReaderConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeUpdateManyWithoutAssociatedKioskNestedInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutKiosksNestedInput>;
  maintenanceEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceEndsTime?: InputMaybe<Scalars['String']>;
  maintenanceStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceStartsTime?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  powerSwitchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rfidTagType?: InputMaybe<NullableEnumRfidTagTypeFieldUpdateOperationsInput>;
  serverUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutKiosksNestedInput>;
  terminalLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type CustomLocalizationInput = {
  languageId: Scalars['String'];
  localization?: InputMaybe<Scalars['String']>;
};

export type CustomLocalizationInputArgs = {
  localizationsInputs: Array<CustomLocalizationInput>;
};

export type CustomLocationGroup = {
  _count?: Maybe<LocationGroupCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  locationIds?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  tenantId: Scalars['String'];
};

export type CustomLocationGroupCreateInput = {
  groups?: InputMaybe<Array<Scalars['String']>>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  name: Scalars['String'];
  tenantId: Scalars['String'];
};

export type CustomLocationGroupUpdateInput = {
  groups?: InputMaybe<Array<Scalars['String']>>;
  locations?: InputMaybe<Array<Scalars['String']>>;
  name?: InputMaybe<Scalars['String']>;
};

export type CustomLocationGroupWhereUniqueInput = {
  id: Scalars['String'];
};

export type CustomLocationWhereInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdListRelationFilter>;
  accessGrants?: InputMaybe<AccessGrantListRelationFilter>;
  address?: InputMaybe<StringFilter>;
  amenities?: InputMaybe<AmenityListRelationFilter>;
  AND?: InputMaybe<Array<LocationWhereInput>>;
  callRecords?: InputMaybe<CallRecordListRelationFilter>;
  Characteristic?: InputMaybe<CharacteristicListRelationFilter>;
  countryCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultEndTime?: InputMaybe<StringFilter>;
  defaultRequirements?: InputMaybe<DefaultRequirementListRelationFilter>;
  defaultStartTime?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emailBccList?: InputMaybe<StringNullableFilter>;
  emailCcList?: InputMaybe<StringNullableFilter>;
  emailFrom?: InputMaybe<StringNullableFilter>;
  emailTemplateId?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  iconUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  infos?: InputMaybe<InfoItemListRelationFilter>;
  kiosks?: InputMaybe<KioskListRelationFilter>;
  language?: InputMaybe<LanguageRelationFilter>;
  languageId?: InputMaybe<StringNullableFilter>;
  lat?: InputMaybe<FloatNullableFilter>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<IntNullableFilter>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<IntNullableFilter>;
  lng?: InputMaybe<FloatNullableFilter>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationListRelationFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  loyaltyConfig?: InputMaybe<JsonNullableFilter>;
  loyaltyType?: InputMaybe<EnumLoyaltyTypeNullableFilter>;
  Membership?: InputMaybe<MembershipListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LocationWhereInput>>;
  Notification?: InputMaybe<NotificationListRelationFilter>;
  notificationsConfig?: InputMaybe<JsonNullableFilter>;
  OR?: InputMaybe<Array<LocationWhereInput>>;
  paymentProvider?: InputMaybe<PaymentProviderRelationFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  pms?: InputMaybe<PmsRelationFilter>;
  pmsConfig?: InputMaybe<JsonNullableFilter>;
  pmsId?: InputMaybe<StringNullableFilter>;
  pmsType?: InputMaybe<EnumPmsTypeNullableFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  processReservations?: InputMaybe<BoolFilter>;
  resourceGroups?: InputMaybe<ResourceGroupListRelationFilter>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  securityDeposit?: InputMaybe<FloatNullableFilter>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFilter>;
  ServiceCategory?: InputMaybe<ServiceCategoryListRelationFilter>;
  services?: InputMaybe<ServiceListRelationFilter>;
  supportsPolling?: InputMaybe<BoolFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  termsAndConditionsUrl?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringFilter>;
  unitTypes?: InputMaybe<UnitTypeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  UserLocationData?: InputMaybe<UserLocationDataListRelationFilter>;
  vendorServers?: InputMaybe<VendorServerListRelationFilter>;
};

export type CustomPackagesInputs = {
  quantity: Scalars['Float'];
  serviceId: Scalars['String'];
};

export type CustomPaymentCreateInput = {
  cardType?: InputMaybe<CreditCardType>;
  cardTypeFromPaymentProvider?: InputMaybe<Scalars['String']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expMonthAndYear?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  location: LocationCreateNestedOneWithoutPaymentsInput;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenant: TenantCreateNestedOneWithoutPaymentInput;
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
};

export type CustomPaymentRequirement = {
  kiosk: CustomPaymentRequirementOption;
  mobile: CustomPaymentRequirementOption;
  web: CustomPaymentRequirementOption;
};

export type CustomPaymentRequirementOption = {
  disablePaymentRequirements: Scalars['Boolean'];
};

export type CustomPaymentRequirementsWhereInput = {
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type CustomRequirementUpdateInput = {
  id: Scalars['String'];
  status: RequirementStatus;
};

export type CustomResourceCreateInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutResourcesInput>;
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<CustomImageInput>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourcesInput;
  name: Scalars['String'];
  overrides?: InputMaybe<OverrideCreateNestedManyWithoutResourceInput>;
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutResourcesInput>;
  tenant: TenantCreateNestedOneWithoutResourcesInput;
  type?: InputMaybe<ResourceType>;
  unitType?: InputMaybe<UnitTypeCreateNestedOneWithoutResourcesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type CustomResourceUpdateInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutResourcesNestedInput>;
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<CustomImageInput>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourcesNestedInput>;
  name?: InputMaybe<Scalars['String']>;
  overrides?: InputMaybe<OverrideUpdateManyWithoutResourceNestedInput>;
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutResourcesNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourcesNestedInput>;
  type?: InputMaybe<ResourceType>;
  unitType?: InputMaybe<UnitTypeUpdateOneWithoutResourcesNestedInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor?: InputMaybe<ResourceVendor>;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type CustomServiceCreateInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image: CustomImageInput;
  largeDescription?: InputMaybe<Scalars['String']>;
  location: LocationCreateNestedOneWithoutServicesInput;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  serviceCategory?: InputMaybe<ServiceCategoryCreateNestedOneWithoutServicesInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutServiceInput>;
  status?: InputMaybe<ServiceStatus>;
  title: Scalars['String'];
  type: ServiceType;
};

export type CustomServiceUpdateInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  description?: InputMaybe<Scalars['String']>;
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  image?: InputMaybe<CustomImageInput>;
  largeDescription?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationUpdateOneWithoutServicesNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['Float']>;
  serviceCategory?: InputMaybe<ServiceCategoryUpdateOneWithoutServicesNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutServiceNestedInput>;
  status?: InputMaybe<ServiceStatus>;
  title?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ServiceType>;
};

export type CustomUnitTypeCreateInput = {
  id?: InputMaybe<Scalars['String']>;
  image: CustomImageInput;
  location: LocationCreateNestedOneWithoutUnitTypesInput;
  numberOfGuests: Scalars['Int'];
  resources?: InputMaybe<ResourceCreateNestedManyWithoutUnitTypeInput>;
  type: Scalars['String'];
};

export type CustomUnitTypeUpdateInput = {
  image?: InputMaybe<CustomImageInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutUnitTypesNestedInput>;
  numberOfGuests?: InputMaybe<Scalars['Int']>;
  resources?: InputMaybe<ResourceUpdateManyWithoutUnitTypeNestedInput>;
  type?: InputMaybe<Scalars['String']>;
};

export type DagfAccessGrantStateFilter = {
  in?: InputMaybe<Array<AccessGrantState>>;
  notIn?: InputMaybe<Array<AccessGrantState>>;
};

export type DagfAccessGrantStatusFilter = {
  in?: InputMaybe<Array<AccessGrantStatus>>;
  notIn?: InputMaybe<Array<AccessGrantStatus>>;
};

export type DagfRequirementStatusFilter = {
  in?: InputMaybe<Array<RequirementStatus>>;
  notIn?: InputMaybe<Array<RequirementStatus>>;
};

export type DagfRequirementTypeFilter = {
  in?: InputMaybe<Array<RequirementType>>;
  notIn?: InputMaybe<Array<RequirementType>>;
};

export type DagfRetryCheckinStatusFilter = {
  in?: InputMaybe<Array<RetryCheckinStatus>>;
  notIn?: InputMaybe<Array<RetryCheckinStatus>>;
};

export type DagfStringFilter = {
  in?: InputMaybe<Array<Scalars['String']>>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
};

/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardAccessGrant = {
  AccessGrantResId?: Maybe<Array<AccessGrantResId>>;
  address?: Maybe<Scalars['String']>;
  /** The time of arrival (ETA) of guest */
  arrivalTime?: Maybe<Scalars['String']>;
  callRecords?: Maybe<Array<CallRecord>>;
  code?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  credentials?: Maybe<Array<Credential>>;
  deviceRegistrations?: Maybe<Array<DeviceRegistration>>;
  endDate?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: Maybe<Scalars['String']>;
  floorPlan?: Maybe<Scalars['String']>;
  gotCODResponse?: Maybe<Scalars['Boolean']>;
  gracePeriods?: Maybe<Scalars['JSONObject']>;
  housekeepingDate?: Maybe<Scalars['DateTime']>;
  housekeepingRRule?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idVerification: IdVerification;
  idVerificationResult?: Maybe<IdVerificationResult>;
  idVerificationResultId?: Maybe<Scalars['String']>;
  infos?: Maybe<Array<InfoItem>>;
  lastPolledAt?: Maybe<Scalars['DateTime']>;
  location?: Maybe<DashboardLocation>;
  locationId: Scalars['String'];
  maxKeys?: Maybe<Scalars['Int']>;
  metadata: Scalars['JSONObject'];
  noticeDate?: Maybe<Scalars['DateTime']>;
  notifications?: Maybe<Array<Notification>>;
  numKeysDispensed?: Maybe<Scalars['Int']>;
  overrides?: Maybe<Array<Override>>;
  passes?: Maybe<Array<Pass>>;
  paymentTransactions?: Maybe<Array<PaymentTransaction>>;
  qrCodeImageUrl?: Maybe<Scalars['String']>;
  requirements?: Maybe<Array<Requirement>>;
  resources?: Maybe<Array<Resource>>;
  retryCheckin?: Maybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: Maybe<Scalars['DateTime']>;
  roomNumber?: Maybe<Scalars['String']>;
  secondaryUsers?: Maybe<Array<SecondaryUsersOnAccessGrants>>;
  serviceRequests?: Maybe<Array<ServiceRequest>>;
  startDate?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  startTime?: Maybe<Scalars['String']>;
  state?: Maybe<AccessGrantState>;
  status: AccessGrantStatus;
  supplementaryCards?: Maybe<Array<SupplementaryCard>>;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String'];
  type: AccessGrantType;
  uidOnLocation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['String'];
};

export type DashboardAccessGrantsOrderBy = {
  confirmationCode?: InputMaybe<SortOrder>;
  endDate?: InputMaybe<SortOrder>;
  endsAt?: InputMaybe<SortOrder>;
  retryCheckin?: InputMaybe<SortOrder>;
  startDate?: InputMaybe<SortOrder>;
  startsAt?: InputMaybe<SortOrder>;
  state?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  userName?: InputMaybe<SortOrder>;
};

export type DashboardAccessGrantsResponse = {
  data: Array<AccessGrant>;
  /** Number of records that were returned (could be less than the limit) */
  dataCount: Scalars['Int'];
  /** Total number of records without pagination. Will return -1 if filter.countTotal = false */
  totalCount: Scalars['Int'];
};

/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocation = {
  _count?: Maybe<LocationCount>;
  AccessGrantResId: Array<AccessGrantResId>;
  accessGrants: Array<AccessGrant>;
  address: Scalars['String'];
  amenities: Array<Amenity>;
  callRecords: Array<CallRecord>;
  Characteristic: Array<Characteristic>;
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  defaultEndTime: Scalars['String'];
  defaultRequirements: Array<DefaultRequirement>;
  defaultStartTime: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emailBccList?: Maybe<Scalars['String']>;
  emailCcList?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<Scalars['String']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  infos: Array<InfoItem>;
  kiosks: Array<Kiosk>;
  language?: Maybe<Language>;
  languageId?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: Maybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: Maybe<Scalars['Int']>;
  lng?: Maybe<Scalars['Float']>;
  LocationGroupToLocation: Array<LocationGroupToLocation>;
  logoUrl?: Maybe<Scalars['String']>;
  loyaltyConfig?: Maybe<Scalars['JSON']>;
  loyaltyType?: Maybe<LoyaltyType>;
  Membership: Array<Membership>;
  name: Scalars['String'];
  Notification: Array<Notification>;
  notificationsConfig?: Maybe<Scalars['JSON']>;
  paymentProvider?: Maybe<PaymentProvider>;
  payments: Array<Payment>;
  phoneNumber: Scalars['String'];
  pms?: Maybe<Pms>;
  pmsConfig?: Maybe<Scalars['JSON']>;
  pmsId?: Maybe<Scalars['String']>;
  pmsType?: Maybe<PmsType>;
  postalCode?: Maybe<Scalars['String']>;
  processReservations: Scalars['Boolean'];
  resourceGroups: Array<ResourceGroup>;
  resources: Array<Resource>;
  securityDeposit?: Maybe<Scalars['Float']>;
  securityDepositPolicy: SecurityDepositPolicy;
  ServiceCategory: Array<ServiceCategory>;
  services: Array<Service>;
  supportsPolling: Scalars['Boolean'];
  tenant: Tenant;
  tenantId: Scalars['String'];
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes: Array<UnitType>;
  updatedAt: Scalars['DateTime'];
  UserLocationData: Array<UserLocationData>;
  vendorServers: Array<VendorServer>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationAccessGrantResIdArgs = {
  cursor?: InputMaybe<AccessGrantResIdWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantResIdScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantResIdOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantResIdWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationAmenitiesArgs = {
  cursor?: InputMaybe<AmenityWhereUniqueInput>;
  distinct?: InputMaybe<Array<AmenityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AmenityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationCharacteristicArgs = {
  cursor?: InputMaybe<CharacteristicWhereUniqueInput>;
  distinct?: InputMaybe<Array<CharacteristicScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CharacteristicOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CharacteristicWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationDefaultRequirementsArgs = {
  cursor?: InputMaybe<DefaultRequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<DefaultRequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DefaultRequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefaultRequirementWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationInfosArgs = {
  cursor?: InputMaybe<InfoItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<InfoItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationKiosksArgs = {
  cursor?: InputMaybe<KioskWhereUniqueInput>;
  distinct?: InputMaybe<Array<KioskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationLocationGroupToLocationArgs = {
  cursor?: InputMaybe<LocationGroupToLocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationGroupToLocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationGroupToLocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationGroupToLocationWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationMembershipArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationResourceGroupsArgs = {
  cursor?: InputMaybe<ResourceGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationServiceCategoryArgs = {
  cursor?: InputMaybe<ServiceCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceCategoryWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationServicesArgs = {
  cursor?: InputMaybe<ServiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationUnitTypesArgs = {
  cursor?: InputMaybe<UnitTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<UnitTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UnitTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitTypeWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationUserLocationDataArgs = {
  cursor?: InputMaybe<UserLocationDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserLocationDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserLocationDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserLocationDataWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type DashboardLocationVendorServersArgs = {
  cursor?: InputMaybe<VendorServerWhereUniqueInput>;
  distinct?: InputMaybe<Array<VendorServerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VendorServerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VendorServerWhereInput>;
};

export type DashboardPreferences = {
  locationGroup?: Maybe<Scalars['Boolean']>;
  preferredDateFormat?: Maybe<Scalars['String']>;
  preferredTimeFormat?: Maybe<Scalars['String']>;
  quickActionBar?: Maybe<QuickActionBarPreferences>;
  reportingServices?: Maybe<ReportingServices>;
};

export type DashboardSupportedNotificationsWhereInput = {
  locationId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};

export type DashboardTextFilter = {
  type: DashboardTextFilterType;
  value: Scalars['String'];
};

export enum DashboardTextFilterType {
  ConfirmationCode = 'CONFIRMATION_CODE',
  RoomNumber = 'ROOM_NUMBER',
  UserName = 'USER_NAME'
}

export type DashboardTimeFilter = {
  endsAt?: InputMaybe<DashboardTimeRangeFilter>;
  startsAt?: InputMaybe<DashboardTimeRangeFilter>;
};

export type DashboardTimeRangeFilter = {
  from?: InputMaybe<Scalars['DateTime']>;
  to?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type DateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type DefaultRequirement = {
  id: Scalars['String'];
  locationId: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  type: RequirementType;
};

export type DefaultRequirementCreateManyLocationInput = {
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  type: RequirementType;
};

export type DefaultRequirementCreateManyLocationInputEnvelope = {
  data: Array<DefaultRequirementCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DefaultRequirementCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<DefaultRequirementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefaultRequirementCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DefaultRequirementCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DefaultRequirementCreateManyLocationInputEnvelope>;
};

export type DefaultRequirementCreateOrConnectWithoutLocationInput = {
  create: DefaultRequirementCreateWithoutLocationInput;
  where: DefaultRequirementWhereUniqueInput;
};

export type DefaultRequirementCreateWithoutLocationInput = {
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  type: RequirementType;
};

export type DefaultRequirementListRelationFilter = {
  every?: InputMaybe<DefaultRequirementWhereInput>;
  none?: InputMaybe<DefaultRequirementWhereInput>;
  some?: InputMaybe<DefaultRequirementWhereInput>;
};

export type DefaultRequirementOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DefaultRequirementOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  Location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  type?: InputMaybe<SortOrder>;
};

export enum DefaultRequirementScalarFieldEnum {
  Id = 'id',
  LocationId = 'locationId',
  Metadata = 'metadata',
  Type = 'type'
}

export type DefaultRequirementScalarWhereInput = {
  AND?: InputMaybe<Array<DefaultRequirementScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<DefaultRequirementScalarWhereInput>>;
  OR?: InputMaybe<Array<DefaultRequirementScalarWhereInput>>;
  type?: InputMaybe<EnumRequirementTypeFilter>;
};

export type DefaultRequirementTypeLocationIdCompoundUniqueInput = {
  locationId: Scalars['String'];
  type: RequirementType;
};

export type DefaultRequirementUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
};

export type DefaultRequirementUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<DefaultRequirementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DefaultRequirementCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<DefaultRequirementCreateWithoutLocationInput>>;
  createMany?: InputMaybe<DefaultRequirementCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<DefaultRequirementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DefaultRequirementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DefaultRequirementWhereUniqueInput>>;
  set?: InputMaybe<Array<DefaultRequirementWhereUniqueInput>>;
  update?: InputMaybe<Array<DefaultRequirementUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<DefaultRequirementUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<DefaultRequirementUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type DefaultRequirementUpdateManyWithWhereWithoutLocationInput = {
  data: DefaultRequirementUpdateManyMutationInput;
  where: DefaultRequirementScalarWhereInput;
};

export type DefaultRequirementUpdateWithoutLocationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
};

export type DefaultRequirementUpdateWithWhereUniqueWithoutLocationInput = {
  data: DefaultRequirementUpdateWithoutLocationInput;
  where: DefaultRequirementWhereUniqueInput;
};

export type DefaultRequirementUpsertWithWhereUniqueWithoutLocationInput = {
  create: DefaultRequirementCreateWithoutLocationInput;
  update: DefaultRequirementUpdateWithoutLocationInput;
  where: DefaultRequirementWhereUniqueInput;
};

export type DefaultRequirementWhereInput = {
  AND?: InputMaybe<Array<DefaultRequirementWhereInput>>;
  id?: InputMaybe<StringFilter>;
  Location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<DefaultRequirementWhereInput>>;
  OR?: InputMaybe<Array<DefaultRequirementWhereInput>>;
  type?: InputMaybe<EnumRequirementTypeFilter>;
};

export type DefaultRequirementWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  type_locationId?: InputMaybe<DefaultRequirementTypeLocationIdCompoundUniqueInput>;
};

export type DeleteConciergeItemResponse = {
  id: Scalars['String'];
};

export type Device = {
  _count?: Maybe<DeviceCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isPrimary: Scalars['Boolean'];
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  uniqueId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type DeviceCount = {
  registrations: Scalars['Int'];
};


export type DeviceCountRegistrationsArgs = {
  where?: InputMaybe<DeviceRegistrationWhereInput>;
};

export type DeviceCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  uniqueId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DeviceCreateManyUserInputEnvelope = {
  data: Array<DeviceCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DeviceCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<DeviceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DeviceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DeviceCreateWithoutUserInput>>;
  createMany?: InputMaybe<DeviceCreateManyUserInputEnvelope>;
};

export type DeviceCreateNestedOneWithoutRegistrationsInput = {
  connect?: InputMaybe<DeviceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeviceCreateOrConnectWithoutRegistrationsInput>;
  create?: InputMaybe<DeviceCreateWithoutRegistrationsInput>;
};

export type DeviceCreateOrConnectWithoutRegistrationsInput = {
  create: DeviceCreateWithoutRegistrationsInput;
  where: DeviceWhereUniqueInput;
};

export type DeviceCreateOrConnectWithoutUserInput = {
  create: DeviceCreateWithoutUserInput;
  where: DeviceWhereUniqueInput;
};

export type DeviceCreateWithoutRegistrationsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  uniqueId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutDevicesInput;
};

export type DeviceCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isPrimary?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  registrations?: InputMaybe<DeviceRegistrationCreateNestedManyWithoutDeviceInput>;
  uniqueId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type DeviceListRelationFilter = {
  every?: InputMaybe<DeviceWhereInput>;
  none?: InputMaybe<DeviceWhereInput>;
  some?: InputMaybe<DeviceWhereInput>;
};

export type DeviceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DeviceOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isPrimary?: InputMaybe<SortOrder>;
  lastSeenAt?: InputMaybe<SortOrderInput>;
  registrations?: InputMaybe<DeviceRegistrationOrderByRelationAggregateInput>;
  uniqueId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type DeviceRegistration = {
  accessGrantId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  deviceId: Scalars['String'];
  id: Scalars['String'];
  vendor: ResourceVendor;
};

export type DeviceRegistrationCreateManyAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deviceId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type DeviceRegistrationCreateManyAccessGrantInputEnvelope = {
  data: Array<DeviceRegistrationCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DeviceRegistrationCreateManyDeviceInput = {
  accessGrantId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type DeviceRegistrationCreateManyDeviceInputEnvelope = {
  data: Array<DeviceRegistrationCreateManyDeviceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type DeviceRegistrationCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DeviceRegistrationCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<DeviceRegistrationCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<DeviceRegistrationCreateManyAccessGrantInputEnvelope>;
};

export type DeviceRegistrationCreateNestedManyWithoutDeviceInput = {
  connect?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DeviceRegistrationCreateOrConnectWithoutDeviceInput>>;
  create?: InputMaybe<Array<DeviceRegistrationCreateWithoutDeviceInput>>;
  createMany?: InputMaybe<DeviceRegistrationCreateManyDeviceInputEnvelope>;
};

export type DeviceRegistrationCreateOrConnectWithoutAccessGrantInput = {
  create: DeviceRegistrationCreateWithoutAccessGrantInput;
  where: DeviceRegistrationWhereUniqueInput;
};

export type DeviceRegistrationCreateOrConnectWithoutDeviceInput = {
  create: DeviceRegistrationCreateWithoutDeviceInput;
  where: DeviceRegistrationWhereUniqueInput;
};

export type DeviceRegistrationCreateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  device: DeviceCreateNestedOneWithoutRegistrationsInput;
  id?: InputMaybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type DeviceRegistrationCreateWithoutDeviceInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutDeviceRegistrationsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type DeviceRegistrationListRelationFilter = {
  every?: InputMaybe<DeviceRegistrationWhereInput>;
  none?: InputMaybe<DeviceRegistrationWhereInput>;
  some?: InputMaybe<DeviceRegistrationWhereInput>;
};

export type DeviceRegistrationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type DeviceRegistrationOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  device?: InputMaybe<DeviceOrderByWithRelationInput>;
  deviceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
};

export enum DeviceRegistrationScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  CreatedAt = 'createdAt',
  DeviceId = 'deviceId',
  Id = 'id',
  Vendor = 'vendor'
}

export type DeviceRegistrationScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<DeviceRegistrationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deviceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<DeviceRegistrationScalarWhereInput>>;
  OR?: InputMaybe<Array<DeviceRegistrationScalarWhereInput>>;
  vendor?: InputMaybe<EnumResourceVendorFilter>;
};

export type DeviceRegistrationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
};

export type DeviceRegistrationUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DeviceRegistrationCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<DeviceRegistrationCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<DeviceRegistrationCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DeviceRegistrationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  set?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  update?: InputMaybe<Array<DeviceRegistrationUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<DeviceRegistrationUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<DeviceRegistrationUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type DeviceRegistrationUpdateManyWithoutDeviceNestedInput = {
  connect?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DeviceRegistrationCreateOrConnectWithoutDeviceInput>>;
  create?: InputMaybe<Array<DeviceRegistrationCreateWithoutDeviceInput>>;
  createMany?: InputMaybe<DeviceRegistrationCreateManyDeviceInputEnvelope>;
  delete?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DeviceRegistrationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  set?: InputMaybe<Array<DeviceRegistrationWhereUniqueInput>>;
  update?: InputMaybe<Array<DeviceRegistrationUpdateWithWhereUniqueWithoutDeviceInput>>;
  updateMany?: InputMaybe<Array<DeviceRegistrationUpdateManyWithWhereWithoutDeviceInput>>;
  upsert?: InputMaybe<Array<DeviceRegistrationUpsertWithWhereUniqueWithoutDeviceInput>>;
};

export type DeviceRegistrationUpdateManyWithWhereWithoutAccessGrantInput = {
  data: DeviceRegistrationUpdateManyMutationInput;
  where: DeviceRegistrationScalarWhereInput;
};

export type DeviceRegistrationUpdateManyWithWhereWithoutDeviceInput = {
  data: DeviceRegistrationUpdateManyMutationInput;
  where: DeviceRegistrationScalarWhereInput;
};

export type DeviceRegistrationUpdateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  device?: InputMaybe<DeviceUpdateOneRequiredWithoutRegistrationsNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
};

export type DeviceRegistrationUpdateWithoutDeviceInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutDeviceRegistrationsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
};

export type DeviceRegistrationUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: DeviceRegistrationUpdateWithoutAccessGrantInput;
  where: DeviceRegistrationWhereUniqueInput;
};

export type DeviceRegistrationUpdateWithWhereUniqueWithoutDeviceInput = {
  data: DeviceRegistrationUpdateWithoutDeviceInput;
  where: DeviceRegistrationWhereUniqueInput;
};

export type DeviceRegistrationUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: DeviceRegistrationCreateWithoutAccessGrantInput;
  update: DeviceRegistrationUpdateWithoutAccessGrantInput;
  where: DeviceRegistrationWhereUniqueInput;
};

export type DeviceRegistrationUpsertWithWhereUniqueWithoutDeviceInput = {
  create: DeviceRegistrationCreateWithoutDeviceInput;
  update: DeviceRegistrationUpdateWithoutDeviceInput;
  where: DeviceRegistrationWhereUniqueInput;
};

export type DeviceRegistrationWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<DeviceRegistrationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  device?: InputMaybe<DeviceRelationFilter>;
  deviceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<DeviceRegistrationWhereInput>>;
  OR?: InputMaybe<Array<DeviceRegistrationWhereInput>>;
  vendor?: InputMaybe<EnumResourceVendorFilter>;
};

export type DeviceRegistrationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type DeviceRelationFilter = {
  is?: InputMaybe<DeviceWhereInput>;
  isNot?: InputMaybe<DeviceWhereInput>;
};

export enum DeviceScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsPrimary = 'isPrimary',
  LastSeenAt = 'lastSeenAt',
  UniqueId = 'uniqueId',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type DeviceScalarWhereInput = {
  AND?: InputMaybe<Array<DeviceScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPrimary?: InputMaybe<BoolFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  NOT?: InputMaybe<Array<DeviceScalarWhereInput>>;
  OR?: InputMaybe<Array<DeviceScalarWhereInput>>;
  uniqueId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type DeviceUniqueIdUserIdCompoundUniqueInput = {
  uniqueId: Scalars['String'];
  userId: Scalars['String'];
};

export type DeviceUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uniqueId?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeviceUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<DeviceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<DeviceCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<DeviceCreateWithoutUserInput>>;
  createMany?: InputMaybe<DeviceCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<DeviceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<DeviceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<DeviceWhereUniqueInput>>;
  set?: InputMaybe<Array<DeviceWhereUniqueInput>>;
  update?: InputMaybe<Array<DeviceUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<DeviceUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<DeviceUpsertWithWhereUniqueWithoutUserInput>>;
};

export type DeviceUpdateManyWithWhereWithoutUserInput = {
  data: DeviceUpdateManyMutationInput;
  where: DeviceScalarWhereInput;
};

export type DeviceUpdateOneRequiredWithoutRegistrationsNestedInput = {
  connect?: InputMaybe<DeviceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<DeviceCreateOrConnectWithoutRegistrationsInput>;
  create?: InputMaybe<DeviceCreateWithoutRegistrationsInput>;
  update?: InputMaybe<DeviceUpdateWithoutRegistrationsInput>;
  upsert?: InputMaybe<DeviceUpsertWithoutRegistrationsInput>;
};

export type DeviceUpdateWithoutRegistrationsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  uniqueId?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutDevicesNestedInput>;
};

export type DeviceUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isPrimary?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  registrations?: InputMaybe<DeviceRegistrationUpdateManyWithoutDeviceNestedInput>;
  uniqueId?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type DeviceUpdateWithWhereUniqueWithoutUserInput = {
  data: DeviceUpdateWithoutUserInput;
  where: DeviceWhereUniqueInput;
};

export type DeviceUpsertWithoutRegistrationsInput = {
  create: DeviceCreateWithoutRegistrationsInput;
  update: DeviceUpdateWithoutRegistrationsInput;
};

export type DeviceUpsertWithWhereUniqueWithoutUserInput = {
  create: DeviceCreateWithoutUserInput;
  update: DeviceUpdateWithoutUserInput;
  where: DeviceWhereUniqueInput;
};

export type DeviceWhereInput = {
  AND?: InputMaybe<Array<DeviceWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isPrimary?: InputMaybe<BoolFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  NOT?: InputMaybe<Array<DeviceWhereInput>>;
  OR?: InputMaybe<Array<DeviceWhereInput>>;
  registrations?: InputMaybe<DeviceRegistrationListRelationFilter>;
  uniqueId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type DeviceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  uniqueId_userId?: InputMaybe<DeviceUniqueIdUserIdCompoundUniqueInput>;
};

export type DisableKeyGeneration = {
  card?: Maybe<Scalars['Boolean']>;
  mobile?: Maybe<Scalars['Boolean']>;
  wristband?: Maybe<Scalars['Boolean']>;
};

export type DispenseKeySettingAnswer = {
  maxKeys?: Maybe<Scalars['Float']>;
  numKeysDispensed?: Maybe<Scalars['Float']>;
};

export type DispenserConfigInput = {
  dispenserType?: InputMaybe<DispenserType>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  serial?: InputMaybe<Scalars['String']>;
  usage?: InputMaybe<Scalars['String']>;
};

export enum DispenserType {
  F1_1000 = 'F1_1000',
  F3_1000 = 'F3_1000',
  LemurX = 'LEMUR_X'
}

export type DormakabaGenerateLegicTokenResponse = {
  token?: Maybe<Scalars['String']>;
};

export type DormakabaGenerateMobileKeyResponse = {
  success: Scalars['Boolean'];
  uidOnLocation: Scalars['String'];
};

export type DownloadCsvAnswer = {
  data: Scalars['String'];
};

export type DynamicUserDetails = {
  userDetails: Scalars['String'];
};

export type DynamicUserDetailsConfigJson = {
  dataFromExternalApi: Scalars['String'];
  dataFromVirdee: Scalars['String'];
  dynamicUserDetailsFields: Array<DynamicUserDetailsFieldsR>;
};

export type DynamicUserDetailsFieldsR = {
  description?: Maybe<Scalars['Boolean']>;
  form: DynamicUserDetailsFormR;
  key: Scalars['String'];
  label: Scalars['String'];
  mrzDataKeyMap: Scalars['String'];
  permission: Scalars['String'];
  required: Scalars['String'];
  shouldSave: Scalars['Boolean'];
  shouldSend: Scalars['Boolean'];
};

export type DynamicUserDetailsFormR = {
  default?: Maybe<Scalars['String']>;
  length?: Maybe<Scalars['Float']>;
  options?: Maybe<Array<Option>>;
  type: Scalars['String'];
};

export type EarlyCheckInConfig = {
  allowEarlyCheckIn: Scalars['Boolean'];
  checkInGracePeriod?: Maybe<Scalars['Float']>;
};

export type EarlyCheckInConfigInput = {
  allowEarlyCheckIn: Scalars['Boolean'];
  checkInGracePeriod?: InputMaybe<Scalars['Float']>;
};

export type EarlyCheckInPackage = {
  endTime?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  freeUpgrade?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  loyaltyCodes?: Maybe<Array<Scalars['String']>>;
  price?: Maybe<Scalars['Float']>;
  serviceId: Scalars['String'];
  startTime?: Maybe<Scalars['String']>;
};

export type EarlyCheckInPackageInput = {
  endTime?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  freeUpgrade?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  loyaltyCodes?: InputMaybe<Array<Scalars['String']>>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type EarlyCheckInPackageOffer = {
  freeUpgrade: Scalars['Boolean'];
  package?: Maybe<EarlyCheckInPackageOfferDetail>;
  roomAssigned: Scalars['Boolean'];
  roomsAvailable?: Maybe<Scalars['Float']>;
  shouldOffer: Scalars['Boolean'];
};

export type EarlyCheckInPackageOfferDetail = {
  externalId: Scalars['String'];
  price: Scalars['Float'];
  serviceId: Scalars['String'];
};

export type EligibleAccessGrantResponse = {
  credential?: Maybe<AccessGrantAuthCredentials>;
  eligible: Scalars['Boolean'];
  requirements?: Maybe<Array<Requirement>>;
};

export type EmitKeyDispensedEventInput = {
  accessGrantId: Scalars['String'];
  dispenserSerialNumber?: InputMaybe<Scalars['String']>;
  hasPaymentCapabilities?: InputMaybe<Scalars['Boolean']>;
  hasRoomAccess?: InputMaybe<Scalars['Boolean']>;
  keySerialNumber: Scalars['String'];
  keyType: Scalars['String'];
  origin: Scalars['String'];
  status: Scalars['String'];
  virdeeError?: InputMaybe<Scalars['String']>;
  wristbandUsage?: InputMaybe<Scalars['String']>;
};

export enum EntityType {
  AccessGrant = 'ACCESS_GRANT',
  Kiosk = 'KIOSK',
  Location = 'LOCATION',
  Requirement = 'REQUIREMENT',
  System = 'SYSTEM',
  Tenant = 'TENANT',
  UnitType = 'UNIT_TYPE'
}

export type EnumAccessGrantStateNullableFilter = {
  equals?: InputMaybe<AccessGrantState>;
  in?: InputMaybe<Array<AccessGrantState>>;
  not?: InputMaybe<NestedEnumAccessGrantStateNullableFilter>;
  notIn?: InputMaybe<Array<AccessGrantState>>;
};

export type EnumAccessGrantStateNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAccessGrantStateNullableFilter>;
  _min?: InputMaybe<NestedEnumAccessGrantStateNullableFilter>;
  equals?: InputMaybe<AccessGrantState>;
  in?: InputMaybe<Array<AccessGrantState>>;
  not?: InputMaybe<NestedEnumAccessGrantStateNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AccessGrantState>>;
};

export type EnumAccessGrantStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<AccessGrantStatus>;
};

export type EnumAccessGrantStatusFilter = {
  equals?: InputMaybe<AccessGrantStatus>;
  in?: InputMaybe<Array<AccessGrantStatus>>;
  not?: InputMaybe<NestedEnumAccessGrantStatusFilter>;
  notIn?: InputMaybe<Array<AccessGrantStatus>>;
};

export type EnumAccessGrantStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAccessGrantStatusFilter>;
  _min?: InputMaybe<NestedEnumAccessGrantStatusFilter>;
  equals?: InputMaybe<AccessGrantStatus>;
  in?: InputMaybe<Array<AccessGrantStatus>>;
  not?: InputMaybe<NestedEnumAccessGrantStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AccessGrantStatus>>;
};

export type EnumAccessGrantTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<AccessGrantType>;
};

export type EnumAccessGrantTypeFilter = {
  equals?: InputMaybe<AccessGrantType>;
  in?: InputMaybe<Array<AccessGrantType>>;
  not?: InputMaybe<NestedEnumAccessGrantTypeFilter>;
  notIn?: InputMaybe<Array<AccessGrantType>>;
};

export type EnumAccessGrantTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAccessGrantTypeFilter>;
  _min?: InputMaybe<NestedEnumAccessGrantTypeFilter>;
  equals?: InputMaybe<AccessGrantType>;
  in?: InputMaybe<Array<AccessGrantType>>;
  not?: InputMaybe<NestedEnumAccessGrantTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AccessGrantType>>;
};

export type EnumApiCallStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ApiCallStatus>;
};

export type EnumApiCallStatusFilter = {
  equals?: InputMaybe<ApiCallStatus>;
  in?: InputMaybe<Array<ApiCallStatus>>;
  not?: InputMaybe<NestedEnumApiCallStatusFilter>;
  notIn?: InputMaybe<Array<ApiCallStatus>>;
};

export type EnumAssaCardTypeNullableFilter = {
  equals?: InputMaybe<AssaCardType>;
  in?: InputMaybe<Array<AssaCardType>>;
  not?: InputMaybe<NestedEnumAssaCardTypeNullableFilter>;
  notIn?: InputMaybe<Array<AssaCardType>>;
};

export type EnumAssaCardTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAssaCardTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumAssaCardTypeNullableFilter>;
  equals?: InputMaybe<AssaCardType>;
  in?: InputMaybe<Array<AssaCardType>>;
  not?: InputMaybe<NestedEnumAssaCardTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AssaCardType>>;
};

export type EnumCallStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<CallStatus>;
};

export type EnumCallStatusFilter = {
  equals?: InputMaybe<CallStatus>;
  in?: InputMaybe<Array<CallStatus>>;
  not?: InputMaybe<NestedEnumCallStatusFilter>;
  notIn?: InputMaybe<Array<CallStatus>>;
};

export type EnumCallStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCallStatusFilter>;
  _min?: InputMaybe<NestedEnumCallStatusFilter>;
  equals?: InputMaybe<CallStatus>;
  in?: InputMaybe<Array<CallStatus>>;
  not?: InputMaybe<NestedEnumCallStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CallStatus>>;
};

export type EnumCallTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CallType>;
};

export type EnumCallTypeFilter = {
  equals?: InputMaybe<CallType>;
  in?: InputMaybe<Array<CallType>>;
  not?: InputMaybe<NestedEnumCallTypeFilter>;
  notIn?: InputMaybe<Array<CallType>>;
};

export type EnumCallTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCallTypeFilter>;
  _min?: InputMaybe<NestedEnumCallTypeFilter>;
  equals?: InputMaybe<CallType>;
  in?: InputMaybe<Array<CallType>>;
  not?: InputMaybe<NestedEnumCallTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CallType>>;
};

export type EnumCharacteristicCategoryFieldUpdateOperationsInput = {
  set?: InputMaybe<CharacteristicCategory>;
};

export type EnumCharacteristicCategoryFilter = {
  equals?: InputMaybe<CharacteristicCategory>;
  in?: InputMaybe<Array<CharacteristicCategory>>;
  not?: InputMaybe<NestedEnumCharacteristicCategoryFilter>;
  notIn?: InputMaybe<Array<CharacteristicCategory>>;
};

export type EnumCharacteristicRuleTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CharacteristicRuleType>;
};

export type EnumCharacteristicRuleTypeFilter = {
  equals?: InputMaybe<CharacteristicRuleType>;
  in?: InputMaybe<Array<CharacteristicRuleType>>;
  not?: InputMaybe<NestedEnumCharacteristicRuleTypeFilter>;
  notIn?: InputMaybe<Array<CharacteristicRuleType>>;
};

export type EnumChargingStateNullableFilter = {
  equals?: InputMaybe<ChargingState>;
  in?: InputMaybe<Array<ChargingState>>;
  not?: InputMaybe<NestedEnumChargingStateNullableFilter>;
  notIn?: InputMaybe<Array<ChargingState>>;
};

export type EnumChargingStateNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumChargingStateNullableFilter>;
  _min?: InputMaybe<NestedEnumChargingStateNullableFilter>;
  equals?: InputMaybe<ChargingState>;
  in?: InputMaybe<Array<ChargingState>>;
  not?: InputMaybe<NestedEnumChargingStateNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ChargingState>>;
};

export type EnumCredentialTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CredentialType>;
};

export type EnumCredentialTypeFilter = {
  equals?: InputMaybe<CredentialType>;
  in?: InputMaybe<Array<CredentialType>>;
  not?: InputMaybe<NestedEnumCredentialTypeFilter>;
  notIn?: InputMaybe<Array<CredentialType>>;
};

export type EnumCredentialTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCredentialTypeFilter>;
  _min?: InputMaybe<NestedEnumCredentialTypeFilter>;
  equals?: InputMaybe<CredentialType>;
  in?: InputMaybe<Array<CredentialType>>;
  not?: InputMaybe<NestedEnumCredentialTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CredentialType>>;
};

export type EnumCreditCardTypeNullableFilter = {
  equals?: InputMaybe<CreditCardType>;
  in?: InputMaybe<Array<CreditCardType>>;
  not?: InputMaybe<NestedEnumCreditCardTypeNullableFilter>;
  notIn?: InputMaybe<Array<CreditCardType>>;
};

export type EnumCreditCardTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCreditCardTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumCreditCardTypeNullableFilter>;
  equals?: InputMaybe<CreditCardType>;
  in?: InputMaybe<Array<CreditCardType>>;
  not?: InputMaybe<NestedEnumCreditCardTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CreditCardType>>;
};

export type EnumDispenserTypeNullableFilter = {
  equals?: InputMaybe<DispenserType>;
  in?: InputMaybe<Array<DispenserType>>;
  not?: InputMaybe<NestedEnumDispenserTypeNullableFilter>;
  notIn?: InputMaybe<Array<DispenserType>>;
};

export type EnumDispenserTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDispenserTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDispenserTypeNullableFilter>;
  equals?: InputMaybe<DispenserType>;
  in?: InputMaybe<Array<DispenserType>>;
  not?: InputMaybe<NestedEnumDispenserTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DispenserType>>;
};

export type EnumEntityTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<EntityType>;
};

export type EnumEntityTypeFilter = {
  equals?: InputMaybe<EntityType>;
  in?: InputMaybe<Array<EntityType>>;
  not?: InputMaybe<NestedEnumEntityTypeFilter>;
  notIn?: InputMaybe<Array<EntityType>>;
};

export type EnumEntityTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEntityTypeFilter>;
  _min?: InputMaybe<NestedEnumEntityTypeFilter>;
  equals?: InputMaybe<EntityType>;
  in?: InputMaybe<Array<EntityType>>;
  not?: InputMaybe<NestedEnumEntityTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<EntityType>>;
};

export type EnumFileStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<FileStatus>;
};

export type EnumFileStatusFilter = {
  equals?: InputMaybe<FileStatus>;
  in?: InputMaybe<Array<FileStatus>>;
  not?: InputMaybe<NestedEnumFileStatusFilter>;
  notIn?: InputMaybe<Array<FileStatus>>;
};

export type EnumFileTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<FileType>;
};

export type EnumFileTypeFilter = {
  equals?: InputMaybe<FileType>;
  in?: InputMaybe<Array<FileType>>;
  not?: InputMaybe<NestedEnumFileTypeFilter>;
  notIn?: InputMaybe<Array<FileType>>;
};

export type EnumIdVerificationFieldUpdateOperationsInput = {
  set?: InputMaybe<IdVerification>;
};

export type EnumIdVerificationFilter = {
  equals?: InputMaybe<IdVerification>;
  in?: InputMaybe<Array<IdVerification>>;
  not?: InputMaybe<NestedEnumIdVerificationFilter>;
  notIn?: InputMaybe<Array<IdVerification>>;
};

export type EnumIdVerificationResultStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<IdVerificationResultStatus>;
};

export type EnumIdVerificationResultStatusFilter = {
  equals?: InputMaybe<IdVerificationResultStatus>;
  in?: InputMaybe<Array<IdVerificationResultStatus>>;
  not?: InputMaybe<NestedEnumIdVerificationResultStatusFilter>;
  notIn?: InputMaybe<Array<IdVerificationResultStatus>>;
};

export type EnumIdVerificationWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumIdVerificationFilter>;
  _min?: InputMaybe<NestedEnumIdVerificationFilter>;
  equals?: InputMaybe<IdVerification>;
  in?: InputMaybe<Array<IdVerification>>;
  not?: InputMaybe<NestedEnumIdVerificationWithAggregatesFilter>;
  notIn?: InputMaybe<Array<IdVerification>>;
};

export type EnumInfoContentTypeNullableFilter = {
  equals?: InputMaybe<InfoContentType>;
  in?: InputMaybe<Array<InfoContentType>>;
  not?: InputMaybe<NestedEnumInfoContentTypeNullableFilter>;
  notIn?: InputMaybe<Array<InfoContentType>>;
};

export type EnumInfoContentTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumInfoContentTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumInfoContentTypeNullableFilter>;
  equals?: InputMaybe<InfoContentType>;
  in?: InputMaybe<Array<InfoContentType>>;
  not?: InputMaybe<NestedEnumInfoContentTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InfoContentType>>;
};

export type EnumInfoTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<InfoType>;
};

export type EnumInfoTypeFilter = {
  equals?: InputMaybe<InfoType>;
  in?: InputMaybe<Array<InfoType>>;
  not?: InputMaybe<NestedEnumInfoTypeFilter>;
  notIn?: InputMaybe<Array<InfoType>>;
};

export type EnumInfoTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumInfoTypeFilter>;
  _min?: InputMaybe<NestedEnumInfoTypeFilter>;
  equals?: InputMaybe<InfoType>;
  in?: InputMaybe<Array<InfoType>>;
  not?: InputMaybe<NestedEnumInfoTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InfoType>>;
};

export type EnumInternalApiKeyTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<InternalApiKeyType>;
};

export type EnumInternalApiKeyTypeFilter = {
  equals?: InputMaybe<InternalApiKeyType>;
  in?: InputMaybe<Array<InternalApiKeyType>>;
  not?: InputMaybe<NestedEnumInternalApiKeyTypeFilter>;
  notIn?: InputMaybe<Array<InternalApiKeyType>>;
};

export type EnumKeycardOriginNullableFilter = {
  equals?: InputMaybe<KeycardOrigin>;
  in?: InputMaybe<Array<KeycardOrigin>>;
  not?: InputMaybe<NestedEnumKeycardOriginNullableFilter>;
  notIn?: InputMaybe<Array<KeycardOrigin>>;
};

export type EnumKeycardOriginNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumKeycardOriginNullableFilter>;
  _min?: InputMaybe<NestedEnumKeycardOriginNullableFilter>;
  equals?: InputMaybe<KeycardOrigin>;
  in?: InputMaybe<Array<KeycardOrigin>>;
  not?: InputMaybe<NestedEnumKeycardOriginNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<KeycardOrigin>>;
};

export type EnumLoyaltyTypeNullableFilter = {
  equals?: InputMaybe<LoyaltyType>;
  in?: InputMaybe<Array<LoyaltyType>>;
  not?: InputMaybe<NestedEnumLoyaltyTypeNullableFilter>;
  notIn?: InputMaybe<Array<LoyaltyType>>;
};

export type EnumLoyaltyTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumLoyaltyTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumLoyaltyTypeNullableFilter>;
  equals?: InputMaybe<LoyaltyType>;
  in?: InputMaybe<Array<LoyaltyType>>;
  not?: InputMaybe<NestedEnumLoyaltyTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LoyaltyType>>;
};

export type EnumNotificationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<NotificationStatus>;
};

export type EnumNotificationStatusFilter = {
  equals?: InputMaybe<NotificationStatus>;
  in?: InputMaybe<Array<NotificationStatus>>;
  not?: InputMaybe<NestedEnumNotificationStatusFilter>;
  notIn?: InputMaybe<Array<NotificationStatus>>;
};

export type EnumNotificationTransportFieldUpdateOperationsInput = {
  set?: InputMaybe<NotificationTransport>;
};

export type EnumNotificationTransportFilter = {
  equals?: InputMaybe<NotificationTransport>;
  in?: InputMaybe<Array<NotificationTransport>>;
  not?: InputMaybe<NestedEnumNotificationTransportFilter>;
  notIn?: InputMaybe<Array<NotificationTransport>>;
};

export type EnumNotificationTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<NotificationType>;
};

export type EnumNotificationTypeFilter = {
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type EnumOriginTypeNullableFilter = {
  equals?: InputMaybe<OriginType>;
  in?: InputMaybe<Array<OriginType>>;
  not?: InputMaybe<NestedEnumOriginTypeNullableFilter>;
  notIn?: InputMaybe<Array<OriginType>>;
};

export type EnumOriginTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumOriginTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumOriginTypeNullableFilter>;
  equals?: InputMaybe<OriginType>;
  in?: InputMaybe<Array<OriginType>>;
  not?: InputMaybe<NestedEnumOriginTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<OriginType>>;
};

export type EnumPaymentProviderTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentProviderType>;
};

export type EnumPaymentProviderTypeFilter = {
  equals?: InputMaybe<PaymentProviderType>;
  in?: InputMaybe<Array<PaymentProviderType>>;
  not?: InputMaybe<NestedEnumPaymentProviderTypeFilter>;
  notIn?: InputMaybe<Array<PaymentProviderType>>;
};

export type EnumPaymentProviderTypeNullableFilter = {
  equals?: InputMaybe<PaymentProviderType>;
  in?: InputMaybe<Array<PaymentProviderType>>;
  not?: InputMaybe<NestedEnumPaymentProviderTypeNullableFilter>;
  notIn?: InputMaybe<Array<PaymentProviderType>>;
};

export type EnumPaymentProviderTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPaymentProviderTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumPaymentProviderTypeNullableFilter>;
  equals?: InputMaybe<PaymentProviderType>;
  in?: InputMaybe<Array<PaymentProviderType>>;
  not?: InputMaybe<NestedEnumPaymentProviderTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentProviderType>>;
};

export type EnumPaymentProviderTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentProviderTypeFilter>;
  _min?: InputMaybe<NestedEnumPaymentProviderTypeFilter>;
  equals?: InputMaybe<PaymentProviderType>;
  in?: InputMaybe<Array<PaymentProviderType>>;
  not?: InputMaybe<NestedEnumPaymentProviderTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentProviderType>>;
};

export type EnumPaymentTransactionStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentTransactionStatus>;
};

export type EnumPaymentTransactionStatusFilter = {
  equals?: InputMaybe<PaymentTransactionStatus>;
  in?: InputMaybe<Array<PaymentTransactionStatus>>;
  not?: InputMaybe<NestedEnumPaymentTransactionStatusFilter>;
  notIn?: InputMaybe<Array<PaymentTransactionStatus>>;
};

export type EnumPaymentTransactionStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentTransactionStatusFilter>;
  _min?: InputMaybe<NestedEnumPaymentTransactionStatusFilter>;
  equals?: InputMaybe<PaymentTransactionStatus>;
  in?: InputMaybe<Array<PaymentTransactionStatus>>;
  not?: InputMaybe<NestedEnumPaymentTransactionStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentTransactionStatus>>;
};

export type EnumPaymentTypeNullableFilter = {
  equals?: InputMaybe<PaymentType>;
  in?: InputMaybe<Array<PaymentType>>;
  not?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
  notIn?: InputMaybe<Array<PaymentType>>;
};

export type EnumPaymentTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
  equals?: InputMaybe<PaymentType>;
  in?: InputMaybe<Array<PaymentType>>;
  not?: InputMaybe<NestedEnumPaymentTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentType>>;
};

export type EnumPaymentVerificationStatusNullableFilter = {
  equals?: InputMaybe<PaymentVerificationStatus>;
  in?: InputMaybe<Array<PaymentVerificationStatus>>;
  not?: InputMaybe<NestedEnumPaymentVerificationStatusNullableFilter>;
  notIn?: InputMaybe<Array<PaymentVerificationStatus>>;
};

export type EnumPaymentVerificationStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPaymentVerificationStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumPaymentVerificationStatusNullableFilter>;
  equals?: InputMaybe<PaymentVerificationStatus>;
  in?: InputMaybe<Array<PaymentVerificationStatus>>;
  not?: InputMaybe<NestedEnumPaymentVerificationStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentVerificationStatus>>;
};

export type EnumPmsTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PmsType>;
};

export type EnumPmsTypeFilter = {
  equals?: InputMaybe<PmsType>;
  in?: InputMaybe<Array<PmsType>>;
  not?: InputMaybe<NestedEnumPmsTypeFilter>;
  notIn?: InputMaybe<Array<PmsType>>;
};

export type EnumPmsTypeNullableFilter = {
  equals?: InputMaybe<PmsType>;
  in?: InputMaybe<Array<PmsType>>;
  not?: InputMaybe<NestedEnumPmsTypeNullableFilter>;
  notIn?: InputMaybe<Array<PmsType>>;
};

export type EnumPmsTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPmsTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumPmsTypeNullableFilter>;
  equals?: InputMaybe<PmsType>;
  in?: InputMaybe<Array<PmsType>>;
  not?: InputMaybe<NestedEnumPmsTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PmsType>>;
};

export type EnumRequirementStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<RequirementStatus>;
};

export type EnumRequirementStatusFilter = {
  equals?: InputMaybe<RequirementStatus>;
  in?: InputMaybe<Array<RequirementStatus>>;
  not?: InputMaybe<NestedEnumRequirementStatusFilter>;
  notIn?: InputMaybe<Array<RequirementStatus>>;
};

export type EnumRequirementStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRequirementStatusFilter>;
  _min?: InputMaybe<NestedEnumRequirementStatusFilter>;
  equals?: InputMaybe<RequirementStatus>;
  in?: InputMaybe<Array<RequirementStatus>>;
  not?: InputMaybe<NestedEnumRequirementStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<RequirementStatus>>;
};

export type EnumRequirementTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<RequirementType>;
};

export type EnumRequirementTypeFilter = {
  equals?: InputMaybe<RequirementType>;
  in?: InputMaybe<Array<RequirementType>>;
  not?: InputMaybe<NestedEnumRequirementTypeFilter>;
  notIn?: InputMaybe<Array<RequirementType>>;
};

export type EnumRequirementTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRequirementTypeFilter>;
  _min?: InputMaybe<NestedEnumRequirementTypeFilter>;
  equals?: InputMaybe<RequirementType>;
  in?: InputMaybe<Array<RequirementType>>;
  not?: InputMaybe<NestedEnumRequirementTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<RequirementType>>;
};

export type EnumResourceControlTypeNullableFilter = {
  equals?: InputMaybe<ResourceControlType>;
  in?: InputMaybe<Array<ResourceControlType>>;
  not?: InputMaybe<NestedEnumResourceControlTypeNullableFilter>;
  notIn?: InputMaybe<Array<ResourceControlType>>;
};

export type EnumResourceControlTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumResourceControlTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumResourceControlTypeNullableFilter>;
  equals?: InputMaybe<ResourceControlType>;
  in?: InputMaybe<Array<ResourceControlType>>;
  not?: InputMaybe<NestedEnumResourceControlTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ResourceControlType>>;
};

export type EnumResourceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ResourceType>;
};

export type EnumResourceTypeFilter = {
  equals?: InputMaybe<ResourceType>;
  in?: InputMaybe<Array<ResourceType>>;
  not?: InputMaybe<NestedEnumResourceTypeFilter>;
  notIn?: InputMaybe<Array<ResourceType>>;
};

export type EnumResourceTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumResourceTypeFilter>;
  _min?: InputMaybe<NestedEnumResourceTypeFilter>;
  equals?: InputMaybe<ResourceType>;
  in?: InputMaybe<Array<ResourceType>>;
  not?: InputMaybe<NestedEnumResourceTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ResourceType>>;
};

export type EnumResourceVendorFieldUpdateOperationsInput = {
  set?: InputMaybe<ResourceVendor>;
};

export type EnumResourceVendorFilter = {
  equals?: InputMaybe<ResourceVendor>;
  in?: InputMaybe<Array<ResourceVendor>>;
  not?: InputMaybe<NestedEnumResourceVendorFilter>;
  notIn?: InputMaybe<Array<ResourceVendor>>;
};

export type EnumResourceVendorWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumResourceVendorFilter>;
  _min?: InputMaybe<NestedEnumResourceVendorFilter>;
  equals?: InputMaybe<ResourceVendor>;
  in?: InputMaybe<Array<ResourceVendor>>;
  not?: InputMaybe<NestedEnumResourceVendorWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ResourceVendor>>;
};

export type EnumRetryCheckinStatusNullableFilter = {
  equals?: InputMaybe<RetryCheckinStatus>;
  in?: InputMaybe<Array<RetryCheckinStatus>>;
  not?: InputMaybe<NestedEnumRetryCheckinStatusNullableFilter>;
  notIn?: InputMaybe<Array<RetryCheckinStatus>>;
};

export type EnumRetryCheckinStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumRetryCheckinStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumRetryCheckinStatusNullableFilter>;
  equals?: InputMaybe<RetryCheckinStatus>;
  in?: InputMaybe<Array<RetryCheckinStatus>>;
  not?: InputMaybe<NestedEnumRetryCheckinStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<RetryCheckinStatus>>;
};

export type EnumRfidTagTypeNullableFilter = {
  equals?: InputMaybe<RfidTagType>;
  in?: InputMaybe<Array<RfidTagType>>;
  not?: InputMaybe<NestedEnumRfidTagTypeNullableFilter>;
  notIn?: InputMaybe<Array<RfidTagType>>;
};

export type EnumRfidTagTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumRfidTagTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumRfidTagTypeNullableFilter>;
  equals?: InputMaybe<RfidTagType>;
  in?: InputMaybe<Array<RfidTagType>>;
  not?: InputMaybe<NestedEnumRfidTagTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<RfidTagType>>;
};

export type EnumRoleFieldUpdateOperationsInput = {
  set?: InputMaybe<Role>;
};

export type EnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type EnumSecurityDepositPolicyFieldUpdateOperationsInput = {
  set?: InputMaybe<SecurityDepositPolicy>;
};

export type EnumSecurityDepositPolicyFilter = {
  equals?: InputMaybe<SecurityDepositPolicy>;
  in?: InputMaybe<Array<SecurityDepositPolicy>>;
  not?: InputMaybe<NestedEnumSecurityDepositPolicyFilter>;
  notIn?: InputMaybe<Array<SecurityDepositPolicy>>;
};

export type EnumSecurityDepositPolicyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumSecurityDepositPolicyFilter>;
  _min?: InputMaybe<NestedEnumSecurityDepositPolicyFilter>;
  equals?: InputMaybe<SecurityDepositPolicy>;
  in?: InputMaybe<Array<SecurityDepositPolicy>>;
  not?: InputMaybe<NestedEnumSecurityDepositPolicyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<SecurityDepositPolicy>>;
};

export type EnumServiceRequestStatusNullableFilter = {
  equals?: InputMaybe<ServiceRequestStatus>;
  in?: InputMaybe<Array<ServiceRequestStatus>>;
  not?: InputMaybe<NestedEnumServiceRequestStatusNullableFilter>;
  notIn?: InputMaybe<Array<ServiceRequestStatus>>;
};

export type EnumServiceRequestStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumServiceRequestStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumServiceRequestStatusNullableFilter>;
  equals?: InputMaybe<ServiceRequestStatus>;
  in?: InputMaybe<Array<ServiceRequestStatus>>;
  not?: InputMaybe<NestedEnumServiceRequestStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ServiceRequestStatus>>;
};

export type EnumServiceRuleTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ServiceRuleType>;
};

export type EnumServiceRuleTypeFilter = {
  equals?: InputMaybe<ServiceRuleType>;
  in?: InputMaybe<Array<ServiceRuleType>>;
  not?: InputMaybe<NestedEnumServiceRuleTypeFilter>;
  notIn?: InputMaybe<Array<ServiceRuleType>>;
};

export type EnumServiceStatusNullableFilter = {
  equals?: InputMaybe<ServiceStatus>;
  in?: InputMaybe<Array<ServiceStatus>>;
  not?: InputMaybe<NestedEnumServiceStatusNullableFilter>;
  notIn?: InputMaybe<Array<ServiceStatus>>;
};

export type EnumServiceStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumServiceStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumServiceStatusNullableFilter>;
  equals?: InputMaybe<ServiceStatus>;
  in?: InputMaybe<Array<ServiceStatus>>;
  not?: InputMaybe<NestedEnumServiceStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ServiceStatus>>;
};

export type EnumServiceTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ServiceType>;
};

export type EnumServiceTypeFilter = {
  equals?: InputMaybe<ServiceType>;
  in?: InputMaybe<Array<ServiceType>>;
  not?: InputMaybe<NestedEnumServiceTypeFilter>;
  notIn?: InputMaybe<Array<ServiceType>>;
};

export type EnumServiceTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumServiceTypeFilter>;
  _min?: InputMaybe<NestedEnumServiceTypeFilter>;
  equals?: InputMaybe<ServiceType>;
  in?: InputMaybe<Array<ServiceType>>;
  not?: InputMaybe<NestedEnumServiceTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ServiceType>>;
};

export type EnumUserRecordTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<UserRecordType>;
};

export type EnumUserRecordTypeFilter = {
  equals?: InputMaybe<UserRecordType>;
  in?: InputMaybe<Array<UserRecordType>>;
  not?: InputMaybe<NestedEnumUserRecordTypeFilter>;
  notIn?: InputMaybe<Array<UserRecordType>>;
};

export type EnumUserRecordTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUserRecordTypeFilter>;
  _min?: InputMaybe<NestedEnumUserRecordTypeFilter>;
  equals?: InputMaybe<UserRecordType>;
  in?: InputMaybe<Array<UserRecordType>>;
  not?: InputMaybe<NestedEnumUserRecordTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UserRecordType>>;
};

export type File = {
  _count?: Maybe<FileCount>;
  createdAt: Scalars['DateTime'];
  deletedAt?: Maybe<Scalars['DateTime']>;
  FileToEntity: Array<FileToEntity>;
  fileType: FileType;
  id: Scalars['String'];
  status: FileStatus;
  updatedAt: Scalars['DateTime'];
  url: Scalars['String'];
};


export type FileFileToEntityArgs = {
  cursor?: InputMaybe<FileToEntityWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileToEntityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileToEntityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileToEntityWhereInput>;
};

export type FileCount = {
  FileToEntity: Scalars['Int'];
};


export type FileCountFileToEntityArgs = {
  where?: InputMaybe<FileToEntityWhereInput>;
};

export type FileCreateNestedOneWithoutFileToEntityInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutFileToEntityInput>;
  create?: InputMaybe<FileCreateWithoutFileToEntityInput>;
};

export type FileCreateOrConnectWithoutFileToEntityInput = {
  create: FileCreateWithoutFileToEntityInput;
  where: FileWhereUniqueInput;
};

export type FileCreateWithoutFileToEntityInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  deletedAt?: InputMaybe<Scalars['DateTime']>;
  fileType: FileType;
  id?: InputMaybe<Scalars['String']>;
  status: FileStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  url: Scalars['String'];
};

export type FileOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  deletedAt?: InputMaybe<SortOrderInput>;
  FileToEntity?: InputMaybe<FileToEntityOrderByRelationAggregateInput>;
  fileType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  url?: InputMaybe<SortOrder>;
};

export type FileRelationFilter = {
  is?: InputMaybe<FileWhereInput>;
  isNot?: InputMaybe<FileWhereInput>;
};

export enum FileStatus {
  Active = 'ACTIVE',
  Deleted = 'DELETED'
}

export type FileToEntity = {
  entityId: Scalars['String'];
  entityType: EntityType;
  file: File;
  fileId: Scalars['String'];
  id: Scalars['String'];
  Requirement?: Maybe<Requirement>;
  requirementId?: Maybe<Scalars['String']>;
  UserAccessGrantRequirement?: Maybe<UserAccessGrantRequirement>;
  userAccessGrantRequirementId?: Maybe<Scalars['String']>;
};

export type FileToEntityCountAggregate = {
  _all: Scalars['Int'];
  entityId: Scalars['Int'];
  entityType: Scalars['Int'];
  fileId: Scalars['Int'];
  id: Scalars['Int'];
  requirementId: Scalars['Int'];
  userAccessGrantRequirementId: Scalars['Int'];
};

export type FileToEntityCountOrderByAggregateInput = {
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  requirementId?: InputMaybe<SortOrder>;
  userAccessGrantRequirementId?: InputMaybe<SortOrder>;
};

export type FileToEntityCreateInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  file: FileCreateNestedOneWithoutFileToEntityInput;
  id?: InputMaybe<Scalars['String']>;
  Requirement?: InputMaybe<RequirementCreateNestedOneWithoutFilesInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedOneWithoutFilesInput>;
};

export type FileToEntityCreateManyInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  fileId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  requirementId?: InputMaybe<Scalars['String']>;
  userAccessGrantRequirementId?: InputMaybe<Scalars['String']>;
};

export type FileToEntityCreateManyRequirementInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  fileId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  userAccessGrantRequirementId?: InputMaybe<Scalars['String']>;
};

export type FileToEntityCreateManyRequirementInputEnvelope = {
  data: Array<FileToEntityCreateManyRequirementInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FileToEntityCreateManyUserAccessGrantRequirementInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  fileId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  requirementId?: InputMaybe<Scalars['String']>;
};

export type FileToEntityCreateManyUserAccessGrantRequirementInputEnvelope = {
  data: Array<FileToEntityCreateManyUserAccessGrantRequirementInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type FileToEntityCreateNestedManyWithoutRequirementInput = {
  connect?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileToEntityCreateOrConnectWithoutRequirementInput>>;
  create?: InputMaybe<Array<FileToEntityCreateWithoutRequirementInput>>;
  createMany?: InputMaybe<FileToEntityCreateManyRequirementInputEnvelope>;
};

export type FileToEntityCreateNestedManyWithoutUserAccessGrantRequirementInput = {
  connect?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileToEntityCreateOrConnectWithoutUserAccessGrantRequirementInput>>;
  create?: InputMaybe<Array<FileToEntityCreateWithoutUserAccessGrantRequirementInput>>;
  createMany?: InputMaybe<FileToEntityCreateManyUserAccessGrantRequirementInputEnvelope>;
};

export type FileToEntityCreateOrConnectWithoutRequirementInput = {
  create: FileToEntityCreateWithoutRequirementInput;
  where: FileToEntityWhereUniqueInput;
};

export type FileToEntityCreateOrConnectWithoutUserAccessGrantRequirementInput = {
  create: FileToEntityCreateWithoutUserAccessGrantRequirementInput;
  where: FileToEntityWhereUniqueInput;
};

export type FileToEntityCreateWithoutRequirementInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  file: FileCreateNestedOneWithoutFileToEntityInput;
  id?: InputMaybe<Scalars['String']>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedOneWithoutFilesInput>;
};

export type FileToEntityCreateWithoutUserAccessGrantRequirementInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  file: FileCreateNestedOneWithoutFileToEntityInput;
  id?: InputMaybe<Scalars['String']>;
  Requirement?: InputMaybe<RequirementCreateNestedOneWithoutFilesInput>;
};

export type FileToEntityFileIdEntityIdEntityTypeCompoundUniqueInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  fileId: Scalars['String'];
};

export type FileToEntityGroupBy = {
  _count?: Maybe<FileToEntityCountAggregate>;
  _max?: Maybe<FileToEntityMaxAggregate>;
  _min?: Maybe<FileToEntityMinAggregate>;
  entityId: Scalars['String'];
  entityType: EntityType;
  fileId: Scalars['String'];
  id: Scalars['String'];
  requirementId?: Maybe<Scalars['String']>;
  userAccessGrantRequirementId?: Maybe<Scalars['String']>;
};

export type FileToEntityListRelationFilter = {
  every?: InputMaybe<FileToEntityWhereInput>;
  none?: InputMaybe<FileToEntityWhereInput>;
  some?: InputMaybe<FileToEntityWhereInput>;
};

export type FileToEntityMaxAggregate = {
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EntityType>;
  fileId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  requirementId?: Maybe<Scalars['String']>;
  userAccessGrantRequirementId?: Maybe<Scalars['String']>;
};

export type FileToEntityMaxOrderByAggregateInput = {
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  requirementId?: InputMaybe<SortOrder>;
  userAccessGrantRequirementId?: InputMaybe<SortOrder>;
};

export type FileToEntityMinAggregate = {
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EntityType>;
  fileId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  requirementId?: Maybe<Scalars['String']>;
  userAccessGrantRequirementId?: Maybe<Scalars['String']>;
};

export type FileToEntityMinOrderByAggregateInput = {
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  requirementId?: InputMaybe<SortOrder>;
  userAccessGrantRequirementId?: InputMaybe<SortOrder>;
};

export type FileToEntityOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type FileToEntityOrderByWithAggregationInput = {
  _count?: InputMaybe<FileToEntityCountOrderByAggregateInput>;
  _max?: InputMaybe<FileToEntityMaxOrderByAggregateInput>;
  _min?: InputMaybe<FileToEntityMinOrderByAggregateInput>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  requirementId?: InputMaybe<SortOrderInput>;
  userAccessGrantRequirementId?: InputMaybe<SortOrderInput>;
};

export type FileToEntityOrderByWithRelationInput = {
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  file?: InputMaybe<FileOrderByWithRelationInput>;
  fileId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  Requirement?: InputMaybe<RequirementOrderByWithRelationInput>;
  requirementId?: InputMaybe<SortOrderInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementOrderByWithRelationInput>;
  userAccessGrantRequirementId?: InputMaybe<SortOrderInput>;
};

export enum FileToEntityScalarFieldEnum {
  EntityId = 'entityId',
  EntityType = 'entityType',
  FileId = 'fileId',
  Id = 'id',
  RequirementId = 'requirementId',
  UserAccessGrantRequirementId = 'userAccessGrantRequirementId'
}

export type FileToEntityScalarWhereInput = {
  AND?: InputMaybe<Array<FileToEntityScalarWhereInput>>;
  entityId?: InputMaybe<StringFilter>;
  entityType?: InputMaybe<EnumEntityTypeFilter>;
  fileId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<FileToEntityScalarWhereInput>>;
  OR?: InputMaybe<Array<FileToEntityScalarWhereInput>>;
  requirementId?: InputMaybe<StringNullableFilter>;
  userAccessGrantRequirementId?: InputMaybe<StringNullableFilter>;
};

export type FileToEntityScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<FileToEntityScalarWhereWithAggregatesInput>>;
  entityId?: InputMaybe<StringWithAggregatesFilter>;
  entityType?: InputMaybe<EnumEntityTypeWithAggregatesFilter>;
  fileId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<FileToEntityScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<FileToEntityScalarWhereWithAggregatesInput>>;
  requirementId?: InputMaybe<StringNullableWithAggregatesFilter>;
  userAccessGrantRequirementId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type FileToEntityUpdateInput = {
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneRequiredWithoutFileToEntityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  Requirement?: InputMaybe<RequirementUpdateOneWithoutFilesNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateOneWithoutFilesNestedInput>;
};

export type FileToEntityUpdateManyMutationInput = {
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileToEntityUpdateManyWithoutRequirementNestedInput = {
  connect?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileToEntityCreateOrConnectWithoutRequirementInput>>;
  create?: InputMaybe<Array<FileToEntityCreateWithoutRequirementInput>>;
  createMany?: InputMaybe<FileToEntityCreateManyRequirementInputEnvelope>;
  delete?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileToEntityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  set?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  update?: InputMaybe<Array<FileToEntityUpdateWithWhereUniqueWithoutRequirementInput>>;
  updateMany?: InputMaybe<Array<FileToEntityUpdateManyWithWhereWithoutRequirementInput>>;
  upsert?: InputMaybe<Array<FileToEntityUpsertWithWhereUniqueWithoutRequirementInput>>;
};

export type FileToEntityUpdateManyWithoutUserAccessGrantRequirementNestedInput = {
  connect?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<FileToEntityCreateOrConnectWithoutUserAccessGrantRequirementInput>>;
  create?: InputMaybe<Array<FileToEntityCreateWithoutUserAccessGrantRequirementInput>>;
  createMany?: InputMaybe<FileToEntityCreateManyUserAccessGrantRequirementInputEnvelope>;
  delete?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<FileToEntityScalarWhereInput>>;
  disconnect?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  set?: InputMaybe<Array<FileToEntityWhereUniqueInput>>;
  update?: InputMaybe<Array<FileToEntityUpdateWithWhereUniqueWithoutUserAccessGrantRequirementInput>>;
  updateMany?: InputMaybe<Array<FileToEntityUpdateManyWithWhereWithoutUserAccessGrantRequirementInput>>;
  upsert?: InputMaybe<Array<FileToEntityUpsertWithWhereUniqueWithoutUserAccessGrantRequirementInput>>;
};

export type FileToEntityUpdateManyWithWhereWithoutRequirementInput = {
  data: FileToEntityUpdateManyMutationInput;
  where: FileToEntityScalarWhereInput;
};

export type FileToEntityUpdateManyWithWhereWithoutUserAccessGrantRequirementInput = {
  data: FileToEntityUpdateManyMutationInput;
  where: FileToEntityScalarWhereInput;
};

export type FileToEntityUpdateWithoutRequirementInput = {
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneRequiredWithoutFileToEntityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateOneWithoutFilesNestedInput>;
};

export type FileToEntityUpdateWithoutUserAccessGrantRequirementInput = {
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  file?: InputMaybe<FileUpdateOneRequiredWithoutFileToEntityNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  Requirement?: InputMaybe<RequirementUpdateOneWithoutFilesNestedInput>;
};

export type FileToEntityUpdateWithWhereUniqueWithoutRequirementInput = {
  data: FileToEntityUpdateWithoutRequirementInput;
  where: FileToEntityWhereUniqueInput;
};

export type FileToEntityUpdateWithWhereUniqueWithoutUserAccessGrantRequirementInput = {
  data: FileToEntityUpdateWithoutUserAccessGrantRequirementInput;
  where: FileToEntityWhereUniqueInput;
};

export type FileToEntityUpsertWithWhereUniqueWithoutRequirementInput = {
  create: FileToEntityCreateWithoutRequirementInput;
  update: FileToEntityUpdateWithoutRequirementInput;
  where: FileToEntityWhereUniqueInput;
};

export type FileToEntityUpsertWithWhereUniqueWithoutUserAccessGrantRequirementInput = {
  create: FileToEntityCreateWithoutUserAccessGrantRequirementInput;
  update: FileToEntityUpdateWithoutUserAccessGrantRequirementInput;
  where: FileToEntityWhereUniqueInput;
};

export type FileToEntityWhereInput = {
  AND?: InputMaybe<Array<FileToEntityWhereInput>>;
  entityId?: InputMaybe<StringFilter>;
  entityType?: InputMaybe<EnumEntityTypeFilter>;
  file?: InputMaybe<FileRelationFilter>;
  fileId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<FileToEntityWhereInput>>;
  OR?: InputMaybe<Array<FileToEntityWhereInput>>;
  Requirement?: InputMaybe<RequirementRelationFilter>;
  requirementId?: InputMaybe<StringNullableFilter>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementRelationFilter>;
  userAccessGrantRequirementId?: InputMaybe<StringNullableFilter>;
};

export type FileToEntityWhereUniqueInput = {
  fileId_entityId_entityType?: InputMaybe<FileToEntityFileIdEntityIdEntityTypeCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export enum FileType {
  AmenityImageFile = 'AMENITY_IMAGE_FILE',
  InfoItemImageFile = 'INFO_ITEM_IMAGE_FILE',
  OriginalAgreementFile = 'ORIGINAL_AGREEMENT_FILE',
  ResourceImageFile = 'RESOURCE_IMAGE_FILE',
  ServiceImageFile = 'SERVICE_IMAGE_FILE',
  SignedAgreementFile = 'SIGNED_AGREEMENT_FILE',
  UnitTypeImageFile = 'UNIT_TYPE_IMAGE_FILE'
}

export type FileUpdateOneRequiredWithoutFileToEntityNestedInput = {
  connect?: InputMaybe<FileWhereUniqueInput>;
  connectOrCreate?: InputMaybe<FileCreateOrConnectWithoutFileToEntityInput>;
  create?: InputMaybe<FileCreateWithoutFileToEntityInput>;
  update?: InputMaybe<FileUpdateWithoutFileToEntityInput>;
  upsert?: InputMaybe<FileUpsertWithoutFileToEntityInput>;
};

export type FileUpdateWithoutFileToEntityInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  deletedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  fileType?: InputMaybe<EnumFileTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumFileStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  url?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type FileUpsertWithoutFileToEntityInput = {
  create: FileCreateWithoutFileToEntityInput;
  update: FileUpdateWithoutFileToEntityInput;
};

export type FileWhereInput = {
  AND?: InputMaybe<Array<FileWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  deletedAt?: InputMaybe<DateTimeNullableFilter>;
  FileToEntity?: InputMaybe<FileToEntityListRelationFilter>;
  fileType?: InputMaybe<EnumFileTypeFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<FileWhereInput>>;
  OR?: InputMaybe<Array<FileWhereInput>>;
  status?: InputMaybe<EnumFileStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  url?: InputMaybe<StringFilter>;
};

export type FileWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type FindCreateAssociateUserInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  confirmationCode: Scalars['String'];
  country?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  fallbackConfirmationCode?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  processAsSecondaryUser?: InputMaybe<Scalars['Boolean']>;
  tenantId: Scalars['String'];
};

export type FindCreateAssociateUserResult = {
  accessGrantId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type FindOrCreateUserInput = {
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};

export type FloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']>;
  divide?: InputMaybe<Scalars['Float']>;
  increment?: InputMaybe<Scalars['Float']>;
  multiply?: InputMaybe<Scalars['Float']>;
  set?: InputMaybe<Scalars['Float']>;
};

export type FloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type FreedomPayExchangeTokenResponse = {
  cardType: Scalars['String'];
  expirationMonth: Scalars['String'];
  expirationYear: Scalars['String'];
  lastFour: Scalars['String'];
  nameOnCard: Scalars['String'];
  token: Scalars['String'];
};

export type GenerateDeeplinkResult = {
  deeplink: Scalars['String'];
};

export type GenerateMobileWebTokenResult = {
  token: Scalars['String'];
};

export type GetCredentialResponse = {
  accessKeyId: Scalars['String'];
  expiration: Scalars['String'];
  secretAccessKey: Scalars['String'];
  sessionToken: Scalars['String'];
};

export type GetFaceLivenessSessionResultsResponse = {
  confidence: Scalars['Float'];
  faceImage?: Maybe<Scalars['String']>;
  isFaceDetected: Scalars['Boolean'];
  isFaceMatch?: Maybe<Scalars['Boolean']>;
  performFaceMatch?: Maybe<Scalars['Boolean']>;
  sessionId: Scalars['String'];
  status: Scalars['String'];
};

export type GetKioskConfigAnswer = {
  lemurXConfig?: Maybe<LemurXConfig>;
};

export type GracePeriod = {
  commonAreas: GracePeriodValues;
  earlyCheckInConfig: EarlyCheckInConfig;
  rooms: GracePeriodValues;
};

export type GracePeriodInput = {
  commonAreas: GracePeriodValuesInput;
  earlyCheckInConfig?: InputMaybe<EarlyCheckInConfigInput>;
  rooms: GracePeriodValuesInput;
};

export type GracePeriodOverride = {
  absoluteTime?: Maybe<Scalars['String']>;
  absoluteTimePeriod?: Maybe<Scalars['String']>;
  gracePeriodType: Scalars['String'];
  isActive: Scalars['Boolean'];
  relativeTimeInMinutes?: Maybe<Scalars['Float']>;
};

export type GracePeriodOverrideInput = {
  absoluteTime?: InputMaybe<Scalars['String']>;
  absoluteTimePeriod?: InputMaybe<Scalars['String']>;
  gracePeriodType: Scalars['String'];
  isActive: Scalars['Boolean'];
  relativeTimeInMinutes?: InputMaybe<Scalars['Float']>;
};

export type GracePeriodValues = {
  checkIn: GracePeriodOverride;
  checkOut: GracePeriodOverride;
};

export type GracePeriodValuesInput = {
  checkIn: GracePeriodOverrideInput;
  checkOut: GracePeriodOverrideInput;
};

export type GuestContactInfoInput = {
  email?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type GuestCountInput = {
  age?: InputMaybe<Scalars['Float']>;
  ageQualifyingCode: Scalars['String'];
  count: Scalars['Float'];
};

export type HotelMetadata = {
  amountOutstanding?: Maybe<Scalars['String']>;
  amountPaid?: Maybe<Scalars['String']>;
  authorizedAmount?: Maybe<Scalars['String']>;
  company?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  createOrigin?: Maybe<Scalars['String']>;
  didSendRoomInformation?: Maybe<Scalars['String']>;
  earlyCheckIn?: Maybe<Scalars['String']>;
  grandTotal?: Maybe<Scalars['String']>;
  guestsCount?: Maybe<TotalGuests>;
  isLoyaltyMember?: Maybe<Scalars['String']>;
  lateCheckOut?: Maybe<Scalars['String']>;
  loyaltyCode?: Maybe<Scalars['String']>;
  loyaltyRequestUserId?: Maybe<Scalars['String']>;
  pmsDetachedAG?: Maybe<Scalars['String']>;
  pmsResvLastUpdatedAt?: Maybe<Scalars['String']>;
  room?: Maybe<Scalars['String']>;
  roomNumber?: Maybe<Scalars['String']>;
  roomType?: Maybe<Scalars['String']>;
  skipIDVerification?: Maybe<Scalars['String']>;
  status?: Maybe<Scalars['String']>;
  totalRevenue?: Maybe<Scalars['String']>;
  totalTaxes?: Maybe<Scalars['String']>;
  unhandledCheckInPayment?: Maybe<Scalars['String']>;
  wifiPassword?: Maybe<Scalars['String']>;
  wifiSSID?: Maybe<Scalars['String']>;
};

export type IdResult = {
  id?: Maybe<Scalars['String']>;
};

export enum IdVerification {
  Completed = 'COMPLETED',
  NotRequired = 'NOT_REQUIRED',
  Required = 'REQUIRED'
}

export type IdVerificationAnswer = {
  rejectReasonCode?: Maybe<Scalars['String']>;
  requirement?: Maybe<Requirement>;
  result: Scalars['Boolean'];
};

export type IdVerificationAnswerWithRequirement = {
  rejectReasonCode?: Maybe<Scalars['String']>;
  requirement?: Maybe<Requirement>;
  result: Scalars['Boolean'];
};

export type IdVerificationResult = {
  id: Scalars['String'];
  referenceId?: Maybe<Scalars['String']>;
  status: IdVerificationResultStatus;
  timeStamp?: Maybe<Scalars['DateTime']>;
};

export type IdVerificationResultCreateNestedOneWithoutAccessGrantInput = {
  connect?: InputMaybe<IdVerificationResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdVerificationResultCreateOrConnectWithoutAccessGrantInput>;
  create?: InputMaybe<IdVerificationResultCreateWithoutAccessGrantInput>;
};

export type IdVerificationResultCreateOrConnectWithoutAccessGrantInput = {
  create: IdVerificationResultCreateWithoutAccessGrantInput;
  where: IdVerificationResultWhereUniqueInput;
};

export type IdVerificationResultCreateWithoutAccessGrantInput = {
  id: Scalars['String'];
  referenceId?: InputMaybe<Scalars['String']>;
  status: IdVerificationResultStatus;
  timeStamp?: InputMaybe<Scalars['DateTime']>;
};

export type IdVerificationResultOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  id?: InputMaybe<SortOrder>;
  referenceId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  timeStamp?: InputMaybe<SortOrderInput>;
};

export type IdVerificationResultRelationFilter = {
  is?: InputMaybe<IdVerificationResultWhereInput>;
  isNot?: InputMaybe<IdVerificationResultWhereInput>;
};

export enum IdVerificationResultStatus {
  ApprovedVerified = 'APPROVED_VERIFIED',
  DeniedFraud = 'DENIED_FRAUD',
  DeniedUnsupportedIdCountry = 'DENIED_UNSUPPORTED_ID_COUNTRY',
  DeniedUnsupportedIdType = 'DENIED_UNSUPPORTED_ID_TYPE',
  ErrorNotReadableId = 'ERROR_NOT_READABLE_ID',
  NoIdUploaded = 'NO_ID_UPLOADED'
}

export type IdVerificationResultUpdateOneWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<IdVerificationResultWhereUniqueInput>;
  connectOrCreate?: InputMaybe<IdVerificationResultCreateOrConnectWithoutAccessGrantInput>;
  create?: InputMaybe<IdVerificationResultCreateWithoutAccessGrantInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<IdVerificationResultUpdateWithoutAccessGrantInput>;
  upsert?: InputMaybe<IdVerificationResultUpsertWithoutAccessGrantInput>;
};

export type IdVerificationResultUpdateWithoutAccessGrantInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  referenceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumIdVerificationResultStatusFieldUpdateOperationsInput>;
  timeStamp?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type IdVerificationResultUpsertWithoutAccessGrantInput = {
  create: IdVerificationResultCreateWithoutAccessGrantInput;
  update: IdVerificationResultUpdateWithoutAccessGrantInput;
};

export type IdVerificationResultWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  AND?: InputMaybe<Array<IdVerificationResultWhereInput>>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<IdVerificationResultWhereInput>>;
  OR?: InputMaybe<Array<IdVerificationResultWhereInput>>;
  referenceId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumIdVerificationResultStatusFilter>;
  timeStamp?: InputMaybe<DateTimeNullableFilter>;
};

export type IdVerificationResultWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum InfoContentType {
  ExternalUrl = 'EXTERNAL_URL',
  ImageAndDescription = 'IMAGE_AND_DESCRIPTION',
  PdfViewer = 'PDF_VIEWER'
}

export type InfoItem = {
  accessGrant?: Maybe<AccessGrant>;
  accessGrantId?: Maybe<Scalars['String']>;
  contentType?: Maybe<InfoContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  infoType?: Maybe<TypeOfInfo>;
  infoTypeId?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InfoItemCountAggregate = {
  _all: Scalars['Int'];
  accessGrantId: Scalars['Int'];
  contentType: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  imageUrl: Scalars['Int'];
  infoTypeId: Scalars['Int'];
  locationId: Scalars['Int'];
  moreInfoLink: Scalars['Int'];
  thumbnailImage: Scalars['Int'];
  title: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type InfoItemCountOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  infoTypeId?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  moreInfoLink?: InputMaybe<SortOrder>;
  thumbnailImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type InfoItemCreateInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutInfosInput>;
  contentType?: InputMaybe<InfoContentType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infoType?: InputMaybe<TypeOfInfoCreateNestedOneWithoutInfoInput>;
  location?: InputMaybe<LocationCreateNestedOneWithoutInfosInput>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InfoItemCreateManyAccessGrantInput = {
  contentType?: InputMaybe<InfoContentType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infoTypeId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InfoItemCreateManyAccessGrantInputEnvelope = {
  data: Array<InfoItemCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InfoItemCreateManyInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<InfoContentType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infoTypeId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InfoItemCreateManyLocationInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  contentType?: InputMaybe<InfoContentType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infoTypeId?: InputMaybe<Scalars['String']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InfoItemCreateManyLocationInputEnvelope = {
  data: Array<InfoItemCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InfoItemCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InfoItemCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<InfoItemCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<InfoItemCreateManyAccessGrantInputEnvelope>;
};

export type InfoItemCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InfoItemCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<InfoItemCreateWithoutLocationInput>>;
  createMany?: InputMaybe<InfoItemCreateManyLocationInputEnvelope>;
};

export type InfoItemCreateOrConnectWithoutAccessGrantInput = {
  create: InfoItemCreateWithoutAccessGrantInput;
  where: InfoItemWhereUniqueInput;
};

export type InfoItemCreateOrConnectWithoutLocationInput = {
  create: InfoItemCreateWithoutLocationInput;
  where: InfoItemWhereUniqueInput;
};

export type InfoItemCreateWithoutAccessGrantInput = {
  contentType?: InputMaybe<InfoContentType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infoType?: InputMaybe<TypeOfInfoCreateNestedOneWithoutInfoInput>;
  location?: InputMaybe<LocationCreateNestedOneWithoutInfosInput>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InfoItemCreateWithoutLocationInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutInfosInput>;
  contentType?: InputMaybe<InfoContentType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infoType?: InputMaybe<TypeOfInfoCreateNestedOneWithoutInfoInput>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InfoItemGroupBy = {
  _count?: Maybe<InfoItemCountAggregate>;
  _max?: Maybe<InfoItemMaxAggregate>;
  _min?: Maybe<InfoItemMinAggregate>;
  accessGrantId?: Maybe<Scalars['String']>;
  contentType?: Maybe<InfoContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  infoTypeId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: InfoType;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InfoItemListRelationFilter = {
  every?: InputMaybe<InfoItemWhereInput>;
  none?: InputMaybe<InfoItemWhereInput>;
  some?: InputMaybe<InfoItemWhereInput>;
};

export type InfoItemMaxAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  contentType?: Maybe<InfoContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  infoTypeId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<InfoType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InfoItemMaxOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  infoTypeId?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  moreInfoLink?: InputMaybe<SortOrder>;
  thumbnailImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type InfoItemMinAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  contentType?: Maybe<InfoContentType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  infoTypeId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  thumbnailImage?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<InfoType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type InfoItemMinOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  contentType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  infoTypeId?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  moreInfoLink?: InputMaybe<SortOrder>;
  thumbnailImage?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type InfoItemOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type InfoItemOrderByWithAggregationInput = {
  _count?: InputMaybe<InfoItemCountOrderByAggregateInput>;
  _max?: InputMaybe<InfoItemMaxOrderByAggregateInput>;
  _min?: InputMaybe<InfoItemMinOrderByAggregateInput>;
  accessGrantId?: InputMaybe<SortOrderInput>;
  contentType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  infoTypeId?: InputMaybe<SortOrderInput>;
  locationId?: InputMaybe<SortOrderInput>;
  moreInfoLink?: InputMaybe<SortOrderInput>;
  thumbnailImage?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export type InfoItemOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrderInput>;
  contentType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  infoType?: InputMaybe<TypeOfInfoOrderByWithRelationInput>;
  infoTypeId?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  moreInfoLink?: InputMaybe<SortOrderInput>;
  thumbnailImage?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrderInput>;
};

export enum InfoItemScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  ContentType = 'contentType',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  ImageUrl = 'imageUrl',
  InfoTypeId = 'infoTypeId',
  LocationId = 'locationId',
  MoreInfoLink = 'moreInfoLink',
  ThumbnailImage = 'thumbnailImage',
  Title = 'title',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type InfoItemScalarWhereInput = {
  accessGrantId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<InfoItemScalarWhereInput>>;
  contentType?: InputMaybe<EnumInfoContentTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  infoTypeId?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  moreInfoLink?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<InfoItemScalarWhereInput>>;
  OR?: InputMaybe<Array<InfoItemScalarWhereInput>>;
  thumbnailImage?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumInfoTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type InfoItemScalarWhereWithAggregatesInput = {
  accessGrantId?: InputMaybe<StringNullableWithAggregatesFilter>;
  AND?: InputMaybe<Array<InfoItemScalarWhereWithAggregatesInput>>;
  contentType?: InputMaybe<EnumInfoContentTypeNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  infoTypeId?: InputMaybe<StringNullableWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  moreInfoLink?: InputMaybe<StringNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<InfoItemScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<InfoItemScalarWhereWithAggregatesInput>>;
  thumbnailImage?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumInfoTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
};

export type InfoItemUpdateInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutInfosNestedInput>;
  contentType?: InputMaybe<NullableEnumInfoContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infoType?: InputMaybe<TypeOfInfoUpdateOneWithoutInfoNestedInput>;
  location?: InputMaybe<LocationUpdateOneWithoutInfosNestedInput>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumInfoTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type InfoItemUpdateManyMutationInput = {
  contentType?: InputMaybe<NullableEnumInfoContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumInfoTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type InfoItemUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InfoItemCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<InfoItemCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<InfoItemCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InfoItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  set?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  update?: InputMaybe<Array<InfoItemUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<InfoItemUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<InfoItemUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type InfoItemUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InfoItemCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<InfoItemCreateWithoutLocationInput>>;
  createMany?: InputMaybe<InfoItemCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InfoItemScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  set?: InputMaybe<Array<InfoItemWhereUniqueInput>>;
  update?: InputMaybe<Array<InfoItemUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<InfoItemUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<InfoItemUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type InfoItemUpdateManyWithWhereWithoutAccessGrantInput = {
  data: InfoItemUpdateManyMutationInput;
  where: InfoItemScalarWhereInput;
};

export type InfoItemUpdateManyWithWhereWithoutLocationInput = {
  data: InfoItemUpdateManyMutationInput;
  where: InfoItemScalarWhereInput;
};

export type InfoItemUpdateWithoutAccessGrantInput = {
  contentType?: InputMaybe<NullableEnumInfoContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infoType?: InputMaybe<TypeOfInfoUpdateOneWithoutInfoNestedInput>;
  location?: InputMaybe<LocationUpdateOneWithoutInfosNestedInput>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumInfoTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type InfoItemUpdateWithoutLocationInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutInfosNestedInput>;
  contentType?: InputMaybe<NullableEnumInfoContentTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infoType?: InputMaybe<TypeOfInfoUpdateOneWithoutInfoNestedInput>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  thumbnailImage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumInfoTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type InfoItemUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: InfoItemUpdateWithoutAccessGrantInput;
  where: InfoItemWhereUniqueInput;
};

export type InfoItemUpdateWithWhereUniqueWithoutLocationInput = {
  data: InfoItemUpdateWithoutLocationInput;
  where: InfoItemWhereUniqueInput;
};

export type InfoItemUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: InfoItemCreateWithoutAccessGrantInput;
  update: InfoItemUpdateWithoutAccessGrantInput;
  where: InfoItemWhereUniqueInput;
};

export type InfoItemUpsertWithWhereUniqueWithoutLocationInput = {
  create: InfoItemCreateWithoutLocationInput;
  update: InfoItemUpdateWithoutLocationInput;
  where: InfoItemWhereUniqueInput;
};

export type InfoItemWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<InfoItemWhereInput>>;
  contentType?: InputMaybe<EnumInfoContentTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeNullableFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  infoType?: InputMaybe<TypeOfInfoRelationFilter>;
  infoTypeId?: InputMaybe<StringNullableFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  moreInfoLink?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<InfoItemWhereInput>>;
  OR?: InputMaybe<Array<InfoItemWhereInput>>;
  thumbnailImage?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumInfoTypeFilter>;
  updatedAt?: InputMaybe<DateTimeNullableFilter>;
};

export type InfoItemWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum InfoType {
  Category = 'CATEGORY',
  CityGuide = 'CITY_GUIDE',
  InfoItem = 'INFO_ITEM',
  KeyPickup = 'KEY_PICKUP',
  KeyReturn = 'KEY_RETURN',
  Laundry = 'LAUNDRY',
  NoticeToVacate = 'NOTICE_TO_VACATE',
  Parking = 'PARKING',
  TrashRecycling = 'TRASH_RECYCLING'
}

export type InternalApiCall = {
  _count?: Maybe<InternalApiCallCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  internalApiKeyId?: Maybe<Scalars['String']>;
  kioskId?: Maybe<Scalars['String']>;
  operation: Scalars['String'];
  status: ApiCallStatus;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
};

export type InternalApiCallCount = {
  errors: Scalars['Int'];
};


export type InternalApiCallCountErrorsArgs = {
  where?: InputMaybe<ApiCallErrorWhereInput>;
};

export type InternalApiCallCreateManyInternalApiKeyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  operation: Scalars['String'];
  status?: InputMaybe<ApiCallStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type InternalApiCallCreateManyInternalApiKeyInputEnvelope = {
  data: Array<InternalApiCallCreateManyInternalApiKeyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InternalApiCallCreateManyKioskInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeyId?: InputMaybe<Scalars['String']>;
  operation: Scalars['String'];
  status?: InputMaybe<ApiCallStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
};

export type InternalApiCallCreateManyKioskInputEnvelope = {
  data: Array<InternalApiCallCreateManyKioskInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InternalApiCallCreateManyUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeyId?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  operation: Scalars['String'];
  status?: InputMaybe<ApiCallStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InternalApiCallCreateManyUserInputEnvelope = {
  data: Array<InternalApiCallCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InternalApiCallCreateNestedManyWithoutInternalApiKeyInput = {
  connect?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InternalApiCallCreateOrConnectWithoutInternalApiKeyInput>>;
  create?: InputMaybe<Array<InternalApiCallCreateWithoutInternalApiKeyInput>>;
  createMany?: InputMaybe<InternalApiCallCreateManyInternalApiKeyInputEnvelope>;
};

export type InternalApiCallCreateNestedManyWithoutKioskInput = {
  connect?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InternalApiCallCreateOrConnectWithoutKioskInput>>;
  create?: InputMaybe<Array<InternalApiCallCreateWithoutKioskInput>>;
  createMany?: InputMaybe<InternalApiCallCreateManyKioskInputEnvelope>;
};

export type InternalApiCallCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InternalApiCallCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<InternalApiCallCreateWithoutUserInput>>;
  createMany?: InputMaybe<InternalApiCallCreateManyUserInputEnvelope>;
};

export type InternalApiCallCreateOrConnectWithoutInternalApiKeyInput = {
  create: InternalApiCallCreateWithoutInternalApiKeyInput;
  where: InternalApiCallWhereUniqueInput;
};

export type InternalApiCallCreateOrConnectWithoutKioskInput = {
  create: InternalApiCallCreateWithoutKioskInput;
  where: InternalApiCallWhereUniqueInput;
};

export type InternalApiCallCreateOrConnectWithoutUserInput = {
  create: InternalApiCallCreateWithoutUserInput;
  where: InternalApiCallWhereUniqueInput;
};

export type InternalApiCallCreateWithoutInternalApiKeyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  errors?: InputMaybe<ApiCallErrorCreateNestedManyWithoutInternalApiCallInput>;
  id?: InputMaybe<Scalars['String']>;
  kiosk?: InputMaybe<KioskCreateNestedOneWithoutInternalApiCallsInput>;
  operation: Scalars['String'];
  status?: InputMaybe<ApiCallStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutInternalApiCallsInput>;
};

export type InternalApiCallCreateWithoutKioskInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  errors?: InputMaybe<ApiCallErrorCreateNestedManyWithoutInternalApiCallInput>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKey?: InputMaybe<InternalApiKeyCreateNestedOneWithoutInternalApiCallsInput>;
  operation: Scalars['String'];
  status?: InputMaybe<ApiCallStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutInternalApiCallsInput>;
};

export type InternalApiCallCreateWithoutUserInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  errors?: InputMaybe<ApiCallErrorCreateNestedManyWithoutInternalApiCallInput>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKey?: InputMaybe<InternalApiKeyCreateNestedOneWithoutInternalApiCallsInput>;
  kiosk?: InputMaybe<KioskCreateNestedOneWithoutInternalApiCallsInput>;
  operation: Scalars['String'];
  status?: InputMaybe<ApiCallStatus>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InternalApiCallListRelationFilter = {
  every?: InputMaybe<InternalApiCallWhereInput>;
  none?: InputMaybe<InternalApiCallWhereInput>;
  some?: InputMaybe<InternalApiCallWhereInput>;
};

export type InternalApiCallOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type InternalApiCallOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  errors?: InputMaybe<ApiCallErrorOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  internalApiKey?: InputMaybe<InternalApiKeyOrderByWithRelationInput>;
  internalApiKeyId?: InputMaybe<SortOrderInput>;
  kiosk?: InputMaybe<KioskOrderByWithRelationInput>;
  kioskId?: InputMaybe<SortOrderInput>;
  operation?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export type InternalApiCallRelationFilter = {
  is?: InputMaybe<InternalApiCallWhereInput>;
  isNot?: InputMaybe<InternalApiCallWhereInput>;
};

export enum InternalApiCallScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  InternalApiKeyId = 'internalApiKeyId',
  KioskId = 'kioskId',
  Operation = 'operation',
  Status = 'status',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type InternalApiCallScalarWhereInput = {
  AND?: InputMaybe<Array<InternalApiCallScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  internalApiKeyId?: InputMaybe<StringNullableFilter>;
  kioskId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<InternalApiCallScalarWhereInput>>;
  operation?: InputMaybe<StringFilter>;
  OR?: InputMaybe<Array<InternalApiCallScalarWhereInput>>;
  status?: InputMaybe<EnumApiCallStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type InternalApiCallUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  operation?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumApiCallStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InternalApiCallUpdateManyWithoutInternalApiKeyNestedInput = {
  connect?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InternalApiCallCreateOrConnectWithoutInternalApiKeyInput>>;
  create?: InputMaybe<Array<InternalApiCallCreateWithoutInternalApiKeyInput>>;
  createMany?: InputMaybe<InternalApiCallCreateManyInternalApiKeyInputEnvelope>;
  delete?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InternalApiCallScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  set?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  update?: InputMaybe<Array<InternalApiCallUpdateWithWhereUniqueWithoutInternalApiKeyInput>>;
  updateMany?: InputMaybe<Array<InternalApiCallUpdateManyWithWhereWithoutInternalApiKeyInput>>;
  upsert?: InputMaybe<Array<InternalApiCallUpsertWithWhereUniqueWithoutInternalApiKeyInput>>;
};

export type InternalApiCallUpdateManyWithoutKioskNestedInput = {
  connect?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InternalApiCallCreateOrConnectWithoutKioskInput>>;
  create?: InputMaybe<Array<InternalApiCallCreateWithoutKioskInput>>;
  createMany?: InputMaybe<InternalApiCallCreateManyKioskInputEnvelope>;
  delete?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InternalApiCallScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  set?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  update?: InputMaybe<Array<InternalApiCallUpdateWithWhereUniqueWithoutKioskInput>>;
  updateMany?: InputMaybe<Array<InternalApiCallUpdateManyWithWhereWithoutKioskInput>>;
  upsert?: InputMaybe<Array<InternalApiCallUpsertWithWhereUniqueWithoutKioskInput>>;
};

export type InternalApiCallUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InternalApiCallCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<InternalApiCallCreateWithoutUserInput>>;
  createMany?: InputMaybe<InternalApiCallCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InternalApiCallScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  set?: InputMaybe<Array<InternalApiCallWhereUniqueInput>>;
  update?: InputMaybe<Array<InternalApiCallUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<InternalApiCallUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<InternalApiCallUpsertWithWhereUniqueWithoutUserInput>>;
};

export type InternalApiCallUpdateManyWithWhereWithoutInternalApiKeyInput = {
  data: InternalApiCallUpdateManyMutationInput;
  where: InternalApiCallScalarWhereInput;
};

export type InternalApiCallUpdateManyWithWhereWithoutKioskInput = {
  data: InternalApiCallUpdateManyMutationInput;
  where: InternalApiCallScalarWhereInput;
};

export type InternalApiCallUpdateManyWithWhereWithoutUserInput = {
  data: InternalApiCallUpdateManyMutationInput;
  where: InternalApiCallScalarWhereInput;
};

export type InternalApiCallUpdateWithoutInternalApiKeyInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  errors?: InputMaybe<ApiCallErrorUpdateManyWithoutInternalApiCallNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kiosk?: InputMaybe<KioskUpdateOneWithoutInternalApiCallsNestedInput>;
  operation?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumApiCallStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutInternalApiCallsNestedInput>;
};

export type InternalApiCallUpdateWithoutKioskInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  errors?: InputMaybe<ApiCallErrorUpdateManyWithoutInternalApiCallNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKey?: InputMaybe<InternalApiKeyUpdateOneWithoutInternalApiCallsNestedInput>;
  operation?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumApiCallStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutInternalApiCallsNestedInput>;
};

export type InternalApiCallUpdateWithoutUserInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  errors?: InputMaybe<ApiCallErrorUpdateManyWithoutInternalApiCallNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKey?: InputMaybe<InternalApiKeyUpdateOneWithoutInternalApiCallsNestedInput>;
  kiosk?: InputMaybe<KioskUpdateOneWithoutInternalApiCallsNestedInput>;
  operation?: InputMaybe<StringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumApiCallStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InternalApiCallUpdateWithWhereUniqueWithoutInternalApiKeyInput = {
  data: InternalApiCallUpdateWithoutInternalApiKeyInput;
  where: InternalApiCallWhereUniqueInput;
};

export type InternalApiCallUpdateWithWhereUniqueWithoutKioskInput = {
  data: InternalApiCallUpdateWithoutKioskInput;
  where: InternalApiCallWhereUniqueInput;
};

export type InternalApiCallUpdateWithWhereUniqueWithoutUserInput = {
  data: InternalApiCallUpdateWithoutUserInput;
  where: InternalApiCallWhereUniqueInput;
};

export type InternalApiCallUpsertWithWhereUniqueWithoutInternalApiKeyInput = {
  create: InternalApiCallCreateWithoutInternalApiKeyInput;
  update: InternalApiCallUpdateWithoutInternalApiKeyInput;
  where: InternalApiCallWhereUniqueInput;
};

export type InternalApiCallUpsertWithWhereUniqueWithoutKioskInput = {
  create: InternalApiCallCreateWithoutKioskInput;
  update: InternalApiCallUpdateWithoutKioskInput;
  where: InternalApiCallWhereUniqueInput;
};

export type InternalApiCallUpsertWithWhereUniqueWithoutUserInput = {
  create: InternalApiCallCreateWithoutUserInput;
  update: InternalApiCallUpdateWithoutUserInput;
  where: InternalApiCallWhereUniqueInput;
};

export type InternalApiCallWhereInput = {
  AND?: InputMaybe<Array<InternalApiCallWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  errors?: InputMaybe<ApiCallErrorListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  internalApiKey?: InputMaybe<InternalApiKeyRelationFilter>;
  internalApiKeyId?: InputMaybe<StringNullableFilter>;
  kiosk?: InputMaybe<KioskRelationFilter>;
  kioskId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<InternalApiCallWhereInput>>;
  operation?: InputMaybe<StringFilter>;
  OR?: InputMaybe<Array<InternalApiCallWhereInput>>;
  status?: InputMaybe<EnumApiCallStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type InternalApiCallWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type InternalApiKey = {
  _count?: Maybe<InternalApiKeyCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isValid: Scalars['Boolean'];
  key: Scalars['String'];
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  tenantId: Scalars['String'];
  type: InternalApiKeyType;
  updatedAt: Scalars['DateTime'];
};

export type InternalApiKeyCount = {
  internalApiCalls: Scalars['Int'];
};


export type InternalApiKeyCountInternalApiCallsArgs = {
  where?: InputMaybe<InternalApiCallWhereInput>;
};

export type InternalApiKeyCreateManyTenantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isValid?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  type: InternalApiKeyType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InternalApiKeyCreateManyTenantInputEnvelope = {
  data: Array<InternalApiKeyCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type InternalApiKeyCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<InternalApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InternalApiKeyCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<InternalApiKeyCreateWithoutTenantInput>>;
  createMany?: InputMaybe<InternalApiKeyCreateManyTenantInputEnvelope>;
};

export type InternalApiKeyCreateNestedOneWithoutInternalApiCallsInput = {
  connect?: InputMaybe<InternalApiKeyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InternalApiKeyCreateOrConnectWithoutInternalApiCallsInput>;
  create?: InputMaybe<InternalApiKeyCreateWithoutInternalApiCallsInput>;
};

export type InternalApiKeyCreateOrConnectWithoutInternalApiCallsInput = {
  create: InternalApiKeyCreateWithoutInternalApiCallsInput;
  where: InternalApiKeyWhereUniqueInput;
};

export type InternalApiKeyCreateOrConnectWithoutTenantInput = {
  create: InternalApiKeyCreateWithoutTenantInput;
  where: InternalApiKeyWhereUniqueInput;
};

export type InternalApiKeyCreateWithoutInternalApiCallsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isValid?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  tenant: TenantCreateNestedOneWithoutInternalApiKeysInput;
  type: InternalApiKeyType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InternalApiKeyCreateWithoutTenantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutInternalApiKeyInput>;
  isValid?: InputMaybe<Scalars['Boolean']>;
  key?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  type: InternalApiKeyType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type InternalApiKeyListRelationFilter = {
  every?: InputMaybe<InternalApiKeyWhereInput>;
  none?: InputMaybe<InternalApiKeyWhereInput>;
  some?: InputMaybe<InternalApiKeyWhereInput>;
};

export type InternalApiKeyOnlyKeyAndType = {
  key: Scalars['String'];
  type: InternalApiKeyType;
};

export type InternalApiKeyOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type InternalApiKeyOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalApiCalls?: InputMaybe<InternalApiCallOrderByRelationAggregateInput>;
  isValid?: InputMaybe<SortOrder>;
  key?: InputMaybe<SortOrder>;
  lastSeenAt?: InputMaybe<SortOrderInput>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type InternalApiKeyRelationFilter = {
  is?: InputMaybe<InternalApiKeyWhereInput>;
  isNot?: InputMaybe<InternalApiKeyWhereInput>;
};

export enum InternalApiKeyScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsValid = 'isValid',
  Key = 'key',
  LastSeenAt = 'lastSeenAt',
  TenantId = 'tenantId',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type InternalApiKeyScalarWhereInput = {
  AND?: InputMaybe<Array<InternalApiKeyScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isValid?: InputMaybe<BoolFilter>;
  key?: InputMaybe<StringFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  NOT?: InputMaybe<Array<InternalApiKeyScalarWhereInput>>;
  OR?: InputMaybe<Array<InternalApiKeyScalarWhereInput>>;
  tenantId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumInternalApiKeyTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export enum InternalApiKeyType {
  MobileSdk = 'MOBILE_SDK'
}

export type InternalApiKeyTypes = {
  internalApiKeyTypes: Array<Scalars['String']>;
};

export type InternalApiKeyTypeTenantIdCompoundUniqueInput = {
  tenantId: Scalars['String'];
  type: InternalApiKeyType;
};

export type InternalApiKeyUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isValid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumInternalApiKeyTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InternalApiKeyUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<InternalApiKeyWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<InternalApiKeyCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<InternalApiKeyCreateWithoutTenantInput>>;
  createMany?: InputMaybe<InternalApiKeyCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<InternalApiKeyWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<InternalApiKeyScalarWhereInput>>;
  disconnect?: InputMaybe<Array<InternalApiKeyWhereUniqueInput>>;
  set?: InputMaybe<Array<InternalApiKeyWhereUniqueInput>>;
  update?: InputMaybe<Array<InternalApiKeyUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<InternalApiKeyUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<InternalApiKeyUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type InternalApiKeyUpdateManyWithWhereWithoutTenantInput = {
  data: InternalApiKeyUpdateManyMutationInput;
  where: InternalApiKeyScalarWhereInput;
};

export type InternalApiKeyUpdateOneWithoutInternalApiCallsNestedInput = {
  connect?: InputMaybe<InternalApiKeyWhereUniqueInput>;
  connectOrCreate?: InputMaybe<InternalApiKeyCreateOrConnectWithoutInternalApiCallsInput>;
  create?: InputMaybe<InternalApiKeyCreateWithoutInternalApiCallsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<InternalApiKeyUpdateWithoutInternalApiCallsInput>;
  upsert?: InputMaybe<InternalApiKeyUpsertWithoutInternalApiCallsInput>;
};

export type InternalApiKeyUpdateWithoutInternalApiCallsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isValid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutInternalApiKeysNestedInput>;
  type?: InputMaybe<EnumInternalApiKeyTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InternalApiKeyUpdateWithoutTenantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutInternalApiKeyNestedInput>;
  isValid?: InputMaybe<BoolFieldUpdateOperationsInput>;
  key?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumInternalApiKeyTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type InternalApiKeyUpdateWithWhereUniqueWithoutTenantInput = {
  data: InternalApiKeyUpdateWithoutTenantInput;
  where: InternalApiKeyWhereUniqueInput;
};

export type InternalApiKeyUpsertWithoutInternalApiCallsInput = {
  create: InternalApiKeyCreateWithoutInternalApiCallsInput;
  update: InternalApiKeyUpdateWithoutInternalApiCallsInput;
};

export type InternalApiKeyUpsertWithWhereUniqueWithoutTenantInput = {
  create: InternalApiKeyCreateWithoutTenantInput;
  update: InternalApiKeyUpdateWithoutTenantInput;
  where: InternalApiKeyWhereUniqueInput;
};

export type InternalApiKeyWhereInput = {
  AND?: InputMaybe<Array<InternalApiKeyWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  internalApiCalls?: InputMaybe<InternalApiCallListRelationFilter>;
  isValid?: InputMaybe<BoolFilter>;
  key?: InputMaybe<StringFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  NOT?: InputMaybe<Array<InternalApiKeyWhereInput>>;
  OR?: InputMaybe<Array<InternalApiKeyWhereInput>>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumInternalApiKeyTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type InternalApiKeyWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  key?: InputMaybe<Scalars['String']>;
  type_tenantId?: InputMaybe<InternalApiKeyTypeTenantIdCompoundUniqueInput>;
};

export type IntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type IntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type IntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type JsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type JsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type JsonNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedJsonNullableFilter>;
  _min?: InputMaybe<NestedJsonNullableFilter>;
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type JsonWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedJsonFilter>;
  _min?: InputMaybe<NestedJsonFilter>;
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type JumioAccount = {
  id: Scalars['String'];
};

export type JumioCreateAccountResponse = {
  account: JumioAccount;
  sdk: JumioSdk;
  timestamp: Scalars['String'];
  workflowExecution: JumioWorkflowExecution;
};

export type JumioDocumentAndImage = {
  dob?: Maybe<Scalars['String']>;
  expiry?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  images?: Maybe<Array<JumioImage>>;
  issuingCountry?: Maybe<Scalars['String']>;
  issuingDate?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  scanReference?: Maybe<Scalars['String']>;
  status?: Maybe<IdVerificationResultStatus>;
  timestamp?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
};

export type JumioFaceMatchResponse = {
  userMatches: Scalars['Boolean'];
};

export type JumioImage = {
  classifier?: Maybe<Scalars['String']>;
  href?: Maybe<Scalars['String']>;
};

export type JumioPlatformIdVerificationWithLivenessResponse = {
  workflowExecutionId: Scalars['String'];
};

export type JumioSdk = {
  token: Scalars['String'];
};

export type JumioUploadDocumentsResponse = {
  jumioIdScanReference: Scalars['String'];
  timestamp: Scalars['String'];
};

export type JumioWorkflowExecution = {
  credentials: Array<Scalars['String']>;
  id: Scalars['String'];
};

export enum KeycardOrigin {
  Dashboard = 'DASHBOARD',
  Kiosk = 'KIOSK'
}

/** A Virdee kiosk. */
export type Kiosk = {
  _count?: Maybe<KioskCount>;
  batteryLevel?: Maybe<Scalars['Int']>;
  buildNumber?: Maybe<Scalars['String']>;
  CallRecord: Array<CallRecord>;
  chargingState?: Maybe<ChargingState>;
  clerkId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  dispenserConfig: Array<KioskDispenserConfig>;
  dispenserLastSeenAt?: Maybe<Scalars['DateTime']>;
  dispenserType?: Maybe<DispenserType>;
  hasDispenser: Scalars['Boolean'];
  hasTerminal: Scalars['Boolean'];
  id: Scalars['String'];
  internalApiCalls: Array<InternalApiCall>;
  /** Warning: isDispenserConnected will be removed in the future. Please use dispenserLastSeenAt instead. */
  isDispenserConnected?: Maybe<Scalars['Boolean']>;
  /** Warning: isStripeReaderConnected will be removed in the future. Please use terminalLastSeenAt instead. */
  isStripeReaderConnected?: Maybe<Scalars['Boolean']>;
  kioskEnrollmentChallenge: Array<KioskEnrollmentChallenge>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  location: Location;
  locationId: Scalars['String'];
  maintenanceEndsAt?: Maybe<Scalars['DateTime']>;
  maintenanceStartsAt?: Maybe<Scalars['DateTime']>;
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: Maybe<Scalars['String']>;
  rfidTagType?: Maybe<RfidTagType>;
  serverUrl?: Maybe<Scalars['String']>;
  tenant: Tenant;
  tenantId: Scalars['String'];
  terminalLastSeenAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};


/** A Virdee kiosk. */
export type KioskCallRecordArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


/** A Virdee kiosk. */
export type KioskDispenserConfigArgs = {
  cursor?: InputMaybe<KioskDispenserConfigWhereUniqueInput>;
  distinct?: InputMaybe<Array<KioskDispenserConfigScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<KioskDispenserConfigOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskDispenserConfigWhereInput>;
};


/** A Virdee kiosk. */
export type KioskInternalApiCallsArgs = {
  cursor?: InputMaybe<InternalApiCallWhereUniqueInput>;
  distinct?: InputMaybe<Array<InternalApiCallScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InternalApiCallOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InternalApiCallWhereInput>;
};


/** A Virdee kiosk. */
export type KioskKioskEnrollmentChallengeArgs = {
  cursor?: InputMaybe<KioskEnrollmentChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<KioskEnrollmentChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<KioskEnrollmentChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskEnrollmentChallengeWhereInput>;
};

export type KioskAndAccessGrantParams = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  kioskId: Scalars['String'];
};

export type KioskAuthAnswer = {
  accessToken: Scalars['String'];
  kiosk: Kiosk;
  kioskId: Scalars['String'];
};

export type KioskAvgAggregate = {
  batteryLevel?: Maybe<Scalars['Float']>;
  clerkId?: Maybe<Scalars['Float']>;
};

export type KioskAvgOrderByAggregateInput = {
  batteryLevel?: InputMaybe<SortOrder>;
  clerkId?: InputMaybe<SortOrder>;
};

export type KioskCount = {
  CallRecord: Scalars['Int'];
  dispenserConfig: Scalars['Int'];
  internalApiCalls: Scalars['Int'];
  kioskEnrollmentChallenge: Scalars['Int'];
};


export type KioskCountCallRecordArgs = {
  where?: InputMaybe<CallRecordWhereInput>;
};


export type KioskCountDispenserConfigArgs = {
  where?: InputMaybe<KioskDispenserConfigWhereInput>;
};


export type KioskCountInternalApiCallsArgs = {
  where?: InputMaybe<InternalApiCallWhereInput>;
};


export type KioskCountKioskEnrollmentChallengeArgs = {
  where?: InputMaybe<KioskEnrollmentChallengeWhereInput>;
};

export type KioskCountAggregate = {
  _all: Scalars['Int'];
  batteryLevel: Scalars['Int'];
  buildNumber: Scalars['Int'];
  chargingState: Scalars['Int'];
  clerkId: Scalars['Int'];
  createdAt: Scalars['Int'];
  dispenserLastSeenAt: Scalars['Int'];
  dispenserType: Scalars['Int'];
  hasDispenser: Scalars['Int'];
  hasTerminal: Scalars['Int'];
  id: Scalars['Int'];
  isDispenserConnected: Scalars['Int'];
  isStripeReaderConnected: Scalars['Int'];
  lastSeenAt: Scalars['Int'];
  locationId: Scalars['Int'];
  maintenanceEndsAt: Scalars['Int'];
  maintenanceStartsAt: Scalars['Int'];
  metadata: Scalars['Int'];
  name: Scalars['Int'];
  powerSwitchId: Scalars['Int'];
  rfidTagType: Scalars['Int'];
  serverUrl: Scalars['Int'];
  tenantId: Scalars['Int'];
  terminalLastSeenAt: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type KioskCountOrderByAggregateInput = {
  batteryLevel?: InputMaybe<SortOrder>;
  buildNumber?: InputMaybe<SortOrder>;
  chargingState?: InputMaybe<SortOrder>;
  clerkId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dispenserLastSeenAt?: InputMaybe<SortOrder>;
  dispenserType?: InputMaybe<SortOrder>;
  hasDispenser?: InputMaybe<SortOrder>;
  hasTerminal?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDispenserConnected?: InputMaybe<SortOrder>;
  isStripeReaderConnected?: InputMaybe<SortOrder>;
  lastSeenAt?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  maintenanceEndsAt?: InputMaybe<SortOrder>;
  maintenanceStartsAt?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  powerSwitchId?: InputMaybe<SortOrder>;
  rfidTagType?: InputMaybe<SortOrder>;
  serverUrl?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  terminalLastSeenAt?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type KioskCreateInput = {
  batteryLevel?: InputMaybe<Scalars['Int']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  CallRecord?: InputMaybe<CallRecordCreateNestedManyWithoutKioskInput>;
  chargingState?: InputMaybe<ChargingState>;
  clerkId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigCreateNestedManyWithoutAssociatedKioskInput>;
  dispenserLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  dispenserType?: InputMaybe<DispenserType>;
  hasDispenser?: InputMaybe<Scalars['Boolean']>;
  hasTerminal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutKioskInput>;
  isDispenserConnected?: InputMaybe<Scalars['Boolean']>;
  isStripeReaderConnected?: InputMaybe<Scalars['Boolean']>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeCreateNestedManyWithoutAssociatedKioskInput>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutKiosksInput;
  maintenanceEndsAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceStartsAt?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: InputMaybe<Scalars['String']>;
  rfidTagType?: InputMaybe<RfidTagType>;
  serverUrl?: InputMaybe<Scalars['String']>;
  tenant: TenantCreateNestedOneWithoutKiosksInput;
  terminalLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type KioskCreateManyInput = {
  batteryLevel?: InputMaybe<Scalars['Int']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  chargingState?: InputMaybe<ChargingState>;
  clerkId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dispenserLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  dispenserType?: InputMaybe<DispenserType>;
  hasDispenser?: InputMaybe<Scalars['Boolean']>;
  hasTerminal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isDispenserConnected?: InputMaybe<Scalars['Boolean']>;
  isStripeReaderConnected?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  maintenanceEndsAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceStartsAt?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: InputMaybe<Scalars['String']>;
  rfidTagType?: InputMaybe<RfidTagType>;
  serverUrl?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  terminalLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type KioskCreateManyLocationInput = {
  batteryLevel?: InputMaybe<Scalars['Int']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  chargingState?: InputMaybe<ChargingState>;
  clerkId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dispenserLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  dispenserType?: InputMaybe<DispenserType>;
  hasDispenser?: InputMaybe<Scalars['Boolean']>;
  hasTerminal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isDispenserConnected?: InputMaybe<Scalars['Boolean']>;
  isStripeReaderConnected?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceEndsAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceStartsAt?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: InputMaybe<Scalars['String']>;
  rfidTagType?: InputMaybe<RfidTagType>;
  serverUrl?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  terminalLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type KioskCreateManyLocationInputEnvelope = {
  data: Array<KioskCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type KioskCreateManyTenantInput = {
  batteryLevel?: InputMaybe<Scalars['Int']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  chargingState?: InputMaybe<ChargingState>;
  clerkId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dispenserLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  dispenserType?: InputMaybe<DispenserType>;
  hasDispenser?: InputMaybe<Scalars['Boolean']>;
  hasTerminal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isDispenserConnected?: InputMaybe<Scalars['Boolean']>;
  isStripeReaderConnected?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  maintenanceEndsAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceStartsAt?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: InputMaybe<Scalars['String']>;
  rfidTagType?: InputMaybe<RfidTagType>;
  serverUrl?: InputMaybe<Scalars['String']>;
  terminalLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type KioskCreateManyTenantInputEnvelope = {
  data: Array<KioskCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type KioskCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<KioskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<KioskCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<KioskCreateWithoutLocationInput>>;
  createMany?: InputMaybe<KioskCreateManyLocationInputEnvelope>;
};

export type KioskCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<KioskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<KioskCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<KioskCreateWithoutTenantInput>>;
  createMany?: InputMaybe<KioskCreateManyTenantInputEnvelope>;
};

export type KioskCreateNestedOneWithoutCallRecordInput = {
  connect?: InputMaybe<KioskWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KioskCreateOrConnectWithoutCallRecordInput>;
  create?: InputMaybe<KioskCreateWithoutCallRecordInput>;
};

export type KioskCreateNestedOneWithoutInternalApiCallsInput = {
  connect?: InputMaybe<KioskWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KioskCreateOrConnectWithoutInternalApiCallsInput>;
  create?: InputMaybe<KioskCreateWithoutInternalApiCallsInput>;
};

export type KioskCreateOrConnectWithoutCallRecordInput = {
  create: KioskCreateWithoutCallRecordInput;
  where: KioskWhereUniqueInput;
};

export type KioskCreateOrConnectWithoutInternalApiCallsInput = {
  create: KioskCreateWithoutInternalApiCallsInput;
  where: KioskWhereUniqueInput;
};

export type KioskCreateOrConnectWithoutLocationInput = {
  create: KioskCreateWithoutLocationInput;
  where: KioskWhereUniqueInput;
};

export type KioskCreateOrConnectWithoutTenantInput = {
  create: KioskCreateWithoutTenantInput;
  where: KioskWhereUniqueInput;
};

export type KioskCreateWithoutCallRecordInput = {
  batteryLevel?: InputMaybe<Scalars['Int']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  chargingState?: InputMaybe<ChargingState>;
  clerkId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigCreateNestedManyWithoutAssociatedKioskInput>;
  dispenserLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  dispenserType?: InputMaybe<DispenserType>;
  hasDispenser?: InputMaybe<Scalars['Boolean']>;
  hasTerminal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutKioskInput>;
  isDispenserConnected?: InputMaybe<Scalars['Boolean']>;
  isStripeReaderConnected?: InputMaybe<Scalars['Boolean']>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeCreateNestedManyWithoutAssociatedKioskInput>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutKiosksInput;
  maintenanceEndsAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceStartsAt?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: InputMaybe<Scalars['String']>;
  rfidTagType?: InputMaybe<RfidTagType>;
  serverUrl?: InputMaybe<Scalars['String']>;
  tenant: TenantCreateNestedOneWithoutKiosksInput;
  terminalLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type KioskCreateWithoutInternalApiCallsInput = {
  batteryLevel?: InputMaybe<Scalars['Int']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  CallRecord?: InputMaybe<CallRecordCreateNestedManyWithoutKioskInput>;
  chargingState?: InputMaybe<ChargingState>;
  clerkId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigCreateNestedManyWithoutAssociatedKioskInput>;
  dispenserLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  dispenserType?: InputMaybe<DispenserType>;
  hasDispenser?: InputMaybe<Scalars['Boolean']>;
  hasTerminal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  isDispenserConnected?: InputMaybe<Scalars['Boolean']>;
  isStripeReaderConnected?: InputMaybe<Scalars['Boolean']>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeCreateNestedManyWithoutAssociatedKioskInput>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutKiosksInput;
  maintenanceEndsAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceStartsAt?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: InputMaybe<Scalars['String']>;
  rfidTagType?: InputMaybe<RfidTagType>;
  serverUrl?: InputMaybe<Scalars['String']>;
  tenant: TenantCreateNestedOneWithoutKiosksInput;
  terminalLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type KioskCreateWithoutLocationInput = {
  batteryLevel?: InputMaybe<Scalars['Int']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  CallRecord?: InputMaybe<CallRecordCreateNestedManyWithoutKioskInput>;
  chargingState?: InputMaybe<ChargingState>;
  clerkId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigCreateNestedManyWithoutAssociatedKioskInput>;
  dispenserLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  dispenserType?: InputMaybe<DispenserType>;
  hasDispenser?: InputMaybe<Scalars['Boolean']>;
  hasTerminal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutKioskInput>;
  isDispenserConnected?: InputMaybe<Scalars['Boolean']>;
  isStripeReaderConnected?: InputMaybe<Scalars['Boolean']>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeCreateNestedManyWithoutAssociatedKioskInput>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceEndsAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceStartsAt?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: InputMaybe<Scalars['String']>;
  rfidTagType?: InputMaybe<RfidTagType>;
  serverUrl?: InputMaybe<Scalars['String']>;
  tenant: TenantCreateNestedOneWithoutKiosksInput;
  terminalLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type KioskCreateWithoutTenantInput = {
  batteryLevel?: InputMaybe<Scalars['Int']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  CallRecord?: InputMaybe<CallRecordCreateNestedManyWithoutKioskInput>;
  chargingState?: InputMaybe<ChargingState>;
  clerkId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigCreateNestedManyWithoutAssociatedKioskInput>;
  dispenserLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  dispenserType?: InputMaybe<DispenserType>;
  hasDispenser?: InputMaybe<Scalars['Boolean']>;
  hasTerminal?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutKioskInput>;
  isDispenserConnected?: InputMaybe<Scalars['Boolean']>;
  isStripeReaderConnected?: InputMaybe<Scalars['Boolean']>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeCreateNestedManyWithoutAssociatedKioskInput>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutKiosksInput;
  maintenanceEndsAt?: InputMaybe<Scalars['DateTime']>;
  maintenanceStartsAt?: InputMaybe<Scalars['DateTime']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: InputMaybe<Scalars['String']>;
  rfidTagType?: InputMaybe<RfidTagType>;
  serverUrl?: InputMaybe<Scalars['String']>;
  terminalLastSeenAt?: InputMaybe<Scalars['DateTime']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type KioskDispenserConfig = {
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  dispenserType?: Maybe<DispenserType>;
  id: Scalars['String'];
  isActive?: Maybe<Scalars['Boolean']>;
  kioskId?: Maybe<Scalars['String']>;
  serial?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  usage?: Maybe<Scalars['String']>;
};

export type KioskDispenserConfigCreateManyAssociatedKioskInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  dispenserType?: InputMaybe<DispenserType>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usage?: InputMaybe<Scalars['String']>;
};

export type KioskDispenserConfigCreateManyAssociatedKioskInputEnvelope = {
  data: Array<KioskDispenserConfigCreateManyAssociatedKioskInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type KioskDispenserConfigCreateNestedManyWithoutAssociatedKioskInput = {
  connect?: InputMaybe<Array<KioskDispenserConfigWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<KioskDispenserConfigCreateOrConnectWithoutAssociatedKioskInput>>;
  create?: InputMaybe<Array<KioskDispenserConfigCreateWithoutAssociatedKioskInput>>;
  createMany?: InputMaybe<KioskDispenserConfigCreateManyAssociatedKioskInputEnvelope>;
};

export type KioskDispenserConfigCreateOrConnectWithoutAssociatedKioskInput = {
  create: KioskDispenserConfigCreateWithoutAssociatedKioskInput;
  where: KioskDispenserConfigWhereUniqueInput;
};

export type KioskDispenserConfigCreateWithoutAssociatedKioskInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  dispenserType?: InputMaybe<DispenserType>;
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  serial?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  usage?: InputMaybe<Scalars['String']>;
};

export type KioskDispenserConfigListRelationFilter = {
  every?: InputMaybe<KioskDispenserConfigWhereInput>;
  none?: InputMaybe<KioskDispenserConfigWhereInput>;
  some?: InputMaybe<KioskDispenserConfigWhereInput>;
};

export type KioskDispenserConfigOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type KioskDispenserConfigOrderByWithRelationInput = {
  associatedKiosk?: InputMaybe<KioskOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  dispenserType?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrderInput>;
  kioskId?: InputMaybe<SortOrderInput>;
  serial?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  usage?: InputMaybe<SortOrderInput>;
};

export enum KioskDispenserConfigScalarFieldEnum {
  CreatedAt = 'createdAt',
  Description = 'description',
  DispenserType = 'dispenserType',
  Id = 'id',
  IsActive = 'isActive',
  KioskId = 'kioskId',
  Serial = 'serial',
  UpdatedAt = 'updatedAt',
  Usage = 'usage'
}

export type KioskDispenserConfigScalarWhereInput = {
  AND?: InputMaybe<Array<KioskDispenserConfigScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dispenserType?: InputMaybe<EnumDispenserTypeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  kioskId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<KioskDispenserConfigScalarWhereInput>>;
  OR?: InputMaybe<Array<KioskDispenserConfigScalarWhereInput>>;
  serial?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usage?: InputMaybe<StringNullableFilter>;
};

export type KioskDispenserConfigUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispenserType?: InputMaybe<NullableEnumDispenserTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  serial?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type KioskDispenserConfigUpdateManyWithoutAssociatedKioskNestedInput = {
  connect?: InputMaybe<Array<KioskDispenserConfigWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<KioskDispenserConfigCreateOrConnectWithoutAssociatedKioskInput>>;
  create?: InputMaybe<Array<KioskDispenserConfigCreateWithoutAssociatedKioskInput>>;
  createMany?: InputMaybe<KioskDispenserConfigCreateManyAssociatedKioskInputEnvelope>;
  delete?: InputMaybe<Array<KioskDispenserConfigWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<KioskDispenserConfigScalarWhereInput>>;
  disconnect?: InputMaybe<Array<KioskDispenserConfigWhereUniqueInput>>;
  set?: InputMaybe<Array<KioskDispenserConfigWhereUniqueInput>>;
  update?: InputMaybe<Array<KioskDispenserConfigUpdateWithWhereUniqueWithoutAssociatedKioskInput>>;
  updateMany?: InputMaybe<Array<KioskDispenserConfigUpdateManyWithWhereWithoutAssociatedKioskInput>>;
  upsert?: InputMaybe<Array<KioskDispenserConfigUpsertWithWhereUniqueWithoutAssociatedKioskInput>>;
};

export type KioskDispenserConfigUpdateManyWithWhereWithoutAssociatedKioskInput = {
  data: KioskDispenserConfigUpdateManyMutationInput;
  where: KioskDispenserConfigScalarWhereInput;
};

export type KioskDispenserConfigUpdateWithoutAssociatedKioskInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  dispenserType?: InputMaybe<NullableEnumDispenserTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  serial?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  usage?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type KioskDispenserConfigUpdateWithWhereUniqueWithoutAssociatedKioskInput = {
  data: KioskDispenserConfigUpdateWithoutAssociatedKioskInput;
  where: KioskDispenserConfigWhereUniqueInput;
};

export type KioskDispenserConfigUpsertWithWhereUniqueWithoutAssociatedKioskInput = {
  create: KioskDispenserConfigCreateWithoutAssociatedKioskInput;
  update: KioskDispenserConfigUpdateWithoutAssociatedKioskInput;
  where: KioskDispenserConfigWhereUniqueInput;
};

export type KioskDispenserConfigWhereInput = {
  AND?: InputMaybe<Array<KioskDispenserConfigWhereInput>>;
  associatedKiosk?: InputMaybe<KioskRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  dispenserType?: InputMaybe<EnumDispenserTypeNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolNullableFilter>;
  kioskId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<KioskDispenserConfigWhereInput>>;
  OR?: InputMaybe<Array<KioskDispenserConfigWhereInput>>;
  serial?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  usage?: InputMaybe<StringNullableFilter>;
};

export type KioskDispenserConfigWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

/** A temporary challenge to enroll a kiosk with, like activating a media streaming app on a TV. */
export type KioskEnrollmentChallenge = {
  createdAt: Scalars['DateTime'];
  expiresAt: Scalars['DateTime'];
  id: Scalars['String'];
  kioskId?: Maybe<Scalars['String']>;
};

export type KioskEnrollmentChallengeAnswer = {
  code: Scalars['String'];
  expiresIn: Scalars['Float'];
};

export type KioskEnrollmentChallengeCreateManyAssociatedKioskInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  expiresAt: Scalars['DateTime'];
  id: Scalars['String'];
};

export type KioskEnrollmentChallengeCreateManyAssociatedKioskInputEnvelope = {
  data: Array<KioskEnrollmentChallengeCreateManyAssociatedKioskInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type KioskEnrollmentChallengeCreateNestedManyWithoutAssociatedKioskInput = {
  connect?: InputMaybe<Array<KioskEnrollmentChallengeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<KioskEnrollmentChallengeCreateOrConnectWithoutAssociatedKioskInput>>;
  create?: InputMaybe<Array<KioskEnrollmentChallengeCreateWithoutAssociatedKioskInput>>;
  createMany?: InputMaybe<KioskEnrollmentChallengeCreateManyAssociatedKioskInputEnvelope>;
};

export type KioskEnrollmentChallengeCreateOrConnectWithoutAssociatedKioskInput = {
  create: KioskEnrollmentChallengeCreateWithoutAssociatedKioskInput;
  where: KioskEnrollmentChallengeWhereUniqueInput;
};

export type KioskEnrollmentChallengeCreateWithoutAssociatedKioskInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  expiresAt: Scalars['DateTime'];
  id: Scalars['String'];
};

export type KioskEnrollmentChallengeListRelationFilter = {
  every?: InputMaybe<KioskEnrollmentChallengeWhereInput>;
  none?: InputMaybe<KioskEnrollmentChallengeWhereInput>;
  some?: InputMaybe<KioskEnrollmentChallengeWhereInput>;
};

export type KioskEnrollmentChallengeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type KioskEnrollmentChallengeOrderByWithRelationInput = {
  associatedKiosk?: InputMaybe<KioskOrderByWithRelationInput>;
  createdAt?: InputMaybe<SortOrder>;
  expiresAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  kioskId?: InputMaybe<SortOrderInput>;
};

export enum KioskEnrollmentChallengeScalarFieldEnum {
  CreatedAt = 'createdAt',
  ExpiresAt = 'expiresAt',
  Id = 'id',
  KioskId = 'kioskId'
}

export type KioskEnrollmentChallengeScalarWhereInput = {
  AND?: InputMaybe<Array<KioskEnrollmentChallengeScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  kioskId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<KioskEnrollmentChallengeScalarWhereInput>>;
  OR?: InputMaybe<Array<KioskEnrollmentChallengeScalarWhereInput>>;
};

export type KioskEnrollmentChallengeUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type KioskEnrollmentChallengeUpdateManyWithoutAssociatedKioskNestedInput = {
  connect?: InputMaybe<Array<KioskEnrollmentChallengeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<KioskEnrollmentChallengeCreateOrConnectWithoutAssociatedKioskInput>>;
  create?: InputMaybe<Array<KioskEnrollmentChallengeCreateWithoutAssociatedKioskInput>>;
  createMany?: InputMaybe<KioskEnrollmentChallengeCreateManyAssociatedKioskInputEnvelope>;
  delete?: InputMaybe<Array<KioskEnrollmentChallengeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<KioskEnrollmentChallengeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<KioskEnrollmentChallengeWhereUniqueInput>>;
  set?: InputMaybe<Array<KioskEnrollmentChallengeWhereUniqueInput>>;
  update?: InputMaybe<Array<KioskEnrollmentChallengeUpdateWithWhereUniqueWithoutAssociatedKioskInput>>;
  updateMany?: InputMaybe<Array<KioskEnrollmentChallengeUpdateManyWithWhereWithoutAssociatedKioskInput>>;
  upsert?: InputMaybe<Array<KioskEnrollmentChallengeUpsertWithWhereUniqueWithoutAssociatedKioskInput>>;
};

export type KioskEnrollmentChallengeUpdateManyWithWhereWithoutAssociatedKioskInput = {
  data: KioskEnrollmentChallengeUpdateManyMutationInput;
  where: KioskEnrollmentChallengeScalarWhereInput;
};

export type KioskEnrollmentChallengeUpdateWithoutAssociatedKioskInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  expiresAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type KioskEnrollmentChallengeUpdateWithWhereUniqueWithoutAssociatedKioskInput = {
  data: KioskEnrollmentChallengeUpdateWithoutAssociatedKioskInput;
  where: KioskEnrollmentChallengeWhereUniqueInput;
};

export type KioskEnrollmentChallengeUpsertWithWhereUniqueWithoutAssociatedKioskInput = {
  create: KioskEnrollmentChallengeCreateWithoutAssociatedKioskInput;
  update: KioskEnrollmentChallengeUpdateWithoutAssociatedKioskInput;
  where: KioskEnrollmentChallengeWhereUniqueInput;
};

export type KioskEnrollmentChallengeWhereInput = {
  AND?: InputMaybe<Array<KioskEnrollmentChallengeWhereInput>>;
  associatedKiosk?: InputMaybe<KioskRelationFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  expiresAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  kioskId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<KioskEnrollmentChallengeWhereInput>>;
  OR?: InputMaybe<Array<KioskEnrollmentChallengeWhereInput>>;
};

export type KioskEnrollmentChallengeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type KioskGroupBy = {
  _avg?: Maybe<KioskAvgAggregate>;
  _count?: Maybe<KioskCountAggregate>;
  _max?: Maybe<KioskMaxAggregate>;
  _min?: Maybe<KioskMinAggregate>;
  _sum?: Maybe<KioskSumAggregate>;
  batteryLevel?: Maybe<Scalars['Int']>;
  buildNumber?: Maybe<Scalars['String']>;
  chargingState?: Maybe<ChargingState>;
  clerkId: Scalars['Int'];
  createdAt: Scalars['DateTime'];
  dispenserLastSeenAt?: Maybe<Scalars['DateTime']>;
  dispenserType?: Maybe<DispenserType>;
  hasDispenser: Scalars['Boolean'];
  hasTerminal: Scalars['Boolean'];
  id: Scalars['String'];
  isDispenserConnected?: Maybe<Scalars['Boolean']>;
  isStripeReaderConnected?: Maybe<Scalars['Boolean']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
  maintenanceEndsAt?: Maybe<Scalars['DateTime']>;
  maintenanceStartsAt?: Maybe<Scalars['DateTime']>;
  metadata?: Maybe<Scalars['JSON']>;
  name: Scalars['String'];
  powerSwitchId?: Maybe<Scalars['String']>;
  rfidTagType?: Maybe<RfidTagType>;
  serverUrl?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  terminalLastSeenAt?: Maybe<Scalars['DateTime']>;
  updatedAt: Scalars['DateTime'];
};

export type KioskListRelationFilter = {
  every?: InputMaybe<KioskWhereInput>;
  none?: InputMaybe<KioskWhereInput>;
  some?: InputMaybe<KioskWhereInput>;
};

export type KioskLiveUsageAccessGrant = {
  bookedPackages: Array<KioskLiveUsageBookedPackage>;
  confirmationCode?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  id: Scalars['String'];
  requirements: Array<Requirement>;
  resources: Array<Resource>;
  roomNumber?: Maybe<Scalars['String']>;
  secondaryUsers: Array<SecondaryUsersOnAccessGrants>;
  startsAt: Scalars['DateTime'];
  totalGuests: KioskLiveUsageTotalGuests;
  user: KioskLiveUsageGuest;
};

export type KioskLiveUsageBookedPackage = {
  originalQuantity?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  title: Scalars['String'];
};

export type KioskLiveUsageData = {
  accessGrant?: Maybe<KioskLiveUsageAccessGrant>;
  kiosk: KioskLiveUsageInfo;
};

export type KioskLiveUsageGuest = {
  email?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name?: Maybe<Scalars['String']>;
};

export type KioskLiveUsageInfo = {
  dispenserType?: Maybe<DispenserType>;
  hasDispenser?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  location: KioskLiveUsageLocation;
  name: Scalars['String'];
};

export type KioskLiveUsageLocation = {
  id: Scalars['String'];
  name: Scalars['String'];
  tenantId: Scalars['String'];
  timezone: Scalars['String'];
};

export type KioskLiveUsageTotalGuests = {
  adults?: Maybe<Scalars['Float']>;
  children?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

export type KioskMaxAggregate = {
  batteryLevel?: Maybe<Scalars['Int']>;
  buildNumber?: Maybe<Scalars['String']>;
  chargingState?: Maybe<ChargingState>;
  clerkId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dispenserLastSeenAt?: Maybe<Scalars['DateTime']>;
  dispenserType?: Maybe<DispenserType>;
  hasDispenser?: Maybe<Scalars['Boolean']>;
  hasTerminal?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDispenserConnected?: Maybe<Scalars['Boolean']>;
  isStripeReaderConnected?: Maybe<Scalars['Boolean']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  locationId?: Maybe<Scalars['String']>;
  maintenanceEndsAt?: Maybe<Scalars['DateTime']>;
  maintenanceStartsAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  powerSwitchId?: Maybe<Scalars['String']>;
  rfidTagType?: Maybe<RfidTagType>;
  serverUrl?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  terminalLastSeenAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type KioskMaxOrderByAggregateInput = {
  batteryLevel?: InputMaybe<SortOrder>;
  buildNumber?: InputMaybe<SortOrder>;
  chargingState?: InputMaybe<SortOrder>;
  clerkId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dispenserLastSeenAt?: InputMaybe<SortOrder>;
  dispenserType?: InputMaybe<SortOrder>;
  hasDispenser?: InputMaybe<SortOrder>;
  hasTerminal?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDispenserConnected?: InputMaybe<SortOrder>;
  isStripeReaderConnected?: InputMaybe<SortOrder>;
  lastSeenAt?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  maintenanceEndsAt?: InputMaybe<SortOrder>;
  maintenanceStartsAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  powerSwitchId?: InputMaybe<SortOrder>;
  rfidTagType?: InputMaybe<SortOrder>;
  serverUrl?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  terminalLastSeenAt?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type KioskMinAggregate = {
  batteryLevel?: Maybe<Scalars['Int']>;
  buildNumber?: Maybe<Scalars['String']>;
  chargingState?: Maybe<ChargingState>;
  clerkId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  dispenserLastSeenAt?: Maybe<Scalars['DateTime']>;
  dispenserType?: Maybe<DispenserType>;
  hasDispenser?: Maybe<Scalars['Boolean']>;
  hasTerminal?: Maybe<Scalars['Boolean']>;
  id?: Maybe<Scalars['String']>;
  isDispenserConnected?: Maybe<Scalars['Boolean']>;
  isStripeReaderConnected?: Maybe<Scalars['Boolean']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  locationId?: Maybe<Scalars['String']>;
  maintenanceEndsAt?: Maybe<Scalars['DateTime']>;
  maintenanceStartsAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  powerSwitchId?: Maybe<Scalars['String']>;
  rfidTagType?: Maybe<RfidTagType>;
  serverUrl?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  terminalLastSeenAt?: Maybe<Scalars['DateTime']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type KioskMinOrderByAggregateInput = {
  batteryLevel?: InputMaybe<SortOrder>;
  buildNumber?: InputMaybe<SortOrder>;
  chargingState?: InputMaybe<SortOrder>;
  clerkId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dispenserLastSeenAt?: InputMaybe<SortOrder>;
  dispenserType?: InputMaybe<SortOrder>;
  hasDispenser?: InputMaybe<SortOrder>;
  hasTerminal?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDispenserConnected?: InputMaybe<SortOrder>;
  isStripeReaderConnected?: InputMaybe<SortOrder>;
  lastSeenAt?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  maintenanceEndsAt?: InputMaybe<SortOrder>;
  maintenanceStartsAt?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  powerSwitchId?: InputMaybe<SortOrder>;
  rfidTagType?: InputMaybe<SortOrder>;
  serverUrl?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  terminalLastSeenAt?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type KioskOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type KioskOrderByWithAggregationInput = {
  _avg?: InputMaybe<KioskAvgOrderByAggregateInput>;
  _count?: InputMaybe<KioskCountOrderByAggregateInput>;
  _max?: InputMaybe<KioskMaxOrderByAggregateInput>;
  _min?: InputMaybe<KioskMinOrderByAggregateInput>;
  _sum?: InputMaybe<KioskSumOrderByAggregateInput>;
  batteryLevel?: InputMaybe<SortOrderInput>;
  buildNumber?: InputMaybe<SortOrderInput>;
  chargingState?: InputMaybe<SortOrderInput>;
  clerkId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dispenserLastSeenAt?: InputMaybe<SortOrderInput>;
  dispenserType?: InputMaybe<SortOrderInput>;
  hasDispenser?: InputMaybe<SortOrder>;
  hasTerminal?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDispenserConnected?: InputMaybe<SortOrderInput>;
  isStripeReaderConnected?: InputMaybe<SortOrderInput>;
  lastSeenAt?: InputMaybe<SortOrderInput>;
  locationId?: InputMaybe<SortOrder>;
  maintenanceEndsAt?: InputMaybe<SortOrderInput>;
  maintenanceStartsAt?: InputMaybe<SortOrderInput>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  powerSwitchId?: InputMaybe<SortOrderInput>;
  rfidTagType?: InputMaybe<SortOrderInput>;
  serverUrl?: InputMaybe<SortOrderInput>;
  tenantId?: InputMaybe<SortOrder>;
  terminalLastSeenAt?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type KioskOrderByWithRelationInput = {
  batteryLevel?: InputMaybe<SortOrderInput>;
  buildNumber?: InputMaybe<SortOrderInput>;
  CallRecord?: InputMaybe<CallRecordOrderByRelationAggregateInput>;
  chargingState?: InputMaybe<SortOrderInput>;
  clerkId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigOrderByRelationAggregateInput>;
  dispenserLastSeenAt?: InputMaybe<SortOrderInput>;
  dispenserType?: InputMaybe<SortOrderInput>;
  hasDispenser?: InputMaybe<SortOrder>;
  hasTerminal?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  internalApiCalls?: InputMaybe<InternalApiCallOrderByRelationAggregateInput>;
  isDispenserConnected?: InputMaybe<SortOrderInput>;
  isStripeReaderConnected?: InputMaybe<SortOrderInput>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeOrderByRelationAggregateInput>;
  lastSeenAt?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrder>;
  maintenanceEndsAt?: InputMaybe<SortOrderInput>;
  maintenanceStartsAt?: InputMaybe<SortOrderInput>;
  metadata?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  powerSwitchId?: InputMaybe<SortOrderInput>;
  rfidTagType?: InputMaybe<SortOrderInput>;
  serverUrl?: InputMaybe<SortOrderInput>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  terminalLastSeenAt?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type KioskRelationFilter = {
  is?: InputMaybe<KioskWhereInput>;
  isNot?: InputMaybe<KioskWhereInput>;
};

export enum KioskScalarFieldEnum {
  BatteryLevel = 'batteryLevel',
  BuildNumber = 'buildNumber',
  ChargingState = 'chargingState',
  ClerkId = 'clerkId',
  CreatedAt = 'createdAt',
  DispenserLastSeenAt = 'dispenserLastSeenAt',
  DispenserType = 'dispenserType',
  HasDispenser = 'hasDispenser',
  HasTerminal = 'hasTerminal',
  Id = 'id',
  IsDispenserConnected = 'isDispenserConnected',
  IsStripeReaderConnected = 'isStripeReaderConnected',
  LastSeenAt = 'lastSeenAt',
  LocationId = 'locationId',
  MaintenanceEndsAt = 'maintenanceEndsAt',
  MaintenanceStartsAt = 'maintenanceStartsAt',
  Metadata = 'metadata',
  Name = 'name',
  PowerSwitchId = 'powerSwitchId',
  RfidTagType = 'rfidTagType',
  ServerUrl = 'serverUrl',
  TenantId = 'tenantId',
  TerminalLastSeenAt = 'terminalLastSeenAt',
  UpdatedAt = 'updatedAt'
}

export type KioskScalarWhereInput = {
  AND?: InputMaybe<Array<KioskScalarWhereInput>>;
  batteryLevel?: InputMaybe<IntNullableFilter>;
  buildNumber?: InputMaybe<StringNullableFilter>;
  chargingState?: InputMaybe<EnumChargingStateNullableFilter>;
  clerkId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dispenserLastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  dispenserType?: InputMaybe<EnumDispenserTypeNullableFilter>;
  hasDispenser?: InputMaybe<BoolFilter>;
  hasTerminal?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  isDispenserConnected?: InputMaybe<BoolNullableFilter>;
  isStripeReaderConnected?: InputMaybe<BoolNullableFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  locationId?: InputMaybe<StringFilter>;
  maintenanceEndsAt?: InputMaybe<DateTimeNullableFilter>;
  maintenanceStartsAt?: InputMaybe<DateTimeNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<KioskScalarWhereInput>>;
  OR?: InputMaybe<Array<KioskScalarWhereInput>>;
  powerSwitchId?: InputMaybe<StringNullableFilter>;
  rfidTagType?: InputMaybe<EnumRfidTagTypeNullableFilter>;
  serverUrl?: InputMaybe<StringNullableFilter>;
  tenantId?: InputMaybe<StringFilter>;
  terminalLastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type KioskScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<KioskScalarWhereWithAggregatesInput>>;
  batteryLevel?: InputMaybe<IntNullableWithAggregatesFilter>;
  buildNumber?: InputMaybe<StringNullableWithAggregatesFilter>;
  chargingState?: InputMaybe<EnumChargingStateNullableWithAggregatesFilter>;
  clerkId?: InputMaybe<IntWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  dispenserLastSeenAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  dispenserType?: InputMaybe<EnumDispenserTypeNullableWithAggregatesFilter>;
  hasDispenser?: InputMaybe<BoolWithAggregatesFilter>;
  hasTerminal?: InputMaybe<BoolWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isDispenserConnected?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isStripeReaderConnected?: InputMaybe<BoolNullableWithAggregatesFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  locationId?: InputMaybe<StringWithAggregatesFilter>;
  maintenanceEndsAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  maintenanceStartsAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<KioskScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<KioskScalarWhereWithAggregatesInput>>;
  powerSwitchId?: InputMaybe<StringNullableWithAggregatesFilter>;
  rfidTagType?: InputMaybe<EnumRfidTagTypeNullableWithAggregatesFilter>;
  serverUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  tenantId?: InputMaybe<StringWithAggregatesFilter>;
  terminalLastSeenAt?: InputMaybe<DateTimeNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type KiosksLiveUsageData = {
  data: Array<KioskLiveUsageData>;
};

export type KioskSumAggregate = {
  batteryLevel?: Maybe<Scalars['Int']>;
  clerkId?: Maybe<Scalars['Int']>;
};

export type KioskSumOrderByAggregateInput = {
  batteryLevel?: InputMaybe<SortOrder>;
  clerkId?: InputMaybe<SortOrder>;
};

export type KioskUpdateInput = {
  batteryLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  buildNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  CallRecord?: InputMaybe<CallRecordUpdateManyWithoutKioskNestedInput>;
  chargingState?: InputMaybe<NullableEnumChargingStateFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigUpdateManyWithoutAssociatedKioskNestedInput>;
  dispenserLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dispenserType?: InputMaybe<NullableEnumDispenserTypeFieldUpdateOperationsInput>;
  hasDispenser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasTerminal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutKioskNestedInput>;
  isDispenserConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStripeReaderConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeUpdateManyWithoutAssociatedKioskNestedInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutKiosksNestedInput>;
  maintenanceEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  powerSwitchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rfidTagType?: InputMaybe<NullableEnumRfidTagTypeFieldUpdateOperationsInput>;
  serverUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutKiosksNestedInput>;
  terminalLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type KioskUpdateManyMutationInput = {
  batteryLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  buildNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  chargingState?: InputMaybe<NullableEnumChargingStateFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispenserLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dispenserType?: InputMaybe<NullableEnumDispenserTypeFieldUpdateOperationsInput>;
  hasDispenser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasTerminal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDispenserConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStripeReaderConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  powerSwitchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rfidTagType?: InputMaybe<NullableEnumRfidTagTypeFieldUpdateOperationsInput>;
  serverUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  terminalLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type KioskUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<KioskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<KioskCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<KioskCreateWithoutLocationInput>>;
  createMany?: InputMaybe<KioskCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<KioskWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<KioskScalarWhereInput>>;
  disconnect?: InputMaybe<Array<KioskWhereUniqueInput>>;
  set?: InputMaybe<Array<KioskWhereUniqueInput>>;
  update?: InputMaybe<Array<KioskUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<KioskUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<KioskUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type KioskUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<KioskWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<KioskCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<KioskCreateWithoutTenantInput>>;
  createMany?: InputMaybe<KioskCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<KioskWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<KioskScalarWhereInput>>;
  disconnect?: InputMaybe<Array<KioskWhereUniqueInput>>;
  set?: InputMaybe<Array<KioskWhereUniqueInput>>;
  update?: InputMaybe<Array<KioskUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<KioskUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<KioskUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type KioskUpdateManyWithWhereWithoutLocationInput = {
  data: KioskUpdateManyMutationInput;
  where: KioskScalarWhereInput;
};

export type KioskUpdateManyWithWhereWithoutTenantInput = {
  data: KioskUpdateManyMutationInput;
  where: KioskScalarWhereInput;
};

export type KioskUpdateOneWithoutCallRecordNestedInput = {
  connect?: InputMaybe<KioskWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KioskCreateOrConnectWithoutCallRecordInput>;
  create?: InputMaybe<KioskCreateWithoutCallRecordInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<KioskUpdateWithoutCallRecordInput>;
  upsert?: InputMaybe<KioskUpsertWithoutCallRecordInput>;
};

export type KioskUpdateOneWithoutInternalApiCallsNestedInput = {
  connect?: InputMaybe<KioskWhereUniqueInput>;
  connectOrCreate?: InputMaybe<KioskCreateOrConnectWithoutInternalApiCallsInput>;
  create?: InputMaybe<KioskCreateWithoutInternalApiCallsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<KioskUpdateWithoutInternalApiCallsInput>;
  upsert?: InputMaybe<KioskUpsertWithoutInternalApiCallsInput>;
};

export type KioskUpdateWithoutCallRecordInput = {
  batteryLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  buildNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  chargingState?: InputMaybe<NullableEnumChargingStateFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigUpdateManyWithoutAssociatedKioskNestedInput>;
  dispenserLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dispenserType?: InputMaybe<NullableEnumDispenserTypeFieldUpdateOperationsInput>;
  hasDispenser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasTerminal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutKioskNestedInput>;
  isDispenserConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStripeReaderConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeUpdateManyWithoutAssociatedKioskNestedInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutKiosksNestedInput>;
  maintenanceEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  powerSwitchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rfidTagType?: InputMaybe<NullableEnumRfidTagTypeFieldUpdateOperationsInput>;
  serverUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutKiosksNestedInput>;
  terminalLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type KioskUpdateWithoutInternalApiCallsInput = {
  batteryLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  buildNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  CallRecord?: InputMaybe<CallRecordUpdateManyWithoutKioskNestedInput>;
  chargingState?: InputMaybe<NullableEnumChargingStateFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigUpdateManyWithoutAssociatedKioskNestedInput>;
  dispenserLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dispenserType?: InputMaybe<NullableEnumDispenserTypeFieldUpdateOperationsInput>;
  hasDispenser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasTerminal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDispenserConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStripeReaderConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeUpdateManyWithoutAssociatedKioskNestedInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutKiosksNestedInput>;
  maintenanceEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  powerSwitchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rfidTagType?: InputMaybe<NullableEnumRfidTagTypeFieldUpdateOperationsInput>;
  serverUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutKiosksNestedInput>;
  terminalLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type KioskUpdateWithoutLocationInput = {
  batteryLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  buildNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  CallRecord?: InputMaybe<CallRecordUpdateManyWithoutKioskNestedInput>;
  chargingState?: InputMaybe<NullableEnumChargingStateFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigUpdateManyWithoutAssociatedKioskNestedInput>;
  dispenserLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dispenserType?: InputMaybe<NullableEnumDispenserTypeFieldUpdateOperationsInput>;
  hasDispenser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasTerminal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutKioskNestedInput>;
  isDispenserConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStripeReaderConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeUpdateManyWithoutAssociatedKioskNestedInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  powerSwitchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rfidTagType?: InputMaybe<NullableEnumRfidTagTypeFieldUpdateOperationsInput>;
  serverUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutKiosksNestedInput>;
  terminalLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type KioskUpdateWithoutTenantInput = {
  batteryLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  buildNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  CallRecord?: InputMaybe<CallRecordUpdateManyWithoutKioskNestedInput>;
  chargingState?: InputMaybe<NullableEnumChargingStateFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigUpdateManyWithoutAssociatedKioskNestedInput>;
  dispenserLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  dispenserType?: InputMaybe<NullableEnumDispenserTypeFieldUpdateOperationsInput>;
  hasDispenser?: InputMaybe<BoolFieldUpdateOperationsInput>;
  hasTerminal?: InputMaybe<BoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutKioskNestedInput>;
  isDispenserConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isStripeReaderConnected?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeUpdateManyWithoutAssociatedKioskNestedInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutKiosksNestedInput>;
  maintenanceEndsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  maintenanceStartsAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  powerSwitchId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  rfidTagType?: InputMaybe<NullableEnumRfidTagTypeFieldUpdateOperationsInput>;
  serverUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  terminalLastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type KioskUpdateWithWhereUniqueWithoutLocationInput = {
  data: KioskUpdateWithoutLocationInput;
  where: KioskWhereUniqueInput;
};

export type KioskUpdateWithWhereUniqueWithoutTenantInput = {
  data: KioskUpdateWithoutTenantInput;
  where: KioskWhereUniqueInput;
};

export type KioskUpsertWithoutCallRecordInput = {
  create: KioskCreateWithoutCallRecordInput;
  update: KioskUpdateWithoutCallRecordInput;
};

export type KioskUpsertWithoutInternalApiCallsInput = {
  create: KioskCreateWithoutInternalApiCallsInput;
  update: KioskUpdateWithoutInternalApiCallsInput;
};

export type KioskUpsertWithWhereUniqueWithoutLocationInput = {
  create: KioskCreateWithoutLocationInput;
  update: KioskUpdateWithoutLocationInput;
  where: KioskWhereUniqueInput;
};

export type KioskUpsertWithWhereUniqueWithoutTenantInput = {
  create: KioskCreateWithoutTenantInput;
  update: KioskUpdateWithoutTenantInput;
  where: KioskWhereUniqueInput;
};

export type KioskWhereInput = {
  AND?: InputMaybe<Array<KioskWhereInput>>;
  batteryLevel?: InputMaybe<IntNullableFilter>;
  buildNumber?: InputMaybe<StringNullableFilter>;
  CallRecord?: InputMaybe<CallRecordListRelationFilter>;
  chargingState?: InputMaybe<EnumChargingStateNullableFilter>;
  clerkId?: InputMaybe<IntFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  dispenserConfig?: InputMaybe<KioskDispenserConfigListRelationFilter>;
  dispenserLastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  dispenserType?: InputMaybe<EnumDispenserTypeNullableFilter>;
  hasDispenser?: InputMaybe<BoolFilter>;
  hasTerminal?: InputMaybe<BoolFilter>;
  id?: InputMaybe<StringFilter>;
  internalApiCalls?: InputMaybe<InternalApiCallListRelationFilter>;
  isDispenserConnected?: InputMaybe<BoolNullableFilter>;
  isStripeReaderConnected?: InputMaybe<BoolNullableFilter>;
  kioskEnrollmentChallenge?: InputMaybe<KioskEnrollmentChallengeListRelationFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringFilter>;
  maintenanceEndsAt?: InputMaybe<DateTimeNullableFilter>;
  maintenanceStartsAt?: InputMaybe<DateTimeNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<KioskWhereInput>>;
  OR?: InputMaybe<Array<KioskWhereInput>>;
  powerSwitchId?: InputMaybe<StringNullableFilter>;
  rfidTagType?: InputMaybe<EnumRfidTagTypeNullableFilter>;
  serverUrl?: InputMaybe<StringNullableFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  terminalLastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type KioskWhereUniqueInput = {
  clerkId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Language = {
  _count?: Maybe<LanguageCount>;
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LanguageCount = {
  Localization: Scalars['Int'];
  Location: Scalars['Int'];
};


export type LanguageCountLocalizationArgs = {
  where?: InputMaybe<LocalizationWhereInput>;
};


export type LanguageCountLocationArgs = {
  where?: InputMaybe<LocationWhereInput>;
};

export type LanguageCountAggregate = {
  _all: Scalars['Int'];
  code: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
};

export type LanguageCountOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type LanguageCreateInput = {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  Localization?: InputMaybe<LocalizationCreateNestedManyWithoutLanguageInput>;
  Location?: InputMaybe<LocationCreateNestedManyWithoutLanguageInput>;
  name: Scalars['String'];
};

export type LanguageCreateManyInput = {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type LanguageCreateNestedOneWithoutLocalizationInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutLocalizationInput>;
  create?: InputMaybe<LanguageCreateWithoutLocalizationInput>;
};

export type LanguageCreateNestedOneWithoutLocationInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutLocationInput>;
  create?: InputMaybe<LanguageCreateWithoutLocationInput>;
};

export type LanguageCreateOrConnectWithoutLocalizationInput = {
  create: LanguageCreateWithoutLocalizationInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageCreateOrConnectWithoutLocationInput = {
  create: LanguageCreateWithoutLocationInput;
  where: LanguageWhereUniqueInput;
};

export type LanguageCreateWithoutLocalizationInput = {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  Location?: InputMaybe<LocationCreateNestedManyWithoutLanguageInput>;
  name: Scalars['String'];
};

export type LanguageCreateWithoutLocationInput = {
  code: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  Localization?: InputMaybe<LocalizationCreateNestedManyWithoutLanguageInput>;
  name: Scalars['String'];
};

export type LanguageGroupBy = {
  _count?: Maybe<LanguageCountAggregate>;
  _max?: Maybe<LanguageMaxAggregate>;
  _min?: Maybe<LanguageMinAggregate>;
  code: Scalars['String'];
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LanguageInfo = {
  _count?: Maybe<LanguageCount>;
  code: Scalars['String'];
  id: Scalars['String'];
  isRTL: Scalars['Boolean'];
  name: Scalars['String'];
};

export type LanguageMaxAggregate = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type LanguageMaxOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type LanguageMinAggregate = {
  code?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
};

export type LanguageMinOrderByAggregateInput = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type LanguageOrderByWithAggregationInput = {
  _count?: InputMaybe<LanguageCountOrderByAggregateInput>;
  _max?: InputMaybe<LanguageMaxOrderByAggregateInput>;
  _min?: InputMaybe<LanguageMinOrderByAggregateInput>;
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
};

export type LanguageOrderByWithRelationInput = {
  code?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  Localization?: InputMaybe<LocalizationOrderByRelationAggregateInput>;
  Location?: InputMaybe<LocationOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
};

export type LanguageRelationFilter = {
  is?: InputMaybe<LanguageWhereInput>;
  isNot?: InputMaybe<LanguageWhereInput>;
};

export enum LanguageScalarFieldEnum {
  Code = 'code',
  Id = 'id',
  Name = 'name'
}

export type LanguageScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LanguageScalarWhereWithAggregatesInput>>;
  code?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<LanguageScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LanguageScalarWhereWithAggregatesInput>>;
};

export type LanguageUpdateInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  Localization?: InputMaybe<LocalizationUpdateManyWithoutLanguageNestedInput>;
  Location?: InputMaybe<LocationUpdateManyWithoutLanguageNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUpdateManyMutationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUpdateOneRequiredWithoutLocalizationNestedInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutLocalizationInput>;
  create?: InputMaybe<LanguageCreateWithoutLocalizationInput>;
  update?: InputMaybe<LanguageUpdateWithoutLocalizationInput>;
  upsert?: InputMaybe<LanguageUpsertWithoutLocalizationInput>;
};

export type LanguageUpdateOneWithoutLocationNestedInput = {
  connect?: InputMaybe<LanguageWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LanguageCreateOrConnectWithoutLocationInput>;
  create?: InputMaybe<LanguageCreateWithoutLocationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LanguageUpdateWithoutLocationInput>;
  upsert?: InputMaybe<LanguageUpsertWithoutLocationInput>;
};

export type LanguageUpdateWithoutLocalizationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  Location?: InputMaybe<LocationUpdateManyWithoutLanguageNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUpdateWithoutLocationInput = {
  code?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  Localization?: InputMaybe<LocalizationUpdateManyWithoutLanguageNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LanguageUpsertWithoutLocalizationInput = {
  create: LanguageCreateWithoutLocalizationInput;
  update: LanguageUpdateWithoutLocalizationInput;
};

export type LanguageUpsertWithoutLocationInput = {
  create: LanguageCreateWithoutLocationInput;
  update: LanguageUpdateWithoutLocationInput;
};

export type LanguageWhereInput = {
  AND?: InputMaybe<Array<LanguageWhereInput>>;
  code?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  Localization?: InputMaybe<LocalizationListRelationFilter>;
  Location?: InputMaybe<LocationListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LanguageWhereInput>>;
  OR?: InputMaybe<Array<LanguageWhereInput>>;
};

export type LanguageWhereUniqueInput = {
  code?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type LemurXConfig = {
  disabled?: Maybe<Scalars['Boolean']>;
  readDataDelay?: Maybe<Scalars['Float']>;
  sendCommandAndReadResponseDelay?: Maybe<Scalars['Float']>;
  successStatusResponse?: Maybe<Array<Scalars['String']>>;
  writeDataDelay?: Maybe<Scalars['Float']>;
};

export type LimitKeys = {
  maxKeys?: Maybe<Scalars['Float']>;
  numKeysUsed?: Maybe<Scalars['Float']>;
};

export type LoadKioskSessionResultArgs = {
  accessGrantId: Scalars['String'];
  tenantId: Scalars['String'];
};

export type Localization = {
  componentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityType;
  id: Scalars['String'];
  languageId: Scalars['String'];
  localization: Scalars['JSON'];
};

export type LocalizationAnswer = {
  localization: Scalars['JSONObject'];
};

export type LocalizationComponentIdLanguageIdEntityIdCompoundUniqueInput = {
  componentId: Scalars['String'];
  entityId: Scalars['String'];
  languageId: Scalars['String'];
};

export type LocalizationCountAggregate = {
  _all: Scalars['Int'];
  componentId: Scalars['Int'];
  entityId: Scalars['Int'];
  entityType: Scalars['Int'];
  id: Scalars['Int'];
  languageId: Scalars['Int'];
  localization: Scalars['Int'];
};

export type LocalizationCountOrderByAggregateInput = {
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languageId?: InputMaybe<SortOrder>;
  localization?: InputMaybe<SortOrder>;
};

export type LocalizationCreateInput = {
  component: ComponentCreateNestedOneWithoutLocalizationInput;
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  language: LanguageCreateNestedOneWithoutLocalizationInput;
  localization: Scalars['JSON'];
};

export type LocalizationCreateManyComponentInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  languageId: Scalars['String'];
  localization: Scalars['JSON'];
};

export type LocalizationCreateManyComponentInputEnvelope = {
  data: Array<LocalizationCreateManyComponentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocalizationCreateManyInput = {
  componentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  languageId: Scalars['String'];
  localization: Scalars['JSON'];
};

export type LocalizationCreateManyLanguageInput = {
  componentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  localization: Scalars['JSON'];
};

export type LocalizationCreateManyLanguageInputEnvelope = {
  data: Array<LocalizationCreateManyLanguageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocalizationCreateNestedManyWithoutComponentInput = {
  connect?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocalizationCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<LocalizationCreateWithoutComponentInput>>;
  createMany?: InputMaybe<LocalizationCreateManyComponentInputEnvelope>;
};

export type LocalizationCreateNestedManyWithoutLanguageInput = {
  connect?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocalizationCreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<LocalizationCreateWithoutLanguageInput>>;
  createMany?: InputMaybe<LocalizationCreateManyLanguageInputEnvelope>;
};

export type LocalizationCreateOrConnectWithoutComponentInput = {
  create: LocalizationCreateWithoutComponentInput;
  where: LocalizationWhereUniqueInput;
};

export type LocalizationCreateOrConnectWithoutLanguageInput = {
  create: LocalizationCreateWithoutLanguageInput;
  where: LocalizationWhereUniqueInput;
};

export type LocalizationCreateWithoutComponentInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  language: LanguageCreateNestedOneWithoutLocalizationInput;
  localization: Scalars['JSON'];
};

export type LocalizationCreateWithoutLanguageInput = {
  component: ComponentCreateNestedOneWithoutLocalizationInput;
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  localization: Scalars['JSON'];
};

export type LocalizationGroupBy = {
  _count?: Maybe<LocalizationCountAggregate>;
  _max?: Maybe<LocalizationMaxAggregate>;
  _min?: Maybe<LocalizationMinAggregate>;
  componentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityType;
  id: Scalars['String'];
  languageId: Scalars['String'];
  localization: Scalars['JSON'];
};

export type LocalizationListRelationFilter = {
  every?: InputMaybe<LocalizationWhereInput>;
  none?: InputMaybe<LocalizationWhereInput>;
  some?: InputMaybe<LocalizationWhereInput>;
};

export type LocalizationMaxAggregate = {
  componentId?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EntityType>;
  id?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['String']>;
};

export type LocalizationMaxOrderByAggregateInput = {
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languageId?: InputMaybe<SortOrder>;
};

export type LocalizationMinAggregate = {
  componentId?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EntityType>;
  id?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['String']>;
};

export type LocalizationMinOrderByAggregateInput = {
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languageId?: InputMaybe<SortOrder>;
};

export type LocalizationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LocalizationOrderByWithAggregationInput = {
  _count?: InputMaybe<LocalizationCountOrderByAggregateInput>;
  _max?: InputMaybe<LocalizationMaxOrderByAggregateInput>;
  _min?: InputMaybe<LocalizationMinOrderByAggregateInput>;
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  languageId?: InputMaybe<SortOrder>;
  localization?: InputMaybe<SortOrder>;
};

export type LocalizationOrderByWithRelationInput = {
  component?: InputMaybe<ComponentOrderByWithRelationInput>;
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  language?: InputMaybe<LanguageOrderByWithRelationInput>;
  languageId?: InputMaybe<SortOrder>;
  localization?: InputMaybe<SortOrder>;
};

export enum LocalizationScalarFieldEnum {
  ComponentId = 'componentId',
  EntityId = 'entityId',
  EntityType = 'entityType',
  Id = 'id',
  LanguageId = 'languageId',
  Localization = 'localization'
}

export type LocalizationScalarWhereInput = {
  AND?: InputMaybe<Array<LocalizationScalarWhereInput>>;
  componentId?: InputMaybe<StringFilter>;
  entityId?: InputMaybe<StringFilter>;
  entityType?: InputMaybe<EnumEntityTypeFilter>;
  id?: InputMaybe<StringFilter>;
  languageId?: InputMaybe<StringFilter>;
  localization?: InputMaybe<JsonFilter>;
  NOT?: InputMaybe<Array<LocalizationScalarWhereInput>>;
  OR?: InputMaybe<Array<LocalizationScalarWhereInput>>;
};

export type LocalizationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<LocalizationScalarWhereWithAggregatesInput>>;
  componentId?: InputMaybe<StringWithAggregatesFilter>;
  entityId?: InputMaybe<StringWithAggregatesFilter>;
  entityType?: InputMaybe<EnumEntityTypeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  languageId?: InputMaybe<StringWithAggregatesFilter>;
  localization?: InputMaybe<JsonWithAggregatesFilter>;
  NOT?: InputMaybe<Array<LocalizationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<LocalizationScalarWhereWithAggregatesInput>>;
};

export type LocalizationUpdateInput = {
  component?: InputMaybe<ComponentUpdateOneRequiredWithoutLocalizationNestedInput>;
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutLocalizationNestedInput>;
  localization?: InputMaybe<Scalars['JSON']>;
};

export type LocalizationUpdateManyMutationInput = {
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  localization?: InputMaybe<Scalars['JSON']>;
};

export type LocalizationUpdateManyWithoutComponentNestedInput = {
  connect?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocalizationCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<LocalizationCreateWithoutComponentInput>>;
  createMany?: InputMaybe<LocalizationCreateManyComponentInputEnvelope>;
  delete?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocalizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocalizationUpdateWithWhereUniqueWithoutComponentInput>>;
  updateMany?: InputMaybe<Array<LocalizationUpdateManyWithWhereWithoutComponentInput>>;
  upsert?: InputMaybe<Array<LocalizationUpsertWithWhereUniqueWithoutComponentInput>>;
};

export type LocalizationUpdateManyWithoutLanguageNestedInput = {
  connect?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocalizationCreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<LocalizationCreateWithoutLanguageInput>>;
  createMany?: InputMaybe<LocalizationCreateManyLanguageInputEnvelope>;
  delete?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocalizationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocalizationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocalizationUpdateWithWhereUniqueWithoutLanguageInput>>;
  updateMany?: InputMaybe<Array<LocalizationUpdateManyWithWhereWithoutLanguageInput>>;
  upsert?: InputMaybe<Array<LocalizationUpsertWithWhereUniqueWithoutLanguageInput>>;
};

export type LocalizationUpdateManyWithWhereWithoutComponentInput = {
  data: LocalizationUpdateManyMutationInput;
  where: LocalizationScalarWhereInput;
};

export type LocalizationUpdateManyWithWhereWithoutLanguageInput = {
  data: LocalizationUpdateManyMutationInput;
  where: LocalizationScalarWhereInput;
};

export type LocalizationUpdateWithoutComponentInput = {
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  language?: InputMaybe<LanguageUpdateOneRequiredWithoutLocalizationNestedInput>;
  localization?: InputMaybe<Scalars['JSON']>;
};

export type LocalizationUpdateWithoutLanguageInput = {
  component?: InputMaybe<ComponentUpdateOneRequiredWithoutLocalizationNestedInput>;
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  localization?: InputMaybe<Scalars['JSON']>;
};

export type LocalizationUpdateWithWhereUniqueWithoutComponentInput = {
  data: LocalizationUpdateWithoutComponentInput;
  where: LocalizationWhereUniqueInput;
};

export type LocalizationUpdateWithWhereUniqueWithoutLanguageInput = {
  data: LocalizationUpdateWithoutLanguageInput;
  where: LocalizationWhereUniqueInput;
};

export type LocalizationUpsertWithWhereUniqueWithoutComponentInput = {
  create: LocalizationCreateWithoutComponentInput;
  update: LocalizationUpdateWithoutComponentInput;
  where: LocalizationWhereUniqueInput;
};

export type LocalizationUpsertWithWhereUniqueWithoutLanguageInput = {
  create: LocalizationCreateWithoutLanguageInput;
  update: LocalizationUpdateWithoutLanguageInput;
  where: LocalizationWhereUniqueInput;
};

export type LocalizationWhereInput = {
  AND?: InputMaybe<Array<LocalizationWhereInput>>;
  component?: InputMaybe<ComponentRelationFilter>;
  componentId?: InputMaybe<StringFilter>;
  entityId?: InputMaybe<StringFilter>;
  entityType?: InputMaybe<EnumEntityTypeFilter>;
  id?: InputMaybe<StringFilter>;
  language?: InputMaybe<LanguageRelationFilter>;
  languageId?: InputMaybe<StringFilter>;
  localization?: InputMaybe<JsonFilter>;
  NOT?: InputMaybe<Array<LocalizationWhereInput>>;
  OR?: InputMaybe<Array<LocalizationWhereInput>>;
};

export type LocalizationWhereUniqueInput = {
  componentId_languageId_entityId?: InputMaybe<LocalizationComponentIdLanguageIdEntityIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

/** A reference to an individual physical place where virdee and access control equipment is present. */
export type Location = {
  _count?: Maybe<LocationCount>;
  AccessGrantResId: Array<AccessGrantResId>;
  accessGrants: Array<AccessGrant>;
  address: Scalars['String'];
  amenities: Array<Amenity>;
  callRecords: Array<CallRecord>;
  Characteristic: Array<Characteristic>;
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  defaultEndTime: Scalars['String'];
  defaultRequirements: Array<DefaultRequirement>;
  defaultStartTime: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emailBccList?: Maybe<Scalars['String']>;
  emailCcList?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<Scalars['String']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  infos: Array<InfoItem>;
  kiosks: Array<Kiosk>;
  language?: Maybe<Language>;
  languageId?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: Maybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: Maybe<Scalars['Int']>;
  lng?: Maybe<Scalars['Float']>;
  LocationGroupToLocation: Array<LocationGroupToLocation>;
  logoUrl?: Maybe<Scalars['String']>;
  loyaltyConfig?: Maybe<Scalars['JSON']>;
  loyaltyType?: Maybe<LoyaltyType>;
  Membership: Array<Membership>;
  name: Scalars['String'];
  Notification: Array<Notification>;
  notificationsConfig?: Maybe<Scalars['JSON']>;
  paymentProvider?: Maybe<PaymentProvider>;
  payments: Array<Payment>;
  phoneNumber: Scalars['String'];
  pms?: Maybe<Pms>;
  pmsConfig?: Maybe<Scalars['JSON']>;
  pmsId?: Maybe<Scalars['String']>;
  pmsType?: Maybe<PmsType>;
  postalCode?: Maybe<Scalars['String']>;
  processReservations: Scalars['Boolean'];
  resourceGroups: Array<ResourceGroup>;
  resources: Array<Resource>;
  securityDeposit?: Maybe<Scalars['Float']>;
  securityDepositPolicy: SecurityDepositPolicy;
  ServiceCategory: Array<ServiceCategory>;
  services: Array<Service>;
  tenant: Tenant;
  tenantId: Scalars['String'];
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes: Array<UnitType>;
  updatedAt: Scalars['DateTime'];
  UserLocationData: Array<UserLocationData>;
  vendorServers: Array<VendorServer>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationAccessGrantResIdArgs = {
  cursor?: InputMaybe<AccessGrantResIdWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantResIdScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantResIdOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantResIdWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationAmenitiesArgs = {
  cursor?: InputMaybe<AmenityWhereUniqueInput>;
  distinct?: InputMaybe<Array<AmenityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AmenityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationCharacteristicArgs = {
  cursor?: InputMaybe<CharacteristicWhereUniqueInput>;
  distinct?: InputMaybe<Array<CharacteristicScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CharacteristicOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CharacteristicWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationDefaultRequirementsArgs = {
  cursor?: InputMaybe<DefaultRequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<DefaultRequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DefaultRequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DefaultRequirementWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationInfosArgs = {
  cursor?: InputMaybe<InfoItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<InfoItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationKiosksArgs = {
  cursor?: InputMaybe<KioskWhereUniqueInput>;
  distinct?: InputMaybe<Array<KioskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationLocationGroupToLocationArgs = {
  cursor?: InputMaybe<LocationGroupToLocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationGroupToLocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationGroupToLocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationGroupToLocationWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationMembershipArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationResourceGroupsArgs = {
  cursor?: InputMaybe<ResourceGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationServiceCategoryArgs = {
  cursor?: InputMaybe<ServiceCategoryWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceCategoryScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceCategoryOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceCategoryWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationServicesArgs = {
  cursor?: InputMaybe<ServiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationUnitTypesArgs = {
  cursor?: InputMaybe<UnitTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<UnitTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UnitTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitTypeWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationUserLocationDataArgs = {
  cursor?: InputMaybe<UserLocationDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserLocationDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserLocationDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserLocationDataWhereInput>;
};


/** A reference to an individual physical place where virdee and access control equipment is present. */
export type LocationVendorServersArgs = {
  cursor?: InputMaybe<VendorServerWhereUniqueInput>;
  distinct?: InputMaybe<Array<VendorServerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VendorServerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VendorServerWhereInput>;
};

export type LocationAvgAggregate = {
  lat?: Maybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: Maybe<Scalars['Float']>;
  limitOfWritingAttemptsOnPrintingRetry?: Maybe<Scalars['Float']>;
  lng?: Maybe<Scalars['Float']>;
  securityDeposit?: Maybe<Scalars['Float']>;
};

export type LocationAvgOrderByAggregateInput = {
  lat?: InputMaybe<SortOrder>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<SortOrder>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
  securityDeposit?: InputMaybe<SortOrder>;
};

export type LocationCount = {
  AccessGrantResId: Scalars['Int'];
  accessGrants: Scalars['Int'];
  amenities: Scalars['Int'];
  callRecords: Scalars['Int'];
  Characteristic: Scalars['Int'];
  defaultRequirements: Scalars['Int'];
  infos: Scalars['Int'];
  kiosks: Scalars['Int'];
  LocationGroupToLocation: Scalars['Int'];
  Membership: Scalars['Int'];
  Notification: Scalars['Int'];
  payments: Scalars['Int'];
  resourceGroups: Scalars['Int'];
  resources: Scalars['Int'];
  ServiceCategory: Scalars['Int'];
  services: Scalars['Int'];
  unitTypes: Scalars['Int'];
  UserLocationData: Scalars['Int'];
  vendorServers: Scalars['Int'];
};


export type LocationCountAccessGrantResIdArgs = {
  where?: InputMaybe<AccessGrantResIdWhereInput>;
};


export type LocationCountAccessGrantsArgs = {
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type LocationCountAmenitiesArgs = {
  where?: InputMaybe<AmenityWhereInput>;
};


export type LocationCountCallRecordsArgs = {
  where?: InputMaybe<CallRecordWhereInput>;
};


export type LocationCountCharacteristicArgs = {
  where?: InputMaybe<CharacteristicWhereInput>;
};


export type LocationCountDefaultRequirementsArgs = {
  where?: InputMaybe<DefaultRequirementWhereInput>;
};


export type LocationCountInfosArgs = {
  where?: InputMaybe<InfoItemWhereInput>;
};


export type LocationCountKiosksArgs = {
  where?: InputMaybe<KioskWhereInput>;
};


export type LocationCountLocationGroupToLocationArgs = {
  where?: InputMaybe<LocationGroupToLocationWhereInput>;
};


export type LocationCountMembershipArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};


export type LocationCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type LocationCountPaymentsArgs = {
  where?: InputMaybe<PaymentWhereInput>;
};


export type LocationCountResourceGroupsArgs = {
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type LocationCountResourcesArgs = {
  where?: InputMaybe<ResourceWhereInput>;
};


export type LocationCountServiceCategoryArgs = {
  where?: InputMaybe<ServiceCategoryWhereInput>;
};


export type LocationCountServicesArgs = {
  where?: InputMaybe<ServiceWhereInput>;
};


export type LocationCountUnitTypesArgs = {
  where?: InputMaybe<UnitTypeWhereInput>;
};


export type LocationCountUserLocationDataArgs = {
  where?: InputMaybe<UserLocationDataWhereInput>;
};


export type LocationCountVendorServersArgs = {
  where?: InputMaybe<VendorServerWhereInput>;
};

export type LocationCountAggregate = {
  _all: Scalars['Int'];
  address: Scalars['Int'];
  countryCode: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultEndTime: Scalars['Int'];
  defaultStartTime: Scalars['Int'];
  email: Scalars['Int'];
  emailBccList: Scalars['Int'];
  emailCcList: Scalars['Int'];
  emailFrom: Scalars['Int'];
  emailTemplateId: Scalars['Int'];
  externalId: Scalars['Int'];
  iconUrl: Scalars['Int'];
  id: Scalars['Int'];
  imageUrl: Scalars['Int'];
  languageId: Scalars['Int'];
  lat: Scalars['Int'];
  limitOfCardsToUseOnPrintingRetry: Scalars['Int'];
  limitOfWritingAttemptsOnPrintingRetry: Scalars['Int'];
  lng: Scalars['Int'];
  logoUrl: Scalars['Int'];
  loyaltyConfig: Scalars['Int'];
  loyaltyType: Scalars['Int'];
  name: Scalars['Int'];
  notificationsConfig: Scalars['Int'];
  phoneNumber: Scalars['Int'];
  pmsConfig: Scalars['Int'];
  pmsId: Scalars['Int'];
  pmsType: Scalars['Int'];
  postalCode: Scalars['Int'];
  processReservations: Scalars['Int'];
  securityDeposit: Scalars['Int'];
  securityDepositPolicy: Scalars['Int'];
  tenantId: Scalars['Int'];
  termsAndConditionsUrl: Scalars['Int'];
  timezone: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type LocationCountOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEndTime?: InputMaybe<SortOrder>;
  defaultStartTime?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailBccList?: InputMaybe<SortOrder>;
  emailCcList?: InputMaybe<SortOrder>;
  emailFrom?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  iconUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  languageId?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<SortOrder>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
  logoUrl?: InputMaybe<SortOrder>;
  loyaltyConfig?: InputMaybe<SortOrder>;
  loyaltyType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  notificationsConfig?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  pmsConfig?: InputMaybe<SortOrder>;
  pmsId?: InputMaybe<SortOrder>;
  pmsType?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  processReservations?: InputMaybe<SortOrder>;
  securityDeposit?: InputMaybe<SortOrder>;
  securityDepositPolicy?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  termsAndConditionsUrl?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationCreateInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateManyInput = {
  address: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  name: Scalars['String'];
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  phoneNumber: Scalars['String'];
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsId?: InputMaybe<Scalars['String']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  tenantId: Scalars['String'];
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateManyLanguageInput = {
  address: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  name: Scalars['String'];
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  phoneNumber: Scalars['String'];
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsId?: InputMaybe<Scalars['String']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  tenantId: Scalars['String'];
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateManyLanguageInputEnvelope = {
  data: Array<LocationCreateManyLanguageInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationCreateManyPmsInput = {
  address: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  name: Scalars['String'];
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  phoneNumber: Scalars['String'];
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  tenantId: Scalars['String'];
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateManyPmsInputEnvelope = {
  data: Array<LocationCreateManyPmsInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationCreateManyTenantInput = {
  address: Scalars['String'];
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  languageId?: InputMaybe<Scalars['String']>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  name: Scalars['String'];
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  phoneNumber: Scalars['String'];
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsId?: InputMaybe<Scalars['String']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type LocationCreateManyTenantInputEnvelope = {
  data: Array<LocationCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationCreateNestedManyWithoutLanguageInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutLanguageInput>>;
  createMany?: InputMaybe<LocationCreateManyLanguageInputEnvelope>;
};

export type LocationCreateNestedManyWithoutPmsInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutPmsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutPmsInput>>;
  createMany?: InputMaybe<LocationCreateManyPmsInputEnvelope>;
};

export type LocationCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutTenantInput>>;
  createMany?: InputMaybe<LocationCreateManyTenantInputEnvelope>;
};

export type LocationCreateNestedOneWithoutAccessGrantResIdInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutAccessGrantResIdInput>;
  create?: InputMaybe<LocationCreateWithoutAccessGrantResIdInput>;
};

export type LocationCreateNestedOneWithoutAccessGrantsInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutAccessGrantsInput>;
  create?: InputMaybe<LocationCreateWithoutAccessGrantsInput>;
};

export type LocationCreateNestedOneWithoutAmenitiesInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutAmenitiesInput>;
  create?: InputMaybe<LocationCreateWithoutAmenitiesInput>;
};

export type LocationCreateNestedOneWithoutCallRecordsInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutCallRecordsInput>;
  create?: InputMaybe<LocationCreateWithoutCallRecordsInput>;
};

export type LocationCreateNestedOneWithoutInfosInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutInfosInput>;
  create?: InputMaybe<LocationCreateWithoutInfosInput>;
};

export type LocationCreateNestedOneWithoutKiosksInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutKiosksInput>;
  create?: InputMaybe<LocationCreateWithoutKiosksInput>;
};

export type LocationCreateNestedOneWithoutLocationGroupToLocationInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutLocationGroupToLocationInput>;
  create?: InputMaybe<LocationCreateWithoutLocationGroupToLocationInput>;
};

export type LocationCreateNestedOneWithoutMembershipInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutMembershipInput>;
  create?: InputMaybe<LocationCreateWithoutMembershipInput>;
};

export type LocationCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<LocationCreateWithoutNotificationInput>;
};

export type LocationCreateNestedOneWithoutPaymentProviderInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutPaymentProviderInput>;
  create?: InputMaybe<LocationCreateWithoutPaymentProviderInput>;
};

export type LocationCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<LocationCreateWithoutPaymentsInput>;
};

export type LocationCreateNestedOneWithoutResourceGroupsInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutResourceGroupsInput>;
  create?: InputMaybe<LocationCreateWithoutResourceGroupsInput>;
};

export type LocationCreateNestedOneWithoutResourcesInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutResourcesInput>;
  create?: InputMaybe<LocationCreateWithoutResourcesInput>;
};

export type LocationCreateNestedOneWithoutServiceCategoryInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutServiceCategoryInput>;
  create?: InputMaybe<LocationCreateWithoutServiceCategoryInput>;
};

export type LocationCreateNestedOneWithoutServicesInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutServicesInput>;
  create?: InputMaybe<LocationCreateWithoutServicesInput>;
};

export type LocationCreateNestedOneWithoutUnitTypesInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutUnitTypesInput>;
  create?: InputMaybe<LocationCreateWithoutUnitTypesInput>;
};

export type LocationCreateNestedOneWithoutUserLocationDataInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutUserLocationDataInput>;
  create?: InputMaybe<LocationCreateWithoutUserLocationDataInput>;
};

export type LocationCreateNestedOneWithoutVendorServersInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutVendorServersInput>;
  create?: InputMaybe<LocationCreateWithoutVendorServersInput>;
};

export type LocationCreateOrConnectWithoutAccessGrantResIdInput = {
  create: LocationCreateWithoutAccessGrantResIdInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutAccessGrantsInput = {
  create: LocationCreateWithoutAccessGrantsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutAmenitiesInput = {
  create: LocationCreateWithoutAmenitiesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutCallRecordsInput = {
  create: LocationCreateWithoutCallRecordsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutInfosInput = {
  create: LocationCreateWithoutInfosInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutKiosksInput = {
  create: LocationCreateWithoutKiosksInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutLanguageInput = {
  create: LocationCreateWithoutLanguageInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutLocationGroupToLocationInput = {
  create: LocationCreateWithoutLocationGroupToLocationInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutMembershipInput = {
  create: LocationCreateWithoutMembershipInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutNotificationInput = {
  create: LocationCreateWithoutNotificationInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutPaymentProviderInput = {
  create: LocationCreateWithoutPaymentProviderInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutPaymentsInput = {
  create: LocationCreateWithoutPaymentsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutPmsInput = {
  create: LocationCreateWithoutPmsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutResourceGroupsInput = {
  create: LocationCreateWithoutResourceGroupsInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutResourcesInput = {
  create: LocationCreateWithoutResourcesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutServiceCategoryInput = {
  create: LocationCreateWithoutServiceCategoryInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutServicesInput = {
  create: LocationCreateWithoutServicesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutTenantInput = {
  create: LocationCreateWithoutTenantInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutUnitTypesInput = {
  create: LocationCreateWithoutUnitTypesInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutUserLocationDataInput = {
  create: LocationCreateWithoutUserLocationDataInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateOrConnectWithoutVendorServersInput = {
  create: LocationCreateWithoutVendorServersInput;
  where: LocationWhereUniqueInput;
};

export type LocationCreateWithoutAccessGrantResIdInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutAccessGrantsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutAmenitiesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutCallRecordsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutInfosInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutKiosksInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutLanguageInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutLocationGroupToLocationInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutMembershipInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutNotificationInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutPaymentProviderInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutPaymentsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutPmsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutResourceGroupsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutResourcesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutServiceCategoryInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutServicesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutTenantInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutUnitTypesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutUserLocationDataInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendorServers?: InputMaybe<VendorServerCreateNestedManyWithoutLocationInput>;
};

export type LocationCreateWithoutVendorServersInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdCreateNestedManyWithoutLocationInput>;
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutLocationInput>;
  address: Scalars['String'];
  amenities?: InputMaybe<AmenityCreateNestedManyWithoutLocationInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutLocationInput>;
  Characteristic?: InputMaybe<CharacteristicCreateNestedManyWithoutLocationInput>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEndTime?: InputMaybe<Scalars['String']>;
  defaultRequirements?: InputMaybe<DefaultRequirementCreateNestedManyWithoutLocationInput>;
  defaultStartTime?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  emailBccList?: InputMaybe<Scalars['String']>;
  emailCcList?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  emailTemplateId?: InputMaybe<Scalars['String']>;
  externalId?: InputMaybe<Scalars['String']>;
  iconUrl?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  infos?: InputMaybe<InfoItemCreateNestedManyWithoutLocationInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutLocationInput>;
  language?: InputMaybe<LanguageCreateNestedOneWithoutLocationInput>;
  lat?: InputMaybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<Scalars['Int']>;
  lng?: InputMaybe<Scalars['Float']>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationInput>;
  logoUrl?: InputMaybe<Scalars['String']>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<LoyaltyType>;
  Membership?: InputMaybe<MembershipCreateNestedManyWithoutLocationInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutLocationInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutLocationInput>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutLocationInput>;
  phoneNumber: Scalars['String'];
  pms?: InputMaybe<PmsCreateNestedOneWithoutLocationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<PmsType>;
  postalCode?: InputMaybe<Scalars['String']>;
  processReservations?: InputMaybe<Scalars['Boolean']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutLocationInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutLocationInput>;
  securityDeposit?: InputMaybe<Scalars['Float']>;
  securityDepositPolicy?: InputMaybe<SecurityDepositPolicy>;
  ServiceCategory?: InputMaybe<ServiceCategoryCreateNestedManyWithoutLocationInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutLocationInput>;
  tenant: TenantCreateNestedOneWithoutLocationsInput;
  termsAndConditionsUrl?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
  unitTypes?: InputMaybe<UnitTypeCreateNestedManyWithoutLocationInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutLocationInput>;
};

export type LocationData = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LocationGroup = {
  _count?: Maybe<LocationGroupCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  name: Scalars['String'];
  tenantId: Scalars['String'];
};

export type LocationGroupBy = {
  _avg?: Maybe<LocationAvgAggregate>;
  _count?: Maybe<LocationCountAggregate>;
  _max?: Maybe<LocationMaxAggregate>;
  _min?: Maybe<LocationMinAggregate>;
  _sum?: Maybe<LocationSumAggregate>;
  address: Scalars['String'];
  countryCode: Scalars['String'];
  createdAt: Scalars['DateTime'];
  defaultEndTime: Scalars['String'];
  defaultStartTime: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  emailBccList?: Maybe<Scalars['String']>;
  emailCcList?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<Scalars['String']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: Maybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: Maybe<Scalars['Int']>;
  lng?: Maybe<Scalars['Float']>;
  logoUrl?: Maybe<Scalars['String']>;
  loyaltyConfig?: Maybe<Scalars['JSON']>;
  loyaltyType?: Maybe<LoyaltyType>;
  name: Scalars['String'];
  notificationsConfig?: Maybe<Scalars['JSON']>;
  phoneNumber: Scalars['String'];
  pmsConfig?: Maybe<Scalars['JSON']>;
  pmsId?: Maybe<Scalars['String']>;
  pmsType?: Maybe<PmsType>;
  postalCode?: Maybe<Scalars['String']>;
  processReservations: Scalars['Boolean'];
  securityDeposit?: Maybe<Scalars['Float']>;
  securityDepositPolicy: SecurityDepositPolicy;
  tenantId: Scalars['String'];
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
  timezone: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type LocationGroupCount = {
  locationGroupAsChild: Scalars['Int'];
  locationGroupAsParent: Scalars['Int'];
  locations: Scalars['Int'];
  memberships: Scalars['Int'];
};


export type LocationGroupCountLocationGroupAsChildArgs = {
  where?: InputMaybe<LocationGroupToGroupWhereInput>;
};


export type LocationGroupCountLocationGroupAsParentArgs = {
  where?: InputMaybe<LocationGroupToGroupWhereInput>;
};


export type LocationGroupCountLocationsArgs = {
  where?: InputMaybe<LocationGroupToLocationWhereInput>;
};


export type LocationGroupCountMembershipsArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};

export type LocationGroupCreateManyTenantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
};

export type LocationGroupCreateManyTenantInputEnvelope = {
  data: Array<LocationGroupCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationGroupCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<LocationGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<LocationGroupCreateWithoutTenantInput>>;
  createMany?: InputMaybe<LocationGroupCreateManyTenantInputEnvelope>;
};

export type LocationGroupCreateNestedOneWithoutLocationGroupAsChildInput = {
  connect?: InputMaybe<LocationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationGroupCreateOrConnectWithoutLocationGroupAsChildInput>;
  create?: InputMaybe<LocationGroupCreateWithoutLocationGroupAsChildInput>;
};

export type LocationGroupCreateNestedOneWithoutLocationGroupAsParentInput = {
  connect?: InputMaybe<LocationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationGroupCreateOrConnectWithoutLocationGroupAsParentInput>;
  create?: InputMaybe<LocationGroupCreateWithoutLocationGroupAsParentInput>;
};

export type LocationGroupCreateNestedOneWithoutLocationsInput = {
  connect?: InputMaybe<LocationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationGroupCreateOrConnectWithoutLocationsInput>;
  create?: InputMaybe<LocationGroupCreateWithoutLocationsInput>;
};

export type LocationGroupCreateNestedOneWithoutMembershipsInput = {
  connect?: InputMaybe<LocationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationGroupCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<LocationGroupCreateWithoutMembershipsInput>;
};

export type LocationGroupCreateOrConnectWithoutLocationGroupAsChildInput = {
  create: LocationGroupCreateWithoutLocationGroupAsChildInput;
  where: LocationGroupWhereUniqueInput;
};

export type LocationGroupCreateOrConnectWithoutLocationGroupAsParentInput = {
  create: LocationGroupCreateWithoutLocationGroupAsParentInput;
  where: LocationGroupWhereUniqueInput;
};

export type LocationGroupCreateOrConnectWithoutLocationsInput = {
  create: LocationGroupCreateWithoutLocationsInput;
  where: LocationGroupWhereUniqueInput;
};

export type LocationGroupCreateOrConnectWithoutMembershipsInput = {
  create: LocationGroupCreateWithoutMembershipsInput;
  where: LocationGroupWhereUniqueInput;
};

export type LocationGroupCreateOrConnectWithoutTenantInput = {
  create: LocationGroupCreateWithoutTenantInput;
  where: LocationGroupWhereUniqueInput;
};

export type LocationGroupCreateWithoutLocationGroupAsChildInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupCreateNestedManyWithoutParentLocationGroupInput>;
  locations?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationGroupInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutLocationGroupInput>;
  name: Scalars['String'];
  tenant: TenantCreateNestedOneWithoutLocationGroupsInput;
};

export type LocationGroupCreateWithoutLocationGroupAsParentInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupCreateNestedManyWithoutLocationGroupInput>;
  locations?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationGroupInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutLocationGroupInput>;
  name: Scalars['String'];
  tenant: TenantCreateNestedOneWithoutLocationGroupsInput;
};

export type LocationGroupCreateWithoutLocationsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupCreateNestedManyWithoutLocationGroupInput>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupCreateNestedManyWithoutParentLocationGroupInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutLocationGroupInput>;
  name: Scalars['String'];
  tenant: TenantCreateNestedOneWithoutLocationGroupsInput;
};

export type LocationGroupCreateWithoutMembershipsInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupCreateNestedManyWithoutLocationGroupInput>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupCreateNestedManyWithoutParentLocationGroupInput>;
  locations?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationGroupInput>;
  name: Scalars['String'];
  tenant: TenantCreateNestedOneWithoutLocationGroupsInput;
};

export type LocationGroupCreateWithoutTenantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupCreateNestedManyWithoutLocationGroupInput>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupCreateNestedManyWithoutParentLocationGroupInput>;
  locations?: InputMaybe<LocationGroupToLocationCreateNestedManyWithoutLocationGroupInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutLocationGroupInput>;
  name: Scalars['String'];
};

export type LocationGroupData = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LocationGroupDataWithLocationIds = {
  id: Scalars['String'];
  locationIds?: Maybe<Array<Scalars['String']>>;
  name: Scalars['String'];
};

export type LocationGroupListRelationFilter = {
  every?: InputMaybe<LocationGroupWhereInput>;
  none?: InputMaybe<LocationGroupWhereInput>;
  some?: InputMaybe<LocationGroupWhereInput>;
};

export type LocationGroupNameTenantIdCompoundUniqueInput = {
  name: Scalars['String'];
  tenantId: Scalars['String'];
};

export type LocationGroupNodeResponse = {
  id: Scalars['String'];
  locations?: Maybe<Array<LocationData>>;
  name: Scalars['String'];
  parentGroupIds?: Maybe<Array<Scalars['String']>>;
};

export type LocationGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LocationGroupOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupOrderByRelationAggregateInput>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupOrderByRelationAggregateInput>;
  locations?: InputMaybe<LocationGroupToLocationOrderByRelationAggregateInput>;
  memberships?: InputMaybe<MembershipOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
};

export type LocationGroupRelationFilter = {
  is?: InputMaybe<LocationGroupWhereInput>;
  isNot?: InputMaybe<LocationGroupWhereInput>;
};

export type LocationGroupResponse = {
  groups?: Maybe<Array<LocationGroupData>>;
  id: Scalars['String'];
  locations?: Maybe<Array<LocationData>>;
  name: Scalars['String'];
};

export enum LocationGroupScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  Name = 'name',
  TenantId = 'tenantId'
}

export type LocationGroupScalarWhereInput = {
  AND?: InputMaybe<Array<LocationGroupScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LocationGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<LocationGroupScalarWhereInput>>;
  tenantId?: InputMaybe<StringFilter>;
};

export type LocationGroupToGroupCreateManyLocationGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  parentLocationGroupId: Scalars['String'];
};

export type LocationGroupToGroupCreateManyLocationGroupInputEnvelope = {
  data: Array<LocationGroupToGroupCreateManyLocationGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationGroupToGroupCreateManyParentLocationGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  locationGroupId: Scalars['String'];
};

export type LocationGroupToGroupCreateManyParentLocationGroupInputEnvelope = {
  data: Array<LocationGroupToGroupCreateManyParentLocationGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationGroupToGroupCreateNestedManyWithoutLocationGroupInput = {
  connect?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupToGroupCreateOrConnectWithoutLocationGroupInput>>;
  create?: InputMaybe<Array<LocationGroupToGroupCreateWithoutLocationGroupInput>>;
  createMany?: InputMaybe<LocationGroupToGroupCreateManyLocationGroupInputEnvelope>;
};

export type LocationGroupToGroupCreateNestedManyWithoutParentLocationGroupInput = {
  connect?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupToGroupCreateOrConnectWithoutParentLocationGroupInput>>;
  create?: InputMaybe<Array<LocationGroupToGroupCreateWithoutParentLocationGroupInput>>;
  createMany?: InputMaybe<LocationGroupToGroupCreateManyParentLocationGroupInputEnvelope>;
};

export type LocationGroupToGroupCreateOrConnectWithoutLocationGroupInput = {
  create: LocationGroupToGroupCreateWithoutLocationGroupInput;
  where: LocationGroupToGroupWhereUniqueInput;
};

export type LocationGroupToGroupCreateOrConnectWithoutParentLocationGroupInput = {
  create: LocationGroupToGroupCreateWithoutParentLocationGroupInput;
  where: LocationGroupToGroupWhereUniqueInput;
};

export type LocationGroupToGroupCreateWithoutLocationGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  parentLocationGroup: LocationGroupCreateNestedOneWithoutLocationGroupAsParentInput;
};

export type LocationGroupToGroupCreateWithoutParentLocationGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  locationGroup: LocationGroupCreateNestedOneWithoutLocationGroupAsChildInput;
};

export type LocationGroupToGroupListRelationFilter = {
  every?: InputMaybe<LocationGroupToGroupWhereInput>;
  none?: InputMaybe<LocationGroupToGroupWhereInput>;
  some?: InputMaybe<LocationGroupToGroupWhereInput>;
};

export type LocationGroupToGroupLocationGroupIdParentLocationGroupIdCompoundUniqueInput = {
  locationGroupId: Scalars['String'];
  parentLocationGroupId: Scalars['String'];
};

export type LocationGroupToGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LocationGroupToGroupScalarWhereInput = {
  AND?: InputMaybe<Array<LocationGroupToGroupScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  locationGroupId?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LocationGroupToGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<LocationGroupToGroupScalarWhereInput>>;
  parentLocationGroupId?: InputMaybe<StringFilter>;
};

export type LocationGroupToGroupUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationGroupToGroupUpdateManyWithoutLocationGroupNestedInput = {
  connect?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupToGroupCreateOrConnectWithoutLocationGroupInput>>;
  create?: InputMaybe<Array<LocationGroupToGroupCreateWithoutLocationGroupInput>>;
  createMany?: InputMaybe<LocationGroupToGroupCreateManyLocationGroupInputEnvelope>;
  delete?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationGroupToGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationGroupToGroupUpdateWithWhereUniqueWithoutLocationGroupInput>>;
  updateMany?: InputMaybe<Array<LocationGroupToGroupUpdateManyWithWhereWithoutLocationGroupInput>>;
  upsert?: InputMaybe<Array<LocationGroupToGroupUpsertWithWhereUniqueWithoutLocationGroupInput>>;
};

export type LocationGroupToGroupUpdateManyWithoutParentLocationGroupNestedInput = {
  connect?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupToGroupCreateOrConnectWithoutParentLocationGroupInput>>;
  create?: InputMaybe<Array<LocationGroupToGroupCreateWithoutParentLocationGroupInput>>;
  createMany?: InputMaybe<LocationGroupToGroupCreateManyParentLocationGroupInputEnvelope>;
  delete?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationGroupToGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationGroupToGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationGroupToGroupUpdateWithWhereUniqueWithoutParentLocationGroupInput>>;
  updateMany?: InputMaybe<Array<LocationGroupToGroupUpdateManyWithWhereWithoutParentLocationGroupInput>>;
  upsert?: InputMaybe<Array<LocationGroupToGroupUpsertWithWhereUniqueWithoutParentLocationGroupInput>>;
};

export type LocationGroupToGroupUpdateManyWithWhereWithoutLocationGroupInput = {
  data: LocationGroupToGroupUpdateManyMutationInput;
  where: LocationGroupToGroupScalarWhereInput;
};

export type LocationGroupToGroupUpdateManyWithWhereWithoutParentLocationGroupInput = {
  data: LocationGroupToGroupUpdateManyMutationInput;
  where: LocationGroupToGroupScalarWhereInput;
};

export type LocationGroupToGroupUpdateWithoutLocationGroupInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  parentLocationGroup?: InputMaybe<LocationGroupUpdateOneRequiredWithoutLocationGroupAsParentNestedInput>;
};

export type LocationGroupToGroupUpdateWithoutParentLocationGroupInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  locationGroup?: InputMaybe<LocationGroupUpdateOneRequiredWithoutLocationGroupAsChildNestedInput>;
};

export type LocationGroupToGroupUpdateWithWhereUniqueWithoutLocationGroupInput = {
  data: LocationGroupToGroupUpdateWithoutLocationGroupInput;
  where: LocationGroupToGroupWhereUniqueInput;
};

export type LocationGroupToGroupUpdateWithWhereUniqueWithoutParentLocationGroupInput = {
  data: LocationGroupToGroupUpdateWithoutParentLocationGroupInput;
  where: LocationGroupToGroupWhereUniqueInput;
};

export type LocationGroupToGroupUpsertWithWhereUniqueWithoutLocationGroupInput = {
  create: LocationGroupToGroupCreateWithoutLocationGroupInput;
  update: LocationGroupToGroupUpdateWithoutLocationGroupInput;
  where: LocationGroupToGroupWhereUniqueInput;
};

export type LocationGroupToGroupUpsertWithWhereUniqueWithoutParentLocationGroupInput = {
  create: LocationGroupToGroupCreateWithoutParentLocationGroupInput;
  update: LocationGroupToGroupUpdateWithoutParentLocationGroupInput;
  where: LocationGroupToGroupWhereUniqueInput;
};

export type LocationGroupToGroupWhereInput = {
  AND?: InputMaybe<Array<LocationGroupToGroupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  locationGroup?: InputMaybe<LocationGroupRelationFilter>;
  locationGroupId?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LocationGroupToGroupWhereInput>>;
  OR?: InputMaybe<Array<LocationGroupToGroupWhereInput>>;
  parentLocationGroup?: InputMaybe<LocationGroupRelationFilter>;
  parentLocationGroupId?: InputMaybe<StringFilter>;
};

export type LocationGroupToGroupWhereUniqueInput = {
  locationGroupId_parentLocationGroupId?: InputMaybe<LocationGroupToGroupLocationGroupIdParentLocationGroupIdCompoundUniqueInput>;
};

export type LocationGroupToLocation = {
  createdAt: Scalars['DateTime'];
  locationGroupId: Scalars['String'];
  locationId: Scalars['String'];
};

export type LocationGroupToLocationCreateManyLocationGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  locationId: Scalars['String'];
};

export type LocationGroupToLocationCreateManyLocationGroupInputEnvelope = {
  data: Array<LocationGroupToLocationCreateManyLocationGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationGroupToLocationCreateManyLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  locationGroupId: Scalars['String'];
};

export type LocationGroupToLocationCreateManyLocationInputEnvelope = {
  data: Array<LocationGroupToLocationCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type LocationGroupToLocationCreateNestedManyWithoutLocationGroupInput = {
  connect?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupToLocationCreateOrConnectWithoutLocationGroupInput>>;
  create?: InputMaybe<Array<LocationGroupToLocationCreateWithoutLocationGroupInput>>;
  createMany?: InputMaybe<LocationGroupToLocationCreateManyLocationGroupInputEnvelope>;
};

export type LocationGroupToLocationCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupToLocationCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<LocationGroupToLocationCreateWithoutLocationInput>>;
  createMany?: InputMaybe<LocationGroupToLocationCreateManyLocationInputEnvelope>;
};

export type LocationGroupToLocationCreateOrConnectWithoutLocationGroupInput = {
  create: LocationGroupToLocationCreateWithoutLocationGroupInput;
  where: LocationGroupToLocationWhereUniqueInput;
};

export type LocationGroupToLocationCreateOrConnectWithoutLocationInput = {
  create: LocationGroupToLocationCreateWithoutLocationInput;
  where: LocationGroupToLocationWhereUniqueInput;
};

export type LocationGroupToLocationCreateWithoutLocationGroupInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  location: LocationCreateNestedOneWithoutLocationGroupToLocationInput;
};

export type LocationGroupToLocationCreateWithoutLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  locationGroup: LocationGroupCreateNestedOneWithoutLocationsInput;
};

export type LocationGroupToLocationListRelationFilter = {
  every?: InputMaybe<LocationGroupToLocationWhereInput>;
  none?: InputMaybe<LocationGroupToLocationWhereInput>;
  some?: InputMaybe<LocationGroupToLocationWhereInput>;
};

export type LocationGroupToLocationLocationGroupIdLocationIdCompoundUniqueInput = {
  locationGroupId: Scalars['String'];
  locationId: Scalars['String'];
};

export type LocationGroupToLocationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LocationGroupToLocationOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationGroup?: InputMaybe<LocationGroupOrderByWithRelationInput>;
  locationGroupId?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
};

export enum LocationGroupToLocationScalarFieldEnum {
  CreatedAt = 'createdAt',
  LocationGroupId = 'locationGroupId',
  LocationId = 'locationId'
}

export type LocationGroupToLocationScalarWhereInput = {
  AND?: InputMaybe<Array<LocationGroupToLocationScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  locationGroupId?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LocationGroupToLocationScalarWhereInput>>;
  OR?: InputMaybe<Array<LocationGroupToLocationScalarWhereInput>>;
};

export type LocationGroupToLocationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationGroupToLocationUpdateManyWithoutLocationGroupNestedInput = {
  connect?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupToLocationCreateOrConnectWithoutLocationGroupInput>>;
  create?: InputMaybe<Array<LocationGroupToLocationCreateWithoutLocationGroupInput>>;
  createMany?: InputMaybe<LocationGroupToLocationCreateManyLocationGroupInputEnvelope>;
  delete?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationGroupToLocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationGroupToLocationUpdateWithWhereUniqueWithoutLocationGroupInput>>;
  updateMany?: InputMaybe<Array<LocationGroupToLocationUpdateManyWithWhereWithoutLocationGroupInput>>;
  upsert?: InputMaybe<Array<LocationGroupToLocationUpsertWithWhereUniqueWithoutLocationGroupInput>>;
};

export type LocationGroupToLocationUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupToLocationCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<LocationGroupToLocationCreateWithoutLocationInput>>;
  createMany?: InputMaybe<LocationGroupToLocationCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationGroupToLocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationGroupToLocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationGroupToLocationUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<LocationGroupToLocationUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<LocationGroupToLocationUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type LocationGroupToLocationUpdateManyWithWhereWithoutLocationGroupInput = {
  data: LocationGroupToLocationUpdateManyMutationInput;
  where: LocationGroupToLocationScalarWhereInput;
};

export type LocationGroupToLocationUpdateManyWithWhereWithoutLocationInput = {
  data: LocationGroupToLocationUpdateManyMutationInput;
  where: LocationGroupToLocationScalarWhereInput;
};

export type LocationGroupToLocationUpdateWithoutLocationGroupInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutLocationGroupToLocationNestedInput>;
};

export type LocationGroupToLocationUpdateWithoutLocationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  locationGroup?: InputMaybe<LocationGroupUpdateOneRequiredWithoutLocationsNestedInput>;
};

export type LocationGroupToLocationUpdateWithWhereUniqueWithoutLocationGroupInput = {
  data: LocationGroupToLocationUpdateWithoutLocationGroupInput;
  where: LocationGroupToLocationWhereUniqueInput;
};

export type LocationGroupToLocationUpdateWithWhereUniqueWithoutLocationInput = {
  data: LocationGroupToLocationUpdateWithoutLocationInput;
  where: LocationGroupToLocationWhereUniqueInput;
};

export type LocationGroupToLocationUpsertWithWhereUniqueWithoutLocationGroupInput = {
  create: LocationGroupToLocationCreateWithoutLocationGroupInput;
  update: LocationGroupToLocationUpdateWithoutLocationGroupInput;
  where: LocationGroupToLocationWhereUniqueInput;
};

export type LocationGroupToLocationUpsertWithWhereUniqueWithoutLocationInput = {
  create: LocationGroupToLocationCreateWithoutLocationInput;
  update: LocationGroupToLocationUpdateWithoutLocationInput;
  where: LocationGroupToLocationWhereUniqueInput;
};

export type LocationGroupToLocationWhereInput = {
  AND?: InputMaybe<Array<LocationGroupToLocationWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationGroup?: InputMaybe<LocationGroupRelationFilter>;
  locationGroupId?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LocationGroupToLocationWhereInput>>;
  OR?: InputMaybe<Array<LocationGroupToLocationWhereInput>>;
};

export type LocationGroupToLocationWhereUniqueInput = {
  locationGroupId_locationId?: InputMaybe<LocationGroupToLocationLocationGroupIdLocationIdCompoundUniqueInput>;
};

export type LocationGroupUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LocationGroupUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<LocationGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationGroupCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<LocationGroupCreateWithoutTenantInput>>;
  createMany?: InputMaybe<LocationGroupCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<LocationGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationGroupUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<LocationGroupUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<LocationGroupUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type LocationGroupUpdateManyWithWhereWithoutTenantInput = {
  data: LocationGroupUpdateManyMutationInput;
  where: LocationGroupScalarWhereInput;
};

export type LocationGroupUpdateOneRequiredWithoutLocationGroupAsChildNestedInput = {
  connect?: InputMaybe<LocationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationGroupCreateOrConnectWithoutLocationGroupAsChildInput>;
  create?: InputMaybe<LocationGroupCreateWithoutLocationGroupAsChildInput>;
  update?: InputMaybe<LocationGroupUpdateWithoutLocationGroupAsChildInput>;
  upsert?: InputMaybe<LocationGroupUpsertWithoutLocationGroupAsChildInput>;
};

export type LocationGroupUpdateOneRequiredWithoutLocationGroupAsParentNestedInput = {
  connect?: InputMaybe<LocationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationGroupCreateOrConnectWithoutLocationGroupAsParentInput>;
  create?: InputMaybe<LocationGroupCreateWithoutLocationGroupAsParentInput>;
  update?: InputMaybe<LocationGroupUpdateWithoutLocationGroupAsParentInput>;
  upsert?: InputMaybe<LocationGroupUpsertWithoutLocationGroupAsParentInput>;
};

export type LocationGroupUpdateOneRequiredWithoutLocationsNestedInput = {
  connect?: InputMaybe<LocationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationGroupCreateOrConnectWithoutLocationsInput>;
  create?: InputMaybe<LocationGroupCreateWithoutLocationsInput>;
  update?: InputMaybe<LocationGroupUpdateWithoutLocationsInput>;
  upsert?: InputMaybe<LocationGroupUpsertWithoutLocationsInput>;
};

export type LocationGroupUpdateOneWithoutMembershipsNestedInput = {
  connect?: InputMaybe<LocationGroupWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationGroupCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<LocationGroupCreateWithoutMembershipsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationGroupUpdateWithoutMembershipsInput>;
  upsert?: InputMaybe<LocationGroupUpsertWithoutMembershipsInput>;
};

export type LocationGroupUpdateWithoutLocationGroupAsChildInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupUpdateManyWithoutParentLocationGroupNestedInput>;
  locations?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationGroupNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutLocationGroupNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationGroupsNestedInput>;
};

export type LocationGroupUpdateWithoutLocationGroupAsParentInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupUpdateManyWithoutLocationGroupNestedInput>;
  locations?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationGroupNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutLocationGroupNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationGroupsNestedInput>;
};

export type LocationGroupUpdateWithoutLocationsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupUpdateManyWithoutLocationGroupNestedInput>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupUpdateManyWithoutParentLocationGroupNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutLocationGroupNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationGroupsNestedInput>;
};

export type LocationGroupUpdateWithoutMembershipsInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupUpdateManyWithoutLocationGroupNestedInput>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupUpdateManyWithoutParentLocationGroupNestedInput>;
  locations?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationGroupNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationGroupsNestedInput>;
};

export type LocationGroupUpdateWithoutTenantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupUpdateManyWithoutLocationGroupNestedInput>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupUpdateManyWithoutParentLocationGroupNestedInput>;
  locations?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationGroupNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutLocationGroupNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type LocationGroupUpdateWithWhereUniqueWithoutTenantInput = {
  data: LocationGroupUpdateWithoutTenantInput;
  where: LocationGroupWhereUniqueInput;
};

export type LocationGroupUpsertWithoutLocationGroupAsChildInput = {
  create: LocationGroupCreateWithoutLocationGroupAsChildInput;
  update: LocationGroupUpdateWithoutLocationGroupAsChildInput;
};

export type LocationGroupUpsertWithoutLocationGroupAsParentInput = {
  create: LocationGroupCreateWithoutLocationGroupAsParentInput;
  update: LocationGroupUpdateWithoutLocationGroupAsParentInput;
};

export type LocationGroupUpsertWithoutLocationsInput = {
  create: LocationGroupCreateWithoutLocationsInput;
  update: LocationGroupUpdateWithoutLocationsInput;
};

export type LocationGroupUpsertWithoutMembershipsInput = {
  create: LocationGroupCreateWithoutMembershipsInput;
  update: LocationGroupUpdateWithoutMembershipsInput;
};

export type LocationGroupUpsertWithWhereUniqueWithoutTenantInput = {
  create: LocationGroupCreateWithoutTenantInput;
  update: LocationGroupUpdateWithoutTenantInput;
  where: LocationGroupWhereUniqueInput;
};

export type LocationGroupWhereInput = {
  AND?: InputMaybe<Array<LocationGroupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  locationGroupAsChild?: InputMaybe<LocationGroupToGroupListRelationFilter>;
  locationGroupAsParent?: InputMaybe<LocationGroupToGroupListRelationFilter>;
  locations?: InputMaybe<LocationGroupToLocationListRelationFilter>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LocationGroupWhereInput>>;
  OR?: InputMaybe<Array<LocationGroupWhereInput>>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
};

export type LocationGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  name_tenantId?: InputMaybe<LocationGroupNameTenantIdCompoundUniqueInput>;
};

export type LocationListRelationFilter = {
  every?: InputMaybe<LocationWhereInput>;
  none?: InputMaybe<LocationWhereInput>;
  some?: InputMaybe<LocationWhereInput>;
};

export type LocationMaxAggregate = {
  address?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultEndTime?: Maybe<Scalars['String']>;
  defaultStartTime?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailBccList?: Maybe<Scalars['String']>;
  emailCcList?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<Scalars['String']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: Maybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: Maybe<Scalars['Int']>;
  lng?: Maybe<Scalars['Float']>;
  logoUrl?: Maybe<Scalars['String']>;
  loyaltyType?: Maybe<LoyaltyType>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pmsId?: Maybe<Scalars['String']>;
  pmsType?: Maybe<PmsType>;
  postalCode?: Maybe<Scalars['String']>;
  processReservations?: Maybe<Scalars['Boolean']>;
  securityDeposit?: Maybe<Scalars['Float']>;
  securityDepositPolicy?: Maybe<SecurityDepositPolicy>;
  tenantId?: Maybe<Scalars['String']>;
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LocationMaxOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEndTime?: InputMaybe<SortOrder>;
  defaultStartTime?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailBccList?: InputMaybe<SortOrder>;
  emailCcList?: InputMaybe<SortOrder>;
  emailFrom?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  iconUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  languageId?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<SortOrder>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
  logoUrl?: InputMaybe<SortOrder>;
  loyaltyType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  pmsId?: InputMaybe<SortOrder>;
  pmsType?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  processReservations?: InputMaybe<SortOrder>;
  securityDeposit?: InputMaybe<SortOrder>;
  securityDepositPolicy?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  termsAndConditionsUrl?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationMembership = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type LocationMinAggregate = {
  address?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultEndTime?: Maybe<Scalars['String']>;
  defaultStartTime?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  emailBccList?: Maybe<Scalars['String']>;
  emailCcList?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<Scalars['String']>;
  emailTemplateId?: Maybe<Scalars['String']>;
  externalId?: Maybe<Scalars['String']>;
  iconUrl?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  languageId?: Maybe<Scalars['String']>;
  lat?: Maybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: Maybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: Maybe<Scalars['Int']>;
  lng?: Maybe<Scalars['Float']>;
  logoUrl?: Maybe<Scalars['String']>;
  loyaltyType?: Maybe<LoyaltyType>;
  name?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  pmsId?: Maybe<Scalars['String']>;
  pmsType?: Maybe<PmsType>;
  postalCode?: Maybe<Scalars['String']>;
  processReservations?: Maybe<Scalars['Boolean']>;
  securityDeposit?: Maybe<Scalars['Float']>;
  securityDepositPolicy?: Maybe<SecurityDepositPolicy>;
  tenantId?: Maybe<Scalars['String']>;
  termsAndConditionsUrl?: Maybe<Scalars['String']>;
  timezone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type LocationMinOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEndTime?: InputMaybe<SortOrder>;
  defaultStartTime?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrder>;
  emailBccList?: InputMaybe<SortOrder>;
  emailCcList?: InputMaybe<SortOrder>;
  emailFrom?: InputMaybe<SortOrder>;
  emailTemplateId?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  iconUrl?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  languageId?: InputMaybe<SortOrder>;
  lat?: InputMaybe<SortOrder>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<SortOrder>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
  logoUrl?: InputMaybe<SortOrder>;
  loyaltyType?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  phoneNumber?: InputMaybe<SortOrder>;
  pmsId?: InputMaybe<SortOrder>;
  pmsType?: InputMaybe<SortOrder>;
  postalCode?: InputMaybe<SortOrder>;
  processReservations?: InputMaybe<SortOrder>;
  securityDeposit?: InputMaybe<SortOrder>;
  securityDepositPolicy?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  termsAndConditionsUrl?: InputMaybe<SortOrder>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type LocationOrderByWithAggregationInput = {
  _avg?: InputMaybe<LocationAvgOrderByAggregateInput>;
  _count?: InputMaybe<LocationCountOrderByAggregateInput>;
  _max?: InputMaybe<LocationMaxOrderByAggregateInput>;
  _min?: InputMaybe<LocationMinOrderByAggregateInput>;
  _sum?: InputMaybe<LocationSumOrderByAggregateInput>;
  address?: InputMaybe<SortOrder>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEndTime?: InputMaybe<SortOrder>;
  defaultStartTime?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  emailBccList?: InputMaybe<SortOrderInput>;
  emailCcList?: InputMaybe<SortOrderInput>;
  emailFrom?: InputMaybe<SortOrderInput>;
  emailTemplateId?: InputMaybe<SortOrderInput>;
  externalId?: InputMaybe<SortOrderInput>;
  iconUrl?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  languageId?: InputMaybe<SortOrderInput>;
  lat?: InputMaybe<SortOrderInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<SortOrderInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<SortOrderInput>;
  lng?: InputMaybe<SortOrderInput>;
  logoUrl?: InputMaybe<SortOrderInput>;
  loyaltyConfig?: InputMaybe<SortOrderInput>;
  loyaltyType?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  notificationsConfig?: InputMaybe<SortOrderInput>;
  phoneNumber?: InputMaybe<SortOrder>;
  pmsConfig?: InputMaybe<SortOrderInput>;
  pmsId?: InputMaybe<SortOrderInput>;
  pmsType?: InputMaybe<SortOrderInput>;
  postalCode?: InputMaybe<SortOrderInput>;
  processReservations?: InputMaybe<SortOrder>;
  securityDeposit?: InputMaybe<SortOrderInput>;
  securityDepositPolicy?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  termsAndConditionsUrl?: InputMaybe<SortOrderInput>;
  timezone?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type LocationOrderByWithRelationInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdOrderByRelationAggregateInput>;
  accessGrants?: InputMaybe<AccessGrantOrderByRelationAggregateInput>;
  address?: InputMaybe<SortOrder>;
  amenities?: InputMaybe<AmenityOrderByRelationAggregateInput>;
  callRecords?: InputMaybe<CallRecordOrderByRelationAggregateInput>;
  Characteristic?: InputMaybe<CharacteristicOrderByRelationAggregateInput>;
  countryCode?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEndTime?: InputMaybe<SortOrder>;
  defaultRequirements?: InputMaybe<DefaultRequirementOrderByRelationAggregateInput>;
  defaultStartTime?: InputMaybe<SortOrder>;
  email?: InputMaybe<SortOrderInput>;
  emailBccList?: InputMaybe<SortOrderInput>;
  emailCcList?: InputMaybe<SortOrderInput>;
  emailFrom?: InputMaybe<SortOrderInput>;
  emailTemplateId?: InputMaybe<SortOrderInput>;
  externalId?: InputMaybe<SortOrderInput>;
  iconUrl?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  infos?: InputMaybe<InfoItemOrderByRelationAggregateInput>;
  kiosks?: InputMaybe<KioskOrderByRelationAggregateInput>;
  language?: InputMaybe<LanguageOrderByWithRelationInput>;
  languageId?: InputMaybe<SortOrderInput>;
  lat?: InputMaybe<SortOrderInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<SortOrderInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<SortOrderInput>;
  lng?: InputMaybe<SortOrderInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationOrderByRelationAggregateInput>;
  logoUrl?: InputMaybe<SortOrderInput>;
  loyaltyConfig?: InputMaybe<SortOrderInput>;
  loyaltyType?: InputMaybe<SortOrderInput>;
  Membership?: InputMaybe<MembershipOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  Notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  notificationsConfig?: InputMaybe<SortOrderInput>;
  paymentProvider?: InputMaybe<PaymentProviderOrderByWithRelationInput>;
  payments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  phoneNumber?: InputMaybe<SortOrder>;
  pms?: InputMaybe<PmsOrderByWithRelationInput>;
  pmsConfig?: InputMaybe<SortOrderInput>;
  pmsId?: InputMaybe<SortOrderInput>;
  pmsType?: InputMaybe<SortOrderInput>;
  postalCode?: InputMaybe<SortOrderInput>;
  processReservations?: InputMaybe<SortOrder>;
  resourceGroups?: InputMaybe<ResourceGroupOrderByRelationAggregateInput>;
  resources?: InputMaybe<ResourceOrderByRelationAggregateInput>;
  securityDeposit?: InputMaybe<SortOrderInput>;
  securityDepositPolicy?: InputMaybe<SortOrder>;
  ServiceCategory?: InputMaybe<ServiceCategoryOrderByRelationAggregateInput>;
  services?: InputMaybe<ServiceOrderByRelationAggregateInput>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  termsAndConditionsUrl?: InputMaybe<SortOrderInput>;
  timezone?: InputMaybe<SortOrder>;
  unitTypes?: InputMaybe<UnitTypeOrderByRelationAggregateInput>;
  updatedAt?: InputMaybe<SortOrder>;
  UserLocationData?: InputMaybe<UserLocationDataOrderByRelationAggregateInput>;
  vendorServers?: InputMaybe<VendorServerOrderByRelationAggregateInput>;
};

export type LocationParamsInput = {
  /** Preserve the original address */
  preserveAddress?: InputMaybe<Scalars['Boolean']>;
};

export type LocationRelationFilter = {
  is?: InputMaybe<LocationWhereInput>;
  isNot?: InputMaybe<LocationWhereInput>;
};

export enum LocationScalarFieldEnum {
  Address = 'address',
  CountryCode = 'countryCode',
  CreatedAt = 'createdAt',
  DefaultEndTime = 'defaultEndTime',
  DefaultStartTime = 'defaultStartTime',
  Email = 'email',
  EmailBccList = 'emailBccList',
  EmailCcList = 'emailCcList',
  EmailFrom = 'emailFrom',
  EmailTemplateId = 'emailTemplateId',
  ExternalId = 'externalId',
  IconUrl = 'iconUrl',
  Id = 'id',
  ImageUrl = 'imageUrl',
  LanguageId = 'languageId',
  Lat = 'lat',
  LimitOfCardsToUseOnPrintingRetry = 'limitOfCardsToUseOnPrintingRetry',
  LimitOfWritingAttemptsOnPrintingRetry = 'limitOfWritingAttemptsOnPrintingRetry',
  Lng = 'lng',
  LogoUrl = 'logoUrl',
  LoyaltyConfig = 'loyaltyConfig',
  LoyaltyType = 'loyaltyType',
  Name = 'name',
  NotificationsConfig = 'notificationsConfig',
  PhoneNumber = 'phoneNumber',
  PmsConfig = 'pmsConfig',
  PmsId = 'pmsId',
  PmsType = 'pmsType',
  PostalCode = 'postalCode',
  ProcessReservations = 'processReservations',
  SecurityDeposit = 'securityDeposit',
  SecurityDepositPolicy = 'securityDepositPolicy',
  TenantId = 'tenantId',
  TermsAndConditionsUrl = 'termsAndConditionsUrl',
  Timezone = 'timezone',
  UpdatedAt = 'updatedAt'
}

export type LocationScalarWhereInput = {
  address?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<LocationScalarWhereInput>>;
  countryCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultEndTime?: InputMaybe<StringFilter>;
  defaultStartTime?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emailBccList?: InputMaybe<StringNullableFilter>;
  emailCcList?: InputMaybe<StringNullableFilter>;
  emailFrom?: InputMaybe<StringNullableFilter>;
  emailTemplateId?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  iconUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  languageId?: InputMaybe<StringNullableFilter>;
  lat?: InputMaybe<FloatNullableFilter>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<IntNullableFilter>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<IntNullableFilter>;
  lng?: InputMaybe<FloatNullableFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  loyaltyConfig?: InputMaybe<JsonNullableFilter>;
  loyaltyType?: InputMaybe<EnumLoyaltyTypeNullableFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LocationScalarWhereInput>>;
  notificationsConfig?: InputMaybe<JsonNullableFilter>;
  OR?: InputMaybe<Array<LocationScalarWhereInput>>;
  phoneNumber?: InputMaybe<StringFilter>;
  pmsConfig?: InputMaybe<JsonNullableFilter>;
  pmsId?: InputMaybe<StringNullableFilter>;
  pmsType?: InputMaybe<EnumPmsTypeNullableFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  processReservations?: InputMaybe<BoolFilter>;
  securityDeposit?: InputMaybe<FloatNullableFilter>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFilter>;
  tenantId?: InputMaybe<StringFilter>;
  termsAndConditionsUrl?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type LocationScalarWhereWithAggregatesInput = {
  address?: InputMaybe<StringWithAggregatesFilter>;
  AND?: InputMaybe<Array<LocationScalarWhereWithAggregatesInput>>;
  countryCode?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  defaultEndTime?: InputMaybe<StringWithAggregatesFilter>;
  defaultStartTime?: InputMaybe<StringWithAggregatesFilter>;
  email?: InputMaybe<StringNullableWithAggregatesFilter>;
  emailBccList?: InputMaybe<StringNullableWithAggregatesFilter>;
  emailCcList?: InputMaybe<StringNullableWithAggregatesFilter>;
  emailFrom?: InputMaybe<StringNullableWithAggregatesFilter>;
  emailTemplateId?: InputMaybe<StringNullableWithAggregatesFilter>;
  externalId?: InputMaybe<StringNullableWithAggregatesFilter>;
  iconUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  languageId?: InputMaybe<StringNullableWithAggregatesFilter>;
  lat?: InputMaybe<FloatNullableWithAggregatesFilter>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<IntNullableWithAggregatesFilter>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<IntNullableWithAggregatesFilter>;
  lng?: InputMaybe<FloatNullableWithAggregatesFilter>;
  logoUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  loyaltyConfig?: InputMaybe<JsonNullableWithAggregatesFilter>;
  loyaltyType?: InputMaybe<EnumLoyaltyTypeNullableWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<LocationScalarWhereWithAggregatesInput>>;
  notificationsConfig?: InputMaybe<JsonNullableWithAggregatesFilter>;
  OR?: InputMaybe<Array<LocationScalarWhereWithAggregatesInput>>;
  phoneNumber?: InputMaybe<StringWithAggregatesFilter>;
  pmsConfig?: InputMaybe<JsonNullableWithAggregatesFilter>;
  pmsId?: InputMaybe<StringNullableWithAggregatesFilter>;
  pmsType?: InputMaybe<EnumPmsTypeNullableWithAggregatesFilter>;
  postalCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  processReservations?: InputMaybe<BoolWithAggregatesFilter>;
  securityDeposit?: InputMaybe<FloatNullableWithAggregatesFilter>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyWithAggregatesFilter>;
  tenantId?: InputMaybe<StringWithAggregatesFilter>;
  termsAndConditionsUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  timezone?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type LocationSumAggregate = {
  lat?: Maybe<Scalars['Float']>;
  limitOfCardsToUseOnPrintingRetry?: Maybe<Scalars['Int']>;
  limitOfWritingAttemptsOnPrintingRetry?: Maybe<Scalars['Int']>;
  lng?: Maybe<Scalars['Float']>;
  securityDeposit?: Maybe<Scalars['Float']>;
};

export type LocationSumOrderByAggregateInput = {
  lat?: InputMaybe<SortOrder>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<SortOrder>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<SortOrder>;
  lng?: InputMaybe<SortOrder>;
  securityDeposit?: InputMaybe<SortOrder>;
};

export type LocationUpdateInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateManyMutationInput = {
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type LocationUpdateManyWithoutLanguageNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutLanguageInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutLanguageInput>>;
  createMany?: InputMaybe<LocationCreateManyLanguageInputEnvelope>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutLanguageInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutLanguageInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutLanguageInput>>;
};

export type LocationUpdateManyWithoutPmsNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutPmsInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutPmsInput>>;
  createMany?: InputMaybe<LocationCreateManyPmsInputEnvelope>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutPmsInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutPmsInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutPmsInput>>;
};

export type LocationUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<LocationCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<LocationCreateWithoutTenantInput>>;
  createMany?: InputMaybe<LocationCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<LocationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<LocationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<LocationWhereUniqueInput>>;
  set?: InputMaybe<Array<LocationWhereUniqueInput>>;
  update?: InputMaybe<Array<LocationUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<LocationUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<LocationUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type LocationUpdateManyWithWhereWithoutLanguageInput = {
  data: LocationUpdateManyMutationInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutPmsInput = {
  data: LocationUpdateManyMutationInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateManyWithWhereWithoutTenantInput = {
  data: LocationUpdateManyMutationInput;
  where: LocationScalarWhereInput;
};

export type LocationUpdateOneRequiredWithoutAccessGrantResIdNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutAccessGrantResIdInput>;
  create?: InputMaybe<LocationCreateWithoutAccessGrantResIdInput>;
  update?: InputMaybe<LocationUpdateWithoutAccessGrantResIdInput>;
  upsert?: InputMaybe<LocationUpsertWithoutAccessGrantResIdInput>;
};

export type LocationUpdateOneRequiredWithoutAccessGrantsNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutAccessGrantsInput>;
  create?: InputMaybe<LocationCreateWithoutAccessGrantsInput>;
  update?: InputMaybe<LocationUpdateWithoutAccessGrantsInput>;
  upsert?: InputMaybe<LocationUpsertWithoutAccessGrantsInput>;
};

export type LocationUpdateOneRequiredWithoutKiosksNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutKiosksInput>;
  create?: InputMaybe<LocationCreateWithoutKiosksInput>;
  update?: InputMaybe<LocationUpdateWithoutKiosksInput>;
  upsert?: InputMaybe<LocationUpsertWithoutKiosksInput>;
};

export type LocationUpdateOneRequiredWithoutLocationGroupToLocationNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutLocationGroupToLocationInput>;
  create?: InputMaybe<LocationCreateWithoutLocationGroupToLocationInput>;
  update?: InputMaybe<LocationUpdateWithoutLocationGroupToLocationInput>;
  upsert?: InputMaybe<LocationUpsertWithoutLocationGroupToLocationInput>;
};

export type LocationUpdateOneRequiredWithoutResourceGroupsNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutResourceGroupsInput>;
  create?: InputMaybe<LocationCreateWithoutResourceGroupsInput>;
  update?: InputMaybe<LocationUpdateWithoutResourceGroupsInput>;
  upsert?: InputMaybe<LocationUpsertWithoutResourceGroupsInput>;
};

export type LocationUpdateOneRequiredWithoutResourcesNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutResourcesInput>;
  create?: InputMaybe<LocationCreateWithoutResourcesInput>;
  update?: InputMaybe<LocationUpdateWithoutResourcesInput>;
  upsert?: InputMaybe<LocationUpsertWithoutResourcesInput>;
};

export type LocationUpdateOneRequiredWithoutUnitTypesNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutUnitTypesInput>;
  create?: InputMaybe<LocationCreateWithoutUnitTypesInput>;
  update?: InputMaybe<LocationUpdateWithoutUnitTypesInput>;
  upsert?: InputMaybe<LocationUpsertWithoutUnitTypesInput>;
};

export type LocationUpdateOneRequiredWithoutUserLocationDataNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutUserLocationDataInput>;
  create?: InputMaybe<LocationCreateWithoutUserLocationDataInput>;
  update?: InputMaybe<LocationUpdateWithoutUserLocationDataInput>;
  upsert?: InputMaybe<LocationUpsertWithoutUserLocationDataInput>;
};

export type LocationUpdateOneWithoutAmenitiesNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutAmenitiesInput>;
  create?: InputMaybe<LocationCreateWithoutAmenitiesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutAmenitiesInput>;
  upsert?: InputMaybe<LocationUpsertWithoutAmenitiesInput>;
};

export type LocationUpdateOneWithoutCallRecordsNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutCallRecordsInput>;
  create?: InputMaybe<LocationCreateWithoutCallRecordsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutCallRecordsInput>;
  upsert?: InputMaybe<LocationUpsertWithoutCallRecordsInput>;
};

export type LocationUpdateOneWithoutInfosNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutInfosInput>;
  create?: InputMaybe<LocationCreateWithoutInfosInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutInfosInput>;
  upsert?: InputMaybe<LocationUpsertWithoutInfosInput>;
};

export type LocationUpdateOneWithoutMembershipNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutMembershipInput>;
  create?: InputMaybe<LocationCreateWithoutMembershipInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutMembershipInput>;
  upsert?: InputMaybe<LocationUpsertWithoutMembershipInput>;
};

export type LocationUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<LocationCreateWithoutNotificationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutNotificationInput>;
  upsert?: InputMaybe<LocationUpsertWithoutNotificationInput>;
};

export type LocationUpdateOneWithoutPaymentProviderNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutPaymentProviderInput>;
  create?: InputMaybe<LocationCreateWithoutPaymentProviderInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutPaymentProviderInput>;
  upsert?: InputMaybe<LocationUpsertWithoutPaymentProviderInput>;
};

export type LocationUpdateOneWithoutPaymentsNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<LocationCreateWithoutPaymentsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutPaymentsInput>;
  upsert?: InputMaybe<LocationUpsertWithoutPaymentsInput>;
};

export type LocationUpdateOneWithoutServiceCategoryNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutServiceCategoryInput>;
  create?: InputMaybe<LocationCreateWithoutServiceCategoryInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutServiceCategoryInput>;
  upsert?: InputMaybe<LocationUpsertWithoutServiceCategoryInput>;
};

export type LocationUpdateOneWithoutServicesNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutServicesInput>;
  create?: InputMaybe<LocationCreateWithoutServicesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutServicesInput>;
  upsert?: InputMaybe<LocationUpsertWithoutServicesInput>;
};

export type LocationUpdateOneWithoutVendorServersNestedInput = {
  connect?: InputMaybe<LocationWhereUniqueInput>;
  connectOrCreate?: InputMaybe<LocationCreateOrConnectWithoutVendorServersInput>;
  create?: InputMaybe<LocationCreateWithoutVendorServersInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<LocationUpdateWithoutVendorServersInput>;
  upsert?: InputMaybe<LocationUpsertWithoutVendorServersInput>;
};

export type LocationUpdateWithoutAccessGrantResIdInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutAccessGrantsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutAmenitiesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutCallRecordsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutInfosInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutKiosksInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutLanguageInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutLocationGroupToLocationInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutMembershipInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutNotificationInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutPaymentProviderInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutPaymentsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutPmsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutResourceGroupsInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutResourcesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutServiceCategoryInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutServicesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutTenantInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutUnitTypesInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutUserLocationDataInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendorServers?: InputMaybe<VendorServerUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithoutVendorServersInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdUpdateManyWithoutLocationNestedInput>;
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutLocationNestedInput>;
  address?: InputMaybe<StringFieldUpdateOperationsInput>;
  amenities?: InputMaybe<AmenityUpdateManyWithoutLocationNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutLocationNestedInput>;
  Characteristic?: InputMaybe<CharacteristicUpdateManyWithoutLocationNestedInput>;
  countryCode?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEndTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultRequirements?: InputMaybe<DefaultRequirementUpdateManyWithoutLocationNestedInput>;
  defaultStartTime?: InputMaybe<StringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailBccList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailCcList?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  emailTemplateId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  iconUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  infos?: InputMaybe<InfoItemUpdateManyWithoutLocationNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutLocationNestedInput>;
  language?: InputMaybe<LanguageUpdateOneWithoutLocationNestedInput>;
  lat?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  lng?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationUpdateManyWithoutLocationNestedInput>;
  logoUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  loyaltyConfig?: InputMaybe<Scalars['JSON']>;
  loyaltyType?: InputMaybe<NullableEnumLoyaltyTypeFieldUpdateOperationsInput>;
  Membership?: InputMaybe<MembershipUpdateManyWithoutLocationNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutLocationNestedInput>;
  notificationsConfig?: InputMaybe<Scalars['JSON']>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutLocationNestedInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutLocationNestedInput>;
  phoneNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  pms?: InputMaybe<PmsUpdateOneWithoutLocationsNestedInput>;
  pmsConfig?: InputMaybe<Scalars['JSON']>;
  pmsType?: InputMaybe<NullableEnumPmsTypeFieldUpdateOperationsInput>;
  postalCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  processReservations?: InputMaybe<BoolFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutLocationNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutLocationNestedInput>;
  securityDeposit?: InputMaybe<NullableFloatFieldUpdateOperationsInput>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFieldUpdateOperationsInput>;
  ServiceCategory?: InputMaybe<ServiceCategoryUpdateManyWithoutLocationNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutLocationNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutLocationsNestedInput>;
  termsAndConditionsUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  timezone?: InputMaybe<StringFieldUpdateOperationsInput>;
  unitTypes?: InputMaybe<UnitTypeUpdateManyWithoutLocationNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutLocationNestedInput>;
};

export type LocationUpdateWithWhereUniqueWithoutLanguageInput = {
  data: LocationUpdateWithoutLanguageInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutPmsInput = {
  data: LocationUpdateWithoutPmsInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpdateWithWhereUniqueWithoutTenantInput = {
  data: LocationUpdateWithoutTenantInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithoutAccessGrantResIdInput = {
  create: LocationCreateWithoutAccessGrantResIdInput;
  update: LocationUpdateWithoutAccessGrantResIdInput;
};

export type LocationUpsertWithoutAccessGrantsInput = {
  create: LocationCreateWithoutAccessGrantsInput;
  update: LocationUpdateWithoutAccessGrantsInput;
};

export type LocationUpsertWithoutAmenitiesInput = {
  create: LocationCreateWithoutAmenitiesInput;
  update: LocationUpdateWithoutAmenitiesInput;
};

export type LocationUpsertWithoutCallRecordsInput = {
  create: LocationCreateWithoutCallRecordsInput;
  update: LocationUpdateWithoutCallRecordsInput;
};

export type LocationUpsertWithoutInfosInput = {
  create: LocationCreateWithoutInfosInput;
  update: LocationUpdateWithoutInfosInput;
};

export type LocationUpsertWithoutKiosksInput = {
  create: LocationCreateWithoutKiosksInput;
  update: LocationUpdateWithoutKiosksInput;
};

export type LocationUpsertWithoutLocationGroupToLocationInput = {
  create: LocationCreateWithoutLocationGroupToLocationInput;
  update: LocationUpdateWithoutLocationGroupToLocationInput;
};

export type LocationUpsertWithoutMembershipInput = {
  create: LocationCreateWithoutMembershipInput;
  update: LocationUpdateWithoutMembershipInput;
};

export type LocationUpsertWithoutNotificationInput = {
  create: LocationCreateWithoutNotificationInput;
  update: LocationUpdateWithoutNotificationInput;
};

export type LocationUpsertWithoutPaymentProviderInput = {
  create: LocationCreateWithoutPaymentProviderInput;
  update: LocationUpdateWithoutPaymentProviderInput;
};

export type LocationUpsertWithoutPaymentsInput = {
  create: LocationCreateWithoutPaymentsInput;
  update: LocationUpdateWithoutPaymentsInput;
};

export type LocationUpsertWithoutResourceGroupsInput = {
  create: LocationCreateWithoutResourceGroupsInput;
  update: LocationUpdateWithoutResourceGroupsInput;
};

export type LocationUpsertWithoutResourcesInput = {
  create: LocationCreateWithoutResourcesInput;
  update: LocationUpdateWithoutResourcesInput;
};

export type LocationUpsertWithoutServiceCategoryInput = {
  create: LocationCreateWithoutServiceCategoryInput;
  update: LocationUpdateWithoutServiceCategoryInput;
};

export type LocationUpsertWithoutServicesInput = {
  create: LocationCreateWithoutServicesInput;
  update: LocationUpdateWithoutServicesInput;
};

export type LocationUpsertWithoutUnitTypesInput = {
  create: LocationCreateWithoutUnitTypesInput;
  update: LocationUpdateWithoutUnitTypesInput;
};

export type LocationUpsertWithoutUserLocationDataInput = {
  create: LocationCreateWithoutUserLocationDataInput;
  update: LocationUpdateWithoutUserLocationDataInput;
};

export type LocationUpsertWithoutVendorServersInput = {
  create: LocationCreateWithoutVendorServersInput;
  update: LocationUpdateWithoutVendorServersInput;
};

export type LocationUpsertWithWhereUniqueWithoutLanguageInput = {
  create: LocationCreateWithoutLanguageInput;
  update: LocationUpdateWithoutLanguageInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutPmsInput = {
  create: LocationCreateWithoutPmsInput;
  update: LocationUpdateWithoutPmsInput;
  where: LocationWhereUniqueInput;
};

export type LocationUpsertWithWhereUniqueWithoutTenantInput = {
  create: LocationCreateWithoutTenantInput;
  update: LocationUpdateWithoutTenantInput;
  where: LocationWhereUniqueInput;
};

export type LocationWhereInput = {
  AccessGrantResId?: InputMaybe<AccessGrantResIdListRelationFilter>;
  accessGrants?: InputMaybe<AccessGrantListRelationFilter>;
  address?: InputMaybe<StringFilter>;
  amenities?: InputMaybe<AmenityListRelationFilter>;
  AND?: InputMaybe<Array<LocationWhereInput>>;
  callRecords?: InputMaybe<CallRecordListRelationFilter>;
  Characteristic?: InputMaybe<CharacteristicListRelationFilter>;
  countryCode?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultEndTime?: InputMaybe<StringFilter>;
  defaultRequirements?: InputMaybe<DefaultRequirementListRelationFilter>;
  defaultStartTime?: InputMaybe<StringFilter>;
  email?: InputMaybe<StringNullableFilter>;
  emailBccList?: InputMaybe<StringNullableFilter>;
  emailCcList?: InputMaybe<StringNullableFilter>;
  emailFrom?: InputMaybe<StringNullableFilter>;
  emailTemplateId?: InputMaybe<StringNullableFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  iconUrl?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  infos?: InputMaybe<InfoItemListRelationFilter>;
  kiosks?: InputMaybe<KioskListRelationFilter>;
  language?: InputMaybe<LanguageRelationFilter>;
  languageId?: InputMaybe<StringNullableFilter>;
  lat?: InputMaybe<FloatNullableFilter>;
  limitOfCardsToUseOnPrintingRetry?: InputMaybe<IntNullableFilter>;
  limitOfWritingAttemptsOnPrintingRetry?: InputMaybe<IntNullableFilter>;
  lng?: InputMaybe<FloatNullableFilter>;
  LocationGroupToLocation?: InputMaybe<LocationGroupToLocationListRelationFilter>;
  logoUrl?: InputMaybe<StringNullableFilter>;
  loyaltyConfig?: InputMaybe<JsonNullableFilter>;
  loyaltyType?: InputMaybe<EnumLoyaltyTypeNullableFilter>;
  Membership?: InputMaybe<MembershipListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<LocationWhereInput>>;
  Notification?: InputMaybe<NotificationListRelationFilter>;
  notificationsConfig?: InputMaybe<JsonNullableFilter>;
  OR?: InputMaybe<Array<LocationWhereInput>>;
  paymentProvider?: InputMaybe<PaymentProviderRelationFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  phoneNumber?: InputMaybe<StringFilter>;
  pms?: InputMaybe<PmsRelationFilter>;
  pmsConfig?: InputMaybe<JsonNullableFilter>;
  pmsId?: InputMaybe<StringNullableFilter>;
  pmsType?: InputMaybe<EnumPmsTypeNullableFilter>;
  postalCode?: InputMaybe<StringNullableFilter>;
  processReservations?: InputMaybe<BoolFilter>;
  resourceGroups?: InputMaybe<ResourceGroupListRelationFilter>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  securityDeposit?: InputMaybe<FloatNullableFilter>;
  securityDepositPolicy?: InputMaybe<EnumSecurityDepositPolicyFilter>;
  ServiceCategory?: InputMaybe<ServiceCategoryListRelationFilter>;
  services?: InputMaybe<ServiceListRelationFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  termsAndConditionsUrl?: InputMaybe<StringNullableFilter>;
  timezone?: InputMaybe<StringFilter>;
  unitTypes?: InputMaybe<UnitTypeListRelationFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  UserLocationData?: InputMaybe<UserLocationDataListRelationFilter>;
  vendorServers?: InputMaybe<VendorServerListRelationFilter>;
};

export type LocationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum LoyaltyType {
  Cendyn = 'CENDYN'
}

export type Me = {
  _count?: Maybe<UserCount>;
  accessGrants: Array<AccessGrant>;
  activeAccessGrant?: Maybe<VirtualAccessGrant>;
  activeMembership?: Maybe<Membership>;
  activeOrNearestFutureAccessGrant?: Maybe<VirtualAccessGrant>;
  activeOrNearestFutureAccessGrants: Array<VirtualAccessGrant>;
  authChallenges: Array<AuthChallenge>;
  callRecords: Array<CallRecord>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  Credential: Array<Credential>;
  cuid: Scalars['String'];
  dashboardPreferences?: Maybe<Scalars['JSON']>;
  deviceId?: Maybe<Scalars['String']>;
  devices: Array<Device>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hotelAccessGrants?: Maybe<Array<VirtualAccessGrant>>;
  id: Scalars['String'];
  internalApiCalls: Array<InternalApiCall>;
  lastName?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  leasingAccessGrants?: Maybe<Array<VirtualAccessGrant>>;
  madeCalls: Array<CallRecord>;
  memberships: Array<Membership>;
  name?: Maybe<Scalars['String']>;
  Notification: Array<Notification>;
  openpathExternalUserId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  payments: Array<Payment>;
  phoneNumber?: Maybe<Scalars['String']>;
  receivedCalls: Array<CallRecord>;
  SecondaryUsersOnAccessGrants: Array<SecondaryUsersOnAccessGrants>;
  UserAccessGrantRequirement: Array<UserAccessGrantRequirement>;
  UserLocationData: Array<UserLocationData>;
  userPushNotificationTokens: Array<UserPushNotificationToken>;
  userRecords: Array<UserRecord>;
  UserTenantData: Array<UserTenantData>;
};


export type MeAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type MeAuthChallengesArgs = {
  cursor?: InputMaybe<AuthChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuthChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuthChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuthChallengeWhereInput>;
};


export type MeCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type MeCredentialArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type MeDevicesArgs = {
  cursor?: InputMaybe<DeviceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DeviceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DeviceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type MeInternalApiCallsArgs = {
  cursor?: InputMaybe<InternalApiCallWhereUniqueInput>;
  distinct?: InputMaybe<Array<InternalApiCallScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InternalApiCallOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InternalApiCallWhereInput>;
};


export type MeMadeCallsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type MeNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type MePaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type MeReceivedCallsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type MeSecondaryUsersOnAccessGrantsArgs = {
  cursor?: InputMaybe<SecondaryUsersOnAccessGrantsWhereUniqueInput>;
  distinct?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SecondaryUsersOnAccessGrantsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
};


export type MeUserAccessGrantRequirementArgs = {
  cursor?: InputMaybe<UserAccessGrantRequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAccessGrantRequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAccessGrantRequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};


export type MeUserLocationDataArgs = {
  cursor?: InputMaybe<UserLocationDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserLocationDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserLocationDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserLocationDataWhereInput>;
};


export type MeUserPushNotificationTokensArgs = {
  cursor?: InputMaybe<UserPushNotificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPushNotificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPushNotificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type MeUserRecordsArgs = {
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type MeUserTenantDataArgs = {
  cursor?: InputMaybe<UserTenantDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTenantDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};

export type Membership = {
  companyName?: Maybe<Scalars['String']>;
  externalProfileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Location>;
  locationGroup?: Maybe<LocationGroup>;
  locationGroupId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  role: Role;
  tenant: Tenant;
  tenantId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type MembershipCreateManyLocationGroupInput = {
  companyName?: InputMaybe<Scalars['String']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  locationId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};

export type MembershipCreateManyLocationGroupInputEnvelope = {
  data: Array<MembershipCreateManyLocationGroupInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MembershipCreateManyLocationInput = {
  companyName?: InputMaybe<Scalars['String']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  locationGroupId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};

export type MembershipCreateManyLocationInputEnvelope = {
  data: Array<MembershipCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MembershipCreateManyTenantInput = {
  companyName?: InputMaybe<Scalars['String']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  locationGroupId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  userId: Scalars['String'];
};

export type MembershipCreateManyTenantInputEnvelope = {
  data: Array<MembershipCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MembershipCreateManyUserInput = {
  companyName?: InputMaybe<Scalars['String']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  locationGroupId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  role?: InputMaybe<Role>;
  tenantId: Scalars['String'];
};

export type MembershipCreateManyUserInputEnvelope = {
  data: Array<MembershipCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type MembershipCreateNestedManyWithoutLocationGroupInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutLocationGroupInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutLocationGroupInput>>;
  createMany?: InputMaybe<MembershipCreateManyLocationGroupInputEnvelope>;
};

export type MembershipCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutLocationInput>>;
  createMany?: InputMaybe<MembershipCreateManyLocationInputEnvelope>;
};

export type MembershipCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutTenantInput>>;
  createMany?: InputMaybe<MembershipCreateManyTenantInputEnvelope>;
};

export type MembershipCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutUserInput>>;
  createMany?: InputMaybe<MembershipCreateManyUserInputEnvelope>;
};

export type MembershipCreateOrConnectWithoutLocationGroupInput = {
  create: MembershipCreateWithoutLocationGroupInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipCreateOrConnectWithoutLocationInput = {
  create: MembershipCreateWithoutLocationInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipCreateOrConnectWithoutTenantInput = {
  create: MembershipCreateWithoutTenantInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipCreateOrConnectWithoutUserInput = {
  create: MembershipCreateWithoutUserInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipCreateWithoutLocationGroupInput = {
  companyName?: InputMaybe<Scalars['String']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutMembershipInput>;
  role?: InputMaybe<Role>;
  tenant: TenantCreateNestedOneWithoutMembershipsInput;
  user: UserCreateNestedOneWithoutMembershipsInput;
};

export type MembershipCreateWithoutLocationInput = {
  companyName?: InputMaybe<Scalars['String']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  locationGroup?: InputMaybe<LocationGroupCreateNestedOneWithoutMembershipsInput>;
  role?: InputMaybe<Role>;
  tenant: TenantCreateNestedOneWithoutMembershipsInput;
  user: UserCreateNestedOneWithoutMembershipsInput;
};

export type MembershipCreateWithoutTenantInput = {
  companyName?: InputMaybe<Scalars['String']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutMembershipInput>;
  locationGroup?: InputMaybe<LocationGroupCreateNestedOneWithoutMembershipsInput>;
  role?: InputMaybe<Role>;
  user: UserCreateNestedOneWithoutMembershipsInput;
};

export type MembershipCreateWithoutUserInput = {
  companyName?: InputMaybe<Scalars['String']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutMembershipInput>;
  locationGroup?: InputMaybe<LocationGroupCreateNestedOneWithoutMembershipsInput>;
  role?: InputMaybe<Role>;
  tenant: TenantCreateNestedOneWithoutMembershipsInput;
};

export type MembershipListRelationFilter = {
  every?: InputMaybe<MembershipWhereInput>;
  none?: InputMaybe<MembershipWhereInput>;
  some?: InputMaybe<MembershipWhereInput>;
};

export type MembershipOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type MembershipOrderByWithRelationInput = {
  companyName?: InputMaybe<SortOrderInput>;
  externalProfileId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrderInput>;
  lastSeenAt?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationGroup?: InputMaybe<LocationGroupOrderByWithRelationInput>;
  locationGroupId?: InputMaybe<SortOrderInput>;
  locationId?: InputMaybe<SortOrderInput>;
  role?: InputMaybe<SortOrder>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum MembershipScalarFieldEnum {
  CompanyName = 'companyName',
  ExternalProfileId = 'externalProfileId',
  Id = 'id',
  IsDefault = 'isDefault',
  LastSeenAt = 'lastSeenAt',
  LocationGroupId = 'locationGroupId',
  LocationId = 'locationId',
  Role = 'role',
  TenantId = 'tenantId',
  UserId = 'userId'
}

export type MembershipScalarWhereInput = {
  AND?: InputMaybe<Array<MembershipScalarWhereInput>>;
  companyName?: InputMaybe<StringNullableFilter>;
  externalProfileId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDefault?: InputMaybe<BoolNullableFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  locationGroupId?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<MembershipScalarWhereInput>>;
  OR?: InputMaybe<Array<MembershipScalarWhereInput>>;
  role?: InputMaybe<EnumRoleFilter>;
  tenantId?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type MembershipUpdateManyMutationInput = {
  companyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
};

export type MembershipUpdateManyWithoutLocationGroupNestedInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutLocationGroupInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutLocationGroupInput>>;
  createMany?: InputMaybe<MembershipCreateManyLocationGroupInputEnvelope>;
  delete?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<MembershipUpdateWithWhereUniqueWithoutLocationGroupInput>>;
  updateMany?: InputMaybe<Array<MembershipUpdateManyWithWhereWithoutLocationGroupInput>>;
  upsert?: InputMaybe<Array<MembershipUpsertWithWhereUniqueWithoutLocationGroupInput>>;
};

export type MembershipUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutLocationInput>>;
  createMany?: InputMaybe<MembershipCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<MembershipUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<MembershipUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<MembershipUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type MembershipUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutTenantInput>>;
  createMany?: InputMaybe<MembershipCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<MembershipUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<MembershipUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<MembershipUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type MembershipUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<MembershipCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<MembershipCreateWithoutUserInput>>;
  createMany?: InputMaybe<MembershipCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<MembershipScalarWhereInput>>;
  disconnect?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  set?: InputMaybe<Array<MembershipWhereUniqueInput>>;
  update?: InputMaybe<Array<MembershipUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<MembershipUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<MembershipUpsertWithWhereUniqueWithoutUserInput>>;
};

export type MembershipUpdateManyWithWhereWithoutLocationGroupInput = {
  data: MembershipUpdateManyMutationInput;
  where: MembershipScalarWhereInput;
};

export type MembershipUpdateManyWithWhereWithoutLocationInput = {
  data: MembershipUpdateManyMutationInput;
  where: MembershipScalarWhereInput;
};

export type MembershipUpdateManyWithWhereWithoutTenantInput = {
  data: MembershipUpdateManyMutationInput;
  where: MembershipScalarWhereInput;
};

export type MembershipUpdateManyWithWhereWithoutUserInput = {
  data: MembershipUpdateManyMutationInput;
  where: MembershipScalarWhereInput;
};

export type MembershipUpdateWithoutLocationGroupInput = {
  companyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutMembershipNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutMembershipsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMembershipsNestedInput>;
};

export type MembershipUpdateWithoutLocationInput = {
  companyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  locationGroup?: InputMaybe<LocationGroupUpdateOneWithoutMembershipsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutMembershipsNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMembershipsNestedInput>;
};

export type MembershipUpdateWithoutTenantInput = {
  companyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutMembershipNestedInput>;
  locationGroup?: InputMaybe<LocationGroupUpdateOneWithoutMembershipsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutMembershipsNestedInput>;
};

export type MembershipUpdateWithoutUserInput = {
  companyName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  externalProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutMembershipNestedInput>;
  locationGroup?: InputMaybe<LocationGroupUpdateOneWithoutMembershipsNestedInput>;
  role?: InputMaybe<EnumRoleFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutMembershipsNestedInput>;
};

export type MembershipUpdateWithWhereUniqueWithoutLocationGroupInput = {
  data: MembershipUpdateWithoutLocationGroupInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpdateWithWhereUniqueWithoutLocationInput = {
  data: MembershipUpdateWithoutLocationInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpdateWithWhereUniqueWithoutTenantInput = {
  data: MembershipUpdateWithoutTenantInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpdateWithWhereUniqueWithoutUserInput = {
  data: MembershipUpdateWithoutUserInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpsertWithWhereUniqueWithoutLocationGroupInput = {
  create: MembershipCreateWithoutLocationGroupInput;
  update: MembershipUpdateWithoutLocationGroupInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpsertWithWhereUniqueWithoutLocationInput = {
  create: MembershipCreateWithoutLocationInput;
  update: MembershipUpdateWithoutLocationInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpsertWithWhereUniqueWithoutTenantInput = {
  create: MembershipCreateWithoutTenantInput;
  update: MembershipUpdateWithoutTenantInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipUpsertWithWhereUniqueWithoutUserInput = {
  create: MembershipCreateWithoutUserInput;
  update: MembershipUpdateWithoutUserInput;
  where: MembershipWhereUniqueInput;
};

export type MembershipWhereInput = {
  AND?: InputMaybe<Array<MembershipWhereInput>>;
  companyName?: InputMaybe<StringNullableFilter>;
  externalProfileId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  isDefault?: InputMaybe<BoolNullableFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationGroup?: InputMaybe<LocationGroupRelationFilter>;
  locationGroupId?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<MembershipWhereInput>>;
  OR?: InputMaybe<Array<MembershipWhereInput>>;
  role?: InputMaybe<EnumRoleFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type MembershipWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type MembershipWithPermissions = {
  companyName?: Maybe<Scalars['String']>;
  externalProfileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  isDefault?: Maybe<Scalars['Boolean']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  location?: Maybe<Location>;
  locationGroup?: Maybe<CustomLocationGroup>;
  locationGroupId?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  permissions?: Maybe<Scalars['JSONObject']>;
  role: Role;
  tenant: Tenant;
  tenantId: Scalars['String'];
  user: User;
  userId: Scalars['String'];
};

export type MeWithUserRolePermissions = {
  _count?: Maybe<UserCount>;
  accessGrants: Array<AccessGrant>;
  activeAccessGrant?: Maybe<VirtualAccessGrant>;
  activeMembership?: Maybe<MembershipWithPermissions>;
  authChallenges: Array<AuthChallenge>;
  callRecords: Array<CallRecord>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  Credential: Array<Credential>;
  cuid: Scalars['String'];
  dashboardPreferences?: Maybe<Scalars['JSON']>;
  deviceId?: Maybe<Scalars['String']>;
  devices: Array<Device>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  hotelAccessGrants?: Maybe<Array<VirtualAccessGrant>>;
  id: Scalars['String'];
  internalApiCalls: Array<InternalApiCall>;
  lastName?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  leasingAccessGrants?: Maybe<Array<VirtualAccessGrant>>;
  madeCalls: Array<CallRecord>;
  memberships: Array<Membership>;
  name?: Maybe<Scalars['String']>;
  Notification: Array<Notification>;
  openpathExternalUserId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  payments: Array<Payment>;
  phoneNumber?: Maybe<Scalars['String']>;
  receivedCalls: Array<CallRecord>;
  SecondaryUsersOnAccessGrants: Array<SecondaryUsersOnAccessGrants>;
  UserAccessGrantRequirement: Array<UserAccessGrantRequirement>;
  UserLocationData: Array<UserLocationData>;
  userPushNotificationTokens: Array<UserPushNotificationToken>;
  userRecords: Array<UserRecord>;
  UserTenantData: Array<UserTenantData>;
  virtualMemberships?: Maybe<Array<VirtualMembership>>;
};


export type MeWithUserRolePermissionsAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type MeWithUserRolePermissionsAuthChallengesArgs = {
  cursor?: InputMaybe<AuthChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuthChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuthChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuthChallengeWhereInput>;
};


export type MeWithUserRolePermissionsCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type MeWithUserRolePermissionsCredentialArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type MeWithUserRolePermissionsDevicesArgs = {
  cursor?: InputMaybe<DeviceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DeviceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DeviceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type MeWithUserRolePermissionsInternalApiCallsArgs = {
  cursor?: InputMaybe<InternalApiCallWhereUniqueInput>;
  distinct?: InputMaybe<Array<InternalApiCallScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InternalApiCallOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InternalApiCallWhereInput>;
};


export type MeWithUserRolePermissionsMadeCallsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type MeWithUserRolePermissionsMembershipsArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type MeWithUserRolePermissionsNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type MeWithUserRolePermissionsPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type MeWithUserRolePermissionsReceivedCallsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type MeWithUserRolePermissionsSecondaryUsersOnAccessGrantsArgs = {
  cursor?: InputMaybe<SecondaryUsersOnAccessGrantsWhereUniqueInput>;
  distinct?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SecondaryUsersOnAccessGrantsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
};


export type MeWithUserRolePermissionsUserAccessGrantRequirementArgs = {
  cursor?: InputMaybe<UserAccessGrantRequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAccessGrantRequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAccessGrantRequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};


export type MeWithUserRolePermissionsUserLocationDataArgs = {
  cursor?: InputMaybe<UserLocationDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserLocationDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserLocationDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserLocationDataWhereInput>;
};


export type MeWithUserRolePermissionsUserPushNotificationTokensArgs = {
  cursor?: InputMaybe<UserPushNotificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPushNotificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPushNotificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type MeWithUserRolePermissionsUserRecordsArgs = {
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type MeWithUserRolePermissionsUserTenantDataArgs = {
  cursor?: InputMaybe<UserTenantDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTenantDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};

export type MifareBlobAnswer = {
  BlockBinaryData: Array<MifareData>;
  BlockPasswordsList?: Maybe<Array<MifareSectorPasswordsList>>;
  MifareUltralightCKeySet?: Maybe<MifareUltralightCKeySet>;
};

export type MifareData = {
  BinaryData: Scalars['String'];
  BlockID: Scalars['String'];
  SectorID: Scalars['String'];
};

export type MifarePasswordAnswer = {
  BlockBinaryData: Array<MifarePasswordData>;
};

export type MifarePasswordData = {
  BinaryData: Scalars['String'];
  BlockID: Scalars['String'];
  Key: Scalars['String'];
  SectorID: Scalars['String'];
};

export type MifareSectorPasswordsList = {
  BlockID: Scalars['String'];
  ListOfPasswordsToTry: Array<SectorPassword>;
  SectorID: Scalars['String'];
};

export type MifareUltralightCKeySet = {
  Auth0: Scalars['String'];
  Auth1: Scalars['String'];
  Key1: Scalars['String'];
  Key2: Scalars['String'];
};

export type MiwaMobileKey = {
  basic: Scalars['String'];
  ext1: Scalars['String'];
  ext2: Scalars['String'];
};

export type Mutation = {
  accessMembership: Membership;
  addUserToAccessGrant: AddUserToAccessGrantResult;
  /** Exchange an email and challenge for a bearer token. */
  answerEmailAuthChallenge: AuthAnswer;
  /** Exchange a QR code (boarding pass) for a bearer token. */
  answerQRChallenge: AuthAnswer;
  /** Exchange a QR code credential from website token for a bearer token. */
  answerQRChallengeByWebsiteToken: AuthAnswer;
  /** Exchange a phone number and SMS challenge for a bearer token. */
  answerSMSAuthChallenge: AuthAnswer;
  assaCreateEndpointInvitation: AssaCreateEndpointInvitationResponse;
  assaTerminateEndpoint: Scalars['Boolean'];
  /** Authenticate by confirmation code only */
  authenticateByConfirmationCode: AuthAnswer;
  /** Authenticate by first/last name + departure date (YYYY-MM-DD by location timezone) */
  authenticateByFirstLastDeparture: AuthAnswer;
  /** Authenticate requests coming from a PMS, validating token, location external id and pmsType */
  authenticatePmsRequest: AuthenticatePmsRequestResponse;
  authorizePayment: PaymentAuthorization;
  bypassVerification: SuccessAnswer;
  calculateRequirements: Array<Requirement>;
  cancelAccessGrant: AccessGrant;
  capturePayment: PaymentAuthorization;
  captureSecurityDeposit: PaymentAuthorization;
  cloudbedsConnectApp: SuccessAnswer;
  cloudbedsDisconnectApp: SuccessAnswer;
  confirmKeycardWasDispensed: SuccessAnswer;
  createAccessGrant: AccessGrant;
  createAmenityAndUploadImageFile: Amenity;
  createAndSaveTemporaryQRChallenge: TemporaryQrResponse;
  createAssaEndpoint: AssaCreateEndpointInvitationResponse;
  createAssaKey: CreateAssaKeyResponse;
  createAssaMobileKey: CreateAssaMobileKeyResponse;
  createCallRecord: CallRecord;
  createConciergeItem: ConciergeItem;
  createCredential: Credential;
  createEarlyCheckInPackage: EarlyCheckInPackage;
  createFaceLivenessSession: CreateFaceLivenessSessionResponse;
  createGuestEngagementEvent: Scalars['Boolean'];
  createInfoItemAndUploadImageFile: InfoItem;
  createLocation: Location;
  createLocationGroup: LocationGroup;
  createManyAccessGrant: AffectedRowsOutput;
  createManyAmenity: AffectedRowsOutput;
  createManyAmenityGroup: AffectedRowsOutput;
  createManyCallRecord: AffectedRowsOutput;
  createManyCredential: AffectedRowsOutput;
  createManyFileToEntity: AffectedRowsOutput;
  createManyInfoItem: AffectedRowsOutput;
  createManyKiosk: AffectedRowsOutput;
  createManyLanguage: AffectedRowsOutput;
  createManyLocalization: AffectedRowsOutput;
  createManyLocation: AffectedRowsOutput;
  createManyPass: AffectedRowsOutput;
  createManyPayment: AffectedRowsOutput;
  createManyPaymentTransaction: AffectedRowsOutput;
  createManyRegistration: AffectedRowsOutput;
  createManyRequirement: AffectedRowsOutput;
  createManyResource: AffectedRowsOutput;
  createManyResourceGroup: AffectedRowsOutput;
  createManyService: AffectedRowsOutput;
  createManyServiceRequest: AffectedRowsOutput;
  createManySupplementaryCard: AffectedRowsOutput;
  createManyTenant: AffectedRowsOutput;
  createManyTheme: AffectedRowsOutput;
  createManyUnitType: AffectedRowsOutput;
  createManyUserPushNotificationToken: AffectedRowsOutput;
  createManyUserRecord: AffectedRowsOutput;
  createManyUserTenantData: AffectedRowsOutput;
  createManyVendorServer: AffectedRowsOutput;
  createMobileCredentials: SuccessAnswer;
  createOneAccessGrant: AccessGrant;
  createOneAmenity: Amenity;
  createOneAmenityGroup: AmenityGroup;
  createOneCallRecord: CallRecord;
  createOneCredential: Credential;
  createOneFileToEntity: FileToEntity;
  createOneInfoItem: InfoItem;
  createOneKiosk: Kiosk;
  createOneLanguage: Language;
  createOneLocalization: Localization;
  createOneLocation: Location;
  createOnePass: Pass;
  createOnePayment: Payment;
  createOnePaymentTransaction: PaymentTransaction;
  createOneRegistration: Registration;
  createOneRequirement: Requirement;
  createOneResource: Resource;
  createOneResourceGroup: ResourceGroup;
  createOneService: Service;
  createOneServiceRequest: ServiceRequest;
  createOneSupplementaryCard: SupplementaryCard;
  createOneTenant: Tenant;
  createOneTheme: Theme;
  createOneUnitType: UnitType;
  createOneUserPushNotificationToken: UserPushNotificationToken;
  createOneUserRecord: UserRecord;
  createOneUserTenantData: UserTenantData;
  createOneVendorServer: VendorServer;
  createPayment: Payment;
  createPaymentTransaction: PaymentTransaction;
  createRequirement: Requirement;
  createResource: Resource;
  createResourceAndUploadImageFile: Resource;
  createResourceGroup: ResourceGroup;
  createSeosMobileKey: AssaCreateMobileKeyResponse;
  createServiceAndUploadImageFile: Service;
  createServiceRequest: ServiceRequest;
  createSquareCustomer: SquareCreateCustomerResponse;
  createSquareCustomerWithAccessGrantId: SquareCreateCustomerResponse;
  createUnitTypeAndUploadImageFile: UnitType;
  createUser: User;
  /** Upserts a credential and deletes all existing ones with the same key data */
  customUpsertCredential: Credential;
  /** Exchange a email and password for a bearer token. Applicable only for SysUser (ADMIN and AGENT) */
  dashboardSignIn: AuthAnswer;
  deleteConciergeItem: DeleteConciergeItemResponse;
  deleteEarlyCheckInPackage: SuccessAnswer;
  deleteKioskLocalization: BaseSettingAnswer;
  deleteKioskTheme: BaseSettingAnswer;
  deleteLocationGroup: SuccessAnswer;
  deleteLocationLocalization: BaseSettingAnswer;
  deleteLocationTheme: BaseSettingAnswer;
  deleteManyAccessGrant: AffectedRowsOutput;
  deleteManyAmenity: AffectedRowsOutput;
  deleteManyAmenityGroup: AffectedRowsOutput;
  deleteManyCallRecord: AffectedRowsOutput;
  deleteManyCredential: AffectedRowsOutput;
  deleteManyFileToEntity: AffectedRowsOutput;
  deleteManyInfoItem: AffectedRowsOutput;
  deleteManyKiosk: AffectedRowsOutput;
  deleteManyLanguage: AffectedRowsOutput;
  deleteManyLocalization: AffectedRowsOutput;
  deleteManyLocation: AffectedRowsOutput;
  deleteManyPass: AffectedRowsOutput;
  deleteManyPayment: AffectedRowsOutput;
  deleteManyPaymentTransaction: AffectedRowsOutput;
  deleteManyRegistration: AffectedRowsOutput;
  deleteManyRequirement: AffectedRowsOutput;
  deleteManyResource: AffectedRowsOutput;
  deleteManyResourceGroup: AffectedRowsOutput;
  deleteManyService: AffectedRowsOutput;
  deleteManyServiceRequest: AffectedRowsOutput;
  deleteManySupplementaryCard: AffectedRowsOutput;
  deleteManyTenant: AffectedRowsOutput;
  deleteManyTheme: AffectedRowsOutput;
  deleteManyUnitType: AffectedRowsOutput;
  deleteManyUserPushNotificationToken: AffectedRowsOutput;
  deleteManyUserRecord: AffectedRowsOutput;
  deleteManyUserTenantData: AffectedRowsOutput;
  deleteManyVendorServer: AffectedRowsOutput;
  deleteOneAccessGrant?: Maybe<AccessGrant>;
  deleteOneAmenity?: Maybe<Amenity>;
  deleteOneAmenityGroup?: Maybe<AmenityGroup>;
  deleteOneCallRecord?: Maybe<CallRecord>;
  deleteOneCredential?: Maybe<Credential>;
  deleteOneFileToEntity?: Maybe<FileToEntity>;
  deleteOneInfoItem?: Maybe<InfoItem>;
  deleteOneKiosk?: Maybe<Kiosk>;
  deleteOneLanguage?: Maybe<Language>;
  deleteOneLocalization?: Maybe<Localization>;
  deleteOneLocation?: Maybe<Location>;
  deleteOnePass?: Maybe<Pass>;
  deleteOnePayment?: Maybe<Payment>;
  deleteOnePaymentTransaction?: Maybe<PaymentTransaction>;
  deleteOneRegistration?: Maybe<Registration>;
  deleteOneRequirement?: Maybe<Requirement>;
  deleteOneResource?: Maybe<Resource>;
  deleteOneResourceGroup?: Maybe<ResourceGroup>;
  deleteOneService?: Maybe<Service>;
  deleteOneServiceRequest?: Maybe<ServiceRequest>;
  deleteOneSupplementaryCard?: Maybe<SupplementaryCard>;
  deleteOneTenant?: Maybe<Tenant>;
  deleteOneTheme?: Maybe<Theme>;
  deleteOneUnitType?: Maybe<UnitType>;
  deleteOneUserPushNotificationToken?: Maybe<UserPushNotificationToken>;
  deleteOneUserRecord?: Maybe<UserRecord>;
  deleteOneUserTenantData?: Maybe<UserTenantData>;
  deleteOneVendorServer?: Maybe<VendorServer>;
  deleteResourceGroup: ResourceGroup;
  deleteTenantLocalization: BaseSettingAnswer;
  deleteTenantTheme: BaseSettingAnswer;
  deleteUser: User;
  emitAllReservationKeysDispensedEvent: SuccessAnswer;
  emitKeyDispensedEvent: SuccessAnswer;
  endPhoneCall: SuccessAnswer;
  endVideo: SuccessAnswer;
  endVoice: SuccessAnswer;
  enrollKiosk: Kiosk;
  exchangeEnrollmentForAuth: KioskAuthAnswer;
  exchangeFreedomPayPaymentKeyForToken: FreedomPayExchangeTokenResponse;
  exchangeInternalApiKeyForAccessToken: AccessTokenOnlyAuthAnswer;
  /** Exchange a refresh token for a new bearer token. */
  exchangeRefreshToken: AuthAnswer;
  exchangeUserForPrimaryAccessToken: AuthAnswer;
  findCreateAssociateUser: FindCreateAssociateUserResult;
  findOrCreateUser: User;
  generateAssaEncryptedImageAndAuthenticationKey: AssaEncryptedImageAndAuthenticationKey;
  generateCardBlob: MifareBlobAnswer;
  generateCardBlobAndSectorsPasswords: MifareBlobAnswer;
  generateInternalApiKey: InternalApiKeyOnlyKeyAndType;
  generateLegicMobileKey: DormakabaGenerateMobileKeyResponse;
  generateLegicToken: DormakabaGenerateLegicTokenResponse;
  generateMiwaMobileKey: MiwaMobileKey;
  generateMobileWebToken: GenerateMobileWebTokenResult;
  generateSaltoMobileKey: SaltoMobileKeyResponse;
  generateWebsiteDeeplink: GenerateDeeplinkResult;
  getAwsFaceLivenessCredential: GetCredentialResponse;
  getEligibleAccessGrant: EligibleAccessGrantResponse;
  getFaceLivenessSessionResults: GetFaceLivenessSessionResultsResponse;
  getJumioKyxAccount: JumioCreateAccountResponse;
  invalidateCredential: Credential;
  issueBeamsToken: BeamsAuthAnswer;
  /** Issue an Email sign-in challenge. */
  issueEmailAuthChallenge: Scalars['Boolean'];
  issueKeyForKiosk: SuccessAnswer;
  issueKeyForKioskWithAccessGrantId: SuccessAnswer;
  /** Issue a code to pair a kiosk. */
  issueKioskEnrollmentChallenge: KioskEnrollmentChallengeAnswer;
  issueResetPasswordByEmailChallenge: Scalars['Boolean'];
  issueResetPasswordChallenge: Scalars['Boolean'];
  /** Issue a SMS sign-in challenge for a phone number. The phone number is expected to be in E.164 format. */
  issueSMSAuthChallenge: Scalars['Boolean'];
  issueStripeTerminalToken: StripeTerminalTokenAnswer;
  issueTwilioAccessToken: CallAnswer;
  issueTwilioVideoToken: CallAnswer;
  issueTwilioVoiceToken: CallAnswer;
  joinVideo: AccessTokenOnlyAuthAnswer;
  loadKioskSession: SuccessAnswer;
  performCheckIn: SuccessAnswer;
  performCheckOut: SuccessAnswer;
  performJumioPlatformFaceMatch: JumioFaceMatchResponse;
  performJumioPlatformIdVerificationWithFaceLiveness: JumioPlatformIdVerificationWithLivenessResponse;
  /** Ping to check is concardis gateway is ready */
  pingConcardis: Scalars['String'];
  pollReservationFromPms: Scalars['Boolean'];
  populateAccessGrant: IdResult;
  powerCycleKioskEnviroment: Scalars['Boolean'];
  processAndReturnAuthorizedAmount: AuthorizedAmountResponse;
  processDynamicUserData: Scalars['Boolean'];
  registerLoyaltyAccount: SuccessAnswer;
  resendConfirmationInfo: SuccessAnswer;
  resetPassword: Scalars['Boolean'];
  resetPasswordByEmail: Scalars['Boolean'];
  scheduleAccessGrantCheckIn: SuccessAnswer;
  sendAccessGrantRoomInformationToUser: SuccessAnswer;
  sendArrivalTime: SuccessAnswer;
  sendCodesToUserEmail: SuccessAnswer;
  sendDispenserStatusEmail: SuccessAnswer;
  /** Send a heartbeat for a kiosk. Relies on the custom kiosk authorization header to prove kiosk identity. */
  sendHeartbeat: Scalars['Boolean'];
  sendJoinLoyaltyEmail: SuccessAnswer;
  sendLoadKioskSessionEventResult: SuccessAnswer;
  sendMissedCallEmail: SuccessAnswer;
  /** Send a notification to partners about a mobile key update */
  sendMobileKeyNotificationUpdate: SuccessAnswer;
  sendNotification: Scalars['Boolean'];
  sendNotificationToExternalAPI: Scalars['Boolean'];
  sendSpecialRequestEmail: SuccessAnswer;
  setAccessSetup: SuccessAnswer;
  setGracePeriodsConfig: SuccessAnswer;
  setLimitKeysConfig: SuccessAnswer;
  setPaymentAccountToken: SuccessAnswer;
  /** Share a mobile credential */
  shareMobileCredential: SuccessAnswer;
  /** Exchange a username (email or phone number) and password for a bearer token. */
  signIn: AuthAnswer;
  /** Exchange a minimum amount of required information of a user for a bearer token. */
  signInByLookup: AuthAnswer;
  signUpUsersFromThirdPartyAuthenticationService: Array<User>;
  takeScreenshot: SuccessAnswer;
  /** Send the payment request to the payment terminal */
  tokenizeConcardis: Scalars['Boolean'];
  triggerPusherEventForIdVerificationResult: Scalars['Boolean'];
  triggerSendFailedAgeVerificationResultEmail: Scalars['Boolean'];
  updateAccessGrant: AccessGrant;
  updateAmenityAndUploadImageFile: Amenity;
  updateBookedPackages: Array<BookedPackage>;
  updateCaptureSecurityDepositRequirement: Requirement;
  updateConciergeItem: ConciergeItem;
  updateConciergeItemOrder: Array<UpdateConciergeItemOrderResponse>;
  updateEarlyCheckInPackage: EarlyCheckInPackage;
  updateGuestsCount: TotalGuests;
  updateInfoItemAndUploadImageFile: InfoItem;
  updateKeycardWasDispensed: SuccessAnswer;
  updateKiosk?: Maybe<Kiosk>;
  updateLocation?: Maybe<Location>;
  updateLocationGroup: LocationGroup;
  updateManyAccessGrant: AffectedRowsOutput;
  updateManyAmenity: AffectedRowsOutput;
  updateManyAmenityGroup: AffectedRowsOutput;
  updateManyCallRecord: AffectedRowsOutput;
  updateManyCredential: AffectedRowsOutput;
  updateManyFileToEntity: AffectedRowsOutput;
  updateManyInfoItem: AffectedRowsOutput;
  updateManyKiosk: AffectedRowsOutput;
  updateManyLanguage: AffectedRowsOutput;
  updateManyLocalization: AffectedRowsOutput;
  updateManyLocation: AffectedRowsOutput;
  updateManyPass: AffectedRowsOutput;
  updateManyPayment: AffectedRowsOutput;
  updateManyPaymentTransaction: AffectedRowsOutput;
  updateManyRegistration: AffectedRowsOutput;
  updateManyRequirement: AffectedRowsOutput;
  updateManyResource: AffectedRowsOutput;
  updateManyResourceGroup: AffectedRowsOutput;
  updateManyService: AffectedRowsOutput;
  updateManyServiceRequest: AffectedRowsOutput;
  updateManySupplementaryCard: AffectedRowsOutput;
  updateManyTenant: AffectedRowsOutput;
  updateManyTheme: AffectedRowsOutput;
  updateManyUnitType: AffectedRowsOutput;
  updateManyUserPushNotificationToken: AffectedRowsOutput;
  updateManyUserRecord: AffectedRowsOutput;
  updateManyUserTenantData: AffectedRowsOutput;
  updateManyVendorServer: AffectedRowsOutput;
  updateOneAccessGrant?: Maybe<AccessGrant>;
  updateOneAmenity?: Maybe<Amenity>;
  updateOneAmenityGroup?: Maybe<AmenityGroup>;
  updateOneCallRecord?: Maybe<CallRecord>;
  updateOneCredential?: Maybe<Credential>;
  updateOneFileToEntity?: Maybe<FileToEntity>;
  updateOneInfoItem?: Maybe<InfoItem>;
  updateOneKiosk?: Maybe<Kiosk>;
  updateOneLanguage?: Maybe<Language>;
  updateOneLocalization?: Maybe<Localization>;
  updateOneLocation?: Maybe<Location>;
  updateOnePass?: Maybe<Pass>;
  updateOnePayment?: Maybe<Payment>;
  updateOnePaymentTransaction?: Maybe<PaymentTransaction>;
  updateOneRegistration?: Maybe<Registration>;
  updateOneRequirement?: Maybe<Requirement>;
  updateOneResource?: Maybe<Resource>;
  updateOneResourceGroup?: Maybe<ResourceGroup>;
  updateOneService?: Maybe<Service>;
  updateOneServiceRequest?: Maybe<ServiceRequest>;
  updateOneSupplementaryCard?: Maybe<SupplementaryCard>;
  updateOneTenant?: Maybe<Tenant>;
  updateOneTheme?: Maybe<Theme>;
  updateOneUnitType?: Maybe<UnitType>;
  updateOneUserPushNotificationToken?: Maybe<UserPushNotificationToken>;
  updateOneUserRecord?: Maybe<UserRecord>;
  updateOneUserTenantData?: Maybe<UserTenantData>;
  updateOneVendorServer?: Maybe<VendorServer>;
  updateRequirement: Requirement;
  updateRequirements: SuccessAnswer;
  updateResource?: Maybe<Resource>;
  updateResourceAndUploadImageFile?: Maybe<Resource>;
  updateResourceGroup: ResourceGroup;
  updateServiceAndUploadImageFile: Service;
  updateServiceRequest?: Maybe<ServiceRequest>;
  updateUnitTypeAndUploadImageFile: UnitType;
  updateUser: User;
  updateUserAccessGrantRequirement?: Maybe<UserAccessGrantRequirement>;
  uploadDocumentsToJumio: JumioUploadDocumentsResponse;
  uploadFile: File;
  uploadResources?: Maybe<Array<Resource>>;
  uploadSignatureFile: Scalars['String'];
  uploadSignedAgreementFile: Scalars['String'];
  uploadUnitTypes?: Maybe<Array<UnitType>>;
  upsertAccessGrantRequirement: AccessGrant;
  upsertKioskLocalization: BaseSettingAnswer;
  upsertKioskTheme: BaseSettingAnswer;
  upsertLocationLocalization: BaseSettingAnswer;
  upsertLocationTheme: BaseSettingAnswer;
  upsertOneAccessGrant: AccessGrant;
  upsertOneAmenity: Amenity;
  upsertOneAmenityGroup: AmenityGroup;
  upsertOneCallRecord: CallRecord;
  upsertOneCredential: Credential;
  upsertOneFileToEntity: FileToEntity;
  upsertOneInfoItem: InfoItem;
  upsertOneKiosk: Kiosk;
  upsertOneLanguage: Language;
  upsertOneLocalization: Localization;
  upsertOneLocation: Location;
  upsertOnePass: Pass;
  upsertOnePayment: Payment;
  upsertOnePaymentTransaction: PaymentTransaction;
  upsertOneRegistration: Registration;
  upsertOneRequirement: Requirement;
  upsertOneResource: Resource;
  upsertOneResourceGroup: ResourceGroup;
  upsertOneService: Service;
  upsertOneServiceRequest: ServiceRequest;
  upsertOneSupplementaryCard: SupplementaryCard;
  upsertOneTenant: Tenant;
  upsertOneTheme: Theme;
  upsertOneUnitType: UnitType;
  upsertOneUserPushNotificationToken: UserPushNotificationToken;
  upsertOneUserRecord: UserRecord;
  upsertOneUserTenantData: UserTenantData;
  upsertOneVendorServer: VendorServer;
  upsertOrDeleteUnitTypeLocalizations: Array<BaseLocalizationAnswer>;
  upsertTenantLocalization: BaseSettingAnswer;
  upsertTenantTheme: BaseSettingAnswer;
  verifyRequirements: VerifyRequirementsResponse;
  verifyStripeBankAccount: Payment;
};


export type MutationAccessMembershipArgs = {
  membershipId: Scalars['String'];
};


export type MutationAddUserToAccessGrantArgs = {
  data: AddUserToAccessGrantInput;
  where: AddUserToAccessGrantArgsWhereInput;
};


export type MutationAnswerEmailAuthChallengeArgs = {
  answer: Scalars['String'];
  email: Scalars['String'];
};


export type MutationAnswerQrChallengeArgs = {
  code: Scalars['String'];
};


export type MutationAnswerQrChallengeByWebsiteTokenArgs = {
  token: Scalars['String'];
};


export type MutationAnswerSmsAuthChallengeArgs = {
  answer: Scalars['String'];
  phoneNumber: Scalars['String'];
};


export type MutationAssaCreateEndpointInvitationArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationAssaTerminateEndpointArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationAuthenticateByConfirmationCodeArgs = {
  confirmationCode: Scalars['String'];
  locationId: Scalars['String'];
};


export type MutationAuthenticateByFirstLastDepartureArgs = {
  departureDate: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  locationId: Scalars['String'];
};


export type MutationAuthenticatePmsRequestArgs = {
  locationExternalId: Scalars['String'];
  pmsType: PmsType;
  token: Scalars['String'];
};


export type MutationAuthorizePaymentArgs = {
  accessGrantId: Scalars['String'];
  expirationDate?: InputMaybe<Scalars['String']>;
  paymentId?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};


export type MutationBypassVerificationArgs = {
  kioskId: Scalars['String'];
};


export type MutationCalculateRequirementsArgs = {
  accessGrantId: Scalars['String'];
  sessionId?: InputMaybe<Scalars['String']>;
  workFlowType: Scalars['String'];
};


export type MutationCancelAccessGrantArgs = {
  where: AccessGrantWhereUniqueInput;
};


export type MutationCapturePaymentArgs = {
  accessGrantId: Scalars['String'];
  paymentId: Scalars['String'];
};


export type MutationCaptureSecurityDepositArgs = {
  accessGrantId: Scalars['String'];
  paymentId: Scalars['String'];
};


export type MutationCloudbedsConnectAppArgs = {
  locationId: Scalars['String'];
  token: Scalars['String'];
};


export type MutationCloudbedsDisconnectAppArgs = {
  locationId: Scalars['String'];
};


export type MutationConfirmKeycardWasDispensedArgs = {
  accessGrantId: Scalars['String'];
  cardSerialNumber: Scalars['String'];
};


export type MutationCreateAccessGrantArgs = {
  data: AccessGrantCreateInput;
  originalAgreementFileId?: InputMaybe<Scalars['String']>;
};


export type MutationCreateAmenityAndUploadImageFileArgs = {
  data: CustomAmenityCreateInput;
};


export type MutationCreateAndSaveTemporaryQrChallengeArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationCreateAssaEndpointArgs = {
  locationId: Scalars['String'];
};


export type MutationCreateAssaKeyArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationCreateAssaMobileKeyArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationCreateCallRecordArgs = {
  data?: InputMaybe<CallRecordCreateInput>;
};


export type MutationCreateConciergeItemArgs = {
  data: CreateConciergeItemInput;
};


export type MutationCreateCredentialArgs = {
  data: CredentialCreateInput;
};


export type MutationCreateEarlyCheckInPackageArgs = {
  data: EarlyCheckInPackageInput;
};


export type MutationCreateGuestEngagementEventArgs = {
  accessGrantId: Scalars['String'];
  kioskId: Scalars['String'];
};


export type MutationCreateInfoItemAndUploadImageFileArgs = {
  data: CustomInfoItemCreateInput;
};


export type MutationCreateLocationArgs = {
  data: LocationCreateInput;
  params?: InputMaybe<LocationParamsInput>;
};


export type MutationCreateLocationGroupArgs = {
  data: CustomLocationGroupCreateInput;
};


export type MutationCreateManyAccessGrantArgs = {
  data: Array<AccessGrantCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyAmenityArgs = {
  data: Array<AmenityCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyAmenityGroupArgs = {
  data: Array<AmenityGroupCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyCallRecordArgs = {
  data: Array<CallRecordCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyCredentialArgs = {
  data: Array<CredentialCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyFileToEntityArgs = {
  data: Array<FileToEntityCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyInfoItemArgs = {
  data: Array<InfoItemCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyKioskArgs = {
  data: Array<KioskCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyLanguageArgs = {
  data: Array<LanguageCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyLocalizationArgs = {
  data: Array<LocalizationCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyLocationArgs = {
  data: Array<LocationCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyPassArgs = {
  data: Array<PassCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyPaymentArgs = {
  data: Array<PaymentCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyPaymentTransactionArgs = {
  data: Array<PaymentTransactionCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyRegistrationArgs = {
  data: Array<RegistrationCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyRequirementArgs = {
  data: Array<RequirementCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyResourceArgs = {
  data: Array<ResourceCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyResourceGroupArgs = {
  data: Array<ResourceGroupCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyServiceArgs = {
  data: Array<ServiceCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyServiceRequestArgs = {
  data: Array<ServiceRequestCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManySupplementaryCardArgs = {
  data: Array<SupplementaryCardCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyTenantArgs = {
  data: Array<TenantCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyThemeArgs = {
  data: Array<ThemeCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyUnitTypeArgs = {
  data: Array<UnitTypeCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyUserPushNotificationTokenArgs = {
  data: Array<UserPushNotificationTokenCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyUserRecordArgs = {
  data: Array<UserRecordCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyUserTenantDataArgs = {
  data: Array<UserTenantDataCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateManyVendorServerArgs = {
  data: Array<VendorServerCreateManyInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};


export type MutationCreateMobileCredentialsArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationCreateOneAccessGrantArgs = {
  data: AccessGrantCreateInput;
};


export type MutationCreateOneAmenityArgs = {
  data: AmenityCreateInput;
};


export type MutationCreateOneAmenityGroupArgs = {
  data: AmenityGroupCreateInput;
};


export type MutationCreateOneCallRecordArgs = {
  data?: InputMaybe<CallRecordCreateInput>;
};


export type MutationCreateOneCredentialArgs = {
  data: CredentialCreateInput;
};


export type MutationCreateOneFileToEntityArgs = {
  data: FileToEntityCreateInput;
};


export type MutationCreateOneInfoItemArgs = {
  data: InfoItemCreateInput;
};


export type MutationCreateOneKioskArgs = {
  data: KioskCreateInput;
};


export type MutationCreateOneLanguageArgs = {
  data: LanguageCreateInput;
};


export type MutationCreateOneLocalizationArgs = {
  data: LocalizationCreateInput;
};


export type MutationCreateOneLocationArgs = {
  data: LocationCreateInput;
};


export type MutationCreateOnePassArgs = {
  data: PassCreateInput;
};


export type MutationCreateOnePaymentArgs = {
  data: PaymentCreateInput;
};


export type MutationCreateOnePaymentTransactionArgs = {
  data: PaymentTransactionCreateInput;
};


export type MutationCreateOneRegistrationArgs = {
  data: RegistrationCreateInput;
};


export type MutationCreateOneRequirementArgs = {
  data: RequirementCreateInput;
};


export type MutationCreateOneResourceArgs = {
  data: ResourceCreateInput;
};


export type MutationCreateOneResourceGroupArgs = {
  data: ResourceGroupCreateInput;
};


export type MutationCreateOneServiceArgs = {
  data: ServiceCreateInput;
};


export type MutationCreateOneServiceRequestArgs = {
  data: ServiceRequestCreateInput;
};


export type MutationCreateOneSupplementaryCardArgs = {
  data: SupplementaryCardCreateInput;
};


export type MutationCreateOneTenantArgs = {
  data: TenantCreateInput;
};


export type MutationCreateOneThemeArgs = {
  data: ThemeCreateInput;
};


export type MutationCreateOneUnitTypeArgs = {
  data: UnitTypeCreateInput;
};


export type MutationCreateOneUserPushNotificationTokenArgs = {
  data: UserPushNotificationTokenCreateInput;
};


export type MutationCreateOneUserRecordArgs = {
  data: UserRecordCreateInput;
};


export type MutationCreateOneUserTenantDataArgs = {
  data: UserTenantDataCreateInput;
};


export type MutationCreateOneVendorServerArgs = {
  data: VendorServerCreateInput;
};


export type MutationCreatePaymentArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  data: CustomPaymentCreateInput;
};


export type MutationCreatePaymentTransactionArgs = {
  data: PaymentTransactionCreateInput;
};


export type MutationCreateRequirementArgs = {
  data: RequirementCreateInput;
};


export type MutationCreateResourceArgs = {
  data: ResourceCreateInput;
};


export type MutationCreateResourceAndUploadImageFileArgs = {
  data: CustomResourceCreateInput;
};


export type MutationCreateResourceGroupArgs = {
  data: ResourceGroupCreateInput;
};


export type MutationCreateSeosMobileKeyArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationCreateServiceAndUploadImageFileArgs = {
  data: CustomServiceCreateInput;
};


export type MutationCreateServiceRequestArgs = {
  data: ServiceRequestCreateInput;
};


export type MutationCreateSquareCustomerArgs = {
  tenantId: Scalars['String'];
};


export type MutationCreateSquareCustomerWithAccessGrantIdArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationCreateUnitTypeAndUploadImageFileArgs = {
  data: CustomUnitTypeCreateInput;
};


export type MutationCreateUserArgs = {
  data?: InputMaybe<UserCreateInput>;
};


export type MutationCustomUpsertCredentialArgs = {
  create: CredentialCreateInput;
  update: CredentialUpdateInput;
  where: CredentialWhereUniqueInput;
};


export type MutationDashboardSignInArgs = {
  email: Scalars['String'];
  password: Scalars['String'];
};


export type MutationDeleteConciergeItemArgs = {
  where: InfoItemWhereInput;
};


export type MutationDeleteEarlyCheckInPackageArgs = {
  serviceId: Scalars['String'];
};


export type MutationDeleteKioskLocalizationArgs = {
  componentName: Scalars['String'];
  kioskId: Scalars['String'];
  languageId: Scalars['String'];
};


export type MutationDeleteKioskThemeArgs = {
  componentName: Scalars['String'];
  kioskId: Scalars['String'];
};


export type MutationDeleteLocationGroupArgs = {
  locationGroupId: Scalars['String'];
};


export type MutationDeleteLocationLocalizationArgs = {
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  locationId: Scalars['String'];
};


export type MutationDeleteLocationThemeArgs = {
  componentName: Scalars['String'];
  locationId: Scalars['String'];
};


export type MutationDeleteManyAccessGrantArgs = {
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type MutationDeleteManyAmenityArgs = {
  where?: InputMaybe<AmenityWhereInput>;
};


export type MutationDeleteManyAmenityGroupArgs = {
  where?: InputMaybe<AmenityGroupWhereInput>;
};


export type MutationDeleteManyCallRecordArgs = {
  where?: InputMaybe<CallRecordWhereInput>;
};


export type MutationDeleteManyCredentialArgs = {
  where?: InputMaybe<CredentialWhereInput>;
};


export type MutationDeleteManyFileToEntityArgs = {
  where?: InputMaybe<FileToEntityWhereInput>;
};


export type MutationDeleteManyInfoItemArgs = {
  where?: InputMaybe<InfoItemWhereInput>;
};


export type MutationDeleteManyKioskArgs = {
  where?: InputMaybe<KioskWhereInput>;
};


export type MutationDeleteManyLanguageArgs = {
  where?: InputMaybe<LanguageWhereInput>;
};


export type MutationDeleteManyLocalizationArgs = {
  where?: InputMaybe<LocalizationWhereInput>;
};


export type MutationDeleteManyLocationArgs = {
  where?: InputMaybe<LocationWhereInput>;
};


export type MutationDeleteManyPassArgs = {
  where?: InputMaybe<PassWhereInput>;
};


export type MutationDeleteManyPaymentArgs = {
  where?: InputMaybe<PaymentWhereInput>;
};


export type MutationDeleteManyPaymentTransactionArgs = {
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


export type MutationDeleteManyRegistrationArgs = {
  where?: InputMaybe<RegistrationWhereInput>;
};


export type MutationDeleteManyRequirementArgs = {
  where?: InputMaybe<RequirementWhereInput>;
};


export type MutationDeleteManyResourceArgs = {
  where?: InputMaybe<ResourceWhereInput>;
};


export type MutationDeleteManyResourceGroupArgs = {
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type MutationDeleteManyServiceArgs = {
  where?: InputMaybe<ServiceWhereInput>;
};


export type MutationDeleteManyServiceRequestArgs = {
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type MutationDeleteManySupplementaryCardArgs = {
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


export type MutationDeleteManyTenantArgs = {
  where?: InputMaybe<TenantWhereInput>;
};


export type MutationDeleteManyThemeArgs = {
  where?: InputMaybe<ThemeWhereInput>;
};


export type MutationDeleteManyUnitTypeArgs = {
  where?: InputMaybe<UnitTypeWhereInput>;
};


export type MutationDeleteManyUserPushNotificationTokenArgs = {
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type MutationDeleteManyUserRecordArgs = {
  where?: InputMaybe<UserRecordWhereInput>;
};


export type MutationDeleteManyUserTenantDataArgs = {
  where?: InputMaybe<UserTenantDataWhereInput>;
};


export type MutationDeleteManyVendorServerArgs = {
  where?: InputMaybe<VendorServerWhereInput>;
};


export type MutationDeleteOneAccessGrantArgs = {
  where: AccessGrantWhereUniqueInput;
};


export type MutationDeleteOneAmenityArgs = {
  where: AmenityWhereUniqueInput;
};


export type MutationDeleteOneAmenityGroupArgs = {
  where: AmenityGroupWhereUniqueInput;
};


export type MutationDeleteOneCallRecordArgs = {
  where: CallRecordWhereUniqueInput;
};


export type MutationDeleteOneCredentialArgs = {
  where: CredentialWhereUniqueInput;
};


export type MutationDeleteOneFileToEntityArgs = {
  where: FileToEntityWhereUniqueInput;
};


export type MutationDeleteOneInfoItemArgs = {
  where: InfoItemWhereUniqueInput;
};


export type MutationDeleteOneKioskArgs = {
  where: KioskWhereUniqueInput;
};


export type MutationDeleteOneLanguageArgs = {
  where: LanguageWhereUniqueInput;
};


export type MutationDeleteOneLocalizationArgs = {
  where: LocalizationWhereUniqueInput;
};


export type MutationDeleteOneLocationArgs = {
  where: LocationWhereUniqueInput;
};


export type MutationDeleteOnePassArgs = {
  where: PassWhereUniqueInput;
};


export type MutationDeleteOnePaymentArgs = {
  where: PaymentWhereUniqueInput;
};


export type MutationDeleteOnePaymentTransactionArgs = {
  where: PaymentTransactionWhereUniqueInput;
};


export type MutationDeleteOneRegistrationArgs = {
  where: RegistrationWhereUniqueInput;
};


export type MutationDeleteOneRequirementArgs = {
  where: RequirementWhereUniqueInput;
};


export type MutationDeleteOneResourceArgs = {
  where: ResourceWhereUniqueInput;
};


export type MutationDeleteOneResourceGroupArgs = {
  where: ResourceGroupWhereUniqueInput;
};


export type MutationDeleteOneServiceArgs = {
  where: ServiceWhereUniqueInput;
};


export type MutationDeleteOneServiceRequestArgs = {
  where: ServiceRequestWhereUniqueInput;
};


export type MutationDeleteOneSupplementaryCardArgs = {
  where: SupplementaryCardWhereUniqueInput;
};


export type MutationDeleteOneTenantArgs = {
  where: TenantWhereUniqueInput;
};


export type MutationDeleteOneThemeArgs = {
  where: ThemeWhereUniqueInput;
};


export type MutationDeleteOneUnitTypeArgs = {
  where: UnitTypeWhereUniqueInput;
};


export type MutationDeleteOneUserPushNotificationTokenArgs = {
  where: UserPushNotificationTokenWhereUniqueInput;
};


export type MutationDeleteOneUserRecordArgs = {
  where: UserRecordWhereUniqueInput;
};


export type MutationDeleteOneUserTenantDataArgs = {
  where: UserTenantDataWhereUniqueInput;
};


export type MutationDeleteOneVendorServerArgs = {
  where: VendorServerWhereUniqueInput;
};


export type MutationDeleteResourceGroupArgs = {
  where: ResourceGroupWhereUniqueInput;
};


export type MutationDeleteTenantLocalizationArgs = {
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationDeleteTenantThemeArgs = {
  componentName: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationDeleteUserArgs = {
  where: UserWhereUniqueInput;
};


export type MutationEmitAllReservationKeysDispensedEventArgs = {
  data: EmitKeyDispensedEventInput;
};


export type MutationEmitKeyDispensedEventArgs = {
  data: EmitKeyDispensedEventInput;
};


export type MutationEndPhoneCallArgs = {
  callRecordId: Scalars['String'];
};


export type MutationEndVideoArgs = {
  callRecordId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationEndVoiceArgs = {
  callRecordId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationEnrollKioskArgs = {
  code: Scalars['String'];
  locationId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
};


export type MutationExchangeEnrollmentForAuthArgs = {
  code: Scalars['String'];
};


export type MutationExchangeFreedomPayPaymentKeyForTokenArgs = {
  accessGrantId: Scalars['String'];
  nameOnCard: Scalars['String'];
  paymentKey: Scalars['String'];
  sessionKey: Scalars['String'];
};


export type MutationExchangeInternalApiKeyForAccessTokenArgs = {
  key: Scalars['String'];
};


export type MutationExchangeRefreshTokenArgs = {
  token: Scalars['String'];
};


export type MutationExchangeUserForPrimaryAccessTokenArgs = {
  userId: Scalars['String'];
};


export type MutationFindCreateAssociateUserArgs = {
  where: FindCreateAssociateUserInput;
};


export type MutationFindOrCreateUserArgs = {
  where: FindOrCreateUserInput;
};


export type MutationGenerateAssaEncryptedImageAndAuthenticationKeyArgs = {
  accessGrantId: Scalars['String'];
  cardSN: Scalars['String'];
};


export type MutationGenerateCardBlobArgs = {
  accessGrantId: Scalars['String'];
  cardSN: Scalars['String'];
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
};


export type MutationGenerateCardBlobAndSectorsPasswordsArgs = {
  accessGrantId: Scalars['String'];
  cardSN: Scalars['String'];
  rfidTagType?: InputMaybe<RfidTagType>;
};


export type MutationGenerateInternalApiKeyArgs = {
  tenantId: Scalars['String'];
  type: InternalApiKeyType;
};


export type MutationGenerateLegicMobileKeyArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationGenerateLegicTokenArgs = {
  deviceId?: InputMaybe<Scalars['String']>;
};


export type MutationGenerateMiwaMobileKeyArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationGenerateMobileWebTokenArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationGenerateSaltoMobileKeyArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationGenerateWebsiteDeeplinkArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationGetAwsFaceLivenessCredentialArgs = {
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationGetEligibleAccessGrantArgs = {
  confirmationCode: Scalars['String'];
  locationId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationGetFaceLivenessSessionResultsArgs = {
  accessGrantId: Scalars['String'];
  performFaceMatch?: InputMaybe<Scalars['Boolean']>;
  sessionId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
  workFlowType: Scalars['String'];
};


export type MutationGetJumioKyxAccountArgs = {
  accessGrantId: Scalars['String'];
  reportingCriteria?: InputMaybe<Scalars['String']>;
  userConsentObtainedAt?: InputMaybe<Scalars['String']>;
  userCountry?: InputMaybe<Scalars['String']>;
  userIp?: InputMaybe<Scalars['String']>;
  workflowKey?: InputMaybe<Scalars['Float']>;
};


export type MutationInvalidateCredentialArgs = {
  credentialId: Scalars['String'];
};


export type MutationIssueEmailAuthChallengeArgs = {
  email: Scalars['String'];
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationIssueKeyForKioskArgs = {
  kioskId: Scalars['String'];
};


export type MutationIssueKeyForKioskWithAccessGrantIdArgs = {
  accessGrantId: Scalars['String'];
  kioskId: Scalars['String'];
};


export type MutationIssueResetPasswordByEmailChallengeArgs = {
  email: Scalars['String'];
};


export type MutationIssueResetPasswordChallengeArgs = {
  channel: Scalars['String'];
  tenantId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};


export type MutationIssueSmsAuthChallengeArgs = {
  phoneNumber: Scalars['String'];
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationIssueTwilioAccessTokenArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationIssueTwilioVideoTokenArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationIssueTwilioVoiceTokenArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  kioskId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationJoinVideoArgs = {
  callRecordId: Scalars['String'];
  joinerChallenge: Scalars['String'];
  room: Scalars['String'];
};


export type MutationLoadKioskSessionArgs = {
  accessGrantId: Scalars['String'];
  kioskId: Scalars['String'];
};


export type MutationPerformCheckInArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationPerformCheckOutArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationPerformJumioPlatformFaceMatchArgs = {
  accessGrantId: Scalars['String'];
  faceImageUrl: Scalars['String'];
  workFlowType: Scalars['String'];
};


export type MutationPerformJumioPlatformIdVerificationWithFaceLivenessArgs = {
  accessGrantId: Scalars['String'];
  backsideImageBase64?: InputMaybe<Scalars['String']>;
  faceImageBase64?: InputMaybe<Scalars['String']>;
  faceImageUrl?: InputMaybe<Scalars['String']>;
  frontsideImageBase64: Scalars['String'];
  reportingCriteria: Scalars['String'];
  userConsentObtainedAt?: InputMaybe<Scalars['String']>;
  userCountry?: InputMaybe<Scalars['String']>;
  userIp?: InputMaybe<Scalars['String']>;
};


export type MutationPollReservationFromPmsArgs = {
  confirmationCode: Scalars['String'];
  locationId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationPopulateAccessGrantArgs = {
  where: PopulateAccessGrantInput;
};


export type MutationPowerCycleKioskEnviromentArgs = {
  command: Scalars['String'];
};


export type MutationProcessAndReturnAuthorizedAmountArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationProcessDynamicUserDataArgs = {
  accessGrantId: Scalars['String'];
  dynamicUserDetails: DynamicUserDetails;
};


export type MutationRegisterLoyaltyAccountArgs = {
  AccessGrantId: Scalars['String'];
};


export type MutationResendConfirmationInfoArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationResetPasswordArgs = {
  challenge: Scalars['String'];
  password: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationResetPasswordByEmailArgs = {
  challenge: Scalars['String'];
  email: Scalars['String'];
  newPassword: Scalars['String'];
};


export type MutationScheduleAccessGrantCheckInArgs = {
  accessGrantId: Scalars['String'];
  retryCheckinStartsAt: Scalars['DateTime'];
};


export type MutationSendAccessGrantRoomInformationToUserArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationSendArrivalTimeArgs = {
  accessGrantId: Scalars['String'];
  arrivalTime: Scalars['String'];
};


export type MutationSendCodesToUserEmailArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationSendDispenserStatusEmailArgs = {
  emailType?: InputMaybe<Scalars['String']>;
  secondStatus?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};


export type MutationSendHeartbeatArgs = {
  appVersion?: InputMaybe<Scalars['String']>;
  batteryLevel?: InputMaybe<Scalars['Float']>;
  buildNumber?: InputMaybe<Scalars['String']>;
  chargingState?: InputMaybe<Scalars['String']>;
  deviceId?: InputMaybe<Scalars['String']>;
  deviceModel?: InputMaybe<Scalars['String']>;
  deviceOS?: InputMaybe<Scalars['String']>;
  deviceVersion?: InputMaybe<Scalars['String']>;
  isDispenserConnected?: InputMaybe<Scalars['Boolean']>;
  isStripeReaderConnected?: InputMaybe<Scalars['Boolean']>;
  isTerminalConnected?: InputMaybe<Scalars['Boolean']>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  serverUrl?: InputMaybe<Scalars['String']>;
};


export type MutationSendJoinLoyaltyEmailArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationSendLoadKioskSessionEventResultArgs = {
  loadKioskSessionResultArgs: LoadKioskSessionResultArgs;
  result: SendLoadKioskSessionEventResult;
};


export type MutationSendMissedCallEmailArgs = {
  callRecordId: Scalars['String'];
  guestContactInfo?: InputMaybe<GuestContactInfoInput>;
};


export type MutationSendMobileKeyNotificationUpdateArgs = {
  accessGrantId: Scalars['String'];
  status: Scalars['String'];
};


export type MutationSendNotificationArgs = {
  accessGrantId: Scalars['String'];
  notificationId: Scalars['String'];
  transport: Scalars['String'];
};


export type MutationSendNotificationToExternalApiArgs = {
  accessGrantId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};


export type MutationSendSpecialRequestEmailArgs = {
  accessGrantId: Scalars['String'];
  requestMessage: Scalars['String'];
};


export type MutationSetAccessSetupArgs = {
  data: AccessSetupInput;
  where: AccessSetupWhere;
};


export type MutationSetGracePeriodsConfigArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  data: GracePeriodInput;
  gracePeriodsConfigLevel: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationSetLimitKeysConfigArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  limitKeysConfigLevel: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  maxKeys?: InputMaybe<Scalars['Float']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type MutationSetPaymentAccountTokenArgs = {
  data: SetPaymentAccountTokenInput;
};


export type MutationShareMobileCredentialArgs = {
  accessGrantId: Scalars['String'];
  data?: InputMaybe<UserCreateInput>;
};


export type MutationSignInArgs = {
  password: Scalars['String'];
  username: Scalars['String'];
};


export type MutationSignInByLookupArgs = {
  confirmationCode: Scalars['String'];
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
};


export type MutationSignUpUsersFromThirdPartyAuthenticationServiceArgs = {
  serviceType: Scalars['String'];
  tenantId: Scalars['String'];
};


export type MutationTakeScreenshotArgs = {
  kioskId: Scalars['String'];
};


export type MutationTokenizeConcardisArgs = {
  accessGrantId: Scalars['String'];
  amount: Scalars['Float'];
  isCapture: Scalars['Boolean'];
  shouldIgnoreReverseOnPreAuth?: InputMaybe<Scalars['Boolean']>;
};


export type MutationTriggerPusherEventForIdVerificationResultArgs = {
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  scanReference: Scalars['String'];
  status: Scalars['String'];
  userId: Scalars['String'];
};


export type MutationTriggerSendFailedAgeVerificationResultEmailArgs = {
  accessGrantId: Scalars['String'];
};


export type MutationUpdateAccessGrantArgs = {
  data: AccessGrantUpdateInput;
  originalAgreementFileId?: InputMaybe<Scalars['String']>;
  where: AccessGrantWhereUniqueInput;
};


export type MutationUpdateAmenityAndUploadImageFileArgs = {
  data: CustomAmenityUpdateInput;
  where: AmenityWhereUniqueInput;
};


export type MutationUpdateBookedPackagesArgs = {
  accessGrantId: Scalars['String'];
  data: Array<CustomPackagesInputs>;
};


export type MutationUpdateCaptureSecurityDepositRequirementArgs = {
  accessGrantId: Scalars['String'];
  paymentTransactionId: Scalars['String'];
};


export type MutationUpdateConciergeItemArgs = {
  data: UpdateConciergeItemInput;
  where: InfoItemWhereInput;
};


export type MutationUpdateConciergeItemOrderArgs = {
  data: Array<UpdateConciergeItemOrderInput>;
  locationId: Scalars['String'];
};


export type MutationUpdateEarlyCheckInPackageArgs = {
  data: EarlyCheckInPackageInput;
  where: UpdateEarlyCheckInPackageWhere;
};


export type MutationUpdateGuestsCountArgs = {
  accessGrantId: Scalars['String'];
  data: Array<GuestCountInput>;
};


export type MutationUpdateInfoItemAndUploadImageFileArgs = {
  data: CustomInfoItemUpdateInput;
  where: InfoItemWhereUniqueInput;
};


export type MutationUpdateKeycardWasDispensedArgs = {
  accessGrantId: Scalars['String'];
  cardSerialNumber: Scalars['String'];
  keycardOrigin: KeycardOrigin;
};


export type MutationUpdateKioskArgs = {
  data: CustomKioskUpdateInput;
  where: KioskWhereUniqueInput;
};


export type MutationUpdateLocationArgs = {
  data: LocationUpdateInput;
  params?: InputMaybe<LocationParamsInput>;
  where: LocationWhereUniqueInput;
};


export type MutationUpdateLocationGroupArgs = {
  data: CustomLocationGroupUpdateInput;
  where: CustomLocationGroupWhereUniqueInput;
};


export type MutationUpdateManyAccessGrantArgs = {
  data: AccessGrantUpdateManyMutationInput;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type MutationUpdateManyAmenityArgs = {
  data: AmenityUpdateManyMutationInput;
  where?: InputMaybe<AmenityWhereInput>;
};


export type MutationUpdateManyAmenityGroupArgs = {
  data: AmenityGroupUpdateManyMutationInput;
  where?: InputMaybe<AmenityGroupWhereInput>;
};


export type MutationUpdateManyCallRecordArgs = {
  data: CallRecordUpdateManyMutationInput;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type MutationUpdateManyCredentialArgs = {
  data: CredentialUpdateManyMutationInput;
  where?: InputMaybe<CredentialWhereInput>;
};


export type MutationUpdateManyFileToEntityArgs = {
  data: FileToEntityUpdateManyMutationInput;
  where?: InputMaybe<FileToEntityWhereInput>;
};


export type MutationUpdateManyInfoItemArgs = {
  data: InfoItemUpdateManyMutationInput;
  where?: InputMaybe<InfoItemWhereInput>;
};


export type MutationUpdateManyKioskArgs = {
  data: KioskUpdateManyMutationInput;
  where?: InputMaybe<KioskWhereInput>;
};


export type MutationUpdateManyLanguageArgs = {
  data: LanguageUpdateManyMutationInput;
  where?: InputMaybe<LanguageWhereInput>;
};


export type MutationUpdateManyLocalizationArgs = {
  data: LocalizationUpdateManyMutationInput;
  where?: InputMaybe<LocalizationWhereInput>;
};


export type MutationUpdateManyLocationArgs = {
  data: LocationUpdateManyMutationInput;
  where?: InputMaybe<LocationWhereInput>;
};


export type MutationUpdateManyPassArgs = {
  data: PassUpdateManyMutationInput;
  where?: InputMaybe<PassWhereInput>;
};


export type MutationUpdateManyPaymentArgs = {
  data: PaymentUpdateManyMutationInput;
  where?: InputMaybe<PaymentWhereInput>;
};


export type MutationUpdateManyPaymentTransactionArgs = {
  data: PaymentTransactionUpdateManyMutationInput;
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


export type MutationUpdateManyRegistrationArgs = {
  data: RegistrationUpdateManyMutationInput;
  where?: InputMaybe<RegistrationWhereInput>;
};


export type MutationUpdateManyRequirementArgs = {
  data: RequirementUpdateManyMutationInput;
  where?: InputMaybe<RequirementWhereInput>;
};


export type MutationUpdateManyResourceArgs = {
  data: ResourceUpdateManyMutationInput;
  where?: InputMaybe<ResourceWhereInput>;
};


export type MutationUpdateManyResourceGroupArgs = {
  data: ResourceGroupUpdateManyMutationInput;
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type MutationUpdateManyServiceArgs = {
  data: ServiceUpdateManyMutationInput;
  where?: InputMaybe<ServiceWhereInput>;
};


export type MutationUpdateManyServiceRequestArgs = {
  data: ServiceRequestUpdateManyMutationInput;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type MutationUpdateManySupplementaryCardArgs = {
  data: SupplementaryCardUpdateManyMutationInput;
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


export type MutationUpdateManyTenantArgs = {
  data: TenantUpdateManyMutationInput;
  where?: InputMaybe<TenantWhereInput>;
};


export type MutationUpdateManyThemeArgs = {
  data: ThemeUpdateManyMutationInput;
  where?: InputMaybe<ThemeWhereInput>;
};


export type MutationUpdateManyUnitTypeArgs = {
  data: UnitTypeUpdateManyMutationInput;
  where?: InputMaybe<UnitTypeWhereInput>;
};


export type MutationUpdateManyUserPushNotificationTokenArgs = {
  data: UserPushNotificationTokenUpdateManyMutationInput;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type MutationUpdateManyUserRecordArgs = {
  data: UserRecordUpdateManyMutationInput;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type MutationUpdateManyUserTenantDataArgs = {
  data: UserTenantDataUpdateManyMutationInput;
  where?: InputMaybe<UserTenantDataWhereInput>;
};


export type MutationUpdateManyVendorServerArgs = {
  data: VendorServerUpdateManyMutationInput;
  where?: InputMaybe<VendorServerWhereInput>;
};


export type MutationUpdateOneAccessGrantArgs = {
  data: AccessGrantUpdateInput;
  where: AccessGrantWhereUniqueInput;
};


export type MutationUpdateOneAmenityArgs = {
  data: AmenityUpdateInput;
  where: AmenityWhereUniqueInput;
};


export type MutationUpdateOneAmenityGroupArgs = {
  data: AmenityGroupUpdateInput;
  where: AmenityGroupWhereUniqueInput;
};


export type MutationUpdateOneCallRecordArgs = {
  data: CallRecordUpdateInput;
  where: CallRecordWhereUniqueInput;
};


export type MutationUpdateOneCredentialArgs = {
  data: CredentialUpdateInput;
  where: CredentialWhereUniqueInput;
};


export type MutationUpdateOneFileToEntityArgs = {
  data: FileToEntityUpdateInput;
  where: FileToEntityWhereUniqueInput;
};


export type MutationUpdateOneInfoItemArgs = {
  data: InfoItemUpdateInput;
  where: InfoItemWhereUniqueInput;
};


export type MutationUpdateOneKioskArgs = {
  data: KioskUpdateInput;
  where: KioskWhereUniqueInput;
};


export type MutationUpdateOneLanguageArgs = {
  data: LanguageUpdateInput;
  where: LanguageWhereUniqueInput;
};


export type MutationUpdateOneLocalizationArgs = {
  data: LocalizationUpdateInput;
  where: LocalizationWhereUniqueInput;
};


export type MutationUpdateOneLocationArgs = {
  data: LocationUpdateInput;
  where: LocationWhereUniqueInput;
};


export type MutationUpdateOnePassArgs = {
  data: PassUpdateInput;
  where: PassWhereUniqueInput;
};


export type MutationUpdateOnePaymentArgs = {
  data: PaymentUpdateInput;
  where: PaymentWhereUniqueInput;
};


export type MutationUpdateOnePaymentTransactionArgs = {
  data: PaymentTransactionUpdateInput;
  where: PaymentTransactionWhereUniqueInput;
};


export type MutationUpdateOneRegistrationArgs = {
  data: RegistrationUpdateInput;
  where: RegistrationWhereUniqueInput;
};


export type MutationUpdateOneRequirementArgs = {
  data: RequirementUpdateInput;
  where: RequirementWhereUniqueInput;
};


export type MutationUpdateOneResourceArgs = {
  data: ResourceUpdateInput;
  where: ResourceWhereUniqueInput;
};


export type MutationUpdateOneResourceGroupArgs = {
  data: ResourceGroupUpdateInput;
  where: ResourceGroupWhereUniqueInput;
};


export type MutationUpdateOneServiceArgs = {
  data: ServiceUpdateInput;
  where: ServiceWhereUniqueInput;
};


export type MutationUpdateOneServiceRequestArgs = {
  data: ServiceRequestUpdateInput;
  where: ServiceRequestWhereUniqueInput;
};


export type MutationUpdateOneSupplementaryCardArgs = {
  data: SupplementaryCardUpdateInput;
  where: SupplementaryCardWhereUniqueInput;
};


export type MutationUpdateOneTenantArgs = {
  data: TenantUpdateInput;
  where: TenantWhereUniqueInput;
};


export type MutationUpdateOneThemeArgs = {
  data: ThemeUpdateInput;
  where: ThemeWhereUniqueInput;
};


export type MutationUpdateOneUnitTypeArgs = {
  data: UnitTypeUpdateInput;
  where: UnitTypeWhereUniqueInput;
};


export type MutationUpdateOneUserPushNotificationTokenArgs = {
  data: UserPushNotificationTokenUpdateInput;
  where: UserPushNotificationTokenWhereUniqueInput;
};


export type MutationUpdateOneUserRecordArgs = {
  data: UserRecordUpdateInput;
  where: UserRecordWhereUniqueInput;
};


export type MutationUpdateOneUserTenantDataArgs = {
  data: UserTenantDataUpdateInput;
  where: UserTenantDataWhereUniqueInput;
};


export type MutationUpdateOneVendorServerArgs = {
  data: VendorServerUpdateInput;
  where: VendorServerWhereUniqueInput;
};


export type MutationUpdateRequirementArgs = {
  data: RequirementUpdateInput;
  where: RequirementWhereUniqueInput;
};


export type MutationUpdateRequirementsArgs = {
  accessGrantId: Scalars['String'];
  kioskId: Scalars['String'];
  requirementArgsList: Array<CustomRequirementUpdateInput>;
};


export type MutationUpdateResourceArgs = {
  data: ResourceUpdateInput;
  where: ResourceWhereUniqueInput;
};


export type MutationUpdateResourceAndUploadImageFileArgs = {
  data: CustomResourceUpdateInput;
  where: ResourceWhereUniqueInput;
};


export type MutationUpdateResourceGroupArgs = {
  data: ResourceGroupUpdateInput;
  where: ResourceGroupWhereUniqueInput;
};


export type MutationUpdateServiceAndUploadImageFileArgs = {
  data: CustomServiceUpdateInput;
  where: ServiceWhereUniqueInput;
};


export type MutationUpdateServiceRequestArgs = {
  data: ServiceRequestUpdateInput;
  where: ServiceRequestWhereUniqueInput;
};


export type MutationUpdateUnitTypeAndUploadImageFileArgs = {
  data: CustomUnitTypeUpdateInput;
  where: UnitTypeWhereUniqueInput;
};


export type MutationUpdateUserArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
};


export type MutationUpdateUserAccessGrantRequirementArgs = {
  data: UserAccessGrantRequirementUpdateInput;
  where: UserAccessGrantRequirementWhereUniqueInput;
};


export type MutationUploadDocumentsToJumioArgs = {
  backsideImage?: InputMaybe<Scalars['String']>;
  callbackUrl: Scalars['String'];
  consentObtainedAt?: InputMaybe<Scalars['String']>;
  country: Scalars['String'];
  faceImage: Scalars['String'];
  frontsideImage: Scalars['String'];
  idType: Scalars['String'];
  merchantIdScanReference: Scalars['String'];
  merchantReportingCriteria: Scalars['String'];
  userIp?: InputMaybe<Scalars['String']>;
  userLocation?: InputMaybe<Scalars['String']>;
};


export type MutationUploadFileArgs = {
  file: Scalars['Upload'];
  fileType: FileType;
  locationId: Scalars['String'];
};


export type MutationUploadResourcesArgs = {
  file: Scalars['Upload'];
  locationId: Scalars['String'];
};


export type MutationUploadSignatureFileArgs = {
  accessGrantId: Scalars['String'];
  file: Scalars['Upload'];
  userAgreements?: InputMaybe<Array<UserAgreementInput>>;
};


export type MutationUploadSignedAgreementFileArgs = {
  accessGrantId: Scalars['String'];
  file: Scalars['Upload'];
  signedDate: Scalars['DateTime'];
  userAgreements?: InputMaybe<Array<UserAgreementInput>>;
};


export type MutationUploadUnitTypesArgs = {
  file: Scalars['Upload'];
  languageId: Scalars['String'];
  locationId: Scalars['String'];
};


export type MutationUpsertAccessGrantRequirementArgs = {
  accessGrantId: Scalars['String'];
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
};


export type MutationUpsertKioskLocalizationArgs = {
  componentName: Scalars['String'];
  kioskId: Scalars['String'];
  languageId: Scalars['String'];
  localization?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertKioskThemeArgs = {
  componentName: Scalars['String'];
  kioskId: Scalars['String'];
  setting?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertLocationLocalizationArgs = {
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  localization?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
};


export type MutationUpsertLocationThemeArgs = {
  componentName: Scalars['String'];
  locationId: Scalars['String'];
  setting?: InputMaybe<Scalars['String']>;
};


export type MutationUpsertOneAccessGrantArgs = {
  create: AccessGrantCreateInput;
  update: AccessGrantUpdateInput;
  where: AccessGrantWhereUniqueInput;
};


export type MutationUpsertOneAmenityArgs = {
  create: AmenityCreateInput;
  update: AmenityUpdateInput;
  where: AmenityWhereUniqueInput;
};


export type MutationUpsertOneAmenityGroupArgs = {
  create: AmenityGroupCreateInput;
  update: AmenityGroupUpdateInput;
  where: AmenityGroupWhereUniqueInput;
};


export type MutationUpsertOneCallRecordArgs = {
  create: CallRecordCreateInput;
  update: CallRecordUpdateInput;
  where: CallRecordWhereUniqueInput;
};


export type MutationUpsertOneCredentialArgs = {
  create: CredentialCreateInput;
  update: CredentialUpdateInput;
  where: CredentialWhereUniqueInput;
};


export type MutationUpsertOneFileToEntityArgs = {
  create: FileToEntityCreateInput;
  update: FileToEntityUpdateInput;
  where: FileToEntityWhereUniqueInput;
};


export type MutationUpsertOneInfoItemArgs = {
  create: InfoItemCreateInput;
  update: InfoItemUpdateInput;
  where: InfoItemWhereUniqueInput;
};


export type MutationUpsertOneKioskArgs = {
  create: KioskCreateInput;
  update: KioskUpdateInput;
  where: KioskWhereUniqueInput;
};


export type MutationUpsertOneLanguageArgs = {
  create: LanguageCreateInput;
  update: LanguageUpdateInput;
  where: LanguageWhereUniqueInput;
};


export type MutationUpsertOneLocalizationArgs = {
  create: LocalizationCreateInput;
  update: LocalizationUpdateInput;
  where: LocalizationWhereUniqueInput;
};


export type MutationUpsertOneLocationArgs = {
  create: LocationCreateInput;
  update: LocationUpdateInput;
  where: LocationWhereUniqueInput;
};


export type MutationUpsertOnePassArgs = {
  create: PassCreateInput;
  update: PassUpdateInput;
  where: PassWhereUniqueInput;
};


export type MutationUpsertOnePaymentArgs = {
  create: PaymentCreateInput;
  update: PaymentUpdateInput;
  where: PaymentWhereUniqueInput;
};


export type MutationUpsertOnePaymentTransactionArgs = {
  create: PaymentTransactionCreateInput;
  update: PaymentTransactionUpdateInput;
  where: PaymentTransactionWhereUniqueInput;
};


export type MutationUpsertOneRegistrationArgs = {
  create: RegistrationCreateInput;
  update: RegistrationUpdateInput;
  where: RegistrationWhereUniqueInput;
};


export type MutationUpsertOneRequirementArgs = {
  create: RequirementCreateInput;
  update: RequirementUpdateInput;
  where: RequirementWhereUniqueInput;
};


export type MutationUpsertOneResourceArgs = {
  create: ResourceCreateInput;
  update: ResourceUpdateInput;
  where: ResourceWhereUniqueInput;
};


export type MutationUpsertOneResourceGroupArgs = {
  create: ResourceGroupCreateInput;
  update: ResourceGroupUpdateInput;
  where: ResourceGroupWhereUniqueInput;
};


export type MutationUpsertOneServiceArgs = {
  create: ServiceCreateInput;
  update: ServiceUpdateInput;
  where: ServiceWhereUniqueInput;
};


export type MutationUpsertOneServiceRequestArgs = {
  create: ServiceRequestCreateInput;
  update: ServiceRequestUpdateInput;
  where: ServiceRequestWhereUniqueInput;
};


export type MutationUpsertOneSupplementaryCardArgs = {
  create: SupplementaryCardCreateInput;
  update: SupplementaryCardUpdateInput;
  where: SupplementaryCardWhereUniqueInput;
};


export type MutationUpsertOneTenantArgs = {
  create: TenantCreateInput;
  update: TenantUpdateInput;
  where: TenantWhereUniqueInput;
};


export type MutationUpsertOneThemeArgs = {
  create: ThemeCreateInput;
  update: ThemeUpdateInput;
  where: ThemeWhereUniqueInput;
};


export type MutationUpsertOneUnitTypeArgs = {
  create: UnitTypeCreateInput;
  update: UnitTypeUpdateInput;
  where: UnitTypeWhereUniqueInput;
};


export type MutationUpsertOneUserPushNotificationTokenArgs = {
  create: UserPushNotificationTokenCreateInput;
  update: UserPushNotificationTokenUpdateInput;
  where: UserPushNotificationTokenWhereUniqueInput;
};


export type MutationUpsertOneUserRecordArgs = {
  create: UserRecordCreateInput;
  update: UserRecordUpdateInput;
  where: UserRecordWhereUniqueInput;
};


export type MutationUpsertOneUserTenantDataArgs = {
  create: UserTenantDataCreateInput;
  update: UserTenantDataUpdateInput;
  where: UserTenantDataWhereUniqueInput;
};


export type MutationUpsertOneVendorServerArgs = {
  create: VendorServerCreateInput;
  update: VendorServerUpdateInput;
  where: VendorServerWhereUniqueInput;
};


export type MutationUpsertOrDeleteUnitTypeLocalizationsArgs = {
  componentName: Scalars['String'];
  unitTypeId: Scalars['String'];
  unitTypeLocalizations: CustomLocalizationInputArgs;
};


export type MutationUpsertTenantLocalizationArgs = {
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  localization?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type MutationUpsertTenantThemeArgs = {
  componentName: Scalars['String'];
  setting?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type MutationVerifyRequirementsArgs = {
  accessGrantId: Scalars['String'];
  workFlowType?: InputMaybe<Scalars['String']>;
};


export type MutationVerifyStripeBankAccountArgs = {
  amounts: Array<Scalars['Float']>;
  paymentId: Scalars['String'];
};

export type NestedBoolFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolFilter>;
};

export type NestedBoolNullableFilter = {
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableFilter>;
};

export type NestedBoolNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedBoolNullableFilter>;
  _min?: InputMaybe<NestedBoolNullableFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolNullableWithAggregatesFilter>;
};

export type NestedBoolWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedBoolFilter>;
  _min?: InputMaybe<NestedBoolFilter>;
  equals?: InputMaybe<Scalars['Boolean']>;
  not?: InputMaybe<NestedBoolWithAggregatesFilter>;
};

export type NestedDateTimeFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableFilter = {
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedDateTimeNullableFilter>;
  _min?: InputMaybe<NestedDateTimeNullableFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedDateTimeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedDateTimeFilter>;
  _min?: InputMaybe<NestedDateTimeFilter>;
  equals?: InputMaybe<Scalars['DateTime']>;
  gt?: InputMaybe<Scalars['DateTime']>;
  gte?: InputMaybe<Scalars['DateTime']>;
  in?: InputMaybe<Array<Scalars['DateTime']>>;
  lt?: InputMaybe<Scalars['DateTime']>;
  lte?: InputMaybe<Scalars['DateTime']>;
  not?: InputMaybe<NestedDateTimeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['DateTime']>>;
};

export type NestedEnumAccessGrantStateNullableFilter = {
  equals?: InputMaybe<AccessGrantState>;
  in?: InputMaybe<Array<AccessGrantState>>;
  not?: InputMaybe<NestedEnumAccessGrantStateNullableFilter>;
  notIn?: InputMaybe<Array<AccessGrantState>>;
};

export type NestedEnumAccessGrantStateNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAccessGrantStateNullableFilter>;
  _min?: InputMaybe<NestedEnumAccessGrantStateNullableFilter>;
  equals?: InputMaybe<AccessGrantState>;
  in?: InputMaybe<Array<AccessGrantState>>;
  not?: InputMaybe<NestedEnumAccessGrantStateNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AccessGrantState>>;
};

export type NestedEnumAccessGrantStatusFilter = {
  equals?: InputMaybe<AccessGrantStatus>;
  in?: InputMaybe<Array<AccessGrantStatus>>;
  not?: InputMaybe<NestedEnumAccessGrantStatusFilter>;
  notIn?: InputMaybe<Array<AccessGrantStatus>>;
};

export type NestedEnumAccessGrantStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAccessGrantStatusFilter>;
  _min?: InputMaybe<NestedEnumAccessGrantStatusFilter>;
  equals?: InputMaybe<AccessGrantStatus>;
  in?: InputMaybe<Array<AccessGrantStatus>>;
  not?: InputMaybe<NestedEnumAccessGrantStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AccessGrantStatus>>;
};

export type NestedEnumAccessGrantTypeFilter = {
  equals?: InputMaybe<AccessGrantType>;
  in?: InputMaybe<Array<AccessGrantType>>;
  not?: InputMaybe<NestedEnumAccessGrantTypeFilter>;
  notIn?: InputMaybe<Array<AccessGrantType>>;
};

export type NestedEnumAccessGrantTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumAccessGrantTypeFilter>;
  _min?: InputMaybe<NestedEnumAccessGrantTypeFilter>;
  equals?: InputMaybe<AccessGrantType>;
  in?: InputMaybe<Array<AccessGrantType>>;
  not?: InputMaybe<NestedEnumAccessGrantTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AccessGrantType>>;
};

export type NestedEnumApiCallStatusFilter = {
  equals?: InputMaybe<ApiCallStatus>;
  in?: InputMaybe<Array<ApiCallStatus>>;
  not?: InputMaybe<NestedEnumApiCallStatusFilter>;
  notIn?: InputMaybe<Array<ApiCallStatus>>;
};

export type NestedEnumAssaCardTypeNullableFilter = {
  equals?: InputMaybe<AssaCardType>;
  in?: InputMaybe<Array<AssaCardType>>;
  not?: InputMaybe<NestedEnumAssaCardTypeNullableFilter>;
  notIn?: InputMaybe<Array<AssaCardType>>;
};

export type NestedEnumAssaCardTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumAssaCardTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumAssaCardTypeNullableFilter>;
  equals?: InputMaybe<AssaCardType>;
  in?: InputMaybe<Array<AssaCardType>>;
  not?: InputMaybe<NestedEnumAssaCardTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<AssaCardType>>;
};

export type NestedEnumCallStatusFilter = {
  equals?: InputMaybe<CallStatus>;
  in?: InputMaybe<Array<CallStatus>>;
  not?: InputMaybe<NestedEnumCallStatusFilter>;
  notIn?: InputMaybe<Array<CallStatus>>;
};

export type NestedEnumCallStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCallStatusFilter>;
  _min?: InputMaybe<NestedEnumCallStatusFilter>;
  equals?: InputMaybe<CallStatus>;
  in?: InputMaybe<Array<CallStatus>>;
  not?: InputMaybe<NestedEnumCallStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CallStatus>>;
};

export type NestedEnumCallTypeFilter = {
  equals?: InputMaybe<CallType>;
  in?: InputMaybe<Array<CallType>>;
  not?: InputMaybe<NestedEnumCallTypeFilter>;
  notIn?: InputMaybe<Array<CallType>>;
};

export type NestedEnumCallTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCallTypeFilter>;
  _min?: InputMaybe<NestedEnumCallTypeFilter>;
  equals?: InputMaybe<CallType>;
  in?: InputMaybe<Array<CallType>>;
  not?: InputMaybe<NestedEnumCallTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CallType>>;
};

export type NestedEnumCharacteristicCategoryFilter = {
  equals?: InputMaybe<CharacteristicCategory>;
  in?: InputMaybe<Array<CharacteristicCategory>>;
  not?: InputMaybe<NestedEnumCharacteristicCategoryFilter>;
  notIn?: InputMaybe<Array<CharacteristicCategory>>;
};

export type NestedEnumCharacteristicRuleTypeFilter = {
  equals?: InputMaybe<CharacteristicRuleType>;
  in?: InputMaybe<Array<CharacteristicRuleType>>;
  not?: InputMaybe<NestedEnumCharacteristicRuleTypeFilter>;
  notIn?: InputMaybe<Array<CharacteristicRuleType>>;
};

export type NestedEnumChargingStateNullableFilter = {
  equals?: InputMaybe<ChargingState>;
  in?: InputMaybe<Array<ChargingState>>;
  not?: InputMaybe<NestedEnumChargingStateNullableFilter>;
  notIn?: InputMaybe<Array<ChargingState>>;
};

export type NestedEnumChargingStateNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumChargingStateNullableFilter>;
  _min?: InputMaybe<NestedEnumChargingStateNullableFilter>;
  equals?: InputMaybe<ChargingState>;
  in?: InputMaybe<Array<ChargingState>>;
  not?: InputMaybe<NestedEnumChargingStateNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ChargingState>>;
};

export type NestedEnumCredentialTypeFilter = {
  equals?: InputMaybe<CredentialType>;
  in?: InputMaybe<Array<CredentialType>>;
  not?: InputMaybe<NestedEnumCredentialTypeFilter>;
  notIn?: InputMaybe<Array<CredentialType>>;
};

export type NestedEnumCredentialTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumCredentialTypeFilter>;
  _min?: InputMaybe<NestedEnumCredentialTypeFilter>;
  equals?: InputMaybe<CredentialType>;
  in?: InputMaybe<Array<CredentialType>>;
  not?: InputMaybe<NestedEnumCredentialTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CredentialType>>;
};

export type NestedEnumCreditCardTypeNullableFilter = {
  equals?: InputMaybe<CreditCardType>;
  in?: InputMaybe<Array<CreditCardType>>;
  not?: InputMaybe<NestedEnumCreditCardTypeNullableFilter>;
  notIn?: InputMaybe<Array<CreditCardType>>;
};

export type NestedEnumCreditCardTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumCreditCardTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumCreditCardTypeNullableFilter>;
  equals?: InputMaybe<CreditCardType>;
  in?: InputMaybe<Array<CreditCardType>>;
  not?: InputMaybe<NestedEnumCreditCardTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<CreditCardType>>;
};

export type NestedEnumDispenserTypeNullableFilter = {
  equals?: InputMaybe<DispenserType>;
  in?: InputMaybe<Array<DispenserType>>;
  not?: InputMaybe<NestedEnumDispenserTypeNullableFilter>;
  notIn?: InputMaybe<Array<DispenserType>>;
};

export type NestedEnumDispenserTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumDispenserTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumDispenserTypeNullableFilter>;
  equals?: InputMaybe<DispenserType>;
  in?: InputMaybe<Array<DispenserType>>;
  not?: InputMaybe<NestedEnumDispenserTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<DispenserType>>;
};

export type NestedEnumEntityTypeFilter = {
  equals?: InputMaybe<EntityType>;
  in?: InputMaybe<Array<EntityType>>;
  not?: InputMaybe<NestedEnumEntityTypeFilter>;
  notIn?: InputMaybe<Array<EntityType>>;
};

export type NestedEnumEntityTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumEntityTypeFilter>;
  _min?: InputMaybe<NestedEnumEntityTypeFilter>;
  equals?: InputMaybe<EntityType>;
  in?: InputMaybe<Array<EntityType>>;
  not?: InputMaybe<NestedEnumEntityTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<EntityType>>;
};

export type NestedEnumFileStatusFilter = {
  equals?: InputMaybe<FileStatus>;
  in?: InputMaybe<Array<FileStatus>>;
  not?: InputMaybe<NestedEnumFileStatusFilter>;
  notIn?: InputMaybe<Array<FileStatus>>;
};

export type NestedEnumFileTypeFilter = {
  equals?: InputMaybe<FileType>;
  in?: InputMaybe<Array<FileType>>;
  not?: InputMaybe<NestedEnumFileTypeFilter>;
  notIn?: InputMaybe<Array<FileType>>;
};

export type NestedEnumIdVerificationFilter = {
  equals?: InputMaybe<IdVerification>;
  in?: InputMaybe<Array<IdVerification>>;
  not?: InputMaybe<NestedEnumIdVerificationFilter>;
  notIn?: InputMaybe<Array<IdVerification>>;
};

export type NestedEnumIdVerificationResultStatusFilter = {
  equals?: InputMaybe<IdVerificationResultStatus>;
  in?: InputMaybe<Array<IdVerificationResultStatus>>;
  not?: InputMaybe<NestedEnumIdVerificationResultStatusFilter>;
  notIn?: InputMaybe<Array<IdVerificationResultStatus>>;
};

export type NestedEnumIdVerificationWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumIdVerificationFilter>;
  _min?: InputMaybe<NestedEnumIdVerificationFilter>;
  equals?: InputMaybe<IdVerification>;
  in?: InputMaybe<Array<IdVerification>>;
  not?: InputMaybe<NestedEnumIdVerificationWithAggregatesFilter>;
  notIn?: InputMaybe<Array<IdVerification>>;
};

export type NestedEnumInfoContentTypeNullableFilter = {
  equals?: InputMaybe<InfoContentType>;
  in?: InputMaybe<Array<InfoContentType>>;
  not?: InputMaybe<NestedEnumInfoContentTypeNullableFilter>;
  notIn?: InputMaybe<Array<InfoContentType>>;
};

export type NestedEnumInfoContentTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumInfoContentTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumInfoContentTypeNullableFilter>;
  equals?: InputMaybe<InfoContentType>;
  in?: InputMaybe<Array<InfoContentType>>;
  not?: InputMaybe<NestedEnumInfoContentTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InfoContentType>>;
};

export type NestedEnumInfoTypeFilter = {
  equals?: InputMaybe<InfoType>;
  in?: InputMaybe<Array<InfoType>>;
  not?: InputMaybe<NestedEnumInfoTypeFilter>;
  notIn?: InputMaybe<Array<InfoType>>;
};

export type NestedEnumInfoTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumInfoTypeFilter>;
  _min?: InputMaybe<NestedEnumInfoTypeFilter>;
  equals?: InputMaybe<InfoType>;
  in?: InputMaybe<Array<InfoType>>;
  not?: InputMaybe<NestedEnumInfoTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<InfoType>>;
};

export type NestedEnumInternalApiKeyTypeFilter = {
  equals?: InputMaybe<InternalApiKeyType>;
  in?: InputMaybe<Array<InternalApiKeyType>>;
  not?: InputMaybe<NestedEnumInternalApiKeyTypeFilter>;
  notIn?: InputMaybe<Array<InternalApiKeyType>>;
};

export type NestedEnumKeycardOriginNullableFilter = {
  equals?: InputMaybe<KeycardOrigin>;
  in?: InputMaybe<Array<KeycardOrigin>>;
  not?: InputMaybe<NestedEnumKeycardOriginNullableFilter>;
  notIn?: InputMaybe<Array<KeycardOrigin>>;
};

export type NestedEnumKeycardOriginNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumKeycardOriginNullableFilter>;
  _min?: InputMaybe<NestedEnumKeycardOriginNullableFilter>;
  equals?: InputMaybe<KeycardOrigin>;
  in?: InputMaybe<Array<KeycardOrigin>>;
  not?: InputMaybe<NestedEnumKeycardOriginNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<KeycardOrigin>>;
};

export type NestedEnumLoyaltyTypeNullableFilter = {
  equals?: InputMaybe<LoyaltyType>;
  in?: InputMaybe<Array<LoyaltyType>>;
  not?: InputMaybe<NestedEnumLoyaltyTypeNullableFilter>;
  notIn?: InputMaybe<Array<LoyaltyType>>;
};

export type NestedEnumLoyaltyTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumLoyaltyTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumLoyaltyTypeNullableFilter>;
  equals?: InputMaybe<LoyaltyType>;
  in?: InputMaybe<Array<LoyaltyType>>;
  not?: InputMaybe<NestedEnumLoyaltyTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<LoyaltyType>>;
};

export type NestedEnumNotificationStatusFilter = {
  equals?: InputMaybe<NotificationStatus>;
  in?: InputMaybe<Array<NotificationStatus>>;
  not?: InputMaybe<NestedEnumNotificationStatusFilter>;
  notIn?: InputMaybe<Array<NotificationStatus>>;
};

export type NestedEnumNotificationTransportFilter = {
  equals?: InputMaybe<NotificationTransport>;
  in?: InputMaybe<Array<NotificationTransport>>;
  not?: InputMaybe<NestedEnumNotificationTransportFilter>;
  notIn?: InputMaybe<Array<NotificationTransport>>;
};

export type NestedEnumNotificationTypeFilter = {
  equals?: InputMaybe<NotificationType>;
  in?: InputMaybe<Array<NotificationType>>;
  not?: InputMaybe<NestedEnumNotificationTypeFilter>;
  notIn?: InputMaybe<Array<NotificationType>>;
};

export type NestedEnumOriginTypeNullableFilter = {
  equals?: InputMaybe<OriginType>;
  in?: InputMaybe<Array<OriginType>>;
  not?: InputMaybe<NestedEnumOriginTypeNullableFilter>;
  notIn?: InputMaybe<Array<OriginType>>;
};

export type NestedEnumOriginTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumOriginTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumOriginTypeNullableFilter>;
  equals?: InputMaybe<OriginType>;
  in?: InputMaybe<Array<OriginType>>;
  not?: InputMaybe<NestedEnumOriginTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<OriginType>>;
};

export type NestedEnumPaymentProviderTypeFilter = {
  equals?: InputMaybe<PaymentProviderType>;
  in?: InputMaybe<Array<PaymentProviderType>>;
  not?: InputMaybe<NestedEnumPaymentProviderTypeFilter>;
  notIn?: InputMaybe<Array<PaymentProviderType>>;
};

export type NestedEnumPaymentProviderTypeNullableFilter = {
  equals?: InputMaybe<PaymentProviderType>;
  in?: InputMaybe<Array<PaymentProviderType>>;
  not?: InputMaybe<NestedEnumPaymentProviderTypeNullableFilter>;
  notIn?: InputMaybe<Array<PaymentProviderType>>;
};

export type NestedEnumPaymentProviderTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPaymentProviderTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumPaymentProviderTypeNullableFilter>;
  equals?: InputMaybe<PaymentProviderType>;
  in?: InputMaybe<Array<PaymentProviderType>>;
  not?: InputMaybe<NestedEnumPaymentProviderTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentProviderType>>;
};

export type NestedEnumPaymentProviderTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentProviderTypeFilter>;
  _min?: InputMaybe<NestedEnumPaymentProviderTypeFilter>;
  equals?: InputMaybe<PaymentProviderType>;
  in?: InputMaybe<Array<PaymentProviderType>>;
  not?: InputMaybe<NestedEnumPaymentProviderTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentProviderType>>;
};

export type NestedEnumPaymentTransactionStatusFilter = {
  equals?: InputMaybe<PaymentTransactionStatus>;
  in?: InputMaybe<Array<PaymentTransactionStatus>>;
  not?: InputMaybe<NestedEnumPaymentTransactionStatusFilter>;
  notIn?: InputMaybe<Array<PaymentTransactionStatus>>;
};

export type NestedEnumPaymentTransactionStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumPaymentTransactionStatusFilter>;
  _min?: InputMaybe<NestedEnumPaymentTransactionStatusFilter>;
  equals?: InputMaybe<PaymentTransactionStatus>;
  in?: InputMaybe<Array<PaymentTransactionStatus>>;
  not?: InputMaybe<NestedEnumPaymentTransactionStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentTransactionStatus>>;
};

export type NestedEnumPaymentTypeNullableFilter = {
  equals?: InputMaybe<PaymentType>;
  in?: InputMaybe<Array<PaymentType>>;
  not?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
  notIn?: InputMaybe<Array<PaymentType>>;
};

export type NestedEnumPaymentTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumPaymentTypeNullableFilter>;
  equals?: InputMaybe<PaymentType>;
  in?: InputMaybe<Array<PaymentType>>;
  not?: InputMaybe<NestedEnumPaymentTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentType>>;
};

export type NestedEnumPaymentVerificationStatusNullableFilter = {
  equals?: InputMaybe<PaymentVerificationStatus>;
  in?: InputMaybe<Array<PaymentVerificationStatus>>;
  not?: InputMaybe<NestedEnumPaymentVerificationStatusNullableFilter>;
  notIn?: InputMaybe<Array<PaymentVerificationStatus>>;
};

export type NestedEnumPaymentVerificationStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPaymentVerificationStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumPaymentVerificationStatusNullableFilter>;
  equals?: InputMaybe<PaymentVerificationStatus>;
  in?: InputMaybe<Array<PaymentVerificationStatus>>;
  not?: InputMaybe<NestedEnumPaymentVerificationStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PaymentVerificationStatus>>;
};

export type NestedEnumPmsTypeFilter = {
  equals?: InputMaybe<PmsType>;
  in?: InputMaybe<Array<PmsType>>;
  not?: InputMaybe<NestedEnumPmsTypeFilter>;
  notIn?: InputMaybe<Array<PmsType>>;
};

export type NestedEnumPmsTypeNullableFilter = {
  equals?: InputMaybe<PmsType>;
  in?: InputMaybe<Array<PmsType>>;
  not?: InputMaybe<NestedEnumPmsTypeNullableFilter>;
  notIn?: InputMaybe<Array<PmsType>>;
};

export type NestedEnumPmsTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumPmsTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumPmsTypeNullableFilter>;
  equals?: InputMaybe<PmsType>;
  in?: InputMaybe<Array<PmsType>>;
  not?: InputMaybe<NestedEnumPmsTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<PmsType>>;
};

export type NestedEnumRequirementStatusFilter = {
  equals?: InputMaybe<RequirementStatus>;
  in?: InputMaybe<Array<RequirementStatus>>;
  not?: InputMaybe<NestedEnumRequirementStatusFilter>;
  notIn?: InputMaybe<Array<RequirementStatus>>;
};

export type NestedEnumRequirementStatusWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRequirementStatusFilter>;
  _min?: InputMaybe<NestedEnumRequirementStatusFilter>;
  equals?: InputMaybe<RequirementStatus>;
  in?: InputMaybe<Array<RequirementStatus>>;
  not?: InputMaybe<NestedEnumRequirementStatusWithAggregatesFilter>;
  notIn?: InputMaybe<Array<RequirementStatus>>;
};

export type NestedEnumRequirementTypeFilter = {
  equals?: InputMaybe<RequirementType>;
  in?: InputMaybe<Array<RequirementType>>;
  not?: InputMaybe<NestedEnumRequirementTypeFilter>;
  notIn?: InputMaybe<Array<RequirementType>>;
};

export type NestedEnumRequirementTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumRequirementTypeFilter>;
  _min?: InputMaybe<NestedEnumRequirementTypeFilter>;
  equals?: InputMaybe<RequirementType>;
  in?: InputMaybe<Array<RequirementType>>;
  not?: InputMaybe<NestedEnumRequirementTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<RequirementType>>;
};

export type NestedEnumResourceControlTypeNullableFilter = {
  equals?: InputMaybe<ResourceControlType>;
  in?: InputMaybe<Array<ResourceControlType>>;
  not?: InputMaybe<NestedEnumResourceControlTypeNullableFilter>;
  notIn?: InputMaybe<Array<ResourceControlType>>;
};

export type NestedEnumResourceControlTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumResourceControlTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumResourceControlTypeNullableFilter>;
  equals?: InputMaybe<ResourceControlType>;
  in?: InputMaybe<Array<ResourceControlType>>;
  not?: InputMaybe<NestedEnumResourceControlTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ResourceControlType>>;
};

export type NestedEnumResourceTypeFilter = {
  equals?: InputMaybe<ResourceType>;
  in?: InputMaybe<Array<ResourceType>>;
  not?: InputMaybe<NestedEnumResourceTypeFilter>;
  notIn?: InputMaybe<Array<ResourceType>>;
};

export type NestedEnumResourceTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumResourceTypeFilter>;
  _min?: InputMaybe<NestedEnumResourceTypeFilter>;
  equals?: InputMaybe<ResourceType>;
  in?: InputMaybe<Array<ResourceType>>;
  not?: InputMaybe<NestedEnumResourceTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ResourceType>>;
};

export type NestedEnumResourceVendorFilter = {
  equals?: InputMaybe<ResourceVendor>;
  in?: InputMaybe<Array<ResourceVendor>>;
  not?: InputMaybe<NestedEnumResourceVendorFilter>;
  notIn?: InputMaybe<Array<ResourceVendor>>;
};

export type NestedEnumResourceVendorWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumResourceVendorFilter>;
  _min?: InputMaybe<NestedEnumResourceVendorFilter>;
  equals?: InputMaybe<ResourceVendor>;
  in?: InputMaybe<Array<ResourceVendor>>;
  not?: InputMaybe<NestedEnumResourceVendorWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ResourceVendor>>;
};

export type NestedEnumRetryCheckinStatusNullableFilter = {
  equals?: InputMaybe<RetryCheckinStatus>;
  in?: InputMaybe<Array<RetryCheckinStatus>>;
  not?: InputMaybe<NestedEnumRetryCheckinStatusNullableFilter>;
  notIn?: InputMaybe<Array<RetryCheckinStatus>>;
};

export type NestedEnumRetryCheckinStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumRetryCheckinStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumRetryCheckinStatusNullableFilter>;
  equals?: InputMaybe<RetryCheckinStatus>;
  in?: InputMaybe<Array<RetryCheckinStatus>>;
  not?: InputMaybe<NestedEnumRetryCheckinStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<RetryCheckinStatus>>;
};

export type NestedEnumRfidTagTypeNullableFilter = {
  equals?: InputMaybe<RfidTagType>;
  in?: InputMaybe<Array<RfidTagType>>;
  not?: InputMaybe<NestedEnumRfidTagTypeNullableFilter>;
  notIn?: InputMaybe<Array<RfidTagType>>;
};

export type NestedEnumRfidTagTypeNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumRfidTagTypeNullableFilter>;
  _min?: InputMaybe<NestedEnumRfidTagTypeNullableFilter>;
  equals?: InputMaybe<RfidTagType>;
  in?: InputMaybe<Array<RfidTagType>>;
  not?: InputMaybe<NestedEnumRfidTagTypeNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<RfidTagType>>;
};

export type NestedEnumRoleFilter = {
  equals?: InputMaybe<Role>;
  in?: InputMaybe<Array<Role>>;
  not?: InputMaybe<NestedEnumRoleFilter>;
  notIn?: InputMaybe<Array<Role>>;
};

export type NestedEnumSecurityDepositPolicyFilter = {
  equals?: InputMaybe<SecurityDepositPolicy>;
  in?: InputMaybe<Array<SecurityDepositPolicy>>;
  not?: InputMaybe<NestedEnumSecurityDepositPolicyFilter>;
  notIn?: InputMaybe<Array<SecurityDepositPolicy>>;
};

export type NestedEnumSecurityDepositPolicyWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumSecurityDepositPolicyFilter>;
  _min?: InputMaybe<NestedEnumSecurityDepositPolicyFilter>;
  equals?: InputMaybe<SecurityDepositPolicy>;
  in?: InputMaybe<Array<SecurityDepositPolicy>>;
  not?: InputMaybe<NestedEnumSecurityDepositPolicyWithAggregatesFilter>;
  notIn?: InputMaybe<Array<SecurityDepositPolicy>>;
};

export type NestedEnumServiceRequestStatusNullableFilter = {
  equals?: InputMaybe<ServiceRequestStatus>;
  in?: InputMaybe<Array<ServiceRequestStatus>>;
  not?: InputMaybe<NestedEnumServiceRequestStatusNullableFilter>;
  notIn?: InputMaybe<Array<ServiceRequestStatus>>;
};

export type NestedEnumServiceRequestStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumServiceRequestStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumServiceRequestStatusNullableFilter>;
  equals?: InputMaybe<ServiceRequestStatus>;
  in?: InputMaybe<Array<ServiceRequestStatus>>;
  not?: InputMaybe<NestedEnumServiceRequestStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ServiceRequestStatus>>;
};

export type NestedEnumServiceRuleTypeFilter = {
  equals?: InputMaybe<ServiceRuleType>;
  in?: InputMaybe<Array<ServiceRuleType>>;
  not?: InputMaybe<NestedEnumServiceRuleTypeFilter>;
  notIn?: InputMaybe<Array<ServiceRuleType>>;
};

export type NestedEnumServiceStatusNullableFilter = {
  equals?: InputMaybe<ServiceStatus>;
  in?: InputMaybe<Array<ServiceStatus>>;
  not?: InputMaybe<NestedEnumServiceStatusNullableFilter>;
  notIn?: InputMaybe<Array<ServiceStatus>>;
};

export type NestedEnumServiceStatusNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedEnumServiceStatusNullableFilter>;
  _min?: InputMaybe<NestedEnumServiceStatusNullableFilter>;
  equals?: InputMaybe<ServiceStatus>;
  in?: InputMaybe<Array<ServiceStatus>>;
  not?: InputMaybe<NestedEnumServiceStatusNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ServiceStatus>>;
};

export type NestedEnumServiceTypeFilter = {
  equals?: InputMaybe<ServiceType>;
  in?: InputMaybe<Array<ServiceType>>;
  not?: InputMaybe<NestedEnumServiceTypeFilter>;
  notIn?: InputMaybe<Array<ServiceType>>;
};

export type NestedEnumServiceTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumServiceTypeFilter>;
  _min?: InputMaybe<NestedEnumServiceTypeFilter>;
  equals?: InputMaybe<ServiceType>;
  in?: InputMaybe<Array<ServiceType>>;
  not?: InputMaybe<NestedEnumServiceTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<ServiceType>>;
};

export type NestedEnumUserRecordTypeFilter = {
  equals?: InputMaybe<UserRecordType>;
  in?: InputMaybe<Array<UserRecordType>>;
  not?: InputMaybe<NestedEnumUserRecordTypeFilter>;
  notIn?: InputMaybe<Array<UserRecordType>>;
};

export type NestedEnumUserRecordTypeWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedEnumUserRecordTypeFilter>;
  _min?: InputMaybe<NestedEnumUserRecordTypeFilter>;
  equals?: InputMaybe<UserRecordType>;
  in?: InputMaybe<Array<UserRecordType>>;
  not?: InputMaybe<NestedEnumUserRecordTypeWithAggregatesFilter>;
  notIn?: InputMaybe<Array<UserRecordType>>;
};

export type NestedFloatFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableFilter = {
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedFloatNullableFilter>;
  _min?: InputMaybe<NestedFloatNullableFilter>;
  _sum?: InputMaybe<NestedFloatNullableFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedFloatWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedFloatFilter>;
  _min?: InputMaybe<NestedFloatFilter>;
  _sum?: InputMaybe<NestedFloatFilter>;
  equals?: InputMaybe<Scalars['Float']>;
  gt?: InputMaybe<Scalars['Float']>;
  gte?: InputMaybe<Scalars['Float']>;
  in?: InputMaybe<Array<Scalars['Float']>>;
  lt?: InputMaybe<Scalars['Float']>;
  lte?: InputMaybe<Scalars['Float']>;
  not?: InputMaybe<NestedFloatWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Float']>>;
};

export type NestedIntFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableFilter = {
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntNullableWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatNullableFilter>;
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedIntNullableFilter>;
  _min?: InputMaybe<NestedIntNullableFilter>;
  _sum?: InputMaybe<NestedIntNullableFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedIntWithAggregatesFilter = {
  _avg?: InputMaybe<NestedFloatFilter>;
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedIntFilter>;
  _min?: InputMaybe<NestedIntFilter>;
  _sum?: InputMaybe<NestedIntFilter>;
  equals?: InputMaybe<Scalars['Int']>;
  gt?: InputMaybe<Scalars['Int']>;
  gte?: InputMaybe<Scalars['Int']>;
  in?: InputMaybe<Array<Scalars['Int']>>;
  lt?: InputMaybe<Scalars['Int']>;
  lte?: InputMaybe<Scalars['Int']>;
  not?: InputMaybe<NestedIntWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['Int']>>;
};

export type NestedJsonFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type NestedJsonNullableFilter = {
  array_contains?: InputMaybe<Scalars['JSON']>;
  array_ends_with?: InputMaybe<Scalars['JSON']>;
  array_starts_with?: InputMaybe<Scalars['JSON']>;
  equals?: InputMaybe<Scalars['JSON']>;
  gt?: InputMaybe<Scalars['JSON']>;
  gte?: InputMaybe<Scalars['JSON']>;
  lt?: InputMaybe<Scalars['JSON']>;
  lte?: InputMaybe<Scalars['JSON']>;
  not?: InputMaybe<Scalars['JSON']>;
  path?: InputMaybe<Array<Scalars['String']>>;
  string_contains?: InputMaybe<Scalars['String']>;
  string_ends_with?: InputMaybe<Scalars['String']>;
  string_starts_with?: InputMaybe<Scalars['String']>;
};

export type NestedStringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type NestedStringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type Notification = {
  accessGrantId?: Maybe<Scalars['String']>;
  configId?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  locationId?: Maybe<Scalars['String']>;
  payload?: Maybe<Scalars['JSON']>;
  scheduledTime?: Maybe<Scalars['DateTime']>;
  scheduleKey?: Maybe<Scalars['String']>;
  sentAt?: Maybe<Scalars['DateTime']>;
  status: NotificationStatus;
  tenantId?: Maybe<Scalars['String']>;
  transport: NotificationTransport;
  type: Scalars['String'];
  userId?: Maybe<Scalars['String']>;
};

export type NotificationConfigCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<NotificationConfigWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationConfigCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<NotificationConfigCreateWithoutNotificationInput>;
};

export type NotificationConfigCreateOrConnectWithoutNotificationInput = {
  create: NotificationConfigCreateWithoutNotificationInput;
  where: NotificationConfigWhereUniqueInput;
};

export type NotificationConfigCreateWithoutNotificationInput = {
  days: Scalars['Int'];
  hours: Scalars['Int'];
  id?: InputMaybe<Scalars['String']>;
  relativeId: Scalars['String'];
  type: NotificationType;
};

export type NotificationConfigOrderByWithRelationInput = {
  days?: InputMaybe<SortOrder>;
  hours?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  Notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  relativeId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type NotificationConfigRelationFilter = {
  is?: InputMaybe<NotificationConfigWhereInput>;
  isNot?: InputMaybe<NotificationConfigWhereInput>;
};

export type NotificationConfigUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<NotificationConfigWhereUniqueInput>;
  connectOrCreate?: InputMaybe<NotificationConfigCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<NotificationConfigCreateWithoutNotificationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<NotificationConfigUpdateWithoutNotificationInput>;
  upsert?: InputMaybe<NotificationConfigUpsertWithoutNotificationInput>;
};

export type NotificationConfigUpdateWithoutNotificationInput = {
  days?: InputMaybe<IntFieldUpdateOperationsInput>;
  hours?: InputMaybe<IntFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  relativeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumNotificationTypeFieldUpdateOperationsInput>;
};

export type NotificationConfigUpsertWithoutNotificationInput = {
  create: NotificationConfigCreateWithoutNotificationInput;
  update: NotificationConfigUpdateWithoutNotificationInput;
};

export type NotificationConfigWhereInput = {
  AND?: InputMaybe<Array<NotificationConfigWhereInput>>;
  days?: InputMaybe<IntFilter>;
  hours?: InputMaybe<IntFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<NotificationConfigWhereInput>>;
  Notification?: InputMaybe<NotificationListRelationFilter>;
  OR?: InputMaybe<Array<NotificationConfigWhereInput>>;
  relativeId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumNotificationTypeFilter>;
};

export type NotificationConfigWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type NotificationCreateManyAccessGrantInput = {
  configId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  scheduleKey?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status: NotificationStatus;
  tenantId?: InputMaybe<Scalars['String']>;
  transport: NotificationTransport;
  type: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type NotificationCreateManyAccessGrantInputEnvelope = {
  data: Array<NotificationCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationCreateManyLocationInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  configId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  scheduleKey?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status: NotificationStatus;
  tenantId?: InputMaybe<Scalars['String']>;
  transport: NotificationTransport;
  type: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type NotificationCreateManyLocationInputEnvelope = {
  data: Array<NotificationCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationCreateManyTenantInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  configId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  scheduleKey?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status: NotificationStatus;
  transport: NotificationTransport;
  type: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
};

export type NotificationCreateManyTenantInputEnvelope = {
  data: Array<NotificationCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationCreateManyUserInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  configId?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  scheduleKey?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status: NotificationStatus;
  tenantId?: InputMaybe<Scalars['String']>;
  transport: NotificationTransport;
  type: Scalars['String'];
};

export type NotificationCreateManyUserInputEnvelope = {
  data: Array<NotificationCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type NotificationCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<NotificationCreateManyAccessGrantInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutLocationInput>>;
  createMany?: InputMaybe<NotificationCreateManyLocationInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutTenantInput>>;
  createMany?: InputMaybe<NotificationCreateManyTenantInputEnvelope>;
};

export type NotificationCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
};

export type NotificationCreateOrConnectWithoutAccessGrantInput = {
  create: NotificationCreateWithoutAccessGrantInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutLocationInput = {
  create: NotificationCreateWithoutLocationInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutTenantInput = {
  create: NotificationCreateWithoutTenantInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateOrConnectWithoutUserInput = {
  create: NotificationCreateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationCreateWithoutAccessGrantInput = {
  config?: InputMaybe<NotificationConfigCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutNotificationInput>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  scheduleKey?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status: NotificationStatus;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutNotificationInput>;
  transport: NotificationTransport;
  type: Scalars['String'];
  user?: InputMaybe<UserCreateNestedOneWithoutNotificationInput>;
};

export type NotificationCreateWithoutLocationInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutNotificationsInput>;
  config?: InputMaybe<NotificationConfigCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  scheduleKey?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status: NotificationStatus;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutNotificationInput>;
  transport: NotificationTransport;
  type: Scalars['String'];
  user?: InputMaybe<UserCreateNestedOneWithoutNotificationInput>;
};

export type NotificationCreateWithoutTenantInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutNotificationsInput>;
  config?: InputMaybe<NotificationConfigCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutNotificationInput>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  scheduleKey?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status: NotificationStatus;
  transport: NotificationTransport;
  type: Scalars['String'];
  user?: InputMaybe<UserCreateNestedOneWithoutNotificationInput>;
};

export type NotificationCreateWithoutUserInput = {
  accessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutNotificationsInput>;
  config?: InputMaybe<NotificationConfigCreateNestedOneWithoutNotificationInput>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutNotificationInput>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<Scalars['DateTime']>;
  scheduleKey?: InputMaybe<Scalars['String']>;
  sentAt?: InputMaybe<Scalars['DateTime']>;
  status: NotificationStatus;
  tenant?: InputMaybe<TenantCreateNestedOneWithoutNotificationInput>;
  transport: NotificationTransport;
  type: Scalars['String'];
};

export type NotificationListRelationFilter = {
  every?: InputMaybe<NotificationWhereInput>;
  none?: InputMaybe<NotificationWhereInput>;
  some?: InputMaybe<NotificationWhereInput>;
};

export type NotificationOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type NotificationOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrderInput>;
  config?: InputMaybe<NotificationConfigOrderByWithRelationInput>;
  configId?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  payload?: InputMaybe<SortOrderInput>;
  scheduledTime?: InputMaybe<SortOrderInput>;
  scheduleKey?: InputMaybe<SortOrderInput>;
  sentAt?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrderInput>;
  transport?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
};

export enum NotificationScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  ConfigId = 'configId',
  CreatedAt = 'createdAt',
  Id = 'id',
  LocationId = 'locationId',
  Payload = 'payload',
  ScheduledTime = 'scheduledTime',
  ScheduleKey = 'scheduleKey',
  SentAt = 'sentAt',
  Status = 'status',
  TenantId = 'tenantId',
  Transport = 'transport',
  Type = 'type',
  UserId = 'userId'
}

export type NotificationScalarWhereInput = {
  accessGrantId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<NotificationScalarWhereInput>>;
  configId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<NotificationScalarWhereInput>>;
  OR?: InputMaybe<Array<NotificationScalarWhereInput>>;
  payload?: InputMaybe<JsonNullableFilter>;
  scheduledTime?: InputMaybe<DateTimeNullableFilter>;
  scheduleKey?: InputMaybe<StringNullableFilter>;
  sentAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumNotificationStatusFilter>;
  tenantId?: InputMaybe<StringNullableFilter>;
  transport?: InputMaybe<EnumNotificationTransportFilter>;
  type?: InputMaybe<StringFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type NotificationsObject = {
  notifications: Array<Scalars['String']>;
};

export enum NotificationStatus {
  Created = 'CREATED',
  Failed = 'FAILED',
  Processing = 'PROCESSING',
  Sent = 'SENT'
}

export enum NotificationTransport {
  Email = 'EMAIL',
  ExternalApi = 'EXTERNAL_API',
  InApp = 'IN_APP',
  Pn = 'PN',
  Sms = 'SMS'
}

export enum NotificationType {
  ApiTest = 'API_TEST',
  BookingConfirmation = 'BOOKING_CONFIRMATION',
  CheckInReminder = 'CHECK_IN_REMINDER',
  CheckOutReminder = 'CHECK_OUT_REMINDER',
  CheckedIn = 'CHECKED_IN',
  CheckedOut = 'CHECKED_OUT',
  CheckoutSurvey = 'CHECKOUT_SURVEY',
  CredentialStatusChange = 'CREDENTIAL_STATUS_CHANGE',
  EngageMobileApp = 'ENGAGE_MOBILE_APP',
  JoinLoyalty = 'JOIN_LOYALTY',
  MissedCall = 'MISSED_CALL',
  MobileWebConfirmation = 'MOBILE_WEB_CONFIRMATION',
  OperatorUpdate = 'OPERATOR_UPDATE',
  PdfRegCard = 'PDF_REG_CARD',
  PeriphericalStatus = 'PERIPHERICAL_STATUS',
  Receipt = 'RECEIPT',
  Requirement = 'REQUIREMENT',
  ResendCode = 'RESEND_CODE',
  ResendIdEmail = 'RESEND_ID_EMAIL',
  ResetPassword = 'RESET_PASSWORD',
  RnrFailureLoc2Usr = 'RNR_FAILURE_LOC2USR',
  RnrFailureVrd2Loc = 'RNR_FAILURE_VRD2LOC',
  RoomInformation = 'ROOM_INFORMATION',
  RoomNotAssigned = 'ROOM_NOT_ASSIGNED',
  RoomReady = 'ROOM_READY',
  ServiceRequest = 'SERVICE_REQUEST',
  ShareMobileCredential = 'SHARE_MOBILE_CREDENTIAL',
  SignCode = 'SIGN_CODE',
  SignedLease = 'SIGNED_LEASE',
  SpecialRequest = 'SPECIAL_REQUEST'
}

export type NotificationUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  scheduleKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNotificationStatusFieldUpdateOperationsInput>;
  transport?: InputMaybe<EnumNotificationTransportFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NotificationUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<NotificationCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type NotificationUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutLocationInput>>;
  createMany?: InputMaybe<NotificationCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type NotificationUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutTenantInput>>;
  createMany?: InputMaybe<NotificationCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type NotificationUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<NotificationCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<NotificationCreateWithoutUserInput>>;
  createMany?: InputMaybe<NotificationCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<NotificationScalarWhereInput>>;
  disconnect?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  set?: InputMaybe<Array<NotificationWhereUniqueInput>>;
  update?: InputMaybe<Array<NotificationUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<NotificationUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<NotificationUpsertWithWhereUniqueWithoutUserInput>>;
};

export type NotificationUpdateManyWithWhereWithoutAccessGrantInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutLocationInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutTenantInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateManyWithWhereWithoutUserInput = {
  data: NotificationUpdateManyMutationInput;
  where: NotificationScalarWhereInput;
};

export type NotificationUpdateWithoutAccessGrantInput = {
  config?: InputMaybe<NotificationConfigUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutNotificationNestedInput>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  scheduleKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNotificationStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutNotificationNestedInput>;
  transport?: InputMaybe<EnumNotificationTransportFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNotificationNestedInput>;
};

export type NotificationUpdateWithoutLocationInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutNotificationsNestedInput>;
  config?: InputMaybe<NotificationConfigUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  scheduleKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNotificationStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutNotificationNestedInput>;
  transport?: InputMaybe<EnumNotificationTransportFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNotificationNestedInput>;
};

export type NotificationUpdateWithoutTenantInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutNotificationsNestedInput>;
  config?: InputMaybe<NotificationConfigUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutNotificationNestedInput>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  scheduleKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNotificationStatusFieldUpdateOperationsInput>;
  transport?: InputMaybe<EnumNotificationTransportFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutNotificationNestedInput>;
};

export type NotificationUpdateWithoutUserInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneWithoutNotificationsNestedInput>;
  config?: InputMaybe<NotificationConfigUpdateOneWithoutNotificationNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutNotificationNestedInput>;
  payload?: InputMaybe<Scalars['JSON']>;
  scheduledTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  scheduleKey?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sentAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumNotificationStatusFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneWithoutNotificationNestedInput>;
  transport?: InputMaybe<EnumNotificationTransportFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type NotificationUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: NotificationUpdateWithoutAccessGrantInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutLocationInput = {
  data: NotificationUpdateWithoutLocationInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutTenantInput = {
  data: NotificationUpdateWithoutTenantInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpdateWithWhereUniqueWithoutUserInput = {
  data: NotificationUpdateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: NotificationCreateWithoutAccessGrantInput;
  update: NotificationUpdateWithoutAccessGrantInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutLocationInput = {
  create: NotificationCreateWithoutLocationInput;
  update: NotificationUpdateWithoutLocationInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutTenantInput = {
  create: NotificationCreateWithoutTenantInput;
  update: NotificationUpdateWithoutTenantInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationUpsertWithWhereUniqueWithoutUserInput = {
  create: NotificationCreateWithoutUserInput;
  update: NotificationUpdateWithoutUserInput;
  where: NotificationWhereUniqueInput;
};

export type NotificationWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<NotificationWhereInput>>;
  config?: InputMaybe<NotificationConfigRelationFilter>;
  configId?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<NotificationWhereInput>>;
  OR?: InputMaybe<Array<NotificationWhereInput>>;
  payload?: InputMaybe<JsonNullableFilter>;
  scheduledTime?: InputMaybe<DateTimeNullableFilter>;
  scheduleKey?: InputMaybe<StringNullableFilter>;
  sentAt?: InputMaybe<DateTimeNullableFilter>;
  status?: InputMaybe<EnumNotificationStatusFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringNullableFilter>;
  transport?: InputMaybe<EnumNotificationTransportFilter>;
  type?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
};

export type NotificationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type NullableBoolFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['Boolean']>;
};

export type NullableDateTimeFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['DateTime']>;
};

export type NullableEnumAccessGrantStateFieldUpdateOperationsInput = {
  set?: InputMaybe<AccessGrantState>;
};

export type NullableEnumAssaCardTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<AssaCardType>;
};

export type NullableEnumChargingStateFieldUpdateOperationsInput = {
  set?: InputMaybe<ChargingState>;
};

export type NullableEnumCreditCardTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<CreditCardType>;
};

export type NullableEnumDispenserTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<DispenserType>;
};

export type NullableEnumInfoContentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<InfoContentType>;
};

export type NullableEnumKeycardOriginFieldUpdateOperationsInput = {
  set?: InputMaybe<KeycardOrigin>;
};

export type NullableEnumLoyaltyTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<LoyaltyType>;
};

export type NullableEnumOriginTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<OriginType>;
};

export type NullableEnumPaymentProviderTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentProviderType>;
};

export type NullableEnumPaymentTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentType>;
};

export type NullableEnumPaymentVerificationStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<PaymentVerificationStatus>;
};

export type NullableEnumPmsTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<PmsType>;
};

export type NullableEnumResourceControlTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<ResourceControlType>;
};

export type NullableEnumRetryCheckinStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<RetryCheckinStatus>;
};

export type NullableEnumRfidTagTypeFieldUpdateOperationsInput = {
  set?: InputMaybe<RfidTagType>;
};

export type NullableEnumServiceRequestStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ServiceRequestStatus>;
};

export type NullableEnumServiceStatusFieldUpdateOperationsInput = {
  set?: InputMaybe<ServiceStatus>;
};

export type NullableFloatFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Float']>;
  divide?: InputMaybe<Scalars['Float']>;
  increment?: InputMaybe<Scalars['Float']>;
  multiply?: InputMaybe<Scalars['Float']>;
  set?: InputMaybe<Scalars['Float']>;
};

export type NullableIntFieldUpdateOperationsInput = {
  decrement?: InputMaybe<Scalars['Int']>;
  divide?: InputMaybe<Scalars['Int']>;
  increment?: InputMaybe<Scalars['Int']>;
  multiply?: InputMaybe<Scalars['Int']>;
  set?: InputMaybe<Scalars['Int']>;
};

export type NullableStringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export enum NullsOrder {
  First = 'first',
  Last = 'last'
}

export type Option = {
  label?: Maybe<Scalars['String']>;
  value?: Maybe<Scalars['String']>;
};

export enum OriginType {
  Backend = 'BACKEND',
  Dashboard = 'DASHBOARD',
  IntegrationServer = 'INTEGRATION_SERVER',
  Kiosk = 'KIOSK',
  LogicServer = 'LOGIC_SERVER',
  MobileApp = 'MOBILE_APP',
  MobileSdk = 'MOBILE_SDK',
  MobileWeb = 'MOBILE_WEB',
  PassServer = 'PASS_SERVER',
  Scheduler = 'SCHEDULER',
  Unknown = 'UNKNOWN'
}

export type Override = {
  accessGrantId?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  endTime?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  resourceId: Scalars['String'];
  startTime?: Maybe<Scalars['String']>;
};

export type OverrideCreateManyAccessGrantInput = {
  code?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  resourceId: Scalars['String'];
  startTime?: InputMaybe<Scalars['String']>;
};

export type OverrideCreateManyAccessGrantInputEnvelope = {
  data: Array<OverrideCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type OverrideCreateManyResourceInput = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type OverrideCreateManyResourceInputEnvelope = {
  data: Array<OverrideCreateManyResourceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type OverrideCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OverrideCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<OverrideCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<OverrideCreateManyAccessGrantInputEnvelope>;
};

export type OverrideCreateNestedManyWithoutResourceInput = {
  connect?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OverrideCreateOrConnectWithoutResourceInput>>;
  create?: InputMaybe<Array<OverrideCreateWithoutResourceInput>>;
  createMany?: InputMaybe<OverrideCreateManyResourceInputEnvelope>;
};

export type OverrideCreateOrConnectWithoutAccessGrantInput = {
  create: OverrideCreateWithoutAccessGrantInput;
  where: OverrideWhereUniqueInput;
};

export type OverrideCreateOrConnectWithoutResourceInput = {
  create: OverrideCreateWithoutResourceInput;
  where: OverrideWhereUniqueInput;
};

export type OverrideCreateWithoutAccessGrantInput = {
  code?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  resource: ResourceCreateNestedOneWithoutOverrideInput;
  startTime?: InputMaybe<Scalars['String']>;
};

export type OverrideCreateWithoutResourceInput = {
  AccessGrant?: InputMaybe<AccessGrantCreateNestedOneWithoutOverridesInput>;
  code?: InputMaybe<Scalars['String']>;
  endTime?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
};

export type OverrideListRelationFilter = {
  every?: InputMaybe<OverrideWhereInput>;
  none?: InputMaybe<OverrideWhereInput>;
  some?: InputMaybe<OverrideWhereInput>;
};

export type OverrideOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type OverrideOrderByWithRelationInput = {
  AccessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrderInput>;
  code?: InputMaybe<SortOrderInput>;
  endTime?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  resource?: InputMaybe<ResourceOrderByWithRelationInput>;
  resourceId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrderInput>;
};

export enum OverrideScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  Code = 'code',
  EndTime = 'endTime',
  Id = 'id',
  ResourceId = 'resourceId',
  StartTime = 'startTime'
}

export type OverrideScalarWhereInput = {
  accessGrantId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<OverrideScalarWhereInput>>;
  code?: InputMaybe<StringNullableFilter>;
  endTime?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<OverrideScalarWhereInput>>;
  OR?: InputMaybe<Array<OverrideScalarWhereInput>>;
  resourceId?: InputMaybe<StringFilter>;
  startTime?: InputMaybe<StringNullableFilter>;
};

export type OverrideUpdateManyMutationInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OverrideUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OverrideCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<OverrideCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<OverrideCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OverrideScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  set?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  update?: InputMaybe<Array<OverrideUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<OverrideUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<OverrideUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type OverrideUpdateManyWithoutResourceNestedInput = {
  connect?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<OverrideCreateOrConnectWithoutResourceInput>>;
  create?: InputMaybe<Array<OverrideCreateWithoutResourceInput>>;
  createMany?: InputMaybe<OverrideCreateManyResourceInputEnvelope>;
  delete?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<OverrideScalarWhereInput>>;
  disconnect?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  set?: InputMaybe<Array<OverrideWhereUniqueInput>>;
  update?: InputMaybe<Array<OverrideUpdateWithWhereUniqueWithoutResourceInput>>;
  updateMany?: InputMaybe<Array<OverrideUpdateManyWithWhereWithoutResourceInput>>;
  upsert?: InputMaybe<Array<OverrideUpsertWithWhereUniqueWithoutResourceInput>>;
};

export type OverrideUpdateManyWithWhereWithoutAccessGrantInput = {
  data: OverrideUpdateManyMutationInput;
  where: OverrideScalarWhereInput;
};

export type OverrideUpdateManyWithWhereWithoutResourceInput = {
  data: OverrideUpdateManyMutationInput;
  where: OverrideScalarWhereInput;
};

export type OverrideUpdateWithoutAccessGrantInput = {
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  resource?: InputMaybe<ResourceUpdateOneRequiredWithoutOverrideNestedInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OverrideUpdateWithoutResourceInput = {
  AccessGrant?: InputMaybe<AccessGrantUpdateOneWithoutOverridesNestedInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  endTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type OverrideUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: OverrideUpdateWithoutAccessGrantInput;
  where: OverrideWhereUniqueInput;
};

export type OverrideUpdateWithWhereUniqueWithoutResourceInput = {
  data: OverrideUpdateWithoutResourceInput;
  where: OverrideWhereUniqueInput;
};

export type OverrideUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: OverrideCreateWithoutAccessGrantInput;
  update: OverrideUpdateWithoutAccessGrantInput;
  where: OverrideWhereUniqueInput;
};

export type OverrideUpsertWithWhereUniqueWithoutResourceInput = {
  create: OverrideCreateWithoutResourceInput;
  update: OverrideUpdateWithoutResourceInput;
  where: OverrideWhereUniqueInput;
};

export type OverrideWhereInput = {
  AccessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<OverrideWhereInput>>;
  code?: InputMaybe<StringNullableFilter>;
  endTime?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<OverrideWhereInput>>;
  OR?: InputMaybe<Array<OverrideWhereInput>>;
  resource?: InputMaybe<ResourceRelationFilter>;
  resourceId?: InputMaybe<StringFilter>;
  startTime?: InputMaybe<StringNullableFilter>;
};

export type OverrideWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Package = {
  _count?: Maybe<ServiceCount>;
  askForTime: Scalars['Boolean'];
  availableQuantity?: Maybe<Scalars['Float']>;
  categoryId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  displayCommentBox: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  isInventoryBased?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  largeDescription?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  serviceBenefits: Array<ServiceBenefit>;
  serviceCategory?: Maybe<ServiceCategory>;
  serviceRequests: Array<ServiceRequest>;
  serviceRules: Array<ServiceRule>;
  status?: Maybe<ServiceStatus>;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};


export type PackageServiceBenefitsArgs = {
  cursor?: InputMaybe<ServiceBenefitWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceBenefitScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceBenefitOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceBenefitWhereInput>;
};


export type PackageServiceRequestsArgs = {
  cursor?: InputMaybe<ServiceRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type PackageServiceRulesArgs = {
  cursor?: InputMaybe<ServiceRuleWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceRuleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceRuleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRuleWhereInput>;
};

export type Pass = {
  accessGrantId: Scalars['String'];
  authenticationToken: Scalars['String'];
  createdAt: Scalars['DateTime'];
  googleClassId?: Maybe<Scalars['String']>;
  googleObjectId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  passTypeId: Scalars['String'];
  serialNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PassCountAggregate = {
  _all: Scalars['Int'];
  accessGrantId: Scalars['Int'];
  authenticationToken: Scalars['Int'];
  createdAt: Scalars['Int'];
  googleClassId: Scalars['Int'];
  googleObjectId: Scalars['Int'];
  id: Scalars['Int'];
  passTypeId: Scalars['Int'];
  serialNumber: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PassCountOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  authenticationToken?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  googleClassId?: InputMaybe<SortOrder>;
  googleObjectId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  passTypeId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PassCreateInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutPassesInput;
  authenticationToken: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  googleClassId?: InputMaybe<Scalars['String']>;
  googleObjectId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  passTypeId: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PassCreateManyAccessGrantInput = {
  authenticationToken: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  googleClassId?: InputMaybe<Scalars['String']>;
  googleObjectId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  passTypeId: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PassCreateManyAccessGrantInputEnvelope = {
  data: Array<PassCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PassCreateManyInput = {
  accessGrantId: Scalars['String'];
  authenticationToken: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  googleClassId?: InputMaybe<Scalars['String']>;
  googleObjectId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  passTypeId: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PassCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<PassWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<PassCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<PassCreateManyAccessGrantInputEnvelope>;
};

export type PassCreateOrConnectWithoutAccessGrantInput = {
  create: PassCreateWithoutAccessGrantInput;
  where: PassWhereUniqueInput;
};

export type PassCreateWithoutAccessGrantInput = {
  authenticationToken: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  googleClassId?: InputMaybe<Scalars['String']>;
  googleObjectId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  passTypeId: Scalars['String'];
  serialNumber?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PassGroupBy = {
  _count?: Maybe<PassCountAggregate>;
  _max?: Maybe<PassMaxAggregate>;
  _min?: Maybe<PassMinAggregate>;
  accessGrantId: Scalars['String'];
  authenticationToken: Scalars['String'];
  createdAt: Scalars['DateTime'];
  googleClassId?: Maybe<Scalars['String']>;
  googleObjectId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  passTypeId: Scalars['String'];
  serialNumber: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type PassListRelationFilter = {
  every?: InputMaybe<PassWhereInput>;
  none?: InputMaybe<PassWhereInput>;
  some?: InputMaybe<PassWhereInput>;
};

export type PassMaxAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  authenticationToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  googleClassId?: Maybe<Scalars['String']>;
  googleObjectId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  passTypeId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PassMaxOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  authenticationToken?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  googleClassId?: InputMaybe<SortOrder>;
  googleObjectId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  passTypeId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PassMinAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  authenticationToken?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  googleClassId?: Maybe<Scalars['String']>;
  googleObjectId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  passTypeId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PassMinOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  authenticationToken?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  googleClassId?: InputMaybe<SortOrder>;
  googleObjectId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  passTypeId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PassOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PassOrderByWithAggregationInput = {
  _count?: InputMaybe<PassCountOrderByAggregateInput>;
  _max?: InputMaybe<PassMaxOrderByAggregateInput>;
  _min?: InputMaybe<PassMinOrderByAggregateInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  authenticationToken?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  googleClassId?: InputMaybe<SortOrderInput>;
  googleObjectId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  passTypeId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PassOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  authenticationToken?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  googleClassId?: InputMaybe<SortOrderInput>;
  googleObjectId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  passTypeId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PassScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  AuthenticationToken = 'authenticationToken',
  CreatedAt = 'createdAt',
  GoogleClassId = 'googleClassId',
  GoogleObjectId = 'googleObjectId',
  Id = 'id',
  PassTypeId = 'passTypeId',
  SerialNumber = 'serialNumber',
  UpdatedAt = 'updatedAt'
}

export type PassScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<PassScalarWhereInput>>;
  authenticationToken?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  googleClassId?: InputMaybe<StringNullableFilter>;
  googleObjectId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<PassScalarWhereInput>>;
  OR?: InputMaybe<Array<PassScalarWhereInput>>;
  passTypeId?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PassScalarWhereWithAggregatesInput = {
  accessGrantId?: InputMaybe<StringWithAggregatesFilter>;
  AND?: InputMaybe<Array<PassScalarWhereWithAggregatesInput>>;
  authenticationToken?: InputMaybe<StringWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  googleClassId?: InputMaybe<StringNullableWithAggregatesFilter>;
  googleObjectId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<PassScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PassScalarWhereWithAggregatesInput>>;
  passTypeId?: InputMaybe<StringWithAggregatesFilter>;
  serialNumber?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type PassUpdateInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutPassesNestedInput>;
  authenticationToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  googleClassId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleObjectId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  passTypeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PassUpdateManyMutationInput = {
  authenticationToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  googleClassId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleObjectId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  passTypeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PassUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<PassWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PassCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<PassCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<PassCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<PassWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PassScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PassWhereUniqueInput>>;
  set?: InputMaybe<Array<PassWhereUniqueInput>>;
  update?: InputMaybe<Array<PassUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<PassUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<PassUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type PassUpdateManyWithWhereWithoutAccessGrantInput = {
  data: PassUpdateManyMutationInput;
  where: PassScalarWhereInput;
};

export type PassUpdateWithoutAccessGrantInput = {
  authenticationToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  googleClassId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  googleObjectId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  passTypeId?: InputMaybe<StringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PassUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: PassUpdateWithoutAccessGrantInput;
  where: PassWhereUniqueInput;
};

export type PassUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: PassCreateWithoutAccessGrantInput;
  update: PassUpdateWithoutAccessGrantInput;
  where: PassWhereUniqueInput;
};

export type PassWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<PassWhereInput>>;
  authenticationToken?: InputMaybe<StringFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  googleClassId?: InputMaybe<StringNullableFilter>;
  googleObjectId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<PassWhereInput>>;
  OR?: InputMaybe<Array<PassWhereInput>>;
  passTypeId?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PassWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type Payment = {
  _count?: Maybe<PaymentCount>;
  cardType?: Maybe<CreditCardType>;
  createdAt: Scalars['DateTime'];
  customerId: Scalars['String'];
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastFour?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  nameOnCard?: Maybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenantId: Scalars['String'];
  token: Scalars['String'];
  type?: Maybe<PaymentType>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<PaymentVerificationStatus>;
};

export enum PaymentAccountEntity {
  Default = 'DEFAULT',
  Kiosk = 'KIOSK',
  MobileApp = 'MOBILE_APP',
  MobileSdk = 'MOBILE_SDK',
  MobileWeb = 'MOBILE_WEB'
}

export type PaymentAuthorization = {
  invoiceNumber: Scalars['String'];
};

export type PaymentCount = {
  UserTenantData: Scalars['Int'];
};


export type PaymentCountUserTenantDataArgs = {
  where?: InputMaybe<UserTenantDataWhereInput>;
};

export type PaymentCountAggregate = {
  _all: Scalars['Int'];
  cardType: Scalars['Int'];
  createdAt: Scalars['Int'];
  customerId: Scalars['Int'];
  expMonth: Scalars['Int'];
  expYear: Scalars['Int'];
  id: Scalars['Int'];
  lastFour: Scalars['Int'];
  locationId: Scalars['Int'];
  nameOnCard: Scalars['Int'];
  providerType: Scalars['Int'];
  tenantId: Scalars['Int'];
  token: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
  userId: Scalars['Int'];
  verificationStatus: Scalars['Int'];
};

export type PaymentCountOrderByAggregateInput = {
  cardType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  expMonth?: InputMaybe<SortOrder>;
  expYear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastFour?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  nameOnCard?: InputMaybe<SortOrder>;
  providerType?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
};

export type PaymentCreateInput = {
  cardType?: InputMaybe<CreditCardType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutPaymentsInput>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenant: TenantCreateNestedOneWithoutPaymentInput;
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPaymentsInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutPaymentDataInput>;
  verificationStatus?: InputMaybe<PaymentVerificationStatus>;
};

export type PaymentCreateManyInput = {
  cardType?: InputMaybe<CreditCardType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenantId: Scalars['String'];
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
  verificationStatus?: InputMaybe<PaymentVerificationStatus>;
};

export type PaymentCreateManyLocationInput = {
  cardType?: InputMaybe<CreditCardType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenantId: Scalars['String'];
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
  verificationStatus?: InputMaybe<PaymentVerificationStatus>;
};

export type PaymentCreateManyLocationInputEnvelope = {
  data: Array<PaymentCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PaymentCreateManyTenantInput = {
  cardType?: InputMaybe<CreditCardType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
  verificationStatus?: InputMaybe<PaymentVerificationStatus>;
};

export type PaymentCreateManyTenantInputEnvelope = {
  data: Array<PaymentCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PaymentCreateManyUserInput = {
  cardType?: InputMaybe<CreditCardType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenantId: Scalars['String'];
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  verificationStatus?: InputMaybe<PaymentVerificationStatus>;
};

export type PaymentCreateManyUserInputEnvelope = {
  data: Array<PaymentCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PaymentCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutLocationInput>>;
  createMany?: InputMaybe<PaymentCreateManyLocationInputEnvelope>;
};

export type PaymentCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutTenantInput>>;
  createMany?: InputMaybe<PaymentCreateManyTenantInputEnvelope>;
};

export type PaymentCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutUserInput>>;
  createMany?: InputMaybe<PaymentCreateManyUserInputEnvelope>;
};

export type PaymentCreateNestedOneWithoutUserTenantDataInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutUserTenantDataInput>;
  create?: InputMaybe<PaymentCreateWithoutUserTenantDataInput>;
};

export type PaymentCreateOrConnectWithoutLocationInput = {
  create: PaymentCreateWithoutLocationInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutTenantInput = {
  create: PaymentCreateWithoutTenantInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutUserInput = {
  create: PaymentCreateWithoutUserInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateOrConnectWithoutUserTenantDataInput = {
  create: PaymentCreateWithoutUserTenantDataInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentCreateWithoutLocationInput = {
  cardType?: InputMaybe<CreditCardType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenant: TenantCreateNestedOneWithoutPaymentInput;
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPaymentsInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutPaymentDataInput>;
  verificationStatus?: InputMaybe<PaymentVerificationStatus>;
};

export type PaymentCreateWithoutTenantInput = {
  cardType?: InputMaybe<CreditCardType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutPaymentsInput>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPaymentsInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutPaymentDataInput>;
  verificationStatus?: InputMaybe<PaymentVerificationStatus>;
};

export type PaymentCreateWithoutUserInput = {
  cardType?: InputMaybe<CreditCardType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutPaymentsInput>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenant: TenantCreateNestedOneWithoutPaymentInput;
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutPaymentDataInput>;
  verificationStatus?: InputMaybe<PaymentVerificationStatus>;
};

export type PaymentCreateWithoutUserTenantDataInput = {
  cardType?: InputMaybe<CreditCardType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  customerId: Scalars['String'];
  expMonth?: InputMaybe<Scalars['String']>;
  expYear?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastFour?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutPaymentsInput>;
  nameOnCard?: InputMaybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenant: TenantCreateNestedOneWithoutPaymentInput;
  token: Scalars['String'];
  type?: InputMaybe<PaymentType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutPaymentsInput>;
  verificationStatus?: InputMaybe<PaymentVerificationStatus>;
};

export type PaymentGroupBy = {
  _count?: Maybe<PaymentCountAggregate>;
  _max?: Maybe<PaymentMaxAggregate>;
  _min?: Maybe<PaymentMinAggregate>;
  cardType?: Maybe<CreditCardType>;
  createdAt: Scalars['DateTime'];
  customerId: Scalars['String'];
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  lastFour?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  nameOnCard?: Maybe<Scalars['String']>;
  providerType: PaymentProviderType;
  tenantId: Scalars['String'];
  token: Scalars['String'];
  type?: Maybe<PaymentType>;
  updatedAt: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<PaymentVerificationStatus>;
};

export type PaymentListRelationFilter = {
  every?: InputMaybe<PaymentWhereInput>;
  none?: InputMaybe<PaymentWhereInput>;
  some?: InputMaybe<PaymentWhereInput>;
};

export type PaymentMaxAggregate = {
  cardType?: Maybe<CreditCardType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  nameOnCard?: Maybe<Scalars['String']>;
  providerType?: Maybe<PaymentProviderType>;
  tenantId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<PaymentType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<PaymentVerificationStatus>;
};

export type PaymentMaxOrderByAggregateInput = {
  cardType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  expMonth?: InputMaybe<SortOrder>;
  expYear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastFour?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  nameOnCard?: InputMaybe<SortOrder>;
  providerType?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
};

export type PaymentMethod = {
  brand: Scalars['String'];
  lastFour: Scalars['String'];
};

export type PaymentMinAggregate = {
  cardType?: Maybe<CreditCardType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  customerId?: Maybe<Scalars['String']>;
  expMonth?: Maybe<Scalars['String']>;
  expYear?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastFour?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  nameOnCard?: Maybe<Scalars['String']>;
  providerType?: Maybe<PaymentProviderType>;
  tenantId?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
  type?: Maybe<PaymentType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<PaymentVerificationStatus>;
};

export type PaymentMinOrderByAggregateInput = {
  cardType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  expMonth?: InputMaybe<SortOrder>;
  expYear?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  lastFour?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  nameOnCard?: InputMaybe<SortOrder>;
  providerType?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
};

export type PaymentOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentOrderByWithAggregationInput = {
  _count?: InputMaybe<PaymentCountOrderByAggregateInput>;
  _max?: InputMaybe<PaymentMaxOrderByAggregateInput>;
  _min?: InputMaybe<PaymentMinOrderByAggregateInput>;
  cardType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  expMonth?: InputMaybe<SortOrderInput>;
  expYear?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastFour?: InputMaybe<SortOrderInput>;
  locationId?: InputMaybe<SortOrderInput>;
  nameOnCard?: InputMaybe<SortOrderInput>;
  providerType?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrderInput>;
  verificationStatus?: InputMaybe<SortOrderInput>;
};

export type PaymentOrderByWithRelationInput = {
  cardType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  customerId?: InputMaybe<SortOrder>;
  expMonth?: InputMaybe<SortOrderInput>;
  expYear?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  lastFour?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  nameOnCard?: InputMaybe<SortOrderInput>;
  providerType?: InputMaybe<SortOrder>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  token?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
  UserTenantData?: InputMaybe<UserTenantDataOrderByRelationAggregateInput>;
  verificationStatus?: InputMaybe<SortOrderInput>;
};

export type PaymentProvider = {
  _count?: Maybe<PaymentProviderCount>;
  accountId: Scalars['String'];
  accountToken?: Maybe<Scalars['String']>;
  config?: Maybe<Scalars['JSON']>;
  id: Scalars['String'];
  locationId?: Maybe<Scalars['String']>;
  type: PaymentProviderType;
};

export type PaymentProviderCount = {
  tenant: Scalars['Int'];
};


export type PaymentProviderCountTenantArgs = {
  where?: InputMaybe<TenantWhereInput>;
};

export type PaymentProviderCreateNestedOneWithoutLocationInput = {
  connect?: InputMaybe<PaymentProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentProviderCreateOrConnectWithoutLocationInput>;
  create?: InputMaybe<PaymentProviderCreateWithoutLocationInput>;
};

export type PaymentProviderCreateNestedOneWithoutTenantInput = {
  connect?: InputMaybe<PaymentProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentProviderCreateOrConnectWithoutTenantInput>;
  create?: InputMaybe<PaymentProviderCreateWithoutTenantInput>;
};

export type PaymentProviderCreateOrConnectWithoutLocationInput = {
  create: PaymentProviderCreateWithoutLocationInput;
  where: PaymentProviderWhereUniqueInput;
};

export type PaymentProviderCreateOrConnectWithoutTenantInput = {
  create: PaymentProviderCreateWithoutTenantInput;
  where: PaymentProviderWhereUniqueInput;
};

export type PaymentProviderCreateWithoutLocationInput = {
  accountId: Scalars['String'];
  accountToken?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  tenant?: InputMaybe<TenantCreateNestedManyWithoutPaymentProviderInput>;
  type: PaymentProviderType;
};

export type PaymentProviderCreateWithoutTenantInput = {
  accountId: Scalars['String'];
  accountToken?: InputMaybe<Scalars['String']>;
  config?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutPaymentProviderInput>;
  type: PaymentProviderType;
};

export type PaymentProviderOrderByWithRelationInput = {
  accountId?: InputMaybe<SortOrder>;
  accountToken?: InputMaybe<SortOrderInput>;
  config?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  tenant?: InputMaybe<TenantOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
};

export type PaymentProviderRelationFilter = {
  is?: InputMaybe<PaymentProviderWhereInput>;
  isNot?: InputMaybe<PaymentProviderWhereInput>;
};

export enum PaymentProviderType {
  Concardis = 'CONCARDIS',
  Elavon = 'ELAVON',
  Freedompay = 'FREEDOMPAY',
  PciProxy = 'PCI_PROXY',
  Shift4 = 'SHIFT4',
  Square = 'SQUARE',
  Stripe = 'STRIPE'
}

export type PaymentProviderUpdateOneWithoutLocationNestedInput = {
  connect?: InputMaybe<PaymentProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentProviderCreateOrConnectWithoutLocationInput>;
  create?: InputMaybe<PaymentProviderCreateWithoutLocationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PaymentProviderUpdateWithoutLocationInput>;
  upsert?: InputMaybe<PaymentProviderUpsertWithoutLocationInput>;
};

export type PaymentProviderUpdateOneWithoutTenantNestedInput = {
  connect?: InputMaybe<PaymentProviderWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentProviderCreateOrConnectWithoutTenantInput>;
  create?: InputMaybe<PaymentProviderCreateWithoutTenantInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PaymentProviderUpdateWithoutTenantInput>;
  upsert?: InputMaybe<PaymentProviderUpsertWithoutTenantInput>;
};

export type PaymentProviderUpdateWithoutLocationInput = {
  accountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  accountToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  config?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateManyWithoutPaymentProviderNestedInput>;
  type?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
};

export type PaymentProviderUpdateWithoutTenantInput = {
  accountId?: InputMaybe<StringFieldUpdateOperationsInput>;
  accountToken?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  config?: InputMaybe<Scalars['JSON']>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutPaymentProviderNestedInput>;
  type?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
};

export type PaymentProviderUpsertWithoutLocationInput = {
  create: PaymentProviderCreateWithoutLocationInput;
  update: PaymentProviderUpdateWithoutLocationInput;
};

export type PaymentProviderUpsertWithoutTenantInput = {
  create: PaymentProviderCreateWithoutTenantInput;
  update: PaymentProviderUpdateWithoutTenantInput;
};

export type PaymentProviderWhereInput = {
  accountId?: InputMaybe<StringFilter>;
  accountToken?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<PaymentProviderWhereInput>>;
  config?: InputMaybe<JsonNullableFilter>;
  id?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<PaymentProviderWhereInput>>;
  OR?: InputMaybe<Array<PaymentProviderWhereInput>>;
  tenant?: InputMaybe<TenantListRelationFilter>;
  type?: InputMaybe<EnumPaymentProviderTypeFilter>;
};

export type PaymentProviderWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
};

export type PaymentRelationFilter = {
  is?: InputMaybe<PaymentWhereInput>;
  isNot?: InputMaybe<PaymentWhereInput>;
};

export enum PaymentScalarFieldEnum {
  CardType = 'cardType',
  CreatedAt = 'createdAt',
  CustomerId = 'customerId',
  ExpMonth = 'expMonth',
  ExpYear = 'expYear',
  Id = 'id',
  LastFour = 'lastFour',
  LocationId = 'locationId',
  NameOnCard = 'nameOnCard',
  ProviderType = 'providerType',
  TenantId = 'tenantId',
  Token = 'token',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId',
  VerificationStatus = 'verificationStatus'
}

export type PaymentScalarWhereInput = {
  AND?: InputMaybe<Array<PaymentScalarWhereInput>>;
  cardType?: InputMaybe<EnumCreditCardTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  expMonth?: InputMaybe<StringNullableFilter>;
  expYear?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastFour?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  nameOnCard?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<PaymentScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentScalarWhereInput>>;
  providerType?: InputMaybe<EnumPaymentProviderTypeFilter>;
  tenantId?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPaymentTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  verificationStatus?: InputMaybe<EnumPaymentVerificationStatusNullableFilter>;
};

export type PaymentScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<PaymentScalarWhereWithAggregatesInput>>;
  cardType?: InputMaybe<EnumCreditCardTypeNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  customerId?: InputMaybe<StringWithAggregatesFilter>;
  expMonth?: InputMaybe<StringNullableWithAggregatesFilter>;
  expYear?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  lastFour?: InputMaybe<StringNullableWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  nameOnCard?: InputMaybe<StringNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<PaymentScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PaymentScalarWhereWithAggregatesInput>>;
  providerType?: InputMaybe<EnumPaymentProviderTypeWithAggregatesFilter>;
  tenantId?: InputMaybe<StringWithAggregatesFilter>;
  token?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumPaymentTypeNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<StringNullableWithAggregatesFilter>;
  verificationStatus?: InputMaybe<EnumPaymentVerificationStatusNullableWithAggregatesFilter>;
};

export type PaymentTransaction = {
  accessGrantId: Scalars['String'];
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  invoiceNumber: Scalars['String'];
  paymentProviderType?: Maybe<PaymentProviderType>;
  status: PaymentTransactionStatus;
  updatedAt: Scalars['DateTime'];
};

export type PaymentTransactionAvgAggregate = {
  amount?: Maybe<Scalars['Float']>;
};

export type PaymentTransactionAvgOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
};

export type PaymentTransactionCountAggregate = {
  _all: Scalars['Int'];
  accessGrantId: Scalars['Int'];
  amount: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  invoiceNumber: Scalars['Int'];
  paymentProviderType: Scalars['Int'];
  status: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type PaymentTransactionCountOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  paymentProviderType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentTransactionCreateInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutPaymentTransactionsInput;
  amount: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  paymentProviderType?: InputMaybe<PaymentProviderType>;
  status: PaymentTransactionStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PaymentTransactionCreateManyAccessGrantInput = {
  amount: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  paymentProviderType?: InputMaybe<PaymentProviderType>;
  status: PaymentTransactionStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PaymentTransactionCreateManyAccessGrantInputEnvelope = {
  data: Array<PaymentTransactionCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PaymentTransactionCreateManyInput = {
  accessGrantId: Scalars['String'];
  amount: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  paymentProviderType?: InputMaybe<PaymentProviderType>;
  status: PaymentTransactionStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PaymentTransactionCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentTransactionCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<PaymentTransactionCreateManyAccessGrantInputEnvelope>;
};

export type PaymentTransactionCreateOrConnectWithoutAccessGrantInput = {
  create: PaymentTransactionCreateWithoutAccessGrantInput;
  where: PaymentTransactionWhereUniqueInput;
};

export type PaymentTransactionCreateWithoutAccessGrantInput = {
  amount: Scalars['Float'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  paymentProviderType?: InputMaybe<PaymentProviderType>;
  status: PaymentTransactionStatus;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type PaymentTransactionGroupBy = {
  _avg?: Maybe<PaymentTransactionAvgAggregate>;
  _count?: Maybe<PaymentTransactionCountAggregate>;
  _max?: Maybe<PaymentTransactionMaxAggregate>;
  _min?: Maybe<PaymentTransactionMinAggregate>;
  _sum?: Maybe<PaymentTransactionSumAggregate>;
  accessGrantId: Scalars['String'];
  amount: Scalars['Float'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  invoiceNumber: Scalars['String'];
  paymentProviderType?: Maybe<PaymentProviderType>;
  status: PaymentTransactionStatus;
  updatedAt: Scalars['DateTime'];
};

export type PaymentTransactionListRelationFilter = {
  every?: InputMaybe<PaymentTransactionWhereInput>;
  none?: InputMaybe<PaymentTransactionWhereInput>;
  some?: InputMaybe<PaymentTransactionWhereInput>;
};

export type PaymentTransactionMaxAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  paymentProviderType?: Maybe<PaymentProviderType>;
  status?: Maybe<PaymentTransactionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PaymentTransactionMaxOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  paymentProviderType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentTransactionMinAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  amount?: Maybe<Scalars['Float']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  paymentProviderType?: Maybe<PaymentProviderType>;
  status?: Maybe<PaymentTransactionStatus>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type PaymentTransactionMinOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  paymentProviderType?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentTransactionOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PaymentTransactionOrderByWithAggregationInput = {
  _avg?: InputMaybe<PaymentTransactionAvgOrderByAggregateInput>;
  _count?: InputMaybe<PaymentTransactionCountOrderByAggregateInput>;
  _max?: InputMaybe<PaymentTransactionMaxOrderByAggregateInput>;
  _min?: InputMaybe<PaymentTransactionMinOrderByAggregateInput>;
  _sum?: InputMaybe<PaymentTransactionSumOrderByAggregateInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  paymentProviderType?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type PaymentTransactionOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  amount?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  invoiceNumber?: InputMaybe<SortOrder>;
  paymentProviderType?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum PaymentTransactionScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  Amount = 'amount',
  CreatedAt = 'createdAt',
  Id = 'id',
  InvoiceNumber = 'invoiceNumber',
  PaymentProviderType = 'paymentProviderType',
  Status = 'status',
  UpdatedAt = 'updatedAt'
}

export type PaymentTransactionScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  amount?: InputMaybe<FloatFilter>;
  AND?: InputMaybe<Array<PaymentTransactionScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  invoiceNumber?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<PaymentTransactionScalarWhereInput>>;
  OR?: InputMaybe<Array<PaymentTransactionScalarWhereInput>>;
  paymentProviderType?: InputMaybe<EnumPaymentProviderTypeNullableFilter>;
  status?: InputMaybe<EnumPaymentTransactionStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentTransactionScalarWhereWithAggregatesInput = {
  accessGrantId?: InputMaybe<StringWithAggregatesFilter>;
  amount?: InputMaybe<FloatWithAggregatesFilter>;
  AND?: InputMaybe<Array<PaymentTransactionScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  invoiceNumber?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<PaymentTransactionScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<PaymentTransactionScalarWhereWithAggregatesInput>>;
  paymentProviderType?: InputMaybe<EnumPaymentProviderTypeNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumPaymentTransactionStatusWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum PaymentTransactionStatus {
  Authorized = 'AUTHORIZED',
  Captured = 'CAPTURED',
  Failed = 'FAILED',
  Pending = 'PENDING'
}

export type PaymentTransactionSumAggregate = {
  amount?: Maybe<Scalars['Float']>;
};

export type PaymentTransactionSumOrderByAggregateInput = {
  amount?: InputMaybe<SortOrder>;
};

export type PaymentTransactionUpdateInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutPaymentTransactionsNestedInput>;
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentProviderType?: InputMaybe<NullableEnumPaymentProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentTransactionStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentTransactionUpdateManyMutationInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentProviderType?: InputMaybe<NullableEnumPaymentProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentTransactionStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentTransactionUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<PaymentTransactionWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentTransactionCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<PaymentTransactionCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<PaymentTransactionCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<PaymentTransactionWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentTransactionScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentTransactionWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentTransactionWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentTransactionUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<PaymentTransactionUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<PaymentTransactionUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type PaymentTransactionUpdateManyWithWhereWithoutAccessGrantInput = {
  data: PaymentTransactionUpdateManyMutationInput;
  where: PaymentTransactionScalarWhereInput;
};

export type PaymentTransactionUpdateWithoutAccessGrantInput = {
  amount?: InputMaybe<FloatFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  invoiceNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentProviderType?: InputMaybe<NullableEnumPaymentProviderTypeFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumPaymentTransactionStatusFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type PaymentTransactionUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: PaymentTransactionUpdateWithoutAccessGrantInput;
  where: PaymentTransactionWhereUniqueInput;
};

export type PaymentTransactionUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: PaymentTransactionCreateWithoutAccessGrantInput;
  update: PaymentTransactionUpdateWithoutAccessGrantInput;
  where: PaymentTransactionWhereUniqueInput;
};

export type PaymentTransactionWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  amount?: InputMaybe<FloatFilter>;
  AND?: InputMaybe<Array<PaymentTransactionWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  invoiceNumber?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<PaymentTransactionWhereInput>>;
  OR?: InputMaybe<Array<PaymentTransactionWhereInput>>;
  paymentProviderType?: InputMaybe<EnumPaymentProviderTypeNullableFilter>;
  status?: InputMaybe<EnumPaymentTransactionStatusFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type PaymentTransactionWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum PaymentType {
  BankAccount = 'BANK_ACCOUNT',
  CreditCard = 'CREDIT_CARD'
}

export type PaymentUpdateInput = {
  cardType?: InputMaybe<NullableEnumCreditCardTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  expMonth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastFour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutPaymentsNestedInput>;
  nameOnCard?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerType?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutPaymentNestedInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPaymentsNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutPaymentDataNestedInput>;
  verificationStatus?: InputMaybe<NullableEnumPaymentVerificationStatusFieldUpdateOperationsInput>;
};

export type PaymentUpdateManyMutationInput = {
  cardType?: InputMaybe<NullableEnumCreditCardTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  expMonth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastFour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCard?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerType?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableEnumPaymentVerificationStatusFieldUpdateOperationsInput>;
};

export type PaymentUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutLocationInput>>;
  createMany?: InputMaybe<PaymentCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type PaymentUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutTenantInput>>;
  createMany?: InputMaybe<PaymentCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type PaymentUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PaymentCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<PaymentCreateWithoutUserInput>>;
  createMany?: InputMaybe<PaymentCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PaymentScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  set?: InputMaybe<Array<PaymentWhereUniqueInput>>;
  update?: InputMaybe<Array<PaymentUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<PaymentUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<PaymentUpsertWithWhereUniqueWithoutUserInput>>;
};

export type PaymentUpdateManyWithWhereWithoutLocationInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithWhereWithoutTenantInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateManyWithWhereWithoutUserInput = {
  data: PaymentUpdateManyMutationInput;
  where: PaymentScalarWhereInput;
};

export type PaymentUpdateOneWithoutUserTenantDataNestedInput = {
  connect?: InputMaybe<PaymentWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PaymentCreateOrConnectWithoutUserTenantDataInput>;
  create?: InputMaybe<PaymentCreateWithoutUserTenantDataInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PaymentUpdateWithoutUserTenantDataInput>;
  upsert?: InputMaybe<PaymentUpsertWithoutUserTenantDataInput>;
};

export type PaymentUpdateWithoutLocationInput = {
  cardType?: InputMaybe<NullableEnumCreditCardTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  expMonth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastFour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  nameOnCard?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerType?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutPaymentNestedInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPaymentsNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutPaymentDataNestedInput>;
  verificationStatus?: InputMaybe<NullableEnumPaymentVerificationStatusFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutTenantInput = {
  cardType?: InputMaybe<NullableEnumCreditCardTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  expMonth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastFour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutPaymentsNestedInput>;
  nameOnCard?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerType?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPaymentsNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutPaymentDataNestedInput>;
  verificationStatus?: InputMaybe<NullableEnumPaymentVerificationStatusFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutUserInput = {
  cardType?: InputMaybe<NullableEnumCreditCardTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  expMonth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastFour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutPaymentsNestedInput>;
  nameOnCard?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerType?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutPaymentNestedInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutPaymentDataNestedInput>;
  verificationStatus?: InputMaybe<NullableEnumPaymentVerificationStatusFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithoutUserTenantDataInput = {
  cardType?: InputMaybe<NullableEnumCreditCardTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  customerId?: InputMaybe<StringFieldUpdateOperationsInput>;
  expMonth?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  expYear?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastFour?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutPaymentsNestedInput>;
  nameOnCard?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  providerType?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutPaymentNestedInput>;
  token?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<NullableEnumPaymentTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutPaymentsNestedInput>;
  verificationStatus?: InputMaybe<NullableEnumPaymentVerificationStatusFieldUpdateOperationsInput>;
};

export type PaymentUpdateWithWhereUniqueWithoutLocationInput = {
  data: PaymentUpdateWithoutLocationInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithWhereUniqueWithoutTenantInput = {
  data: PaymentUpdateWithoutTenantInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpdateWithWhereUniqueWithoutUserInput = {
  data: PaymentUpdateWithoutUserInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithoutUserTenantDataInput = {
  create: PaymentCreateWithoutUserTenantDataInput;
  update: PaymentUpdateWithoutUserTenantDataInput;
};

export type PaymentUpsertWithWhereUniqueWithoutLocationInput = {
  create: PaymentCreateWithoutLocationInput;
  update: PaymentUpdateWithoutLocationInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithWhereUniqueWithoutTenantInput = {
  create: PaymentCreateWithoutTenantInput;
  update: PaymentUpdateWithoutTenantInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUpsertWithWhereUniqueWithoutUserInput = {
  create: PaymentCreateWithoutUserInput;
  update: PaymentUpdateWithoutUserInput;
  where: PaymentWhereUniqueInput;
};

export type PaymentUserIdTenantIdCompoundUniqueInput = {
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};

export enum PaymentVerificationStatus {
  Approved = 'APPROVED',
  Rejected = 'REJECTED'
}

export type PaymentWhereInput = {
  AND?: InputMaybe<Array<PaymentWhereInput>>;
  cardType?: InputMaybe<EnumCreditCardTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  customerId?: InputMaybe<StringFilter>;
  expMonth?: InputMaybe<StringNullableFilter>;
  expYear?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastFour?: InputMaybe<StringNullableFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  nameOnCard?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<PaymentWhereInput>>;
  OR?: InputMaybe<Array<PaymentWhereInput>>;
  providerType?: InputMaybe<EnumPaymentProviderTypeFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  token?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPaymentTypeNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  UserTenantData?: InputMaybe<UserTenantDataListRelationFilter>;
  verificationStatus?: InputMaybe<EnumPaymentVerificationStatusNullableFilter>;
};

export type PaymentWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  userId_tenantId?: InputMaybe<PaymentUserIdTenantIdCompoundUniqueInput>;
};

export type Pms = {
  _count?: Maybe<PmsCount>;
  id: Scalars['String'];
  paymentEndpoint?: Maybe<Scalars['String']>;
  paymentEndpointPassword?: Maybe<Scalars['String']>;
  paymentEndpointUser?: Maybe<Scalars['String']>;
  paymentProviderType: PaymentProviderType;
  tenantId: Scalars['String'];
  type: PmsType;
};

export type PmsApiTransactionAnswer = {
  amount: Scalars['Float'];
  currency: Scalars['String'];
  date: Scalars['String'];
  description: Scalars['String'];
};

export type PmsCount = {
  locations: Scalars['Int'];
};


export type PmsCountLocationsArgs = {
  where?: InputMaybe<LocationWhereInput>;
};

export type PmsCreateManyTenantInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentEndpoint?: InputMaybe<Scalars['String']>;
  paymentEndpointPassword?: InputMaybe<Scalars['String']>;
  paymentEndpointUser?: InputMaybe<Scalars['String']>;
  paymentProviderType: PaymentProviderType;
  type: PmsType;
};

export type PmsCreateManyTenantInputEnvelope = {
  data: Array<PmsCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type PmsCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<PmsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PmsCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<PmsCreateWithoutTenantInput>>;
  createMany?: InputMaybe<PmsCreateManyTenantInputEnvelope>;
};

export type PmsCreateNestedOneWithoutLocationsInput = {
  connect?: InputMaybe<PmsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PmsCreateOrConnectWithoutLocationsInput>;
  create?: InputMaybe<PmsCreateWithoutLocationsInput>;
};

export type PmsCreateOrConnectWithoutLocationsInput = {
  create: PmsCreateWithoutLocationsInput;
  where: PmsWhereUniqueInput;
};

export type PmsCreateOrConnectWithoutTenantInput = {
  create: PmsCreateWithoutTenantInput;
  where: PmsWhereUniqueInput;
};

export type PmsCreateWithoutLocationsInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentEndpoint?: InputMaybe<Scalars['String']>;
  paymentEndpointPassword?: InputMaybe<Scalars['String']>;
  paymentEndpointUser?: InputMaybe<Scalars['String']>;
  paymentProviderType: PaymentProviderType;
  tenant: TenantCreateNestedOneWithoutPmsInput;
  type: PmsType;
};

export type PmsCreateWithoutTenantInput = {
  id?: InputMaybe<Scalars['String']>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutPmsInput>;
  paymentEndpoint?: InputMaybe<Scalars['String']>;
  paymentEndpointPassword?: InputMaybe<Scalars['String']>;
  paymentEndpointUser?: InputMaybe<Scalars['String']>;
  paymentProviderType: PaymentProviderType;
  type: PmsType;
};

export type PmsListRelationFilter = {
  every?: InputMaybe<PmsWhereInput>;
  none?: InputMaybe<PmsWhereInput>;
  some?: InputMaybe<PmsWhereInput>;
};

export type PmsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type PmsOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  paymentEndpoint?: InputMaybe<SortOrderInput>;
  paymentEndpointPassword?: InputMaybe<SortOrderInput>;
  paymentEndpointUser?: InputMaybe<SortOrderInput>;
  paymentProviderType?: InputMaybe<SortOrder>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type PmsRelationFilter = {
  is?: InputMaybe<PmsWhereInput>;
  isNot?: InputMaybe<PmsWhereInput>;
};

export enum PmsScalarFieldEnum {
  Id = 'id',
  PaymentEndpoint = 'paymentEndpoint',
  PaymentEndpointPassword = 'paymentEndpointPassword',
  PaymentEndpointUser = 'paymentEndpointUser',
  PaymentProviderType = 'paymentProviderType',
  TenantId = 'tenantId',
  Type = 'type'
}

export type PmsScalarWhereInput = {
  AND?: InputMaybe<Array<PmsScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<PmsScalarWhereInput>>;
  OR?: InputMaybe<Array<PmsScalarWhereInput>>;
  paymentEndpoint?: InputMaybe<StringNullableFilter>;
  paymentEndpointPassword?: InputMaybe<StringNullableFilter>;
  paymentEndpointUser?: InputMaybe<StringNullableFilter>;
  paymentProviderType?: InputMaybe<EnumPaymentProviderTypeFilter>;
  tenantId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPmsTypeFilter>;
};

export enum PmsType {
  Agilysys = 'AGILYSYS',
  Cloudbeds = 'CLOUDBEDS',
  HotelKey = 'HOTEL_KEY',
  Infor = 'INFOR',
  Lms = 'LMS',
  Mews = 'MEWS',
  Opera = 'OPERA',
  OperaOhip = 'OPERA_OHIP',
  Oscar = 'OSCAR',
  Sabre = 'SABRE',
  Stayntouch = 'STAYNTOUCH',
  Tsixty = 'TSIXTY',
  Wrp = 'WRP'
}

export type PmsUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentEndpoint?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEndpointPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEndpointUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentProviderType?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumPmsTypeFieldUpdateOperationsInput>;
};

export type PmsUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<PmsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<PmsCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<PmsCreateWithoutTenantInput>>;
  createMany?: InputMaybe<PmsCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<PmsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<PmsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<PmsWhereUniqueInput>>;
  set?: InputMaybe<Array<PmsWhereUniqueInput>>;
  update?: InputMaybe<Array<PmsUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<PmsUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<PmsUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type PmsUpdateManyWithWhereWithoutTenantInput = {
  data: PmsUpdateManyMutationInput;
  where: PmsScalarWhereInput;
};

export type PmsUpdateOneWithoutLocationsNestedInput = {
  connect?: InputMaybe<PmsWhereUniqueInput>;
  connectOrCreate?: InputMaybe<PmsCreateOrConnectWithoutLocationsInput>;
  create?: InputMaybe<PmsCreateWithoutLocationsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<PmsUpdateWithoutLocationsInput>;
  upsert?: InputMaybe<PmsUpsertWithoutLocationsInput>;
};

export type PmsUpdateWithoutLocationsInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentEndpoint?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEndpointPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEndpointUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentProviderType?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutPmsNestedInput>;
  type?: InputMaybe<EnumPmsTypeFieldUpdateOperationsInput>;
};

export type PmsUpdateWithoutTenantInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutPmsNestedInput>;
  paymentEndpoint?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEndpointPassword?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentEndpointUser?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  paymentProviderType?: InputMaybe<EnumPaymentProviderTypeFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumPmsTypeFieldUpdateOperationsInput>;
};

export type PmsUpdateWithWhereUniqueWithoutTenantInput = {
  data: PmsUpdateWithoutTenantInput;
  where: PmsWhereUniqueInput;
};

export type PmsUpsertWithoutLocationsInput = {
  create: PmsCreateWithoutLocationsInput;
  update: PmsUpdateWithoutLocationsInput;
};

export type PmsUpsertWithWhereUniqueWithoutTenantInput = {
  create: PmsCreateWithoutTenantInput;
  update: PmsUpdateWithoutTenantInput;
  where: PmsWhereUniqueInput;
};

export type PmsWhereInput = {
  AND?: InputMaybe<Array<PmsWhereInput>>;
  id?: InputMaybe<StringFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  NOT?: InputMaybe<Array<PmsWhereInput>>;
  OR?: InputMaybe<Array<PmsWhereInput>>;
  paymentEndpoint?: InputMaybe<StringNullableFilter>;
  paymentEndpointPassword?: InputMaybe<StringNullableFilter>;
  paymentEndpointUser?: InputMaybe<StringNullableFilter>;
  paymentProviderType?: InputMaybe<EnumPaymentProviderTypeFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumPmsTypeFilter>;
};

export type PmsWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type PopulateAccessGrantInput = {
  confirmationCode: Scalars['String'];
  locationId: Scalars['String'];
  tenantId: Scalars['String'];
};

export type Query = {
  accessGrant?: Maybe<AccessGrant>;
  accessGrantIsEnabledToGetDynamicUserData?: Maybe<DynamicUserDetailsConfigJson>;
  accessGrantIsEnabledToSendNotificationToExternalAPI: Scalars['Boolean'];
  accessGrants?: Maybe<Array<AccessGrant>>;
  aggregateAccessGrant?: Maybe<AggregateAccessGrant>;
  aggregateAmenity: AggregateAmenity;
  aggregateAmenityGroup: AggregateAmenityGroup;
  aggregateCallRecord: AggregateCallRecord;
  aggregateCredential: AggregateCredential;
  aggregateDashboardAccessGrants?: Maybe<AggregateAccessGrant>;
  aggregateDashboardLocation?: Maybe<AggregateLocation>;
  aggregateFileToEntity: AggregateFileToEntity;
  aggregateInfoItem: AggregateInfoItem;
  aggregateKiosk: AggregateKiosk;
  aggregateLanguage: AggregateLanguage;
  aggregateLocalization: AggregateLocalization;
  aggregateLocation: AggregateLocation;
  aggregatePass: AggregatePass;
  aggregatePayment: AggregatePayment;
  aggregatePaymentTransaction: AggregatePaymentTransaction;
  aggregateRegistration: AggregateRegistration;
  aggregateRequirement: AggregateRequirement;
  aggregateResource: AggregateResource;
  aggregateResourceGroup: AggregateResourceGroup;
  aggregateService: AggregateService;
  aggregateServiceRequest: AggregateServiceRequest;
  aggregateSupplementaryCard: AggregateSupplementaryCard;
  aggregateTenant: AggregateTenant;
  aggregateTheme: AggregateTheme;
  aggregateUnitType: AggregateUnitType;
  aggregateUser: AggregateUser;
  aggregateUserPushNotificationToken: AggregateUserPushNotificationToken;
  aggregateUserRecord: AggregateUserRecord;
  aggregateUserTenantData: AggregateUserTenantData;
  aggregateVendorServer: AggregateVendorServer;
  amenities: Array<Amenity>;
  amenity?: Maybe<Amenity>;
  amenityGroup?: Maybe<AmenityGroup>;
  amenityGroups: Array<AmenityGroup>;
  callRecord?: Maybe<CallRecord>;
  callRecords: Array<CallRecord>;
  canAssociateLocationGroup: Scalars['Boolean'];
  compareUserNames: SuccessAnswer;
  credential?: Maybe<Credential>;
  credentials: Array<Credential>;
  /** Download the resource template CSV File. The query result it is the file encoded into base64. */
  downloadResourceTemplateCSVFile?: Maybe<DownloadCsvAnswer>;
  /** Download the unit type template CSV File. The query result it is the file encoded into base64. */
  downloadUnitTypeTemplateCSVFile?: Maybe<DownloadCsvAnswer>;
  fileToEntities: Array<FileToEntity>;
  fileToEntity?: Maybe<FileToEntity>;
  filterDashboardAccessGrants: DashboardAccessGrantsResponse;
  findAccessGrantByFirstNameAndLastName: VirtualAccessGrant;
  findAccessGrantById: VirtualAccessGrant;
  findAccessGrantsByConfirmationCodeAndLastName?: Maybe<Array<VirtualAccessGrant>>;
  findAccessGrantsByRoomNumberAndLastName?: Maybe<Array<VirtualAccessGrant>>;
  findAccessGrantsByType: Array<VirtualAccessGrant>;
  /** Returns a MifareBlobAnswer with passwords to unlock a previously used card or null if no credential with the provided serialNumber exists */
  findCardPasswordBySerialNumber?: Maybe<MifarePasswordAnswer>;
  findDashboardAccessGrant?: Maybe<DashboardAccessGrant>;
  findDashboardAccessGrants: Array<AccessGrant>;
  findFirstAccessGrant?: Maybe<AccessGrant>;
  findFirstAccessGrantOrThrow?: Maybe<AccessGrant>;
  findFirstAmenity?: Maybe<Amenity>;
  findFirstAmenityGroup?: Maybe<AmenityGroup>;
  findFirstAmenityGroupOrThrow?: Maybe<AmenityGroup>;
  findFirstAmenityOrThrow?: Maybe<Amenity>;
  findFirstCallRecord?: Maybe<CallRecord>;
  findFirstCallRecordOrThrow?: Maybe<CallRecord>;
  findFirstCredential?: Maybe<Credential>;
  findFirstCredentialOrThrow?: Maybe<Credential>;
  findFirstFileToEntity?: Maybe<FileToEntity>;
  findFirstFileToEntityOrThrow?: Maybe<FileToEntity>;
  findFirstInfoItem?: Maybe<InfoItem>;
  findFirstInfoItemOrThrow?: Maybe<InfoItem>;
  findFirstKiosk?: Maybe<Kiosk>;
  findFirstKioskOrThrow?: Maybe<Kiosk>;
  findFirstLanguage?: Maybe<Language>;
  findFirstLanguageOrThrow?: Maybe<Language>;
  findFirstLocalization?: Maybe<Localization>;
  findFirstLocalizationOrThrow?: Maybe<Localization>;
  findFirstLocation?: Maybe<Location>;
  findFirstLocationOrThrow?: Maybe<Location>;
  findFirstPass?: Maybe<Pass>;
  findFirstPassOrThrow?: Maybe<Pass>;
  findFirstPayment?: Maybe<Payment>;
  findFirstPaymentOrThrow?: Maybe<Payment>;
  findFirstPaymentTransaction?: Maybe<PaymentTransaction>;
  findFirstPaymentTransactionOrThrow?: Maybe<PaymentTransaction>;
  findFirstRegistration?: Maybe<Registration>;
  findFirstRegistrationOrThrow?: Maybe<Registration>;
  findFirstRequirement?: Maybe<Requirement>;
  findFirstRequirementOrThrow?: Maybe<Requirement>;
  findFirstResource?: Maybe<Resource>;
  findFirstResourceGroup?: Maybe<ResourceGroup>;
  findFirstResourceGroupOrThrow?: Maybe<ResourceGroup>;
  findFirstResourceOrThrow?: Maybe<Resource>;
  findFirstService?: Maybe<Service>;
  findFirstServiceOrThrow?: Maybe<Service>;
  findFirstServiceRequest?: Maybe<ServiceRequest>;
  findFirstServiceRequestOrThrow?: Maybe<ServiceRequest>;
  findFirstSupplementaryCard?: Maybe<SupplementaryCard>;
  findFirstSupplementaryCardOrThrow?: Maybe<SupplementaryCard>;
  findFirstTenant?: Maybe<Tenant>;
  findFirstTenantOrThrow?: Maybe<Tenant>;
  findFirstTheme?: Maybe<Theme>;
  findFirstThemeOrThrow?: Maybe<Theme>;
  findFirstUnitType?: Maybe<UnitType>;
  findFirstUnitTypeOrThrow?: Maybe<UnitType>;
  findFirstUserPushNotificationToken?: Maybe<UserPushNotificationToken>;
  findFirstUserPushNotificationTokenOrThrow?: Maybe<UserPushNotificationToken>;
  findFirstUserRecord?: Maybe<UserRecord>;
  findFirstUserRecordOrThrow?: Maybe<UserRecord>;
  findFirstUserTenantData?: Maybe<UserTenantData>;
  findFirstUserTenantDataOrThrow?: Maybe<UserTenantData>;
  findFirstVendorServer?: Maybe<VendorServer>;
  findFirstVendorServerOrThrow?: Maybe<VendorServer>;
  findKioskUserByFirstNameAndLastName: User;
  findManyUserTenantData: Array<UserTenantData>;
  findUniqueUserTenantData?: Maybe<UserTenantData>;
  findUniqueUserTenantDataOrThrow?: Maybe<UserTenantData>;
  generateArrivalsByDayReport: SuccessAnswer;
  getAccessGrant?: Maybe<AccessGrant>;
  getAccessGrantAuthenticationCredentials?: Maybe<AccessGrantAuthenticationCredentials>;
  getAccessGrantByLocationIdAndConfirmationCode: CleanedAccessGrantForApiUse;
  getAccessGrantGuestCounters?: Maybe<TotalGuests>;
  getAccessSetup: AccessSetupResponse;
  getAllTenantLocations: Array<CleanedLocationForApiUse>;
  getAmenity?: Maybe<Amenity>;
  getAmenityGroup?: Maybe<AmenityGroup>;
  getCallRecord?: Maybe<CallRecord>;
  getCheckOutTransactionList: Array<PmsApiTransactionAnswer>;
  getClearRemoteConfig: ClearIdVerificationRemoteConfigResponse;
  getConcierge?: Maybe<Array<ConciergeClientResponse>>;
  getConciergeTreeView?: Maybe<Array<ConciergeTreeViewNode>>;
  getCredential?: Maybe<Credential>;
  getCredentials: Array<Credential>;
  getCustomPaymentRequirement?: Maybe<CustomPaymentRequirement>;
  getDashboardLocation?: Maybe<DashboardLocation>;
  getDashboardLocations: Array<DashboardLocation>;
  getDashboardPreferences?: Maybe<DashboardPreferences>;
  getDashboardSupportedNotifications?: Maybe<NotificationsObject>;
  getDynamicUserDetails?: Maybe<DynamicUserDetailsConfigJson>;
  getEarlyCheckInPackageOffer: EarlyCheckInPackageOffer;
  getEarlyCheckInPackagesExternalIds: Array<Scalars['String']>;
  getEndpointTmsId: AssaEndpointTmsIdResponse;
  getFileToEntity?: Maybe<FileToEntity>;
  getGracePeriodsConfig: GracePeriod;
  getInfoItem?: Maybe<InfoItem>;
  getInternalApiKeys: Array<InternalApiKeyOnlyKeyAndType>;
  getInternalApiKeyTypes: InternalApiKeyTypes;
  getKiosk?: Maybe<Kiosk>;
  getKioskAccessGrantDispenseKeySettings?: Maybe<DispenseKeySettingAnswer>;
  getKioskConfig: GetKioskConfigAnswer;
  getKioskLocalization: BaseSettingAnswer;
  getKiosksLiveUsageData: KiosksLiveUsageData;
  getKioskTheme: BaseSettingAnswer;
  getLanguage?: Maybe<Language>;
  getLanguages: Array<LanguageInfo>;
  getLimitKeysConfig: LimitKeys;
  getLocalization?: Maybe<Localization>;
  getLocalizationAnswer: LocalizationAnswer;
  getLocation?: Maybe<Location>;
  getLocationDashboardCustomizeableComponents: Array<Component>;
  getLocationGroup: LocationGroupResponse;
  getLocationGroupNodes: Array<LocationGroupNodeResponse>;
  getLocationLocalization: BaseSettingAnswer;
  getLocationTheme: BaseSettingAnswer;
  getPass?: Maybe<Pass>;
  getPayment?: Maybe<Payment>;
  getPaymentTransaction?: Maybe<PaymentTransaction>;
  getRegistration?: Maybe<Registration>;
  getRelevantGracePeriodsForAccessGrant: GracePeriod;
  getRequirement?: Maybe<Requirement>;
  getReservationConfig: ReservationConfigResponse;
  /** Retrieves accessGrant by website token if token not expired. If token expired, generate new token and send it the user. */
  getReservationInfoByWebsiteToken: ReservationInfo;
  getResource?: Maybe<Resource>;
  getResourceGroup?: Maybe<ResourceGroup>;
  getService?: Maybe<Service>;
  getServiceRequest?: Maybe<ServiceRequest>;
  getSupplementaryCard?: Maybe<SupplementaryCard>;
  getTenant?: Maybe<Tenant>;
  getTenantDashboardCustomizeableComponents: Array<Component>;
  getTenantLocalization: BaseSettingAnswer;
  getTenantLocations: Array<TenantLocation>;
  getTenantTheme: BaseSettingAnswer;
  getTheme?: Maybe<Theme>;
  getThemeAnswer: ThemeAnswer;
  getTrack2Information?: Maybe<Track2Information>;
  getUnitType?: Maybe<UnitType>;
  getUnitTypeLocalizations: Array<BaseLocalizationAnswer>;
  getUserMemberships: Array<TenantMembership>;
  getUserPushNotificationToken?: Maybe<UserPushNotificationToken>;
  getUserRecord?: Maybe<UserRecord>;
  getVendorServer?: Maybe<VendorServer>;
  groupByAccessGrant: Array<AccessGrantGroupBy>;
  groupByAmenity: Array<AmenityGroupBy>;
  groupByAmenityGroup: Array<AmenityGroupGroupBy>;
  groupByCallRecord: Array<CallRecordGroupBy>;
  groupByCredential: Array<CredentialGroupBy>;
  groupByFileToEntity: Array<FileToEntityGroupBy>;
  groupByInfoItem: Array<InfoItemGroupBy>;
  groupByKiosk: Array<KioskGroupBy>;
  groupByLanguage: Array<LanguageGroupBy>;
  groupByLocalization: Array<LocalizationGroupBy>;
  groupByLocation: Array<LocationGroupBy>;
  groupByPass: Array<PassGroupBy>;
  groupByPayment: Array<PaymentGroupBy>;
  groupByPaymentTransaction: Array<PaymentTransactionGroupBy>;
  groupByRegistration: Array<RegistrationGroupBy>;
  groupByRequirement: Array<RequirementGroupBy>;
  groupByResource: Array<ResourceGroupBy>;
  groupByResourceGroup: Array<ResourceGroupGroupBy>;
  groupByService: Array<ServiceGroupBy>;
  groupByServiceRequest: Array<ServiceRequestGroupBy>;
  groupBySupplementaryCard: Array<SupplementaryCardGroupBy>;
  groupByTenant: Array<TenantGroupBy>;
  groupByTheme: Array<ThemeGroupBy>;
  groupByUnitType: Array<UnitTypeGroupBy>;
  groupByUserPushNotificationToken: Array<UserPushNotificationTokenGroupBy>;
  groupByUserRecord: Array<UserRecordGroupBy>;
  groupByUserTenantData: Array<UserTenantDataGroupBy>;
  groupByVendorServer: Array<VendorServerGroupBy>;
  hasPackagesFeatureEnabled: SuccessAnswer;
  hasPackageWithNeedVoucher: SuccessAnswer;
  info?: Maybe<InfoItem>;
  infoItem?: Maybe<InfoItem>;
  infoItems: Array<InfoItem>;
  infos?: Maybe<Array<InfoItem>>;
  infoTypes?: Maybe<Array<TypeOfInfo>>;
  kiosk?: Maybe<Kiosk>;
  kiosks: Array<Kiosk>;
  language?: Maybe<Language>;
  languages: Array<Language>;
  /** List of shared credentials */
  listSharedMobileCredentials: Array<AccessGrantUser>;
  localization?: Maybe<Localization>;
  localizations: Array<Localization>;
  location?: Maybe<Location>;
  locationGroups: Array<LocationGroup>;
  locations: Array<Location>;
  me: Me;
  meWithUserRolePermissions: MeWithUserRolePermissions;
  pass?: Maybe<Pass>;
  passes: Array<Pass>;
  payment?: Maybe<Payment>;
  payments: Array<Payment>;
  paymentTransaction?: Maybe<PaymentTransaction>;
  paymentTransactions: Array<PaymentTransaction>;
  registration?: Maybe<Registration>;
  registrations: Array<Registration>;
  requirement?: Maybe<Requirement>;
  requirements: Array<Requirement>;
  resource?: Maybe<Resource>;
  resourceGroup?: Maybe<ResourceGroup>;
  resourceGroups: Array<ResourceGroup>;
  resources: Array<Resource>;
  retrieveAccessGrantUsers: Array<AccessGrantUser>;
  retrieveAvailablePackages: Array<Package>;
  retrieveAvailablePackagesByServiceCategory: Array<ServiceByCategory>;
  retrieveBookedPackagesFromReservation: Array<BookedPackage>;
  retrieveShift4AuthorizeAndCancelBody: Shift4AuthorizeBodyResponse;
  retrieveShift4AuthorizeBody: Shift4AuthorizeBodyResponse;
  retrieveVerificationResult: JumioDocumentAndImage;
  retrivePaymentMethod: PaymentMethod;
  searchAccessGrant?: Maybe<Array<AccessGrant>>;
  searchResource?: Maybe<Array<Resource>>;
  service?: Maybe<Service>;
  serviceRequest?: Maybe<ServiceRequest>;
  serviceRequests: Array<ServiceRequest>;
  services?: Maybe<Array<Service>>;
  stayDatesOrFutureAccessGrants: Array<VirtualAccessGrant>;
  supplementaryCard?: Maybe<SupplementaryCard>;
  supplementaryCards: Array<SupplementaryCard>;
  tenant?: Maybe<Tenant>;
  tenants: Array<Tenant>;
  theme?: Maybe<Theme>;
  themes: Array<Theme>;
  unitType?: Maybe<UnitType>;
  unitTypes?: Maybe<Array<UnitType>>;
  user?: Maybe<User>;
  userPushNotificationToken?: Maybe<UserPushNotificationToken>;
  userPushNotificationTokens: Array<UserPushNotificationToken>;
  userRecord?: Maybe<UserRecord>;
  userRecords: Array<UserRecord>;
  users: Array<User>;
  validateIdOnSimplifiedAuth: IdVerificationAnswer;
  vendorServer?: Maybe<VendorServer>;
  vendorServers?: Maybe<Array<VendorServer>>;
  verifyId: IdVerificationAnswerWithRequirement;
};


export type QueryAccessGrantArgs = {
  where: AccessGrantWhereUniqueInput;
};


export type QueryAccessGrantIsEnabledToGetDynamicUserDataArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryAccessGrantIsEnabledToSendNotificationToExternalApiArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type QueryAggregateAccessGrantArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type QueryAggregateAmenityArgs = {
  cursor?: InputMaybe<AmenityWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AmenityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityWhereInput>;
};


export type QueryAggregateAmenityGroupArgs = {
  cursor?: InputMaybe<AmenityGroupWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AmenityGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityGroupWhereInput>;
};


export type QueryAggregateCallRecordArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type QueryAggregateCredentialArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type QueryAggregateDashboardAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type QueryAggregateDashboardLocationArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CustomLocationWhereInput>;
};


export type QueryAggregateFileToEntityArgs = {
  cursor?: InputMaybe<FileToEntityWhereUniqueInput>;
  orderBy?: InputMaybe<Array<FileToEntityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileToEntityWhereInput>;
};


export type QueryAggregateInfoItemArgs = {
  cursor?: InputMaybe<InfoItemWhereUniqueInput>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


export type QueryAggregateKioskArgs = {
  cursor?: InputMaybe<KioskWhereUniqueInput>;
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
};


export type QueryAggregateLanguageArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  orderBy?: InputMaybe<Array<LanguageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type QueryAggregateLocalizationArgs = {
  cursor?: InputMaybe<LocalizationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<LocalizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocalizationWhereInput>;
};


export type QueryAggregateLocationArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryAggregatePassArgs = {
  cursor?: InputMaybe<PassWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PassOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PassWhereInput>;
};


export type QueryAggregatePaymentArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryAggregatePaymentTransactionArgs = {
  cursor?: InputMaybe<PaymentTransactionWhereUniqueInput>;
  orderBy?: InputMaybe<Array<PaymentTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


export type QueryAggregateRegistrationArgs = {
  cursor?: InputMaybe<RegistrationWhereUniqueInput>;
  orderBy?: InputMaybe<Array<RegistrationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RegistrationWhereInput>;
};


export type QueryAggregateRequirementArgs = {
  cursor?: InputMaybe<RequirementWhereUniqueInput>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
};


export type QueryAggregateResourceArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type QueryAggregateResourceGroupArgs = {
  cursor?: InputMaybe<ResourceGroupWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type QueryAggregateServiceArgs = {
  cursor?: InputMaybe<ServiceWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ServiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceWhereInput>;
};


export type QueryAggregateServiceRequestArgs = {
  cursor?: InputMaybe<ServiceRequestWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ServiceRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type QueryAggregateSupplementaryCardArgs = {
  cursor?: InputMaybe<SupplementaryCardWhereUniqueInput>;
  orderBy?: InputMaybe<Array<SupplementaryCardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


export type QueryAggregateTenantArgs = {
  cursor?: InputMaybe<TenantWhereUniqueInput>;
  orderBy?: InputMaybe<Array<TenantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TenantWhereInput>;
};


export type QueryAggregateThemeArgs = {
  cursor?: InputMaybe<ThemeWhereUniqueInput>;
  orderBy?: InputMaybe<Array<ThemeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThemeWhereInput>;
};


export type QueryAggregateUnitTypeArgs = {
  cursor?: InputMaybe<UnitTypeWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UnitTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitTypeWhereInput>;
};


export type QueryAggregateUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryAggregateUserPushNotificationTokenArgs = {
  cursor?: InputMaybe<UserPushNotificationTokenWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserPushNotificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type QueryAggregateUserRecordArgs = {
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type QueryAggregateUserTenantDataArgs = {
  cursor?: InputMaybe<UserTenantDataWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};


export type QueryAggregateVendorServerArgs = {
  cursor?: InputMaybe<VendorServerWhereUniqueInput>;
  orderBy?: InputMaybe<Array<VendorServerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VendorServerWhereInput>;
};


export type QueryAmenitiesArgs = {
  cursor?: InputMaybe<AmenityWhereUniqueInput>;
  distinct?: InputMaybe<Array<AmenityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AmenityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityWhereInput>;
};


export type QueryAmenityArgs = {
  where: AmenityWhereUniqueInput;
};


export type QueryAmenityGroupArgs = {
  where: AmenityGroupWhereUniqueInput;
};


export type QueryAmenityGroupsArgs = {
  cursor?: InputMaybe<AmenityGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AmenityGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AmenityGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityGroupWhereInput>;
};


export type QueryCallRecordArgs = {
  where: CallRecordWhereUniqueInput;
};


export type QueryCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type QueryCanAssociateLocationGroupArgs = {
  locationGroupId: Scalars['String'];
  parentLocationGroupId: Scalars['String'];
};


export type QueryCompareUserNamesArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  lastName1?: InputMaybe<Scalars['String']>;
  lastName2?: InputMaybe<Scalars['String']>;
  name1?: InputMaybe<Scalars['String']>;
  name2?: InputMaybe<Scalars['String']>;
};


export type QueryCredentialArgs = {
  where: CredentialWhereUniqueInput;
};


export type QueryCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type QueryFileToEntitiesArgs = {
  cursor?: InputMaybe<FileToEntityWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileToEntityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileToEntityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileToEntityWhereInput>;
};


export type QueryFileToEntityArgs = {
  where: FileToEntityWhereUniqueInput;
};


export type QueryFilterDashboardAccessGrantsArgs = {
  limit?: InputMaybe<Scalars['Int']>;
  locationId?: InputMaybe<DagfStringFilter>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardAccessGrantsOrderBy>>;
  requirementStatus?: InputMaybe<DagfRequirementStatusFilter>;
  requirementType?: InputMaybe<DagfRequirementTypeFilter>;
  retryCheckinStatus?: InputMaybe<DagfRetryCheckinStatusFilter>;
  state?: InputMaybe<DagfAccessGrantStateFilter>;
  status?: InputMaybe<DagfAccessGrantStatusFilter>;
  tenantId: Scalars['String'];
  textFilter?: InputMaybe<DashboardTextFilter>;
  timeFilter?: InputMaybe<DashboardTimeFilter>;
  userId?: InputMaybe<Scalars['String']>;
};


export type QueryFindAccessGrantByFirstNameAndLastNameArgs = {
  dateOfBirth?: InputMaybe<Scalars['String']>;
  expireDate?: InputMaybe<Scalars['String']>;
  findAccessGrantType?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  nameVerificationAuthType?: InputMaybe<Scalars['String']>;
};


export type QueryFindAccessGrantByIdArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryFindAccessGrantsByConfirmationCodeAndLastNameArgs = {
  confirmationCode: Scalars['String'];
  findAccessGrantType: Scalars['String'];
  lastName: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  timezone?: InputMaybe<Scalars['String']>;
};


export type QueryFindAccessGrantsByRoomNumberAndLastNameArgs = {
  findAccessGrantType: Scalars['String'];
  lastName: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  roomNumber: Scalars['String'];
};


export type QueryFindAccessGrantsByTypeArgs = {
  findAccessGrantType: Scalars['String'];
  locationId: Scalars['String'];
};


export type QueryFindCardPasswordBySerialNumberArgs = {
  serialNumber: Scalars['String'];
};


export type QueryFindDashboardAccessGrantArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type QueryFindDashboardAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type QueryFindFirstAccessGrantArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type QueryFindFirstAccessGrantOrThrowArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type QueryFindFirstAmenityArgs = {
  cursor?: InputMaybe<AmenityWhereUniqueInput>;
  distinct?: InputMaybe<Array<AmenityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AmenityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityWhereInput>;
};


export type QueryFindFirstAmenityGroupArgs = {
  cursor?: InputMaybe<AmenityGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AmenityGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AmenityGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityGroupWhereInput>;
};


export type QueryFindFirstAmenityGroupOrThrowArgs = {
  cursor?: InputMaybe<AmenityGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<AmenityGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AmenityGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityGroupWhereInput>;
};


export type QueryFindFirstAmenityOrThrowArgs = {
  cursor?: InputMaybe<AmenityWhereUniqueInput>;
  distinct?: InputMaybe<Array<AmenityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AmenityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityWhereInput>;
};


export type QueryFindFirstCallRecordArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type QueryFindFirstCallRecordOrThrowArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type QueryFindFirstCredentialArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type QueryFindFirstCredentialOrThrowArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type QueryFindFirstFileToEntityArgs = {
  cursor?: InputMaybe<FileToEntityWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileToEntityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileToEntityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileToEntityWhereInput>;
};


export type QueryFindFirstFileToEntityOrThrowArgs = {
  cursor?: InputMaybe<FileToEntityWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileToEntityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileToEntityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileToEntityWhereInput>;
};


export type QueryFindFirstInfoItemArgs = {
  cursor?: InputMaybe<InfoItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<InfoItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


export type QueryFindFirstInfoItemOrThrowArgs = {
  cursor?: InputMaybe<InfoItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<InfoItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


export type QueryFindFirstKioskArgs = {
  cursor?: InputMaybe<KioskWhereUniqueInput>;
  distinct?: InputMaybe<Array<KioskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
};


export type QueryFindFirstKioskOrThrowArgs = {
  cursor?: InputMaybe<KioskWhereUniqueInput>;
  distinct?: InputMaybe<Array<KioskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
};


export type QueryFindFirstLanguageArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  distinct?: InputMaybe<Array<LanguageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LanguageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type QueryFindFirstLanguageOrThrowArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  distinct?: InputMaybe<Array<LanguageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LanguageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type QueryFindFirstLocalizationArgs = {
  cursor?: InputMaybe<LocalizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocalizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocalizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocalizationWhereInput>;
};


export type QueryFindFirstLocalizationOrThrowArgs = {
  cursor?: InputMaybe<LocalizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocalizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocalizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocalizationWhereInput>;
};


export type QueryFindFirstLocationArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryFindFirstLocationOrThrowArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryFindFirstPassArgs = {
  cursor?: InputMaybe<PassWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PassWhereInput>;
};


export type QueryFindFirstPassOrThrowArgs = {
  cursor?: InputMaybe<PassWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PassWhereInput>;
};


export type QueryFindFirstPaymentArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryFindFirstPaymentOrThrowArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryFindFirstPaymentTransactionArgs = {
  cursor?: InputMaybe<PaymentTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


export type QueryFindFirstPaymentTransactionOrThrowArgs = {
  cursor?: InputMaybe<PaymentTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


export type QueryFindFirstRegistrationArgs = {
  cursor?: InputMaybe<RegistrationWhereUniqueInput>;
  distinct?: InputMaybe<Array<RegistrationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RegistrationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RegistrationWhereInput>;
};


export type QueryFindFirstRegistrationOrThrowArgs = {
  cursor?: InputMaybe<RegistrationWhereUniqueInput>;
  distinct?: InputMaybe<Array<RegistrationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RegistrationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RegistrationWhereInput>;
};


export type QueryFindFirstRequirementArgs = {
  cursor?: InputMaybe<RequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<RequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
};


export type QueryFindFirstRequirementOrThrowArgs = {
  cursor?: InputMaybe<RequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<RequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
};


export type QueryFindFirstResourceArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type QueryFindFirstResourceGroupArgs = {
  cursor?: InputMaybe<ResourceGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type QueryFindFirstResourceGroupOrThrowArgs = {
  cursor?: InputMaybe<ResourceGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type QueryFindFirstResourceOrThrowArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type QueryFindFirstServiceArgs = {
  cursor?: InputMaybe<ServiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceWhereInput>;
};


export type QueryFindFirstServiceOrThrowArgs = {
  cursor?: InputMaybe<ServiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceWhereInput>;
};


export type QueryFindFirstServiceRequestArgs = {
  cursor?: InputMaybe<ServiceRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type QueryFindFirstServiceRequestOrThrowArgs = {
  cursor?: InputMaybe<ServiceRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type QueryFindFirstSupplementaryCardArgs = {
  cursor?: InputMaybe<SupplementaryCardWhereUniqueInput>;
  distinct?: InputMaybe<Array<SupplementaryCardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SupplementaryCardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


export type QueryFindFirstSupplementaryCardOrThrowArgs = {
  cursor?: InputMaybe<SupplementaryCardWhereUniqueInput>;
  distinct?: InputMaybe<Array<SupplementaryCardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SupplementaryCardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


export type QueryFindFirstTenantArgs = {
  cursor?: InputMaybe<TenantWhereUniqueInput>;
  distinct?: InputMaybe<Array<TenantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TenantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TenantWhereInput>;
};


export type QueryFindFirstTenantOrThrowArgs = {
  cursor?: InputMaybe<TenantWhereUniqueInput>;
  distinct?: InputMaybe<Array<TenantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TenantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TenantWhereInput>;
};


export type QueryFindFirstThemeArgs = {
  cursor?: InputMaybe<ThemeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ThemeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ThemeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThemeWhereInput>;
};


export type QueryFindFirstThemeOrThrowArgs = {
  cursor?: InputMaybe<ThemeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ThemeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ThemeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThemeWhereInput>;
};


export type QueryFindFirstUnitTypeArgs = {
  cursor?: InputMaybe<UnitTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<UnitTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UnitTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitTypeWhereInput>;
};


export type QueryFindFirstUnitTypeOrThrowArgs = {
  cursor?: InputMaybe<UnitTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<UnitTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UnitTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitTypeWhereInput>;
};


export type QueryFindFirstUserPushNotificationTokenArgs = {
  cursor?: InputMaybe<UserPushNotificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPushNotificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPushNotificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type QueryFindFirstUserPushNotificationTokenOrThrowArgs = {
  cursor?: InputMaybe<UserPushNotificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPushNotificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPushNotificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type QueryFindFirstUserRecordArgs = {
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type QueryFindFirstUserRecordOrThrowArgs = {
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type QueryFindFirstUserTenantDataArgs = {
  cursor?: InputMaybe<UserTenantDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTenantDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};


export type QueryFindFirstUserTenantDataOrThrowArgs = {
  cursor?: InputMaybe<UserTenantDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTenantDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};


export type QueryFindFirstVendorServerArgs = {
  cursor?: InputMaybe<VendorServerWhereUniqueInput>;
  distinct?: InputMaybe<Array<VendorServerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VendorServerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VendorServerWhereInput>;
};


export type QueryFindFirstVendorServerOrThrowArgs = {
  cursor?: InputMaybe<VendorServerWhereUniqueInput>;
  distinct?: InputMaybe<Array<VendorServerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VendorServerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VendorServerWhereInput>;
};


export type QueryFindKioskUserByFirstNameAndLastNameArgs = {
  firstName: Scalars['String'];
  lastName: Scalars['String'];
};


export type QueryFindManyUserTenantDataArgs = {
  cursor?: InputMaybe<UserTenantDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTenantDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};


export type QueryFindUniqueUserTenantDataArgs = {
  where: UserTenantDataWhereUniqueInput;
};


export type QueryFindUniqueUserTenantDataOrThrowArgs = {
  where: UserTenantDataWhereUniqueInput;
};


export type QueryGenerateArrivalsByDayReportArgs = {
  days?: InputMaybe<Scalars['Float']>;
  locationId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type QueryGetAccessGrantArgs = {
  where: AccessGrantWhereUniqueInput;
};


export type QueryGetAccessGrantAuthenticationCredentialsArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryGetAccessGrantByLocationIdAndConfirmationCodeArgs = {
  confirmationCode: Scalars['String'];
  locationId: Scalars['String'];
};


export type QueryGetAccessGrantGuestCountersArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryGetAccessSetupArgs = {
  locationId: Scalars['String'];
};


export type QueryGetAmenityArgs = {
  where: AmenityWhereUniqueInput;
};


export type QueryGetAmenityGroupArgs = {
  where: AmenityGroupWhereUniqueInput;
};


export type QueryGetCallRecordArgs = {
  where: CallRecordWhereUniqueInput;
};


export type QueryGetCheckOutTransactionListArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryGetClearRemoteConfigArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryGetConciergeArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
};


export type QueryGetConciergeTreeViewArgs = {
  locationId: Scalars['String'];
};


export type QueryGetCredentialArgs = {
  where: CredentialWhereUniqueInput;
};


export type QueryGetCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type QueryGetCustomPaymentRequirementArgs = {
  where: CustomPaymentRequirementsWhereInput;
};


export type QueryGetDashboardLocationArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryGetDashboardLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CustomLocationWhereInput>;
};


export type QueryGetDashboardPreferencesArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};


export type QueryGetDashboardSupportedNotificationsArgs = {
  where: DashboardSupportedNotificationsWhereInput;
};


export type QueryGetDynamicUserDetailsArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryGetEarlyCheckInPackageOfferArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryGetEarlyCheckInPackagesExternalIdsArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryGetEndpointTmsIdArgs = {
  locationId: Scalars['String'];
};


export type QueryGetFileToEntityArgs = {
  where: FileToEntityWhereUniqueInput;
};


export type QueryGetGracePeriodsConfigArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  gracePeriodsConfigLevel: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryGetInfoItemArgs = {
  where: InfoItemWhereUniqueInput;
};


export type QueryGetInternalApiKeysArgs = {
  tenantId: Scalars['String'];
};


export type QueryGetKioskArgs = {
  where: KioskWhereUniqueInput;
};


export type QueryGetKioskAccessGrantDispenseKeySettingsArgs = {
  accessGrantId: Scalars['String'];
  locationId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryGetKioskLocalizationArgs = {
  componentName: Scalars['String'];
  kioskId: Scalars['String'];
  languageId: Scalars['String'];
};


export type QueryGetKiosksLiveUsageDataArgs = {
  kioskAndAccessGrantParams: Array<KioskAndAccessGrantParams>;
};


export type QueryGetKioskThemeArgs = {
  componentName: Scalars['String'];
  kioskId: Scalars['String'];
};


export type QueryGetLanguageArgs = {
  where: LanguageWhereUniqueInput;
};


export type QueryGetLanguagesArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  distinct?: InputMaybe<Array<LanguageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LanguageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type QueryGetLimitKeysConfigArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  limitKeysConfigLevel: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryGetLocalizationArgs = {
  where: LocalizationWhereUniqueInput;
};


export type QueryGetLocalizationAnswerArgs = {
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryGetLocationArgs = {
  where: LocationWhereUniqueInput;
};


export type QueryGetLocationDashboardCustomizeableComponentsArgs = {
  locationId: Scalars['String'];
};


export type QueryGetLocationGroupArgs = {
  locationGroupId: Scalars['String'];
};


export type QueryGetLocationGroupNodesArgs = {
  tenantId: Scalars['String'];
};


export type QueryGetLocationLocalizationArgs = {
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  locationId: Scalars['String'];
};


export type QueryGetLocationThemeArgs = {
  componentName: Scalars['String'];
  locationId: Scalars['String'];
};


export type QueryGetPassArgs = {
  where: PassWhereUniqueInput;
};


export type QueryGetPaymentArgs = {
  where: PaymentWhereUniqueInput;
};


export type QueryGetPaymentTransactionArgs = {
  where: PaymentTransactionWhereUniqueInput;
};


export type QueryGetRegistrationArgs = {
  where: RegistrationWhereUniqueInput;
};


export type QueryGetRelevantGracePeriodsForAccessGrantArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryGetRequirementArgs = {
  where: RequirementWhereUniqueInput;
};


export type QueryGetReservationConfigArgs = {
  locationId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryGetReservationInfoByWebsiteTokenArgs = {
  token: Scalars['String'];
};


export type QueryGetResourceArgs = {
  where: ResourceWhereUniqueInput;
};


export type QueryGetResourceGroupArgs = {
  where: ResourceGroupWhereUniqueInput;
};


export type QueryGetServiceArgs = {
  where: ServiceWhereUniqueInput;
};


export type QueryGetServiceRequestArgs = {
  where: ServiceRequestWhereUniqueInput;
};


export type QueryGetSupplementaryCardArgs = {
  where: SupplementaryCardWhereUniqueInput;
};


export type QueryGetTenantArgs = {
  where: TenantWhereUniqueInput;
};


export type QueryGetTenantDashboardCustomizeableComponentsArgs = {
  tenantId: Scalars['String'];
};


export type QueryGetTenantLocalizationArgs = {
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryGetTenantLocationsArgs = {
  tenantId: Scalars['String'];
};


export type QueryGetTenantThemeArgs = {
  componentName: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryGetThemeArgs = {
  where: ThemeWhereUniqueInput;
};


export type QueryGetThemeAnswerArgs = {
  componentName: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
};


export type QueryGetTrack2InformationArgs = {
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryGetUnitTypeArgs = {
  where: UnitTypeWhereUniqueInput;
};


export type QueryGetUnitTypeLocalizationsArgs = {
  componentName: Scalars['String'];
  unitTypeId: Scalars['String'];
};


export type QueryGetUserPushNotificationTokenArgs = {
  where: UserPushNotificationTokenWhereUniqueInput;
};


export type QueryGetUserRecordArgs = {
  where: UserRecordWhereUniqueInput;
};


export type QueryGetVendorServerArgs = {
  where: VendorServerWhereUniqueInput;
};


export type QueryGroupByAccessGrantArgs = {
  by: Array<AccessGrantScalarFieldEnum>;
  having?: InputMaybe<AccessGrantScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type QueryGroupByAmenityArgs = {
  by: Array<AmenityScalarFieldEnum>;
  having?: InputMaybe<AmenityScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AmenityOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityWhereInput>;
};


export type QueryGroupByAmenityGroupArgs = {
  by: Array<AmenityGroupScalarFieldEnum>;
  having?: InputMaybe<AmenityGroupScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<AmenityGroupOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityGroupWhereInput>;
};


export type QueryGroupByCallRecordArgs = {
  by: Array<CallRecordScalarFieldEnum>;
  having?: InputMaybe<CallRecordScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type QueryGroupByCredentialArgs = {
  by: Array<CredentialScalarFieldEnum>;
  having?: InputMaybe<CredentialScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type QueryGroupByFileToEntityArgs = {
  by: Array<FileToEntityScalarFieldEnum>;
  having?: InputMaybe<FileToEntityScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<FileToEntityOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileToEntityWhereInput>;
};


export type QueryGroupByInfoItemArgs = {
  by: Array<InfoItemScalarFieldEnum>;
  having?: InputMaybe<InfoItemScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


export type QueryGroupByKioskArgs = {
  by: Array<KioskScalarFieldEnum>;
  having?: InputMaybe<KioskScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<KioskOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
};


export type QueryGroupByLanguageArgs = {
  by: Array<LanguageScalarFieldEnum>;
  having?: InputMaybe<LanguageScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<LanguageOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type QueryGroupByLocalizationArgs = {
  by: Array<LocalizationScalarFieldEnum>;
  having?: InputMaybe<LocalizationScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<LocalizationOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocalizationWhereInput>;
};


export type QueryGroupByLocationArgs = {
  by: Array<LocationScalarFieldEnum>;
  having?: InputMaybe<LocationScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<LocationOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryGroupByPassArgs = {
  by: Array<PassScalarFieldEnum>;
  having?: InputMaybe<PassScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PassOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PassWhereInput>;
};


export type QueryGroupByPaymentArgs = {
  by: Array<PaymentScalarFieldEnum>;
  having?: InputMaybe<PaymentScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryGroupByPaymentTransactionArgs = {
  by: Array<PaymentTransactionScalarFieldEnum>;
  having?: InputMaybe<PaymentTransactionScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<PaymentTransactionOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


export type QueryGroupByRegistrationArgs = {
  by: Array<RegistrationScalarFieldEnum>;
  having?: InputMaybe<RegistrationScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<RegistrationOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RegistrationWhereInput>;
};


export type QueryGroupByRequirementArgs = {
  by: Array<RequirementScalarFieldEnum>;
  having?: InputMaybe<RequirementScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
};


export type QueryGroupByResourceArgs = {
  by: Array<ResourceScalarFieldEnum>;
  having?: InputMaybe<ResourceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type QueryGroupByResourceGroupArgs = {
  by: Array<ResourceGroupScalarFieldEnum>;
  having?: InputMaybe<ResourceGroupScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type QueryGroupByServiceArgs = {
  by: Array<ServiceScalarFieldEnum>;
  having?: InputMaybe<ServiceScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ServiceOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceWhereInput>;
};


export type QueryGroupByServiceRequestArgs = {
  by: Array<ServiceRequestScalarFieldEnum>;
  having?: InputMaybe<ServiceRequestScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ServiceRequestOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type QueryGroupBySupplementaryCardArgs = {
  by: Array<SupplementaryCardScalarFieldEnum>;
  having?: InputMaybe<SupplementaryCardScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<SupplementaryCardOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


export type QueryGroupByTenantArgs = {
  by: Array<TenantScalarFieldEnum>;
  having?: InputMaybe<TenantScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<TenantOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TenantWhereInput>;
};


export type QueryGroupByThemeArgs = {
  by: Array<ThemeScalarFieldEnum>;
  having?: InputMaybe<ThemeScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<ThemeOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThemeWhereInput>;
};


export type QueryGroupByUnitTypeArgs = {
  by: Array<UnitTypeScalarFieldEnum>;
  having?: InputMaybe<UnitTypeScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UnitTypeOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitTypeWhereInput>;
};


export type QueryGroupByUserPushNotificationTokenArgs = {
  by: Array<UserPushNotificationTokenScalarFieldEnum>;
  having?: InputMaybe<UserPushNotificationTokenScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserPushNotificationTokenOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type QueryGroupByUserRecordArgs = {
  by: Array<UserRecordScalarFieldEnum>;
  having?: InputMaybe<UserRecordScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type QueryGroupByUserTenantDataArgs = {
  by: Array<UserTenantDataScalarFieldEnum>;
  having?: InputMaybe<UserTenantDataScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};


export type QueryGroupByVendorServerArgs = {
  by: Array<VendorServerScalarFieldEnum>;
  having?: InputMaybe<VendorServerScalarWhereWithAggregatesInput>;
  orderBy?: InputMaybe<Array<VendorServerOrderByWithAggregationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VendorServerWhereInput>;
};


export type QueryHasPackagesFeatureEnabledArgs = {
  locationId: Scalars['String'];
  tenantId: Scalars['String'];
};


export type QueryHasPackageWithNeedVoucherArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryInfoArgs = {
  where: InfoItemWhereUniqueInput;
};


export type QueryInfoItemArgs = {
  where: InfoItemWhereUniqueInput;
};


export type QueryInfoItemsArgs = {
  cursor?: InputMaybe<InfoItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<InfoItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


export type QueryInfosArgs = {
  cursor?: InputMaybe<InfoItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<InfoItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


export type QueryKioskArgs = {
  where: KioskWhereUniqueInput;
};


export type QueryKiosksArgs = {
  cursor?: InputMaybe<KioskWhereUniqueInput>;
  distinct?: InputMaybe<Array<KioskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
};


export type QueryLanguageArgs = {
  where: LanguageWhereUniqueInput;
};


export type QueryLanguagesArgs = {
  cursor?: InputMaybe<LanguageWhereUniqueInput>;
  distinct?: InputMaybe<Array<LanguageScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LanguageOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LanguageWhereInput>;
};


export type QueryListSharedMobileCredentialsArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryLocalizationArgs = {
  where: LocalizationWhereUniqueInput;
};


export type QueryLocalizationsArgs = {
  cursor?: InputMaybe<LocalizationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocalizationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocalizationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocalizationWhereInput>;
};


export type QueryLocationArgs = {
  where: LocationWhereUniqueInput;
};


export type QueryLocationGroupsArgs = {
  cursor?: InputMaybe<LocationGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationGroupWhereInput>;
};


export type QueryLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type QueryPassArgs = {
  where: PassWhereUniqueInput;
};


export type QueryPassesArgs = {
  cursor?: InputMaybe<PassWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PassWhereInput>;
};


export type QueryPaymentArgs = {
  where: PaymentWhereUniqueInput;
};


export type QueryPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type QueryPaymentTransactionArgs = {
  where: PaymentTransactionWhereUniqueInput;
};


export type QueryPaymentTransactionsArgs = {
  cursor?: InputMaybe<PaymentTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


export type QueryRegistrationArgs = {
  where: RegistrationWhereUniqueInput;
};


export type QueryRegistrationsArgs = {
  cursor?: InputMaybe<RegistrationWhereUniqueInput>;
  distinct?: InputMaybe<Array<RegistrationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RegistrationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RegistrationWhereInput>;
};


export type QueryRequirementArgs = {
  where: RequirementWhereUniqueInput;
};


export type QueryRequirementsArgs = {
  cursor?: InputMaybe<RequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<RequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
};


export type QueryResourceArgs = {
  where: ResourceWhereUniqueInput;
};


export type QueryResourceGroupArgs = {
  where: ResourceGroupWhereUniqueInput;
};


export type QueryResourceGroupsArgs = {
  cursor?: InputMaybe<ResourceGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type QueryResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type QueryRetrieveAccessGrantUsersArgs = {
  accessGrantId: Scalars['String'];
  onlySecondaryUsers?: Scalars['Boolean'];
};


export type QueryRetrieveAvailablePackagesArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryRetrieveAvailablePackagesByServiceCategoryArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
};


export type QueryRetrieveBookedPackagesFromReservationArgs = {
  accessGrantId: Scalars['String'];
};


export type QueryRetrieveShift4AuthorizeAndCancelBodyArgs = {
  accessGrantId: Scalars['String'];
  clerkId: Scalars['Float'];
};


export type QueryRetrieveShift4AuthorizeBodyArgs = {
  accessGrantId: Scalars['String'];
  clerkId: Scalars['Float'];
};


export type QueryRetrieveVerificationResultArgs = {
  scanReference: Scalars['String'];
};


export type QueryRetrivePaymentMethodArgs = {
  where: PaymentWhereUniqueInput;
};


export type QuerySearchAccessGrantArgs = {
  where: AccessGrantSearchInput;
};


export type QuerySearchResourceArgs = {
  where: ResourceSearchInput;
};


export type QueryServiceArgs = {
  where: ServiceWhereUniqueInput;
};


export type QueryServiceRequestArgs = {
  where: ServiceRequestWhereUniqueInput;
};


export type QueryServiceRequestsArgs = {
  cursor?: InputMaybe<ServiceRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type QueryServicesArgs = {
  cursor?: InputMaybe<ServiceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceWhereInput>;
};


export type QueryStayDatesOrFutureAccessGrantsArgs = {
  tenantId?: InputMaybe<Scalars['String']>;
  timezone: Scalars['String'];
};


export type QuerySupplementaryCardArgs = {
  where: SupplementaryCardWhereUniqueInput;
};


export type QuerySupplementaryCardsArgs = {
  cursor?: InputMaybe<SupplementaryCardWhereUniqueInput>;
  distinct?: InputMaybe<Array<SupplementaryCardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SupplementaryCardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


export type QueryTenantArgs = {
  where: TenantWhereUniqueInput;
};


export type QueryTenantsArgs = {
  cursor?: InputMaybe<TenantWhereUniqueInput>;
  distinct?: InputMaybe<Array<TenantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<TenantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TenantWhereInput>;
};


export type QueryThemeArgs = {
  where: ThemeWhereUniqueInput;
};


export type QueryThemesArgs = {
  cursor?: InputMaybe<ThemeWhereUniqueInput>;
  distinct?: InputMaybe<Array<ThemeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ThemeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ThemeWhereInput>;
};


export type QueryUnitTypeArgs = {
  where: UnitTypeWhereUniqueInput;
};


export type QueryUnitTypesArgs = {
  cursor?: InputMaybe<UnitTypeWhereUniqueInput>;
  distinct?: InputMaybe<Array<UnitTypeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UnitTypeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitTypeWhereInput>;
};


export type QueryUserArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryUserPushNotificationTokenArgs = {
  where: UserPushNotificationTokenWhereUniqueInput;
};


export type QueryUserPushNotificationTokensArgs = {
  cursor?: InputMaybe<UserPushNotificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPushNotificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPushNotificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type QueryUserRecordArgs = {
  where: UserRecordWhereUniqueInput;
};


export type QueryUserRecordsArgs = {
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type QueryUsersArgs = {
  cursor?: InputMaybe<UserWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
};


export type QueryValidateIdOnSimplifiedAuthArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  expireDate?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
};


export type QueryVendorServerArgs = {
  where: VendorServerWhereUniqueInput;
};


export type QueryVendorServersArgs = {
  cursor?: InputMaybe<VendorServerWhereUniqueInput>;
  distinct?: InputMaybe<Array<VendorServerScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<VendorServerOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VendorServerWhereInput>;
};


export type QueryVerifyIdArgs = {
  accessGrantId?: InputMaybe<Scalars['String']>;
  authToken?: InputMaybe<Scalars['String']>;
  callbackDate?: InputMaybe<Scalars['String']>;
  callBackType?: InputMaybe<Scalars['String']>;
  customerId?: InputMaybe<Scalars['String']>;
  dateOfBirth?: InputMaybe<Scalars['String']>;
  expireDate?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  idDob?: InputMaybe<Scalars['String']>;
  identityVerification?: InputMaybe<Scalars['String']>;
  idFirstName?: InputMaybe<Scalars['String']>;
  idLastName?: InputMaybe<Scalars['String']>;
  idScanSource?: InputMaybe<Scalars['String']>;
  idScanStatus?: InputMaybe<Scalars['String']>;
  jumioIdScanReference?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  merchantIdScanReference?: InputMaybe<Scalars['String']>;
  merchantReportingCriteria?: InputMaybe<Scalars['String']>;
  redirectUri?: InputMaybe<Scalars['String']>;
  rejectReason?: InputMaybe<Scalars['String']>;
  transactionDate?: InputMaybe<Scalars['String']>;
  vendor: Scalars['String'];
  verificationStatus?: InputMaybe<Scalars['String']>;
  workflowExecutionUrl?: InputMaybe<Scalars['String']>;
};

export enum QueryMode {
  Default = 'default',
  Insensitive = 'insensitive'
}

export type QuickActionBarPreferences = {
  actions?: Maybe<ActionBarCtAs>;
  enabled?: Maybe<Scalars['Boolean']>;
};

export type Registration = {
  deviceId: Scalars['String'];
  id: Scalars['String'];
  pushToken: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type RegistrationCountAggregate = {
  _all: Scalars['Int'];
  deviceId: Scalars['Int'];
  id: Scalars['Int'];
  pushToken: Scalars['Int'];
  serialNumber: Scalars['Int'];
};

export type RegistrationCountOrderByAggregateInput = {
  deviceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pushToken?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
};

export type RegistrationCreateInput = {
  deviceId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  pushToken: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type RegistrationCreateManyInput = {
  deviceId: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  pushToken: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type RegistrationGroupBy = {
  _count?: Maybe<RegistrationCountAggregate>;
  _max?: Maybe<RegistrationMaxAggregate>;
  _min?: Maybe<RegistrationMinAggregate>;
  deviceId: Scalars['String'];
  id: Scalars['String'];
  pushToken: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type RegistrationMaxAggregate = {
  deviceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type RegistrationMaxOrderByAggregateInput = {
  deviceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pushToken?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
};

export type RegistrationMinAggregate = {
  deviceId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  pushToken?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type RegistrationMinOrderByAggregateInput = {
  deviceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pushToken?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
};

export type RegistrationOrderByWithAggregationInput = {
  _count?: InputMaybe<RegistrationCountOrderByAggregateInput>;
  _max?: InputMaybe<RegistrationMaxOrderByAggregateInput>;
  _min?: InputMaybe<RegistrationMinOrderByAggregateInput>;
  deviceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pushToken?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
};

export type RegistrationOrderByWithRelationInput = {
  deviceId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  pushToken?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
};

export enum RegistrationScalarFieldEnum {
  DeviceId = 'deviceId',
  Id = 'id',
  PushToken = 'pushToken',
  SerialNumber = 'serialNumber'
}

export type RegistrationScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<RegistrationScalarWhereWithAggregatesInput>>;
  deviceId?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<RegistrationScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<RegistrationScalarWhereWithAggregatesInput>>;
  pushToken?: InputMaybe<StringWithAggregatesFilter>;
  serialNumber?: InputMaybe<StringWithAggregatesFilter>;
};

export type RegistrationUpdateInput = {
  deviceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pushToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegistrationUpdateManyMutationInput = {
  deviceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  pushToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type RegistrationWhereInput = {
  AND?: InputMaybe<Array<RegistrationWhereInput>>;
  deviceId?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<RegistrationWhereInput>>;
  OR?: InputMaybe<Array<RegistrationWhereInput>>;
  pushToken?: InputMaybe<StringFilter>;
  serialNumber?: InputMaybe<StringFilter>;
};

export type RegistrationWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ReportingServices = {
  reportTitle: Scalars['String'];
  reportUrl: Scalars['String'];
};

export type Requirement = {
  _count?: Maybe<RequirementCount>;
  AccessGrant: AccessGrant;
  accessGrantId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  files: Array<FileToEntity>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  rejectReasonCode?: Maybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt: Scalars['DateTime'];
};


export type RequirementFilesArgs = {
  cursor?: InputMaybe<FileToEntityWhereUniqueInput>;
  distinct?: InputMaybe<Array<FileToEntityScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<FileToEntityOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<FileToEntityWhereInput>;
};

export type RequirementCount = {
  files: Scalars['Int'];
};


export type RequirementCountFilesArgs = {
  where?: InputMaybe<FileToEntityWhereInput>;
};

export type RequirementCountAggregate = {
  _all: Scalars['Int'];
  accessGrantId: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  metadata: Scalars['Int'];
  rejectReasonCode: Scalars['Int'];
  status: Scalars['Int'];
  type: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type RequirementCountOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  rejectReasonCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RequirementCreateInput = {
  AccessGrant: AccessGrantCreateNestedOneWithoutRequirementsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileToEntityCreateNestedManyWithoutRequirementInput>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RequirementCreateManyAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RequirementCreateManyAccessGrantInputEnvelope = {
  data: Array<RequirementCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type RequirementCreateManyInput = {
  accessGrantId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RequirementCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<RequirementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequirementCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<RequirementCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<RequirementCreateManyAccessGrantInputEnvelope>;
};

export type RequirementCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<RequirementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RequirementCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<RequirementCreateWithoutFilesInput>;
};

export type RequirementCreateOrConnectWithoutAccessGrantInput = {
  create: RequirementCreateWithoutAccessGrantInput;
  where: RequirementWhereUniqueInput;
};

export type RequirementCreateOrConnectWithoutFilesInput = {
  create: RequirementCreateWithoutFilesInput;
  where: RequirementWhereUniqueInput;
};

export type RequirementCreateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileToEntityCreateNestedManyWithoutRequirementInput>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RequirementCreateWithoutFilesInput = {
  AccessGrant: AccessGrantCreateNestedOneWithoutRequirementsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type RequirementGroupBy = {
  _count?: Maybe<RequirementCountAggregate>;
  _max?: Maybe<RequirementMaxAggregate>;
  _min?: Maybe<RequirementMinAggregate>;
  accessGrantId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  rejectReasonCode?: Maybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt: Scalars['DateTime'];
};

export type RequirementListRelationFilter = {
  every?: InputMaybe<RequirementWhereInput>;
  none?: InputMaybe<RequirementWhereInput>;
  some?: InputMaybe<RequirementWhereInput>;
};

export type RequirementMaxAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rejectReasonCode?: Maybe<Scalars['String']>;
  status?: Maybe<RequirementStatus>;
  type?: Maybe<RequirementType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequirementMaxOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rejectReasonCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RequirementMinAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  rejectReasonCode?: Maybe<Scalars['String']>;
  status?: Maybe<RequirementStatus>;
  type?: Maybe<RequirementType>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type RequirementMinOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  rejectReasonCode?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RequirementOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type RequirementOrderByWithAggregationInput = {
  _count?: InputMaybe<RequirementCountOrderByAggregateInput>;
  _max?: InputMaybe<RequirementMaxOrderByAggregateInput>;
  _min?: InputMaybe<RequirementMinOrderByAggregateInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  rejectReasonCode?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RequirementOrderByWithRelationInput = {
  AccessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  files?: InputMaybe<FileToEntityOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  rejectReasonCode?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type RequirementRelationFilter = {
  is?: InputMaybe<RequirementWhereInput>;
  isNot?: InputMaybe<RequirementWhereInput>;
};

export enum RequirementScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Metadata = 'metadata',
  RejectReasonCode = 'rejectReasonCode',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt'
}

export type RequirementScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<RequirementScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<RequirementScalarWhereInput>>;
  OR?: InputMaybe<Array<RequirementScalarWhereInput>>;
  rejectReasonCode?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumRequirementStatusFilter>;
  type?: InputMaybe<EnumRequirementTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RequirementScalarWhereWithAggregatesInput = {
  accessGrantId?: InputMaybe<StringWithAggregatesFilter>;
  AND?: InputMaybe<Array<RequirementScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<RequirementScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<RequirementScalarWhereWithAggregatesInput>>;
  rejectReasonCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  status?: InputMaybe<EnumRequirementStatusWithAggregatesFilter>;
  type?: InputMaybe<EnumRequirementTypeWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum RequirementStatus {
  Completed = 'COMPLETED',
  ContactUser = 'CONTACT_USER',
  Failed = 'FAILED',
  NotRequired = 'NOT_REQUIRED',
  Processing = 'PROCESSING',
  Redo = 'REDO',
  Required = 'REQUIRED',
  VerifyInformation = 'VERIFY_INFORMATION'
}

export enum RequirementType {
  BusinessIdVerification = 'BUSINESS_ID_VERIFICATION',
  CaptureSecurityDeposit = 'CAPTURE_SECURITY_DEPOSIT',
  FaceMatch = 'FACE_MATCH',
  HealthCheck = 'HEALTH_CHECK',
  IdVerification = 'ID_VERIFICATION',
  ManualCheckIn = 'MANUAL_CHECK_IN',
  MatchNames = 'MATCH_NAMES',
  MrzIdVerification = 'MRZ_ID_VERIFICATION',
  PaymentAuthorization = 'PAYMENT_AUTHORIZATION',
  PaymentCapture = 'PAYMENT_CAPTURE',
  PaymentStatus = 'PAYMENT_STATUS',
  PmsConfirmation = 'PMS_CONFIRMATION',
  TermsAndConditionsConfirmation = 'TERMS_AND_CONDITIONS_CONFIRMATION',
  UserInformation = 'USER_INFORMATION'
}

export type RequirementTypeAccessGrantIdCompoundUniqueInput = {
  accessGrantId: Scalars['String'];
  type: RequirementType;
};

export type RequirementUpdateInput = {
  AccessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutRequirementsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileToEntityUpdateManyWithoutRequirementNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRequirementStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequirementUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRequirementStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequirementUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<RequirementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<RequirementCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<RequirementCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<RequirementCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<RequirementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<RequirementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<RequirementWhereUniqueInput>>;
  set?: InputMaybe<Array<RequirementWhereUniqueInput>>;
  update?: InputMaybe<Array<RequirementUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<RequirementUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<RequirementUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type RequirementUpdateManyWithWhereWithoutAccessGrantInput = {
  data: RequirementUpdateManyMutationInput;
  where: RequirementScalarWhereInput;
};

export type RequirementUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<RequirementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<RequirementCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<RequirementCreateWithoutFilesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<RequirementUpdateWithoutFilesInput>;
  upsert?: InputMaybe<RequirementUpsertWithoutFilesInput>;
};

export type RequirementUpdateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileToEntityUpdateManyWithoutRequirementNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRequirementStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequirementUpdateWithoutFilesInput = {
  AccessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutRequirementsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRequirementStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type RequirementUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: RequirementUpdateWithoutAccessGrantInput;
  where: RequirementWhereUniqueInput;
};

export type RequirementUpsertWithoutFilesInput = {
  create: RequirementCreateWithoutFilesInput;
  update: RequirementUpdateWithoutFilesInput;
};

export type RequirementUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: RequirementCreateWithoutAccessGrantInput;
  update: RequirementUpdateWithoutAccessGrantInput;
  where: RequirementWhereUniqueInput;
};

export type RequirementWhereInput = {
  AccessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<RequirementWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  files?: InputMaybe<FileToEntityListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<RequirementWhereInput>>;
  OR?: InputMaybe<Array<RequirementWhereInput>>;
  rejectReasonCode?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumRequirementStatusFilter>;
  type?: InputMaybe<EnumRequirementTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type RequirementWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  type_accessGrantId?: InputMaybe<RequirementTypeAccessGrantIdCompoundUniqueInput>;
};

export type ReservationConfigResponse = {
  allowEarlyCheckin?: Maybe<Scalars['Boolean']>;
  allowScheduledCheckin?: Maybe<Scalars['Boolean']>;
  enableLiveUsageEvents?: Maybe<Scalars['Boolean']>;
  hasPackagesFeature?: Maybe<Scalars['Boolean']>;
  maxIdvRetries?: Maybe<Scalars['Float']>;
  retryPaymentRequirement?: Maybe<RetryPaymentRequirement>;
};

export type ReservationInfo = {
  _count?: Maybe<AccessGrantCount>;
  AccessGrantResId: Array<AccessGrantResId>;
  address?: Maybe<Scalars['String']>;
  arrivalTime?: Maybe<Scalars['String']>;
  callRecords: Array<CallRecord>;
  checkIn: Scalars['String'];
  checkOut: Scalars['String'];
  code?: Maybe<Scalars['String']>;
  confirmationCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  credentials: Array<Credential>;
  deeplink?: Maybe<Scalars['String']>;
  deviceRegistrations: Array<DeviceRegistration>;
  endDate?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: Maybe<Scalars['String']>;
  floorPlan?: Maybe<Scalars['String']>;
  gotCODResponse?: Maybe<Scalars['Boolean']>;
  gracePeriods?: Maybe<Scalars['JSON']>;
  grandTotal?: Maybe<Scalars['String']>;
  housekeepingDate?: Maybe<Scalars['DateTime']>;
  housekeepingRRule?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idVerification: IdVerification;
  idVerificationResult?: Maybe<IdVerificationResult>;
  idVerificationResultId?: Maybe<Scalars['String']>;
  infos: Array<InfoItem>;
  lastPolledAt?: Maybe<Scalars['DateTime']>;
  location: Location;
  locationId: Scalars['String'];
  maxKeys?: Maybe<Scalars['Int']>;
  metadata: Scalars['JSON'];
  noticeDate?: Maybe<Scalars['DateTime']>;
  notifications: Array<Notification>;
  numKeysDispensed?: Maybe<Scalars['Int']>;
  overrides: Array<Override>;
  passes: Array<Pass>;
  paymentTransactions: Array<PaymentTransaction>;
  pretaxTotal?: Maybe<Scalars['String']>;
  qrCodeImageUrl?: Maybe<Scalars['String']>;
  requirements: Array<Requirement>;
  resources: Array<Resource>;
  retryCheckin?: Maybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: Maybe<Scalars['DateTime']>;
  roomNumber?: Maybe<Scalars['String']>;
  roomType: Scalars['String'];
  secondaryUsers: Array<SecondaryUsersOnAccessGrants>;
  serviceRequests: Array<ServiceRequest>;
  startDate?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  startTime?: Maybe<Scalars['String']>;
  state?: Maybe<AccessGrantState>;
  status: AccessGrantStatus;
  supplementaryCards: Array<SupplementaryCard>;
  tax?: Maybe<Scalars['String']>;
  tenant: Tenant;
  tenantId: Scalars['String'];
  type: AccessGrantType;
  uidOnLocation?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  user: User;
  UserAccessGrantRequirement: Array<UserAccessGrantRequirement>;
  userId: Scalars['String'];
};


export type ReservationInfoAccessGrantResIdArgs = {
  cursor?: InputMaybe<AccessGrantResIdWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantResIdScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantResIdOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantResIdWhereInput>;
};


export type ReservationInfoCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type ReservationInfoCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type ReservationInfoDeviceRegistrationsArgs = {
  cursor?: InputMaybe<DeviceRegistrationWhereUniqueInput>;
  distinct?: InputMaybe<Array<DeviceRegistrationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DeviceRegistrationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DeviceRegistrationWhereInput>;
};


export type ReservationInfoInfosArgs = {
  cursor?: InputMaybe<InfoItemWhereUniqueInput>;
  distinct?: InputMaybe<Array<InfoItemScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
};


export type ReservationInfoNotificationsArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type ReservationInfoOverridesArgs = {
  cursor?: InputMaybe<OverrideWhereUniqueInput>;
  distinct?: InputMaybe<Array<OverrideScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OverrideOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OverrideWhereInput>;
};


export type ReservationInfoPassesArgs = {
  cursor?: InputMaybe<PassWhereUniqueInput>;
  distinct?: InputMaybe<Array<PassScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PassOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PassWhereInput>;
};


export type ReservationInfoPaymentTransactionsArgs = {
  cursor?: InputMaybe<PaymentTransactionWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentTransactionScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentTransactionOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentTransactionWhereInput>;
};


export type ReservationInfoRequirementsArgs = {
  cursor?: InputMaybe<RequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<RequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
};


export type ReservationInfoResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type ReservationInfoSecondaryUsersArgs = {
  cursor?: InputMaybe<SecondaryUsersOnAccessGrantsWhereUniqueInput>;
  distinct?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SecondaryUsersOnAccessGrantsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
};


export type ReservationInfoServiceRequestsArgs = {
  cursor?: InputMaybe<ServiceRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type ReservationInfoSupplementaryCardsArgs = {
  cursor?: InputMaybe<SupplementaryCardWhereUniqueInput>;
  distinct?: InputMaybe<Array<SupplementaryCardScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SupplementaryCardOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SupplementaryCardWhereInput>;
};


export type ReservationInfoUserAccessGrantRequirementArgs = {
  cursor?: InputMaybe<UserAccessGrantRequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAccessGrantRequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAccessGrantRequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};

/** An entity present at a location that a `User` can be granted access to. */
export type Resource = {
  _count?: Maybe<ResourceCount>;
  accessGrants: Array<AccessGrant>;
  address?: Maybe<Scalars['String']>;
  building?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  controlType?: Maybe<ResourceControlType>;
  createdAt: Scalars['DateTime'];
  defaultEnd: Scalars['String'];
  defaultStart: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  isComponentRoom?: Maybe<Scalars['Boolean']>;
  location: Location;
  locationId: Scalars['String'];
  name: Scalars['String'];
  Override: Array<Override>;
  passLevel?: Maybe<Scalars['Int']>;
  pmsId?: Maybe<Scalars['String']>;
  resourceGroups: Array<ResourceGroup>;
  tenant: Tenant;
  tenantId: Scalars['String'];
  type: ResourceType;
  unitType?: Maybe<UnitType>;
  unitTypeId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vendor: ResourceVendor;
  vendorId?: Maybe<Scalars['String']>;
};


/** An entity present at a location that a `User` can be granted access to. */
export type ResourceAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


/** An entity present at a location that a `User` can be granted access to. */
export type ResourceOverrideArgs = {
  cursor?: InputMaybe<OverrideWhereUniqueInput>;
  distinct?: InputMaybe<Array<OverrideScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<OverrideOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<OverrideWhereInput>;
};


/** An entity present at a location that a `User` can be granted access to. */
export type ResourceResourceGroupsArgs = {
  cursor?: InputMaybe<ResourceGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
};

export type ResourceAvgAggregate = {
  passLevel?: Maybe<Scalars['Float']>;
};

export type ResourceAvgOrderByAggregateInput = {
  passLevel?: InputMaybe<SortOrder>;
};

export enum ResourceControlType {
  Automatic = 'AUTOMATIC',
  Manual = 'MANUAL'
}

export type ResourceCount = {
  accessGrants: Scalars['Int'];
  Override: Scalars['Int'];
  resourceGroups: Scalars['Int'];
};


export type ResourceCountAccessGrantsArgs = {
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type ResourceCountOverrideArgs = {
  where?: InputMaybe<OverrideWhereInput>;
};


export type ResourceCountResourceGroupsArgs = {
  where?: InputMaybe<ResourceGroupWhereInput>;
};

export type ResourceCountAggregate = {
  _all: Scalars['Int'];
  address: Scalars['Int'];
  building: Scalars['Int'];
  code: Scalars['Int'];
  controlType: Scalars['Int'];
  createdAt: Scalars['Int'];
  defaultEnd: Scalars['Int'];
  defaultStart: Scalars['Int'];
  description: Scalars['Int'];
  floor: Scalars['Int'];
  id: Scalars['Int'];
  imageUrl: Scalars['Int'];
  isComponentRoom: Scalars['Int'];
  locationId: Scalars['Int'];
  name: Scalars['Int'];
  passLevel: Scalars['Int'];
  pmsId: Scalars['Int'];
  tenantId: Scalars['Int'];
  type: Scalars['Int'];
  unitTypeId: Scalars['Int'];
  updatedAt: Scalars['Int'];
  vendor: Scalars['Int'];
  vendorId: Scalars['Int'];
};

export type ResourceCountOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  building?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  controlType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEnd?: InputMaybe<SortOrder>;
  defaultStart?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  floor?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  isComponentRoom?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  passLevel?: InputMaybe<SortOrder>;
  pmsId?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unitTypeId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
  vendorId?: InputMaybe<SortOrder>;
};

export type ResourceCreateInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutResourcesInput>;
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourcesInput;
  name: Scalars['String'];
  Override?: InputMaybe<OverrideCreateNestedManyWithoutResourceInput>;
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutResourcesInput>;
  tenant: TenantCreateNestedOneWithoutResourcesInput;
  type?: InputMaybe<ResourceType>;
  unitType?: InputMaybe<UnitTypeCreateNestedOneWithoutResourcesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateManyInput = {
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type?: InputMaybe<ResourceType>;
  unitTypeId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateManyLocationInput = {
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type?: InputMaybe<ResourceType>;
  unitTypeId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateManyLocationInputEnvelope = {
  data: Array<ResourceCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceCreateManyTenantInput = {
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<ResourceType>;
  unitTypeId?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateManyTenantInputEnvelope = {
  data: Array<ResourceCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceCreateManyUnitTypeInput = {
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type?: InputMaybe<ResourceType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateManyUnitTypeInputEnvelope = {
  data: Array<ResourceCreateManyUnitTypeInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceCreateNestedManyWithoutAccessGrantsInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutAccessGrantsInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutAccessGrantsInput>>;
};

export type ResourceCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutLocationInput>>;
  createMany?: InputMaybe<ResourceCreateManyLocationInputEnvelope>;
};

export type ResourceCreateNestedManyWithoutResourceGroupsInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutResourceGroupsInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutResourceGroupsInput>>;
};

export type ResourceCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutTenantInput>>;
  createMany?: InputMaybe<ResourceCreateManyTenantInputEnvelope>;
};

export type ResourceCreateNestedManyWithoutUnitTypeInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutUnitTypeInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutUnitTypeInput>>;
  createMany?: InputMaybe<ResourceCreateManyUnitTypeInputEnvelope>;
};

export type ResourceCreateNestedOneWithoutOverrideInput = {
  connect?: InputMaybe<ResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceCreateOrConnectWithoutOverrideInput>;
  create?: InputMaybe<ResourceCreateWithoutOverrideInput>;
};

export type ResourceCreateOrConnectWithoutAccessGrantsInput = {
  create: ResourceCreateWithoutAccessGrantsInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateOrConnectWithoutLocationInput = {
  create: ResourceCreateWithoutLocationInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateOrConnectWithoutOverrideInput = {
  create: ResourceCreateWithoutOverrideInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateOrConnectWithoutResourceGroupsInput = {
  create: ResourceCreateWithoutResourceGroupsInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateOrConnectWithoutTenantInput = {
  create: ResourceCreateWithoutTenantInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateOrConnectWithoutUnitTypeInput = {
  create: ResourceCreateWithoutUnitTypeInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceCreateWithoutAccessGrantsInput = {
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourcesInput;
  name: Scalars['String'];
  Override?: InputMaybe<OverrideCreateNestedManyWithoutResourceInput>;
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutResourcesInput>;
  tenant: TenantCreateNestedOneWithoutResourcesInput;
  type?: InputMaybe<ResourceType>;
  unitType?: InputMaybe<UnitTypeCreateNestedOneWithoutResourcesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateWithoutLocationInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutResourcesInput>;
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  Override?: InputMaybe<OverrideCreateNestedManyWithoutResourceInput>;
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutResourcesInput>;
  tenant: TenantCreateNestedOneWithoutResourcesInput;
  type?: InputMaybe<ResourceType>;
  unitType?: InputMaybe<UnitTypeCreateNestedOneWithoutResourcesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateWithoutOverrideInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutResourcesInput>;
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourcesInput;
  name: Scalars['String'];
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutResourcesInput>;
  tenant: TenantCreateNestedOneWithoutResourcesInput;
  type?: InputMaybe<ResourceType>;
  unitType?: InputMaybe<UnitTypeCreateNestedOneWithoutResourcesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateWithoutResourceGroupsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutResourcesInput>;
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourcesInput;
  name: Scalars['String'];
  Override?: InputMaybe<OverrideCreateNestedManyWithoutResourceInput>;
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  tenant: TenantCreateNestedOneWithoutResourcesInput;
  type?: InputMaybe<ResourceType>;
  unitType?: InputMaybe<UnitTypeCreateNestedOneWithoutResourcesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateWithoutTenantInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutResourcesInput>;
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourcesInput;
  name: Scalars['String'];
  Override?: InputMaybe<OverrideCreateNestedManyWithoutResourceInput>;
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutResourcesInput>;
  type?: InputMaybe<ResourceType>;
  unitType?: InputMaybe<UnitTypeCreateNestedOneWithoutResourcesInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

export type ResourceCreateWithoutUnitTypeInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutResourcesInput>;
  address?: InputMaybe<Scalars['String']>;
  building?: InputMaybe<Scalars['String']>;
  code?: InputMaybe<Scalars['String']>;
  controlType?: InputMaybe<ResourceControlType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  defaultEnd?: InputMaybe<Scalars['String']>;
  defaultStart?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  floor?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  isComponentRoom?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourcesInput;
  name: Scalars['String'];
  Override?: InputMaybe<OverrideCreateNestedManyWithoutResourceInput>;
  passLevel?: InputMaybe<Scalars['Int']>;
  pmsId?: InputMaybe<Scalars['String']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutResourcesInput>;
  tenant: TenantCreateNestedOneWithoutResourcesInput;
  type?: InputMaybe<ResourceType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  vendor: ResourceVendor;
  vendorId?: InputMaybe<Scalars['String']>;
};

/** A logical grouping of `Resource` entities, like "Common Spaces" or "Building Exteriors" */
export type ResourceGroup = {
  _count?: Maybe<ResourceGroupCount>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  location: Location;
  locationId: Scalars['String'];
  name: Scalars['String'];
  resources: Array<Resource>;
  tenant: Tenant;
  tenantId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};


/** A logical grouping of `Resource` entities, like "Common Spaces" or "Building Exteriors" */
export type ResourceGroupResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};

export type ResourceGroupBy = {
  _avg?: Maybe<ResourceAvgAggregate>;
  _count?: Maybe<ResourceCountAggregate>;
  _max?: Maybe<ResourceMaxAggregate>;
  _min?: Maybe<ResourceMinAggregate>;
  _sum?: Maybe<ResourceSumAggregate>;
  address?: Maybe<Scalars['String']>;
  building?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  controlType?: Maybe<ResourceControlType>;
  createdAt: Scalars['DateTime'];
  defaultEnd: Scalars['String'];
  defaultStart: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl?: Maybe<Scalars['String']>;
  isComponentRoom?: Maybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  passLevel?: Maybe<Scalars['Int']>;
  pmsId?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  type: ResourceType;
  unitTypeId?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
  vendor: ResourceVendor;
  vendorId?: Maybe<Scalars['String']>;
};

export type ResourceGroupCount = {
  resources: Scalars['Int'];
};


export type ResourceGroupCountResourcesArgs = {
  where?: InputMaybe<ResourceWhereInput>;
};

export type ResourceGroupCountAggregate = {
  _all: Scalars['Int'];
  createdAt: Scalars['Int'];
  id: Scalars['Int'];
  isDefault: Scalars['Int'];
  locationId: Scalars['Int'];
  name: Scalars['Int'];
  tenantId: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ResourceGroupCountOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ResourceGroupCreateInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourceGroupsInput;
  name: Scalars['String'];
  resources?: InputMaybe<ResourceCreateNestedManyWithoutResourceGroupsInput>;
  tenant: TenantCreateNestedOneWithoutResourceGroupsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResourceGroupCreateManyInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResourceGroupCreateManyLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResourceGroupCreateManyLocationInputEnvelope = {
  data: Array<ResourceGroupCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceGroupCreateManyTenantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  locationId: Scalars['String'];
  name: Scalars['String'];
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResourceGroupCreateManyTenantInputEnvelope = {
  data: Array<ResourceGroupCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ResourceGroupCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceGroupCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<ResourceGroupCreateWithoutLocationInput>>;
  createMany?: InputMaybe<ResourceGroupCreateManyLocationInputEnvelope>;
};

export type ResourceGroupCreateNestedManyWithoutResourcesInput = {
  connect?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceGroupCreateOrConnectWithoutResourcesInput>>;
  create?: InputMaybe<Array<ResourceGroupCreateWithoutResourcesInput>>;
};

export type ResourceGroupCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceGroupCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<ResourceGroupCreateWithoutTenantInput>>;
  createMany?: InputMaybe<ResourceGroupCreateManyTenantInputEnvelope>;
};

export type ResourceGroupCreateOrConnectWithoutLocationInput = {
  create: ResourceGroupCreateWithoutLocationInput;
  where: ResourceGroupWhereUniqueInput;
};

export type ResourceGroupCreateOrConnectWithoutResourcesInput = {
  create: ResourceGroupCreateWithoutResourcesInput;
  where: ResourceGroupWhereUniqueInput;
};

export type ResourceGroupCreateOrConnectWithoutTenantInput = {
  create: ResourceGroupCreateWithoutTenantInput;
  where: ResourceGroupWhereUniqueInput;
};

export type ResourceGroupCreateWithoutLocationInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  resources?: InputMaybe<ResourceCreateNestedManyWithoutResourceGroupsInput>;
  tenant: TenantCreateNestedOneWithoutResourceGroupsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResourceGroupCreateWithoutResourcesInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourceGroupsInput;
  name: Scalars['String'];
  tenant: TenantCreateNestedOneWithoutResourceGroupsInput;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResourceGroupCreateWithoutTenantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  isDefault?: InputMaybe<Scalars['Boolean']>;
  location: LocationCreateNestedOneWithoutResourceGroupsInput;
  name: Scalars['String'];
  resources?: InputMaybe<ResourceCreateNestedManyWithoutResourceGroupsInput>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ResourceGroupGroupBy = {
  _count?: Maybe<ResourceGroupCountAggregate>;
  _max?: Maybe<ResourceGroupMaxAggregate>;
  _min?: Maybe<ResourceGroupMinAggregate>;
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  isDefault: Scalars['Boolean'];
  locationId: Scalars['String'];
  name: Scalars['String'];
  tenantId: Scalars['String'];
  updatedAt: Scalars['DateTime'];
};

export type ResourceGroupListRelationFilter = {
  every?: InputMaybe<ResourceGroupWhereInput>;
  none?: InputMaybe<ResourceGroupWhereInput>;
  some?: InputMaybe<ResourceGroupWhereInput>;
};

export type ResourceGroupMaxAggregate = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ResourceGroupMaxOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ResourceGroupMinAggregate = {
  createdAt?: Maybe<Scalars['DateTime']>;
  id?: Maybe<Scalars['String']>;
  isDefault?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ResourceGroupMinOrderByAggregateInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ResourceGroupNameLocationIdCompoundUniqueInput = {
  locationId: Scalars['String'];
  name: Scalars['String'];
};

export type ResourceGroupOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ResourceGroupOrderByWithAggregationInput = {
  _count?: InputMaybe<ResourceGroupCountOrderByAggregateInput>;
  _max?: InputMaybe<ResourceGroupMaxOrderByAggregateInput>;
  _min?: InputMaybe<ResourceGroupMinOrderByAggregateInput>;
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ResourceGroupOrderByWithRelationInput = {
  createdAt?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isDefault?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  resources?: InputMaybe<ResourceOrderByRelationAggregateInput>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ResourceGroupScalarFieldEnum {
  CreatedAt = 'createdAt',
  Id = 'id',
  IsDefault = 'isDefault',
  LocationId = 'locationId',
  Name = 'name',
  TenantId = 'tenantId',
  UpdatedAt = 'updatedAt'
}

export type ResourceGroupScalarWhereInput = {
  AND?: InputMaybe<Array<ResourceGroupScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isDefault?: InputMaybe<BoolFilter>;
  locationId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ResourceGroupScalarWhereInput>>;
  OR?: InputMaybe<Array<ResourceGroupScalarWhereInput>>;
  tenantId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ResourceGroupScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ResourceGroupScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isDefault?: InputMaybe<BoolWithAggregatesFilter>;
  locationId?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<ResourceGroupScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ResourceGroupScalarWhereWithAggregatesInput>>;
  tenantId?: InputMaybe<StringWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export type ResourceGroupUpdateInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourceGroupsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutResourceGroupsNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourceGroupsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResourceGroupUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResourceGroupUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceGroupCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<ResourceGroupCreateWithoutLocationInput>>;
  createMany?: InputMaybe<ResourceGroupCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceGroupUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<ResourceGroupUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<ResourceGroupUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type ResourceGroupUpdateManyWithoutResourcesNestedInput = {
  connect?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceGroupCreateOrConnectWithoutResourcesInput>>;
  create?: InputMaybe<Array<ResourceGroupCreateWithoutResourcesInput>>;
  delete?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceGroupUpdateWithWhereUniqueWithoutResourcesInput>>;
  updateMany?: InputMaybe<Array<ResourceGroupUpdateManyWithWhereWithoutResourcesInput>>;
  upsert?: InputMaybe<Array<ResourceGroupUpsertWithWhereUniqueWithoutResourcesInput>>;
};

export type ResourceGroupUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceGroupCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<ResourceGroupCreateWithoutTenantInput>>;
  createMany?: InputMaybe<ResourceGroupCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceGroupScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceGroupWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceGroupUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<ResourceGroupUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<ResourceGroupUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type ResourceGroupUpdateManyWithWhereWithoutLocationInput = {
  data: ResourceGroupUpdateManyMutationInput;
  where: ResourceGroupScalarWhereInput;
};

export type ResourceGroupUpdateManyWithWhereWithoutResourcesInput = {
  data: ResourceGroupUpdateManyMutationInput;
  where: ResourceGroupScalarWhereInput;
};

export type ResourceGroupUpdateManyWithWhereWithoutTenantInput = {
  data: ResourceGroupUpdateManyMutationInput;
  where: ResourceGroupScalarWhereInput;
};

export type ResourceGroupUpdateWithoutLocationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutResourceGroupsNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourceGroupsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResourceGroupUpdateWithoutResourcesInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourceGroupsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourceGroupsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResourceGroupUpdateWithoutTenantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isDefault?: InputMaybe<BoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourceGroupsNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutResourceGroupsNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ResourceGroupUpdateWithWhereUniqueWithoutLocationInput = {
  data: ResourceGroupUpdateWithoutLocationInput;
  where: ResourceGroupWhereUniqueInput;
};

export type ResourceGroupUpdateWithWhereUniqueWithoutResourcesInput = {
  data: ResourceGroupUpdateWithoutResourcesInput;
  where: ResourceGroupWhereUniqueInput;
};

export type ResourceGroupUpdateWithWhereUniqueWithoutTenantInput = {
  data: ResourceGroupUpdateWithoutTenantInput;
  where: ResourceGroupWhereUniqueInput;
};

export type ResourceGroupUpsertWithWhereUniqueWithoutLocationInput = {
  create: ResourceGroupCreateWithoutLocationInput;
  update: ResourceGroupUpdateWithoutLocationInput;
  where: ResourceGroupWhereUniqueInput;
};

export type ResourceGroupUpsertWithWhereUniqueWithoutResourcesInput = {
  create: ResourceGroupCreateWithoutResourcesInput;
  update: ResourceGroupUpdateWithoutResourcesInput;
  where: ResourceGroupWhereUniqueInput;
};

export type ResourceGroupUpsertWithWhereUniqueWithoutTenantInput = {
  create: ResourceGroupCreateWithoutTenantInput;
  update: ResourceGroupUpdateWithoutTenantInput;
  where: ResourceGroupWhereUniqueInput;
};

export type ResourceGroupWhereInput = {
  AND?: InputMaybe<Array<ResourceGroupWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  isDefault?: InputMaybe<BoolFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ResourceGroupWhereInput>>;
  OR?: InputMaybe<Array<ResourceGroupWhereInput>>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ResourceGroupWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  name_locationId?: InputMaybe<ResourceGroupNameLocationIdCompoundUniqueInput>;
};

export type ResourceListRelationFilter = {
  every?: InputMaybe<ResourceWhereInput>;
  none?: InputMaybe<ResourceWhereInput>;
  some?: InputMaybe<ResourceWhereInput>;
};

export type ResourceMaxAggregate = {
  address?: Maybe<Scalars['String']>;
  building?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  controlType?: Maybe<ResourceControlType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultEnd?: Maybe<Scalars['String']>;
  defaultStart?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isComponentRoom?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  passLevel?: Maybe<Scalars['Int']>;
  pmsId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<ResourceType>;
  unitTypeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vendor?: Maybe<ResourceVendor>;
  vendorId?: Maybe<Scalars['String']>;
};

export type ResourceMaxOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  building?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  controlType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEnd?: InputMaybe<SortOrder>;
  defaultStart?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  floor?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  isComponentRoom?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  passLevel?: InputMaybe<SortOrder>;
  pmsId?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unitTypeId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
  vendorId?: InputMaybe<SortOrder>;
};

export type ResourceMinAggregate = {
  address?: Maybe<Scalars['String']>;
  building?: Maybe<Scalars['String']>;
  code?: Maybe<Scalars['String']>;
  controlType?: Maybe<ResourceControlType>;
  createdAt?: Maybe<Scalars['DateTime']>;
  defaultEnd?: Maybe<Scalars['String']>;
  defaultStart?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  floor?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isComponentRoom?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  passLevel?: Maybe<Scalars['Int']>;
  pmsId?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  type?: Maybe<ResourceType>;
  unitTypeId?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
  vendor?: Maybe<ResourceVendor>;
  vendorId?: Maybe<Scalars['String']>;
};

export type ResourceMinOrderByAggregateInput = {
  address?: InputMaybe<SortOrder>;
  building?: InputMaybe<SortOrder>;
  code?: InputMaybe<SortOrder>;
  controlType?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEnd?: InputMaybe<SortOrder>;
  defaultStart?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  floor?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  isComponentRoom?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  passLevel?: InputMaybe<SortOrder>;
  pmsId?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unitTypeId?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
  vendorId?: InputMaybe<SortOrder>;
};

export type ResourceNameLocationIdCompoundUniqueInput = {
  locationId: Scalars['String'];
  name: Scalars['String'];
};

export type ResourceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ResourceOrderByWithAggregationInput = {
  _avg?: InputMaybe<ResourceAvgOrderByAggregateInput>;
  _count?: InputMaybe<ResourceCountOrderByAggregateInput>;
  _max?: InputMaybe<ResourceMaxOrderByAggregateInput>;
  _min?: InputMaybe<ResourceMinOrderByAggregateInput>;
  _sum?: InputMaybe<ResourceSumOrderByAggregateInput>;
  address?: InputMaybe<SortOrderInput>;
  building?: InputMaybe<SortOrderInput>;
  code?: InputMaybe<SortOrderInput>;
  controlType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEnd?: InputMaybe<SortOrder>;
  defaultStart?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  floor?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  isComponentRoom?: InputMaybe<SortOrderInput>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  passLevel?: InputMaybe<SortOrderInput>;
  pmsId?: InputMaybe<SortOrderInput>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unitTypeId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
  vendorId?: InputMaybe<SortOrderInput>;
};

export type ResourceOrderByWithRelationInput = {
  accessGrants?: InputMaybe<AccessGrantOrderByRelationAggregateInput>;
  address?: InputMaybe<SortOrderInput>;
  building?: InputMaybe<SortOrderInput>;
  code?: InputMaybe<SortOrderInput>;
  controlType?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  defaultEnd?: InputMaybe<SortOrder>;
  defaultStart?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  floor?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrderInput>;
  isComponentRoom?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  Override?: InputMaybe<OverrideOrderByRelationAggregateInput>;
  passLevel?: InputMaybe<SortOrderInput>;
  pmsId?: InputMaybe<SortOrderInput>;
  resourceGroups?: InputMaybe<ResourceGroupOrderByRelationAggregateInput>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  unitType?: InputMaybe<UnitTypeOrderByWithRelationInput>;
  unitTypeId?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
  vendorId?: InputMaybe<SortOrderInput>;
};

export type ResourceRelationFilter = {
  is?: InputMaybe<ResourceWhereInput>;
  isNot?: InputMaybe<ResourceWhereInput>;
};

export enum ResourceScalarFieldEnum {
  Address = 'address',
  Building = 'building',
  Code = 'code',
  ControlType = 'controlType',
  CreatedAt = 'createdAt',
  DefaultEnd = 'defaultEnd',
  DefaultStart = 'defaultStart',
  Description = 'description',
  Floor = 'floor',
  Id = 'id',
  ImageUrl = 'imageUrl',
  IsComponentRoom = 'isComponentRoom',
  LocationId = 'locationId',
  Name = 'name',
  PassLevel = 'passLevel',
  PmsId = 'pmsId',
  TenantId = 'tenantId',
  Type = 'type',
  UnitTypeId = 'unitTypeId',
  UpdatedAt = 'updatedAt',
  Vendor = 'vendor',
  VendorId = 'vendorId'
}

export type ResourceScalarWhereInput = {
  address?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<ResourceScalarWhereInput>>;
  building?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  controlType?: InputMaybe<EnumResourceControlTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultEnd?: InputMaybe<StringFilter>;
  defaultStart?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  floor?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  isComponentRoom?: InputMaybe<BoolNullableFilter>;
  locationId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ResourceScalarWhereInput>>;
  OR?: InputMaybe<Array<ResourceScalarWhereInput>>;
  passLevel?: InputMaybe<IntNullableFilter>;
  pmsId?: InputMaybe<StringNullableFilter>;
  tenantId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumResourceTypeFilter>;
  unitTypeId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendor?: InputMaybe<EnumResourceVendorFilter>;
  vendorId?: InputMaybe<StringNullableFilter>;
};

export type ResourceScalarWhereWithAggregatesInput = {
  address?: InputMaybe<StringNullableWithAggregatesFilter>;
  AND?: InputMaybe<Array<ResourceScalarWhereWithAggregatesInput>>;
  building?: InputMaybe<StringNullableWithAggregatesFilter>;
  code?: InputMaybe<StringNullableWithAggregatesFilter>;
  controlType?: InputMaybe<EnumResourceControlTypeNullableWithAggregatesFilter>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  defaultEnd?: InputMaybe<StringWithAggregatesFilter>;
  defaultStart?: InputMaybe<StringWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  floor?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  isComponentRoom?: InputMaybe<BoolNullableWithAggregatesFilter>;
  locationId?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<ResourceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ResourceScalarWhereWithAggregatesInput>>;
  passLevel?: InputMaybe<IntNullableWithAggregatesFilter>;
  pmsId?: InputMaybe<StringNullableWithAggregatesFilter>;
  tenantId?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumResourceTypeWithAggregatesFilter>;
  unitTypeId?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  vendor?: InputMaybe<EnumResourceVendorWithAggregatesFilter>;
  vendorId?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export type ResourceSearchInput = {
  locationId?: InputMaybe<Scalars['String']>;
  pmsId?: InputMaybe<Scalars['String']>;
};

export type ResourceSumAggregate = {
  passLevel?: Maybe<Scalars['Int']>;
};

export type ResourceSumOrderByAggregateInput = {
  passLevel?: InputMaybe<SortOrder>;
};

export enum ResourceType {
  Door = 'DOOR',
  Lock = 'LOCK',
  Reader = 'READER',
  Relay = 'RELAY',
  Zone = 'ZONE'
}

export type ResourceUpdateInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutResourcesNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  building?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  controlType?: InputMaybe<NullableEnumResourceControlTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEnd?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultStart?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isComponentRoom?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourcesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Override?: InputMaybe<OverrideUpdateManyWithoutResourceNestedInput>;
  passLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutResourcesNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourcesNestedInput>;
  type?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  unitType?: InputMaybe<UnitTypeUpdateOneWithoutResourcesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
  vendorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ResourceUpdateManyMutationInput = {
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  building?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  controlType?: InputMaybe<NullableEnumResourceControlTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEnd?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultStart?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isComponentRoom?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  passLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
  vendorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ResourceUpdateManyWithoutAccessGrantsNestedInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutAccessGrantsInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutAccessGrantsInput>>;
  delete?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceUpdateWithWhereUniqueWithoutAccessGrantsInput>>;
  updateMany?: InputMaybe<Array<ResourceUpdateManyWithWhereWithoutAccessGrantsInput>>;
  upsert?: InputMaybe<Array<ResourceUpsertWithWhereUniqueWithoutAccessGrantsInput>>;
};

export type ResourceUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutLocationInput>>;
  createMany?: InputMaybe<ResourceCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<ResourceUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<ResourceUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type ResourceUpdateManyWithoutResourceGroupsNestedInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutResourceGroupsInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutResourceGroupsInput>>;
  delete?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceUpdateWithWhereUniqueWithoutResourceGroupsInput>>;
  updateMany?: InputMaybe<Array<ResourceUpdateManyWithWhereWithoutResourceGroupsInput>>;
  upsert?: InputMaybe<Array<ResourceUpsertWithWhereUniqueWithoutResourceGroupsInput>>;
};

export type ResourceUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutTenantInput>>;
  createMany?: InputMaybe<ResourceCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<ResourceUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<ResourceUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type ResourceUpdateManyWithoutUnitTypeNestedInput = {
  connect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ResourceCreateOrConnectWithoutUnitTypeInput>>;
  create?: InputMaybe<Array<ResourceCreateWithoutUnitTypeInput>>;
  createMany?: InputMaybe<ResourceCreateManyUnitTypeInputEnvelope>;
  delete?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ResourceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  set?: InputMaybe<Array<ResourceWhereUniqueInput>>;
  update?: InputMaybe<Array<ResourceUpdateWithWhereUniqueWithoutUnitTypeInput>>;
  updateMany?: InputMaybe<Array<ResourceUpdateManyWithWhereWithoutUnitTypeInput>>;
  upsert?: InputMaybe<Array<ResourceUpsertWithWhereUniqueWithoutUnitTypeInput>>;
};

export type ResourceUpdateManyWithWhereWithoutAccessGrantsInput = {
  data: ResourceUpdateManyMutationInput;
  where: ResourceScalarWhereInput;
};

export type ResourceUpdateManyWithWhereWithoutLocationInput = {
  data: ResourceUpdateManyMutationInput;
  where: ResourceScalarWhereInput;
};

export type ResourceUpdateManyWithWhereWithoutResourceGroupsInput = {
  data: ResourceUpdateManyMutationInput;
  where: ResourceScalarWhereInput;
};

export type ResourceUpdateManyWithWhereWithoutTenantInput = {
  data: ResourceUpdateManyMutationInput;
  where: ResourceScalarWhereInput;
};

export type ResourceUpdateManyWithWhereWithoutUnitTypeInput = {
  data: ResourceUpdateManyMutationInput;
  where: ResourceScalarWhereInput;
};

export type ResourceUpdateOneRequiredWithoutOverrideNestedInput = {
  connect?: InputMaybe<ResourceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ResourceCreateOrConnectWithoutOverrideInput>;
  create?: InputMaybe<ResourceCreateWithoutOverrideInput>;
  update?: InputMaybe<ResourceUpdateWithoutOverrideInput>;
  upsert?: InputMaybe<ResourceUpsertWithoutOverrideInput>;
};

export type ResourceUpdateWithoutAccessGrantsInput = {
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  building?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  controlType?: InputMaybe<NullableEnumResourceControlTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEnd?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultStart?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isComponentRoom?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourcesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Override?: InputMaybe<OverrideUpdateManyWithoutResourceNestedInput>;
  passLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutResourcesNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourcesNestedInput>;
  type?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  unitType?: InputMaybe<UnitTypeUpdateOneWithoutResourcesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
  vendorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ResourceUpdateWithoutLocationInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutResourcesNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  building?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  controlType?: InputMaybe<NullableEnumResourceControlTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEnd?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultStart?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isComponentRoom?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Override?: InputMaybe<OverrideUpdateManyWithoutResourceNestedInput>;
  passLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutResourcesNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourcesNestedInput>;
  type?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  unitType?: InputMaybe<UnitTypeUpdateOneWithoutResourcesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
  vendorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ResourceUpdateWithoutOverrideInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutResourcesNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  building?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  controlType?: InputMaybe<NullableEnumResourceControlTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEnd?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultStart?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isComponentRoom?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourcesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  passLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutResourcesNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourcesNestedInput>;
  type?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  unitType?: InputMaybe<UnitTypeUpdateOneWithoutResourcesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
  vendorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ResourceUpdateWithoutResourceGroupsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutResourcesNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  building?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  controlType?: InputMaybe<NullableEnumResourceControlTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEnd?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultStart?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isComponentRoom?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourcesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Override?: InputMaybe<OverrideUpdateManyWithoutResourceNestedInput>;
  passLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourcesNestedInput>;
  type?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  unitType?: InputMaybe<UnitTypeUpdateOneWithoutResourcesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
  vendorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ResourceUpdateWithoutTenantInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutResourcesNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  building?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  controlType?: InputMaybe<NullableEnumResourceControlTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEnd?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultStart?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isComponentRoom?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourcesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Override?: InputMaybe<OverrideUpdateManyWithoutResourceNestedInput>;
  passLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutResourcesNestedInput>;
  type?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  unitType?: InputMaybe<UnitTypeUpdateOneWithoutResourcesNestedInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
  vendorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ResourceUpdateWithoutUnitTypeInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutResourcesNestedInput>;
  address?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  building?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  code?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  controlType?: InputMaybe<NullableEnumResourceControlTypeFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  defaultEnd?: InputMaybe<StringFieldUpdateOperationsInput>;
  defaultStart?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  floor?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  isComponentRoom?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutResourcesNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Override?: InputMaybe<OverrideUpdateManyWithoutResourceNestedInput>;
  passLevel?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  pmsId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutResourcesNestedInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutResourcesNestedInput>;
  type?: InputMaybe<EnumResourceTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
  vendorId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type ResourceUpdateWithWhereUniqueWithoutAccessGrantsInput = {
  data: ResourceUpdateWithoutAccessGrantsInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpdateWithWhereUniqueWithoutLocationInput = {
  data: ResourceUpdateWithoutLocationInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpdateWithWhereUniqueWithoutResourceGroupsInput = {
  data: ResourceUpdateWithoutResourceGroupsInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpdateWithWhereUniqueWithoutTenantInput = {
  data: ResourceUpdateWithoutTenantInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpdateWithWhereUniqueWithoutUnitTypeInput = {
  data: ResourceUpdateWithoutUnitTypeInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpsertWithoutOverrideInput = {
  create: ResourceCreateWithoutOverrideInput;
  update: ResourceUpdateWithoutOverrideInput;
};

export type ResourceUpsertWithWhereUniqueWithoutAccessGrantsInput = {
  create: ResourceCreateWithoutAccessGrantsInput;
  update: ResourceUpdateWithoutAccessGrantsInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpsertWithWhereUniqueWithoutLocationInput = {
  create: ResourceCreateWithoutLocationInput;
  update: ResourceUpdateWithoutLocationInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpsertWithWhereUniqueWithoutResourceGroupsInput = {
  create: ResourceCreateWithoutResourceGroupsInput;
  update: ResourceUpdateWithoutResourceGroupsInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpsertWithWhereUniqueWithoutTenantInput = {
  create: ResourceCreateWithoutTenantInput;
  update: ResourceUpdateWithoutTenantInput;
  where: ResourceWhereUniqueInput;
};

export type ResourceUpsertWithWhereUniqueWithoutUnitTypeInput = {
  create: ResourceCreateWithoutUnitTypeInput;
  update: ResourceUpdateWithoutUnitTypeInput;
  where: ResourceWhereUniqueInput;
};

export enum ResourceVendor {
  AssaAbloy = 'ASSA_ABLOY',
  AssaAbloyVisionline = 'ASSA_ABLOY_VISIONLINE',
  DormakabaAmbiance = 'DORMAKABA_AMBIANCE',
  DormakabaAtlas = 'DORMAKABA_ATLAS',
  DormakabaSystem_6000 = 'DORMAKABA_SYSTEM_6000',
  Miwa = 'MIWA',
  None = 'NONE',
  Onity = 'ONITY',
  Openpath = 'OPENPATH',
  Salto = 'SALTO',
  Schlage = 'SCHLAGE',
  Shift4Utg = 'SHIFT4_UTG',
  Yale = 'YALE'
}

export type ResourceWhereInput = {
  accessGrants?: InputMaybe<AccessGrantListRelationFilter>;
  address?: InputMaybe<StringNullableFilter>;
  AND?: InputMaybe<Array<ResourceWhereInput>>;
  building?: InputMaybe<StringNullableFilter>;
  code?: InputMaybe<StringNullableFilter>;
  controlType?: InputMaybe<EnumResourceControlTypeNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  defaultEnd?: InputMaybe<StringFilter>;
  defaultStart?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringNullableFilter>;
  floor?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringNullableFilter>;
  isComponentRoom?: InputMaybe<BoolNullableFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ResourceWhereInput>>;
  OR?: InputMaybe<Array<ResourceWhereInput>>;
  Override?: InputMaybe<OverrideListRelationFilter>;
  passLevel?: InputMaybe<IntNullableFilter>;
  pmsId?: InputMaybe<StringNullableFilter>;
  resourceGroups?: InputMaybe<ResourceGroupListRelationFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumResourceTypeFilter>;
  unitType?: InputMaybe<UnitTypeRelationFilter>;
  unitTypeId?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  vendor?: InputMaybe<EnumResourceVendorFilter>;
  vendorId?: InputMaybe<StringNullableFilter>;
};

export type ResourceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  name_locationId?: InputMaybe<ResourceNameLocationIdCompoundUniqueInput>;
};

export enum RetryCheckinStatus {
  Aborted = 'ABORTED',
  Active = 'ACTIVE',
  Completed = 'COMPLETED',
  Failed = 'FAILED'
}

export type RetryPaymentRequirement = {
  enabled?: Maybe<Scalars['Boolean']>;
  paymentErrorCodes?: Maybe<Array<Scalars['String']>>;
};

export enum RfidTagType {
  ClassicEv1_1K = 'CLASSIC_EV1_1K',
  ClassicEv1_4K = 'CLASSIC_EV1_4K',
  DesFire = 'DESFire',
  PlusEv1_2K = 'PLUS_EV1_2K',
  UltralightC = 'ULTRALIGHT_C',
  UltralightEv1 = 'ULTRALIGHT_EV1'
}

export enum Role {
  Admin = 'ADMIN',
  Agent = 'AGENT',
  User = 'USER'
}

export type SaltoMobileKeyResponse = {
  data?: Maybe<Scalars['String']>;
};

export type SecondaryUsersOnAccessGrants = {
  accessGrant: AccessGrant;
  accessGrantId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  user: User;
  userId: Scalars['String'];
};

export type SecondaryUsersOnAccessGrantsCreateManyAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type SecondaryUsersOnAccessGrantsCreateManyAccessGrantInputEnvelope = {
  data: Array<SecondaryUsersOnAccessGrantsCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SecondaryUsersOnAccessGrantsCreateManyUserInput = {
  accessGrantId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
};

export type SecondaryUsersOnAccessGrantsCreateManyUserInputEnvelope = {
  data: Array<SecondaryUsersOnAccessGrantsCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SecondaryUsersOnAccessGrantsCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SecondaryUsersOnAccessGrantsCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<SecondaryUsersOnAccessGrantsCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<SecondaryUsersOnAccessGrantsCreateManyAccessGrantInputEnvelope>;
};

export type SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SecondaryUsersOnAccessGrantsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SecondaryUsersOnAccessGrantsCreateWithoutUserInput>>;
  createMany?: InputMaybe<SecondaryUsersOnAccessGrantsCreateManyUserInputEnvelope>;
};

export type SecondaryUsersOnAccessGrantsCreateOrConnectWithoutAccessGrantInput = {
  create: SecondaryUsersOnAccessGrantsCreateWithoutAccessGrantInput;
  where: SecondaryUsersOnAccessGrantsWhereUniqueInput;
};

export type SecondaryUsersOnAccessGrantsCreateOrConnectWithoutUserInput = {
  create: SecondaryUsersOnAccessGrantsCreateWithoutUserInput;
  where: SecondaryUsersOnAccessGrantsWhereUniqueInput;
};

export type SecondaryUsersOnAccessGrantsCreateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  user: UserCreateNestedOneWithoutSecondaryUsersOnAccessGrantsInput;
};

export type SecondaryUsersOnAccessGrantsCreateWithoutUserInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutSecondaryUsersInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
};

export type SecondaryUsersOnAccessGrantsListRelationFilter = {
  every?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
  none?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
  some?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
};

export type SecondaryUsersOnAccessGrantsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SecondaryUsersOnAccessGrantsOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum SecondaryUsersOnAccessGrantsScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  CreatedAt = 'createdAt',
  UserId = 'userId'
}

export type SecondaryUsersOnAccessGrantsScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  NOT?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarWhereInput>>;
  OR?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarWhereInput>>;
  userId?: InputMaybe<StringFilter>;
};

export type SecondaryUsersOnAccessGrantsUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SecondaryUsersOnAccessGrantsUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SecondaryUsersOnAccessGrantsCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<SecondaryUsersOnAccessGrantsCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<SecondaryUsersOnAccessGrantsCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  set?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  update?: InputMaybe<Array<SecondaryUsersOnAccessGrantsUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<SecondaryUsersOnAccessGrantsUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<SecondaryUsersOnAccessGrantsUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SecondaryUsersOnAccessGrantsCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<SecondaryUsersOnAccessGrantsCreateWithoutUserInput>>;
  createMany?: InputMaybe<SecondaryUsersOnAccessGrantsCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  set?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereUniqueInput>>;
  update?: InputMaybe<Array<SecondaryUsersOnAccessGrantsUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<SecondaryUsersOnAccessGrantsUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<SecondaryUsersOnAccessGrantsUpsertWithWhereUniqueWithoutUserInput>>;
};

export type SecondaryUsersOnAccessGrantsUpdateManyWithWhereWithoutAccessGrantInput = {
  data: SecondaryUsersOnAccessGrantsUpdateManyMutationInput;
  where: SecondaryUsersOnAccessGrantsScalarWhereInput;
};

export type SecondaryUsersOnAccessGrantsUpdateManyWithWhereWithoutUserInput = {
  data: SecondaryUsersOnAccessGrantsUpdateManyMutationInput;
  where: SecondaryUsersOnAccessGrantsScalarWhereInput;
};

export type SecondaryUsersOnAccessGrantsUpdateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutSecondaryUsersOnAccessGrantsNestedInput>;
};

export type SecondaryUsersOnAccessGrantsUpdateWithoutUserInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutSecondaryUsersNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type SecondaryUsersOnAccessGrantsUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: SecondaryUsersOnAccessGrantsUpdateWithoutAccessGrantInput;
  where: SecondaryUsersOnAccessGrantsWhereUniqueInput;
};

export type SecondaryUsersOnAccessGrantsUpdateWithWhereUniqueWithoutUserInput = {
  data: SecondaryUsersOnAccessGrantsUpdateWithoutUserInput;
  where: SecondaryUsersOnAccessGrantsWhereUniqueInput;
};

export type SecondaryUsersOnAccessGrantsUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: SecondaryUsersOnAccessGrantsCreateWithoutAccessGrantInput;
  update: SecondaryUsersOnAccessGrantsUpdateWithoutAccessGrantInput;
  where: SecondaryUsersOnAccessGrantsWhereUniqueInput;
};

export type SecondaryUsersOnAccessGrantsUpsertWithWhereUniqueWithoutUserInput = {
  create: SecondaryUsersOnAccessGrantsCreateWithoutUserInput;
  update: SecondaryUsersOnAccessGrantsUpdateWithoutUserInput;
  where: SecondaryUsersOnAccessGrantsWhereUniqueInput;
};

export type SecondaryUsersOnAccessGrantsUserIdAccessGrantIdCompoundUniqueInput = {
  accessGrantId: Scalars['String'];
  userId: Scalars['String'];
};

export type SecondaryUsersOnAccessGrantsWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  NOT?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereInput>>;
  OR?: InputMaybe<Array<SecondaryUsersOnAccessGrantsWhereInput>>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type SecondaryUsersOnAccessGrantsWhereUniqueInput = {
  userId_accessGrantId?: InputMaybe<SecondaryUsersOnAccessGrantsUserIdAccessGrantIdCompoundUniqueInput>;
};

export type SectorPassword = {
  BinaryData: Scalars['String'];
  KeyType: Scalars['String'];
};

export enum SecurityDepositPolicy {
  FixedAmount = 'FIXED_AMOUNT',
  PerNight = 'PER_NIGHT'
}

export type SendLoadKioskSessionEventResult = {
  errorCode?: InputMaybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export type Service = {
  _count?: Maybe<ServiceCount>;
  askForTime: Scalars['Boolean'];
  categoryId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  displayCommentBox: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  isInventoryBased?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  largeDescription?: Maybe<Scalars['String']>;
  location?: Maybe<Location>;
  locationId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  serviceBenefits: Array<ServiceBenefit>;
  serviceCategory?: Maybe<ServiceCategory>;
  serviceRequests: Array<ServiceRequest>;
  serviceRules: Array<ServiceRule>;
  status?: Maybe<ServiceStatus>;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};


export type ServiceServiceBenefitsArgs = {
  cursor?: InputMaybe<ServiceBenefitWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceBenefitScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceBenefitOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceBenefitWhereInput>;
};


export type ServiceServiceRequestsArgs = {
  cursor?: InputMaybe<ServiceRequestWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceRequestScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceRequestOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type ServiceServiceRulesArgs = {
  cursor?: InputMaybe<ServiceRuleWhereUniqueInput>;
  distinct?: InputMaybe<Array<ServiceRuleScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ServiceRuleOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceRuleWhereInput>;
};

export type ServiceAvgAggregate = {
  price?: Maybe<Scalars['Float']>;
};

export type ServiceAvgOrderByAggregateInput = {
  price?: InputMaybe<SortOrder>;
};

export type ServiceBenefit = {
  _count?: Maybe<ServiceBenefitCount>;
  badgeImg: Scalars['String'];
  description: Scalars['String'];
  id: Scalars['String'];
  isFeatured: Scalars['Boolean'];
  name: Scalars['String'];
};

export type ServiceBenefitCount = {
  ServiceCategoryBenefits: Scalars['Int'];
  services: Scalars['Int'];
};


export type ServiceBenefitCountServiceCategoryBenefitsArgs = {
  where?: InputMaybe<ServiceCategoryBenefitsWhereInput>;
};


export type ServiceBenefitCountServicesArgs = {
  where?: InputMaybe<ServiceWhereInput>;
};

export type ServiceBenefitCreateNestedManyWithoutServicesInput = {
  connect?: InputMaybe<Array<ServiceBenefitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceBenefitCreateOrConnectWithoutServicesInput>>;
  create?: InputMaybe<Array<ServiceBenefitCreateWithoutServicesInput>>;
};

export type ServiceBenefitCreateNestedOneWithoutServiceCategoryBenefitsInput = {
  connect?: InputMaybe<ServiceBenefitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceBenefitCreateOrConnectWithoutServiceCategoryBenefitsInput>;
  create?: InputMaybe<ServiceBenefitCreateWithoutServiceCategoryBenefitsInput>;
};

export type ServiceBenefitCreateOrConnectWithoutServiceCategoryBenefitsInput = {
  create: ServiceBenefitCreateWithoutServiceCategoryBenefitsInput;
  where: ServiceBenefitWhereUniqueInput;
};

export type ServiceBenefitCreateOrConnectWithoutServicesInput = {
  create: ServiceBenefitCreateWithoutServicesInput;
  where: ServiceBenefitWhereUniqueInput;
};

export type ServiceBenefitCreateWithoutServiceCategoryBenefitsInput = {
  badgeImg: Scalars['String'];
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  services?: InputMaybe<ServiceCreateNestedManyWithoutServiceBenefitsInput>;
};

export type ServiceBenefitCreateWithoutServicesInput = {
  badgeImg: Scalars['String'];
  description: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isFeatured?: InputMaybe<Scalars['Boolean']>;
  name: Scalars['String'];
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsCreateNestedManyWithoutServiceBenefitInput>;
};

export type ServiceBenefitListRelationFilter = {
  every?: InputMaybe<ServiceBenefitWhereInput>;
  none?: InputMaybe<ServiceBenefitWhereInput>;
  some?: InputMaybe<ServiceBenefitWhereInput>;
};

export type ServiceBenefitOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ServiceBenefitOrderByWithRelationInput = {
  badgeImg?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isFeatured?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsOrderByRelationAggregateInput>;
  services?: InputMaybe<ServiceOrderByRelationAggregateInput>;
};

export type ServiceBenefitRelationFilter = {
  is?: InputMaybe<ServiceBenefitWhereInput>;
  isNot?: InputMaybe<ServiceBenefitWhereInput>;
};

export enum ServiceBenefitScalarFieldEnum {
  BadgeImg = 'badgeImg',
  Description = 'description',
  Id = 'id',
  IsFeatured = 'isFeatured',
  Name = 'name'
}

export type ServiceBenefitScalarWhereInput = {
  AND?: InputMaybe<Array<ServiceBenefitScalarWhereInput>>;
  badgeImg?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isFeatured?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ServiceBenefitScalarWhereInput>>;
  OR?: InputMaybe<Array<ServiceBenefitScalarWhereInput>>;
};

export type ServiceBenefitUpdateManyMutationInput = {
  badgeImg?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFeatured?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ServiceBenefitUpdateManyWithoutServicesNestedInput = {
  connect?: InputMaybe<Array<ServiceBenefitWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceBenefitCreateOrConnectWithoutServicesInput>>;
  create?: InputMaybe<Array<ServiceBenefitCreateWithoutServicesInput>>;
  delete?: InputMaybe<Array<ServiceBenefitWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceBenefitScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceBenefitWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceBenefitWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceBenefitUpdateWithWhereUniqueWithoutServicesInput>>;
  updateMany?: InputMaybe<Array<ServiceBenefitUpdateManyWithWhereWithoutServicesInput>>;
  upsert?: InputMaybe<Array<ServiceBenefitUpsertWithWhereUniqueWithoutServicesInput>>;
};

export type ServiceBenefitUpdateManyWithWhereWithoutServicesInput = {
  data: ServiceBenefitUpdateManyMutationInput;
  where: ServiceBenefitScalarWhereInput;
};

export type ServiceBenefitUpdateOneRequiredWithoutServiceCategoryBenefitsNestedInput = {
  connect?: InputMaybe<ServiceBenefitWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceBenefitCreateOrConnectWithoutServiceCategoryBenefitsInput>;
  create?: InputMaybe<ServiceBenefitCreateWithoutServiceCategoryBenefitsInput>;
  update?: InputMaybe<ServiceBenefitUpdateWithoutServiceCategoryBenefitsInput>;
  upsert?: InputMaybe<ServiceBenefitUpsertWithoutServiceCategoryBenefitsInput>;
};

export type ServiceBenefitUpdateWithoutServiceCategoryBenefitsInput = {
  badgeImg?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFeatured?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutServiceBenefitsNestedInput>;
};

export type ServiceBenefitUpdateWithoutServicesInput = {
  badgeImg?: InputMaybe<StringFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isFeatured?: InputMaybe<BoolFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsUpdateManyWithoutServiceBenefitNestedInput>;
};

export type ServiceBenefitUpdateWithWhereUniqueWithoutServicesInput = {
  data: ServiceBenefitUpdateWithoutServicesInput;
  where: ServiceBenefitWhereUniqueInput;
};

export type ServiceBenefitUpsertWithoutServiceCategoryBenefitsInput = {
  create: ServiceBenefitCreateWithoutServiceCategoryBenefitsInput;
  update: ServiceBenefitUpdateWithoutServiceCategoryBenefitsInput;
};

export type ServiceBenefitUpsertWithWhereUniqueWithoutServicesInput = {
  create: ServiceBenefitCreateWithoutServicesInput;
  update: ServiceBenefitUpdateWithoutServicesInput;
  where: ServiceBenefitWhereUniqueInput;
};

export type ServiceBenefitWhereInput = {
  AND?: InputMaybe<Array<ServiceBenefitWhereInput>>;
  badgeImg?: InputMaybe<StringFilter>;
  description?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isFeatured?: InputMaybe<BoolFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ServiceBenefitWhereInput>>;
  OR?: InputMaybe<Array<ServiceBenefitWhereInput>>;
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsListRelationFilter>;
  services?: InputMaybe<ServiceListRelationFilter>;
};

export type ServiceBenefitWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ServiceByCategory = {
  benefits?: Maybe<Array<ServiceCategoryBenefits>>;
  name: Scalars['String'];
  services: Array<Service>;
};

export type ServiceCategory = {
  _count?: Maybe<ServiceCategoryCount>;
  id: Scalars['String'];
  isComparable: Scalars['Int'];
  locationId?: Maybe<Scalars['String']>;
  name: Scalars['String'];
};

export type ServiceCategoryBenefits = {
  order: Scalars['Int'];
  serviceBenefitId: Scalars['String'];
  serviceCategoryId: Scalars['String'];
};

export type ServiceCategoryBenefitsCreateManyServiceBenefitInput = {
  order: Scalars['Int'];
  serviceCategoryId: Scalars['String'];
};

export type ServiceCategoryBenefitsCreateManyServiceBenefitInputEnvelope = {
  data: Array<ServiceCategoryBenefitsCreateManyServiceBenefitInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceCategoryBenefitsCreateManyServiceCategoryInput = {
  order: Scalars['Int'];
  serviceBenefitId: Scalars['String'];
};

export type ServiceCategoryBenefitsCreateManyServiceCategoryInputEnvelope = {
  data: Array<ServiceCategoryBenefitsCreateManyServiceCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceCategoryBenefitsCreateNestedManyWithoutServiceBenefitInput = {
  connect?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCategoryBenefitsCreateOrConnectWithoutServiceBenefitInput>>;
  create?: InputMaybe<Array<ServiceCategoryBenefitsCreateWithoutServiceBenefitInput>>;
  createMany?: InputMaybe<ServiceCategoryBenefitsCreateManyServiceBenefitInputEnvelope>;
};

export type ServiceCategoryBenefitsCreateNestedManyWithoutServiceCategoryInput = {
  connect?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCategoryBenefitsCreateOrConnectWithoutServiceCategoryInput>>;
  create?: InputMaybe<Array<ServiceCategoryBenefitsCreateWithoutServiceCategoryInput>>;
  createMany?: InputMaybe<ServiceCategoryBenefitsCreateManyServiceCategoryInputEnvelope>;
};

export type ServiceCategoryBenefitsCreateOrConnectWithoutServiceBenefitInput = {
  create: ServiceCategoryBenefitsCreateWithoutServiceBenefitInput;
  where: ServiceCategoryBenefitsWhereUniqueInput;
};

export type ServiceCategoryBenefitsCreateOrConnectWithoutServiceCategoryInput = {
  create: ServiceCategoryBenefitsCreateWithoutServiceCategoryInput;
  where: ServiceCategoryBenefitsWhereUniqueInput;
};

export type ServiceCategoryBenefitsCreateWithoutServiceBenefitInput = {
  order: Scalars['Int'];
  serviceCategory: ServiceCategoryCreateNestedOneWithoutServiceCategoryBenefitsInput;
};

export type ServiceCategoryBenefitsCreateWithoutServiceCategoryInput = {
  order: Scalars['Int'];
  serviceBenefit: ServiceBenefitCreateNestedOneWithoutServiceCategoryBenefitsInput;
};

export type ServiceCategoryBenefitsListRelationFilter = {
  every?: InputMaybe<ServiceCategoryBenefitsWhereInput>;
  none?: InputMaybe<ServiceCategoryBenefitsWhereInput>;
  some?: InputMaybe<ServiceCategoryBenefitsWhereInput>;
};

export type ServiceCategoryBenefitsOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ServiceCategoryBenefitsScalarWhereInput = {
  AND?: InputMaybe<Array<ServiceCategoryBenefitsScalarWhereInput>>;
  NOT?: InputMaybe<Array<ServiceCategoryBenefitsScalarWhereInput>>;
  OR?: InputMaybe<Array<ServiceCategoryBenefitsScalarWhereInput>>;
  order?: InputMaybe<IntFilter>;
  serviceBenefitId?: InputMaybe<StringFilter>;
  serviceCategoryId?: InputMaybe<StringFilter>;
};

export type ServiceCategoryBenefitsServiceCategoryIdServiceBenefitIdCompoundUniqueInput = {
  serviceBenefitId: Scalars['String'];
  serviceCategoryId: Scalars['String'];
};

export type ServiceCategoryBenefitsUpdateManyMutationInput = {
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
};

export type ServiceCategoryBenefitsUpdateManyWithoutServiceBenefitNestedInput = {
  connect?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCategoryBenefitsCreateOrConnectWithoutServiceBenefitInput>>;
  create?: InputMaybe<Array<ServiceCategoryBenefitsCreateWithoutServiceBenefitInput>>;
  createMany?: InputMaybe<ServiceCategoryBenefitsCreateManyServiceBenefitInputEnvelope>;
  delete?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceCategoryBenefitsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceCategoryBenefitsUpdateWithWhereUniqueWithoutServiceBenefitInput>>;
  updateMany?: InputMaybe<Array<ServiceCategoryBenefitsUpdateManyWithWhereWithoutServiceBenefitInput>>;
  upsert?: InputMaybe<Array<ServiceCategoryBenefitsUpsertWithWhereUniqueWithoutServiceBenefitInput>>;
};

export type ServiceCategoryBenefitsUpdateManyWithoutServiceCategoryNestedInput = {
  connect?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCategoryBenefitsCreateOrConnectWithoutServiceCategoryInput>>;
  create?: InputMaybe<Array<ServiceCategoryBenefitsCreateWithoutServiceCategoryInput>>;
  createMany?: InputMaybe<ServiceCategoryBenefitsCreateManyServiceCategoryInputEnvelope>;
  delete?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceCategoryBenefitsScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceCategoryBenefitsWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceCategoryBenefitsUpdateWithWhereUniqueWithoutServiceCategoryInput>>;
  updateMany?: InputMaybe<Array<ServiceCategoryBenefitsUpdateManyWithWhereWithoutServiceCategoryInput>>;
  upsert?: InputMaybe<Array<ServiceCategoryBenefitsUpsertWithWhereUniqueWithoutServiceCategoryInput>>;
};

export type ServiceCategoryBenefitsUpdateManyWithWhereWithoutServiceBenefitInput = {
  data: ServiceCategoryBenefitsUpdateManyMutationInput;
  where: ServiceCategoryBenefitsScalarWhereInput;
};

export type ServiceCategoryBenefitsUpdateManyWithWhereWithoutServiceCategoryInput = {
  data: ServiceCategoryBenefitsUpdateManyMutationInput;
  where: ServiceCategoryBenefitsScalarWhereInput;
};

export type ServiceCategoryBenefitsUpdateWithoutServiceBenefitInput = {
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  serviceCategory?: InputMaybe<ServiceCategoryUpdateOneRequiredWithoutServiceCategoryBenefitsNestedInput>;
};

export type ServiceCategoryBenefitsUpdateWithoutServiceCategoryInput = {
  order?: InputMaybe<IntFieldUpdateOperationsInput>;
  serviceBenefit?: InputMaybe<ServiceBenefitUpdateOneRequiredWithoutServiceCategoryBenefitsNestedInput>;
};

export type ServiceCategoryBenefitsUpdateWithWhereUniqueWithoutServiceBenefitInput = {
  data: ServiceCategoryBenefitsUpdateWithoutServiceBenefitInput;
  where: ServiceCategoryBenefitsWhereUniqueInput;
};

export type ServiceCategoryBenefitsUpdateWithWhereUniqueWithoutServiceCategoryInput = {
  data: ServiceCategoryBenefitsUpdateWithoutServiceCategoryInput;
  where: ServiceCategoryBenefitsWhereUniqueInput;
};

export type ServiceCategoryBenefitsUpsertWithWhereUniqueWithoutServiceBenefitInput = {
  create: ServiceCategoryBenefitsCreateWithoutServiceBenefitInput;
  update: ServiceCategoryBenefitsUpdateWithoutServiceBenefitInput;
  where: ServiceCategoryBenefitsWhereUniqueInput;
};

export type ServiceCategoryBenefitsUpsertWithWhereUniqueWithoutServiceCategoryInput = {
  create: ServiceCategoryBenefitsCreateWithoutServiceCategoryInput;
  update: ServiceCategoryBenefitsUpdateWithoutServiceCategoryInput;
  where: ServiceCategoryBenefitsWhereUniqueInput;
};

export type ServiceCategoryBenefitsWhereInput = {
  AND?: InputMaybe<Array<ServiceCategoryBenefitsWhereInput>>;
  NOT?: InputMaybe<Array<ServiceCategoryBenefitsWhereInput>>;
  OR?: InputMaybe<Array<ServiceCategoryBenefitsWhereInput>>;
  order?: InputMaybe<IntFilter>;
  serviceBenefit?: InputMaybe<ServiceBenefitRelationFilter>;
  serviceBenefitId?: InputMaybe<StringFilter>;
  serviceCategory?: InputMaybe<ServiceCategoryRelationFilter>;
  serviceCategoryId?: InputMaybe<StringFilter>;
};

export type ServiceCategoryBenefitsWhereUniqueInput = {
  serviceCategoryId_serviceBenefitId?: InputMaybe<ServiceCategoryBenefitsServiceCategoryIdServiceBenefitIdCompoundUniqueInput>;
};

export type ServiceCategoryCount = {
  ServiceCategoryBenefits: Scalars['Int'];
  services: Scalars['Int'];
};


export type ServiceCategoryCountServiceCategoryBenefitsArgs = {
  where?: InputMaybe<ServiceCategoryBenefitsWhereInput>;
};


export type ServiceCategoryCountServicesArgs = {
  where?: InputMaybe<ServiceWhereInput>;
};

export type ServiceCategoryCreateManyLocationInput = {
  id?: InputMaybe<Scalars['String']>;
  isComparable?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
};

export type ServiceCategoryCreateManyLocationInputEnvelope = {
  data: Array<ServiceCategoryCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceCategoryCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCategoryCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<ServiceCategoryCreateWithoutLocationInput>>;
  createMany?: InputMaybe<ServiceCategoryCreateManyLocationInputEnvelope>;
};

export type ServiceCategoryCreateNestedOneWithoutServiceCategoryBenefitsInput = {
  connect?: InputMaybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCategoryCreateOrConnectWithoutServiceCategoryBenefitsInput>;
  create?: InputMaybe<ServiceCategoryCreateWithoutServiceCategoryBenefitsInput>;
};

export type ServiceCategoryCreateNestedOneWithoutServicesInput = {
  connect?: InputMaybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCategoryCreateOrConnectWithoutServicesInput>;
  create?: InputMaybe<ServiceCategoryCreateWithoutServicesInput>;
};

export type ServiceCategoryCreateOrConnectWithoutLocationInput = {
  create: ServiceCategoryCreateWithoutLocationInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryCreateOrConnectWithoutServiceCategoryBenefitsInput = {
  create: ServiceCategoryCreateWithoutServiceCategoryBenefitsInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryCreateOrConnectWithoutServicesInput = {
  create: ServiceCategoryCreateWithoutServicesInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryCreateWithoutLocationInput = {
  id?: InputMaybe<Scalars['String']>;
  isComparable?: InputMaybe<Scalars['Int']>;
  name: Scalars['String'];
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsCreateNestedManyWithoutServiceCategoryInput>;
  services?: InputMaybe<ServiceCreateNestedManyWithoutServiceCategoryInput>;
};

export type ServiceCategoryCreateWithoutServiceCategoryBenefitsInput = {
  id?: InputMaybe<Scalars['String']>;
  isComparable?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutServiceCategoryInput>;
  name: Scalars['String'];
  services?: InputMaybe<ServiceCreateNestedManyWithoutServiceCategoryInput>;
};

export type ServiceCategoryCreateWithoutServicesInput = {
  id?: InputMaybe<Scalars['String']>;
  isComparable?: InputMaybe<Scalars['Int']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutServiceCategoryInput>;
  name: Scalars['String'];
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsCreateNestedManyWithoutServiceCategoryInput>;
};

export type ServiceCategoryListRelationFilter = {
  every?: InputMaybe<ServiceCategoryWhereInput>;
  none?: InputMaybe<ServiceCategoryWhereInput>;
  some?: InputMaybe<ServiceCategoryWhereInput>;
};

export type ServiceCategoryOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ServiceCategoryOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  isComparable?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  name?: InputMaybe<SortOrder>;
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsOrderByRelationAggregateInput>;
  services?: InputMaybe<ServiceOrderByRelationAggregateInput>;
};

export type ServiceCategoryRelationFilter = {
  is?: InputMaybe<ServiceCategoryWhereInput>;
  isNot?: InputMaybe<ServiceCategoryWhereInput>;
};

export enum ServiceCategoryScalarFieldEnum {
  Id = 'id',
  IsComparable = 'isComparable',
  LocationId = 'locationId',
  Name = 'name'
}

export type ServiceCategoryScalarWhereInput = {
  AND?: InputMaybe<Array<ServiceCategoryScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  isComparable?: InputMaybe<IntFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ServiceCategoryScalarWhereInput>>;
  OR?: InputMaybe<Array<ServiceCategoryScalarWhereInput>>;
};

export type ServiceCategoryUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isComparable?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type ServiceCategoryUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<ServiceCategoryWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCategoryCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<ServiceCategoryCreateWithoutLocationInput>>;
  createMany?: InputMaybe<ServiceCategoryCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<ServiceCategoryWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceCategoryScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceCategoryWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceCategoryWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceCategoryUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<ServiceCategoryUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<ServiceCategoryUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type ServiceCategoryUpdateManyWithWhereWithoutLocationInput = {
  data: ServiceCategoryUpdateManyMutationInput;
  where: ServiceCategoryScalarWhereInput;
};

export type ServiceCategoryUpdateOneRequiredWithoutServiceCategoryBenefitsNestedInput = {
  connect?: InputMaybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCategoryCreateOrConnectWithoutServiceCategoryBenefitsInput>;
  create?: InputMaybe<ServiceCategoryCreateWithoutServiceCategoryBenefitsInput>;
  update?: InputMaybe<ServiceCategoryUpdateWithoutServiceCategoryBenefitsInput>;
  upsert?: InputMaybe<ServiceCategoryUpsertWithoutServiceCategoryBenefitsInput>;
};

export type ServiceCategoryUpdateOneWithoutServicesNestedInput = {
  connect?: InputMaybe<ServiceCategoryWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCategoryCreateOrConnectWithoutServicesInput>;
  create?: InputMaybe<ServiceCategoryCreateWithoutServicesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<ServiceCategoryUpdateWithoutServicesInput>;
  upsert?: InputMaybe<ServiceCategoryUpsertWithoutServicesInput>;
};

export type ServiceCategoryUpdateWithoutLocationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isComparable?: InputMaybe<IntFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsUpdateManyWithoutServiceCategoryNestedInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutServiceCategoryNestedInput>;
};

export type ServiceCategoryUpdateWithoutServiceCategoryBenefitsInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isComparable?: InputMaybe<IntFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutServiceCategoryNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  services?: InputMaybe<ServiceUpdateManyWithoutServiceCategoryNestedInput>;
};

export type ServiceCategoryUpdateWithoutServicesInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isComparable?: InputMaybe<IntFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutServiceCategoryNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsUpdateManyWithoutServiceCategoryNestedInput>;
};

export type ServiceCategoryUpdateWithWhereUniqueWithoutLocationInput = {
  data: ServiceCategoryUpdateWithoutLocationInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryUpsertWithoutServiceCategoryBenefitsInput = {
  create: ServiceCategoryCreateWithoutServiceCategoryBenefitsInput;
  update: ServiceCategoryUpdateWithoutServiceCategoryBenefitsInput;
};

export type ServiceCategoryUpsertWithoutServicesInput = {
  create: ServiceCategoryCreateWithoutServicesInput;
  update: ServiceCategoryUpdateWithoutServicesInput;
};

export type ServiceCategoryUpsertWithWhereUniqueWithoutLocationInput = {
  create: ServiceCategoryCreateWithoutLocationInput;
  update: ServiceCategoryUpdateWithoutLocationInput;
  where: ServiceCategoryWhereUniqueInput;
};

export type ServiceCategoryWhereInput = {
  AND?: InputMaybe<Array<ServiceCategoryWhereInput>>;
  id?: InputMaybe<StringFilter>;
  isComparable?: InputMaybe<IntFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ServiceCategoryWhereInput>>;
  OR?: InputMaybe<Array<ServiceCategoryWhereInput>>;
  ServiceCategoryBenefits?: InputMaybe<ServiceCategoryBenefitsListRelationFilter>;
  services?: InputMaybe<ServiceListRelationFilter>;
};

export type ServiceCategoryWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ServiceCount = {
  serviceBenefits: Scalars['Int'];
  serviceRequests: Scalars['Int'];
  serviceRules: Scalars['Int'];
};


export type ServiceCountServiceBenefitsArgs = {
  where?: InputMaybe<ServiceBenefitWhereInput>;
};


export type ServiceCountServiceRequestsArgs = {
  where?: InputMaybe<ServiceRequestWhereInput>;
};


export type ServiceCountServiceRulesArgs = {
  where?: InputMaybe<ServiceRuleWhereInput>;
};

export type ServiceCountAggregate = {
  _all: Scalars['Int'];
  askForTime: Scalars['Int'];
  categoryId: Scalars['Int'];
  description: Scalars['Int'];
  displayCommentBox: Scalars['Int'];
  externalId: Scalars['Int'];
  id: Scalars['Int'];
  imageUrl: Scalars['Int'];
  isInventoryBased: Scalars['Int'];
  label: Scalars['Int'];
  largeDescription: Scalars['Int'];
  locationId: Scalars['Int'];
  metadata: Scalars['Int'];
  moreInfoLink: Scalars['Int'];
  price: Scalars['Int'];
  status: Scalars['Int'];
  thumbnail: Scalars['Int'];
  title: Scalars['Int'];
  type: Scalars['Int'];
};

export type ServiceCountOrderByAggregateInput = {
  askForTime?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  displayCommentBox?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  isInventoryBased?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  largeDescription?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  moreInfoLink?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  thumbnail?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ServiceCreateInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  isInventoryBased?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  largeDescription?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutServicesInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  serviceBenefits?: InputMaybe<ServiceBenefitCreateNestedManyWithoutServicesInput>;
  serviceCategory?: InputMaybe<ServiceCategoryCreateNestedOneWithoutServicesInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutServiceInput>;
  serviceRules?: InputMaybe<ServiceRuleCreateNestedManyWithoutServiceInput>;
  status?: InputMaybe<ServiceStatus>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};

export type ServiceCreateManyInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  categoryId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  isInventoryBased?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  largeDescription?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  status?: InputMaybe<ServiceStatus>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};

export type ServiceCreateManyLocationInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  categoryId?: InputMaybe<Scalars['String']>;
  description: Scalars['String'];
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  isInventoryBased?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  largeDescription?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  status?: InputMaybe<ServiceStatus>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};

export type ServiceCreateManyLocationInputEnvelope = {
  data: Array<ServiceCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceCreateManyServiceCategoryInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  isInventoryBased?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  largeDescription?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  status?: InputMaybe<ServiceStatus>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};

export type ServiceCreateManyServiceCategoryInputEnvelope = {
  data: Array<ServiceCreateManyServiceCategoryInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<ServiceCreateWithoutLocationInput>>;
  createMany?: InputMaybe<ServiceCreateManyLocationInputEnvelope>;
};

export type ServiceCreateNestedManyWithoutServiceBenefitsInput = {
  connect?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCreateOrConnectWithoutServiceBenefitsInput>>;
  create?: InputMaybe<Array<ServiceCreateWithoutServiceBenefitsInput>>;
};

export type ServiceCreateNestedManyWithoutServiceCategoryInput = {
  connect?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCreateOrConnectWithoutServiceCategoryInput>>;
  create?: InputMaybe<Array<ServiceCreateWithoutServiceCategoryInput>>;
  createMany?: InputMaybe<ServiceCreateManyServiceCategoryInputEnvelope>;
};

export type ServiceCreateNestedOneWithoutServiceRequestsInput = {
  connect?: InputMaybe<ServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCreateOrConnectWithoutServiceRequestsInput>;
  create?: InputMaybe<ServiceCreateWithoutServiceRequestsInput>;
};

export type ServiceCreateOrConnectWithoutLocationInput = {
  create: ServiceCreateWithoutLocationInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutServiceBenefitsInput = {
  create: ServiceCreateWithoutServiceBenefitsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutServiceCategoryInput = {
  create: ServiceCreateWithoutServiceCategoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateOrConnectWithoutServiceRequestsInput = {
  create: ServiceCreateWithoutServiceRequestsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceCreateWithoutLocationInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  isInventoryBased?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  largeDescription?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  serviceBenefits?: InputMaybe<ServiceBenefitCreateNestedManyWithoutServicesInput>;
  serviceCategory?: InputMaybe<ServiceCategoryCreateNestedOneWithoutServicesInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutServiceInput>;
  serviceRules?: InputMaybe<ServiceRuleCreateNestedManyWithoutServiceInput>;
  status?: InputMaybe<ServiceStatus>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};

export type ServiceCreateWithoutServiceBenefitsInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  isInventoryBased?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  largeDescription?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutServicesInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  serviceCategory?: InputMaybe<ServiceCategoryCreateNestedOneWithoutServicesInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutServiceInput>;
  serviceRules?: InputMaybe<ServiceRuleCreateNestedManyWithoutServiceInput>;
  status?: InputMaybe<ServiceStatus>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};

export type ServiceCreateWithoutServiceCategoryInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  isInventoryBased?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  largeDescription?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutServicesInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  serviceBenefits?: InputMaybe<ServiceBenefitCreateNestedManyWithoutServicesInput>;
  serviceRequests?: InputMaybe<ServiceRequestCreateNestedManyWithoutServiceInput>;
  serviceRules?: InputMaybe<ServiceRuleCreateNestedManyWithoutServiceInput>;
  status?: InputMaybe<ServiceStatus>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};

export type ServiceCreateWithoutServiceRequestsInput = {
  askForTime?: InputMaybe<Scalars['Boolean']>;
  description: Scalars['String'];
  displayCommentBox?: InputMaybe<Scalars['Boolean']>;
  externalId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  isInventoryBased?: InputMaybe<Scalars['Boolean']>;
  label?: InputMaybe<Scalars['String']>;
  largeDescription?: InputMaybe<Scalars['String']>;
  location?: InputMaybe<LocationCreateNestedOneWithoutServicesInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  price: Scalars['Float'];
  serviceBenefits?: InputMaybe<ServiceBenefitCreateNestedManyWithoutServicesInput>;
  serviceCategory?: InputMaybe<ServiceCategoryCreateNestedOneWithoutServicesInput>;
  serviceRules?: InputMaybe<ServiceRuleCreateNestedManyWithoutServiceInput>;
  status?: InputMaybe<ServiceStatus>;
  thumbnail?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};

export type ServiceGroupBy = {
  _avg?: Maybe<ServiceAvgAggregate>;
  _count?: Maybe<ServiceCountAggregate>;
  _max?: Maybe<ServiceMaxAggregate>;
  _min?: Maybe<ServiceMinAggregate>;
  _sum?: Maybe<ServiceSumAggregate>;
  askForTime: Scalars['Boolean'];
  categoryId?: Maybe<Scalars['String']>;
  description: Scalars['String'];
  displayCommentBox: Scalars['Boolean'];
  externalId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  isInventoryBased?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  largeDescription?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  metadata?: Maybe<Scalars['JSON']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  price: Scalars['Float'];
  status?: Maybe<ServiceStatus>;
  thumbnail?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: ServiceType;
};

export type ServiceListRelationFilter = {
  every?: InputMaybe<ServiceWhereInput>;
  none?: InputMaybe<ServiceWhereInput>;
  some?: InputMaybe<ServiceWhereInput>;
};

export type ServiceMaxAggregate = {
  askForTime?: Maybe<Scalars['Boolean']>;
  categoryId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayCommentBox?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isInventoryBased?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  largeDescription?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<ServiceStatus>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ServiceType>;
};

export type ServiceMaxOrderByAggregateInput = {
  askForTime?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  displayCommentBox?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  isInventoryBased?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  largeDescription?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  moreInfoLink?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  thumbnail?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ServiceMinAggregate = {
  askForTime?: Maybe<Scalars['Boolean']>;
  categoryId?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  displayCommentBox?: Maybe<Scalars['Boolean']>;
  externalId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  isInventoryBased?: Maybe<Scalars['Boolean']>;
  label?: Maybe<Scalars['String']>;
  largeDescription?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  moreInfoLink?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['Float']>;
  status?: Maybe<ServiceStatus>;
  thumbnail?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<ServiceType>;
};

export type ServiceMinOrderByAggregateInput = {
  askForTime?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  displayCommentBox?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  isInventoryBased?: InputMaybe<SortOrder>;
  label?: InputMaybe<SortOrder>;
  largeDescription?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  moreInfoLink?: InputMaybe<SortOrder>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  thumbnail?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ServiceOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ServiceOrderByWithAggregationInput = {
  _avg?: InputMaybe<ServiceAvgOrderByAggregateInput>;
  _count?: InputMaybe<ServiceCountOrderByAggregateInput>;
  _max?: InputMaybe<ServiceMaxOrderByAggregateInput>;
  _min?: InputMaybe<ServiceMinOrderByAggregateInput>;
  _sum?: InputMaybe<ServiceSumOrderByAggregateInput>;
  askForTime?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrder>;
  displayCommentBox?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  isInventoryBased?: InputMaybe<SortOrderInput>;
  label?: InputMaybe<SortOrderInput>;
  largeDescription?: InputMaybe<SortOrderInput>;
  locationId?: InputMaybe<SortOrderInput>;
  metadata?: InputMaybe<SortOrderInput>;
  moreInfoLink?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrderInput>;
  thumbnail?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ServiceOrderByWithRelationInput = {
  askForTime?: InputMaybe<SortOrder>;
  categoryId?: InputMaybe<SortOrderInput>;
  description?: InputMaybe<SortOrder>;
  displayCommentBox?: InputMaybe<SortOrder>;
  externalId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  isInventoryBased?: InputMaybe<SortOrderInput>;
  label?: InputMaybe<SortOrderInput>;
  largeDescription?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  metadata?: InputMaybe<SortOrderInput>;
  moreInfoLink?: InputMaybe<SortOrderInput>;
  price?: InputMaybe<SortOrder>;
  serviceBenefits?: InputMaybe<ServiceBenefitOrderByRelationAggregateInput>;
  serviceCategory?: InputMaybe<ServiceCategoryOrderByWithRelationInput>;
  serviceRequests?: InputMaybe<ServiceRequestOrderByRelationAggregateInput>;
  serviceRules?: InputMaybe<ServiceRuleOrderByRelationAggregateInput>;
  status?: InputMaybe<SortOrderInput>;
  thumbnail?: InputMaybe<SortOrderInput>;
  title?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type ServiceRelationFilter = {
  is?: InputMaybe<ServiceWhereInput>;
  isNot?: InputMaybe<ServiceWhereInput>;
};

export type ServiceRequest = {
  accessGrant: AccessGrant;
  accessGrantId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  origin?: Maybe<OriginType>;
  originalQuantity?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  service: Service;
  serviceId: Scalars['String'];
  status?: Maybe<ServiceRequestStatus>;
  time?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ServiceRequestAvgAggregate = {
  originalQuantity?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

export type ServiceRequestAvgOrderByAggregateInput = {
  originalQuantity?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
};

export type ServiceRequestCountAggregate = {
  _all: Scalars['Int'];
  accessGrantId: Scalars['Int'];
  createdAt: Scalars['Int'];
  description: Scalars['Int'];
  id: Scalars['Int'];
  origin: Scalars['Int'];
  originalQuantity: Scalars['Int'];
  quantity: Scalars['Int'];
  serviceId: Scalars['Int'];
  status: Scalars['Int'];
  time: Scalars['Int'];
  updatedAt: Scalars['Int'];
};

export type ServiceRequestCountOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  originalQuantity?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ServiceRequestCreateInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutServiceRequestsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  originalQuantity?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  service: ServiceCreateNestedOneWithoutServiceRequestsInput;
  status?: InputMaybe<ServiceRequestStatus>;
  time?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceRequestCreateManyAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  originalQuantity?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  serviceId: Scalars['String'];
  status?: InputMaybe<ServiceRequestStatus>;
  time?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceRequestCreateManyAccessGrantInputEnvelope = {
  data: Array<ServiceRequestCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceRequestCreateManyInput = {
  accessGrantId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  originalQuantity?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  serviceId: Scalars['String'];
  status?: InputMaybe<ServiceRequestStatus>;
  time?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceRequestCreateManyServiceInput = {
  accessGrantId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  originalQuantity?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ServiceRequestStatus>;
  time?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceRequestCreateManyServiceInputEnvelope = {
  data: Array<ServiceRequestCreateManyServiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceRequestCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceRequestCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<ServiceRequestCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<ServiceRequestCreateManyAccessGrantInputEnvelope>;
};

export type ServiceRequestCreateNestedManyWithoutServiceInput = {
  connect?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceRequestCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<ServiceRequestCreateWithoutServiceInput>>;
  createMany?: InputMaybe<ServiceRequestCreateManyServiceInputEnvelope>;
};

export type ServiceRequestCreateOrConnectWithoutAccessGrantInput = {
  create: ServiceRequestCreateWithoutAccessGrantInput;
  where: ServiceRequestWhereUniqueInput;
};

export type ServiceRequestCreateOrConnectWithoutServiceInput = {
  create: ServiceRequestCreateWithoutServiceInput;
  where: ServiceRequestWhereUniqueInput;
};

export type ServiceRequestCreateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  originalQuantity?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  service: ServiceCreateNestedOneWithoutServiceRequestsInput;
  status?: InputMaybe<ServiceRequestStatus>;
  time?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceRequestCreateWithoutServiceInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutServiceRequestsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  origin?: InputMaybe<OriginType>;
  originalQuantity?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
  status?: InputMaybe<ServiceRequestStatus>;
  time?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceRequestGroupBy = {
  _avg?: Maybe<ServiceRequestAvgAggregate>;
  _count?: Maybe<ServiceRequestCountAggregate>;
  _max?: Maybe<ServiceRequestMaxAggregate>;
  _min?: Maybe<ServiceRequestMinAggregate>;
  _sum?: Maybe<ServiceRequestSumAggregate>;
  accessGrantId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  origin?: Maybe<OriginType>;
  originalQuantity?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  serviceId: Scalars['String'];
  status?: Maybe<ServiceRequestStatus>;
  time?: Maybe<Scalars['String']>;
  updatedAt: Scalars['DateTime'];
};

export type ServiceRequestListRelationFilter = {
  every?: InputMaybe<ServiceRequestWhereInput>;
  none?: InputMaybe<ServiceRequestWhereInput>;
  some?: InputMaybe<ServiceRequestWhereInput>;
};

export type ServiceRequestMaxAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<OriginType>;
  originalQuantity?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  serviceId?: Maybe<Scalars['String']>;
  status?: Maybe<ServiceRequestStatus>;
  time?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceRequestMaxOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  originalQuantity?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ServiceRequestMinAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  origin?: Maybe<OriginType>;
  originalQuantity?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
  serviceId?: Maybe<Scalars['String']>;
  status?: Maybe<ServiceRequestStatus>;
  time?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['DateTime']>;
};

export type ServiceRequestMinOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrder>;
  originalQuantity?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
  serviceId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrder>;
  time?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ServiceRequestOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ServiceRequestOrderByWithAggregationInput = {
  _avg?: InputMaybe<ServiceRequestAvgOrderByAggregateInput>;
  _count?: InputMaybe<ServiceRequestCountOrderByAggregateInput>;
  _max?: InputMaybe<ServiceRequestMaxOrderByAggregateInput>;
  _min?: InputMaybe<ServiceRequestMinOrderByAggregateInput>;
  _sum?: InputMaybe<ServiceRequestSumOrderByAggregateInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrderInput>;
  originalQuantity?: InputMaybe<SortOrderInput>;
  quantity?: InputMaybe<SortOrderInput>;
  serviceId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrderInput>;
  time?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export type ServiceRequestOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  description?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  origin?: InputMaybe<SortOrderInput>;
  originalQuantity?: InputMaybe<SortOrderInput>;
  quantity?: InputMaybe<SortOrderInput>;
  service?: InputMaybe<ServiceOrderByWithRelationInput>;
  serviceId?: InputMaybe<SortOrder>;
  status?: InputMaybe<SortOrderInput>;
  time?: InputMaybe<SortOrderInput>;
  updatedAt?: InputMaybe<SortOrder>;
};

export enum ServiceRequestScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  CreatedAt = 'createdAt',
  Description = 'description',
  Id = 'id',
  Origin = 'origin',
  OriginalQuantity = 'originalQuantity',
  Quantity = 'quantity',
  ServiceId = 'serviceId',
  Status = 'status',
  Time = 'time',
  UpdatedAt = 'updatedAt'
}

export type ServiceRequestScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<ServiceRequestScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ServiceRequestScalarWhereInput>>;
  OR?: InputMaybe<Array<ServiceRequestScalarWhereInput>>;
  origin?: InputMaybe<EnumOriginTypeNullableFilter>;
  originalQuantity?: InputMaybe<IntNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  serviceId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumServiceRequestStatusNullableFilter>;
  time?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ServiceRequestScalarWhereWithAggregatesInput = {
  accessGrantId?: InputMaybe<StringWithAggregatesFilter>;
  AND?: InputMaybe<Array<ServiceRequestScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  description?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<ServiceRequestScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ServiceRequestScalarWhereWithAggregatesInput>>;
  origin?: InputMaybe<EnumOriginTypeNullableWithAggregatesFilter>;
  originalQuantity?: InputMaybe<IntNullableWithAggregatesFilter>;
  quantity?: InputMaybe<IntNullableWithAggregatesFilter>;
  serviceId?: InputMaybe<StringWithAggregatesFilter>;
  status?: InputMaybe<EnumServiceRequestStatusNullableWithAggregatesFilter>;
  time?: InputMaybe<StringNullableWithAggregatesFilter>;
  updatedAt?: InputMaybe<DateTimeWithAggregatesFilter>;
};

export enum ServiceRequestStatus {
  Approved = 'APPROVED',
  Denied = 'DENIED'
}

export type ServiceRequestSumAggregate = {
  originalQuantity?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

export type ServiceRequestSumOrderByAggregateInput = {
  originalQuantity?: InputMaybe<SortOrder>;
  quantity?: InputMaybe<SortOrder>;
};

export type ServiceRequestUpdateInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutServiceRequestsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  originalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  service?: InputMaybe<ServiceUpdateOneRequiredWithoutServiceRequestsNestedInput>;
  status?: InputMaybe<NullableEnumServiceRequestStatusFieldUpdateOperationsInput>;
  time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ServiceRequestUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  originalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumServiceRequestStatusFieldUpdateOperationsInput>;
  time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ServiceRequestUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceRequestCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<ServiceRequestCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<ServiceRequestCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceRequestUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<ServiceRequestUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<ServiceRequestUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type ServiceRequestUpdateManyWithoutServiceNestedInput = {
  connect?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceRequestCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<ServiceRequestCreateWithoutServiceInput>>;
  createMany?: InputMaybe<ServiceRequestCreateManyServiceInputEnvelope>;
  delete?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceRequestScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceRequestWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceRequestUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: InputMaybe<Array<ServiceRequestUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: InputMaybe<Array<ServiceRequestUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServiceRequestUpdateManyWithWhereWithoutAccessGrantInput = {
  data: ServiceRequestUpdateManyMutationInput;
  where: ServiceRequestScalarWhereInput;
};

export type ServiceRequestUpdateManyWithWhereWithoutServiceInput = {
  data: ServiceRequestUpdateManyMutationInput;
  where: ServiceRequestScalarWhereInput;
};

export type ServiceRequestUpdateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  originalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  service?: InputMaybe<ServiceUpdateOneRequiredWithoutServiceRequestsNestedInput>;
  status?: InputMaybe<NullableEnumServiceRequestStatusFieldUpdateOperationsInput>;
  time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ServiceRequestUpdateWithoutServiceInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutServiceRequestsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  description?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  origin?: InputMaybe<NullableEnumOriginTypeFieldUpdateOperationsInput>;
  originalQuantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  quantity?: InputMaybe<NullableIntFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumServiceRequestStatusFieldUpdateOperationsInput>;
  time?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type ServiceRequestUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: ServiceRequestUpdateWithoutAccessGrantInput;
  where: ServiceRequestWhereUniqueInput;
};

export type ServiceRequestUpdateWithWhereUniqueWithoutServiceInput = {
  data: ServiceRequestUpdateWithoutServiceInput;
  where: ServiceRequestWhereUniqueInput;
};

export type ServiceRequestUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: ServiceRequestCreateWithoutAccessGrantInput;
  update: ServiceRequestUpdateWithoutAccessGrantInput;
  where: ServiceRequestWhereUniqueInput;
};

export type ServiceRequestUpsertWithWhereUniqueWithoutServiceInput = {
  create: ServiceRequestCreateWithoutServiceInput;
  update: ServiceRequestUpdateWithoutServiceInput;
  where: ServiceRequestWhereUniqueInput;
};

export type ServiceRequestWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<ServiceRequestWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  description?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ServiceRequestWhereInput>>;
  OR?: InputMaybe<Array<ServiceRequestWhereInput>>;
  origin?: InputMaybe<EnumOriginTypeNullableFilter>;
  originalQuantity?: InputMaybe<IntNullableFilter>;
  quantity?: InputMaybe<IntNullableFilter>;
  service?: InputMaybe<ServiceRelationFilter>;
  serviceId?: InputMaybe<StringFilter>;
  status?: InputMaybe<EnumServiceRequestStatusNullableFilter>;
  time?: InputMaybe<StringNullableFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
};

export type ServiceRequestWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type ServiceRule = {
  endTime?: Maybe<Scalars['DateTime']>;
  freeUpgrade?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  loyaltyCode?: Maybe<Scalars['String']>;
  ruleType: ServiceRuleType;
  serviceId: Scalars['String'];
  startTime?: Maybe<Scalars['DateTime']>;
};

export type ServiceRuleCreateManyServiceInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  freeUpgrade?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  loyaltyCode?: InputMaybe<Scalars['String']>;
  ruleType: ServiceRuleType;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceRuleCreateManyServiceInputEnvelope = {
  data: Array<ServiceRuleCreateManyServiceInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ServiceRuleCreateNestedManyWithoutServiceInput = {
  connect?: InputMaybe<Array<ServiceRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceRuleCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<ServiceRuleCreateWithoutServiceInput>>;
  createMany?: InputMaybe<ServiceRuleCreateManyServiceInputEnvelope>;
};

export type ServiceRuleCreateOrConnectWithoutServiceInput = {
  create: ServiceRuleCreateWithoutServiceInput;
  where: ServiceRuleWhereUniqueInput;
};

export type ServiceRuleCreateWithoutServiceInput = {
  endTime?: InputMaybe<Scalars['DateTime']>;
  freeUpgrade?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['String']>;
  loyaltyCode?: InputMaybe<Scalars['String']>;
  ruleType: ServiceRuleType;
  startTime?: InputMaybe<Scalars['DateTime']>;
};

export type ServiceRuleListRelationFilter = {
  every?: InputMaybe<ServiceRuleWhereInput>;
  none?: InputMaybe<ServiceRuleWhereInput>;
  some?: InputMaybe<ServiceRuleWhereInput>;
};

export type ServiceRuleOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ServiceRuleOrderByWithRelationInput = {
  endTime?: InputMaybe<SortOrderInput>;
  freeUpgrade?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  loyaltyCode?: InputMaybe<SortOrderInput>;
  ruleType?: InputMaybe<SortOrder>;
  service?: InputMaybe<ServiceOrderByWithRelationInput>;
  serviceId?: InputMaybe<SortOrder>;
  startTime?: InputMaybe<SortOrderInput>;
};

export enum ServiceRuleScalarFieldEnum {
  EndTime = 'endTime',
  FreeUpgrade = 'freeUpgrade',
  Id = 'id',
  LoyaltyCode = 'loyaltyCode',
  RuleType = 'ruleType',
  ServiceId = 'serviceId',
  StartTime = 'startTime'
}

export type ServiceRuleScalarWhereInput = {
  AND?: InputMaybe<Array<ServiceRuleScalarWhereInput>>;
  endTime?: InputMaybe<DateTimeNullableFilter>;
  freeUpgrade?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  loyaltyCode?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<ServiceRuleScalarWhereInput>>;
  OR?: InputMaybe<Array<ServiceRuleScalarWhereInput>>;
  ruleType?: InputMaybe<EnumServiceRuleTypeFilter>;
  serviceId?: InputMaybe<StringFilter>;
  startTime?: InputMaybe<DateTimeNullableFilter>;
};

export enum ServiceRuleType {
  Loyalty = 'LOYALTY',
  TimeRange = 'TIME_RANGE'
}

export type ServiceRuleUpdateManyMutationInput = {
  endTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  freeUpgrade?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  loyaltyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ruleType?: InputMaybe<EnumServiceRuleTypeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ServiceRuleUpdateManyWithoutServiceNestedInput = {
  connect?: InputMaybe<Array<ServiceRuleWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceRuleCreateOrConnectWithoutServiceInput>>;
  create?: InputMaybe<Array<ServiceRuleCreateWithoutServiceInput>>;
  createMany?: InputMaybe<ServiceRuleCreateManyServiceInputEnvelope>;
  delete?: InputMaybe<Array<ServiceRuleWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceRuleScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceRuleWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceRuleWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceRuleUpdateWithWhereUniqueWithoutServiceInput>>;
  updateMany?: InputMaybe<Array<ServiceRuleUpdateManyWithWhereWithoutServiceInput>>;
  upsert?: InputMaybe<Array<ServiceRuleUpsertWithWhereUniqueWithoutServiceInput>>;
};

export type ServiceRuleUpdateManyWithWhereWithoutServiceInput = {
  data: ServiceRuleUpdateManyMutationInput;
  where: ServiceRuleScalarWhereInput;
};

export type ServiceRuleUpdateWithoutServiceInput = {
  endTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  freeUpgrade?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  loyaltyCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  ruleType?: InputMaybe<EnumServiceRuleTypeFieldUpdateOperationsInput>;
  startTime?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
};

export type ServiceRuleUpdateWithWhereUniqueWithoutServiceInput = {
  data: ServiceRuleUpdateWithoutServiceInput;
  where: ServiceRuleWhereUniqueInput;
};

export type ServiceRuleUpsertWithWhereUniqueWithoutServiceInput = {
  create: ServiceRuleCreateWithoutServiceInput;
  update: ServiceRuleUpdateWithoutServiceInput;
  where: ServiceRuleWhereUniqueInput;
};

export type ServiceRuleWhereInput = {
  AND?: InputMaybe<Array<ServiceRuleWhereInput>>;
  endTime?: InputMaybe<DateTimeNullableFilter>;
  freeUpgrade?: InputMaybe<BoolNullableFilter>;
  id?: InputMaybe<StringFilter>;
  loyaltyCode?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<ServiceRuleWhereInput>>;
  OR?: InputMaybe<Array<ServiceRuleWhereInput>>;
  ruleType?: InputMaybe<EnumServiceRuleTypeFilter>;
  service?: InputMaybe<ServiceRelationFilter>;
  serviceId?: InputMaybe<StringFilter>;
  startTime?: InputMaybe<DateTimeNullableFilter>;
};

export type ServiceRuleWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export enum ServiceScalarFieldEnum {
  AskForTime = 'askForTime',
  CategoryId = 'categoryId',
  Description = 'description',
  DisplayCommentBox = 'displayCommentBox',
  ExternalId = 'externalId',
  Id = 'id',
  ImageUrl = 'imageUrl',
  IsInventoryBased = 'isInventoryBased',
  Label = 'label',
  LargeDescription = 'largeDescription',
  LocationId = 'locationId',
  Metadata = 'metadata',
  MoreInfoLink = 'moreInfoLink',
  Price = 'price',
  Status = 'status',
  Thumbnail = 'thumbnail',
  Title = 'title',
  Type = 'type'
}

export type ServiceScalarWhereInput = {
  AND?: InputMaybe<Array<ServiceScalarWhereInput>>;
  askForTime?: InputMaybe<BoolFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  displayCommentBox?: InputMaybe<BoolFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  isInventoryBased?: InputMaybe<BoolNullableFilter>;
  label?: InputMaybe<StringNullableFilter>;
  largeDescription?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  moreInfoLink?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<ServiceScalarWhereInput>>;
  OR?: InputMaybe<Array<ServiceScalarWhereInput>>;
  price?: InputMaybe<FloatFilter>;
  status?: InputMaybe<EnumServiceStatusNullableFilter>;
  thumbnail?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumServiceTypeFilter>;
};

export type ServiceScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ServiceScalarWhereWithAggregatesInput>>;
  askForTime?: InputMaybe<BoolWithAggregatesFilter>;
  categoryId?: InputMaybe<StringNullableWithAggregatesFilter>;
  description?: InputMaybe<StringWithAggregatesFilter>;
  displayCommentBox?: InputMaybe<BoolWithAggregatesFilter>;
  externalId?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringWithAggregatesFilter>;
  isInventoryBased?: InputMaybe<BoolNullableWithAggregatesFilter>;
  label?: InputMaybe<StringNullableWithAggregatesFilter>;
  largeDescription?: InputMaybe<StringNullableWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
  moreInfoLink?: InputMaybe<StringNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<ServiceScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ServiceScalarWhereWithAggregatesInput>>;
  price?: InputMaybe<FloatWithAggregatesFilter>;
  status?: InputMaybe<EnumServiceStatusNullableWithAggregatesFilter>;
  thumbnail?: InputMaybe<StringNullableWithAggregatesFilter>;
  title?: InputMaybe<StringWithAggregatesFilter>;
  type?: InputMaybe<EnumServiceTypeWithAggregatesFilter>;
};

export enum ServiceStatus {
  Active = 'ACTIVE',
  Inactive = 'INACTIVE'
}

export type ServiceSumAggregate = {
  price?: Maybe<Scalars['Float']>;
};

export type ServiceSumOrderByAggregateInput = {
  price?: InputMaybe<SortOrder>;
};

export enum ServiceType {
  Comparable = 'COMPARABLE',
  EarlyCheckIn = 'EARLY_CHECK_IN',
  Food = 'FOOD',
  Housekeeping = 'HOUSEKEEPING',
  LateCheckOut = 'LATE_CHECK_OUT',
  Packages = 'PACKAGES',
  Room = 'ROOM'
}

export type ServiceUpdateInput = {
  askForTime?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  displayCommentBox?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInventoryBased?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  largeDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutServicesNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  serviceBenefits?: InputMaybe<ServiceBenefitUpdateManyWithoutServicesNestedInput>;
  serviceCategory?: InputMaybe<ServiceCategoryUpdateOneWithoutServicesNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutServiceNestedInput>;
  serviceRules?: InputMaybe<ServiceRuleUpdateManyWithoutServiceNestedInput>;
  status?: InputMaybe<NullableEnumServiceStatusFieldUpdateOperationsInput>;
  thumbnail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumServiceTypeFieldUpdateOperationsInput>;
};

export type ServiceUpdateManyMutationInput = {
  askForTime?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  displayCommentBox?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInventoryBased?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  largeDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  status?: InputMaybe<NullableEnumServiceStatusFieldUpdateOperationsInput>;
  thumbnail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumServiceTypeFieldUpdateOperationsInput>;
};

export type ServiceUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<ServiceCreateWithoutLocationInput>>;
  createMany?: InputMaybe<ServiceCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<ServiceUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<ServiceUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type ServiceUpdateManyWithoutServiceBenefitsNestedInput = {
  connect?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCreateOrConnectWithoutServiceBenefitsInput>>;
  create?: InputMaybe<Array<ServiceCreateWithoutServiceBenefitsInput>>;
  delete?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceUpdateWithWhereUniqueWithoutServiceBenefitsInput>>;
  updateMany?: InputMaybe<Array<ServiceUpdateManyWithWhereWithoutServiceBenefitsInput>>;
  upsert?: InputMaybe<Array<ServiceUpsertWithWhereUniqueWithoutServiceBenefitsInput>>;
};

export type ServiceUpdateManyWithoutServiceCategoryNestedInput = {
  connect?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ServiceCreateOrConnectWithoutServiceCategoryInput>>;
  create?: InputMaybe<Array<ServiceCreateWithoutServiceCategoryInput>>;
  createMany?: InputMaybe<ServiceCreateManyServiceCategoryInputEnvelope>;
  delete?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ServiceScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  set?: InputMaybe<Array<ServiceWhereUniqueInput>>;
  update?: InputMaybe<Array<ServiceUpdateWithWhereUniqueWithoutServiceCategoryInput>>;
  updateMany?: InputMaybe<Array<ServiceUpdateManyWithWhereWithoutServiceCategoryInput>>;
  upsert?: InputMaybe<Array<ServiceUpsertWithWhereUniqueWithoutServiceCategoryInput>>;
};

export type ServiceUpdateManyWithWhereWithoutLocationInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateManyWithWhereWithoutServiceBenefitsInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateManyWithWhereWithoutServiceCategoryInput = {
  data: ServiceUpdateManyMutationInput;
  where: ServiceScalarWhereInput;
};

export type ServiceUpdateOneRequiredWithoutServiceRequestsNestedInput = {
  connect?: InputMaybe<ServiceWhereUniqueInput>;
  connectOrCreate?: InputMaybe<ServiceCreateOrConnectWithoutServiceRequestsInput>;
  create?: InputMaybe<ServiceCreateWithoutServiceRequestsInput>;
  update?: InputMaybe<ServiceUpdateWithoutServiceRequestsInput>;
  upsert?: InputMaybe<ServiceUpsertWithoutServiceRequestsInput>;
};

export type ServiceUpdateWithoutLocationInput = {
  askForTime?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  displayCommentBox?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInventoryBased?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  largeDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  serviceBenefits?: InputMaybe<ServiceBenefitUpdateManyWithoutServicesNestedInput>;
  serviceCategory?: InputMaybe<ServiceCategoryUpdateOneWithoutServicesNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutServiceNestedInput>;
  serviceRules?: InputMaybe<ServiceRuleUpdateManyWithoutServiceNestedInput>;
  status?: InputMaybe<NullableEnumServiceStatusFieldUpdateOperationsInput>;
  thumbnail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumServiceTypeFieldUpdateOperationsInput>;
};

export type ServiceUpdateWithoutServiceBenefitsInput = {
  askForTime?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  displayCommentBox?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInventoryBased?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  largeDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutServicesNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  serviceCategory?: InputMaybe<ServiceCategoryUpdateOneWithoutServicesNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutServiceNestedInput>;
  serviceRules?: InputMaybe<ServiceRuleUpdateManyWithoutServiceNestedInput>;
  status?: InputMaybe<NullableEnumServiceStatusFieldUpdateOperationsInput>;
  thumbnail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumServiceTypeFieldUpdateOperationsInput>;
};

export type ServiceUpdateWithoutServiceCategoryInput = {
  askForTime?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  displayCommentBox?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInventoryBased?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  largeDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutServicesNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  serviceBenefits?: InputMaybe<ServiceBenefitUpdateManyWithoutServicesNestedInput>;
  serviceRequests?: InputMaybe<ServiceRequestUpdateManyWithoutServiceNestedInput>;
  serviceRules?: InputMaybe<ServiceRuleUpdateManyWithoutServiceNestedInput>;
  status?: InputMaybe<NullableEnumServiceStatusFieldUpdateOperationsInput>;
  thumbnail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumServiceTypeFieldUpdateOperationsInput>;
};

export type ServiceUpdateWithoutServiceRequestsInput = {
  askForTime?: InputMaybe<BoolFieldUpdateOperationsInput>;
  description?: InputMaybe<StringFieldUpdateOperationsInput>;
  displayCommentBox?: InputMaybe<BoolFieldUpdateOperationsInput>;
  externalId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  isInventoryBased?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  label?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  largeDescription?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneWithoutServicesNestedInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  moreInfoLink?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  price?: InputMaybe<FloatFieldUpdateOperationsInput>;
  serviceBenefits?: InputMaybe<ServiceBenefitUpdateManyWithoutServicesNestedInput>;
  serviceCategory?: InputMaybe<ServiceCategoryUpdateOneWithoutServicesNestedInput>;
  serviceRules?: InputMaybe<ServiceRuleUpdateManyWithoutServiceNestedInput>;
  status?: InputMaybe<NullableEnumServiceStatusFieldUpdateOperationsInput>;
  thumbnail?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumServiceTypeFieldUpdateOperationsInput>;
};

export type ServiceUpdateWithWhereUniqueWithoutLocationInput = {
  data: ServiceUpdateWithoutLocationInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpdateWithWhereUniqueWithoutServiceBenefitsInput = {
  data: ServiceUpdateWithoutServiceBenefitsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpdateWithWhereUniqueWithoutServiceCategoryInput = {
  data: ServiceUpdateWithoutServiceCategoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithoutServiceRequestsInput = {
  create: ServiceCreateWithoutServiceRequestsInput;
  update: ServiceUpdateWithoutServiceRequestsInput;
};

export type ServiceUpsertWithWhereUniqueWithoutLocationInput = {
  create: ServiceCreateWithoutLocationInput;
  update: ServiceUpdateWithoutLocationInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithWhereUniqueWithoutServiceBenefitsInput = {
  create: ServiceCreateWithoutServiceBenefitsInput;
  update: ServiceUpdateWithoutServiceBenefitsInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceUpsertWithWhereUniqueWithoutServiceCategoryInput = {
  create: ServiceCreateWithoutServiceCategoryInput;
  update: ServiceUpdateWithoutServiceCategoryInput;
  where: ServiceWhereUniqueInput;
};

export type ServiceWhereInput = {
  AND?: InputMaybe<Array<ServiceWhereInput>>;
  askForTime?: InputMaybe<BoolFilter>;
  categoryId?: InputMaybe<StringNullableFilter>;
  description?: InputMaybe<StringFilter>;
  displayCommentBox?: InputMaybe<BoolFilter>;
  externalId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  isInventoryBased?: InputMaybe<BoolNullableFilter>;
  label?: InputMaybe<StringNullableFilter>;
  largeDescription?: InputMaybe<StringNullableFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  moreInfoLink?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<ServiceWhereInput>>;
  OR?: InputMaybe<Array<ServiceWhereInput>>;
  price?: InputMaybe<FloatFilter>;
  serviceBenefits?: InputMaybe<ServiceBenefitListRelationFilter>;
  serviceCategory?: InputMaybe<ServiceCategoryRelationFilter>;
  serviceRequests?: InputMaybe<ServiceRequestListRelationFilter>;
  serviceRules?: InputMaybe<ServiceRuleListRelationFilter>;
  status?: InputMaybe<EnumServiceStatusNullableFilter>;
  thumbnail?: InputMaybe<StringNullableFilter>;
  title?: InputMaybe<StringFilter>;
  type?: InputMaybe<EnumServiceTypeFilter>;
};

export type ServiceWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type SetPaymentAccountTokenInput = {
  accountToken: Scalars['String'];
  entity: PaymentAccountEntity;
  kioskId?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
};

export type Shift4AuthorizeBodyResponse = {
  body: Scalars['JSONObject'];
};

export enum SortOrder {
  Asc = 'asc',
  Desc = 'desc'
}

export type SortOrderInput = {
  nulls?: InputMaybe<NullsOrder>;
  sort: SortOrder;
};

export type SquareCreateCustomerResponse = {
  id: Scalars['String'];
};

export type StringFieldUpdateOperationsInput = {
  set?: InputMaybe<Scalars['String']>;
};

export type StringFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableFilter = {
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringNullableWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntNullableFilter>;
  _max?: InputMaybe<NestedStringNullableFilter>;
  _min?: InputMaybe<NestedStringNullableFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringNullableWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StringWithAggregatesFilter = {
  _count?: InputMaybe<NestedIntFilter>;
  _max?: InputMaybe<NestedStringFilter>;
  _min?: InputMaybe<NestedStringFilter>;
  contains?: InputMaybe<Scalars['String']>;
  endsWith?: InputMaybe<Scalars['String']>;
  equals?: InputMaybe<Scalars['String']>;
  gt?: InputMaybe<Scalars['String']>;
  gte?: InputMaybe<Scalars['String']>;
  in?: InputMaybe<Array<Scalars['String']>>;
  lt?: InputMaybe<Scalars['String']>;
  lte?: InputMaybe<Scalars['String']>;
  mode?: InputMaybe<QueryMode>;
  not?: InputMaybe<NestedStringWithAggregatesFilter>;
  notIn?: InputMaybe<Array<Scalars['String']>>;
  startsWith?: InputMaybe<Scalars['String']>;
};

export type StripeTerminalTokenAnswer = {
  object: Scalars['String'];
  secret: Scalars['String'];
};

export type SuccessAnswer = {
  success: Scalars['Boolean'];
};

export type SupplementaryCard = {
  accessGrantId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  credentialId?: Maybe<Scalars['String']>;
  data: Scalars['String'];
  hasPaymentCapability?: Maybe<Scalars['Boolean']>;
  isActive: Scalars['Boolean'];
  keyId?: Maybe<Scalars['String']>;
  serialNumber: Scalars['String'];
};

export type SupplementaryCardAccessGrantIdSerialNumberCompoundUniqueInput = {
  accessGrantId: Scalars['String'];
  serialNumber: Scalars['String'];
};

export type SupplementaryCardCountAggregate = {
  _all: Scalars['Int'];
  accessGrantId: Scalars['Int'];
  createdAt: Scalars['Int'];
  credentialId: Scalars['Int'];
  data: Scalars['Int'];
  hasPaymentCapability: Scalars['Int'];
  isActive: Scalars['Int'];
  keyId: Scalars['Int'];
  serialNumber: Scalars['Int'];
};

export type SupplementaryCardCountOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credentialId?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  hasPaymentCapability?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  keyId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
};

export type SupplementaryCardCreateInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutSupplementaryCardsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutSupplementaryCardsInput>;
  data: Scalars['String'];
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
};

export type SupplementaryCardCreateManyAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentialId?: InputMaybe<Scalars['String']>;
  data: Scalars['String'];
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
};

export type SupplementaryCardCreateManyAccessGrantInputEnvelope = {
  data: Array<SupplementaryCardCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SupplementaryCardCreateManyCredentialInput = {
  accessGrantId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['String'];
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
};

export type SupplementaryCardCreateManyCredentialInputEnvelope = {
  data: Array<SupplementaryCardCreateManyCredentialInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type SupplementaryCardCreateManyInput = {
  accessGrantId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credentialId?: InputMaybe<Scalars['String']>;
  data: Scalars['String'];
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
};

export type SupplementaryCardCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SupplementaryCardCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<SupplementaryCardCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<SupplementaryCardCreateManyAccessGrantInputEnvelope>;
};

export type SupplementaryCardCreateNestedManyWithoutCredentialInput = {
  connect?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SupplementaryCardCreateOrConnectWithoutCredentialInput>>;
  create?: InputMaybe<Array<SupplementaryCardCreateWithoutCredentialInput>>;
  createMany?: InputMaybe<SupplementaryCardCreateManyCredentialInputEnvelope>;
};

export type SupplementaryCardCreateOrConnectWithoutAccessGrantInput = {
  create: SupplementaryCardCreateWithoutAccessGrantInput;
  where: SupplementaryCardWhereUniqueInput;
};

export type SupplementaryCardCreateOrConnectWithoutCredentialInput = {
  create: SupplementaryCardCreateWithoutCredentialInput;
  where: SupplementaryCardWhereUniqueInput;
};

export type SupplementaryCardCreateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  credential?: InputMaybe<CredentialCreateNestedOneWithoutSupplementaryCardsInput>;
  data: Scalars['String'];
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
};

export type SupplementaryCardCreateWithoutCredentialInput = {
  accessGrant: AccessGrantCreateNestedOneWithoutSupplementaryCardsInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  data: Scalars['String'];
  hasPaymentCapability?: InputMaybe<Scalars['Boolean']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  keyId?: InputMaybe<Scalars['String']>;
  serialNumber: Scalars['String'];
};

export type SupplementaryCardGroupBy = {
  _count?: Maybe<SupplementaryCardCountAggregate>;
  _max?: Maybe<SupplementaryCardMaxAggregate>;
  _min?: Maybe<SupplementaryCardMinAggregate>;
  accessGrantId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  credentialId?: Maybe<Scalars['String']>;
  data: Scalars['String'];
  hasPaymentCapability?: Maybe<Scalars['Boolean']>;
  isActive: Scalars['Boolean'];
  keyId?: Maybe<Scalars['String']>;
  serialNumber: Scalars['String'];
};

export type SupplementaryCardListRelationFilter = {
  every?: InputMaybe<SupplementaryCardWhereInput>;
  none?: InputMaybe<SupplementaryCardWhereInput>;
  some?: InputMaybe<SupplementaryCardWhereInput>;
};

export type SupplementaryCardMaxAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  credentialId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  hasPaymentCapability?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  keyId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type SupplementaryCardMaxOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credentialId?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  hasPaymentCapability?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  keyId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
};

export type SupplementaryCardMinAggregate = {
  accessGrantId?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  credentialId?: Maybe<Scalars['String']>;
  data?: Maybe<Scalars['String']>;
  hasPaymentCapability?: Maybe<Scalars['Boolean']>;
  isActive?: Maybe<Scalars['Boolean']>;
  keyId?: Maybe<Scalars['String']>;
  serialNumber?: Maybe<Scalars['String']>;
};

export type SupplementaryCardMinOrderByAggregateInput = {
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credentialId?: InputMaybe<SortOrder>;
  data?: InputMaybe<SortOrder>;
  hasPaymentCapability?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  keyId?: InputMaybe<SortOrder>;
  serialNumber?: InputMaybe<SortOrder>;
};

export type SupplementaryCardOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type SupplementaryCardOrderByWithAggregationInput = {
  _count?: InputMaybe<SupplementaryCardCountOrderByAggregateInput>;
  _max?: InputMaybe<SupplementaryCardMaxOrderByAggregateInput>;
  _min?: InputMaybe<SupplementaryCardMinOrderByAggregateInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credentialId?: InputMaybe<SortOrderInput>;
  data?: InputMaybe<SortOrder>;
  hasPaymentCapability?: InputMaybe<SortOrderInput>;
  isActive?: InputMaybe<SortOrder>;
  keyId?: InputMaybe<SortOrderInput>;
  serialNumber?: InputMaybe<SortOrder>;
};

export type SupplementaryCardOrderByWithRelationInput = {
  accessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  credential?: InputMaybe<CredentialOrderByWithRelationInput>;
  credentialId?: InputMaybe<SortOrderInput>;
  data?: InputMaybe<SortOrder>;
  hasPaymentCapability?: InputMaybe<SortOrderInput>;
  isActive?: InputMaybe<SortOrder>;
  keyId?: InputMaybe<SortOrderInput>;
  serialNumber?: InputMaybe<SortOrder>;
};

export enum SupplementaryCardScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  CreatedAt = 'createdAt',
  CredentialId = 'credentialId',
  Data = 'data',
  HasPaymentCapability = 'hasPaymentCapability',
  IsActive = 'isActive',
  KeyId = 'keyId',
  SerialNumber = 'serialNumber'
}

export type SupplementaryCardScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<SupplementaryCardScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credentialId?: InputMaybe<StringNullableFilter>;
  data?: InputMaybe<StringFilter>;
  hasPaymentCapability?: InputMaybe<BoolNullableFilter>;
  isActive?: InputMaybe<BoolFilter>;
  keyId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<SupplementaryCardScalarWhereInput>>;
  OR?: InputMaybe<Array<SupplementaryCardScalarWhereInput>>;
  serialNumber?: InputMaybe<StringFilter>;
};

export type SupplementaryCardScalarWhereWithAggregatesInput = {
  accessGrantId?: InputMaybe<StringWithAggregatesFilter>;
  AND?: InputMaybe<Array<SupplementaryCardScalarWhereWithAggregatesInput>>;
  createdAt?: InputMaybe<DateTimeWithAggregatesFilter>;
  credentialId?: InputMaybe<StringNullableWithAggregatesFilter>;
  data?: InputMaybe<StringWithAggregatesFilter>;
  hasPaymentCapability?: InputMaybe<BoolNullableWithAggregatesFilter>;
  isActive?: InputMaybe<BoolWithAggregatesFilter>;
  keyId?: InputMaybe<StringNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<SupplementaryCardScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<SupplementaryCardScalarWhereWithAggregatesInput>>;
  serialNumber?: InputMaybe<StringWithAggregatesFilter>;
};

export type SupplementaryCardUpdateInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutSupplementaryCardsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutSupplementaryCardsNestedInput>;
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasPaymentCapability?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SupplementaryCardUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasPaymentCapability?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SupplementaryCardUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SupplementaryCardCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<SupplementaryCardCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<SupplementaryCardCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SupplementaryCardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  set?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  update?: InputMaybe<Array<SupplementaryCardUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<SupplementaryCardUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<SupplementaryCardUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type SupplementaryCardUpdateManyWithoutCredentialNestedInput = {
  connect?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<SupplementaryCardCreateOrConnectWithoutCredentialInput>>;
  create?: InputMaybe<Array<SupplementaryCardCreateWithoutCredentialInput>>;
  createMany?: InputMaybe<SupplementaryCardCreateManyCredentialInputEnvelope>;
  delete?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<SupplementaryCardScalarWhereInput>>;
  disconnect?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  set?: InputMaybe<Array<SupplementaryCardWhereUniqueInput>>;
  update?: InputMaybe<Array<SupplementaryCardUpdateWithWhereUniqueWithoutCredentialInput>>;
  updateMany?: InputMaybe<Array<SupplementaryCardUpdateManyWithWhereWithoutCredentialInput>>;
  upsert?: InputMaybe<Array<SupplementaryCardUpsertWithWhereUniqueWithoutCredentialInput>>;
};

export type SupplementaryCardUpdateManyWithWhereWithoutAccessGrantInput = {
  data: SupplementaryCardUpdateManyMutationInput;
  where: SupplementaryCardScalarWhereInput;
};

export type SupplementaryCardUpdateManyWithWhereWithoutCredentialInput = {
  data: SupplementaryCardUpdateManyMutationInput;
  where: SupplementaryCardScalarWhereInput;
};

export type SupplementaryCardUpdateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  credential?: InputMaybe<CredentialUpdateOneWithoutSupplementaryCardsNestedInput>;
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasPaymentCapability?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SupplementaryCardUpdateWithoutCredentialInput = {
  accessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutSupplementaryCardsNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  data?: InputMaybe<StringFieldUpdateOperationsInput>;
  hasPaymentCapability?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  keyId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  serialNumber?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type SupplementaryCardUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: SupplementaryCardUpdateWithoutAccessGrantInput;
  where: SupplementaryCardWhereUniqueInput;
};

export type SupplementaryCardUpdateWithWhereUniqueWithoutCredentialInput = {
  data: SupplementaryCardUpdateWithoutCredentialInput;
  where: SupplementaryCardWhereUniqueInput;
};

export type SupplementaryCardUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: SupplementaryCardCreateWithoutAccessGrantInput;
  update: SupplementaryCardUpdateWithoutAccessGrantInput;
  where: SupplementaryCardWhereUniqueInput;
};

export type SupplementaryCardUpsertWithWhereUniqueWithoutCredentialInput = {
  create: SupplementaryCardCreateWithoutCredentialInput;
  update: SupplementaryCardUpdateWithoutCredentialInput;
  where: SupplementaryCardWhereUniqueInput;
};

export type SupplementaryCardWhereInput = {
  accessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<SupplementaryCardWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  credential?: InputMaybe<CredentialRelationFilter>;
  credentialId?: InputMaybe<StringNullableFilter>;
  data?: InputMaybe<StringFilter>;
  hasPaymentCapability?: InputMaybe<BoolNullableFilter>;
  isActive?: InputMaybe<BoolFilter>;
  keyId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<SupplementaryCardWhereInput>>;
  OR?: InputMaybe<Array<SupplementaryCardWhereInput>>;
  serialNumber?: InputMaybe<StringFilter>;
};

export type SupplementaryCardWhereUniqueInput = {
  accessGrantId_serialNumber?: InputMaybe<SupplementaryCardAccessGrantIdSerialNumberCompoundUniqueInput>;
};

export type TemporaryQrResponse = {
  confirmationCode?: Maybe<Scalars['String']>;
  error?: Maybe<Scalars['String']>;
  errorCode?: Maybe<Scalars['String']>;
  expiresAt?: Maybe<Scalars['DateTime']>;
  qrCodeBase64?: Maybe<Scalars['String']>;
};

export type Tenant = {
  _count?: Maybe<TenantCount>;
  accessGrants: Array<AccessGrant>;
  apiKey: Scalars['String'];
  callRecords: Array<CallRecord>;
  emailFrom?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internalApiKeys: Array<InternalApiKey>;
  kiosks: Array<Kiosk>;
  locationGroups: Array<LocationGroup>;
  locations: Array<Location>;
  memberships: Array<Membership>;
  name: Scalars['String'];
  Notification: Array<Notification>;
  Payment: Array<Payment>;
  paymentProvider?: Maybe<PaymentProvider>;
  paymentProviderId?: Maybe<Scalars['String']>;
  pms: Array<Pms>;
  pmsConfigByType?: Maybe<Scalars['JSON']>;
  resourceGroups: Array<ResourceGroup>;
  resources: Array<Resource>;
  theme: Scalars['JSON'];
  userRecords: Array<UserRecord>;
  UserTenantData: Array<UserTenantData>;
};


export type TenantAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type TenantCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type TenantInternalApiKeysArgs = {
  cursor?: InputMaybe<InternalApiKeyWhereUniqueInput>;
  distinct?: InputMaybe<Array<InternalApiKeyScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InternalApiKeyOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InternalApiKeyWhereInput>;
};


export type TenantKiosksArgs = {
  cursor?: InputMaybe<KioskWhereUniqueInput>;
  distinct?: InputMaybe<Array<KioskScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
};


export type TenantLocationGroupsArgs = {
  cursor?: InputMaybe<LocationGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationGroupWhereInput>;
};


export type TenantLocationsArgs = {
  cursor?: InputMaybe<LocationWhereUniqueInput>;
  distinct?: InputMaybe<Array<LocationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
};


export type TenantMembershipsArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type TenantNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type TenantPaymentArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type TenantPmsArgs = {
  cursor?: InputMaybe<PmsWhereUniqueInput>;
  distinct?: InputMaybe<Array<PmsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PmsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PmsWhereInput>;
};


export type TenantResourceGroupsArgs = {
  cursor?: InputMaybe<ResourceGroupWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceGroupScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type TenantResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};


export type TenantUserRecordsArgs = {
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type TenantUserTenantDataArgs = {
  cursor?: InputMaybe<UserTenantDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTenantDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};

export type TenantCount = {
  accessGrants: Scalars['Int'];
  callRecords: Scalars['Int'];
  internalApiKeys: Scalars['Int'];
  kiosks: Scalars['Int'];
  locationGroups: Scalars['Int'];
  locations: Scalars['Int'];
  memberships: Scalars['Int'];
  Notification: Scalars['Int'];
  Payment: Scalars['Int'];
  pms: Scalars['Int'];
  resourceGroups: Scalars['Int'];
  resources: Scalars['Int'];
  userRecords: Scalars['Int'];
  UserTenantData: Scalars['Int'];
};


export type TenantCountAccessGrantsArgs = {
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type TenantCountCallRecordsArgs = {
  where?: InputMaybe<CallRecordWhereInput>;
};


export type TenantCountInternalApiKeysArgs = {
  where?: InputMaybe<InternalApiKeyWhereInput>;
};


export type TenantCountKiosksArgs = {
  where?: InputMaybe<KioskWhereInput>;
};


export type TenantCountLocationGroupsArgs = {
  where?: InputMaybe<LocationGroupWhereInput>;
};


export type TenantCountLocationsArgs = {
  where?: InputMaybe<LocationWhereInput>;
};


export type TenantCountMembershipsArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};


export type TenantCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type TenantCountPaymentArgs = {
  where?: InputMaybe<PaymentWhereInput>;
};


export type TenantCountPmsArgs = {
  where?: InputMaybe<PmsWhereInput>;
};


export type TenantCountResourceGroupsArgs = {
  where?: InputMaybe<ResourceGroupWhereInput>;
};


export type TenantCountResourcesArgs = {
  where?: InputMaybe<ResourceWhereInput>;
};


export type TenantCountUserRecordsArgs = {
  where?: InputMaybe<UserRecordWhereInput>;
};


export type TenantCountUserTenantDataArgs = {
  where?: InputMaybe<UserTenantDataWhereInput>;
};

export type TenantCountAggregate = {
  _all: Scalars['Int'];
  apiKey: Scalars['Int'];
  emailFrom: Scalars['Int'];
  id: Scalars['Int'];
  name: Scalars['Int'];
  paymentProviderId: Scalars['Int'];
  pmsConfigByType: Scalars['Int'];
  theme: Scalars['Int'];
};

export type TenantCountOrderByAggregateInput = {
  apiKey?: InputMaybe<SortOrder>;
  emailFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  paymentProviderId?: InputMaybe<SortOrder>;
  pmsConfigByType?: InputMaybe<SortOrder>;
  theme?: InputMaybe<SortOrder>;
};

export type TenantCreateInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateManyInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  paymentProviderId?: InputMaybe<Scalars['String']>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  theme: Scalars['JSON'];
};

export type TenantCreateManyPaymentProviderInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  theme: Scalars['JSON'];
};

export type TenantCreateManyPaymentProviderInputEnvelope = {
  data: Array<TenantCreateManyPaymentProviderInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type TenantCreateNestedManyWithoutPaymentProviderInput = {
  connect?: InputMaybe<Array<TenantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TenantCreateOrConnectWithoutPaymentProviderInput>>;
  create?: InputMaybe<Array<TenantCreateWithoutPaymentProviderInput>>;
  createMany?: InputMaybe<TenantCreateManyPaymentProviderInputEnvelope>;
};

export type TenantCreateNestedOneWithoutAccessGrantsInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutAccessGrantsInput>;
  create?: InputMaybe<TenantCreateWithoutAccessGrantsInput>;
};

export type TenantCreateNestedOneWithoutCallRecordsInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutCallRecordsInput>;
  create?: InputMaybe<TenantCreateWithoutCallRecordsInput>;
};

export type TenantCreateNestedOneWithoutInternalApiKeysInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutInternalApiKeysInput>;
  create?: InputMaybe<TenantCreateWithoutInternalApiKeysInput>;
};

export type TenantCreateNestedOneWithoutKiosksInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutKiosksInput>;
  create?: InputMaybe<TenantCreateWithoutKiosksInput>;
};

export type TenantCreateNestedOneWithoutLocationGroupsInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutLocationGroupsInput>;
  create?: InputMaybe<TenantCreateWithoutLocationGroupsInput>;
};

export type TenantCreateNestedOneWithoutLocationsInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutLocationsInput>;
  create?: InputMaybe<TenantCreateWithoutLocationsInput>;
};

export type TenantCreateNestedOneWithoutMembershipsInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<TenantCreateWithoutMembershipsInput>;
};

export type TenantCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<TenantCreateWithoutNotificationInput>;
};

export type TenantCreateNestedOneWithoutPaymentInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<TenantCreateWithoutPaymentInput>;
};

export type TenantCreateNestedOneWithoutPmsInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutPmsInput>;
  create?: InputMaybe<TenantCreateWithoutPmsInput>;
};

export type TenantCreateNestedOneWithoutResourceGroupsInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutResourceGroupsInput>;
  create?: InputMaybe<TenantCreateWithoutResourceGroupsInput>;
};

export type TenantCreateNestedOneWithoutResourcesInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutResourcesInput>;
  create?: InputMaybe<TenantCreateWithoutResourcesInput>;
};

export type TenantCreateNestedOneWithoutUserRecordsInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutUserRecordsInput>;
  create?: InputMaybe<TenantCreateWithoutUserRecordsInput>;
};

export type TenantCreateNestedOneWithoutUserTenantDataInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutUserTenantDataInput>;
  create?: InputMaybe<TenantCreateWithoutUserTenantDataInput>;
};

export type TenantCreateOrConnectWithoutAccessGrantsInput = {
  create: TenantCreateWithoutAccessGrantsInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutCallRecordsInput = {
  create: TenantCreateWithoutCallRecordsInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutInternalApiKeysInput = {
  create: TenantCreateWithoutInternalApiKeysInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutKiosksInput = {
  create: TenantCreateWithoutKiosksInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutLocationGroupsInput = {
  create: TenantCreateWithoutLocationGroupsInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutLocationsInput = {
  create: TenantCreateWithoutLocationsInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutMembershipsInput = {
  create: TenantCreateWithoutMembershipsInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutNotificationInput = {
  create: TenantCreateWithoutNotificationInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutPaymentInput = {
  create: TenantCreateWithoutPaymentInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutPaymentProviderInput = {
  create: TenantCreateWithoutPaymentProviderInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutPmsInput = {
  create: TenantCreateWithoutPmsInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutResourceGroupsInput = {
  create: TenantCreateWithoutResourceGroupsInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutResourcesInput = {
  create: TenantCreateWithoutResourcesInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutUserRecordsInput = {
  create: TenantCreateWithoutUserRecordsInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateOrConnectWithoutUserTenantDataInput = {
  create: TenantCreateWithoutUserTenantDataInput;
  where: TenantWhereUniqueInput;
};

export type TenantCreateWithoutAccessGrantsInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutCallRecordsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutInternalApiKeysInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutKiosksInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutLocationGroupsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutLocationsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutMembershipsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutNotificationInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutPaymentInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutPaymentProviderInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutPmsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutResourceGroupsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutResourcesInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutUserRecordsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutTenantInput>;
};

export type TenantCreateWithoutUserTenantDataInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutTenantInput>;
  apiKey?: InputMaybe<Scalars['String']>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutTenantInput>;
  emailFrom?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiKeys?: InputMaybe<InternalApiKeyCreateNestedManyWithoutTenantInput>;
  kiosks?: InputMaybe<KioskCreateNestedManyWithoutTenantInput>;
  locationGroups?: InputMaybe<LocationGroupCreateNestedManyWithoutTenantInput>;
  locations?: InputMaybe<LocationCreateNestedManyWithoutTenantInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutTenantInput>;
  name: Scalars['String'];
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutTenantInput>;
  Payment?: InputMaybe<PaymentCreateNestedManyWithoutTenantInput>;
  paymentProvider?: InputMaybe<PaymentProviderCreateNestedOneWithoutTenantInput>;
  pms?: InputMaybe<PmsCreateNestedManyWithoutTenantInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupCreateNestedManyWithoutTenantInput>;
  resources?: InputMaybe<ResourceCreateNestedManyWithoutTenantInput>;
  theme: Scalars['JSON'];
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutTenantInput>;
};

export type TenantGroupBy = {
  _count?: Maybe<TenantCountAggregate>;
  _max?: Maybe<TenantMaxAggregate>;
  _min?: Maybe<TenantMinAggregate>;
  apiKey: Scalars['String'];
  emailFrom?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  name: Scalars['String'];
  paymentProviderId?: Maybe<Scalars['String']>;
  pmsConfigByType?: Maybe<Scalars['JSON']>;
  theme: Scalars['JSON'];
};

export type TenantListRelationFilter = {
  every?: InputMaybe<TenantWhereInput>;
  none?: InputMaybe<TenantWhereInput>;
  some?: InputMaybe<TenantWhereInput>;
};

export type TenantLocation = {
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TenantMaxAggregate = {
  apiKey?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentProviderId?: Maybe<Scalars['String']>;
};

export type TenantMaxOrderByAggregateInput = {
  apiKey?: InputMaybe<SortOrder>;
  emailFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  paymentProviderId?: InputMaybe<SortOrder>;
};

export type TenantMembership = {
  id: Scalars['String'];
  locations?: Maybe<Array<LocationMembership>>;
  name: Scalars['String'];
};

export type TenantMinAggregate = {
  apiKey?: Maybe<Scalars['String']>;
  emailFrom?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  paymentProviderId?: Maybe<Scalars['String']>;
};

export type TenantMinOrderByAggregateInput = {
  apiKey?: InputMaybe<SortOrder>;
  emailFrom?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  paymentProviderId?: InputMaybe<SortOrder>;
};

export type TenantOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type TenantOrderByWithAggregationInput = {
  _count?: InputMaybe<TenantCountOrderByAggregateInput>;
  _max?: InputMaybe<TenantMaxOrderByAggregateInput>;
  _min?: InputMaybe<TenantMinOrderByAggregateInput>;
  apiKey?: InputMaybe<SortOrder>;
  emailFrom?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  name?: InputMaybe<SortOrder>;
  paymentProviderId?: InputMaybe<SortOrderInput>;
  pmsConfigByType?: InputMaybe<SortOrderInput>;
  theme?: InputMaybe<SortOrder>;
};

export type TenantOrderByWithRelationInput = {
  accessGrants?: InputMaybe<AccessGrantOrderByRelationAggregateInput>;
  apiKey?: InputMaybe<SortOrder>;
  callRecords?: InputMaybe<CallRecordOrderByRelationAggregateInput>;
  emailFrom?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  internalApiKeys?: InputMaybe<InternalApiKeyOrderByRelationAggregateInput>;
  kiosks?: InputMaybe<KioskOrderByRelationAggregateInput>;
  locationGroups?: InputMaybe<LocationGroupOrderByRelationAggregateInput>;
  locations?: InputMaybe<LocationOrderByRelationAggregateInput>;
  memberships?: InputMaybe<MembershipOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrder>;
  Notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  Payment?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  paymentProvider?: InputMaybe<PaymentProviderOrderByWithRelationInput>;
  paymentProviderId?: InputMaybe<SortOrderInput>;
  pms?: InputMaybe<PmsOrderByRelationAggregateInput>;
  pmsConfigByType?: InputMaybe<SortOrderInput>;
  resourceGroups?: InputMaybe<ResourceGroupOrderByRelationAggregateInput>;
  resources?: InputMaybe<ResourceOrderByRelationAggregateInput>;
  theme?: InputMaybe<SortOrder>;
  userRecords?: InputMaybe<UserRecordOrderByRelationAggregateInput>;
  UserTenantData?: InputMaybe<UserTenantDataOrderByRelationAggregateInput>;
};

export type TenantRelationFilter = {
  is?: InputMaybe<TenantWhereInput>;
  isNot?: InputMaybe<TenantWhereInput>;
};

export enum TenantScalarFieldEnum {
  ApiKey = 'apiKey',
  EmailFrom = 'emailFrom',
  Id = 'id',
  Name = 'name',
  PaymentProviderId = 'paymentProviderId',
  PmsConfigByType = 'pmsConfigByType',
  Theme = 'theme'
}

export type TenantScalarWhereInput = {
  AND?: InputMaybe<Array<TenantScalarWhereInput>>;
  apiKey?: InputMaybe<StringFilter>;
  emailFrom?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<TenantScalarWhereInput>>;
  OR?: InputMaybe<Array<TenantScalarWhereInput>>;
  paymentProviderId?: InputMaybe<StringNullableFilter>;
  pmsConfigByType?: InputMaybe<JsonNullableFilter>;
  theme?: InputMaybe<JsonFilter>;
};

export type TenantScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<TenantScalarWhereWithAggregatesInput>>;
  apiKey?: InputMaybe<StringWithAggregatesFilter>;
  emailFrom?: InputMaybe<StringNullableWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  name?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<TenantScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<TenantScalarWhereWithAggregatesInput>>;
  paymentProviderId?: InputMaybe<StringNullableWithAggregatesFilter>;
  pmsConfigByType?: InputMaybe<JsonNullableWithAggregatesFilter>;
  theme?: InputMaybe<JsonWithAggregatesFilter>;
};

export type TenantUpdateInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateManyMutationInput = {
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  theme?: InputMaybe<Scalars['JSON']>;
};

export type TenantUpdateManyWithoutPaymentProviderNestedInput = {
  connect?: InputMaybe<Array<TenantWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<TenantCreateOrConnectWithoutPaymentProviderInput>>;
  create?: InputMaybe<Array<TenantCreateWithoutPaymentProviderInput>>;
  createMany?: InputMaybe<TenantCreateManyPaymentProviderInputEnvelope>;
  delete?: InputMaybe<Array<TenantWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<TenantScalarWhereInput>>;
  disconnect?: InputMaybe<Array<TenantWhereUniqueInput>>;
  set?: InputMaybe<Array<TenantWhereUniqueInput>>;
  update?: InputMaybe<Array<TenantUpdateWithWhereUniqueWithoutPaymentProviderInput>>;
  updateMany?: InputMaybe<Array<TenantUpdateManyWithWhereWithoutPaymentProviderInput>>;
  upsert?: InputMaybe<Array<TenantUpsertWithWhereUniqueWithoutPaymentProviderInput>>;
};

export type TenantUpdateManyWithWhereWithoutPaymentProviderInput = {
  data: TenantUpdateManyMutationInput;
  where: TenantScalarWhereInput;
};

export type TenantUpdateOneRequiredWithoutAccessGrantsNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutAccessGrantsInput>;
  create?: InputMaybe<TenantCreateWithoutAccessGrantsInput>;
  update?: InputMaybe<TenantUpdateWithoutAccessGrantsInput>;
  upsert?: InputMaybe<TenantUpsertWithoutAccessGrantsInput>;
};

export type TenantUpdateOneRequiredWithoutInternalApiKeysNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutInternalApiKeysInput>;
  create?: InputMaybe<TenantCreateWithoutInternalApiKeysInput>;
  update?: InputMaybe<TenantUpdateWithoutInternalApiKeysInput>;
  upsert?: InputMaybe<TenantUpsertWithoutInternalApiKeysInput>;
};

export type TenantUpdateOneRequiredWithoutKiosksNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutKiosksInput>;
  create?: InputMaybe<TenantCreateWithoutKiosksInput>;
  update?: InputMaybe<TenantUpdateWithoutKiosksInput>;
  upsert?: InputMaybe<TenantUpsertWithoutKiosksInput>;
};

export type TenantUpdateOneRequiredWithoutLocationGroupsNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutLocationGroupsInput>;
  create?: InputMaybe<TenantCreateWithoutLocationGroupsInput>;
  update?: InputMaybe<TenantUpdateWithoutLocationGroupsInput>;
  upsert?: InputMaybe<TenantUpsertWithoutLocationGroupsInput>;
};

export type TenantUpdateOneRequiredWithoutLocationsNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutLocationsInput>;
  create?: InputMaybe<TenantCreateWithoutLocationsInput>;
  update?: InputMaybe<TenantUpdateWithoutLocationsInput>;
  upsert?: InputMaybe<TenantUpsertWithoutLocationsInput>;
};

export type TenantUpdateOneRequiredWithoutMembershipsNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<TenantCreateWithoutMembershipsInput>;
  update?: InputMaybe<TenantUpdateWithoutMembershipsInput>;
  upsert?: InputMaybe<TenantUpsertWithoutMembershipsInput>;
};

export type TenantUpdateOneRequiredWithoutPaymentNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutPaymentInput>;
  create?: InputMaybe<TenantCreateWithoutPaymentInput>;
  update?: InputMaybe<TenantUpdateWithoutPaymentInput>;
  upsert?: InputMaybe<TenantUpsertWithoutPaymentInput>;
};

export type TenantUpdateOneRequiredWithoutPmsNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutPmsInput>;
  create?: InputMaybe<TenantCreateWithoutPmsInput>;
  update?: InputMaybe<TenantUpdateWithoutPmsInput>;
  upsert?: InputMaybe<TenantUpsertWithoutPmsInput>;
};

export type TenantUpdateOneRequiredWithoutResourceGroupsNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutResourceGroupsInput>;
  create?: InputMaybe<TenantCreateWithoutResourceGroupsInput>;
  update?: InputMaybe<TenantUpdateWithoutResourceGroupsInput>;
  upsert?: InputMaybe<TenantUpsertWithoutResourceGroupsInput>;
};

export type TenantUpdateOneRequiredWithoutResourcesNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutResourcesInput>;
  create?: InputMaybe<TenantCreateWithoutResourcesInput>;
  update?: InputMaybe<TenantUpdateWithoutResourcesInput>;
  upsert?: InputMaybe<TenantUpsertWithoutResourcesInput>;
};

export type TenantUpdateOneRequiredWithoutUserRecordsNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutUserRecordsInput>;
  create?: InputMaybe<TenantCreateWithoutUserRecordsInput>;
  update?: InputMaybe<TenantUpdateWithoutUserRecordsInput>;
  upsert?: InputMaybe<TenantUpsertWithoutUserRecordsInput>;
};

export type TenantUpdateOneRequiredWithoutUserTenantDataNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutUserTenantDataInput>;
  create?: InputMaybe<TenantCreateWithoutUserTenantDataInput>;
  update?: InputMaybe<TenantUpdateWithoutUserTenantDataInput>;
  upsert?: InputMaybe<TenantUpsertWithoutUserTenantDataInput>;
};

export type TenantUpdateOneWithoutCallRecordsNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutCallRecordsInput>;
  create?: InputMaybe<TenantCreateWithoutCallRecordsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TenantUpdateWithoutCallRecordsInput>;
  upsert?: InputMaybe<TenantUpsertWithoutCallRecordsInput>;
};

export type TenantUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<TenantWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TenantCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<TenantCreateWithoutNotificationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TenantUpdateWithoutNotificationInput>;
  upsert?: InputMaybe<TenantUpsertWithoutNotificationInput>;
};

export type TenantUpdateWithoutAccessGrantsInput = {
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutCallRecordsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutInternalApiKeysInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutKiosksInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutLocationGroupsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutLocationsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutMembershipsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutNotificationInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutPaymentInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutPaymentProviderInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutPmsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutResourceGroupsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutResourcesInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutUserRecordsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithoutUserTenantDataInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutTenantNestedInput>;
  apiKey?: InputMaybe<StringFieldUpdateOperationsInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutTenantNestedInput>;
  emailFrom?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiKeys?: InputMaybe<InternalApiKeyUpdateManyWithoutTenantNestedInput>;
  kiosks?: InputMaybe<KioskUpdateManyWithoutTenantNestedInput>;
  locationGroups?: InputMaybe<LocationGroupUpdateManyWithoutTenantNestedInput>;
  locations?: InputMaybe<LocationUpdateManyWithoutTenantNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutTenantNestedInput>;
  name?: InputMaybe<StringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutTenantNestedInput>;
  Payment?: InputMaybe<PaymentUpdateManyWithoutTenantNestedInput>;
  paymentProvider?: InputMaybe<PaymentProviderUpdateOneWithoutTenantNestedInput>;
  pms?: InputMaybe<PmsUpdateManyWithoutTenantNestedInput>;
  pmsConfigByType?: InputMaybe<Scalars['JSON']>;
  resourceGroups?: InputMaybe<ResourceGroupUpdateManyWithoutTenantNestedInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutTenantNestedInput>;
  theme?: InputMaybe<Scalars['JSON']>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutTenantNestedInput>;
};

export type TenantUpdateWithWhereUniqueWithoutPaymentProviderInput = {
  data: TenantUpdateWithoutPaymentProviderInput;
  where: TenantWhereUniqueInput;
};

export type TenantUpsertWithoutAccessGrantsInput = {
  create: TenantCreateWithoutAccessGrantsInput;
  update: TenantUpdateWithoutAccessGrantsInput;
};

export type TenantUpsertWithoutCallRecordsInput = {
  create: TenantCreateWithoutCallRecordsInput;
  update: TenantUpdateWithoutCallRecordsInput;
};

export type TenantUpsertWithoutInternalApiKeysInput = {
  create: TenantCreateWithoutInternalApiKeysInput;
  update: TenantUpdateWithoutInternalApiKeysInput;
};

export type TenantUpsertWithoutKiosksInput = {
  create: TenantCreateWithoutKiosksInput;
  update: TenantUpdateWithoutKiosksInput;
};

export type TenantUpsertWithoutLocationGroupsInput = {
  create: TenantCreateWithoutLocationGroupsInput;
  update: TenantUpdateWithoutLocationGroupsInput;
};

export type TenantUpsertWithoutLocationsInput = {
  create: TenantCreateWithoutLocationsInput;
  update: TenantUpdateWithoutLocationsInput;
};

export type TenantUpsertWithoutMembershipsInput = {
  create: TenantCreateWithoutMembershipsInput;
  update: TenantUpdateWithoutMembershipsInput;
};

export type TenantUpsertWithoutNotificationInput = {
  create: TenantCreateWithoutNotificationInput;
  update: TenantUpdateWithoutNotificationInput;
};

export type TenantUpsertWithoutPaymentInput = {
  create: TenantCreateWithoutPaymentInput;
  update: TenantUpdateWithoutPaymentInput;
};

export type TenantUpsertWithoutPmsInput = {
  create: TenantCreateWithoutPmsInput;
  update: TenantUpdateWithoutPmsInput;
};

export type TenantUpsertWithoutResourceGroupsInput = {
  create: TenantCreateWithoutResourceGroupsInput;
  update: TenantUpdateWithoutResourceGroupsInput;
};

export type TenantUpsertWithoutResourcesInput = {
  create: TenantCreateWithoutResourcesInput;
  update: TenantUpdateWithoutResourcesInput;
};

export type TenantUpsertWithoutUserRecordsInput = {
  create: TenantCreateWithoutUserRecordsInput;
  update: TenantUpdateWithoutUserRecordsInput;
};

export type TenantUpsertWithoutUserTenantDataInput = {
  create: TenantCreateWithoutUserTenantDataInput;
  update: TenantUpdateWithoutUserTenantDataInput;
};

export type TenantUpsertWithWhereUniqueWithoutPaymentProviderInput = {
  create: TenantCreateWithoutPaymentProviderInput;
  update: TenantUpdateWithoutPaymentProviderInput;
  where: TenantWhereUniqueInput;
};

export type TenantWhereInput = {
  accessGrants?: InputMaybe<AccessGrantListRelationFilter>;
  AND?: InputMaybe<Array<TenantWhereInput>>;
  apiKey?: InputMaybe<StringFilter>;
  callRecords?: InputMaybe<CallRecordListRelationFilter>;
  emailFrom?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  internalApiKeys?: InputMaybe<InternalApiKeyListRelationFilter>;
  kiosks?: InputMaybe<KioskListRelationFilter>;
  locationGroups?: InputMaybe<LocationGroupListRelationFilter>;
  locations?: InputMaybe<LocationListRelationFilter>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  name?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<TenantWhereInput>>;
  Notification?: InputMaybe<NotificationListRelationFilter>;
  OR?: InputMaybe<Array<TenantWhereInput>>;
  Payment?: InputMaybe<PaymentListRelationFilter>;
  paymentProvider?: InputMaybe<PaymentProviderRelationFilter>;
  paymentProviderId?: InputMaybe<StringNullableFilter>;
  pms?: InputMaybe<PmsListRelationFilter>;
  pmsConfigByType?: InputMaybe<JsonNullableFilter>;
  resourceGroups?: InputMaybe<ResourceGroupListRelationFilter>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  theme?: InputMaybe<JsonFilter>;
  userRecords?: InputMaybe<UserRecordListRelationFilter>;
  UserTenantData?: InputMaybe<UserTenantDataListRelationFilter>;
};

export type TenantWhereUniqueInput = {
  apiKey?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
};

export type Theme = {
  componentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityType;
  id: Scalars['String'];
  setting: Scalars['JSON'];
};

export type ThemeAnswer = {
  setting: Scalars['JSONObject'];
};

export type ThemeComponentIdEntityIdCompoundUniqueInput = {
  componentId: Scalars['String'];
  entityId: Scalars['String'];
};

export type ThemeCountAggregate = {
  _all: Scalars['Int'];
  componentId: Scalars['Int'];
  entityId: Scalars['Int'];
  entityType: Scalars['Int'];
  id: Scalars['Int'];
  setting: Scalars['Int'];
};

export type ThemeCountOrderByAggregateInput = {
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  setting?: InputMaybe<SortOrder>;
};

export type ThemeCreateInput = {
  component: ComponentCreateNestedOneWithoutThemeInput;
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  setting: Scalars['JSON'];
};

export type ThemeCreateManyComponentInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  setting: Scalars['JSON'];
};

export type ThemeCreateManyComponentInputEnvelope = {
  data: Array<ThemeCreateManyComponentInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type ThemeCreateManyInput = {
  componentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  setting: Scalars['JSON'];
};

export type ThemeCreateNestedManyWithoutComponentInput = {
  connect?: InputMaybe<Array<ThemeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ThemeCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<ThemeCreateWithoutComponentInput>>;
  createMany?: InputMaybe<ThemeCreateManyComponentInputEnvelope>;
};

export type ThemeCreateOrConnectWithoutComponentInput = {
  create: ThemeCreateWithoutComponentInput;
  where: ThemeWhereUniqueInput;
};

export type ThemeCreateWithoutComponentInput = {
  entityId: Scalars['String'];
  entityType: EntityType;
  id?: InputMaybe<Scalars['String']>;
  setting: Scalars['JSON'];
};

export type ThemeGroupBy = {
  _count?: Maybe<ThemeCountAggregate>;
  _max?: Maybe<ThemeMaxAggregate>;
  _min?: Maybe<ThemeMinAggregate>;
  componentId: Scalars['String'];
  entityId: Scalars['String'];
  entityType: EntityType;
  id: Scalars['String'];
  setting: Scalars['JSON'];
};

export type ThemeListRelationFilter = {
  every?: InputMaybe<ThemeWhereInput>;
  none?: InputMaybe<ThemeWhereInput>;
  some?: InputMaybe<ThemeWhereInput>;
};

export type ThemeMaxAggregate = {
  componentId?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EntityType>;
  id?: Maybe<Scalars['String']>;
};

export type ThemeMaxOrderByAggregateInput = {
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ThemeMinAggregate = {
  componentId?: Maybe<Scalars['String']>;
  entityId?: Maybe<Scalars['String']>;
  entityType?: Maybe<EntityType>;
  id?: Maybe<Scalars['String']>;
};

export type ThemeMinOrderByAggregateInput = {
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
};

export type ThemeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type ThemeOrderByWithAggregationInput = {
  _count?: InputMaybe<ThemeCountOrderByAggregateInput>;
  _max?: InputMaybe<ThemeMaxOrderByAggregateInput>;
  _min?: InputMaybe<ThemeMinOrderByAggregateInput>;
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  setting?: InputMaybe<SortOrder>;
};

export type ThemeOrderByWithRelationInput = {
  component?: InputMaybe<ComponentOrderByWithRelationInput>;
  componentId?: InputMaybe<SortOrder>;
  entityId?: InputMaybe<SortOrder>;
  entityType?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  setting?: InputMaybe<SortOrder>;
};

export enum ThemeScalarFieldEnum {
  ComponentId = 'componentId',
  EntityId = 'entityId',
  EntityType = 'entityType',
  Id = 'id',
  Setting = 'setting'
}

export type ThemeScalarWhereInput = {
  AND?: InputMaybe<Array<ThemeScalarWhereInput>>;
  componentId?: InputMaybe<StringFilter>;
  entityId?: InputMaybe<StringFilter>;
  entityType?: InputMaybe<EnumEntityTypeFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ThemeScalarWhereInput>>;
  OR?: InputMaybe<Array<ThemeScalarWhereInput>>;
  setting?: InputMaybe<JsonFilter>;
};

export type ThemeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<ThemeScalarWhereWithAggregatesInput>>;
  componentId?: InputMaybe<StringWithAggregatesFilter>;
  entityId?: InputMaybe<StringWithAggregatesFilter>;
  entityType?: InputMaybe<EnumEntityTypeWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<ThemeScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<ThemeScalarWhereWithAggregatesInput>>;
  setting?: InputMaybe<JsonWithAggregatesFilter>;
};

export type ThemeUpdateInput = {
  component?: InputMaybe<ComponentUpdateOneRequiredWithoutThemeNestedInput>;
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  setting?: InputMaybe<Scalars['JSON']>;
};

export type ThemeUpdateManyMutationInput = {
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  setting?: InputMaybe<Scalars['JSON']>;
};

export type ThemeUpdateManyWithoutComponentNestedInput = {
  connect?: InputMaybe<Array<ThemeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<ThemeCreateOrConnectWithoutComponentInput>>;
  create?: InputMaybe<Array<ThemeCreateWithoutComponentInput>>;
  createMany?: InputMaybe<ThemeCreateManyComponentInputEnvelope>;
  delete?: InputMaybe<Array<ThemeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<ThemeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<ThemeWhereUniqueInput>>;
  set?: InputMaybe<Array<ThemeWhereUniqueInput>>;
  update?: InputMaybe<Array<ThemeUpdateWithWhereUniqueWithoutComponentInput>>;
  updateMany?: InputMaybe<Array<ThemeUpdateManyWithWhereWithoutComponentInput>>;
  upsert?: InputMaybe<Array<ThemeUpsertWithWhereUniqueWithoutComponentInput>>;
};

export type ThemeUpdateManyWithWhereWithoutComponentInput = {
  data: ThemeUpdateManyMutationInput;
  where: ThemeScalarWhereInput;
};

export type ThemeUpdateWithoutComponentInput = {
  entityId?: InputMaybe<StringFieldUpdateOperationsInput>;
  entityType?: InputMaybe<EnumEntityTypeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  setting?: InputMaybe<Scalars['JSON']>;
};

export type ThemeUpdateWithWhereUniqueWithoutComponentInput = {
  data: ThemeUpdateWithoutComponentInput;
  where: ThemeWhereUniqueInput;
};

export type ThemeUpsertWithWhereUniqueWithoutComponentInput = {
  create: ThemeCreateWithoutComponentInput;
  update: ThemeUpdateWithoutComponentInput;
  where: ThemeWhereUniqueInput;
};

export type ThemeWhereInput = {
  AND?: InputMaybe<Array<ThemeWhereInput>>;
  component?: InputMaybe<ComponentRelationFilter>;
  componentId?: InputMaybe<StringFilter>;
  entityId?: InputMaybe<StringFilter>;
  entityType?: InputMaybe<EnumEntityTypeFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<ThemeWhereInput>>;
  OR?: InputMaybe<Array<ThemeWhereInput>>;
  setting?: InputMaybe<JsonFilter>;
};

export type ThemeWhereUniqueInput = {
  componentId_entityId?: InputMaybe<ThemeComponentIdEntityIdCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type TotalGuests = {
  /** The quantity of adults for the reservation */
  adults: Scalars['Float'];
  /** The quantity of children for the reservation */
  children: Scalars['Float'];
  /** The total of guests for the reservation */
  total: Scalars['Float'];
};

export type Track2Information = {
  disableKeyGeneration?: Maybe<DisableKeyGeneration>;
  includeTrack2Data?: Maybe<Scalars['Boolean']>;
};

export type TypeOfInfo = {
  _count?: Maybe<TypeOfInfoCount>;
  id: Scalars['String'];
  shouldAppearInDashboard: Scalars['Boolean'];
  title: Scalars['String'];
};

export type TypeOfInfoCount = {
  Info: Scalars['Int'];
};


export type TypeOfInfoCountInfoArgs = {
  where?: InputMaybe<InfoItemWhereInput>;
};

export type TypeOfInfoCreateNestedOneWithoutInfoInput = {
  connect?: InputMaybe<TypeOfInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TypeOfInfoCreateOrConnectWithoutInfoInput>;
  create?: InputMaybe<TypeOfInfoCreateWithoutInfoInput>;
};

export type TypeOfInfoCreateOrConnectWithoutInfoInput = {
  create: TypeOfInfoCreateWithoutInfoInput;
  where: TypeOfInfoWhereUniqueInput;
};

export type TypeOfInfoCreateWithoutInfoInput = {
  id?: InputMaybe<Scalars['String']>;
  shouldAppearInDashboard: Scalars['Boolean'];
  title: Scalars['String'];
};

export type TypeOfInfoOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  Info?: InputMaybe<InfoItemOrderByRelationAggregateInput>;
  shouldAppearInDashboard?: InputMaybe<SortOrder>;
  title?: InputMaybe<SortOrder>;
};

export type TypeOfInfoRelationFilter = {
  is?: InputMaybe<TypeOfInfoWhereInput>;
  isNot?: InputMaybe<TypeOfInfoWhereInput>;
};

export type TypeOfInfoUpdateOneWithoutInfoNestedInput = {
  connect?: InputMaybe<TypeOfInfoWhereUniqueInput>;
  connectOrCreate?: InputMaybe<TypeOfInfoCreateOrConnectWithoutInfoInput>;
  create?: InputMaybe<TypeOfInfoCreateWithoutInfoInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<TypeOfInfoUpdateWithoutInfoInput>;
  upsert?: InputMaybe<TypeOfInfoUpsertWithoutInfoInput>;
};

export type TypeOfInfoUpdateWithoutInfoInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  shouldAppearInDashboard?: InputMaybe<BoolFieldUpdateOperationsInput>;
  title?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type TypeOfInfoUpsertWithoutInfoInput = {
  create: TypeOfInfoCreateWithoutInfoInput;
  update: TypeOfInfoUpdateWithoutInfoInput;
};

export type TypeOfInfoWhereInput = {
  AND?: InputMaybe<Array<TypeOfInfoWhereInput>>;
  id?: InputMaybe<StringFilter>;
  Info?: InputMaybe<InfoItemListRelationFilter>;
  NOT?: InputMaybe<Array<TypeOfInfoWhereInput>>;
  OR?: InputMaybe<Array<TypeOfInfoWhereInput>>;
  shouldAppearInDashboard?: InputMaybe<BoolFilter>;
  title?: InputMaybe<StringFilter>;
};

export type TypeOfInfoWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type UnitType = {
  _count?: Maybe<UnitTypeCount>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  location: Location;
  locationId: Scalars['String'];
  numberOfGuests: Scalars['Int'];
  resources: Array<Resource>;
  type: Scalars['String'];
};


export type UnitTypeResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};

export type UnitTypeAvgAggregate = {
  numberOfGuests?: Maybe<Scalars['Float']>;
};

export type UnitTypeAvgOrderByAggregateInput = {
  numberOfGuests?: InputMaybe<SortOrder>;
};

export type UnitTypeCount = {
  resources: Scalars['Int'];
};


export type UnitTypeCountResourcesArgs = {
  where?: InputMaybe<ResourceWhereInput>;
};

export type UnitTypeCountAggregate = {
  _all: Scalars['Int'];
  id: Scalars['Int'];
  imageUrl: Scalars['Int'];
  locationId: Scalars['Int'];
  numberOfGuests: Scalars['Int'];
  type: Scalars['Int'];
};

export type UnitTypeCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  numberOfGuests?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type UnitTypeCreateInput = {
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  location: LocationCreateNestedOneWithoutUnitTypesInput;
  numberOfGuests: Scalars['Int'];
  resources?: InputMaybe<ResourceCreateNestedManyWithoutUnitTypeInput>;
  type: Scalars['String'];
};

export type UnitTypeCreateManyInput = {
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  locationId: Scalars['String'];
  numberOfGuests: Scalars['Int'];
  type: Scalars['String'];
};

export type UnitTypeCreateManyLocationInput = {
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  numberOfGuests: Scalars['Int'];
  type: Scalars['String'];
};

export type UnitTypeCreateManyLocationInputEnvelope = {
  data: Array<UnitTypeCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UnitTypeCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<UnitTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UnitTypeCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<UnitTypeCreateWithoutLocationInput>>;
  createMany?: InputMaybe<UnitTypeCreateManyLocationInputEnvelope>;
};

export type UnitTypeCreateNestedOneWithoutResourcesInput = {
  connect?: InputMaybe<UnitTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UnitTypeCreateOrConnectWithoutResourcesInput>;
  create?: InputMaybe<UnitTypeCreateWithoutResourcesInput>;
};

export type UnitTypeCreateOrConnectWithoutLocationInput = {
  create: UnitTypeCreateWithoutLocationInput;
  where: UnitTypeWhereUniqueInput;
};

export type UnitTypeCreateOrConnectWithoutResourcesInput = {
  create: UnitTypeCreateWithoutResourcesInput;
  where: UnitTypeWhereUniqueInput;
};

export type UnitTypeCreateWithoutLocationInput = {
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  numberOfGuests: Scalars['Int'];
  resources?: InputMaybe<ResourceCreateNestedManyWithoutUnitTypeInput>;
  type: Scalars['String'];
};

export type UnitTypeCreateWithoutResourcesInput = {
  id?: InputMaybe<Scalars['String']>;
  imageUrl: Scalars['String'];
  location: LocationCreateNestedOneWithoutUnitTypesInput;
  numberOfGuests: Scalars['Int'];
  type: Scalars['String'];
};

export type UnitTypeGroupBy = {
  _avg?: Maybe<UnitTypeAvgAggregate>;
  _count?: Maybe<UnitTypeCountAggregate>;
  _max?: Maybe<UnitTypeMaxAggregate>;
  _min?: Maybe<UnitTypeMinAggregate>;
  _sum?: Maybe<UnitTypeSumAggregate>;
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  locationId: Scalars['String'];
  numberOfGuests: Scalars['Int'];
  type: Scalars['String'];
};

export type UnitTypeListRelationFilter = {
  every?: InputMaybe<UnitTypeWhereInput>;
  none?: InputMaybe<UnitTypeWhereInput>;
  some?: InputMaybe<UnitTypeWhereInput>;
};

export type UnitTypeLocationIdTypeCompoundUniqueInput = {
  locationId: Scalars['String'];
  type: Scalars['String'];
};

export type UnitTypeMaxAggregate = {
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  numberOfGuests?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type UnitTypeMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  numberOfGuests?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type UnitTypeMinAggregate = {
  id?: Maybe<Scalars['String']>;
  imageUrl?: Maybe<Scalars['String']>;
  locationId?: Maybe<Scalars['String']>;
  numberOfGuests?: Maybe<Scalars['Int']>;
  type?: Maybe<Scalars['String']>;
};

export type UnitTypeMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  numberOfGuests?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type UnitTypeOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UnitTypeOrderByWithAggregationInput = {
  _avg?: InputMaybe<UnitTypeAvgOrderByAggregateInput>;
  _count?: InputMaybe<UnitTypeCountOrderByAggregateInput>;
  _max?: InputMaybe<UnitTypeMaxOrderByAggregateInput>;
  _min?: InputMaybe<UnitTypeMinOrderByAggregateInput>;
  _sum?: InputMaybe<UnitTypeSumOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  numberOfGuests?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
};

export type UnitTypeOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  imageUrl?: InputMaybe<SortOrder>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrder>;
  numberOfGuests?: InputMaybe<SortOrder>;
  resources?: InputMaybe<ResourceOrderByRelationAggregateInput>;
  type?: InputMaybe<SortOrder>;
};

export type UnitTypeRelationFilter = {
  is?: InputMaybe<UnitTypeWhereInput>;
  isNot?: InputMaybe<UnitTypeWhereInput>;
};

export enum UnitTypeScalarFieldEnum {
  Id = 'id',
  ImageUrl = 'imageUrl',
  LocationId = 'locationId',
  NumberOfGuests = 'numberOfGuests',
  Type = 'type'
}

export type UnitTypeScalarWhereInput = {
  AND?: InputMaybe<Array<UnitTypeScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  locationId?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<UnitTypeScalarWhereInput>>;
  numberOfGuests?: InputMaybe<IntFilter>;
  OR?: InputMaybe<Array<UnitTypeScalarWhereInput>>;
  type?: InputMaybe<StringFilter>;
};

export type UnitTypeScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UnitTypeScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  imageUrl?: InputMaybe<StringWithAggregatesFilter>;
  locationId?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<UnitTypeScalarWhereWithAggregatesInput>>;
  numberOfGuests?: InputMaybe<IntWithAggregatesFilter>;
  OR?: InputMaybe<Array<UnitTypeScalarWhereWithAggregatesInput>>;
  type?: InputMaybe<StringWithAggregatesFilter>;
};

export type UnitTypeSumAggregate = {
  numberOfGuests?: Maybe<Scalars['Int']>;
};

export type UnitTypeSumOrderByAggregateInput = {
  numberOfGuests?: InputMaybe<SortOrder>;
};

export type UnitTypeUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutUnitTypesNestedInput>;
  numberOfGuests?: InputMaybe<IntFieldUpdateOperationsInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutUnitTypeNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UnitTypeUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  numberOfGuests?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UnitTypeUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<UnitTypeWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UnitTypeCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<UnitTypeCreateWithoutLocationInput>>;
  createMany?: InputMaybe<UnitTypeCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<UnitTypeWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UnitTypeScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UnitTypeWhereUniqueInput>>;
  set?: InputMaybe<Array<UnitTypeWhereUniqueInput>>;
  update?: InputMaybe<Array<UnitTypeUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<UnitTypeUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<UnitTypeUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type UnitTypeUpdateManyWithWhereWithoutLocationInput = {
  data: UnitTypeUpdateManyMutationInput;
  where: UnitTypeScalarWhereInput;
};

export type UnitTypeUpdateOneWithoutResourcesNestedInput = {
  connect?: InputMaybe<UnitTypeWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UnitTypeCreateOrConnectWithoutResourcesInput>;
  create?: InputMaybe<UnitTypeCreateWithoutResourcesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UnitTypeUpdateWithoutResourcesInput>;
  upsert?: InputMaybe<UnitTypeUpsertWithoutResourcesInput>;
};

export type UnitTypeUpdateWithoutLocationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  numberOfGuests?: InputMaybe<IntFieldUpdateOperationsInput>;
  resources?: InputMaybe<ResourceUpdateManyWithoutUnitTypeNestedInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UnitTypeUpdateWithoutResourcesInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  imageUrl?: InputMaybe<StringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutUnitTypesNestedInput>;
  numberOfGuests?: InputMaybe<IntFieldUpdateOperationsInput>;
  type?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UnitTypeUpdateWithWhereUniqueWithoutLocationInput = {
  data: UnitTypeUpdateWithoutLocationInput;
  where: UnitTypeWhereUniqueInput;
};

export type UnitTypeUpsertWithoutResourcesInput = {
  create: UnitTypeCreateWithoutResourcesInput;
  update: UnitTypeUpdateWithoutResourcesInput;
};

export type UnitTypeUpsertWithWhereUniqueWithoutLocationInput = {
  create: UnitTypeCreateWithoutLocationInput;
  update: UnitTypeUpdateWithoutLocationInput;
  where: UnitTypeWhereUniqueInput;
};

export type UnitTypeWhereInput = {
  AND?: InputMaybe<Array<UnitTypeWhereInput>>;
  id?: InputMaybe<StringFilter>;
  imageUrl?: InputMaybe<StringFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<UnitTypeWhereInput>>;
  numberOfGuests?: InputMaybe<IntFilter>;
  OR?: InputMaybe<Array<UnitTypeWhereInput>>;
  resources?: InputMaybe<ResourceListRelationFilter>;
  type?: InputMaybe<StringFilter>;
};

export type UnitTypeWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  locationId_type?: InputMaybe<UnitTypeLocationIdTypeCompoundUniqueInput>;
};

export type UpdateConciergeItemInput = {
  contentType?: InputMaybe<InfoContentType>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  description?: InputMaybe<Scalars['String']>;
  externalUrl?: InputMaybe<Scalars['String']>;
  imageUrl?: InputMaybe<Scalars['String']>;
  moreInfoLink?: InputMaybe<Scalars['String']>;
  parentCategory?: InputMaybe<Scalars['String']>;
  pdfUrl?: InputMaybe<Scalars['String']>;
  thumbnailImage?: InputMaybe<Scalars['String']>;
  title: Scalars['String'];
  type?: InputMaybe<InfoType>;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UpdateConciergeItemOrderInput = {
  id: Scalars['String'];
  order: Scalars['Float'];
  parent: Scalars['String'];
};

export type UpdateConciergeItemOrderResponse = {
  id: Scalars['String'];
  order: Scalars['Float'];
  parent: Scalars['String'];
};

export type UpdateEarlyCheckInPackageWhere = {
  serviceId: Scalars['String'];
};

export type User = {
  _count?: Maybe<UserCount>;
  accessGrants: Array<AccessGrant>;
  authChallenges: Array<AuthChallenge>;
  callRecords: Array<CallRecord>;
  country?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  Credential: Array<Credential>;
  cuid: Scalars['String'];
  dashboardPreferences?: Maybe<Scalars['JSON']>;
  deviceId?: Maybe<Scalars['String']>;
  devices: Array<Device>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  internalApiCalls: Array<InternalApiCall>;
  lastName?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  madeCalls: Array<CallRecord>;
  memberships: Array<Membership>;
  name?: Maybe<Scalars['String']>;
  Notification: Array<Notification>;
  openpathExternalUserId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  payments: Array<Payment>;
  phoneNumber?: Maybe<Scalars['String']>;
  receivedCalls: Array<CallRecord>;
  SecondaryUsersOnAccessGrants: Array<SecondaryUsersOnAccessGrants>;
  UserAccessGrantRequirement: Array<UserAccessGrantRequirement>;
  UserLocationData: Array<UserLocationData>;
  userPushNotificationTokens: Array<UserPushNotificationToken>;
  userRecords: Array<UserRecord>;
  UserTenantData: Array<UserTenantData>;
};


export type UserAccessGrantsArgs = {
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type UserAuthChallengesArgs = {
  cursor?: InputMaybe<AuthChallengeWhereUniqueInput>;
  distinct?: InputMaybe<Array<AuthChallengeScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<AuthChallengeOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AuthChallengeWhereInput>;
};


export type UserCallRecordsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type UserCredentialArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type UserDevicesArgs = {
  cursor?: InputMaybe<DeviceWhereUniqueInput>;
  distinct?: InputMaybe<Array<DeviceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<DeviceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<DeviceWhereInput>;
};


export type UserInternalApiCallsArgs = {
  cursor?: InputMaybe<InternalApiCallWhereUniqueInput>;
  distinct?: InputMaybe<Array<InternalApiCallScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<InternalApiCallOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InternalApiCallWhereInput>;
};


export type UserMadeCallsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type UserMembershipsArgs = {
  cursor?: InputMaybe<MembershipWhereUniqueInput>;
  distinct?: InputMaybe<Array<MembershipScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<MembershipOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MembershipWhereInput>;
};


export type UserNotificationArgs = {
  cursor?: InputMaybe<NotificationWhereUniqueInput>;
  distinct?: InputMaybe<Array<NotificationScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<NotificationOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<NotificationWhereInput>;
};


export type UserPaymentsArgs = {
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
};


export type UserReceivedCallsArgs = {
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
};


export type UserSecondaryUsersOnAccessGrantsArgs = {
  cursor?: InputMaybe<SecondaryUsersOnAccessGrantsWhereUniqueInput>;
  distinct?: InputMaybe<Array<SecondaryUsersOnAccessGrantsScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<SecondaryUsersOnAccessGrantsOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
};


export type UserUserAccessGrantRequirementArgs = {
  cursor?: InputMaybe<UserAccessGrantRequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserAccessGrantRequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserAccessGrantRequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};


export type UserUserLocationDataArgs = {
  cursor?: InputMaybe<UserLocationDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserLocationDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserLocationDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserLocationDataWhereInput>;
};


export type UserUserPushNotificationTokensArgs = {
  cursor?: InputMaybe<UserPushNotificationTokenWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserPushNotificationTokenScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserPushNotificationTokenOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type UserUserRecordsArgs = {
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRecordScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
};


export type UserUserTenantDataArgs = {
  cursor?: InputMaybe<UserTenantDataWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserTenantDataScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<UserTenantDataOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserTenantDataWhereInput>;
};

export type UserAccessGrantRequirement = {
  _count?: Maybe<UserAccessGrantRequirementCount>;
  accessGrantId: Scalars['String'];
  createdAt: Scalars['DateTime'];
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  rejectReasonCode?: Maybe<Scalars['String']>;
  sessionId?: Maybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt: Scalars['DateTime'];
  userId: Scalars['String'];
};

export type UserAccessGrantRequirementCount = {
  files: Scalars['Int'];
};


export type UserAccessGrantRequirementCountFilesArgs = {
  where?: InputMaybe<FileToEntityWhereInput>;
};

export type UserAccessGrantRequirementCreateManyAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  userId: Scalars['String'];
};

export type UserAccessGrantRequirementCreateManyAccessGrantInputEnvelope = {
  data: Array<UserAccessGrantRequirementCreateManyAccessGrantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserAccessGrantRequirementCreateManyUserInput = {
  accessGrantId: Scalars['String'];
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UserAccessGrantRequirementCreateManyUserInputEnvelope = {
  data: Array<UserAccessGrantRequirementCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserAccessGrantRequirementCreateNestedManyWithoutAccessGrantInput = {
  connect?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAccessGrantRequirementCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<UserAccessGrantRequirementCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<UserAccessGrantRequirementCreateManyAccessGrantInputEnvelope>;
};

export type UserAccessGrantRequirementCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAccessGrantRequirementCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserAccessGrantRequirementCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserAccessGrantRequirementCreateManyUserInputEnvelope>;
};

export type UserAccessGrantRequirementCreateNestedOneWithoutFilesInput = {
  connect?: InputMaybe<UserAccessGrantRequirementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserAccessGrantRequirementCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserAccessGrantRequirementCreateWithoutFilesInput>;
};

export type UserAccessGrantRequirementCreateOrConnectWithoutAccessGrantInput = {
  create: UserAccessGrantRequirementCreateWithoutAccessGrantInput;
  where: UserAccessGrantRequirementWhereUniqueInput;
};

export type UserAccessGrantRequirementCreateOrConnectWithoutFilesInput = {
  create: UserAccessGrantRequirementCreateWithoutFilesInput;
  where: UserAccessGrantRequirementWhereUniqueInput;
};

export type UserAccessGrantRequirementCreateOrConnectWithoutUserInput = {
  create: UserAccessGrantRequirementCreateWithoutUserInput;
  where: UserAccessGrantRequirementWhereUniqueInput;
};

export type UserAccessGrantRequirementCreateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileToEntityCreateNestedManyWithoutUserAccessGrantRequirementInput>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  User: UserCreateNestedOneWithoutUserAccessGrantRequirementInput;
};

export type UserAccessGrantRequirementCreateWithoutFilesInput = {
  AccessGrant: AccessGrantCreateNestedOneWithoutUserAccessGrantRequirementInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
  User: UserCreateNestedOneWithoutUserAccessGrantRequirementInput;
};

export type UserAccessGrantRequirementCreateWithoutUserInput = {
  AccessGrant: AccessGrantCreateNestedOneWithoutUserAccessGrantRequirementInput;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  files?: InputMaybe<FileToEntityCreateNestedManyWithoutUserAccessGrantRequirementInput>;
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<Scalars['String']>;
  sessionId?: InputMaybe<Scalars['String']>;
  status: RequirementStatus;
  type: RequirementType;
  updatedAt?: InputMaybe<Scalars['DateTime']>;
};

export type UserAccessGrantRequirementListRelationFilter = {
  every?: InputMaybe<UserAccessGrantRequirementWhereInput>;
  none?: InputMaybe<UserAccessGrantRequirementWhereInput>;
  some?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};

export type UserAccessGrantRequirementOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserAccessGrantRequirementOrderByWithRelationInput = {
  AccessGrant?: InputMaybe<AccessGrantOrderByWithRelationInput>;
  accessGrantId?: InputMaybe<SortOrder>;
  createdAt?: InputMaybe<SortOrder>;
  files?: InputMaybe<FileToEntityOrderByRelationAggregateInput>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  rejectReasonCode?: InputMaybe<SortOrderInput>;
  sessionId?: InputMaybe<SortOrderInput>;
  status?: InputMaybe<SortOrder>;
  type?: InputMaybe<SortOrder>;
  updatedAt?: InputMaybe<SortOrder>;
  User?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export type UserAccessGrantRequirementRelationFilter = {
  is?: InputMaybe<UserAccessGrantRequirementWhereInput>;
  isNot?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};

export enum UserAccessGrantRequirementScalarFieldEnum {
  AccessGrantId = 'accessGrantId',
  CreatedAt = 'createdAt',
  Id = 'id',
  Metadata = 'metadata',
  RejectReasonCode = 'rejectReasonCode',
  SessionId = 'sessionId',
  Status = 'status',
  Type = 'type',
  UpdatedAt = 'updatedAt',
  UserId = 'userId'
}

export type UserAccessGrantRequirementScalarWhereInput = {
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<UserAccessGrantRequirementScalarWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<UserAccessGrantRequirementScalarWhereInput>>;
  OR?: InputMaybe<Array<UserAccessGrantRequirementScalarWhereInput>>;
  rejectReasonCode?: InputMaybe<StringNullableFilter>;
  sessionId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumRequirementStatusFilter>;
  type?: InputMaybe<EnumRequirementTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserAccessGrantRequirementTypeAccessGrantIdUserIdCompoundUniqueInput = {
  accessGrantId: Scalars['String'];
  type: RequirementType;
  userId: Scalars['String'];
};

export type UserAccessGrantRequirementUpdateInput = {
  AccessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutUserAccessGrantRequirementNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileToEntityUpdateManyWithoutUserAccessGrantRequirementNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRequirementStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutUserAccessGrantRequirementNestedInput>;
};

export type UserAccessGrantRequirementUpdateManyMutationInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRequirementStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserAccessGrantRequirementUpdateManyWithoutAccessGrantNestedInput = {
  connect?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAccessGrantRequirementCreateOrConnectWithoutAccessGrantInput>>;
  create?: InputMaybe<Array<UserAccessGrantRequirementCreateWithoutAccessGrantInput>>;
  createMany?: InputMaybe<UserAccessGrantRequirementCreateManyAccessGrantInputEnvelope>;
  delete?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserAccessGrantRequirementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  set?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  update?: InputMaybe<Array<UserAccessGrantRequirementUpdateWithWhereUniqueWithoutAccessGrantInput>>;
  updateMany?: InputMaybe<Array<UserAccessGrantRequirementUpdateManyWithWhereWithoutAccessGrantInput>>;
  upsert?: InputMaybe<Array<UserAccessGrantRequirementUpsertWithWhereUniqueWithoutAccessGrantInput>>;
};

export type UserAccessGrantRequirementUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserAccessGrantRequirementCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserAccessGrantRequirementCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserAccessGrantRequirementCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserAccessGrantRequirementScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  set?: InputMaybe<Array<UserAccessGrantRequirementWhereUniqueInput>>;
  update?: InputMaybe<Array<UserAccessGrantRequirementUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserAccessGrantRequirementUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserAccessGrantRequirementUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserAccessGrantRequirementUpdateManyWithWhereWithoutAccessGrantInput = {
  data: UserAccessGrantRequirementUpdateManyMutationInput;
  where: UserAccessGrantRequirementScalarWhereInput;
};

export type UserAccessGrantRequirementUpdateManyWithWhereWithoutUserInput = {
  data: UserAccessGrantRequirementUpdateManyMutationInput;
  where: UserAccessGrantRequirementScalarWhereInput;
};

export type UserAccessGrantRequirementUpdateOneWithoutFilesNestedInput = {
  connect?: InputMaybe<UserAccessGrantRequirementWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserAccessGrantRequirementCreateOrConnectWithoutFilesInput>;
  create?: InputMaybe<UserAccessGrantRequirementCreateWithoutFilesInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserAccessGrantRequirementUpdateWithoutFilesInput>;
  upsert?: InputMaybe<UserAccessGrantRequirementUpsertWithoutFilesInput>;
};

export type UserAccessGrantRequirementUpdateWithoutAccessGrantInput = {
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileToEntityUpdateManyWithoutUserAccessGrantRequirementNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRequirementStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutUserAccessGrantRequirementNestedInput>;
};

export type UserAccessGrantRequirementUpdateWithoutFilesInput = {
  AccessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutUserAccessGrantRequirementNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRequirementStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  User?: InputMaybe<UserUpdateOneRequiredWithoutUserAccessGrantRequirementNestedInput>;
};

export type UserAccessGrantRequirementUpdateWithoutUserInput = {
  AccessGrant?: InputMaybe<AccessGrantUpdateOneRequiredWithoutUserAccessGrantRequirementNestedInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  files?: InputMaybe<FileToEntityUpdateManyWithoutUserAccessGrantRequirementNestedInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  rejectReasonCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  sessionId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  status?: InputMaybe<EnumRequirementStatusFieldUpdateOperationsInput>;
  type?: InputMaybe<EnumRequirementTypeFieldUpdateOperationsInput>;
  updatedAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
};

export type UserAccessGrantRequirementUpdateWithWhereUniqueWithoutAccessGrantInput = {
  data: UserAccessGrantRequirementUpdateWithoutAccessGrantInput;
  where: UserAccessGrantRequirementWhereUniqueInput;
};

export type UserAccessGrantRequirementUpdateWithWhereUniqueWithoutUserInput = {
  data: UserAccessGrantRequirementUpdateWithoutUserInput;
  where: UserAccessGrantRequirementWhereUniqueInput;
};

export type UserAccessGrantRequirementUpsertWithoutFilesInput = {
  create: UserAccessGrantRequirementCreateWithoutFilesInput;
  update: UserAccessGrantRequirementUpdateWithoutFilesInput;
};

export type UserAccessGrantRequirementUpsertWithWhereUniqueWithoutAccessGrantInput = {
  create: UserAccessGrantRequirementCreateWithoutAccessGrantInput;
  update: UserAccessGrantRequirementUpdateWithoutAccessGrantInput;
  where: UserAccessGrantRequirementWhereUniqueInput;
};

export type UserAccessGrantRequirementUpsertWithWhereUniqueWithoutUserInput = {
  create: UserAccessGrantRequirementCreateWithoutUserInput;
  update: UserAccessGrantRequirementUpdateWithoutUserInput;
  where: UserAccessGrantRequirementWhereUniqueInput;
};

export type UserAccessGrantRequirementWhereInput = {
  AccessGrant?: InputMaybe<AccessGrantRelationFilter>;
  accessGrantId?: InputMaybe<StringFilter>;
  AND?: InputMaybe<Array<UserAccessGrantRequirementWhereInput>>;
  createdAt?: InputMaybe<DateTimeFilter>;
  files?: InputMaybe<FileToEntityListRelationFilter>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<UserAccessGrantRequirementWhereInput>>;
  OR?: InputMaybe<Array<UserAccessGrantRequirementWhereInput>>;
  rejectReasonCode?: InputMaybe<StringNullableFilter>;
  sessionId?: InputMaybe<StringNullableFilter>;
  status?: InputMaybe<EnumRequirementStatusFilter>;
  type?: InputMaybe<EnumRequirementTypeFilter>;
  updatedAt?: InputMaybe<DateTimeFilter>;
  User?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserAccessGrantRequirementWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  type_accessGrantId_userId?: InputMaybe<UserAccessGrantRequirementTypeAccessGrantIdUserIdCompoundUniqueInput>;
};

export type UserAgreementInput = {
  id: Scalars['String'];
  title: Scalars['String'];
};

export type UserCount = {
  accessGrants: Scalars['Int'];
  authChallenges: Scalars['Int'];
  callRecords: Scalars['Int'];
  Credential: Scalars['Int'];
  devices: Scalars['Int'];
  internalApiCalls: Scalars['Int'];
  madeCalls: Scalars['Int'];
  memberships: Scalars['Int'];
  Notification: Scalars['Int'];
  payments: Scalars['Int'];
  receivedCalls: Scalars['Int'];
  SecondaryUsersOnAccessGrants: Scalars['Int'];
  UserAccessGrantRequirement: Scalars['Int'];
  UserLocationData: Scalars['Int'];
  userPushNotificationTokens: Scalars['Int'];
  userRecords: Scalars['Int'];
  UserTenantData: Scalars['Int'];
};


export type UserCountAccessGrantsArgs = {
  where?: InputMaybe<AccessGrantWhereInput>;
};


export type UserCountAuthChallengesArgs = {
  where?: InputMaybe<AuthChallengeWhereInput>;
};


export type UserCountCallRecordsArgs = {
  where?: InputMaybe<CallRecordWhereInput>;
};


export type UserCountCredentialArgs = {
  where?: InputMaybe<CredentialWhereInput>;
};


export type UserCountDevicesArgs = {
  where?: InputMaybe<DeviceWhereInput>;
};


export type UserCountInternalApiCallsArgs = {
  where?: InputMaybe<InternalApiCallWhereInput>;
};


export type UserCountMadeCallsArgs = {
  where?: InputMaybe<CallRecordWhereInput>;
};


export type UserCountMembershipsArgs = {
  where?: InputMaybe<MembershipWhereInput>;
};


export type UserCountNotificationArgs = {
  where?: InputMaybe<NotificationWhereInput>;
};


export type UserCountPaymentsArgs = {
  where?: InputMaybe<PaymentWhereInput>;
};


export type UserCountReceivedCallsArgs = {
  where?: InputMaybe<CallRecordWhereInput>;
};


export type UserCountSecondaryUsersOnAccessGrantsArgs = {
  where?: InputMaybe<SecondaryUsersOnAccessGrantsWhereInput>;
};


export type UserCountUserAccessGrantRequirementArgs = {
  where?: InputMaybe<UserAccessGrantRequirementWhereInput>;
};


export type UserCountUserLocationDataArgs = {
  where?: InputMaybe<UserLocationDataWhereInput>;
};


export type UserCountUserPushNotificationTokensArgs = {
  where?: InputMaybe<UserPushNotificationTokenWhereInput>;
};


export type UserCountUserRecordsArgs = {
  where?: InputMaybe<UserRecordWhereInput>;
};


export type UserCountUserTenantDataArgs = {
  where?: InputMaybe<UserTenantDataWhereInput>;
};

export type UserCountAggregate = {
  _all: Scalars['Int'];
  country: Scalars['Int'];
  createdAt: Scalars['Int'];
  cuid: Scalars['Int'];
  dashboardPreferences: Scalars['Int'];
  deviceId: Scalars['Int'];
  email: Scalars['Int'];
  firstName: Scalars['Int'];
  id: Scalars['Int'];
  lastName: Scalars['Int'];
  lastSeenAt: Scalars['Int'];
  name: Scalars['Int'];
  openpathExternalUserId: Scalars['Int'];
  password: Scalars['Int'];
  phoneNumber: Scalars['Int'];
};

export type UserCreateInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateNestedManyWithoutCallRecordsInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutCallRecordsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutCallRecordsInput>>;
};

export type UserCreateNestedOneWithoutAccessGrantsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAccessGrantsInput>;
  create?: InputMaybe<UserCreateWithoutAccessGrantsInput>;
};

export type UserCreateNestedOneWithoutCredentialInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<UserCreateWithoutCredentialInput>;
};

export type UserCreateNestedOneWithoutDevicesInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDevicesInput>;
  create?: InputMaybe<UserCreateWithoutDevicesInput>;
};

export type UserCreateNestedOneWithoutInternalApiCallsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutInternalApiCallsInput>;
  create?: InputMaybe<UserCreateWithoutInternalApiCallsInput>;
};

export type UserCreateNestedOneWithoutMadeCallsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMadeCallsInput>;
  create?: InputMaybe<UserCreateWithoutMadeCallsInput>;
};

export type UserCreateNestedOneWithoutMembershipsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<UserCreateWithoutMembershipsInput>;
};

export type UserCreateNestedOneWithoutNotificationInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<UserCreateWithoutNotificationInput>;
};

export type UserCreateNestedOneWithoutPaymentsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<UserCreateWithoutPaymentsInput>;
};

export type UserCreateNestedOneWithoutReceivedCallsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutReceivedCallsInput>;
  create?: InputMaybe<UserCreateWithoutReceivedCallsInput>;
};

export type UserCreateNestedOneWithoutSecondaryUsersOnAccessGrantsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSecondaryUsersOnAccessGrantsInput>;
  create?: InputMaybe<UserCreateWithoutSecondaryUsersOnAccessGrantsInput>;
};

export type UserCreateNestedOneWithoutUserAccessGrantRequirementInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserAccessGrantRequirementInput>;
  create?: InputMaybe<UserCreateWithoutUserAccessGrantRequirementInput>;
};

export type UserCreateNestedOneWithoutUserLocationDataInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserLocationDataInput>;
  create?: InputMaybe<UserCreateWithoutUserLocationDataInput>;
};

export type UserCreateNestedOneWithoutUserPushNotificationTokensInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserPushNotificationTokensInput>;
  create?: InputMaybe<UserCreateWithoutUserPushNotificationTokensInput>;
};

export type UserCreateNestedOneWithoutUserRecordsInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserRecordsInput>;
  create?: InputMaybe<UserCreateWithoutUserRecordsInput>;
};

export type UserCreateNestedOneWithoutUserTenantDataInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserTenantDataInput>;
  create?: InputMaybe<UserCreateWithoutUserTenantDataInput>;
};

export type UserCreateOrConnectWithoutAccessGrantsInput = {
  create: UserCreateWithoutAccessGrantsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCallRecordsInput = {
  create: UserCreateWithoutCallRecordsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutCredentialInput = {
  create: UserCreateWithoutCredentialInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutDevicesInput = {
  create: UserCreateWithoutDevicesInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutInternalApiCallsInput = {
  create: UserCreateWithoutInternalApiCallsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMadeCallsInput = {
  create: UserCreateWithoutMadeCallsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutMembershipsInput = {
  create: UserCreateWithoutMembershipsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutNotificationInput = {
  create: UserCreateWithoutNotificationInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutPaymentsInput = {
  create: UserCreateWithoutPaymentsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutReceivedCallsInput = {
  create: UserCreateWithoutReceivedCallsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutSecondaryUsersOnAccessGrantsInput = {
  create: UserCreateWithoutSecondaryUsersOnAccessGrantsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserAccessGrantRequirementInput = {
  create: UserCreateWithoutUserAccessGrantRequirementInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserLocationDataInput = {
  create: UserCreateWithoutUserLocationDataInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserPushNotificationTokensInput = {
  create: UserCreateWithoutUserPushNotificationTokensInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserRecordsInput = {
  create: UserCreateWithoutUserRecordsInput;
  where: UserWhereUniqueInput;
};

export type UserCreateOrConnectWithoutUserTenantDataInput = {
  create: UserCreateWithoutUserTenantDataInput;
  where: UserWhereUniqueInput;
};

export type UserCreateWithoutAccessGrantsInput = {
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutCallRecordsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutCredentialInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutDevicesInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutInternalApiCallsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutMadeCallsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutMembershipsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutNotificationInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutPaymentsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutReceivedCallsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutSecondaryUsersOnAccessGrantsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserAccessGrantRequirementInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserLocationDataInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserPushNotificationTokensInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserRecordsInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  UserTenantData?: InputMaybe<UserTenantDataCreateNestedManyWithoutUserInput>;
};

export type UserCreateWithoutUserTenantDataInput = {
  accessGrants?: InputMaybe<AccessGrantCreateNestedManyWithoutUserInput>;
  authChallenges?: InputMaybe<AuthChallengeCreateNestedManyWithoutUserInput>;
  callRecords?: InputMaybe<CallRecordCreateNestedManyWithoutUsersInput>;
  country?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['DateTime']>;
  Credential?: InputMaybe<CredentialCreateNestedManyWithoutUserInput>;
  cuid?: InputMaybe<Scalars['String']>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<Scalars['String']>;
  devices?: InputMaybe<DeviceCreateNestedManyWithoutUserInput>;
  email?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  internalApiCalls?: InputMaybe<InternalApiCallCreateNestedManyWithoutUserInput>;
  lastName?: InputMaybe<Scalars['String']>;
  lastSeenAt?: InputMaybe<Scalars['DateTime']>;
  madeCalls?: InputMaybe<CallRecordCreateNestedManyWithoutCallerInput>;
  memberships?: InputMaybe<MembershipCreateNestedManyWithoutUserInput>;
  name?: InputMaybe<Scalars['String']>;
  Notification?: InputMaybe<NotificationCreateNestedManyWithoutUserInput>;
  openpathExternalUserId?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  payments?: InputMaybe<PaymentCreateNestedManyWithoutUserInput>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  receivedCalls?: InputMaybe<CallRecordCreateNestedManyWithoutAgentInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsCreateNestedManyWithoutUserInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementCreateNestedManyWithoutUserInput>;
  UserLocationData?: InputMaybe<UserLocationDataCreateNestedManyWithoutUserInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenCreateNestedManyWithoutUserInput>;
  userRecords?: InputMaybe<UserRecordCreateNestedManyWithoutUserInput>;
};

export type UserEmailPhoneNumberCompoundUniqueInput = {
  email: Scalars['String'];
  phoneNumber: Scalars['String'];
};

export type UserListRelationFilter = {
  every?: InputMaybe<UserWhereInput>;
  none?: InputMaybe<UserWhereInput>;
  some?: InputMaybe<UserWhereInput>;
};

export type UserLocationData = {
  dynamicUserData?: Maybe<Scalars['JSON']>;
  externalProfileId?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  jumioAccountId?: Maybe<Scalars['String']>;
  locationId: Scalars['String'];
  lockVendorExternalUserId?: Maybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type UserLocationDataCreateManyLocationInput = {
  dynamicUserData?: InputMaybe<Scalars['JSON']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jumioAccountId?: InputMaybe<Scalars['String']>;
  lockVendorExternalUserId?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type UserLocationDataCreateManyLocationInputEnvelope = {
  data: Array<UserLocationDataCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserLocationDataCreateManyUserInput = {
  dynamicUserData?: InputMaybe<Scalars['JSON']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jumioAccountId?: InputMaybe<Scalars['String']>;
  locationId: Scalars['String'];
  lockVendorExternalUserId?: InputMaybe<Scalars['String']>;
};

export type UserLocationDataCreateManyUserInputEnvelope = {
  data: Array<UserLocationDataCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserLocationDataCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLocationDataCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<UserLocationDataCreateWithoutLocationInput>>;
  createMany?: InputMaybe<UserLocationDataCreateManyLocationInputEnvelope>;
};

export type UserLocationDataCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLocationDataCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserLocationDataCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserLocationDataCreateManyUserInputEnvelope>;
};

export type UserLocationDataCreateOrConnectWithoutLocationInput = {
  create: UserLocationDataCreateWithoutLocationInput;
  where: UserLocationDataWhereUniqueInput;
};

export type UserLocationDataCreateOrConnectWithoutUserInput = {
  create: UserLocationDataCreateWithoutUserInput;
  where: UserLocationDataWhereUniqueInput;
};

export type UserLocationDataCreateWithoutLocationInput = {
  dynamicUserData?: InputMaybe<Scalars['JSON']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jumioAccountId?: InputMaybe<Scalars['String']>;
  lockVendorExternalUserId?: InputMaybe<Scalars['String']>;
  user: UserCreateNestedOneWithoutUserLocationDataInput;
};

export type UserLocationDataCreateWithoutUserInput = {
  dynamicUserData?: InputMaybe<Scalars['JSON']>;
  externalProfileId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['String']>;
  jumioAccountId?: InputMaybe<Scalars['String']>;
  location: LocationCreateNestedOneWithoutUserLocationDataInput;
  lockVendorExternalUserId?: InputMaybe<Scalars['String']>;
};

export type UserLocationDataListRelationFilter = {
  every?: InputMaybe<UserLocationDataWhereInput>;
  none?: InputMaybe<UserLocationDataWhereInput>;
  some?: InputMaybe<UserLocationDataWhereInput>;
};

export type UserLocationDataOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserLocationDataOrderByWithRelationInput = {
  dynamicUserData?: InputMaybe<SortOrderInput>;
  externalProfileId?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  jumioAccountId?: InputMaybe<SortOrderInput>;
  location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrder>;
  lockVendorExternalUserId?: InputMaybe<SortOrderInput>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserLocationDataScalarFieldEnum {
  DynamicUserData = 'dynamicUserData',
  ExternalProfileId = 'externalProfileId',
  Id = 'id',
  JumioAccountId = 'jumioAccountId',
  LocationId = 'locationId',
  LockVendorExternalUserId = 'lockVendorExternalUserId',
  UserId = 'userId'
}

export type UserLocationDataScalarWhereInput = {
  AND?: InputMaybe<Array<UserLocationDataScalarWhereInput>>;
  dynamicUserData?: InputMaybe<JsonNullableFilter>;
  externalProfileId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  jumioAccountId?: InputMaybe<StringNullableFilter>;
  locationId?: InputMaybe<StringFilter>;
  lockVendorExternalUserId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<UserLocationDataScalarWhereInput>>;
  OR?: InputMaybe<Array<UserLocationDataScalarWhereInput>>;
  userId?: InputMaybe<StringFilter>;
};

export type UserLocationDataUpdateManyMutationInput = {
  dynamicUserData?: InputMaybe<Scalars['JSON']>;
  externalProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jumioAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lockVendorExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserLocationDataUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLocationDataCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<UserLocationDataCreateWithoutLocationInput>>;
  createMany?: InputMaybe<UserLocationDataCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserLocationDataScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  set?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  update?: InputMaybe<Array<UserLocationDataUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<UserLocationDataUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<UserLocationDataUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type UserLocationDataUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserLocationDataCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserLocationDataCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserLocationDataCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserLocationDataScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  set?: InputMaybe<Array<UserLocationDataWhereUniqueInput>>;
  update?: InputMaybe<Array<UserLocationDataUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserLocationDataUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserLocationDataUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserLocationDataUpdateManyWithWhereWithoutLocationInput = {
  data: UserLocationDataUpdateManyMutationInput;
  where: UserLocationDataScalarWhereInput;
};

export type UserLocationDataUpdateManyWithWhereWithoutUserInput = {
  data: UserLocationDataUpdateManyMutationInput;
  where: UserLocationDataScalarWhereInput;
};

export type UserLocationDataUpdateWithoutLocationInput = {
  dynamicUserData?: InputMaybe<Scalars['JSON']>;
  externalProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jumioAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lockVendorExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserLocationDataNestedInput>;
};

export type UserLocationDataUpdateWithoutUserInput = {
  dynamicUserData?: InputMaybe<Scalars['JSON']>;
  externalProfileId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  jumioAccountId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  location?: InputMaybe<LocationUpdateOneRequiredWithoutUserLocationDataNestedInput>;
  lockVendorExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserLocationDataUpdateWithWhereUniqueWithoutLocationInput = {
  data: UserLocationDataUpdateWithoutLocationInput;
  where: UserLocationDataWhereUniqueInput;
};

export type UserLocationDataUpdateWithWhereUniqueWithoutUserInput = {
  data: UserLocationDataUpdateWithoutUserInput;
  where: UserLocationDataWhereUniqueInput;
};

export type UserLocationDataUpsertWithWhereUniqueWithoutLocationInput = {
  create: UserLocationDataCreateWithoutLocationInput;
  update: UserLocationDataUpdateWithoutLocationInput;
  where: UserLocationDataWhereUniqueInput;
};

export type UserLocationDataUpsertWithWhereUniqueWithoutUserInput = {
  create: UserLocationDataCreateWithoutUserInput;
  update: UserLocationDataUpdateWithoutUserInput;
  where: UserLocationDataWhereUniqueInput;
};

export type UserLocationDataUserIdLocationIdCompoundUniqueInput = {
  locationId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserLocationDataWhereInput = {
  AND?: InputMaybe<Array<UserLocationDataWhereInput>>;
  dynamicUserData?: InputMaybe<JsonNullableFilter>;
  externalProfileId?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  jumioAccountId?: InputMaybe<StringNullableFilter>;
  location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringFilter>;
  lockVendorExternalUserId?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<UserLocationDataWhereInput>>;
  OR?: InputMaybe<Array<UserLocationDataWhereInput>>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserLocationDataWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  userId_locationId?: InputMaybe<UserLocationDataUserIdLocationIdCompoundUniqueInput>;
};

export type UserMaxAggregate = {
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cuid?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  openpathExternalUserId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type UserMinAggregate = {
  country?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['DateTime']>;
  cuid?: Maybe<Scalars['String']>;
  deviceId?: Maybe<Scalars['String']>;
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  lastSeenAt?: Maybe<Scalars['DateTime']>;
  name?: Maybe<Scalars['String']>;
  openpathExternalUserId?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type UserOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserOrderByWithRelationInput = {
  accessGrants?: InputMaybe<AccessGrantOrderByRelationAggregateInput>;
  authChallenges?: InputMaybe<AuthChallengeOrderByRelationAggregateInput>;
  callRecords?: InputMaybe<CallRecordOrderByRelationAggregateInput>;
  country?: InputMaybe<SortOrderInput>;
  createdAt?: InputMaybe<SortOrder>;
  Credential?: InputMaybe<CredentialOrderByRelationAggregateInput>;
  cuid?: InputMaybe<SortOrder>;
  dashboardPreferences?: InputMaybe<SortOrderInput>;
  deviceId?: InputMaybe<SortOrderInput>;
  devices?: InputMaybe<DeviceOrderByRelationAggregateInput>;
  email?: InputMaybe<SortOrderInput>;
  firstName?: InputMaybe<SortOrderInput>;
  id?: InputMaybe<SortOrder>;
  internalApiCalls?: InputMaybe<InternalApiCallOrderByRelationAggregateInput>;
  lastName?: InputMaybe<SortOrderInput>;
  lastSeenAt?: InputMaybe<SortOrderInput>;
  madeCalls?: InputMaybe<CallRecordOrderByRelationAggregateInput>;
  memberships?: InputMaybe<MembershipOrderByRelationAggregateInput>;
  name?: InputMaybe<SortOrderInput>;
  Notification?: InputMaybe<NotificationOrderByRelationAggregateInput>;
  openpathExternalUserId?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrderInput>;
  payments?: InputMaybe<PaymentOrderByRelationAggregateInput>;
  phoneNumber?: InputMaybe<SortOrderInput>;
  receivedCalls?: InputMaybe<CallRecordOrderByRelationAggregateInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsOrderByRelationAggregateInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementOrderByRelationAggregateInput>;
  UserLocationData?: InputMaybe<UserLocationDataOrderByRelationAggregateInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenOrderByRelationAggregateInput>;
  userRecords?: InputMaybe<UserRecordOrderByRelationAggregateInput>;
  UserTenantData?: InputMaybe<UserTenantDataOrderByRelationAggregateInput>;
};

export type UserPushNotificationToken = {
  deviceId: Scalars['String'];
  fcmToken: Scalars['String'];
  id: Scalars['String'];
  userId: Scalars['String'];
};

export type UserPushNotificationTokenCountAggregate = {
  _all: Scalars['Int'];
  deviceId: Scalars['Int'];
  fcmToken: Scalars['Int'];
  id: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserPushNotificationTokenCountOrderByAggregateInput = {
  deviceId?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPushNotificationTokenCreateInput = {
  deviceId: Scalars['String'];
  fcmToken: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  user: UserCreateNestedOneWithoutUserPushNotificationTokensInput;
};

export type UserPushNotificationTokenCreateManyInput = {
  deviceId: Scalars['String'];
  fcmToken: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  userId: Scalars['String'];
};

export type UserPushNotificationTokenCreateManyUserInput = {
  deviceId: Scalars['String'];
  fcmToken: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};

export type UserPushNotificationTokenCreateManyUserInputEnvelope = {
  data: Array<UserPushNotificationTokenCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserPushNotificationTokenCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserPushNotificationTokenWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPushNotificationTokenCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserPushNotificationTokenCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserPushNotificationTokenCreateManyUserInputEnvelope>;
};

export type UserPushNotificationTokenCreateOrConnectWithoutUserInput = {
  create: UserPushNotificationTokenCreateWithoutUserInput;
  where: UserPushNotificationTokenWhereUniqueInput;
};

export type UserPushNotificationTokenCreateWithoutUserInput = {
  deviceId: Scalars['String'];
  fcmToken: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
};

export type UserPushNotificationTokenGroupBy = {
  _count?: Maybe<UserPushNotificationTokenCountAggregate>;
  _max?: Maybe<UserPushNotificationTokenMaxAggregate>;
  _min?: Maybe<UserPushNotificationTokenMinAggregate>;
  deviceId: Scalars['String'];
  fcmToken: Scalars['String'];
  id: Scalars['String'];
  userId: Scalars['String'];
};

export type UserPushNotificationTokenListRelationFilter = {
  every?: InputMaybe<UserPushNotificationTokenWhereInput>;
  none?: InputMaybe<UserPushNotificationTokenWhereInput>;
  some?: InputMaybe<UserPushNotificationTokenWhereInput>;
};

export type UserPushNotificationTokenMaxAggregate = {
  deviceId?: Maybe<Scalars['String']>;
  fcmToken?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserPushNotificationTokenMaxOrderByAggregateInput = {
  deviceId?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPushNotificationTokenMinAggregate = {
  deviceId?: Maybe<Scalars['String']>;
  fcmToken?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserPushNotificationTokenMinOrderByAggregateInput = {
  deviceId?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPushNotificationTokenOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserPushNotificationTokenOrderByWithAggregationInput = {
  _count?: InputMaybe<UserPushNotificationTokenCountOrderByAggregateInput>;
  _max?: InputMaybe<UserPushNotificationTokenMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserPushNotificationTokenMinOrderByAggregateInput>;
  deviceId?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserPushNotificationTokenOrderByWithRelationInput = {
  deviceId?: InputMaybe<SortOrder>;
  fcmToken?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserPushNotificationTokenScalarFieldEnum {
  DeviceId = 'deviceId',
  FcmToken = 'fcmToken',
  Id = 'id',
  UserId = 'userId'
}

export type UserPushNotificationTokenScalarWhereInput = {
  AND?: InputMaybe<Array<UserPushNotificationTokenScalarWhereInput>>;
  deviceId?: InputMaybe<StringFilter>;
  fcmToken?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<UserPushNotificationTokenScalarWhereInput>>;
  OR?: InputMaybe<Array<UserPushNotificationTokenScalarWhereInput>>;
  userId?: InputMaybe<StringFilter>;
};

export type UserPushNotificationTokenScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserPushNotificationTokenScalarWhereWithAggregatesInput>>;
  deviceId?: InputMaybe<StringWithAggregatesFilter>;
  fcmToken?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<UserPushNotificationTokenScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserPushNotificationTokenScalarWhereWithAggregatesInput>>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UserPushNotificationTokenUpdateInput = {
  deviceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserPushNotificationTokensNestedInput>;
};

export type UserPushNotificationTokenUpdateManyMutationInput = {
  deviceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserPushNotificationTokenUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserPushNotificationTokenWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserPushNotificationTokenCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserPushNotificationTokenCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserPushNotificationTokenCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserPushNotificationTokenWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserPushNotificationTokenScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserPushNotificationTokenWhereUniqueInput>>;
  set?: InputMaybe<Array<UserPushNotificationTokenWhereUniqueInput>>;
  update?: InputMaybe<Array<UserPushNotificationTokenUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserPushNotificationTokenUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserPushNotificationTokenUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserPushNotificationTokenUpdateManyWithWhereWithoutUserInput = {
  data: UserPushNotificationTokenUpdateManyMutationInput;
  where: UserPushNotificationTokenScalarWhereInput;
};

export type UserPushNotificationTokenUpdateWithoutUserInput = {
  deviceId?: InputMaybe<StringFieldUpdateOperationsInput>;
  fcmToken?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
};

export type UserPushNotificationTokenUpdateWithWhereUniqueWithoutUserInput = {
  data: UserPushNotificationTokenUpdateWithoutUserInput;
  where: UserPushNotificationTokenWhereUniqueInput;
};

export type UserPushNotificationTokenUpsertWithWhereUniqueWithoutUserInput = {
  create: UserPushNotificationTokenCreateWithoutUserInput;
  update: UserPushNotificationTokenUpdateWithoutUserInput;
  where: UserPushNotificationTokenWhereUniqueInput;
};

export type UserPushNotificationTokenUserIdDeviceIdCompoundUniqueInput = {
  deviceId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserPushNotificationTokenWhereInput = {
  AND?: InputMaybe<Array<UserPushNotificationTokenWhereInput>>;
  deviceId?: InputMaybe<StringFilter>;
  fcmToken?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<UserPushNotificationTokenWhereInput>>;
  OR?: InputMaybe<Array<UserPushNotificationTokenWhereInput>>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserPushNotificationTokenWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  userId_deviceId?: InputMaybe<UserPushNotificationTokenUserIdDeviceIdCompoundUniqueInput>;
};

export type UserRecord = {
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  recordId: Scalars['String'];
  recordType: UserRecordType;
  tenantId: Scalars['String'];
  timeStamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<Scalars['String']>;
};

export type UserRecordCountAggregate = {
  _all: Scalars['Int'];
  id: Scalars['Int'];
  metadata: Scalars['Int'];
  recordId: Scalars['Int'];
  recordType: Scalars['Int'];
  tenantId: Scalars['Int'];
  timeStamp: Scalars['Int'];
  userId: Scalars['Int'];
  verificationStatus: Scalars['Int'];
};

export type UserRecordCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrder>;
  recordId?: InputMaybe<SortOrder>;
  recordType?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  timeStamp?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
};

export type UserRecordCreateInput = {
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId: Scalars['String'];
  recordType: UserRecordType;
  tenant: TenantCreateNestedOneWithoutUserRecordsInput;
  timeStamp?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserRecordsInput>;
  verificationStatus?: InputMaybe<Scalars['String']>;
};

export type UserRecordCreateManyInput = {
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId: Scalars['String'];
  recordType: UserRecordType;
  tenantId: Scalars['String'];
  timeStamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
  verificationStatus?: InputMaybe<Scalars['String']>;
};

export type UserRecordCreateManyTenantInput = {
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId: Scalars['String'];
  recordType: UserRecordType;
  timeStamp?: InputMaybe<Scalars['DateTime']>;
  userId?: InputMaybe<Scalars['String']>;
  verificationStatus?: InputMaybe<Scalars['String']>;
};

export type UserRecordCreateManyTenantInputEnvelope = {
  data: Array<UserRecordCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserRecordCreateManyUserInput = {
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId: Scalars['String'];
  recordType: UserRecordType;
  tenantId: Scalars['String'];
  timeStamp?: InputMaybe<Scalars['DateTime']>;
  verificationStatus?: InputMaybe<Scalars['String']>;
};

export type UserRecordCreateManyUserInputEnvelope = {
  data: Array<UserRecordCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserRecordCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserRecordCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<UserRecordCreateWithoutTenantInput>>;
  createMany?: InputMaybe<UserRecordCreateManyTenantInputEnvelope>;
};

export type UserRecordCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserRecordCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserRecordCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserRecordCreateManyUserInputEnvelope>;
};

export type UserRecordCreateOrConnectWithoutTenantInput = {
  create: UserRecordCreateWithoutTenantInput;
  where: UserRecordWhereUniqueInput;
};

export type UserRecordCreateOrConnectWithoutUserInput = {
  create: UserRecordCreateWithoutUserInput;
  where: UserRecordWhereUniqueInput;
};

export type UserRecordCreateWithoutTenantInput = {
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId: Scalars['String'];
  recordType: UserRecordType;
  timeStamp?: InputMaybe<Scalars['DateTime']>;
  user?: InputMaybe<UserCreateNestedOneWithoutUserRecordsInput>;
  verificationStatus?: InputMaybe<Scalars['String']>;
};

export type UserRecordCreateWithoutUserInput = {
  id?: InputMaybe<Scalars['String']>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId: Scalars['String'];
  recordType: UserRecordType;
  tenant: TenantCreateNestedOneWithoutUserRecordsInput;
  timeStamp?: InputMaybe<Scalars['DateTime']>;
  verificationStatus?: InputMaybe<Scalars['String']>;
};

export type UserRecordGroupBy = {
  _count?: Maybe<UserRecordCountAggregate>;
  _max?: Maybe<UserRecordMaxAggregate>;
  _min?: Maybe<UserRecordMinAggregate>;
  id: Scalars['String'];
  metadata?: Maybe<Scalars['JSON']>;
  recordId: Scalars['String'];
  recordType: UserRecordType;
  tenantId: Scalars['String'];
  timeStamp: Scalars['DateTime'];
  userId?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<Scalars['String']>;
};

export type UserRecordListRelationFilter = {
  every?: InputMaybe<UserRecordWhereInput>;
  none?: InputMaybe<UserRecordWhereInput>;
  some?: InputMaybe<UserRecordWhereInput>;
};

export type UserRecordMaxAggregate = {
  id?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  recordType?: Maybe<UserRecordType>;
  tenantId?: Maybe<Scalars['String']>;
  timeStamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<Scalars['String']>;
};

export type UserRecordMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  recordId?: InputMaybe<SortOrder>;
  recordType?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  timeStamp?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
};

export type UserRecordMinAggregate = {
  id?: Maybe<Scalars['String']>;
  recordId?: Maybe<Scalars['String']>;
  recordType?: Maybe<UserRecordType>;
  tenantId?: Maybe<Scalars['String']>;
  timeStamp?: Maybe<Scalars['DateTime']>;
  userId?: Maybe<Scalars['String']>;
  verificationStatus?: Maybe<Scalars['String']>;
};

export type UserRecordMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  recordId?: InputMaybe<SortOrder>;
  recordType?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  timeStamp?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
  verificationStatus?: InputMaybe<SortOrder>;
};

export type UserRecordOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserRecordOrderByWithAggregationInput = {
  _count?: InputMaybe<UserRecordCountOrderByAggregateInput>;
  _max?: InputMaybe<UserRecordMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserRecordMinOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  recordId?: InputMaybe<SortOrder>;
  recordType?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  timeStamp?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrderInput>;
  verificationStatus?: InputMaybe<SortOrderInput>;
};

export type UserRecordOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  metadata?: InputMaybe<SortOrderInput>;
  recordId?: InputMaybe<SortOrder>;
  recordType?: InputMaybe<SortOrder>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  timeStamp?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userId?: InputMaybe<SortOrderInput>;
  verificationStatus?: InputMaybe<SortOrderInput>;
};

export enum UserRecordScalarFieldEnum {
  Id = 'id',
  Metadata = 'metadata',
  RecordId = 'recordId',
  RecordType = 'recordType',
  TenantId = 'tenantId',
  TimeStamp = 'timeStamp',
  UserId = 'userId',
  VerificationStatus = 'verificationStatus'
}

export type UserRecordScalarWhereInput = {
  AND?: InputMaybe<Array<UserRecordScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<UserRecordScalarWhereInput>>;
  OR?: InputMaybe<Array<UserRecordScalarWhereInput>>;
  recordId?: InputMaybe<StringFilter>;
  recordType?: InputMaybe<EnumUserRecordTypeFilter>;
  tenantId?: InputMaybe<StringFilter>;
  timeStamp?: InputMaybe<DateTimeFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  verificationStatus?: InputMaybe<StringNullableFilter>;
};

export type UserRecordScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserRecordScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  metadata?: InputMaybe<JsonNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<UserRecordScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserRecordScalarWhereWithAggregatesInput>>;
  recordId?: InputMaybe<StringWithAggregatesFilter>;
  recordType?: InputMaybe<EnumUserRecordTypeWithAggregatesFilter>;
  tenantId?: InputMaybe<StringWithAggregatesFilter>;
  timeStamp?: InputMaybe<DateTimeWithAggregatesFilter>;
  userId?: InputMaybe<StringNullableWithAggregatesFilter>;
  verificationStatus?: InputMaybe<StringNullableWithAggregatesFilter>;
};

export enum UserRecordType {
  Call = 'CALL',
  FaceLiveness = 'FACE_LIVENESS',
  FaceUpload = 'FACE_UPLOAD',
  IdVerification = 'ID_VERIFICATION',
  MrzIdVerification = 'MRZ_ID_VERIFICATION',
  Payment = 'PAYMENT',
  PaymentAuthorization = 'PAYMENT_AUTHORIZATION'
}

export type UserRecordUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId?: InputMaybe<StringFieldUpdateOperationsInput>;
  recordType?: InputMaybe<EnumUserRecordTypeFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutUserRecordsNestedInput>;
  timeStamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutUserRecordsNestedInput>;
  verificationStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserRecordUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId?: InputMaybe<StringFieldUpdateOperationsInput>;
  recordType?: InputMaybe<EnumUserRecordTypeFieldUpdateOperationsInput>;
  timeStamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserRecordUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserRecordCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<UserRecordCreateWithoutTenantInput>>;
  createMany?: InputMaybe<UserRecordCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<UserRecordUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<UserRecordUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<UserRecordUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type UserRecordUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserRecordCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserRecordCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserRecordCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserRecordScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  set?: InputMaybe<Array<UserRecordWhereUniqueInput>>;
  update?: InputMaybe<Array<UserRecordUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserRecordUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserRecordUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserRecordUpdateManyWithWhereWithoutTenantInput = {
  data: UserRecordUpdateManyMutationInput;
  where: UserRecordScalarWhereInput;
};

export type UserRecordUpdateManyWithWhereWithoutUserInput = {
  data: UserRecordUpdateManyMutationInput;
  where: UserRecordScalarWhereInput;
};

export type UserRecordUpdateWithoutTenantInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId?: InputMaybe<StringFieldUpdateOperationsInput>;
  recordType?: InputMaybe<EnumUserRecordTypeFieldUpdateOperationsInput>;
  timeStamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneWithoutUserRecordsNestedInput>;
  verificationStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserRecordUpdateWithoutUserInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  metadata?: InputMaybe<Scalars['JSON']>;
  recordId?: InputMaybe<StringFieldUpdateOperationsInput>;
  recordType?: InputMaybe<EnumUserRecordTypeFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutUserRecordsNestedInput>;
  timeStamp?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  verificationStatus?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserRecordUpdateWithWhereUniqueWithoutTenantInput = {
  data: UserRecordUpdateWithoutTenantInput;
  where: UserRecordWhereUniqueInput;
};

export type UserRecordUpdateWithWhereUniqueWithoutUserInput = {
  data: UserRecordUpdateWithoutUserInput;
  where: UserRecordWhereUniqueInput;
};

export type UserRecordUpsertWithWhereUniqueWithoutTenantInput = {
  create: UserRecordCreateWithoutTenantInput;
  update: UserRecordUpdateWithoutTenantInput;
  where: UserRecordWhereUniqueInput;
};

export type UserRecordUpsertWithWhereUniqueWithoutUserInput = {
  create: UserRecordCreateWithoutUserInput;
  update: UserRecordUpdateWithoutUserInput;
  where: UserRecordWhereUniqueInput;
};

export type UserRecordWhereInput = {
  AND?: InputMaybe<Array<UserRecordWhereInput>>;
  id?: InputMaybe<StringFilter>;
  metadata?: InputMaybe<JsonNullableFilter>;
  NOT?: InputMaybe<Array<UserRecordWhereInput>>;
  OR?: InputMaybe<Array<UserRecordWhereInput>>;
  recordId?: InputMaybe<StringFilter>;
  recordType?: InputMaybe<EnumUserRecordTypeFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  timeStamp?: InputMaybe<DateTimeFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userId?: InputMaybe<StringNullableFilter>;
  verificationStatus?: InputMaybe<StringNullableFilter>;
};

export type UserRecordWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type UserRelationFilter = {
  is?: InputMaybe<UserWhereInput>;
  isNot?: InputMaybe<UserWhereInput>;
};

export enum UserScalarFieldEnum {
  Country = 'country',
  CreatedAt = 'createdAt',
  Cuid = 'cuid',
  DashboardPreferences = 'dashboardPreferences',
  DeviceId = 'deviceId',
  Email = 'email',
  FirstName = 'firstName',
  Id = 'id',
  LastName = 'lastName',
  LastSeenAt = 'lastSeenAt',
  Name = 'name',
  OpenpathExternalUserId = 'openpathExternalUserId',
  Password = 'password',
  PhoneNumber = 'phoneNumber'
}

export type UserScalarWhereInput = {
  AND?: InputMaybe<Array<UserScalarWhereInput>>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  cuid?: InputMaybe<StringFilter>;
  dashboardPreferences?: InputMaybe<JsonNullableFilter>;
  deviceId?: InputMaybe<StringNullableFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  name?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<UserScalarWhereInput>>;
  openpathExternalUserId?: InputMaybe<StringNullableFilter>;
  OR?: InputMaybe<Array<UserScalarWhereInput>>;
  password?: InputMaybe<StringNullableFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
};

export type UserTenantData = {
  id: Scalars['String'];
  paymentDataId?: Maybe<Scalars['String']>;
  signatureImageUrl?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  userAcceptedTerms?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UserTenantDataCountAggregate = {
  _all: Scalars['Int'];
  id: Scalars['Int'];
  paymentDataId: Scalars['Int'];
  signatureImageUrl: Scalars['Int'];
  tenantId: Scalars['Int'];
  userAcceptedTerms: Scalars['Int'];
  userId: Scalars['Int'];
};

export type UserTenantDataCountOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  paymentDataId?: InputMaybe<SortOrder>;
  signatureImageUrl?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  userAcceptedTerms?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserTenantDataCreateInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentData?: InputMaybe<PaymentCreateNestedOneWithoutUserTenantDataInput>;
  signatureImageUrl?: InputMaybe<Scalars['String']>;
  tenant: TenantCreateNestedOneWithoutUserTenantDataInput;
  user: UserCreateNestedOneWithoutUserTenantDataInput;
  userAcceptedTerms?: InputMaybe<Scalars['Boolean']>;
};

export type UserTenantDataCreateManyInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentDataId?: InputMaybe<Scalars['String']>;
  signatureImageUrl?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  userAcceptedTerms?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UserTenantDataCreateManyPaymentDataInput = {
  id?: InputMaybe<Scalars['String']>;
  signatureImageUrl?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  userAcceptedTerms?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UserTenantDataCreateManyPaymentDataInputEnvelope = {
  data: Array<UserTenantDataCreateManyPaymentDataInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserTenantDataCreateManyTenantInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentDataId?: InputMaybe<Scalars['String']>;
  signatureImageUrl?: InputMaybe<Scalars['String']>;
  userAcceptedTerms?: InputMaybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UserTenantDataCreateManyTenantInputEnvelope = {
  data: Array<UserTenantDataCreateManyTenantInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserTenantDataCreateManyUserInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentDataId?: InputMaybe<Scalars['String']>;
  signatureImageUrl?: InputMaybe<Scalars['String']>;
  tenantId: Scalars['String'];
  userAcceptedTerms?: InputMaybe<Scalars['Boolean']>;
};

export type UserTenantDataCreateManyUserInputEnvelope = {
  data: Array<UserTenantDataCreateManyUserInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type UserTenantDataCreateNestedManyWithoutPaymentDataInput = {
  connect?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTenantDataCreateOrConnectWithoutPaymentDataInput>>;
  create?: InputMaybe<Array<UserTenantDataCreateWithoutPaymentDataInput>>;
  createMany?: InputMaybe<UserTenantDataCreateManyPaymentDataInputEnvelope>;
};

export type UserTenantDataCreateNestedManyWithoutTenantInput = {
  connect?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTenantDataCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<UserTenantDataCreateWithoutTenantInput>>;
  createMany?: InputMaybe<UserTenantDataCreateManyTenantInputEnvelope>;
};

export type UserTenantDataCreateNestedManyWithoutUserInput = {
  connect?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTenantDataCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserTenantDataCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserTenantDataCreateManyUserInputEnvelope>;
};

export type UserTenantDataCreateOrConnectWithoutPaymentDataInput = {
  create: UserTenantDataCreateWithoutPaymentDataInput;
  where: UserTenantDataWhereUniqueInput;
};

export type UserTenantDataCreateOrConnectWithoutTenantInput = {
  create: UserTenantDataCreateWithoutTenantInput;
  where: UserTenantDataWhereUniqueInput;
};

export type UserTenantDataCreateOrConnectWithoutUserInput = {
  create: UserTenantDataCreateWithoutUserInput;
  where: UserTenantDataWhereUniqueInput;
};

export type UserTenantDataCreateWithoutPaymentDataInput = {
  id?: InputMaybe<Scalars['String']>;
  signatureImageUrl?: InputMaybe<Scalars['String']>;
  tenant: TenantCreateNestedOneWithoutUserTenantDataInput;
  user: UserCreateNestedOneWithoutUserTenantDataInput;
  userAcceptedTerms?: InputMaybe<Scalars['Boolean']>;
};

export type UserTenantDataCreateWithoutTenantInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentData?: InputMaybe<PaymentCreateNestedOneWithoutUserTenantDataInput>;
  signatureImageUrl?: InputMaybe<Scalars['String']>;
  user: UserCreateNestedOneWithoutUserTenantDataInput;
  userAcceptedTerms?: InputMaybe<Scalars['Boolean']>;
};

export type UserTenantDataCreateWithoutUserInput = {
  id?: InputMaybe<Scalars['String']>;
  paymentData?: InputMaybe<PaymentCreateNestedOneWithoutUserTenantDataInput>;
  signatureImageUrl?: InputMaybe<Scalars['String']>;
  tenant: TenantCreateNestedOneWithoutUserTenantDataInput;
  userAcceptedTerms?: InputMaybe<Scalars['Boolean']>;
};

export type UserTenantDataGroupBy = {
  _count?: Maybe<UserTenantDataCountAggregate>;
  _max?: Maybe<UserTenantDataMaxAggregate>;
  _min?: Maybe<UserTenantDataMinAggregate>;
  id: Scalars['String'];
  paymentDataId?: Maybe<Scalars['String']>;
  signatureImageUrl?: Maybe<Scalars['String']>;
  tenantId: Scalars['String'];
  userAcceptedTerms?: Maybe<Scalars['Boolean']>;
  userId: Scalars['String'];
};

export type UserTenantDataListRelationFilter = {
  every?: InputMaybe<UserTenantDataWhereInput>;
  none?: InputMaybe<UserTenantDataWhereInput>;
  some?: InputMaybe<UserTenantDataWhereInput>;
};

export type UserTenantDataMaxAggregate = {
  id?: Maybe<Scalars['String']>;
  paymentDataId?: Maybe<Scalars['String']>;
  signatureImageUrl?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  userAcceptedTerms?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserTenantDataMaxOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  paymentDataId?: InputMaybe<SortOrder>;
  signatureImageUrl?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  userAcceptedTerms?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserTenantDataMinAggregate = {
  id?: Maybe<Scalars['String']>;
  paymentDataId?: Maybe<Scalars['String']>;
  signatureImageUrl?: Maybe<Scalars['String']>;
  tenantId?: Maybe<Scalars['String']>;
  userAcceptedTerms?: Maybe<Scalars['Boolean']>;
  userId?: Maybe<Scalars['String']>;
};

export type UserTenantDataMinOrderByAggregateInput = {
  id?: InputMaybe<SortOrder>;
  paymentDataId?: InputMaybe<SortOrder>;
  signatureImageUrl?: InputMaybe<SortOrder>;
  tenantId?: InputMaybe<SortOrder>;
  userAcceptedTerms?: InputMaybe<SortOrder>;
  userId?: InputMaybe<SortOrder>;
};

export type UserTenantDataOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type UserTenantDataOrderByWithAggregationInput = {
  _count?: InputMaybe<UserTenantDataCountOrderByAggregateInput>;
  _max?: InputMaybe<UserTenantDataMaxOrderByAggregateInput>;
  _min?: InputMaybe<UserTenantDataMinOrderByAggregateInput>;
  id?: InputMaybe<SortOrder>;
  paymentDataId?: InputMaybe<SortOrderInput>;
  signatureImageUrl?: InputMaybe<SortOrderInput>;
  tenantId?: InputMaybe<SortOrder>;
  userAcceptedTerms?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrder>;
};

export type UserTenantDataOrderByWithRelationInput = {
  id?: InputMaybe<SortOrder>;
  paymentData?: InputMaybe<PaymentOrderByWithRelationInput>;
  paymentDataId?: InputMaybe<SortOrderInput>;
  signatureImageUrl?: InputMaybe<SortOrderInput>;
  tenant?: InputMaybe<TenantOrderByWithRelationInput>;
  tenantId?: InputMaybe<SortOrder>;
  user?: InputMaybe<UserOrderByWithRelationInput>;
  userAcceptedTerms?: InputMaybe<SortOrderInput>;
  userId?: InputMaybe<SortOrder>;
};

export enum UserTenantDataScalarFieldEnum {
  Id = 'id',
  PaymentDataId = 'paymentDataId',
  SignatureImageUrl = 'signatureImageUrl',
  TenantId = 'tenantId',
  UserAcceptedTerms = 'userAcceptedTerms',
  UserId = 'userId'
}

export type UserTenantDataScalarWhereInput = {
  AND?: InputMaybe<Array<UserTenantDataScalarWhereInput>>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<UserTenantDataScalarWhereInput>>;
  OR?: InputMaybe<Array<UserTenantDataScalarWhereInput>>;
  paymentDataId?: InputMaybe<StringNullableFilter>;
  signatureImageUrl?: InputMaybe<StringNullableFilter>;
  tenantId?: InputMaybe<StringFilter>;
  userAcceptedTerms?: InputMaybe<BoolNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserTenantDataScalarWhereWithAggregatesInput = {
  AND?: InputMaybe<Array<UserTenantDataScalarWhereWithAggregatesInput>>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  NOT?: InputMaybe<Array<UserTenantDataScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<UserTenantDataScalarWhereWithAggregatesInput>>;
  paymentDataId?: InputMaybe<StringNullableWithAggregatesFilter>;
  signatureImageUrl?: InputMaybe<StringNullableWithAggregatesFilter>;
  tenantId?: InputMaybe<StringWithAggregatesFilter>;
  userAcceptedTerms?: InputMaybe<BoolNullableWithAggregatesFilter>;
  userId?: InputMaybe<StringWithAggregatesFilter>;
};

export type UserTenantDataUpdateInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentData?: InputMaybe<PaymentUpdateOneWithoutUserTenantDataNestedInput>;
  signatureImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutUserTenantDataNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserTenantDataNestedInput>;
  userAcceptedTerms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type UserTenantDataUpdateManyMutationInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  signatureImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  userAcceptedTerms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type UserTenantDataUpdateManyWithoutPaymentDataNestedInput = {
  connect?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTenantDataCreateOrConnectWithoutPaymentDataInput>>;
  create?: InputMaybe<Array<UserTenantDataCreateWithoutPaymentDataInput>>;
  createMany?: InputMaybe<UserTenantDataCreateManyPaymentDataInputEnvelope>;
  delete?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserTenantDataScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  set?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  update?: InputMaybe<Array<UserTenantDataUpdateWithWhereUniqueWithoutPaymentDataInput>>;
  updateMany?: InputMaybe<Array<UserTenantDataUpdateManyWithWhereWithoutPaymentDataInput>>;
  upsert?: InputMaybe<Array<UserTenantDataUpsertWithWhereUniqueWithoutPaymentDataInput>>;
};

export type UserTenantDataUpdateManyWithoutTenantNestedInput = {
  connect?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTenantDataCreateOrConnectWithoutTenantInput>>;
  create?: InputMaybe<Array<UserTenantDataCreateWithoutTenantInput>>;
  createMany?: InputMaybe<UserTenantDataCreateManyTenantInputEnvelope>;
  delete?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserTenantDataScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  set?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  update?: InputMaybe<Array<UserTenantDataUpdateWithWhereUniqueWithoutTenantInput>>;
  updateMany?: InputMaybe<Array<UserTenantDataUpdateManyWithWhereWithoutTenantInput>>;
  upsert?: InputMaybe<Array<UserTenantDataUpsertWithWhereUniqueWithoutTenantInput>>;
};

export type UserTenantDataUpdateManyWithoutUserNestedInput = {
  connect?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserTenantDataCreateOrConnectWithoutUserInput>>;
  create?: InputMaybe<Array<UserTenantDataCreateWithoutUserInput>>;
  createMany?: InputMaybe<UserTenantDataCreateManyUserInputEnvelope>;
  delete?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserTenantDataScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  set?: InputMaybe<Array<UserTenantDataWhereUniqueInput>>;
  update?: InputMaybe<Array<UserTenantDataUpdateWithWhereUniqueWithoutUserInput>>;
  updateMany?: InputMaybe<Array<UserTenantDataUpdateManyWithWhereWithoutUserInput>>;
  upsert?: InputMaybe<Array<UserTenantDataUpsertWithWhereUniqueWithoutUserInput>>;
};

export type UserTenantDataUpdateManyWithWhereWithoutPaymentDataInput = {
  data: UserTenantDataUpdateManyMutationInput;
  where: UserTenantDataScalarWhereInput;
};

export type UserTenantDataUpdateManyWithWhereWithoutTenantInput = {
  data: UserTenantDataUpdateManyMutationInput;
  where: UserTenantDataScalarWhereInput;
};

export type UserTenantDataUpdateManyWithWhereWithoutUserInput = {
  data: UserTenantDataUpdateManyMutationInput;
  where: UserTenantDataScalarWhereInput;
};

export type UserTenantDataUpdateWithoutPaymentDataInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  signatureImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutUserTenantDataNestedInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserTenantDataNestedInput>;
  userAcceptedTerms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type UserTenantDataUpdateWithoutTenantInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentData?: InputMaybe<PaymentUpdateOneWithoutUserTenantDataNestedInput>;
  signatureImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  user?: InputMaybe<UserUpdateOneRequiredWithoutUserTenantDataNestedInput>;
  userAcceptedTerms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type UserTenantDataUpdateWithoutUserInput = {
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  paymentData?: InputMaybe<PaymentUpdateOneWithoutUserTenantDataNestedInput>;
  signatureImageUrl?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  tenant?: InputMaybe<TenantUpdateOneRequiredWithoutUserTenantDataNestedInput>;
  userAcceptedTerms?: InputMaybe<NullableBoolFieldUpdateOperationsInput>;
};

export type UserTenantDataUpdateWithWhereUniqueWithoutPaymentDataInput = {
  data: UserTenantDataUpdateWithoutPaymentDataInput;
  where: UserTenantDataWhereUniqueInput;
};

export type UserTenantDataUpdateWithWhereUniqueWithoutTenantInput = {
  data: UserTenantDataUpdateWithoutTenantInput;
  where: UserTenantDataWhereUniqueInput;
};

export type UserTenantDataUpdateWithWhereUniqueWithoutUserInput = {
  data: UserTenantDataUpdateWithoutUserInput;
  where: UserTenantDataWhereUniqueInput;
};

export type UserTenantDataUpsertWithWhereUniqueWithoutPaymentDataInput = {
  create: UserTenantDataCreateWithoutPaymentDataInput;
  update: UserTenantDataUpdateWithoutPaymentDataInput;
  where: UserTenantDataWhereUniqueInput;
};

export type UserTenantDataUpsertWithWhereUniqueWithoutTenantInput = {
  create: UserTenantDataCreateWithoutTenantInput;
  update: UserTenantDataUpdateWithoutTenantInput;
  where: UserTenantDataWhereUniqueInput;
};

export type UserTenantDataUpsertWithWhereUniqueWithoutUserInput = {
  create: UserTenantDataCreateWithoutUserInput;
  update: UserTenantDataUpdateWithoutUserInput;
  where: UserTenantDataWhereUniqueInput;
};

export type UserTenantDataUserIdTenantIdCompoundUniqueInput = {
  tenantId: Scalars['String'];
  userId: Scalars['String'];
};

export type UserTenantDataWhereInput = {
  AND?: InputMaybe<Array<UserTenantDataWhereInput>>;
  id?: InputMaybe<StringFilter>;
  NOT?: InputMaybe<Array<UserTenantDataWhereInput>>;
  OR?: InputMaybe<Array<UserTenantDataWhereInput>>;
  paymentData?: InputMaybe<PaymentRelationFilter>;
  paymentDataId?: InputMaybe<StringNullableFilter>;
  signatureImageUrl?: InputMaybe<StringNullableFilter>;
  tenant?: InputMaybe<TenantRelationFilter>;
  tenantId?: InputMaybe<StringFilter>;
  user?: InputMaybe<UserRelationFilter>;
  userAcceptedTerms?: InputMaybe<BoolNullableFilter>;
  userId?: InputMaybe<StringFilter>;
};

export type UserTenantDataWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
  userId_tenantId?: InputMaybe<UserTenantDataUserIdTenantIdCompoundUniqueInput>;
};

export type UserUpdateInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateManyMutationInput = {
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
};

export type UserUpdateManyWithoutCallRecordsNestedInput = {
  connect?: InputMaybe<Array<UserWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<UserCreateOrConnectWithoutCallRecordsInput>>;
  create?: InputMaybe<Array<UserCreateWithoutCallRecordsInput>>;
  delete?: InputMaybe<Array<UserWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<UserScalarWhereInput>>;
  disconnect?: InputMaybe<Array<UserWhereUniqueInput>>;
  set?: InputMaybe<Array<UserWhereUniqueInput>>;
  update?: InputMaybe<Array<UserUpdateWithWhereUniqueWithoutCallRecordsInput>>;
  updateMany?: InputMaybe<Array<UserUpdateManyWithWhereWithoutCallRecordsInput>>;
  upsert?: InputMaybe<Array<UserUpsertWithWhereUniqueWithoutCallRecordsInput>>;
};

export type UserUpdateManyWithWhereWithoutCallRecordsInput = {
  data: UserUpdateManyMutationInput;
  where: UserScalarWhereInput;
};

export type UserUpdateOneRequiredWithoutAccessGrantsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutAccessGrantsInput>;
  create?: InputMaybe<UserCreateWithoutAccessGrantsInput>;
  update?: InputMaybe<UserUpdateWithoutAccessGrantsInput>;
  upsert?: InputMaybe<UserUpsertWithoutAccessGrantsInput>;
};

export type UserUpdateOneRequiredWithoutCredentialNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutCredentialInput>;
  create?: InputMaybe<UserCreateWithoutCredentialInput>;
  update?: InputMaybe<UserUpdateWithoutCredentialInput>;
  upsert?: InputMaybe<UserUpsertWithoutCredentialInput>;
};

export type UserUpdateOneRequiredWithoutDevicesNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutDevicesInput>;
  create?: InputMaybe<UserCreateWithoutDevicesInput>;
  update?: InputMaybe<UserUpdateWithoutDevicesInput>;
  upsert?: InputMaybe<UserUpsertWithoutDevicesInput>;
};

export type UserUpdateOneRequiredWithoutMembershipsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMembershipsInput>;
  create?: InputMaybe<UserCreateWithoutMembershipsInput>;
  update?: InputMaybe<UserUpdateWithoutMembershipsInput>;
  upsert?: InputMaybe<UserUpsertWithoutMembershipsInput>;
};

export type UserUpdateOneRequiredWithoutSecondaryUsersOnAccessGrantsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutSecondaryUsersOnAccessGrantsInput>;
  create?: InputMaybe<UserCreateWithoutSecondaryUsersOnAccessGrantsInput>;
  update?: InputMaybe<UserUpdateWithoutSecondaryUsersOnAccessGrantsInput>;
  upsert?: InputMaybe<UserUpsertWithoutSecondaryUsersOnAccessGrantsInput>;
};

export type UserUpdateOneRequiredWithoutUserAccessGrantRequirementNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserAccessGrantRequirementInput>;
  create?: InputMaybe<UserCreateWithoutUserAccessGrantRequirementInput>;
  update?: InputMaybe<UserUpdateWithoutUserAccessGrantRequirementInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserAccessGrantRequirementInput>;
};

export type UserUpdateOneRequiredWithoutUserLocationDataNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserLocationDataInput>;
  create?: InputMaybe<UserCreateWithoutUserLocationDataInput>;
  update?: InputMaybe<UserUpdateWithoutUserLocationDataInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserLocationDataInput>;
};

export type UserUpdateOneRequiredWithoutUserPushNotificationTokensNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserPushNotificationTokensInput>;
  create?: InputMaybe<UserCreateWithoutUserPushNotificationTokensInput>;
  update?: InputMaybe<UserUpdateWithoutUserPushNotificationTokensInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserPushNotificationTokensInput>;
};

export type UserUpdateOneRequiredWithoutUserTenantDataNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserTenantDataInput>;
  create?: InputMaybe<UserCreateWithoutUserTenantDataInput>;
  update?: InputMaybe<UserUpdateWithoutUserTenantDataInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserTenantDataInput>;
};

export type UserUpdateOneWithoutInternalApiCallsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutInternalApiCallsInput>;
  create?: InputMaybe<UserCreateWithoutInternalApiCallsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateWithoutInternalApiCallsInput>;
  upsert?: InputMaybe<UserUpsertWithoutInternalApiCallsInput>;
};

export type UserUpdateOneWithoutMadeCallsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutMadeCallsInput>;
  create?: InputMaybe<UserCreateWithoutMadeCallsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateWithoutMadeCallsInput>;
  upsert?: InputMaybe<UserUpsertWithoutMadeCallsInput>;
};

export type UserUpdateOneWithoutNotificationNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutNotificationInput>;
  create?: InputMaybe<UserCreateWithoutNotificationInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateWithoutNotificationInput>;
  upsert?: InputMaybe<UserUpsertWithoutNotificationInput>;
};

export type UserUpdateOneWithoutPaymentsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutPaymentsInput>;
  create?: InputMaybe<UserCreateWithoutPaymentsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateWithoutPaymentsInput>;
  upsert?: InputMaybe<UserUpsertWithoutPaymentsInput>;
};

export type UserUpdateOneWithoutReceivedCallsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutReceivedCallsInput>;
  create?: InputMaybe<UserCreateWithoutReceivedCallsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateWithoutReceivedCallsInput>;
  upsert?: InputMaybe<UserUpsertWithoutReceivedCallsInput>;
};

export type UserUpdateOneWithoutUserRecordsNestedInput = {
  connect?: InputMaybe<UserWhereUniqueInput>;
  connectOrCreate?: InputMaybe<UserCreateOrConnectWithoutUserRecordsInput>;
  create?: InputMaybe<UserCreateWithoutUserRecordsInput>;
  delete?: InputMaybe<Scalars['Boolean']>;
  disconnect?: InputMaybe<Scalars['Boolean']>;
  update?: InputMaybe<UserUpdateWithoutUserRecordsInput>;
  upsert?: InputMaybe<UserUpsertWithoutUserRecordsInput>;
};

export type UserUpdateWithoutAccessGrantsInput = {
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutCallRecordsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutCredentialInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutDevicesInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutInternalApiCallsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutMadeCallsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutMembershipsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutNotificationInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutPaymentsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutReceivedCallsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutSecondaryUsersOnAccessGrantsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserAccessGrantRequirementInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserLocationDataInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserPushNotificationTokensInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserRecordsInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  UserTenantData?: InputMaybe<UserTenantDataUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithoutUserTenantDataInput = {
  accessGrants?: InputMaybe<AccessGrantUpdateManyWithoutUserNestedInput>;
  authChallenges?: InputMaybe<AuthChallengeUpdateManyWithoutUserNestedInput>;
  callRecords?: InputMaybe<CallRecordUpdateManyWithoutUsersNestedInput>;
  country?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  createdAt?: InputMaybe<DateTimeFieldUpdateOperationsInput>;
  Credential?: InputMaybe<CredentialUpdateManyWithoutUserNestedInput>;
  cuid?: InputMaybe<StringFieldUpdateOperationsInput>;
  dashboardPreferences?: InputMaybe<Scalars['JSON']>;
  deviceId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  devices?: InputMaybe<DeviceUpdateManyWithoutUserNestedInput>;
  email?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  firstName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  internalApiCalls?: InputMaybe<InternalApiCallUpdateManyWithoutUserNestedInput>;
  lastName?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  lastSeenAt?: InputMaybe<NullableDateTimeFieldUpdateOperationsInput>;
  madeCalls?: InputMaybe<CallRecordUpdateManyWithoutCallerNestedInput>;
  memberships?: InputMaybe<MembershipUpdateManyWithoutUserNestedInput>;
  name?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  Notification?: InputMaybe<NotificationUpdateManyWithoutUserNestedInput>;
  openpathExternalUserId?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  payments?: InputMaybe<PaymentUpdateManyWithoutUserNestedInput>;
  phoneNumber?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  receivedCalls?: InputMaybe<CallRecordUpdateManyWithoutAgentNestedInput>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsUpdateManyWithoutUserNestedInput>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementUpdateManyWithoutUserNestedInput>;
  UserLocationData?: InputMaybe<UserLocationDataUpdateManyWithoutUserNestedInput>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenUpdateManyWithoutUserNestedInput>;
  userRecords?: InputMaybe<UserRecordUpdateManyWithoutUserNestedInput>;
};

export type UserUpdateWithWhereUniqueWithoutCallRecordsInput = {
  data: UserUpdateWithoutCallRecordsInput;
  where: UserWhereUniqueInput;
};

export type UserUpsertWithoutAccessGrantsInput = {
  create: UserCreateWithoutAccessGrantsInput;
  update: UserUpdateWithoutAccessGrantsInput;
};

export type UserUpsertWithoutCredentialInput = {
  create: UserCreateWithoutCredentialInput;
  update: UserUpdateWithoutCredentialInput;
};

export type UserUpsertWithoutDevicesInput = {
  create: UserCreateWithoutDevicesInput;
  update: UserUpdateWithoutDevicesInput;
};

export type UserUpsertWithoutInternalApiCallsInput = {
  create: UserCreateWithoutInternalApiCallsInput;
  update: UserUpdateWithoutInternalApiCallsInput;
};

export type UserUpsertWithoutMadeCallsInput = {
  create: UserCreateWithoutMadeCallsInput;
  update: UserUpdateWithoutMadeCallsInput;
};

export type UserUpsertWithoutMembershipsInput = {
  create: UserCreateWithoutMembershipsInput;
  update: UserUpdateWithoutMembershipsInput;
};

export type UserUpsertWithoutNotificationInput = {
  create: UserCreateWithoutNotificationInput;
  update: UserUpdateWithoutNotificationInput;
};

export type UserUpsertWithoutPaymentsInput = {
  create: UserCreateWithoutPaymentsInput;
  update: UserUpdateWithoutPaymentsInput;
};

export type UserUpsertWithoutReceivedCallsInput = {
  create: UserCreateWithoutReceivedCallsInput;
  update: UserUpdateWithoutReceivedCallsInput;
};

export type UserUpsertWithoutSecondaryUsersOnAccessGrantsInput = {
  create: UserCreateWithoutSecondaryUsersOnAccessGrantsInput;
  update: UserUpdateWithoutSecondaryUsersOnAccessGrantsInput;
};

export type UserUpsertWithoutUserAccessGrantRequirementInput = {
  create: UserCreateWithoutUserAccessGrantRequirementInput;
  update: UserUpdateWithoutUserAccessGrantRequirementInput;
};

export type UserUpsertWithoutUserLocationDataInput = {
  create: UserCreateWithoutUserLocationDataInput;
  update: UserUpdateWithoutUserLocationDataInput;
};

export type UserUpsertWithoutUserPushNotificationTokensInput = {
  create: UserCreateWithoutUserPushNotificationTokensInput;
  update: UserUpdateWithoutUserPushNotificationTokensInput;
};

export type UserUpsertWithoutUserRecordsInput = {
  create: UserCreateWithoutUserRecordsInput;
  update: UserUpdateWithoutUserRecordsInput;
};

export type UserUpsertWithoutUserTenantDataInput = {
  create: UserCreateWithoutUserTenantDataInput;
  update: UserUpdateWithoutUserTenantDataInput;
};

export type UserUpsertWithWhereUniqueWithoutCallRecordsInput = {
  create: UserCreateWithoutCallRecordsInput;
  update: UserUpdateWithoutCallRecordsInput;
  where: UserWhereUniqueInput;
};

export type UserWhereInput = {
  accessGrants?: InputMaybe<AccessGrantListRelationFilter>;
  AND?: InputMaybe<Array<UserWhereInput>>;
  authChallenges?: InputMaybe<AuthChallengeListRelationFilter>;
  callRecords?: InputMaybe<CallRecordListRelationFilter>;
  country?: InputMaybe<StringNullableFilter>;
  createdAt?: InputMaybe<DateTimeFilter>;
  Credential?: InputMaybe<CredentialListRelationFilter>;
  cuid?: InputMaybe<StringFilter>;
  dashboardPreferences?: InputMaybe<JsonNullableFilter>;
  deviceId?: InputMaybe<StringNullableFilter>;
  devices?: InputMaybe<DeviceListRelationFilter>;
  email?: InputMaybe<StringNullableFilter>;
  firstName?: InputMaybe<StringNullableFilter>;
  id?: InputMaybe<StringFilter>;
  internalApiCalls?: InputMaybe<InternalApiCallListRelationFilter>;
  lastName?: InputMaybe<StringNullableFilter>;
  lastSeenAt?: InputMaybe<DateTimeNullableFilter>;
  madeCalls?: InputMaybe<CallRecordListRelationFilter>;
  memberships?: InputMaybe<MembershipListRelationFilter>;
  name?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<UserWhereInput>>;
  Notification?: InputMaybe<NotificationListRelationFilter>;
  openpathExternalUserId?: InputMaybe<StringNullableFilter>;
  OR?: InputMaybe<Array<UserWhereInput>>;
  password?: InputMaybe<StringNullableFilter>;
  payments?: InputMaybe<PaymentListRelationFilter>;
  phoneNumber?: InputMaybe<StringNullableFilter>;
  receivedCalls?: InputMaybe<CallRecordListRelationFilter>;
  SecondaryUsersOnAccessGrants?: InputMaybe<SecondaryUsersOnAccessGrantsListRelationFilter>;
  UserAccessGrantRequirement?: InputMaybe<UserAccessGrantRequirementListRelationFilter>;
  UserLocationData?: InputMaybe<UserLocationDataListRelationFilter>;
  userPushNotificationTokens?: InputMaybe<UserPushNotificationTokenListRelationFilter>;
  userRecords?: InputMaybe<UserRecordListRelationFilter>;
  UserTenantData?: InputMaybe<UserTenantDataListRelationFilter>;
};

export type UserWhereUniqueInput = {
  cuid?: InputMaybe<Scalars['String']>;
  email_phoneNumber?: InputMaybe<UserEmailPhoneNumberCompoundUniqueInput>;
  id?: InputMaybe<Scalars['String']>;
};

export type VendorServer = {
  accessID?: Maybe<Scalars['String']>;
  additionalConfig?: Maybe<Scalars['JSON']>;
  assaCardType?: Maybe<AssaCardType>;
  certificateAuthority?: Maybe<Scalars['String']>;
  certificateAuthorityExpiration?: Maybe<Scalars['String']>;
  host: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  locationId?: Maybe<Scalars['String']>;
  lockServiceCode?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  port: Scalars['Int'];
  shouldAllJoin: Scalars['Boolean'];
  trailerBlock?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type VendorServerAvgAggregate = {
  port?: Maybe<Scalars['Float']>;
};

export type VendorServerAvgOrderByAggregateInput = {
  port?: InputMaybe<SortOrder>;
};

export type VendorServerCountAggregate = {
  _all: Scalars['Int'];
  accessID: Scalars['Int'];
  additionalConfig: Scalars['Int'];
  assaCardType: Scalars['Int'];
  certificateAuthority: Scalars['Int'];
  certificateAuthorityExpiration: Scalars['Int'];
  host: Scalars['Int'];
  id: Scalars['Int'];
  isActive: Scalars['Int'];
  locationId: Scalars['Int'];
  lockServiceCode: Scalars['Int'];
  password: Scalars['Int'];
  port: Scalars['Int'];
  shouldAllJoin: Scalars['Int'];
  trailerBlock: Scalars['Int'];
  username: Scalars['Int'];
  uuid: Scalars['Int'];
  vendor: Scalars['Int'];
};

export type VendorServerCountOrderByAggregateInput = {
  accessID?: InputMaybe<SortOrder>;
  additionalConfig?: InputMaybe<SortOrder>;
  assaCardType?: InputMaybe<SortOrder>;
  certificateAuthority?: InputMaybe<SortOrder>;
  certificateAuthorityExpiration?: InputMaybe<SortOrder>;
  host?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  lockServiceCode?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  port?: InputMaybe<SortOrder>;
  shouldAllJoin?: InputMaybe<SortOrder>;
  trailerBlock?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
};

export type VendorServerCreateInput = {
  accessID?: InputMaybe<Scalars['String']>;
  additionalConfig?: InputMaybe<Scalars['JSON']>;
  assaCardType?: InputMaybe<AssaCardType>;
  certificateAuthority?: InputMaybe<Scalars['String']>;
  certificateAuthorityExpiration?: InputMaybe<Scalars['String']>;
  host: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  Location?: InputMaybe<LocationCreateNestedOneWithoutVendorServersInput>;
  lockServiceCode?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  port: Scalars['Int'];
  shouldAllJoin?: InputMaybe<Scalars['Boolean']>;
  trailerBlock?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type VendorServerCreateManyInput = {
  accessID?: InputMaybe<Scalars['String']>;
  additionalConfig?: InputMaybe<Scalars['JSON']>;
  assaCardType?: InputMaybe<AssaCardType>;
  certificateAuthority?: InputMaybe<Scalars['String']>;
  certificateAuthorityExpiration?: InputMaybe<Scalars['String']>;
  host: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  locationId?: InputMaybe<Scalars['String']>;
  lockServiceCode?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  port: Scalars['Int'];
  shouldAllJoin?: InputMaybe<Scalars['Boolean']>;
  trailerBlock?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type VendorServerCreateManyLocationInput = {
  accessID?: InputMaybe<Scalars['String']>;
  additionalConfig?: InputMaybe<Scalars['JSON']>;
  assaCardType?: InputMaybe<AssaCardType>;
  certificateAuthority?: InputMaybe<Scalars['String']>;
  certificateAuthorityExpiration?: InputMaybe<Scalars['String']>;
  host: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lockServiceCode?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  port: Scalars['Int'];
  shouldAllJoin?: InputMaybe<Scalars['Boolean']>;
  trailerBlock?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type VendorServerCreateManyLocationInputEnvelope = {
  data: Array<VendorServerCreateManyLocationInput>;
  skipDuplicates?: InputMaybe<Scalars['Boolean']>;
};

export type VendorServerCreateNestedManyWithoutLocationInput = {
  connect?: InputMaybe<Array<VendorServerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VendorServerCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<VendorServerCreateWithoutLocationInput>>;
  createMany?: InputMaybe<VendorServerCreateManyLocationInputEnvelope>;
};

export type VendorServerCreateOrConnectWithoutLocationInput = {
  create: VendorServerCreateWithoutLocationInput;
  where: VendorServerWhereUniqueInput;
};

export type VendorServerCreateWithoutLocationInput = {
  accessID?: InputMaybe<Scalars['String']>;
  additionalConfig?: InputMaybe<Scalars['JSON']>;
  assaCardType?: InputMaybe<AssaCardType>;
  certificateAuthority?: InputMaybe<Scalars['String']>;
  certificateAuthorityExpiration?: InputMaybe<Scalars['String']>;
  host: Scalars['String'];
  id?: InputMaybe<Scalars['String']>;
  isActive?: InputMaybe<Scalars['Boolean']>;
  lockServiceCode?: InputMaybe<Scalars['String']>;
  password?: InputMaybe<Scalars['String']>;
  port: Scalars['Int'];
  shouldAllJoin?: InputMaybe<Scalars['Boolean']>;
  trailerBlock?: InputMaybe<Scalars['String']>;
  username?: InputMaybe<Scalars['String']>;
  uuid?: InputMaybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type VendorServerGroupBy = {
  _avg?: Maybe<VendorServerAvgAggregate>;
  _count?: Maybe<VendorServerCountAggregate>;
  _max?: Maybe<VendorServerMaxAggregate>;
  _min?: Maybe<VendorServerMinAggregate>;
  _sum?: Maybe<VendorServerSumAggregate>;
  accessID?: Maybe<Scalars['String']>;
  additionalConfig?: Maybe<Scalars['JSON']>;
  assaCardType?: Maybe<AssaCardType>;
  certificateAuthority?: Maybe<Scalars['String']>;
  certificateAuthorityExpiration?: Maybe<Scalars['String']>;
  host: Scalars['String'];
  id: Scalars['String'];
  isActive: Scalars['Boolean'];
  locationId?: Maybe<Scalars['String']>;
  lockServiceCode?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  port: Scalars['Int'];
  shouldAllJoin: Scalars['Boolean'];
  trailerBlock?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  vendor: ResourceVendor;
};

export type VendorServerListRelationFilter = {
  every?: InputMaybe<VendorServerWhereInput>;
  none?: InputMaybe<VendorServerWhereInput>;
  some?: InputMaybe<VendorServerWhereInput>;
};

export type VendorServerMaxAggregate = {
  accessID?: Maybe<Scalars['String']>;
  assaCardType?: Maybe<AssaCardType>;
  certificateAuthority?: Maybe<Scalars['String']>;
  certificateAuthorityExpiration?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  lockServiceCode?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['Int']>;
  shouldAllJoin?: Maybe<Scalars['Boolean']>;
  trailerBlock?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  vendor?: Maybe<ResourceVendor>;
};

export type VendorServerMaxOrderByAggregateInput = {
  accessID?: InputMaybe<SortOrder>;
  assaCardType?: InputMaybe<SortOrder>;
  certificateAuthority?: InputMaybe<SortOrder>;
  certificateAuthorityExpiration?: InputMaybe<SortOrder>;
  host?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  lockServiceCode?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  port?: InputMaybe<SortOrder>;
  shouldAllJoin?: InputMaybe<SortOrder>;
  trailerBlock?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
};

export type VendorServerMinAggregate = {
  accessID?: Maybe<Scalars['String']>;
  assaCardType?: Maybe<AssaCardType>;
  certificateAuthority?: Maybe<Scalars['String']>;
  certificateAuthorityExpiration?: Maybe<Scalars['String']>;
  host?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  isActive?: Maybe<Scalars['Boolean']>;
  locationId?: Maybe<Scalars['String']>;
  lockServiceCode?: Maybe<Scalars['String']>;
  password?: Maybe<Scalars['String']>;
  port?: Maybe<Scalars['Int']>;
  shouldAllJoin?: Maybe<Scalars['Boolean']>;
  trailerBlock?: Maybe<Scalars['String']>;
  username?: Maybe<Scalars['String']>;
  uuid?: Maybe<Scalars['String']>;
  vendor?: Maybe<ResourceVendor>;
};

export type VendorServerMinOrderByAggregateInput = {
  accessID?: InputMaybe<SortOrder>;
  assaCardType?: InputMaybe<SortOrder>;
  certificateAuthority?: InputMaybe<SortOrder>;
  certificateAuthorityExpiration?: InputMaybe<SortOrder>;
  host?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrder>;
  lockServiceCode?: InputMaybe<SortOrder>;
  password?: InputMaybe<SortOrder>;
  port?: InputMaybe<SortOrder>;
  shouldAllJoin?: InputMaybe<SortOrder>;
  trailerBlock?: InputMaybe<SortOrder>;
  username?: InputMaybe<SortOrder>;
  uuid?: InputMaybe<SortOrder>;
  vendor?: InputMaybe<SortOrder>;
};

export type VendorServerOrderByRelationAggregateInput = {
  _count?: InputMaybe<SortOrder>;
};

export type VendorServerOrderByWithAggregationInput = {
  _avg?: InputMaybe<VendorServerAvgOrderByAggregateInput>;
  _count?: InputMaybe<VendorServerCountOrderByAggregateInput>;
  _max?: InputMaybe<VendorServerMaxOrderByAggregateInput>;
  _min?: InputMaybe<VendorServerMinOrderByAggregateInput>;
  _sum?: InputMaybe<VendorServerSumOrderByAggregateInput>;
  accessID?: InputMaybe<SortOrderInput>;
  additionalConfig?: InputMaybe<SortOrderInput>;
  assaCardType?: InputMaybe<SortOrderInput>;
  certificateAuthority?: InputMaybe<SortOrderInput>;
  certificateAuthorityExpiration?: InputMaybe<SortOrderInput>;
  host?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  locationId?: InputMaybe<SortOrderInput>;
  lockServiceCode?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrderInput>;
  port?: InputMaybe<SortOrder>;
  shouldAllJoin?: InputMaybe<SortOrder>;
  trailerBlock?: InputMaybe<SortOrderInput>;
  username?: InputMaybe<SortOrderInput>;
  uuid?: InputMaybe<SortOrderInput>;
  vendor?: InputMaybe<SortOrder>;
};

export type VendorServerOrderByWithRelationInput = {
  accessID?: InputMaybe<SortOrderInput>;
  additionalConfig?: InputMaybe<SortOrderInput>;
  assaCardType?: InputMaybe<SortOrderInput>;
  certificateAuthority?: InputMaybe<SortOrderInput>;
  certificateAuthorityExpiration?: InputMaybe<SortOrderInput>;
  host?: InputMaybe<SortOrder>;
  id?: InputMaybe<SortOrder>;
  isActive?: InputMaybe<SortOrder>;
  Location?: InputMaybe<LocationOrderByWithRelationInput>;
  locationId?: InputMaybe<SortOrderInput>;
  lockServiceCode?: InputMaybe<SortOrderInput>;
  password?: InputMaybe<SortOrderInput>;
  port?: InputMaybe<SortOrder>;
  shouldAllJoin?: InputMaybe<SortOrder>;
  trailerBlock?: InputMaybe<SortOrderInput>;
  username?: InputMaybe<SortOrderInput>;
  uuid?: InputMaybe<SortOrderInput>;
  vendor?: InputMaybe<SortOrder>;
};

export enum VendorServerScalarFieldEnum {
  AccessId = 'accessID',
  AdditionalConfig = 'additionalConfig',
  AssaCardType = 'assaCardType',
  CertificateAuthority = 'certificateAuthority',
  CertificateAuthorityExpiration = 'certificateAuthorityExpiration',
  Host = 'host',
  Id = 'id',
  IsActive = 'isActive',
  LocationId = 'locationId',
  LockServiceCode = 'lockServiceCode',
  Password = 'password',
  Port = 'port',
  ShouldAllJoin = 'shouldAllJoin',
  TrailerBlock = 'trailerBlock',
  Username = 'username',
  Uuid = 'uuid',
  Vendor = 'vendor'
}

export type VendorServerScalarWhereInput = {
  accessID?: InputMaybe<StringNullableFilter>;
  additionalConfig?: InputMaybe<JsonNullableFilter>;
  AND?: InputMaybe<Array<VendorServerScalarWhereInput>>;
  assaCardType?: InputMaybe<EnumAssaCardTypeNullableFilter>;
  certificateAuthority?: InputMaybe<StringNullableFilter>;
  certificateAuthorityExpiration?: InputMaybe<StringNullableFilter>;
  host?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  lockServiceCode?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<VendorServerScalarWhereInput>>;
  OR?: InputMaybe<Array<VendorServerScalarWhereInput>>;
  password?: InputMaybe<StringNullableFilter>;
  port?: InputMaybe<IntFilter>;
  shouldAllJoin?: InputMaybe<BoolFilter>;
  trailerBlock?: InputMaybe<StringNullableFilter>;
  username?: InputMaybe<StringNullableFilter>;
  uuid?: InputMaybe<StringNullableFilter>;
  vendor?: InputMaybe<EnumResourceVendorFilter>;
};

export type VendorServerScalarWhereWithAggregatesInput = {
  accessID?: InputMaybe<StringNullableWithAggregatesFilter>;
  additionalConfig?: InputMaybe<JsonNullableWithAggregatesFilter>;
  AND?: InputMaybe<Array<VendorServerScalarWhereWithAggregatesInput>>;
  assaCardType?: InputMaybe<EnumAssaCardTypeNullableWithAggregatesFilter>;
  certificateAuthority?: InputMaybe<StringNullableWithAggregatesFilter>;
  certificateAuthorityExpiration?: InputMaybe<StringNullableWithAggregatesFilter>;
  host?: InputMaybe<StringWithAggregatesFilter>;
  id?: InputMaybe<StringWithAggregatesFilter>;
  isActive?: InputMaybe<BoolWithAggregatesFilter>;
  locationId?: InputMaybe<StringNullableWithAggregatesFilter>;
  lockServiceCode?: InputMaybe<StringNullableWithAggregatesFilter>;
  NOT?: InputMaybe<Array<VendorServerScalarWhereWithAggregatesInput>>;
  OR?: InputMaybe<Array<VendorServerScalarWhereWithAggregatesInput>>;
  password?: InputMaybe<StringNullableWithAggregatesFilter>;
  port?: InputMaybe<IntWithAggregatesFilter>;
  shouldAllJoin?: InputMaybe<BoolWithAggregatesFilter>;
  trailerBlock?: InputMaybe<StringNullableWithAggregatesFilter>;
  username?: InputMaybe<StringNullableWithAggregatesFilter>;
  uuid?: InputMaybe<StringNullableWithAggregatesFilter>;
  vendor?: InputMaybe<EnumResourceVendorWithAggregatesFilter>;
};

export type VendorServerSumAggregate = {
  port?: Maybe<Scalars['Int']>;
};

export type VendorServerSumOrderByAggregateInput = {
  port?: InputMaybe<SortOrder>;
};

export type VendorServerUpdateInput = {
  accessID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  additionalConfig?: InputMaybe<Scalars['JSON']>;
  assaCardType?: InputMaybe<NullableEnumAssaCardTypeFieldUpdateOperationsInput>;
  certificateAuthority?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificateAuthorityExpiration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  host?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  Location?: InputMaybe<LocationUpdateOneWithoutVendorServersNestedInput>;
  lockServiceCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  shouldAllJoin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trailerBlock?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
};

export type VendorServerUpdateManyMutationInput = {
  accessID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  additionalConfig?: InputMaybe<Scalars['JSON']>;
  assaCardType?: InputMaybe<NullableEnumAssaCardTypeFieldUpdateOperationsInput>;
  certificateAuthority?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificateAuthorityExpiration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  host?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lockServiceCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  shouldAllJoin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trailerBlock?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
};

export type VendorServerUpdateManyWithoutLocationNestedInput = {
  connect?: InputMaybe<Array<VendorServerWhereUniqueInput>>;
  connectOrCreate?: InputMaybe<Array<VendorServerCreateOrConnectWithoutLocationInput>>;
  create?: InputMaybe<Array<VendorServerCreateWithoutLocationInput>>;
  createMany?: InputMaybe<VendorServerCreateManyLocationInputEnvelope>;
  delete?: InputMaybe<Array<VendorServerWhereUniqueInput>>;
  deleteMany?: InputMaybe<Array<VendorServerScalarWhereInput>>;
  disconnect?: InputMaybe<Array<VendorServerWhereUniqueInput>>;
  set?: InputMaybe<Array<VendorServerWhereUniqueInput>>;
  update?: InputMaybe<Array<VendorServerUpdateWithWhereUniqueWithoutLocationInput>>;
  updateMany?: InputMaybe<Array<VendorServerUpdateManyWithWhereWithoutLocationInput>>;
  upsert?: InputMaybe<Array<VendorServerUpsertWithWhereUniqueWithoutLocationInput>>;
};

export type VendorServerUpdateManyWithWhereWithoutLocationInput = {
  data: VendorServerUpdateManyMutationInput;
  where: VendorServerScalarWhereInput;
};

export type VendorServerUpdateWithoutLocationInput = {
  accessID?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  additionalConfig?: InputMaybe<Scalars['JSON']>;
  assaCardType?: InputMaybe<NullableEnumAssaCardTypeFieldUpdateOperationsInput>;
  certificateAuthority?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  certificateAuthorityExpiration?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  host?: InputMaybe<StringFieldUpdateOperationsInput>;
  id?: InputMaybe<StringFieldUpdateOperationsInput>;
  isActive?: InputMaybe<BoolFieldUpdateOperationsInput>;
  lockServiceCode?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  password?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  port?: InputMaybe<IntFieldUpdateOperationsInput>;
  shouldAllJoin?: InputMaybe<BoolFieldUpdateOperationsInput>;
  trailerBlock?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  username?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  uuid?: InputMaybe<NullableStringFieldUpdateOperationsInput>;
  vendor?: InputMaybe<EnumResourceVendorFieldUpdateOperationsInput>;
};

export type VendorServerUpdateWithWhereUniqueWithoutLocationInput = {
  data: VendorServerUpdateWithoutLocationInput;
  where: VendorServerWhereUniqueInput;
};

export type VendorServerUpsertWithWhereUniqueWithoutLocationInput = {
  create: VendorServerCreateWithoutLocationInput;
  update: VendorServerUpdateWithoutLocationInput;
  where: VendorServerWhereUniqueInput;
};

export type VendorServerWhereInput = {
  accessID?: InputMaybe<StringNullableFilter>;
  additionalConfig?: InputMaybe<JsonNullableFilter>;
  AND?: InputMaybe<Array<VendorServerWhereInput>>;
  assaCardType?: InputMaybe<EnumAssaCardTypeNullableFilter>;
  certificateAuthority?: InputMaybe<StringNullableFilter>;
  certificateAuthorityExpiration?: InputMaybe<StringNullableFilter>;
  host?: InputMaybe<StringFilter>;
  id?: InputMaybe<StringFilter>;
  isActive?: InputMaybe<BoolFilter>;
  Location?: InputMaybe<LocationRelationFilter>;
  locationId?: InputMaybe<StringNullableFilter>;
  lockServiceCode?: InputMaybe<StringNullableFilter>;
  NOT?: InputMaybe<Array<VendorServerWhereInput>>;
  OR?: InputMaybe<Array<VendorServerWhereInput>>;
  password?: InputMaybe<StringNullableFilter>;
  port?: InputMaybe<IntFilter>;
  shouldAllJoin?: InputMaybe<BoolFilter>;
  trailerBlock?: InputMaybe<StringNullableFilter>;
  username?: InputMaybe<StringNullableFilter>;
  uuid?: InputMaybe<StringNullableFilter>;
  vendor?: InputMaybe<EnumResourceVendorFilter>;
};

export type VendorServerWhereUniqueInput = {
  id?: InputMaybe<Scalars['String']>;
};

export type VerifyRequirementsResponse = {
  incompleteRequirements?: Maybe<Array<Requirement>>;
  status: RequirementStatus;
};

export type VirtualAccessGrant = AbstractAccessGrant & {
  accessToken?: Maybe<Scalars['String']>;
  address?: Maybe<Scalars['String']>;
  authorizedAmount?: Maybe<Scalars['Float']>;
  confirmationCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['DateTime'];
  credentials?: Maybe<Array<Credential>>;
  endDate?: Maybe<Scalars['String']>;
  endsAt: Scalars['DateTime'];
  endTime?: Maybe<Scalars['String']>;
  floorPlan?: Maybe<Scalars['String']>;
  gracePeriods?: Maybe<Scalars['String']>;
  id: Scalars['String'];
  idVerification: IdVerification;
  infos?: Maybe<Array<InfoItem>>;
  isBetweenCheckInToCheckOut?: Maybe<Scalars['Boolean']>;
  isLockEnabled?: Maybe<Scalars['Boolean']>;
  location: Location;
  locationId: Scalars['String'];
  maxKeys?: Maybe<Scalars['Float']>;
  metadata: HotelMetadata;
  numKeysDispensed?: Maybe<Scalars['Float']>;
  requirements?: Maybe<Array<Requirement>>;
  resources?: Maybe<Array<Resource>>;
  retryCheckin?: Maybe<RetryCheckinStatus>;
  retryCheckinStartsAt?: Maybe<Scalars['DateTime']>;
  roomNumber?: Maybe<Scalars['String']>;
  shouldShowResourceCode?: Maybe<Scalars['Boolean']>;
  startDate?: Maybe<Scalars['String']>;
  startsAt: Scalars['DateTime'];
  startTime?: Maybe<Scalars['String']>;
  state?: Maybe<AccessGrantState>;
  status: AccessGrantStatus;
  tenant?: Maybe<Tenant>;
  tenantId: Scalars['String'];
  type: AccessGrantType;
  updatedAt: Scalars['DateTime'];
  user?: Maybe<User>;
  userId: Scalars['String'];
};


export type VirtualAccessGrantCredentialsArgs = {
  cursor?: InputMaybe<CredentialWhereUniqueInput>;
  distinct?: InputMaybe<Array<CredentialScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
};


export type VirtualAccessGrantRequirementsArgs = {
  cursor?: InputMaybe<RequirementWhereUniqueInput>;
  distinct?: InputMaybe<Array<RequirementScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
};


export type VirtualAccessGrantResourcesArgs = {
  cursor?: InputMaybe<ResourceWhereUniqueInput>;
  distinct?: InputMaybe<Array<ResourceScalarFieldEnum>>;
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput>>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
};

export type VirtualMembership = {
  id: Scalars['String'];
  location?: Maybe<LocationData>;
  locationGroup?: Maybe<LocationGroupDataWithLocationIds>;
  role: Role;
  tenant: TenantLocation;
};

export type CanAssociateLocationGroupQueryVariables = Exact<{
  locationGroupId: Scalars['String'];
  parentLocationGroupId: Scalars['String'];
}>;


export type CanAssociateLocationGroupQuery = { canAssociateLocationGroup: boolean };

export type CreateLocationGroupMutationVariables = Exact<{
  data: CustomLocationGroupCreateInput;
}>;


export type CreateLocationGroupMutation = { createLocationGroup: { id: string, name: string } };

export type DeleteLocatonGroupMutationVariables = Exact<{
  locationGroupId: Scalars['String'];
}>;


export type DeleteLocatonGroupMutation = { deleteLocationGroup: { success: boolean } };

export type GetLocationGroupQueryVariables = Exact<{
  locationGroupId: Scalars['String'];
}>;


export type GetLocationGroupQuery = { getLocationGroup: { id: string, name: string, groups?: Array<{ id: string, name: string }> | null, locations?: Array<{ id: string, name: string }> | null } };

export type UpdateLocationGroupMutationVariables = Exact<{
  data: CustomLocationGroupUpdateInput;
  where: CustomLocationGroupWhereUniqueInput;
}>;


export type UpdateLocationGroupMutation = { updateLocationGroup: { id: string, name: string } };

export type AccessMembershipMutationVariables = Exact<{
  membershipId: Scalars['String'];
}>;


export type AccessMembershipMutation = { accessMembership: { lastSeenAt?: any | null, tenant: { id: string }, location?: { id: string } | null } };

export type GetAccessGrantCountQueryVariables = Exact<{
  where: AccessGrantWhereInput;
}>;


export type GetAccessGrantCountQuery = { aggregateDashboardAccessGrants?: { _count?: { _all: number } | null } | null };

export type GetAmenityCountQueryVariables = Exact<{
  where: AmenityWhereInput;
}>;


export type GetAmenityCountQuery = { aggregateAmenity: { _count?: { _all: number } | null } };

export type GetCallRecordCountQueryVariables = Exact<{
  where: CallRecordWhereInput;
}>;


export type GetCallRecordCountQuery = { aggregateCallRecord: { _count?: { _all: number } | null } };

export type GetCredentialCountQueryVariables = Exact<{
  where: CredentialWhereInput;
}>;


export type GetCredentialCountQuery = { aggregateCredential: { _count?: { _all: number } | null } };

export type GetKioskCountQueryVariables = Exact<{
  where: KioskWhereInput;
}>;


export type GetKioskCountQuery = { aggregateKiosk: { _count?: { _all: number } | null } };

export type AggregateDashboardLocationQueryVariables = Exact<{
  where?: InputMaybe<CustomLocationWhereInput>;
}>;


export type AggregateDashboardLocationQuery = { aggregateDashboardLocation?: { _count?: { _all: number } | null } | null };

export type GetLocationCountQueryVariables = Exact<{
  where?: InputMaybe<LocationWhereInput>;
}>;


export type GetLocationCountQuery = { aggregateLocation: { _count?: { _all: number } | null } };

export type GetPaymentCountQueryVariables = Exact<{
  where: PaymentWhereInput;
}>;


export type GetPaymentCountQuery = { aggregatePayment: { _count?: { _all: number } | null } };

export type GetPaymentTransactionQueryVariables = Exact<{
  where: PaymentTransactionWhereInput;
}>;


export type GetPaymentTransactionQuery = { aggregatePaymentTransaction: { _count?: { _all: number } | null } };

export type GetResourceCountQueryVariables = Exact<{
  where: ResourceWhereInput;
}>;


export type GetResourceCountQuery = { aggregateResource: { _count?: { _all: number } | null } };

export type GetResourceGroupCountQueryVariables = Exact<{
  where?: InputMaybe<ResourceGroupWhereInput>;
}>;


export type GetResourceGroupCountQuery = { aggregateResourceGroup: { _count?: { _all: number } | null } };

export type GetServiceCountQueryVariables = Exact<{
  where: ServiceWhereInput;
}>;


export type GetServiceCountQuery = { aggregateService: { _count?: { _all: number } | null } };

export type GetUnitTypeCountQueryVariables = Exact<{
  where: UnitTypeWhereInput;
}>;


export type GetUnitTypeCountQuery = { aggregateUnitType: { _count?: { _all: number } | null } };

export type GetUserCountQueryVariables = Exact<{
  where: UserWhereInput;
}>;


export type GetUserCountQuery = { aggregateUser: { _count?: { _all: number } | null } };

export type GetUserRecordCountQueryVariables = Exact<{
  where: UserRecordWhereInput;
}>;


export type GetUserRecordCountQuery = { aggregateUserRecord: { _count?: { _all: number } | null } };

export type ArrivalsByDayQueryVariables = Exact<{
  days?: InputMaybe<Scalars['Float']>;
  tenantId: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type ArrivalsByDayQuery = { generateArrivalsByDayReport: { success: boolean } };

export type BypassVerificationMutationVariables = Exact<{
  kioskId: Scalars['String'];
}>;


export type BypassVerificationMutation = { bypassVerification: { success: boolean } };

export type CallRecordsQueryVariables = Exact<{
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum> | CallRecordScalarFieldEnum>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput> | CallRecordOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
}>;


export type CallRecordsQuery = { callRecords: Array<{ createdAt: any, duration?: number | null, id: string, room?: string | null, status: CallStatus, type: CallType, accessGrant?: { id: string, startsAt: any, endsAt: any, metadata: any, user: { name?: string | null, email?: string | null, phoneNumber?: string | null }, location: { name: string } } | null, kiosk?: { id: string, name: string } | null, location?: { id: string, name: string, address: string } | null, tenant?: { name: string } | null, caller?: { id: string, email?: string | null, name?: string | null, phoneNumber?: string | null } | null, agent?: { id: string, email?: string | null, name?: string | null, phoneNumber?: string | null } | null }> };

export type CancelAccessGrantMutationVariables = Exact<{
  where: AccessGrantWhereUniqueInput;
}>;


export type CancelAccessGrantMutation = { cancelAccessGrant: { confirmationCode?: string | null, id: string } };

export type CloudbedsConnectAppMutationVariables = Exact<{
  token: Scalars['String'];
  locationId: Scalars['String'];
}>;


export type CloudbedsConnectAppMutation = { cloudbedsConnectApp: { success: boolean } };

export type CreateAccessGrantMutationVariables = Exact<{
  data: AccessGrantCreateInput;
  originalAgreementFileId?: InputMaybe<Scalars['String']>;
}>;


export type CreateAccessGrantMutation = { createAccessGrant: { confirmationCode?: string | null, id: string, requirements: Array<{ type: RequirementType, id: string }> } };

export type CreateAmenityAndUploadImageFileMutationVariables = Exact<{
  data: CustomAmenityCreateInput;
}>;


export type CreateAmenityAndUploadImageFileMutation = { createAmenityAndUploadImageFile: { id: string, imageUrl: string, title: string, description?: string | null } };

export type CreateEarlyCheckInPackageMutationVariables = Exact<{
  data: EarlyCheckInPackageInput;
}>;


export type CreateEarlyCheckInPackageMutation = { createEarlyCheckInPackage: { endTime?: string | null, externalId?: string | null, freeUpgrade?: boolean | null, locationId: string, loyaltyCodes?: Array<string> | null, price?: number | null, serviceId: string, startTime?: string | null } };

export type CreateInfoItemAndUploadImageFileMutationVariables = Exact<{
  data: CustomInfoItemCreateInput;
}>;


export type CreateInfoItemAndUploadImageFileMutation = { createInfoItemAndUploadImageFile: { id: string, title: string } };

export type CreateKioskMutationVariables = Exact<{
  data: KioskCreateInput;
}>;


export type CreateKioskMutation = { createOneKiosk: { id: string, locationId: string, name: string } };

export type CreateResourceAndUploadImageFileMutationVariables = Exact<{
  data: CustomResourceCreateInput;
}>;


export type CreateResourceAndUploadImageFileMutation = { createResourceAndUploadImageFile: { id: string, locationId: string, name: string } };

export type CreateResourceGroupMutationVariables = Exact<{
  data: ResourceGroupCreateInput;
}>;


export type CreateResourceGroupMutation = { createResourceGroup: { id: string, isDefault: boolean, name: string, resources: Array<{ id: string, name: string }> } };

export type CreateServiceAndUploadImageFileMutationVariables = Exact<{
  data: CustomServiceCreateInput;
}>;


export type CreateServiceAndUploadImageFileMutation = { createServiceAndUploadImageFile: { id: string, type: ServiceType, imageUrl: string, title: string, description: string, price: number, locationId?: string | null, askForTime: boolean, displayCommentBox: boolean, status?: ServiceStatus | null, metadata?: any | null, largeDescription?: string | null, location?: { id: string, name: string } | null } };

export type CreateUnitTypeAndUploadImageFileMutationVariables = Exact<{
  data: CustomUnitTypeCreateInput;
}>;


export type CreateUnitTypeAndUploadImageFileMutation = { createUnitTypeAndUploadImageFile: { id: string, imageUrl: string, locationId: string, numberOfGuests: number, type: string } };

export type CreateUserMutationVariables = Exact<{
  data: UserCreateInput;
}>;


export type CreateUserMutation = { createUser: { id: string, name?: string | null } };

export type CreateOneVendorServerMutationVariables = Exact<{
  data: VendorServerCreateInput;
}>;


export type CreateOneVendorServerMutation = { createOneVendorServer: { id: string, vendor: ResourceVendor } };

export type DeleteOneAmenityMutationVariables = Exact<{
  where: AmenityWhereUniqueInput;
}>;


export type DeleteOneAmenityMutation = { deleteOneAmenity?: { id: string, title: string } | null };

export type DeleteEarlyCheckInPackageMutationVariables = Exact<{
  serviceId: Scalars['String'];
}>;


export type DeleteEarlyCheckInPackageMutation = { deleteEarlyCheckInPackage: { success: boolean } };

export type DeleteOneInfoItemMutationVariables = Exact<{
  where: InfoItemWhereUniqueInput;
}>;


export type DeleteOneInfoItemMutation = { deleteOneInfoItem?: { id: string, title: string } | null };

export type DeleteOneKioskMutationVariables = Exact<{
  where: KioskWhereUniqueInput;
}>;


export type DeleteOneKioskMutation = { deleteOneKiosk?: { id: string, name: string } | null };

export type DeleteOneLocationMutationVariables = Exact<{
  where: LocationWhereUniqueInput;
}>;


export type DeleteOneLocationMutation = { deleteOneLocation?: { id: string, name: string } | null };

export type DeleteOnePaymentMutationVariables = Exact<{
  where: PaymentWhereUniqueInput;
}>;


export type DeleteOnePaymentMutation = { deleteOnePayment?: { id: string } | null };

export type DeleteOneResourceMutationVariables = Exact<{
  where: ResourceWhereUniqueInput;
}>;


export type DeleteOneResourceMutation = { deleteOneResource?: { id: string, name: string } | null };

export type DeleteResourceGroupMutationVariables = Exact<{
  id: Scalars['String'];
}>;


export type DeleteResourceGroupMutation = { deleteResourceGroup: { id: string, name: string } };

export type DeleteOneServiceMutationVariables = Exact<{
  where: ServiceWhereUniqueInput;
}>;


export type DeleteOneServiceMutation = { deleteOneService?: { id: string, title: string } | null };

export type DeleteOneUnitTypeMutationVariables = Exact<{
  where: UnitTypeWhereUniqueInput;
}>;


export type DeleteOneUnitTypeMutation = { deleteOneUnitType?: { id: string, type: string } | null };

export type DeleteUserMutationVariables = Exact<{
  where: UserWhereUniqueInput;
}>;


export type DeleteUserMutation = { deleteUser: { email?: string | null, id: string, name?: string | null } };

export type DeleteOneVendorServerMutationVariables = Exact<{
  where: VendorServerWhereUniqueInput;
}>;


export type DeleteOneVendorServerMutation = { deleteOneVendorServer?: { id: string, vendor: ResourceVendor } | null };

export type CloudbedsDisconnectAppMutationVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type CloudbedsDisconnectAppMutation = { cloudbedsDisconnectApp: { success: boolean } };

export type DownloadResourceTemplateCsvFileQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadResourceTemplateCsvFileQuery = { downloadResourceTemplateCSVFile?: { data: string } | null };

export type DownloadUnitTypeTemplateCsvFileQueryVariables = Exact<{ [key: string]: never; }>;


export type DownloadUnitTypeTemplateCsvFileQuery = { downloadUnitTypeTemplateCSVFile?: { data: string } | null };

export type EndVideoMutationVariables = Exact<{
  callRecordId: Scalars['String'];
  userId?: InputMaybe<Scalars['String']>;
}>;


export type EndVideoMutation = { endVideo: { success: boolean } };

export type ExchangeRefreshTokenMutationVariables = Exact<{
  token: Scalars['String'];
}>;


export type ExchangeRefreshTokenMutation = { exchangeRefreshToken: { accessToken?: string | null, authErrorCode?: string | null, expiresIn?: string | null, refreshToken?: string | null } };

export type FilterDashboardAccessGrantsQueryVariables = Exact<{
  tenantId: Scalars['String'];
  locationId?: InputMaybe<DagfStringFilter>;
  timeFilter?: InputMaybe<DashboardTimeFilter>;
  status?: InputMaybe<DagfAccessGrantStatusFilter>;
  state?: InputMaybe<DagfAccessGrantStateFilter>;
  retryCheckinStatus?: InputMaybe<DagfRetryCheckinStatusFilter>;
  requirementType?: InputMaybe<DagfRequirementTypeFilter>;
  requirementStatus?: InputMaybe<DagfRequirementStatusFilter>;
  userId?: InputMaybe<Scalars['String']>;
  textFilter?: InputMaybe<DashboardTextFilter>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<DashboardAccessGrantsOrderBy> | DashboardAccessGrantsOrderBy>;
}>;


export type FilterDashboardAccessGrantsQuery = { filterDashboardAccessGrants: { dataCount: number, totalCount: number, data: Array<{ id: string, confirmationCode?: string | null, state?: AccessGrantState | null, status: AccessGrantStatus, startsAt: any, startDate?: string | null, startTime?: string | null, endsAt: any, endDate?: string | null, endTime?: string | null, arrivalTime?: string | null, location: { id: string, name: string, timezone: string }, user: { id: string, name?: string | null, lastSeenAt?: any | null }, requirements: Array<{ id: string, status: RequirementStatus }>, secondaryUsers: Array<{ user: { id: string, name?: string | null } }>, resources: Array<{ id: string, name: string, type: ResourceType }> }> } };

export type AccessGrantTableFieldsFragment = { confirmationCode?: string | null, endsAt: any, endTime?: string | null, id: string, startsAt: any, arrivalTime?: string | null, startTime?: string | null, state?: AccessGrantState | null, status: AccessGrantStatus, tenantId: string, credentials: Array<{ id: string, userId: string }>, idVerificationResult?: { id: string, status: IdVerificationResultStatus } | null, location: { id: string, name: string, timezone: string }, requirements: Array<{ status: RequirementStatus, type: RequirementType }>, user: { id: string, lastSeenAt?: any | null, name?: string | null } };

export type AmenityTableFieldsFragment = { id: string, imageUrl: string, title: string, description?: string | null, locationId?: string | null, amenityGroupId?: string | null, group?: { id: string, title: string } | null, location?: { id: string, name: string } | null };

export type CredentialFieldsFragment = { id: string, type: CredentialType, userId: string, isActive: boolean, createdAt: any, expiresAt?: any | null, cancelledAt?: any | null, updatedAt?: any | null, user: { id: string, name?: string | null }, accessGrant: { id: string, userId: string } };

export type GracePeriodValuesFieldsFragment = { checkIn: { gracePeriodType: string, isActive: boolean, absoluteTime?: string | null, absoluteTimePeriod?: string | null, relativeTimeInMinutes?: number | null }, checkOut: { gracePeriodType: string, isActive: boolean, absoluteTime?: string | null, absoluteTimePeriod?: string | null, relativeTimeInMinutes?: number | null } };

export type InfoItemFieldsFragment = { id: string, title: string, description?: string | null, imageUrl?: string | null, moreInfoLink?: string | null, type: InfoType, locationId?: string | null, location?: { id: string, name: string } | null, infoType?: { id: string, title: string, shouldAppearInDashboard: boolean } | null };

export type KioskTableFieldsFragment = { hasDispenser: boolean, hasTerminal: boolean, id: string, dispenserLastSeenAt?: any | null, terminalLastSeenAt?: any | null, lastSeenAt?: any | null, name: string, serverUrl?: string | null, buildNumber?: string | null, metadata?: any | null, location: { id: string, name: string, timezone: string } };

export type LocationTableFieldsFragment = { address: string, createdAt: any, defaultEndTime: string, defaultStartTime: string, email?: string | null, emailFrom?: string | null, id: string, imageUrl?: string | null, name: string, phoneNumber: string, updatedAt: any, logoUrl?: string | null, timezone: string, defaultRequirements: Array<{ id: string, type: RequirementType, metadata?: any | null }> };

export type VirtualMembershipFieldsFragment = { id: string, role: Role, tenant: { id: string, name: string }, location?: { id: string, name: string } | null, locationGroup?: { id: string, name: string, locationIds?: Array<string> | null } | null };

export type ActiveMembershipFieldsFragment = { id: string, lastSeenAt?: any | null, tenantId: string, role: Role, permissions?: any | null, location?: { id: string, name: string } | null, tenant: { id: string, name: string }, locationGroup?: { id: string, name: string, locationIds?: Array<string> | null } | null };

export type ResourceTableFieldsFragment = { code?: string | null, controlType?: ResourceControlType | null, description?: string | null, id: string, imageUrl?: string | null, name: string, pmsId?: string | null, type: ResourceType, unitTypeId?: string | null, vendor: ResourceVendor, vendorId?: string | null, unitType?: { type: string } | null };

export type ServiceFieldsFragment = { id: string, type: ServiceType, imageUrl: string, title: string, description: string, price: number, locationId?: string | null, askForTime: boolean, displayCommentBox: boolean, status?: ServiceStatus | null, metadata?: any | null, largeDescription?: string | null, location?: { id: string, name: string } | null };

export type UnitTypeFieldsFragment = { id: string, imageUrl: string, locationId: string, numberOfGuests: number, type: string, location: { id: string, name: string } };

export type VendorServerFieldsFragment = { id: string, vendor: ResourceVendor, host: string, port: number, isActive: boolean, shouldAllJoin: boolean };

export type VendorServerDetailsFieldsFragment = { username?: string | null, password?: string | null, shouldAllJoin: boolean, lockServiceCode?: string | null, trailerBlock?: string | null, accessID?: string | null, uuid?: string | null, assaCardType?: AssaCardType | null, additionalConfig?: any | null, id: string, vendor: ResourceVendor, host: string, port: number, isActive: boolean };

export type AccessGrantQueryVariables = Exact<{
  where: AccessGrantWhereUniqueInput;
}>;


export type AccessGrantQuery = { accessGrant?: { code?: string | null, confirmationCode?: string | null, endsAt: any, endDate?: string | null, endTime?: string | null, id: string, locationId: string, metadata: any, retryCheckin?: RetryCheckinStatus | null, startsAt: any, startDate?: string | null, arrivalTime?: string | null, startTime?: string | null, status: AccessGrantStatus, type: AccessGrantType, credentials: Array<{ data: string, type: CredentialType }>, location: { address: string, id: string, name: string, phoneNumber: string, timezone: string }, overrides: Array<{ code?: string | null, endTime?: string | null, id: string, resourceId: string, startTime?: string | null }>, requirements: Array<{ type: RequirementType, status: RequirementStatus, metadata?: any | null, id: string, files: Array<{ file: { url: string, fileType: FileType } }> }>, resources: Array<{ controlType?: ResourceControlType | null, defaultEnd: string, defaultStart: string, id: string, locationId: string, name: string, passLevel?: number | null, pmsId?: string | null, type: ResourceType, vendor: ResourceVendor, vendorId?: string | null }>, secondaryUsers: Array<{ user: { id: string, name?: string | null } }>, user: { email?: string | null, id: string, lastSeenAt?: any | null, name?: string | null, phoneNumber?: string | null } } | null };

export type GetAccessGrantAuthenticationCredentialsQueryVariables = Exact<{
  accessGrantId: Scalars['String'];
}>;


export type GetAccessGrantAuthenticationCredentialsQuery = { getAccessGrantAuthenticationCredentials?: { deeplink: string, mobileWebUrl: string, qrCode: string } | null };

export type GetAccessGrantTableDataQueryVariables = Exact<{
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum> | AccessGrantScalarFieldEnum>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput> | AccessGrantOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
}>;


export type GetAccessGrantTableDataQuery = { findDashboardAccessGrants: Array<{ confirmationCode?: string | null, endsAt: any, endTime?: string | null, id: string, startsAt: any, arrivalTime?: string | null, startTime?: string | null, state?: AccessGrantState | null, status: AccessGrantStatus, tenantId: string, credentials: Array<{ id: string, userId: string }>, idVerificationResult?: { id: string, status: IdVerificationResultStatus } | null, location: { id: string, name: string, timezone: string }, requirements: Array<{ status: RequirementStatus, type: RequirementType }>, user: { id: string, lastSeenAt?: any | null, name?: string | null } }> };

export type GetAccessGrantsAndCountQueryVariables = Exact<{
  cursor?: InputMaybe<AccessGrantWhereUniqueInput>;
  distinct?: InputMaybe<Array<AccessGrantScalarFieldEnum> | AccessGrantScalarFieldEnum>;
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput> | AccessGrantOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
}>;


export type GetAccessGrantsAndCountQuery = { findDashboardAccessGrants: Array<{ id: string, confirmationCode?: string | null, startsAt: any, endsAt: any, location: { timezone: string }, resources: Array<{ id: string, name: string, type: ResourceType }>, user: { id: string, name?: string | null }, secondaryUsers: Array<{ user: { id: string, name?: string | null } }> }>, aggregateDashboardAccessGrants?: { _count?: { _all: number } | null } | null };

export type GetAccessSetupQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetAccessSetupQuery = { getAccessSetup: { defaultStartTime: string, defaultEndTime: string, enableEarlyCheckInByTimeRange: boolean, enableEarlyCheckInByLoyalty: boolean, packages?: Array<{ endTime?: string | null, externalId?: string | null, freeUpgrade?: boolean | null, locationId: string, loyaltyCodes?: Array<string> | null, price?: number | null, serviceId: string, startTime?: string | null }> | null } };

export type GetAmenityQueryVariables = Exact<{
  where: AmenityWhereUniqueInput;
}>;


export type GetAmenityQuery = { amenity?: { id: string, title: string, description?: string | null, imageUrl: string, amenityGroupId?: string | null, locationId?: string | null, location?: { id: string, name: string } | null, group?: { id: string, title: string } | null } | null };

export type GetAmenityTableDataQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<AmenityOrderByWithRelationInput> | AmenityOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityWhereInput>;
}>;


export type GetAmenityTableDataQuery = { amenities: Array<{ id: string, imageUrl: string, title: string, description?: string | null, locationId?: string | null, amenityGroupId?: string | null, group?: { id: string, title: string } | null, location?: { id: string, name: string } | null }> };

export type GetCallRecordsTableDataQueryVariables = Exact<{
  cursor?: InputMaybe<CallRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<CallRecordScalarFieldEnum> | CallRecordScalarFieldEnum>;
  orderBy?: InputMaybe<Array<CallRecordOrderByWithRelationInput> | CallRecordOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CallRecordWhereInput>;
}>;


export type GetCallRecordsTableDataQuery = { callRecords: Array<{ duration?: number | null, id: string, status: CallStatus, type: CallType, accessGrant?: { confirmationCode?: string | null } | null, agent?: { id: string, name?: string | null } | null, caller?: { id: string, name?: string | null } | null, kiosk?: { id: string, name: string } | null, location?: { id: string, name: string } | null, users: Array<{ id: string, name?: string | null }> }> };

export type GetCredentialTableDataQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<CredentialOrderByWithRelationInput> | CredentialOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CredentialWhereInput>;
}>;


export type GetCredentialTableDataQuery = { getCredentials: Array<{ id: string, type: CredentialType, userId: string, isActive: boolean, createdAt: any, expiresAt?: any | null, cancelledAt?: any | null, updatedAt?: any | null, user: { id: string, name?: string | null }, accessGrant: { id: string, userId: string } }> };

export type GetTenantDashboardCustomizeableComponentsQueryVariables = Exact<{
  entityId: Scalars['String'];
}>;


export type GetTenantDashboardCustomizeableComponentsQuery = { getTenantDashboardCustomizeableComponents: Array<{ id: string, name: string }> };

export type GetLocationDashboardCustomizeableComponentsQueryVariables = Exact<{
  entityId: Scalars['String'];
}>;


export type GetLocationDashboardCustomizeableComponentsQuery = { getLocationDashboardCustomizeableComponents: Array<{ id: string, name: string }> };

export type GetDashboardPreferencesQueryVariables = Exact<{
  userId: Scalars['String'];
  tenantId: Scalars['String'];
  locationId?: InputMaybe<Scalars['String']>;
}>;


export type GetDashboardPreferencesQuery = { getDashboardPreferences?: { preferredDateFormat?: string | null, preferredTimeFormat?: string | null, locationGroup?: boolean | null, quickActionBar?: { enabled?: boolean | null, actions?: { checkIn?: boolean | null, checkOut?: boolean | null, blockCheckIn?: boolean | null, getAutenticationCredentials?: boolean | null, remotePrintKeyCard?: boolean | null, repollReservation?: boolean | null } | null } | null, reportingServices?: { reportTitle: string, reportUrl: string } | null } | null };

export type GetGracePeriodsConfigQueryVariables = Exact<{
  gracePeriodsConfigLevel: Scalars['String'];
  accessGrantId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
}>;


export type GetGracePeriodsConfigQuery = { getGracePeriodsConfig: { rooms: { checkIn: { gracePeriodType: string, isActive: boolean, absoluteTime?: string | null, absoluteTimePeriod?: string | null, relativeTimeInMinutes?: number | null }, checkOut: { gracePeriodType: string, isActive: boolean, absoluteTime?: string | null, absoluteTimePeriod?: string | null, relativeTimeInMinutes?: number | null } }, commonAreas: { checkIn: { gracePeriodType: string, isActive: boolean, absoluteTime?: string | null, absoluteTimePeriod?: string | null, relativeTimeInMinutes?: number | null }, checkOut: { gracePeriodType: string, isActive: boolean, absoluteTime?: string | null, absoluteTimePeriod?: string | null, relativeTimeInMinutes?: number | null } }, earlyCheckInConfig: { allowEarlyCheckIn: boolean, checkInGracePeriod?: number | null } } };

export type GetInfoQueryVariables = Exact<{
  where: InfoItemWhereUniqueInput;
}>;


export type GetInfoQuery = { info?: { id: string, title: string, description?: string | null, imageUrl?: string | null, moreInfoLink?: string | null, type: InfoType, locationId?: string | null, location?: { id: string, name: string } | null, infoType?: { id: string, title: string, shouldAppearInDashboard: boolean } | null } | null };

export type GetInfoTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInfoTypesQuery = { infoTypes?: Array<{ id: string, title: string, shouldAppearInDashboard: boolean }> | null };

export type GetConciergeTreeViewQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type GetConciergeTreeViewQuery = { getConciergeTreeView?: Array<{ id: string, parent: string, text: string, droppable: boolean, data: { id: string, title: string, description?: string | null, type: InfoType, thumbnailImage?: string | null, imageUrl?: string | null, moreInfoLink?: string | null, contentType?: InfoContentType | null } }> | null };

export type UpdateConciergeItemOrderMutationVariables = Exact<{
  locationId: Scalars['String'];
  data: Array<UpdateConciergeItemOrderInput> | UpdateConciergeItemOrderInput;
}>;


export type UpdateConciergeItemOrderMutation = { updateConciergeItemOrder: Array<{ id: string, parent: string, order: number }> };

export type CreateConciergeItemMutationVariables = Exact<{
  data: CreateConciergeItemInput;
}>;


export type CreateConciergeItemMutation = { createConciergeItem: { title: string } };

export type UpdateConciergeItemMutationVariables = Exact<{
  data: UpdateConciergeItemInput;
  where: InfoItemWhereInput;
}>;


export type UpdateConciergeItemMutation = { updateConciergeItem: { title: string } };

export type DeleteConciergeItemMutationVariables = Exact<{
  where: InfoItemWhereInput;
}>;


export type DeleteConciergeItemMutation = { deleteConciergeItem: { id: string } };

export type FetchConciergeQueryVariables = Exact<{
  locationId: Scalars['String'];
}>;


export type FetchConciergeQuery = { getConcierge?: Array<{ id: string, title: string, type: InfoType, thumbnailImage?: string | null, children?: Array<{ id: string, title: string, type: InfoType, children?: Array<{ id: string, title: string, type: InfoType, thumbnailImage?: string | null }> | null }> | null }> | null };

export type GetInfoItemsTableDataQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<InfoItemOrderByWithRelationInput> | InfoItemOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<InfoItemWhereInput>;
}>;


export type GetInfoItemsTableDataQuery = { infos?: Array<{ id: string, title: string, description?: string | null, imageUrl?: string | null, moreInfoLink?: string | null, type: InfoType, locationId?: string | null, location?: { id: string, name: string } | null, infoType?: { id: string, title: string, shouldAppearInDashboard: boolean } | null }> | null };

export type GetInfoItemCountQueryVariables = Exact<{
  where: InfoItemWhereInput;
}>;


export type GetInfoItemCountQuery = { aggregateInfoItem: { _count?: { _all: number } | null } };

export type KioskQueryVariables = Exact<{
  where: KioskWhereUniqueInput;
}>;


export type KioskQuery = { kiosk?: { id: string, lastSeenAt?: any | null, locationId: string, name: string, hasTerminal: boolean, hasDispenser: boolean, powerSwitchId?: string | null, dispenserType?: DispenserType | null, maintenanceStartsAt?: any | null, maintenanceEndsAt?: any | null, rfidTagType?: RfidTagType | null, location: { id: string, name: string, timezone: string }, dispenserConfig: Array<{ id: string, dispenserType?: DispenserType | null, serial?: string | null, usage?: string | null, isActive?: boolean | null }> } | null };

export type GetKioskTableDataQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput> | KioskOrderByWithRelationInput>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
}>;


export type GetKioskTableDataQuery = { kiosks: Array<{ hasDispenser: boolean, hasTerminal: boolean, id: string, dispenserLastSeenAt?: any | null, terminalLastSeenAt?: any | null, lastSeenAt?: any | null, name: string, serverUrl?: string | null, buildNumber?: string | null, metadata?: any | null, location: { id: string, name: string, timezone: string } }> };

export type KiosksQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput> | KioskOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
}>;


export type KiosksQuery = { kiosks: Array<{ id: string, name: string }> };

export type GetKiosksAndCountQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput> | KioskOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
}>;


export type GetKiosksAndCountQuery = { kiosks: Array<{ id: string, name: string }>, aggregateKiosk: { count?: { all: number } | null } };

export type GetLanguagesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LanguageOrderByWithRelationInput> | LanguageOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LanguageWhereInput>;
}>;


export type GetLanguagesQuery = { getLanguages: Array<{ id: string, code: string, name: string, isRTL: boolean }> };

export type FileToEntitiesQueryVariables = Exact<{
  where: FileToEntityWhereInput;
}>;


export type FileToEntitiesQuery = { fileToEntities: Array<{ entityId: string, file: { url: string, status: FileStatus, fileType: FileType } }> };

export type GetLimitKeysConfigQueryVariables = Exact<{
  accessGrantId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  limitKeysConfigLevel: Scalars['String'];
}>;


export type GetLimitKeysConfigQuery = { getLimitKeysConfig: { maxKeys?: number | null, numKeysUsed?: number | null } };

export type LocationQueryVariables = Exact<{
  where: LocationWhereUniqueInput;
}>;


export type LocationQuery = { location?: { address: string, createdAt: any, defaultEndTime: string, defaultStartTime: string, email?: string | null, emailFrom?: string | null, id: string, imageUrl?: string | null, name: string, phoneNumber: string, updatedAt: any, logoUrl?: string | null, timezone: string, defaultRequirements: Array<{ id: string, type: RequirementType, metadata?: any | null }> } | null };

export type LocationsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput> | LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
}>;


export type LocationsQuery = { locations: Array<{ address: string, createdAt: any, defaultEndTime: string, defaultStartTime: string, email?: string | null, emailFrom?: string | null, id: string, imageUrl?: string | null, name: string, phoneNumber: string, updatedAt: any, logoUrl?: string | null, timezone: string, defaultRequirements: Array<{ id: string, type: RequirementType, metadata?: any | null }> }> };

export type GetLocationsAndCountQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput> | LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
}>;


export type GetLocationsAndCountQuery = { locations: Array<{ id: string, name: string }>, aggregateLocation: { count?: { all: number } | null } };

export type GetPaymentsPageInfoQueryVariables = Exact<{
  cursor?: InputMaybe<PaymentWhereUniqueInput>;
  distinct?: InputMaybe<Array<PaymentScalarFieldEnum> | PaymentScalarFieldEnum>;
  orderBy?: InputMaybe<Array<PaymentOrderByWithRelationInput> | PaymentOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentWhereInput>;
}>;


export type GetPaymentsPageInfoQuery = { payments: Array<{ id: string, cardType?: CreditCardType | null, lastFour?: string | null, expYear?: string | null, expMonth?: string | null, createdAt: any, token: string }> };

export type GetPaymentTransactionTableDataQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PaymentTransactionWhereInput>;
}>;


export type GetPaymentTransactionTableDataQuery = { paymentTransactions: Array<{ id: string, invoiceNumber: string, amount: number, status: PaymentTransactionStatus, createdAt: any }> };

export type GetReservationConfigQueryVariables = Exact<{
  locationId: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type GetReservationConfigQuery = { getReservationConfig: { enableLiveUsageEvents?: boolean | null } };

export type GetResourceQueryVariables = Exact<{
  where: ResourceWhereUniqueInput;
}>;


export type GetResourceQuery = { resource?: { building?: string | null, controlType?: ResourceControlType | null, defaultEnd: string, defaultStart: string, description?: string | null, floor?: string | null, id: string, imageUrl?: string | null, locationId: string, name: string, passLevel?: number | null, pmsId?: string | null, type: ResourceType, vendor: ResourceVendor, vendorId?: string | null, code?: string | null, isComponentRoom?: boolean | null, location: { id: string, name: string }, unitType?: { id: string, type: string } | null } | null };

export type GetResourceGroupQueryVariables = Exact<{
  id: Scalars['String'];
}>;


export type GetResourceGroupQuery = { resourceGroup?: { isDefault: boolean, name: string, location: { id: string, name: string }, resources: Array<{ id: string, name: string }> } | null };

export type ResourceGroupsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ResourceGroupOrderByWithRelationInput> | ResourceGroupOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceGroupWhereInput>;
}>;


export type ResourceGroupsQuery = { resourceGroups: Array<{ id: string, isDefault: boolean, name: string, resources: Array<{ id: string, name: string }> }> };

export type GetResourceNamesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
}>;


export type GetResourceNamesQuery = { resources: Array<{ id: string, name: string }> };

export type GetResourceTableDataQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ResourceOrderByWithRelationInput> | ResourceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
}>;


export type GetResourceTableDataQuery = { resources: Array<{ code?: string | null, controlType?: ResourceControlType | null, description?: string | null, id: string, imageUrl?: string | null, name: string, pmsId?: string | null, type: ResourceType, unitTypeId?: string | null, vendor: ResourceVendor, vendorId?: string | null, unitType?: { type: string } | null }> };

export type GetServiceQueryVariables = Exact<{
  where: ServiceWhereUniqueInput;
}>;


export type GetServiceQuery = { service?: { id: string, type: ServiceType, imageUrl: string, title: string, description: string, price: number, locationId?: string | null, askForTime: boolean, displayCommentBox: boolean, status?: ServiceStatus | null, metadata?: any | null, largeDescription?: string | null, location?: { id: string, name: string } | null } | null };

export type GetServiceTableDataQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<ServiceOrderByWithRelationInput> | ServiceOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ServiceWhereInput>;
}>;


export type GetServiceTableDataQuery = { services?: Array<{ id: string, type: ServiceType, imageUrl: string, title: string, description: string, price: number, locationId?: string | null, askForTime: boolean, displayCommentBox: boolean, status?: ServiceStatus | null, metadata?: any | null, largeDescription?: string | null, location?: { id: string, name: string } | null }> | null };

export type GetUnitTypeQueryVariables = Exact<{
  where: UnitTypeWhereUniqueInput;
  unitTypeId: Scalars['String'];
  componentName: Scalars['String'];
}>;


export type GetUnitTypeQuery = { unitType?: { id: string, imageUrl: string, locationId: string, numberOfGuests: number, type: string, location: { id: string, name: string } } | null, getUnitTypeLocalizations: Array<{ id: string, settingsData?: any | null, language: { id: string, code: string, name: string, isRTL: boolean } }> };

export type GetUnitTypeTableDataQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<UnitTypeOrderByWithRelationInput> | UnitTypeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitTypeWhereInput>;
}>;


export type GetUnitTypeTableDataQuery = { unitTypes?: Array<{ id: string, imageUrl: string, locationId: string, numberOfGuests: number, type: string, location: { id: string, name: string } }> | null };

export type GetUserQueryVariables = Exact<{
  where: UserWhereInput;
}>;


export type GetUserQuery = { user?: { email?: string | null, id: string, name?: string | null, phoneNumber?: string | null, dashboardPreferences?: any | null, memberships: Array<{ id: string, role: Role, tenantId: string, locationId?: string | null, location?: { id: string, name: string } | null, locationGroup?: { id: string, name: string } | null }>, payments: Array<{ providerType: PaymentProviderType, token: string, customerId: string }>, userRecords: Array<{ recordType: UserRecordType, recordId: string, tenantId: string }> } | null };

export type GetUserMembershipsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetUserMembershipsQuery = { getUserMemberships: Array<{ id: string, name: string, locations?: Array<{ id: string, name: string }> | null }> };

export type GetUserRecordsPageInfoQueryVariables = Exact<{
  cursor?: InputMaybe<UserRecordWhereUniqueInput>;
  distinct?: InputMaybe<Array<UserRecordScalarFieldEnum> | UserRecordScalarFieldEnum>;
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput> | UserRecordOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserRecordWhereInput>;
}>;


export type GetUserRecordsPageInfoQuery = { userRecords: Array<{ id: string, recordType: UserRecordType, recordId: string, timeStamp: any, tenantId: string, userId?: string | null, verificationStatus?: string | null }> };

export type GetUsersTableDataQueryVariables = Exact<{
  cursor?: InputMaybe<UserWhereUniqueInput>;
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput> | UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
}>;


export type GetUsersTableDataQuery = { users: Array<{ email?: string | null, id: string, lastSeenAt?: any | null, name?: string | null, phoneNumber?: string | null, memberships: Array<{ locationId?: string | null, role: Role, tenantId: string }> }> };

export type GetVendorServerQueryVariables = Exact<{
  where: VendorServerWhereUniqueInput;
}>;


export type GetVendorServerQuery = { vendorServer?: { username?: string | null, password?: string | null, shouldAllJoin: boolean, lockServiceCode?: string | null, trailerBlock?: string | null, accessID?: string | null, uuid?: string | null, assaCardType?: AssaCardType | null, additionalConfig?: any | null, id: string, vendor: ResourceVendor, host: string, port: number, isActive: boolean } | null };

export type GetVendorServersTableDataQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<VendorServerOrderByWithRelationInput> | VendorServerOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VendorServerWhereInput>;
}>;


export type GetVendorServersTableDataQuery = { vendorServers?: Array<{ id: string, vendor: ResourceVendor, host: string, port: number, isActive: boolean, shouldAllJoin: boolean }> | null };

export type GetVendorServerCountQueryVariables = Exact<{
  where: VendorServerWhereInput;
}>;


export type GetVendorServerCountQuery = { aggregateVendorServer: { _count?: { _all: number } | null } };

export type InvalidateCredentialMutationVariables = Exact<{
  credentialId: Scalars['String'];
}>;


export type InvalidateCredentialMutation = { invalidateCredential: { id: string, type: CredentialType, userId: string, isActive: boolean, createdAt: any, expiresAt?: any | null, cancelledAt?: any | null, updatedAt?: any | null, user: { id: string, name?: string | null }, accessGrant: { id: string, userId: string } } };

export type IssueKeyForKioskMutationVariables = Exact<{
  kioskId: Scalars['String'];
}>;


export type IssueKeyForKioskMutation = { issueKeyForKiosk: { success: boolean } };

export type IssueKeyForKioskWithAccessGrantIdMutationVariables = Exact<{
  kioskId: Scalars['String'];
  accessGrantId: Scalars['String'];
}>;


export type IssueKeyForKioskWithAccessGrantIdMutation = { issueKeyForKioskWithAccessGrantId: { success: boolean } };

export type JoinVideoMutationVariables = Exact<{
  room: Scalars['String'];
  callRecordId: Scalars['String'];
  joinerChallenge: Scalars['String'];
}>;


export type JoinVideoMutation = { joinVideo: { accessToken: string } };

export type LoadKioskSessionMutationVariables = Exact<{
  accessGrantId: Scalars['String'];
  kioskId: Scalars['String'];
}>;


export type LoadKioskSessionMutation = { loadKioskSession: { success: boolean } };

export type MeWithUserRolePermissionsQueryVariables = Exact<{ [key: string]: never; }>;


export type MeWithUserRolePermissionsQuery = { meWithUserRolePermissions: { email?: string | null, id: string, name?: string | null, phoneNumber?: string | null, activeMembership?: { id: string, lastSeenAt?: any | null, tenantId: string, role: Role, permissions?: any | null, location?: { id: string, name: string } | null, tenant: { id: string, name: string }, locationGroup?: { id: string, name: string, locationIds?: Array<string> | null } | null } | null, virtualMemberships?: Array<{ id: string, role: Role, tenant: { id: string, name: string }, location?: { id: string, name: string } | null, locationGroup?: { id: string, name: string, locationIds?: Array<string> | null } | null }> | null } };

export type DashboardSignInMutationVariables = Exact<{
  password: Scalars['String'];
  email: Scalars['String'];
}>;


export type DashboardSignInMutation = { dashboardSignIn: { accessToken?: string | null, expiresIn?: string | null, refreshToken?: string | null } };

export type EnrollKioskMutationVariables = Exact<{
  code: Scalars['String'];
  locationId: Scalars['String'];
  name?: InputMaybe<Scalars['String']>;
}>;


export type EnrollKioskMutation = { enrollKiosk: { id: string, lastSeenAt?: any | null, locationId: string, name: string, location: { id: string, name: string } } };

export type UpsertKioskLocalizationMutationVariables = Exact<{
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  kioskId: Scalars['String'];
  localization: Scalars['String'];
}>;


export type UpsertKioskLocalizationMutation = { upsertKioskLocalization: { settingsData?: any | null, mergedSettingsData: any } };

export type DeleteKioskThemeMutationVariables = Exact<{
  componentName: Scalars['String'];
  kioskId: Scalars['String'];
}>;


export type DeleteKioskThemeMutation = { deleteKioskTheme: { settingsData?: any | null, mergedSettingsData: any } };

export type DeleteKioskLocalizationMutationVariables = Exact<{
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  kioskId: Scalars['String'];
}>;


export type DeleteKioskLocalizationMutation = { deleteKioskLocalization: { settingsData?: any | null, mergedSettingsData: any } };

export type UpsertKioskThemeMutationVariables = Exact<{
  componentName: Scalars['String'];
  kioskId: Scalars['String'];
  setting: Scalars['String'];
}>;


export type UpsertKioskThemeMutation = { upsertKioskTheme: { settingsData?: any | null, mergedSettingsData: any } };

export type CreateGuestEngagementEventMutationVariables = Exact<{
  accessGrantId: Scalars['String'];
  kioskId: Scalars['String'];
}>;


export type CreateGuestEngagementEventMutation = { createGuestEngagementEvent: boolean };

export type CreateLocationMutationVariables = Exact<{
  data: LocationCreateInput;
}>;


export type CreateLocationMutation = { createLocation: { address: string, createdAt: any, id: string, name: string, phoneNumber: string, updatedAt: any, logoUrl?: string | null, imageUrl?: string | null } };

export type DeleteLocationThemeMutationVariables = Exact<{
  componentName: Scalars['String'];
  locationId: Scalars['String'];
}>;


export type DeleteLocationThemeMutation = { deleteLocationTheme: { settingsData?: any | null, mergedSettingsData: any } };

export type DeleteLocationLocalizationMutationVariables = Exact<{
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  locationId: Scalars['String'];
}>;


export type DeleteLocationLocalizationMutation = { deleteLocationLocalization: { settingsData?: any | null, mergedSettingsData: any } };

export type UpsertLocationLocalizationMutationVariables = Exact<{
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  locationId: Scalars['String'];
  localization: Scalars['String'];
}>;


export type UpsertLocationLocalizationMutation = { upsertLocationLocalization: { settingsData?: any | null, mergedSettingsData: any } };

export type UpsertLocationThemeMutationVariables = Exact<{
  componentName: Scalars['String'];
  locationId: Scalars['String'];
  setting: Scalars['String'];
}>;


export type UpsertLocationThemeMutation = { upsertLocationTheme: { settingsData?: any | null, mergedSettingsData: any } };

export type IssueResetPasswordByEmailChallengeMutationVariables = Exact<{
  email: Scalars['String'];
}>;


export type IssueResetPasswordByEmailChallengeMutation = { issueResetPasswordByEmailChallenge: boolean };

export type ResetPasswordByEmailMutationVariables = Exact<{
  newPassword: Scalars['String'];
  challenge: Scalars['String'];
  email: Scalars['String'];
}>;


export type ResetPasswordByEmailMutation = { resetPasswordByEmail: boolean };

export type DeleteTenantThemeMutationVariables = Exact<{
  componentName: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type DeleteTenantThemeMutation = { deleteTenantTheme: { settingsData?: any | null, mergedSettingsData: any } };

export type DeleteTenantLocalizationMutationVariables = Exact<{
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type DeleteTenantLocalizationMutation = { deleteTenantLocalization: { settingsData?: any | null, mergedSettingsData: any } };

export type UpsertTenantLocalizationMutationVariables = Exact<{
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  tenantId: Scalars['String'];
  localization: Scalars['String'];
}>;


export type UpsertTenantLocalizationMutation = { upsertTenantLocalization: { settingsData?: any | null, mergedSettingsData: any } };

export type UpsertTenantThemeMutationVariables = Exact<{
  componentName: Scalars['String'];
  tenantId: Scalars['String'];
  setting: Scalars['String'];
}>;


export type UpsertTenantThemeMutation = { upsertTenantTheme: { settingsData?: any | null, mergedSettingsData: any } };

export type PerformCheckInMutationVariables = Exact<{
  accessGrantId: Scalars['String'];
}>;


export type PerformCheckInMutation = { performCheckIn: { success: boolean } };

export type PerformCheckOutMutationVariables = Exact<{
  accessGrantId: Scalars['String'];
}>;


export type PerformCheckOutMutation = { performCheckOut: { success: boolean } };

export type PollReservationFromPmsMutationVariables = Exact<{
  tenantId: Scalars['String'];
  locationId: Scalars['String'];
  confirmationCode: Scalars['String'];
}>;


export type PollReservationFromPmsMutation = { pollReservationFromPms: boolean };

export type RetrieveVerficationResultQueryVariables = Exact<{
  scanReference: Scalars['String'];
}>;


export type RetrieveVerficationResultQuery = { retrieveVerificationResult: { dob?: string | null, expiry?: string | null, firstName?: string | null, issuingCountry?: string | null, issuingDate?: string | null, lastName?: string | null, number?: string | null, scanReference?: string | null, status?: IdVerificationResultStatus | null, timestamp?: string | null, type?: string | null, images?: Array<{ classifier?: string | null, href?: string | null }> | null } };

export type GetKioskThemeQueryVariables = Exact<{
  componentName: Scalars['String'];
  kioskId: Scalars['String'];
}>;


export type GetKioskThemeQuery = { getKioskTheme: { settingsData?: any | null, mergedSettingsData: any } };

export type GetKioskLocalizationQueryVariables = Exact<{
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  kioskId: Scalars['String'];
}>;


export type GetKioskLocalizationQuery = { getKioskLocalization: { settingsData?: any | null, mergedSettingsData: any } };

export type GetLocationThemeQueryVariables = Exact<{
  componentName: Scalars['String'];
  locationId: Scalars['String'];
}>;


export type GetLocationThemeQuery = { getLocationTheme: { settingsData?: any | null, mergedSettingsData: any } };

export type GetLocationLocalizationQueryVariables = Exact<{
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  locationId: Scalars['String'];
}>;


export type GetLocationLocalizationQuery = { getLocationLocalization: { settingsData?: any | null, mergedSettingsData: any } };

export type GetTenantThemeQueryVariables = Exact<{
  componentName: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type GetTenantThemeQuery = { getTenantTheme: { settingsData?: any | null, mergedSettingsData: any } };

export type GetTenantLocalizationQueryVariables = Exact<{
  componentName: Scalars['String'];
  languageId: Scalars['String'];
  tenantId: Scalars['String'];
}>;


export type GetTenantLocalizationQuery = { getTenantLocalization: { settingsData?: any | null, mergedSettingsData: any } };

export type UserQueryVariables = Exact<{
  where: UserWhereInput;
}>;


export type UserQuery = { user?: { email?: string | null, id: string, lastSeenAt?: any | null, name?: string | null, phoneNumber?: string | null, memberships: Array<{ id: string, role: Role, tenantId: string }>, payments: Array<{ providerType: PaymentProviderType, token: string, customerId: string }>, userRecords: Array<{ recordType: UserRecordType, recordId: string, tenantId: string }> } | null };

export type UsersQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
}>;


export type UsersQuery = { users: Array<{ email?: string | null, id: string, lastSeenAt?: any | null, name?: string | null, phoneNumber?: string | null, memberships: Array<{ id: string, role: Role, tenantId: string }> }>, aggregateUser: { _count?: { _all: number } | null } };

export type UserRecordsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<UserRecordOrderByWithRelationInput> | UserRecordOrderByWithRelationInput>;
  where?: InputMaybe<UserRecordWhereInput>;
}>;


export type UserRecordsQuery = { userRecords: Array<{ recordType: UserRecordType, recordId: string, tenantId: string }> };

export type ResendConfirmationInfoMutationVariables = Exact<{
  accessGrantId: Scalars['String'];
}>;


export type ResendConfirmationInfoMutation = { resendConfirmationInfo: { success: boolean } };

export type SearchAccessGrantsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<AccessGrantOrderByWithRelationInput> | AccessGrantOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AccessGrantWhereInput>;
}>;


export type SearchAccessGrantsQuery = { accessGrants?: Array<{ id: string, confirmationCode?: string | null }> | null };

export type SearchAmenityGroupsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<AmenityGroupOrderByWithRelationInput> | AmenityGroupOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<AmenityGroupWhereInput>;
}>;


export type SearchAmenityGroupsQuery = { amenityGroups: Array<{ id: string, title: string }> };

export type GetDashboardLocationsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput> | LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CustomLocationWhereInput>;
}>;


export type GetDashboardLocationsQuery = { getDashboardLocations: Array<{ id: string, name: string }> };

export type SearchKiosksQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<KioskOrderByWithRelationInput> | KioskOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<KioskWhereInput>;
}>;


export type SearchKiosksQuery = { kiosks: Array<{ id: string, name: string }> };

export type SearchLocationsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LocationOrderByWithRelationInput> | LocationOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationWhereInput>;
}>;


export type SearchLocationsQuery = { locations: Array<{ id: string, name: string }> };

export type SearchUnitTypesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<UnitTypeOrderByWithRelationInput> | UnitTypeOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UnitTypeWhereInput>;
}>;


export type SearchUnitTypesQuery = { unitTypes?: Array<{ id: string, type: string }> | null };

export type SearchUsersQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<UserOrderByWithRelationInput> | UserOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserWhereInput>;
}>;


export type SearchUsersQuery = { users: Array<{ id: string, name?: string | null }> };

export type SendNotificationMutationVariables = Exact<{
  accessGrantId: Scalars['String'];
  transport: Scalars['String'];
  notificationId: Scalars['String'];
}>;


export type SendNotificationMutation = { sendNotification: boolean };

export type SendNotificationToExternalApiMutationVariables = Exact<{
  accessGrantId: Scalars['String'];
  userId: Scalars['String'];
}>;


export type SendNotificationToExternalApiMutation = { sendNotificationToExternalAPI: boolean };

export type SetAccessSetupMutationVariables = Exact<{
  data: AccessSetupInput;
  where: AccessSetupWhere;
}>;


export type SetAccessSetupMutation = { setAccessSetup: { success: boolean } };

export type SignUpUsersFromThirdPartyAuthenticationServiceMutationVariables = Exact<{
  tenantId: Scalars['String'];
  serviceType: Scalars['String'];
}>;


export type SignUpUsersFromThirdPartyAuthenticationServiceMutation = { signUpUsersFromThirdPartyAuthenticationService: Array<{ email?: string | null, id: string, name?: string | null }> };

export type BaseSettingAnswerFieldsFragment = { settingsData?: any | null, mergedSettingsData: any };

export type TakeScreenshotMutationVariables = Exact<{
  kioskId: Scalars['String'];
}>;


export type TakeScreenshotMutation = { takeScreenshot: { success: boolean } };

export type UpdateAccessGrantMutationVariables = Exact<{
  data: AccessGrantUpdateInput;
  originalAgreementFileId?: InputMaybe<Scalars['String']>;
  where: AccessGrantWhereUniqueInput;
}>;


export type UpdateAccessGrantMutation = { updateAccessGrant: { confirmationCode?: string | null, endsAt: any, endTime?: string | null, id: string, startsAt: any, arrivalTime?: string | null, startTime?: string | null, state?: AccessGrantState | null, status: AccessGrantStatus, tenantId: string, credentials: Array<{ id: string, userId: string }>, idVerificationResult?: { id: string, status: IdVerificationResultStatus } | null, location: { id: string, name: string, timezone: string }, requirements: Array<{ status: RequirementStatus, type: RequirementType }>, user: { id: string, lastSeenAt?: any | null, name?: string | null } } };

export type UpdateAmenityAndUploadImageFileMutationVariables = Exact<{
  data: CustomAmenityUpdateInput;
  where: AmenityWhereUniqueInput;
}>;


export type UpdateAmenityAndUploadImageFileMutation = { updateAmenityAndUploadImageFile: { id: string, title: string, imageUrl: string, description?: string | null, group?: { id: string, title: string } | null, location?: { id: string, name: string } | null } };

export type UpdateEarlyCheckInPackageMutationVariables = Exact<{
  data: EarlyCheckInPackageInput;
  where: UpdateEarlyCheckInPackageWhere;
}>;


export type UpdateEarlyCheckInPackageMutation = { updateEarlyCheckInPackage: { endTime?: string | null, externalId?: string | null, freeUpgrade?: boolean | null, locationId: string, loyaltyCodes?: Array<string> | null, serviceId: string, startTime?: string | null } };

export type UpdateInfoItemAndUploadImageFileMutationVariables = Exact<{
  data: CustomInfoItemUpdateInput;
  where: InfoItemWhereUniqueInput;
}>;


export type UpdateInfoItemAndUploadImageFileMutation = { updateInfoItemAndUploadImageFile: { id: string, title: string } };

export type UpdateKioskMutationVariables = Exact<{
  data: CustomKioskUpdateInput;
  where: KioskWhereUniqueInput;
}>;


export type UpdateKioskMutation = { updateKiosk?: { hasDispenser: boolean, hasTerminal: boolean, id: string, dispenserLastSeenAt?: any | null, terminalLastSeenAt?: any | null, lastSeenAt?: any | null, name: string, serverUrl?: string | null, buildNumber?: string | null, metadata?: any | null, location: { id: string, name: string, timezone: string } } | null };

export type UpdateLocationMutationVariables = Exact<{
  data: LocationUpdateInput;
  where: LocationWhereUniqueInput;
}>;


export type UpdateLocationMutation = { updateLocation?: { address: string, createdAt: any, defaultEndTime: string, defaultStartTime: string, email?: string | null, id: string, imageUrl?: string | null, name: string, phoneNumber: string, updatedAt: any, logoUrl?: string | null, timezone: string, defaultRequirements: Array<{ id: string, type: RequirementType }>, vendorServers: Array<{ id: string, host: string, port: number, vendor: ResourceVendor }> } | null };

export type UpdateRequirementsMutationVariables = Exact<{
  kioskId: Scalars['String'];
  accessGrantId: Scalars['String'];
  requirementArgsList: Array<CustomRequirementUpdateInput> | CustomRequirementUpdateInput;
}>;


export type UpdateRequirementsMutation = { updateRequirements: { success: boolean } };

export type UpdateResourceAndUploadImageFileMutationVariables = Exact<{
  data: CustomResourceUpdateInput;
  where: ResourceWhereUniqueInput;
}>;


export type UpdateResourceAndUploadImageFileMutation = { updateResourceAndUploadImageFile?: { code?: string | null, controlType?: ResourceControlType | null, description?: string | null, id: string, imageUrl?: string | null, name: string, pmsId?: string | null, type: ResourceType, unitTypeId?: string | null, vendor: ResourceVendor, vendorId?: string | null, unitType?: { type: string } | null } | null };

export type UpdateResourceGroupMutationVariables = Exact<{
  data: ResourceGroupUpdateInput;
  where: ResourceGroupWhereUniqueInput;
}>;


export type UpdateResourceGroupMutation = { updateResourceGroup: { id: string, isDefault: boolean, name: string, resources: Array<{ id: string, name: string }> } };

export type UpdateServiceAndUploadImageFileMutationVariables = Exact<{
  data: CustomServiceUpdateInput;
  where: ServiceWhereUniqueInput;
}>;


export type UpdateServiceAndUploadImageFileMutation = { updateServiceAndUploadImageFile: { id: string, type: ServiceType, imageUrl: string, title: string, description: string, price: number, locationId?: string | null, askForTime: boolean, displayCommentBox: boolean, status?: ServiceStatus | null, metadata?: any | null, largeDescription?: string | null, location?: { id: string, name: string } | null } };

export type UpdateUnitTypeAndUploadImageFileMutationVariables = Exact<{
  data: CustomUnitTypeUpdateInput;
  where: UnitTypeWhereUniqueInput;
}>;


export type UpdateUnitTypeAndUploadImageFileMutation = { updateUnitTypeAndUploadImageFile: { id: string, imageUrl: string, locationId: string, numberOfGuests: number, type: string } };

export type UpdateUserMutationVariables = Exact<{
  data: UserUpdateInput;
  where: UserWhereUniqueInput;
}>;


export type UpdateUserMutation = { updateUser: { email?: string | null, id: string, lastSeenAt?: any | null, name?: string | null, phoneNumber?: string | null, memberships: Array<{ role: Role, tenantId: string }> } };

export type UpdateOneVendorServerMutationVariables = Exact<{
  data: VendorServerUpdateInput;
  where: VendorServerWhereUniqueInput;
}>;


export type UpdateOneVendorServerMutation = { updateOneVendorServer?: { id: string, vendor: ResourceVendor } | null };

export type UploadFileMutationVariables = Exact<{
  locationId: Scalars['String'];
  file: Scalars['Upload'];
  fileType: FileType;
}>;


export type UploadFileMutation = { uploadFile: { id: string, url: string } };

export type UploadResourcesMutationVariables = Exact<{
  file: Scalars['Upload'];
  locationId: Scalars['String'];
}>;


export type UploadResourcesMutation = { uploadResources?: Array<{ id: string, name: string }> | null };

export type UploadUnitTypesMutationVariables = Exact<{
  file: Scalars['Upload'];
  locationId: Scalars['String'];
  languageId: Scalars['String'];
}>;


export type UploadUnitTypesMutation = { uploadUnitTypes?: Array<{ id: string, type: string }> | null };

export type SetGracePeriodsConfigMutationVariables = Exact<{
  gracePeriodsConfigLevel: Scalars['String'];
  accessGrantId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  data: GracePeriodInput;
}>;


export type SetGracePeriodsConfigMutation = { setGracePeriodsConfig: { success: boolean } };

export type SetLimitKeysConfigMutationVariables = Exact<{
  accessGrantId?: InputMaybe<Scalars['String']>;
  locationId?: InputMaybe<Scalars['String']>;
  tenantId?: InputMaybe<Scalars['String']>;
  limitKeysConfigLevel: Scalars['String'];
  maxKeys?: InputMaybe<Scalars['Float']>;
}>;


export type SetLimitKeysConfigMutation = { setLimitKeysConfig: { success: boolean } };

export type UpsertOrDeleteUnitTypeLocalizationsMutationVariables = Exact<{
  unitTypeId: Scalars['String'];
  componentName: Scalars['String'];
  unitTypeLocalizations: CustomLocalizationInputArgs;
}>;


export type UpsertOrDeleteUnitTypeLocalizationsMutation = { upsertOrDeleteUnitTypeLocalizations: Array<{ id: string, language: { code: string, name: string } }> };

export type GetKiosksLiveUsageDataQueryVariables = Exact<{
  kioskAndAccessGrantParams: Array<KioskAndAccessGrantParams> | KioskAndAccessGrantParams;
}>;


export type GetKiosksLiveUsageDataQuery = { getKiosksLiveUsageData: { data: Array<{ kiosk: { id: string, name: string, dispenserType?: DispenserType | null, hasDispenser?: boolean | null, location: { id: string, name: string, timezone: string, tenantId: string } }, accessGrant?: { id: string, confirmationCode?: string | null, startsAt: any, endsAt: any, roomNumber?: string | null, user: { id: string, name?: string | null, email?: string | null }, totalGuests: { adults?: number | null, children?: number | null, total?: number | null }, bookedPackages: Array<{ title: string, quantity?: number | null }>, resources: Array<{ id: string, name: string, description?: string | null, pmsId?: string | null }>, secondaryUsers: Array<{ user: { id: string, name?: string | null, email?: string | null } }>, requirements: Array<{ id: string, type: RequirementType, status: RequirementStatus }> } | null }> } };

export type SearchGroupsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<LocationGroupOrderByWithRelationInput> | LocationGroupOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<LocationGroupWhereInput>;
}>;


export type SearchGroupsQuery = { locationGroups: Array<{ id: string, name: string }> };

export type UserOnAgFieldsFragment = { id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, lastSeenAt?: any | null };

export type AccessGrantPageInfoFieldsFragment = { confirmationCode?: string | null, id: string, endsAt: any, endDate?: string | null, endTime?: string | null, lastPolledAt?: any | null, metadata: any, startsAt: any, startDate?: string | null, startTime?: string | null, arrivalTime?: string | null, state?: AccessGrantState | null, status: AccessGrantStatus, tenantId: string, credentials?: Array<{ id: string, userId: string, isActive: boolean }> | null, location?: { id: string, name: string, timezone: string, supportsPolling: boolean } | null, requirements?: Array<{ createdAt: any, id: string, status: RequirementStatus, type: RequirementType, updatedAt: any, files: Array<{ id: string, file: { fileType: FileType, url: string } }> }> | null, resources?: Array<{ name: string, type: ResourceType }> | null, secondaryUsers?: Array<{ user: { id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, lastSeenAt?: any | null } }> | null, user?: { id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, lastSeenAt?: any | null } | null };

export type GetAccessGrantPageInfoAndCheckNotificationCapabilityQueryVariables = Exact<{
  accessGrantId: Scalars['String'];
  where: AccessGrantWhereInput;
}>;


export type GetAccessGrantPageInfoAndCheckNotificationCapabilityQuery = { accessGrantIsEnabledToSendNotificationToExternalAPI: boolean, findDashboardAccessGrant?: { confirmationCode?: string | null, id: string, endsAt: any, endDate?: string | null, endTime?: string | null, lastPolledAt?: any | null, metadata: any, startsAt: any, startDate?: string | null, startTime?: string | null, arrivalTime?: string | null, state?: AccessGrantState | null, status: AccessGrantStatus, tenantId: string, credentials?: Array<{ id: string, userId: string, isActive: boolean }> | null, location?: { id: string, name: string, timezone: string, supportsPolling: boolean } | null, requirements?: Array<{ createdAt: any, id: string, status: RequirementStatus, type: RequirementType, updatedAt: any, files: Array<{ id: string, file: { fileType: FileType, url: string } }> }> | null, resources?: Array<{ name: string, type: ResourceType }> | null, secondaryUsers?: Array<{ user: { id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, lastSeenAt?: any | null } }> | null, user?: { id: string, name?: string | null, email?: string | null, phoneNumber?: string | null, lastSeenAt?: any | null } | null } | null };

export type GetAccessGrantPageRequirementsQueryVariables = Exact<{
  distinct?: InputMaybe<Array<RequirementScalarFieldEnum> | RequirementScalarFieldEnum>;
  orderBy?: InputMaybe<Array<RequirementOrderByWithRelationInput> | RequirementOrderByWithRelationInput>;
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RequirementWhereInput>;
}>;


export type GetAccessGrantPageRequirementsQuery = { requirements: Array<{ createdAt: any, id: string, status: RequirementStatus, type: RequirementType, updatedAt: any }> };

export type GetAccessGrantPageResourcesQueryVariables = Exact<{
  skip?: InputMaybe<Scalars['Int']>;
  take?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceWhereInput>;
}>;


export type GetAccessGrantPageResourcesQuery = { resources: Array<{ code?: string | null, controlType?: ResourceControlType | null, defaultEnd: string, defaultStart: string, id: string, name: string, type: ResourceType, vendor: ResourceVendor }> };

export type GetDashboardSupportedNotificationsQueryVariables = Exact<{
  where: DashboardSupportedNotificationsWhereInput;
}>;


export type GetDashboardSupportedNotificationsQuery = { getDashboardSupportedNotifications?: { notifications: Array<string> } | null };

export type GetKioskPageInfoQueryVariables = Exact<{
  where: KioskWhereUniqueInput;
}>;


export type GetKioskPageInfoQuery = { kiosk?: { id: string, name: string, dispenserType?: DispenserType | null, batteryLevel?: number | null, chargingState?: ChargingState | null, hasDispenser: boolean, dispenserLastSeenAt?: any | null, hasTerminal: boolean, lastSeenAt?: any | null, terminalLastSeenAt?: any | null, buildNumber?: string | null, metadata?: any | null, location: { id: string, name: string, tenantId: string } } | null };

export type GetDashboardLocationQueryVariables = Exact<{
  where: LocationWhereInput;
}>;


export type GetDashboardLocationQuery = { getDashboardLocation?: { id: string, address: string, email?: string | null, logoUrl?: string | null, imageUrl?: string | null, name: string, phoneNumber: string, pmsType?: PmsType | null, tenantId: string, supportsPolling: boolean, defaultStartTime: string, defaultEndTime: string } | null };

export type GetLocationGroupNodesQueryVariables = Exact<{
  tenantId: Scalars['String'];
}>;


export type GetLocationGroupNodesQuery = { getLocationGroupNodes: Array<{ id: string, name: string, parentGroupIds?: Array<string> | null, locations?: Array<{ id: string, name: string }> | null }> };

export type GetTenantPageInfoQueryVariables = Exact<{
  where: TenantWhereUniqueInput;
}>;


export type GetTenantPageInfoQuery = { tenant?: { id: string, name: string } | null };

export const AccessGrantTableFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGrantTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idVerificationResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AccessGrantTableFieldsFragment, unknown>;
export const AmenityTableFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AmenityTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Amenity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"amenityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<AmenityTableFieldsFragment, unknown>;
export const CredentialFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CredentialFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Credential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessGrant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<CredentialFieldsFragment, unknown>;
export const GracePeriodValuesFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GracePeriodValuesFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GracePeriodValues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gracePeriodType"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTime"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTimePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"relativeTimeInMinutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gracePeriodType"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTime"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTimePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"relativeTimeInMinutes"}}]}}]}}]} as unknown as DocumentNode<GracePeriodValuesFieldsFragment, unknown>;
export const InfoItemFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InfoItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moreInfoLink"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"infoType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAppearInDashboard"}}]}}]}}]} as unknown as DocumentNode<InfoItemFieldsFragment, unknown>;
export const KioskTableFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KioskTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Kiosk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasDispenser"}},{"kind":"Field","name":{"kind":"Name","value":"hasTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dispenserLastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminalLastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buildNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]} as unknown as DocumentNode<KioskTableFieldsFragment, unknown>;
export const LocationTableFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailFrom"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]} as unknown as DocumentNode<LocationTableFieldsFragment, unknown>;
export const VirtualMembershipFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VirtualMembershipFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locationIds"}}]}}]}}]} as unknown as DocumentNode<VirtualMembershipFieldsFragment, unknown>;
export const ActiveMembershipFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveMembershipFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipWithPermissions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locationIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}}]}}]} as unknown as DocumentNode<ActiveMembershipFieldsFragment, unknown>;
export const ResourceTableFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"controlType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pmsId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}}]}}]} as unknown as DocumentNode<ResourceTableFieldsFragment, unknown>;
export const ServiceFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Service"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"askForTime"}},{"kind":"Field","name":{"kind":"Name","value":"displayCommentBox"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"largeDescription"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<ServiceFieldsFragment, unknown>;
export const UnitTypeFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitTypeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnitType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfGuests"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UnitTypeFieldsFragment, unknown>;
export const VendorServerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorServerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAllJoin"}}]}}]} as unknown as DocumentNode<VendorServerFieldsFragment, unknown>;
export const VendorServerDetailsFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorServerDetailsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorServerFields"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAllJoin"}},{"kind":"Field","name":{"kind":"Name","value":"lockServiceCode"}},{"kind":"Field","name":{"kind":"Name","value":"trailerBlock"}},{"kind":"Field","name":{"kind":"Name","value":"accessID"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"assaCardType"}},{"kind":"Field","name":{"kind":"Name","value":"additionalConfig"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorServerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAllJoin"}}]}}]} as unknown as DocumentNode<VendorServerDetailsFieldsFragment, unknown>;
export const BaseSettingAnswerFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<BaseSettingAnswerFieldsFragment, unknown>;
export const UserOnAgFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOnAGFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}}]}}]} as unknown as DocumentNode<UserOnAgFieldsFragment, unknown>;
export const AccessGrantPageInfoFieldsFragmentDoc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGrantPageInfoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardAccessGrant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"lastPolledAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"supportsPolling"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOnAGFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOnAGFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOnAGFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}}]}}]} as unknown as DocumentNode<AccessGrantPageInfoFieldsFragment, unknown>;
export const CanAssociateLocationGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"CanAssociateLocationGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"parentLocationGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"canAssociateLocationGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGroupId"}}},{"kind":"Argument","name":{"kind":"Name","value":"parentLocationGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"parentLocationGroupId"}}}]}]}}]} as unknown as DocumentNode<CanAssociateLocationGroupQuery, CanAssociateLocationGroupQueryVariables>;
export const CreateLocationGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLocationGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomLocationGroupCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLocationGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateLocationGroupMutation, CreateLocationGroupMutationVariables>;
export const DeleteLocatonGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteLocatonGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLocationGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteLocatonGroupMutation, DeleteLocatonGroupMutationVariables>;
export const GetLocationGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationGroupId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationGroupId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationGroupId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"groups"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetLocationGroupQuery, GetLocationGroupQueryVariables>;
export const UpdateLocationGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocationGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomLocationGroupUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomLocationGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLocationGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateLocationGroupMutation, UpdateLocationGroupMutationVariables>;
export const AccessMembershipDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"AccessMembership"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessMembership"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"membershipId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"membershipId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}}]}}]}}]} as unknown as DocumentNode<AccessMembershipMutation, AccessMembershipMutationVariables>;
export const GetAccessGrantCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessGrantCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateDashboardAccessGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccessGrantCountQuery, GetAccessGrantCountQueryVariables>;
export const GetAmenityCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAmenityCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AmenityWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateAmenity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetAmenityCountQuery, GetAmenityCountQueryVariables>;
export const GetCallRecordCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCallRecordCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CallRecordWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateCallRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetCallRecordCountQuery, GetCallRecordCountQueryVariables>;
export const GetCredentialCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCredentialCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CredentialWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateCredential"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetCredentialCountQuery, GetCredentialCountQueryVariables>;
export const GetKioskCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKioskCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateKiosk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetKioskCountQuery, GetKioskCountQueryVariables>;
export const AggregateDashboardLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AggregateDashboardLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomLocationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateDashboardLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<AggregateDashboardLocationQuery, AggregateDashboardLocationQueryVariables>;
export const GetLocationCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetLocationCountQuery, GetLocationCountQueryVariables>;
export const GetPaymentCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetPaymentCountQuery, GetPaymentCountQueryVariables>;
export const GetPaymentTransactionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentTransaction"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentTransactionWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregatePaymentTransaction"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetPaymentTransactionQuery, GetPaymentTransactionQueryVariables>;
export const GetResourceCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetResourceCountQuery, GetResourceCountQueryVariables>;
export const GetResourceGroupCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceGroupCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceGroupWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateResourceGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetResourceGroupCountQuery, GetResourceGroupCountQueryVariables>;
export const GetServiceCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetServiceCountQuery, GetServiceCountQueryVariables>;
export const GetUnitTypeCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnitTypeCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnitTypeWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateUnitType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetUnitTypeCountQuery, GetUnitTypeCountQueryVariables>;
export const GetUserCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserCountQuery, GetUserCountQueryVariables>;
export const GetUserRecordCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserRecordCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecordWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateUserRecord"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserRecordCountQuery, GetUserRecordCountQueryVariables>;
export const ArrivalsByDayDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ArrivalsByDay"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"days"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"generateArrivalsByDayReport"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"days"},"value":{"kind":"Variable","name":{"kind":"Name","value":"days"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ArrivalsByDayQuery, ArrivalsByDayQueryVariables>;
export const BypassVerificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"bypassVerification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"bypassVerification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<BypassVerificationMutation, BypassVerificationMutationVariables>;
export const CallRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"callRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CallRecordScalarFieldEnum"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CallRecordOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CallRecordWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessGrant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"kiosk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"address"}}]}},{"kind":"Field","name":{"kind":"Name","value":"room"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"caller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]} as unknown as DocumentNode<CallRecordsQuery, CallRecordsQueryVariables>;
export const CancelAccessGrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CancelAccessGrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cancelAccessGrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<CancelAccessGrantMutation, CancelAccessGrantMutationVariables>;
export const CloudbedsConnectAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"cloudbedsConnectApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cloudbedsConnectApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CloudbedsConnectAppMutation, CloudbedsConnectAppMutationVariables>;
export const CreateAccessGrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAccessGrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantCreateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originalAgreementFileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAccessGrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"originalAgreementFileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalAgreementFileId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]}}]} as unknown as DocumentNode<CreateAccessGrantMutation, CreateAccessGrantMutationVariables>;
export const CreateAmenityAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateAmenityAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomAmenityCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createAmenityAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}}]}}]}}]} as unknown as DocumentNode<CreateAmenityAndUploadImageFileMutation, CreateAmenityAndUploadImageFileMutationVariables>;
export const CreateEarlyCheckInPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"createEarlyCheckInPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EarlyCheckInPackageInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createEarlyCheckInPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"freeUpgrade"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyCodes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}}]}}]} as unknown as DocumentNode<CreateEarlyCheckInPackageMutation, CreateEarlyCheckInPackageMutationVariables>;
export const CreateInfoItemAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateInfoItemAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInfoItemCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createInfoItemAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CreateInfoItemAndUploadImageFileMutation, CreateInfoItemAndUploadImageFileMutationVariables>;
export const CreateKioskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateKiosk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneKiosk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateKioskMutation, CreateKioskMutationVariables>;
export const CreateResourceAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateResourceAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomResourceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createResourceAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateResourceAndUploadImageFileMutation, CreateResourceAndUploadImageFileMutationVariables>;
export const CreateResourceGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateResourceGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceGroupCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createResourceGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<CreateResourceGroupMutation, CreateResourceGroupMutationVariables>;
export const CreateServiceAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateServiceAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomServiceCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createServiceAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Service"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"askForTime"}},{"kind":"Field","name":{"kind":"Name","value":"displayCommentBox"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"largeDescription"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateServiceAndUploadImageFileMutation, CreateServiceAndUploadImageFileMutationVariables>;
export const CreateUnitTypeAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUnitTypeAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomUnitTypeCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUnitTypeAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfGuests"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<CreateUnitTypeAndUploadImageFileMutation, CreateUnitTypeAndUploadImageFileMutationVariables>;
export const CreateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<CreateUserMutation, CreateUserMutationVariables>;
export const CreateOneVendorServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateOneVendorServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServerCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createOneVendorServer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}}]}}]} as unknown as DocumentNode<CreateOneVendorServerMutation, CreateOneVendorServerMutationVariables>;
export const DeleteOneAmenityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneAmenity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AmenityWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneAmenity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<DeleteOneAmenityMutation, DeleteOneAmenityMutationVariables>;
export const DeleteEarlyCheckInPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteEarlyCheckInPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteEarlyCheckInPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"serviceId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<DeleteEarlyCheckInPackageMutation, DeleteEarlyCheckInPackageMutationVariables>;
export const DeleteOneInfoItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneInfoItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItemWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneInfoItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<DeleteOneInfoItemMutation, DeleteOneInfoItemMutationVariables>;
export const DeleteOneKioskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneKiosk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneKiosk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneKioskMutation, DeleteOneKioskMutationVariables>;
export const DeleteOneLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneLocationMutation, DeleteOneLocationMutationVariables>;
export const DeleteOnePaymentDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOnePayment"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOnePayment"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteOnePaymentMutation, DeleteOnePaymentMutationVariables>;
export const DeleteOneResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneResource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteOneResourceMutation, DeleteOneResourceMutationVariables>;
export const DeleteResourceGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteResourceGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteResourceGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteResourceGroupMutation, DeleteResourceGroupMutationVariables>;
export const DeleteOneServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<DeleteOneServiceMutation, DeleteOneServiceMutationVariables>;
export const DeleteOneUnitTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneUnitType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnitTypeWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneUnitType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<DeleteOneUnitTypeMutation, DeleteOneUnitTypeMutationVariables>;
export const DeleteUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<DeleteUserMutation, DeleteUserMutationVariables>;
export const DeleteOneVendorServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteOneVendorServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServerWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteOneVendorServer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}}]}}]} as unknown as DocumentNode<DeleteOneVendorServerMutation, DeleteOneVendorServerMutationVariables>;
export const CloudbedsDisconnectAppDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CloudbedsDisconnectApp"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"cloudbedsDisconnectApp"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<CloudbedsDisconnectAppMutation, CloudbedsDisconnectAppMutationVariables>;
export const DownloadResourceTemplateCsvFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadResourceTemplateCSVFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadResourceTemplateCSVFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<DownloadResourceTemplateCsvFileQuery, DownloadResourceTemplateCsvFileQueryVariables>;
export const DownloadUnitTypeTemplateCsvFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"DownloadUnitTypeTemplateCSVFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"downloadUnitTypeTemplateCSVFile"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}}]}}]}}]} as unknown as DocumentNode<DownloadUnitTypeTemplateCsvFileQuery, DownloadUnitTypeTemplateCsvFileQueryVariables>;
export const EndVideoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"endVideo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callRecordId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endVideo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"callRecordId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callRecordId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<EndVideoMutation, EndVideoMutationVariables>;
export const ExchangeRefreshTokenDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ExchangeRefreshToken"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"token"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"exchangeRefreshToken"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"token"},"value":{"kind":"Variable","name":{"kind":"Name","value":"token"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"authErrorCode"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<ExchangeRefreshTokenMutation, ExchangeRefreshTokenMutationVariables>;
export const FilterDashboardAccessGrantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FilterDashboardAccessGrants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DAGFStringFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"timeFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardTimeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"status"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DAGFAccessGrantStatusFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"state"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DAGFAccessGrantStateFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"retryCheckinStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DAGFRetryCheckinStatusFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requirementType"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DAGFRequirementTypeFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requirementStatus"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DAGFRequirementStatusFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"textFilter"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardTextFilter"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limit"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"offset"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardAccessGrantsOrderBy"}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"filterDashboardAccessGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"timeFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"timeFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"status"},"value":{"kind":"Variable","name":{"kind":"Name","value":"status"}}},{"kind":"Argument","name":{"kind":"Name","value":"state"},"value":{"kind":"Variable","name":{"kind":"Name","value":"state"}}},{"kind":"Argument","name":{"kind":"Name","value":"retryCheckinStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"retryCheckinStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"requirementType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requirementType"}}},{"kind":"Argument","name":{"kind":"Name","value":"requirementStatus"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requirementStatus"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"textFilter"},"value":{"kind":"Variable","name":{"kind":"Name","value":"textFilter"}}},{"kind":"Argument","name":{"kind":"Name","value":"limit"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limit"}}},{"kind":"Argument","name":{"kind":"Name","value":"offset"},"value":{"kind":"Variable","name":{"kind":"Name","value":"offset"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"dataCount"}},{"kind":"Field","name":{"kind":"Name","value":"totalCount"}}]}}]}}]} as unknown as DocumentNode<FilterDashboardAccessGrantsQuery, FilterDashboardAccessGrantsQueryVariables>;
export const AccessGrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"AccessGrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessGrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"overrides"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"resourceId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"controlType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEnd"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStart"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"passLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pmsId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"retryCheckin"}},{"kind":"Field","name":{"kind":"Name","value":"secondaryUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]}}]} as unknown as DocumentNode<AccessGrantQuery, AccessGrantQueryVariables>;
export const GetAccessGrantAuthenticationCredentialsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessGrantAuthenticationCredentials"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccessGrantAuthenticationCredentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deeplink"}},{"kind":"Field","name":{"kind":"Name","value":"mobileWebUrl"}},{"kind":"Field","name":{"kind":"Name","value":"qrCode"}}]}}]}}]} as unknown as DocumentNode<GetAccessGrantAuthenticationCredentialsQuery, GetAccessGrantAuthenticationCredentialsQueryVariables>;
export const GetAccessGrantTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessGrantTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereUniqueInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantScalarFieldEnum"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findDashboardAccessGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccessGrantTableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGrantTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idVerificationResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAccessGrantTableDataQuery, GetAccessGrantTableDataQueryVariables>;
export const GetAccessGrantsAndCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessGrantsAndCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereUniqueInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantScalarFieldEnum"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findDashboardAccessGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateDashboardAccessGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccessGrantsAndCountQuery, GetAccessGrantsAndCountQueryVariables>;
export const GetAccessSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getAccessSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getAccessSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"defaultStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"enableEarlyCheckInByTimeRange"}},{"kind":"Field","name":{"kind":"Name","value":"enableEarlyCheckInByLoyalty"}},{"kind":"Field","name":{"kind":"Name","value":"packages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"freeUpgrade"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyCodes"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}}]}}]}}]} as unknown as DocumentNode<GetAccessSetupQuery, GetAccessSetupQueryVariables>;
export const GetAmenityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAmenity"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AmenityWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amenity"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"amenityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]}}]} as unknown as DocumentNode<GetAmenityQuery, GetAmenityQueryVariables>;
export const GetAmenityTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAmenityTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AmenityOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AmenityWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amenities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AmenityTableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AmenityTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Amenity"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"amenityGroupId"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetAmenityTableDataQuery, GetAmenityTableDataQueryVariables>;
export const GetCallRecordsTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCallRecordsTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CallRecordWhereUniqueInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CallRecordScalarFieldEnum"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CallRecordOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CallRecordWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"callRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessGrant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}}]}},{"kind":"Field","name":{"kind":"Name","value":"agent"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"caller"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"duration"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"kiosk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"users"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetCallRecordsTableDataQuery, GetCallRecordsTableDataQueryVariables>;
export const GetCredentialTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetCredentialTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CredentialOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CredentialWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getCredentials"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CredentialFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CredentialFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Credential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessGrant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<GetCredentialTableDataQuery, GetCredentialTableDataQueryVariables>;
export const GetTenantDashboardCustomizeableComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantDashboardCustomizeableComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTenantDashboardCustomizeableComponents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTenantDashboardCustomizeableComponentsQuery, GetTenantDashboardCustomizeableComponentsQueryVariables>;
export const GetLocationDashboardCustomizeableComponentsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationDashboardCustomizeableComponents"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationDashboardCustomizeableComponents"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"entityId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetLocationDashboardCustomizeableComponentsQuery, GetLocationDashboardCustomizeableComponentsQueryVariables>;
export const GetDashboardPreferencesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardPreferences"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDashboardPreferences"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"preferredDateFormat"}},{"kind":"Field","name":{"kind":"Name","value":"preferredTimeFormat"}},{"kind":"Field","name":{"kind":"Name","value":"locationGroup"}},{"kind":"Field","name":{"kind":"Name","value":"quickActionBar"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enabled"}},{"kind":"Field","name":{"kind":"Name","value":"actions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIn"}},{"kind":"Field","name":{"kind":"Name","value":"checkOut"}},{"kind":"Field","name":{"kind":"Name","value":"blockCheckIn"}},{"kind":"Field","name":{"kind":"Name","value":"getAutenticationCredentials"}},{"kind":"Field","name":{"kind":"Name","value":"remotePrintKeyCard"}},{"kind":"Field","name":{"kind":"Name","value":"repollReservation"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"reportingServices"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"reportTitle"}},{"kind":"Field","name":{"kind":"Name","value":"reportUrl"}}]}}]}}]}}]} as unknown as DocumentNode<GetDashboardPreferencesQuery, GetDashboardPreferencesQueryVariables>;
export const GetGracePeriodsConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getGracePeriodsConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gracePeriodsConfigLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getGracePeriodsConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gracePeriodsConfigLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gracePeriodsConfigLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"rooms"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GracePeriodValuesFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"commonAreas"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"GracePeriodValuesFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"earlyCheckInConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"allowEarlyCheckIn"}},{"kind":"Field","name":{"kind":"Name","value":"checkInGracePeriod"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"GracePeriodValuesFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"GracePeriodValues"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"checkIn"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gracePeriodType"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTime"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTimePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"relativeTimeInMinutes"}}]}},{"kind":"Field","name":{"kind":"Name","value":"checkOut"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"gracePeriodType"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTime"}},{"kind":"Field","name":{"kind":"Name","value":"absoluteTimePeriod"}},{"kind":"Field","name":{"kind":"Name","value":"relativeTimeInMinutes"}}]}}]}}]} as unknown as DocumentNode<GetGracePeriodsConfigQuery, GetGracePeriodsConfigQueryVariables>;
export const GetInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItemWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"info"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InfoItemFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InfoItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moreInfoLink"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"infoType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAppearInDashboard"}}]}}]}}]} as unknown as DocumentNode<GetInfoQuery, GetInfoQueryVariables>;
export const GetInfoTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInfoTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infoTypes"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAppearInDashboard"}}]}}]}}]} as unknown as DocumentNode<GetInfoTypesQuery, GetInfoTypesQueryVariables>;
export const GetConciergeTreeViewDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetConciergeTreeView"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getConciergeTreeView"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"text"}},{"kind":"Field","name":{"kind":"Name","value":"droppable"}},{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImage"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moreInfoLink"}},{"kind":"Field","name":{"kind":"Name","value":"contentType"}}]}}]}}]}}]} as unknown as DocumentNode<GetConciergeTreeViewQuery, GetConciergeTreeViewQueryVariables>;
export const UpdateConciergeItemOrderDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConciergeItemOrder"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConciergeItemOrderInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConciergeItemOrder"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"parent"}},{"kind":"Field","name":{"kind":"Name","value":"order"}}]}}]}}]} as unknown as DocumentNode<UpdateConciergeItemOrderMutation, UpdateConciergeItemOrderMutationVariables>;
export const CreateConciergeItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateConciergeItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CreateConciergeItemInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createConciergeItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<CreateConciergeItemMutation, CreateConciergeItemMutationVariables>;
export const UpdateConciergeItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateConciergeItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateConciergeItemInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItemWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateConciergeItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<UpdateConciergeItemMutation, UpdateConciergeItemMutationVariables>;
export const DeleteConciergeItemDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeleteConciergeItem"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItemWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteConciergeItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}}]}}]}}]} as unknown as DocumentNode<DeleteConciergeItemMutation, DeleteConciergeItemMutationVariables>;
export const FetchConciergeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"FetchConcierge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getConcierge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImage"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"children"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"thumbnailImage"}}]}}]}}]}}]}}]} as unknown as DocumentNode<FetchConciergeQuery, FetchConciergeQueryVariables>;
export const GetInfoItemsTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInfoItemsTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItemOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItemWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"infos"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"InfoItemFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"InfoItemFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItem"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"moreInfoLink"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"infoType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAppearInDashboard"}}]}}]}}]} as unknown as DocumentNode<GetInfoItemsTableDataQuery, GetInfoItemsTableDataQueryVariables>;
export const GetInfoItemCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetInfoItemCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItemWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateInfoItem"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetInfoItemCountQuery, GetInfoItemCountQueryVariables>;
export const KioskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Kiosk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kiosk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"hasTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"hasDispenser"}},{"kind":"Field","name":{"kind":"Name","value":"powerSwitchId"}},{"kind":"Field","name":{"kind":"Name","value":"dispenserType"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceStartsAt"}},{"kind":"Field","name":{"kind":"Name","value":"maintenanceEndsAt"}},{"kind":"Field","name":{"kind":"Name","value":"dispenserConfig"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dispenserType"}},{"kind":"Field","name":{"kind":"Name","value":"serial"}},{"kind":"Field","name":{"kind":"Name","value":"usage"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"rfidTagType"}}]}}]}}]} as unknown as DocumentNode<KioskQuery, KioskQueryVariables>;
export const GetKioskTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKioskTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kiosks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"KioskTableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KioskTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Kiosk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasDispenser"}},{"kind":"Field","name":{"kind":"Name","value":"hasTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dispenserLastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminalLastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buildNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]} as unknown as DocumentNode<GetKioskTableDataQuery, GetKioskTableDataQueryVariables>;
export const KiosksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Kiosks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kiosks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<KiosksQuery, KiosksQueryVariables>;
export const GetKiosksAndCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKiosksAndCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kiosks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateKiosk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"count"},"name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"all"},"name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetKiosksAndCountQuery, GetKiosksAndCountQueryVariables>;
export const GetLanguagesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLanguages"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LanguageWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLanguages"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isRTL"}}]}}]}}]} as unknown as DocumentNode<GetLanguagesQuery, GetLanguagesQueryVariables>;
export const FileToEntitiesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"fileToEntities"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileToEntityWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileToEntities"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"entityId"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"url"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"fileType"}}]}}]}}]}}]} as unknown as DocumentNode<FileToEntitiesQuery, FileToEntitiesQueryVariables>;
export const GetLimitKeysConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLimitKeysConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitKeysConfigLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLimitKeysConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitKeysConfigLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitKeysConfigLevel"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"maxKeys"}},{"kind":"Field","name":{"kind":"Name","value":"numKeysUsed"}}]}}]}}]} as unknown as DocumentNode<GetLimitKeysConfigQuery, GetLimitKeysConfigQueryVariables>;
export const LocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Location"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"location"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationTableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailFrom"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]} as unknown as DocumentNode<LocationQuery, LocationQueryVariables>;
export const LocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Locations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"LocationTableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"LocationTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Location"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"emailFrom"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}}]} as unknown as DocumentNode<LocationsQuery, LocationsQueryVariables>;
export const GetLocationsAndCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationsAndCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"count"},"name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","alias":{"kind":"Name","value":"all"},"name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetLocationsAndCountQuery, GetLocationsAndCountQueryVariables>;
export const GetPaymentsPageInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentsPageInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentWhereUniqueInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentScalarFieldEnum"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"payments"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"cardType"}},{"kind":"Field","name":{"kind":"Name","value":"lastFour"}},{"kind":"Field","name":{"kind":"Name","value":"expYear"}},{"kind":"Field","name":{"kind":"Name","value":"expMonth"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"token"}}]}}]}}]} as unknown as DocumentNode<GetPaymentsPageInfoQuery, GetPaymentsPageInfoQueryVariables>;
export const GetPaymentTransactionTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetPaymentTransactionTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"PaymentTransactionWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"paymentTransactions"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"invoiceNumber"}},{"kind":"Field","name":{"kind":"Name","value":"amount"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}}]}}]}}]} as unknown as DocumentNode<GetPaymentTransactionTableDataQuery, GetPaymentTransactionTableDataQueryVariables>;
export const GetReservationConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetReservationConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getReservationConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enableLiveUsageEvents"}}]}}]}}]} as unknown as DocumentNode<GetReservationConfigQuery, GetReservationConfigQueryVariables>;
export const GetResourceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResource"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resource"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"building"}},{"kind":"Field","name":{"kind":"Name","value":"controlType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEnd"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStart"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"floor"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"passLevel"}},{"kind":"Field","name":{"kind":"Name","value":"pmsId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"isComponentRoom"}}]}}]}}]} as unknown as DocumentNode<GetResourceQuery, GetResourceQueryVariables>;
export const GetResourceGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"id"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"ObjectValue","fields":[{"kind":"ObjectField","name":{"kind":"Name","value":"id"},"value":{"kind":"Variable","name":{"kind":"Name","value":"id"}}}]}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetResourceGroupQuery, GetResourceGroupQueryVariables>;
export const ResourceGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"ResourceGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceGroupOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceGroupWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resourceGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<ResourceGroupsQuery, ResourceGroupsQueryVariables>;
export const GetResourceNamesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceNames"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetResourceNamesQuery, GetResourceNamesQueryVariables>;
export const GetResourceTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetResourceTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceTableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"controlType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pmsId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}}]}}]} as unknown as DocumentNode<GetResourceTableDataQuery, GetResourceTableDataQueryVariables>;
export const GetServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"service"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Service"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"askForTime"}},{"kind":"Field","name":{"kind":"Name","value":"displayCommentBox"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"largeDescription"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetServiceQuery, GetServiceQueryVariables>;
export const GetServiceTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetServiceTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"services"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Service"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"askForTime"}},{"kind":"Field","name":{"kind":"Name","value":"displayCommentBox"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"largeDescription"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetServiceTableDataQuery, GetServiceTableDataQueryVariables>;
export const GetUnitTypeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnitType"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnitTypeWhereUniqueInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unitTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitType"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitTypeFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"getUnitTypeLocalizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unitTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unitTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"isRTL"}}]}},{"kind":"Field","name":{"kind":"Name","value":"settingsData"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitTypeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnitType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfGuests"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetUnitTypeQuery, GetUnitTypeQueryVariables>;
export const GetUnitTypeTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUnitTypeTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnitTypeOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UnitTypeWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UnitTypeFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UnitTypeFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"UnitType"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfGuests"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetUnitTypeTableDataQuery, GetUnitTypeTableDataQueryVariables>;
export const GetUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"dashboardPreferences"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerType"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordType"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserQuery, GetUserQueryVariables>;
export const GetUserMembershipsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getUserMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<GetUserMembershipsQuery, GetUserMembershipsQueryVariables>;
export const GetUserRecordsPageInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUserRecordsPageInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecordWhereUniqueInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecordScalarFieldEnum"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecordOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecordWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"recordType"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"timeStamp"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"verificationStatus"}}]}}]}}]} as unknown as DocumentNode<GetUserRecordsPageInfoQuery, GetUserRecordsPageInfoQueryVariables>;
export const GetUsersTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetUsersTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"cursor"},"value":{"kind":"Variable","name":{"kind":"Name","value":"cursor"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]} as unknown as DocumentNode<GetUsersTableDataQuery, GetUsersTableDataQueryVariables>;
export const GetVendorServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVendorServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServerWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorServer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorServerDetailsFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorServerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAllJoin"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorServerDetailsFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorServerFields"}},{"kind":"Field","name":{"kind":"Name","value":"username"}},{"kind":"Field","name":{"kind":"Name","value":"password"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAllJoin"}},{"kind":"Field","name":{"kind":"Name","value":"lockServiceCode"}},{"kind":"Field","name":{"kind":"Name","value":"trailerBlock"}},{"kind":"Field","name":{"kind":"Name","value":"accessID"}},{"kind":"Field","name":{"kind":"Name","value":"uuid"}},{"kind":"Field","name":{"kind":"Name","value":"assaCardType"}},{"kind":"Field","name":{"kind":"Name","value":"additionalConfig"}}]}}]} as unknown as DocumentNode<GetVendorServerQuery, GetVendorServerQueryVariables>;
export const GetVendorServersTableDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVendorServersTableData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServerOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServerWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"vendorServers"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VendorServerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VendorServerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"shouldAllJoin"}}]}}]} as unknown as DocumentNode<GetVendorServersTableDataQuery, GetVendorServersTableDataQueryVariables>;
export const GetVendorServerCountDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetVendorServerCount"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServerWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"aggregateVendorServer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<GetVendorServerCountQuery, GetVendorServerCountQueryVariables>;
export const InvalidateCredentialDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"invalidateCredential"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"credentialId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"invalidateCredential"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"credentialId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"credentialId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"CredentialFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"CredentialFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Credential"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"expiresAt"}},{"kind":"Field","name":{"kind":"Name","value":"cancelledAt"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessGrant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}}]}}]} as unknown as DocumentNode<InvalidateCredentialMutation, InvalidateCredentialMutationVariables>;
export const IssueKeyForKioskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"issueKeyForKiosk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueKeyForKiosk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<IssueKeyForKioskMutation, IssueKeyForKioskMutationVariables>;
export const IssueKeyForKioskWithAccessGrantIdDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"issueKeyForKioskWithAccessGrantId"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueKeyForKioskWithAccessGrantId"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<IssueKeyForKioskWithAccessGrantIdMutation, IssueKeyForKioskWithAccessGrantIdMutationVariables>;
export const JoinVideoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"joinVideo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"room"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"callRecordId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"joinerChallenge"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"joinVideo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"room"},"value":{"kind":"Variable","name":{"kind":"Name","value":"room"}}},{"kind":"Argument","name":{"kind":"Name","value":"callRecordId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"callRecordId"}}},{"kind":"Argument","name":{"kind":"Name","value":"joinerChallenge"},"value":{"kind":"Variable","name":{"kind":"Name","value":"joinerChallenge"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}}]}}]}}]} as unknown as DocumentNode<JoinVideoMutation, JoinVideoMutationVariables>;
export const LoadKioskSessionDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"LoadKioskSession"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"loadKioskSession"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<LoadKioskSessionMutation, LoadKioskSessionMutationVariables>;
export const MeWithUserRolePermissionsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"MeWithUserRolePermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"meWithUserRolePermissions"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"activeMembership"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ActiveMembershipFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"virtualMemberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"VirtualMembershipFields"}}]}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ActiveMembershipFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"MembershipWithPermissions"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locationIds"}}]}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"permissions"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"VirtualMembershipFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"VirtualMembership"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"tenant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"locationGroup"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"locationIds"}}]}}]}}]} as unknown as DocumentNode<MeWithUserRolePermissionsQuery, MeWithUserRolePermissionsQueryVariables>;
export const DashboardSignInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DashboardSignIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"password"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dashboardSignIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"password"},"value":{"kind":"Variable","name":{"kind":"Name","value":"password"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessToken"}},{"kind":"Field","name":{"kind":"Name","value":"expiresIn"}},{"kind":"Field","name":{"kind":"Name","value":"refreshToken"}}]}}]}}]} as unknown as DocumentNode<DashboardSignInMutation, DashboardSignInMutationVariables>;
export const EnrollKioskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"EnrollKiosk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"code"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"name"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"enrollKiosk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"code"},"value":{"kind":"Variable","name":{"kind":"Name","value":"code"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"name"},"value":{"kind":"Variable","name":{"kind":"Name","value":"name"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<EnrollKioskMutation, EnrollKioskMutationVariables>;
export const UpsertKioskLocalizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertKioskLocalization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localization"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertKioskLocalization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}},{"kind":"Argument","name":{"kind":"Name","value":"localization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localization"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<UpsertKioskLocalizationMutation, UpsertKioskLocalizationMutationVariables>;
export const DeleteKioskThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteKioskTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteKioskTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<DeleteKioskThemeMutation, DeleteKioskThemeMutationVariables>;
export const DeleteKioskLocalizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteKioskLocalization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteKioskLocalization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<DeleteKioskLocalizationMutation, DeleteKioskLocalizationMutationVariables>;
export const UpsertKioskThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertKioskTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertKioskTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}},{"kind":"Argument","name":{"kind":"Name","value":"setting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<UpsertKioskThemeMutation, UpsertKioskThemeMutationVariables>;
export const CreateGuestEngagementEventDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateGuestEngagementEvent"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createGuestEngagementEvent"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}}]}]}}]} as unknown as DocumentNode<CreateGuestEngagementEventMutation, CreateGuestEngagementEventMutationVariables>;
export const CreateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"CreateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationCreateInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}}]}}]}}]} as unknown as DocumentNode<CreateLocationMutation, CreateLocationMutationVariables>;
export const DeleteLocationThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteLocationTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLocationTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<DeleteLocationThemeMutation, DeleteLocationThemeMutationVariables>;
export const DeleteLocationLocalizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteLocationLocalization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteLocationLocalization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<DeleteLocationLocalizationMutation, DeleteLocationLocalizationMutationVariables>;
export const UpsertLocationLocalizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertLocationLocalization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localization"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertLocationLocalization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"localization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localization"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<UpsertLocationLocalizationMutation, UpsertLocationLocalizationMutationVariables>;
export const UpsertLocationThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertLocationTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertLocationTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"setting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<UpsertLocationThemeMutation, UpsertLocationThemeMutationVariables>;
export const IssueResetPasswordByEmailChallengeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"IssueResetPasswordByEmailChallenge"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"issueResetPasswordByEmailChallenge"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<IssueResetPasswordByEmailChallengeMutation, IssueResetPasswordByEmailChallengeMutationVariables>;
export const ResetPasswordByEmailDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"ResetPasswordByEmail"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"challenge"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"email"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resetPasswordByEmail"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"newPassword"},"value":{"kind":"Variable","name":{"kind":"Name","value":"newPassword"}}},{"kind":"Argument","name":{"kind":"Name","value":"challenge"},"value":{"kind":"Variable","name":{"kind":"Name","value":"challenge"}}},{"kind":"Argument","name":{"kind":"Name","value":"email"},"value":{"kind":"Variable","name":{"kind":"Name","value":"email"}}}]}]}}]} as unknown as DocumentNode<ResetPasswordByEmailMutation, ResetPasswordByEmailMutationVariables>;
export const DeleteTenantThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTenantTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTenantTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<DeleteTenantThemeMutation, DeleteTenantThemeMutationVariables>;
export const DeleteTenantLocalizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"deleteTenantLocalization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deleteTenantLocalization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<DeleteTenantLocalizationMutation, DeleteTenantLocalizationMutationVariables>;
export const UpsertTenantLocalizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertTenantLocalization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"localization"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertTenantLocalization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"localization"},"value":{"kind":"Variable","name":{"kind":"Name","value":"localization"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<UpsertTenantLocalizationMutation, UpsertTenantLocalizationMutationVariables>;
export const UpsertTenantThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertTenantTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"setting"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertTenantTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"setting"},"value":{"kind":"Variable","name":{"kind":"Name","value":"setting"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<UpsertTenantThemeMutation, UpsertTenantThemeMutationVariables>;
export const PerformCheckInDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PerformCheckIn"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"performCheckIn"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<PerformCheckInMutation, PerformCheckInMutationVariables>;
export const PerformCheckOutDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PerformCheckOut"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"performCheckOut"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<PerformCheckOutMutation, PerformCheckOutMutationVariables>;
export const PollReservationFromPmsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"PollReservationFromPms"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"confirmationCode"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"pollReservationFromPms"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"confirmationCode"},"value":{"kind":"Variable","name":{"kind":"Name","value":"confirmationCode"}}}]}]}}]} as unknown as DocumentNode<PollReservationFromPmsMutation, PollReservationFromPmsMutationVariables>;
export const RetrieveVerficationResultDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"retrieveVerficationResult"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"scanReference"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"retrieveVerificationResult"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"scanReference"},"value":{"kind":"Variable","name":{"kind":"Name","value":"scanReference"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"dob"}},{"kind":"Field","name":{"kind":"Name","value":"expiry"}},{"kind":"Field","name":{"kind":"Name","value":"firstName"}},{"kind":"Field","name":{"kind":"Name","value":"images"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"classifier"}},{"kind":"Field","name":{"kind":"Name","value":"href"}}]}},{"kind":"Field","name":{"kind":"Name","value":"issuingCountry"}},{"kind":"Field","name":{"kind":"Name","value":"issuingDate"}},{"kind":"Field","name":{"kind":"Name","value":"lastName"}},{"kind":"Field","name":{"kind":"Name","value":"number"}},{"kind":"Field","name":{"kind":"Name","value":"scanReference"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"timestamp"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<RetrieveVerficationResultQuery, RetrieveVerficationResultQueryVariables>;
export const GetKioskThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getKioskTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getKioskTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<GetKioskThemeQuery, GetKioskThemeQueryVariables>;
export const GetKioskLocalizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getKioskLocalization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getKioskLocalization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<GetKioskLocalizationQuery, GetKioskLocalizationQueryVariables>;
export const GetLocationThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLocationTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<GetLocationThemeQuery, GetLocationThemeQueryVariables>;
export const GetLocationLocalizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getLocationLocalization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationLocalization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<GetLocationLocalizationQuery, GetLocationLocalizationQueryVariables>;
export const GetTenantThemeDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTenantTheme"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTenantTheme"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<GetTenantThemeQuery, GetTenantThemeQueryVariables>;
export const GetTenantLocalizationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getTenantLocalization"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getTenantLocalization"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"BaseSettingAnswerFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"BaseSettingAnswerFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"BaseSettingAnswer"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"settingsData"}},{"kind":"Field","name":{"kind":"Name","value":"mergedSettingsData"}}]}}]} as unknown as DocumentNode<GetTenantLocalizationQuery, GetTenantLocalizationQueryVariables>;
export const UserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"User"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"payments"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"providerType"}},{"kind":"Field","name":{"kind":"Name","value":"token"}},{"kind":"Field","name":{"kind":"Name","value":"customerId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"userRecords"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordType"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}}]}}]}}]} as unknown as DocumentNode<UserQuery, UserQueryVariables>;
export const UsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"Users"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"aggregateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_count"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"_all"}}]}}]}}]}}]} as unknown as DocumentNode<UsersQuery, UsersQueryVariables>;
export const UserRecordsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"userRecords"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecordOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserRecordWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"userRecords"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"recordType"}},{"kind":"Field","name":{"kind":"Name","value":"recordId"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}}]}}]} as unknown as DocumentNode<UserRecordsQuery, UserRecordsQueryVariables>;
export const ResendConfirmationInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"resendConfirmationInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resendConfirmationInfo"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<ResendConfirmationInfoMutation, ResendConfirmationInfoMutationVariables>;
export const SearchAccessGrantsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchAccessGrants"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"accessGrants"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}}]}}]}}]} as unknown as DocumentNode<SearchAccessGrantsQuery, SearchAccessGrantsQueryVariables>;
export const SearchAmenityGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchAmenityGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AmenityGroupOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"AmenityGroupWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"amenityGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<SearchAmenityGroupsQuery, SearchAmenityGroupsQueryVariables>;
export const GetDashboardLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomLocationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDashboardLocations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetDashboardLocationsQuery, GetDashboardLocationsQueryVariables>;
export const SearchKiosksDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchKiosks"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kiosks"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchKiosksQuery, SearchKiosksQueryVariables>;
export const SearchLocationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchLocations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchLocationsQuery, SearchLocationsQueryVariables>;
export const SearchUnitTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchUnitTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnitTypeOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UnitTypeWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"unitTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<SearchUnitTypesQuery, SearchUnitTypesQueryVariables>;
export const SearchUsersDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchUsers"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"users"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchUsersQuery, SearchUsersQueryVariables>;
export const SendNotificationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"sendNotification"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"transport"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendNotification"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"transport"},"value":{"kind":"Variable","name":{"kind":"Name","value":"transport"}}},{"kind":"Argument","name":{"kind":"Name","value":"notificationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"notificationId"}}}]}]}}]} as unknown as DocumentNode<SendNotificationMutation, SendNotificationMutationVariables>;
export const SendNotificationToExternalApiDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SendNotificationToExternalAPI"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"userId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"sendNotificationToExternalAPI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"userId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"userId"}}}]}]}}]} as unknown as DocumentNode<SendNotificationToExternalApiMutation, SendNotificationToExternalApiMutationVariables>;
export const SetAccessSetupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setAccessSetup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessSetupInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessSetupWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setAccessSetup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SetAccessSetupMutation, SetAccessSetupMutationVariables>;
export const SignUpUsersFromThirdPartyAuthenticationServiceDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"SignUpUsersFromThirdPartyAuthenticationService"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"serviceType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"signUpUsersFromThirdPartyAuthenticationService"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"serviceType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"serviceType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SignUpUsersFromThirdPartyAuthenticationServiceMutation, SignUpUsersFromThirdPartyAuthenticationServiceMutationVariables>;
export const TakeScreenshotDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"takeScreenshot"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"takeScreenshot"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<TakeScreenshotMutation, TakeScreenshotMutationVariables>;
export const UpdateAccessGrantDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAccessGrant"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"originalAgreementFileId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAccessGrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"originalAgreementFileId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"originalAgreementFileId"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccessGrantTableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGrantTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"idVerificationResult"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateAccessGrantMutation, UpdateAccessGrantMutationVariables>;
export const UpdateAmenityAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateAmenityAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomAmenityUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AmenityWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateAmenityAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"group"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateAmenityAndUploadImageFileMutation, UpdateAmenityAndUploadImageFileMutationVariables>;
export const UpdateEarlyCheckInPackageDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateEarlyCheckInPackage"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"EarlyCheckInPackageInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UpdateEarlyCheckInPackageWhere"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateEarlyCheckInPackage"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"externalId"}},{"kind":"Field","name":{"kind":"Name","value":"freeUpgrade"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"loyaltyCodes"}},{"kind":"Field","name":{"kind":"Name","value":"serviceId"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}}]}}]}}]} as unknown as DocumentNode<UpdateEarlyCheckInPackageMutation, UpdateEarlyCheckInPackageMutationVariables>;
export const UpdateInfoItemAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateInfoItemAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomInfoItemUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"InfoItemWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateInfoItemAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"title"}}]}}]}}]} as unknown as DocumentNode<UpdateInfoItemAndUploadImageFileMutation, UpdateInfoItemAndUploadImageFileMutationVariables>;
export const UpdateKioskDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateKiosk"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomKioskUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateKiosk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"KioskTableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"KioskTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Kiosk"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"hasDispenser"}},{"kind":"Field","name":{"kind":"Name","value":"hasTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"dispenserLastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminalLastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"serverUrl"}},{"kind":"Field","name":{"kind":"Name","value":"buildNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]} as unknown as DocumentNode<UpdateKioskMutation, UpdateKioskMutationVariables>;
export const UpdateLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEndTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultRequirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"vendorServers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"host"}},{"kind":"Field","name":{"kind":"Name","value":"port"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateLocationMutation, UpdateLocationMutationVariables>;
export const UpdateRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateRequirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"requirementArgsList"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomRequirementUpdateInput"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateRequirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"kioskId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskId"}}},{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"requirementArgsList"},"value":{"kind":"Variable","name":{"kind":"Name","value":"requirementArgsList"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<UpdateRequirementsMutation, UpdateRequirementsMutationVariables>;
export const UpdateResourceAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateResourceAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomResourceUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateResourceAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ResourceTableFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ResourceTableFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Resource"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"controlType"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"pmsId"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"unitType"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"unitTypeId"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}},{"kind":"Field","name":{"kind":"Name","value":"vendorId"}}]}}]} as unknown as DocumentNode<UpdateResourceAndUploadImageFileMutation, UpdateResourceAndUploadImageFileMutationVariables>;
export const UpdateResourceGroupDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateResourceGroup"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceGroupUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceGroupWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateResourceGroup"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"isDefault"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpdateResourceGroupMutation, UpdateResourceGroupMutationVariables>;
export const UpdateServiceAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateServiceAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomServiceUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ServiceWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateServiceAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"ServiceFields"}}]}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"ServiceFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"Service"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"price"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"askForTime"}},{"kind":"Field","name":{"kind":"Name","value":"displayCommentBox"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"largeDescription"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UpdateServiceAndUploadImageFileMutation, UpdateServiceAndUploadImageFileMutationVariables>;
export const UpdateUnitTypeAndUploadImageFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"updateUnitTypeAndUploadImageFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomUnitTypeUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UnitTypeWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUnitTypeAndUploadImageFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"locationId"}},{"kind":"Field","name":{"kind":"Name","value":"numberOfGuests"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<UpdateUnitTypeAndUploadImageFileMutation, UpdateUnitTypeAndUploadImageFileMutationVariables>;
export const UpdateUserDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateUser"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"UserWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateUser"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"memberships"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"role"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}}]}}]}}]} as unknown as DocumentNode<UpdateUserMutation, UpdateUserMutationVariables>;
export const UpdateOneVendorServerDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UpdateOneVendorServer"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServerUpdateInput"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"VendorServerWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"updateOneVendorServer"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}}]}}]} as unknown as DocumentNode<UpdateOneVendorServerMutation, UpdateOneVendorServerMutationVariables>;
export const UploadFileDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"uploadFile"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"FileType"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadFile"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"fileType"},"value":{"kind":"Variable","name":{"kind":"Name","value":"fileType"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]} as unknown as DocumentNode<UploadFileMutation, UploadFileMutationVariables>;
export const UploadResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadResources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<UploadResourcesMutation, UploadResourcesMutationVariables>;
export const UploadUnitTypesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"UploadUnitTypes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"file"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"Upload"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"uploadUnitTypes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"file"},"value":{"kind":"Variable","name":{"kind":"Name","value":"file"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"languageId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"languageId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}}]}}]} as unknown as DocumentNode<UploadUnitTypesMutation, UploadUnitTypesMutationVariables>;
export const SetGracePeriodsConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setGracePeriodsConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"gracePeriodsConfigLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"data"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"GracePeriodInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setGracePeriodsConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"gracePeriodsConfigLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"gracePeriodsConfigLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"data"},"value":{"kind":"Variable","name":{"kind":"Name","value":"data"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SetGracePeriodsConfigMutation, SetGracePeriodsConfigMutationVariables>;
export const SetLimitKeysConfigDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"setLimitKeysConfig"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"limitKeysConfigLevel"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"maxKeys"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Float"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"setLimitKeysConfig"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"locationId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"locationId"}}},{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}},{"kind":"Argument","name":{"kind":"Name","value":"limitKeysConfigLevel"},"value":{"kind":"Variable","name":{"kind":"Name","value":"limitKeysConfigLevel"}}},{"kind":"Argument","name":{"kind":"Name","value":"maxKeys"},"value":{"kind":"Variable","name":{"kind":"Name","value":"maxKeys"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode<SetLimitKeysConfigMutation, SetLimitKeysConfigMutationVariables>;
export const UpsertOrDeleteUnitTypeLocalizationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"upsertOrDeleteUnitTypeLocalizations"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unitTypeId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"unitTypeLocalizations"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"CustomLocalizationInputArgs"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"upsertOrDeleteUnitTypeLocalizations"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"unitTypeId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unitTypeId"}}},{"kind":"Argument","name":{"kind":"Name","value":"componentName"},"value":{"kind":"Variable","name":{"kind":"Name","value":"componentName"}}},{"kind":"Argument","name":{"kind":"Name","value":"unitTypeLocalizations"},"value":{"kind":"Variable","name":{"kind":"Name","value":"unitTypeLocalizations"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"language"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]}}]} as unknown as DocumentNode<UpsertOrDeleteUnitTypeLocalizationsMutation, UpsertOrDeleteUnitTypeLocalizationsMutationVariables>;
export const GetKiosksLiveUsageDataDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKiosksLiveUsageData"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"kioskAndAccessGrantParams"}},"type":{"kind":"NonNullType","type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskAndAccessGrantParams"}}}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getKiosksLiveUsageData"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"kioskAndAccessGrantParams"},"value":{"kind":"Variable","name":{"kind":"Name","value":"kioskAndAccessGrantParams"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"data"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kiosk"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"dispenserType"}},{"kind":"Field","name":{"kind":"Name","value":"hasDispenser"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessGrant"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}},{"kind":"Field","name":{"kind":"Name","value":"totalGuests"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"adults"}},{"kind":"Field","name":{"kind":"Name","value":"children"}},{"kind":"Field","name":{"kind":"Name","value":"total"}}]}},{"kind":"Field","name":{"kind":"Name","value":"bookedPackages"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"title"}},{"kind":"Field","name":{"kind":"Name","value":"quantity"}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"description"}},{"kind":"Field","name":{"kind":"Name","value":"pmsId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"roomNumber"}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"status"}}]}}]}}]}}]}}]}}]} as unknown as DocumentNode<GetKiosksLiveUsageDataQuery, GetKiosksLiveUsageDataQueryVariables>;
export const SearchGroupsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"SearchGroups"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationGroupOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationGroupWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"locationGroups"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<SearchGroupsQuery, SearchGroupsQueryVariables>;
export const GetAccessGrantPageInfoAndCheckNotificationCapabilityDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessGrantPageInfoAndCheckNotificationCapability"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"AccessGrantWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"findDashboardAccessGrant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"AccessGrantPageInfoFields"}}]}},{"kind":"Field","name":{"kind":"Name","value":"accessGrantIsEnabledToSendNotificationToExternalAPI"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"accessGrantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"accessGrantId"}}}]}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"UserOnAGFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"User"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}}]}},{"kind":"FragmentDefinition","name":{"kind":"Name","value":"AccessGrantPageInfoFields"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardAccessGrant"}},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"credentials"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"userId"}},{"kind":"Field","name":{"kind":"Name","value":"isActive"}}]}},{"kind":"Field","name":{"kind":"Name","value":"confirmationCode"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"endsAt"}},{"kind":"Field","name":{"kind":"Name","value":"endDate"}},{"kind":"Field","name":{"kind":"Name","value":"endTime"}},{"kind":"Field","name":{"kind":"Name","value":"lastPolledAt"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"timezone"}},{"kind":"Field","name":{"kind":"Name","value":"supportsPolling"}}]}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}},{"kind":"Field","name":{"kind":"Name","value":"requirements"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}},{"kind":"Field","name":{"kind":"Name","value":"files"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"file"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"fileType"}},{"kind":"Field","name":{"kind":"Name","value":"url"}}]}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"resources"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}}]}},{"kind":"Field","name":{"kind":"Name","value":"secondaryUsers"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOnAGFields"}}]}}]}},{"kind":"Field","name":{"kind":"Name","value":"startsAt"}},{"kind":"Field","name":{"kind":"Name","value":"startDate"}},{"kind":"Field","name":{"kind":"Name","value":"startTime"}},{"kind":"Field","name":{"kind":"Name","value":"arrivalTime"}},{"kind":"Field","name":{"kind":"Name","value":"state"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"user"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"FragmentSpread","name":{"kind":"Name","value":"UserOnAGFields"}}]}}]}}]} as unknown as DocumentNode<GetAccessGrantPageInfoAndCheckNotificationCapabilityQuery, GetAccessGrantPageInfoAndCheckNotificationCapabilityQueryVariables>;
export const GetAccessGrantPageRequirementsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessGrantPageRequirements"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementScalarFieldEnum"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}},"type":{"kind":"ListType","type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementOrderByWithRelationInput"}}}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"RequirementWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"requirements"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"distinct"},"value":{"kind":"Variable","name":{"kind":"Name","value":"distinct"}}},{"kind":"Argument","name":{"kind":"Name","value":"orderBy"},"value":{"kind":"Variable","name":{"kind":"Name","value":"orderBy"}}},{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"createdAt"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"status"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"updatedAt"}}]}}]}}]} as unknown as DocumentNode<GetAccessGrantPageRequirementsQuery, GetAccessGrantPageRequirementsQueryVariables>;
export const GetAccessGrantPageResourcesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetAccessGrantPageResources"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"skip"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"take"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"Int"}}},{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NamedType","name":{"kind":"Name","value":"ResourceWhereInput"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"resources"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"skip"},"value":{"kind":"Variable","name":{"kind":"Name","value":"skip"}}},{"kind":"Argument","name":{"kind":"Name","value":"take"},"value":{"kind":"Variable","name":{"kind":"Name","value":"take"}}},{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"code"}},{"kind":"Field","name":{"kind":"Name","value":"controlType"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEnd"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStart"}},{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"type"}},{"kind":"Field","name":{"kind":"Name","value":"vendor"}}]}}]}}]} as unknown as DocumentNode<GetAccessGrantPageResourcesQuery, GetAccessGrantPageResourcesQueryVariables>;
export const GetDashboardSupportedNotificationsDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"getDashboardSupportedNotifications"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"DashboardSupportedNotificationsWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDashboardSupportedNotifications"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"notifications"}}]}}]}}]} as unknown as DocumentNode<GetDashboardSupportedNotificationsQuery, GetDashboardSupportedNotificationsQueryVariables>;
export const GetKioskPageInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetKioskPageInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"KioskWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"kiosk"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"location"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"dispenserType"}},{"kind":"Field","name":{"kind":"Name","value":"batteryLevel"}},{"kind":"Field","name":{"kind":"Name","value":"chargingState"}},{"kind":"Field","name":{"kind":"Name","value":"hasDispenser"}},{"kind":"Field","name":{"kind":"Name","value":"dispenserLastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"hasTerminal"}},{"kind":"Field","name":{"kind":"Name","value":"lastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"terminalLastSeenAt"}},{"kind":"Field","name":{"kind":"Name","value":"buildNumber"}},{"kind":"Field","name":{"kind":"Name","value":"metadata"}}]}}]}}]} as unknown as DocumentNode<GetKioskPageInfoQuery, GetKioskPageInfoQueryVariables>;
export const GetDashboardLocationDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetDashboardLocation"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"LocationWhereInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getDashboardLocation"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"address"}},{"kind":"Field","name":{"kind":"Name","value":"email"}},{"kind":"Field","name":{"kind":"Name","value":"logoUrl"}},{"kind":"Field","name":{"kind":"Name","value":"imageUrl"}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"phoneNumber"}},{"kind":"Field","name":{"kind":"Name","value":"pmsType"}},{"kind":"Field","name":{"kind":"Name","value":"tenantId"}},{"kind":"Field","name":{"kind":"Name","value":"supportsPolling"}},{"kind":"Field","name":{"kind":"Name","value":"defaultStartTime"}},{"kind":"Field","name":{"kind":"Name","value":"defaultEndTime"}}]}}]}}]} as unknown as DocumentNode<GetDashboardLocationQuery, GetDashboardLocationQueryVariables>;
export const GetLocationGroupNodesDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetLocationGroupNodes"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"String"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"getLocationGroupNodes"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"tenantId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"tenantId"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"locations"},"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}},{"kind":"Field","name":{"kind":"Name","value":"name"}},{"kind":"Field","name":{"kind":"Name","value":"parentGroupIds"}}]}}]}}]} as unknown as DocumentNode<GetLocationGroupNodesQuery, GetLocationGroupNodesQueryVariables>;
export const GetTenantPageInfoDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"query","name":{"kind":"Name","value":"GetTenantPageInfo"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"where"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"TenantWhereUniqueInput"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"tenant"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"where"},"value":{"kind":"Variable","name":{"kind":"Name","value":"where"}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"}},{"kind":"Field","name":{"kind":"Name","value":"name"}}]}}]}}]} as unknown as DocumentNode<GetTenantPageInfoQuery, GetTenantPageInfoQueryVariables>;